// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=5.0.45", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=5.0.45", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=5.0.45", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=5.0.45", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/remixicon.eot?t=1580819880586", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/remixicon.woff2?t=1580819880586", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/remixicon.woff?t=1580819880586", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/remixicon.ttf?t=1580819880586", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/remixicon.svg?t=1580819880586", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28207, 211.5, 220.5%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2306d6a0%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23ef476f%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23ef476f%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23495057%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28109.8, 168, 253.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=5.0.45" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#remixicon" });
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Chat Sms.by
Author: Themesbrand
Version: 2.0.0
Website: https://themesbrand.com/
Contact: themesbrand@gmail.com
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-ab-testing::before {
  content: "\\f01c9";
}

.mdi-abjad-arabic::before {
  content: "\\f1328";
}

.mdi-abjad-hebrew::before {
  content: "\\f1329";
}

.mdi-abugida-devanagari::before {
  content: "\\f132a";
}

.mdi-abugida-thai::before {
  content: "\\f132b";
}

.mdi-access-point::before {
  content: "\\f0003";
}

.mdi-access-point-network::before {
  content: "\\f0002";
}

.mdi-access-point-network-off::before {
  content: "\\f0be1";
}

.mdi-account::before {
  content: "\\f0004";
}

.mdi-account-alert::before {
  content: "\\f0005";
}

.mdi-account-alert-outline::before {
  content: "\\f0b50";
}

.mdi-account-arrow-left::before {
  content: "\\f0b51";
}

.mdi-account-arrow-left-outline::before {
  content: "\\f0b52";
}

.mdi-account-arrow-right::before {
  content: "\\f0b53";
}

.mdi-account-arrow-right-outline::before {
  content: "\\f0b54";
}

.mdi-account-box::before {
  content: "\\f0006";
}

.mdi-account-box-multiple::before {
  content: "\\f0934";
}

.mdi-account-box-multiple-outline::before {
  content: "\\f100a";
}

.mdi-account-box-outline::before {
  content: "\\f0007";
}

.mdi-account-cancel::before {
  content: "\\f12df";
}

.mdi-account-cancel-outline::before {
  content: "\\f12e0";
}

.mdi-account-cash::before {
  content: "\\f1097";
}

.mdi-account-cash-outline::before {
  content: "\\f1098";
}

.mdi-account-check::before {
  content: "\\f0008";
}

.mdi-account-check-outline::before {
  content: "\\f0be2";
}

.mdi-account-child::before {
  content: "\\f0a89";
}

.mdi-account-child-circle::before {
  content: "\\f0a8a";
}

.mdi-account-child-outline::before {
  content: "\\f10c8";
}

.mdi-account-circle::before {
  content: "\\f0009";
}

.mdi-account-circle-outline::before {
  content: "\\f0b55";
}

.mdi-account-clock::before {
  content: "\\f0b56";
}

.mdi-account-clock-outline::before {
  content: "\\f0b57";
}

.mdi-account-cog::before {
  content: "\\f1370";
}

.mdi-account-cog-outline::before {
  content: "\\f1371";
}

.mdi-account-convert::before {
  content: "\\f000a";
}

.mdi-account-convert-outline::before {
  content: "\\f1301";
}

.mdi-account-cowboy-hat::before {
  content: "\\f0e9b";
}

.mdi-account-details::before {
  content: "\\f0631";
}

.mdi-account-details-outline::before {
  content: "\\f1372";
}

.mdi-account-edit::before {
  content: "\\f06bc";
}

.mdi-account-edit-outline::before {
  content: "\\f0ffb";
}

.mdi-account-group::before {
  content: "\\f0849";
}

.mdi-account-group-outline::before {
  content: "\\f0b58";
}

.mdi-account-hard-hat::before {
  content: "\\f05b5";
}

.mdi-account-heart::before {
  content: "\\f0899";
}

.mdi-account-heart-outline::before {
  content: "\\f0be3";
}

.mdi-account-key::before {
  content: "\\f000b";
}

.mdi-account-key-outline::before {
  content: "\\f0be4";
}

.mdi-account-lock::before {
  content: "\\f115e";
}

.mdi-account-lock-outline::before {
  content: "\\f115f";
}

.mdi-account-minus::before {
  content: "\\f000d";
}

.mdi-account-minus-outline::before {
  content: "\\f0aec";
}

.mdi-account-multiple::before {
  content: "\\f000e";
}

.mdi-account-multiple-check::before {
  content: "\\f08c5";
}

.mdi-account-multiple-check-outline::before {
  content: "\\f11fe";
}

.mdi-account-multiple-minus::before {
  content: "\\f05d3";
}

.mdi-account-multiple-minus-outline::before {
  content: "\\f0be5";
}

.mdi-account-multiple-outline::before {
  content: "\\f000f";
}

.mdi-account-multiple-plus::before {
  content: "\\f0010";
}

.mdi-account-multiple-plus-outline::before {
  content: "\\f0800";
}

.mdi-account-multiple-remove::before {
  content: "\\f120a";
}

.mdi-account-multiple-remove-outline::before {
  content: "\\f120b";
}

.mdi-account-music::before {
  content: "\\f0803";
}

.mdi-account-music-outline::before {
  content: "\\f0ce9";
}

.mdi-account-network::before {
  content: "\\f0011";
}

.mdi-account-network-outline::before {
  content: "\\f0be6";
}

.mdi-account-off::before {
  content: "\\f0012";
}

.mdi-account-off-outline::before {
  content: "\\f0be7";
}

.mdi-account-outline::before {
  content: "\\f0013";
}

.mdi-account-plus::before {
  content: "\\f0014";
}

.mdi-account-plus-outline::before {
  content: "\\f0801";
}

.mdi-account-question::before {
  content: "\\f0b59";
}

.mdi-account-question-outline::before {
  content: "\\f0b5a";
}

.mdi-account-remove::before {
  content: "\\f0015";
}

.mdi-account-remove-outline::before {
  content: "\\f0aed";
}

.mdi-account-search::before {
  content: "\\f0016";
}

.mdi-account-search-outline::before {
  content: "\\f0935";
}

.mdi-account-settings::before {
  content: "\\f0630";
}

.mdi-account-settings-outline::before {
  content: "\\f10c9";
}

.mdi-account-star::before {
  content: "\\f0017";
}

.mdi-account-star-outline::before {
  content: "\\f0be8";
}

.mdi-account-supervisor::before {
  content: "\\f0a8b";
}

.mdi-account-supervisor-circle::before {
  content: "\\f0a8c";
}

.mdi-account-supervisor-outline::before {
  content: "\\f112d";
}

.mdi-account-switch::before {
  content: "\\f0019";
}

.mdi-account-switch-outline::before {
  content: "\\f04cb";
}

.mdi-account-tie::before {
  content: "\\f0ce3";
}

.mdi-account-tie-outline::before {
  content: "\\f10ca";
}

.mdi-account-tie-voice::before {
  content: "\\f1308";
}

.mdi-account-tie-voice-off::before {
  content: "\\f130a";
}

.mdi-account-tie-voice-off-outline::before {
  content: "\\f130b";
}

.mdi-account-tie-voice-outline::before {
  content: "\\f1309";
}

.mdi-account-voice::before {
  content: "\\f05cb";
}

.mdi-adjust::before {
  content: "\\f001a";
}

.mdi-adobe::before {
  content: "\\f0936";
}

.mdi-adobe-acrobat::before {
  content: "\\f0f9d";
}

.mdi-air-conditioner::before {
  content: "\\f001b";
}

.mdi-air-filter::before {
  content: "\\f0d43";
}

.mdi-air-horn::before {
  content: "\\f0dac";
}

.mdi-air-humidifier::before {
  content: "\\f1099";
}

.mdi-air-purifier::before {
  content: "\\f0d44";
}

.mdi-airbag::before {
  content: "\\f0be9";
}

.mdi-airballoon::before {
  content: "\\f001c";
}

.mdi-airballoon-outline::before {
  content: "\\f100b";
}

.mdi-airplane::before {
  content: "\\f001d";
}

.mdi-airplane-landing::before {
  content: "\\f05d4";
}

.mdi-airplane-off::before {
  content: "\\f001e";
}

.mdi-airplane-takeoff::before {
  content: "\\f05d5";
}

.mdi-airport::before {
  content: "\\f084b";
}

.mdi-alarm::before {
  content: "\\f0020";
}

.mdi-alarm-bell::before {
  content: "\\f078e";
}

.mdi-alarm-check::before {
  content: "\\f0021";
}

.mdi-alarm-light::before {
  content: "\\f078f";
}

.mdi-alarm-light-outline::before {
  content: "\\f0bea";
}

.mdi-alarm-multiple::before {
  content: "\\f0022";
}

.mdi-alarm-note::before {
  content: "\\f0e71";
}

.mdi-alarm-note-off::before {
  content: "\\f0e72";
}

.mdi-alarm-off::before {
  content: "\\f0023";
}

.mdi-alarm-plus::before {
  content: "\\f0024";
}

.mdi-alarm-snooze::before {
  content: "\\f068e";
}

.mdi-album::before {
  content: "\\f0025";
}

.mdi-alert::before {
  content: "\\f0026";
}

.mdi-alert-box::before {
  content: "\\f0027";
}

.mdi-alert-box-outline::before {
  content: "\\f0ce4";
}

.mdi-alert-circle::before {
  content: "\\f0028";
}

.mdi-alert-circle-check::before {
  content: "\\f11ed";
}

.mdi-alert-circle-check-outline::before {
  content: "\\f11ee";
}

.mdi-alert-circle-outline::before {
  content: "\\f05d6";
}

.mdi-alert-decagram::before {
  content: "\\f06bd";
}

.mdi-alert-decagram-outline::before {
  content: "\\f0ce5";
}

.mdi-alert-octagon::before {
  content: "\\f0029";
}

.mdi-alert-octagon-outline::before {
  content: "\\f0ce6";
}

.mdi-alert-octagram::before {
  content: "\\f0767";
}

.mdi-alert-octagram-outline::before {
  content: "\\f0ce7";
}

.mdi-alert-outline::before {
  content: "\\f002a";
}

.mdi-alert-rhombus::before {
  content: "\\f11ce";
}

.mdi-alert-rhombus-outline::before {
  content: "\\f11cf";
}

.mdi-alien::before {
  content: "\\f089a";
}

.mdi-alien-outline::before {
  content: "\\f10cb";
}

.mdi-align-horizontal-center::before {
  content: "\\f11c3";
}

.mdi-align-horizontal-left::before {
  content: "\\f11c2";
}

.mdi-align-horizontal-right::before {
  content: "\\f11c4";
}

.mdi-align-vertical-bottom::before {
  content: "\\f11c5";
}

.mdi-align-vertical-center::before {
  content: "\\f11c6";
}

.mdi-align-vertical-top::before {
  content: "\\f11c7";
}

.mdi-all-inclusive::before {
  content: "\\f06be";
}

.mdi-allergy::before {
  content: "\\f1258";
}

.mdi-alpha::before {
  content: "\\f002b";
}

.mdi-alpha-a::before {
  content: "\\f0aee";
}

.mdi-alpha-a-box::before {
  content: "\\f0b08";
}

.mdi-alpha-a-box-outline::before {
  content: "\\f0beb";
}

.mdi-alpha-a-circle::before {
  content: "\\f0bec";
}

.mdi-alpha-a-circle-outline::before {
  content: "\\f0bed";
}

.mdi-alpha-b::before {
  content: "\\f0aef";
}

.mdi-alpha-b-box::before {
  content: "\\f0b09";
}

.mdi-alpha-b-box-outline::before {
  content: "\\f0bee";
}

.mdi-alpha-b-circle::before {
  content: "\\f0bef";
}

.mdi-alpha-b-circle-outline::before {
  content: "\\f0bf0";
}

.mdi-alpha-c::before {
  content: "\\f0af0";
}

.mdi-alpha-c-box::before {
  content: "\\f0b0a";
}

.mdi-alpha-c-box-outline::before {
  content: "\\f0bf1";
}

.mdi-alpha-c-circle::before {
  content: "\\f0bf2";
}

.mdi-alpha-c-circle-outline::before {
  content: "\\f0bf3";
}

.mdi-alpha-d::before {
  content: "\\f0af1";
}

.mdi-alpha-d-box::before {
  content: "\\f0b0b";
}

.mdi-alpha-d-box-outline::before {
  content: "\\f0bf4";
}

.mdi-alpha-d-circle::before {
  content: "\\f0bf5";
}

.mdi-alpha-d-circle-outline::before {
  content: "\\f0bf6";
}

.mdi-alpha-e::before {
  content: "\\f0af2";
}

.mdi-alpha-e-box::before {
  content: "\\f0b0c";
}

.mdi-alpha-e-box-outline::before {
  content: "\\f0bf7";
}

.mdi-alpha-e-circle::before {
  content: "\\f0bf8";
}

.mdi-alpha-e-circle-outline::before {
  content: "\\f0bf9";
}

.mdi-alpha-f::before {
  content: "\\f0af3";
}

.mdi-alpha-f-box::before {
  content: "\\f0b0d";
}

.mdi-alpha-f-box-outline::before {
  content: "\\f0bfa";
}

.mdi-alpha-f-circle::before {
  content: "\\f0bfb";
}

.mdi-alpha-f-circle-outline::before {
  content: "\\f0bfc";
}

.mdi-alpha-g::before {
  content: "\\f0af4";
}

.mdi-alpha-g-box::before {
  content: "\\f0b0e";
}

.mdi-alpha-g-box-outline::before {
  content: "\\f0bfd";
}

.mdi-alpha-g-circle::before {
  content: "\\f0bfe";
}

.mdi-alpha-g-circle-outline::before {
  content: "\\f0bff";
}

.mdi-alpha-h::before {
  content: "\\f0af5";
}

.mdi-alpha-h-box::before {
  content: "\\f0b0f";
}

.mdi-alpha-h-box-outline::before {
  content: "\\f0c00";
}

.mdi-alpha-h-circle::before {
  content: "\\f0c01";
}

.mdi-alpha-h-circle-outline::before {
  content: "\\f0c02";
}

.mdi-alpha-i::before {
  content: "\\f0af6";
}

.mdi-alpha-i-box::before {
  content: "\\f0b10";
}

.mdi-alpha-i-box-outline::before {
  content: "\\f0c03";
}

.mdi-alpha-i-circle::before {
  content: "\\f0c04";
}

.mdi-alpha-i-circle-outline::before {
  content: "\\f0c05";
}

.mdi-alpha-j::before {
  content: "\\f0af7";
}

.mdi-alpha-j-box::before {
  content: "\\f0b11";
}

.mdi-alpha-j-box-outline::before {
  content: "\\f0c06";
}

.mdi-alpha-j-circle::before {
  content: "\\f0c07";
}

.mdi-alpha-j-circle-outline::before {
  content: "\\f0c08";
}

.mdi-alpha-k::before {
  content: "\\f0af8";
}

.mdi-alpha-k-box::before {
  content: "\\f0b12";
}

.mdi-alpha-k-box-outline::before {
  content: "\\f0c09";
}

.mdi-alpha-k-circle::before {
  content: "\\f0c0a";
}

.mdi-alpha-k-circle-outline::before {
  content: "\\f0c0b";
}

.mdi-alpha-l::before {
  content: "\\f0af9";
}

.mdi-alpha-l-box::before {
  content: "\\f0b13";
}

.mdi-alpha-l-box-outline::before {
  content: "\\f0c0c";
}

.mdi-alpha-l-circle::before {
  content: "\\f0c0d";
}

.mdi-alpha-l-circle-outline::before {
  content: "\\f0c0e";
}

.mdi-alpha-m::before {
  content: "\\f0afa";
}

.mdi-alpha-m-box::before {
  content: "\\f0b14";
}

.mdi-alpha-m-box-outline::before {
  content: "\\f0c0f";
}

.mdi-alpha-m-circle::before {
  content: "\\f0c10";
}

.mdi-alpha-m-circle-outline::before {
  content: "\\f0c11";
}

.mdi-alpha-n::before {
  content: "\\f0afb";
}

.mdi-alpha-n-box::before {
  content: "\\f0b15";
}

.mdi-alpha-n-box-outline::before {
  content: "\\f0c12";
}

.mdi-alpha-n-circle::before {
  content: "\\f0c13";
}

.mdi-alpha-n-circle-outline::before {
  content: "\\f0c14";
}

.mdi-alpha-o::before {
  content: "\\f0afc";
}

.mdi-alpha-o-box::before {
  content: "\\f0b16";
}

.mdi-alpha-o-box-outline::before {
  content: "\\f0c15";
}

.mdi-alpha-o-circle::before {
  content: "\\f0c16";
}

.mdi-alpha-o-circle-outline::before {
  content: "\\f0c17";
}

.mdi-alpha-p::before {
  content: "\\f0afd";
}

.mdi-alpha-p-box::before {
  content: "\\f0b17";
}

.mdi-alpha-p-box-outline::before {
  content: "\\f0c18";
}

.mdi-alpha-p-circle::before {
  content: "\\f0c19";
}

.mdi-alpha-p-circle-outline::before {
  content: "\\f0c1a";
}

.mdi-alpha-q::before {
  content: "\\f0afe";
}

.mdi-alpha-q-box::before {
  content: "\\f0b18";
}

.mdi-alpha-q-box-outline::before {
  content: "\\f0c1b";
}

.mdi-alpha-q-circle::before {
  content: "\\f0c1c";
}

.mdi-alpha-q-circle-outline::before {
  content: "\\f0c1d";
}

.mdi-alpha-r::before {
  content: "\\f0aff";
}

.mdi-alpha-r-box::before {
  content: "\\f0b19";
}

.mdi-alpha-r-box-outline::before {
  content: "\\f0c1e";
}

.mdi-alpha-r-circle::before {
  content: "\\f0c1f";
}

.mdi-alpha-r-circle-outline::before {
  content: "\\f0c20";
}

.mdi-alpha-s::before {
  content: "\\f0b00";
}

.mdi-alpha-s-box::before {
  content: "\\f0b1a";
}

.mdi-alpha-s-box-outline::before {
  content: "\\f0c21";
}

.mdi-alpha-s-circle::before {
  content: "\\f0c22";
}

.mdi-alpha-s-circle-outline::before {
  content: "\\f0c23";
}

.mdi-alpha-t::before {
  content: "\\f0b01";
}

.mdi-alpha-t-box::before {
  content: "\\f0b1b";
}

.mdi-alpha-t-box-outline::before {
  content: "\\f0c24";
}

.mdi-alpha-t-circle::before {
  content: "\\f0c25";
}

.mdi-alpha-t-circle-outline::before {
  content: "\\f0c26";
}

.mdi-alpha-u::before {
  content: "\\f0b02";
}

.mdi-alpha-u-box::before {
  content: "\\f0b1c";
}

.mdi-alpha-u-box-outline::before {
  content: "\\f0c27";
}

.mdi-alpha-u-circle::before {
  content: "\\f0c28";
}

.mdi-alpha-u-circle-outline::before {
  content: "\\f0c29";
}

.mdi-alpha-v::before {
  content: "\\f0b03";
}

.mdi-alpha-v-box::before {
  content: "\\f0b1d";
}

.mdi-alpha-v-box-outline::before {
  content: "\\f0c2a";
}

.mdi-alpha-v-circle::before {
  content: "\\f0c2b";
}

.mdi-alpha-v-circle-outline::before {
  content: "\\f0c2c";
}

.mdi-alpha-w::before {
  content: "\\f0b04";
}

.mdi-alpha-w-box::before {
  content: "\\f0b1e";
}

.mdi-alpha-w-box-outline::before {
  content: "\\f0c2d";
}

.mdi-alpha-w-circle::before {
  content: "\\f0c2e";
}

.mdi-alpha-w-circle-outline::before {
  content: "\\f0c2f";
}

.mdi-alpha-x::before {
  content: "\\f0b05";
}

.mdi-alpha-x-box::before {
  content: "\\f0b1f";
}

.mdi-alpha-x-box-outline::before {
  content: "\\f0c30";
}

.mdi-alpha-x-circle::before {
  content: "\\f0c31";
}

.mdi-alpha-x-circle-outline::before {
  content: "\\f0c32";
}

.mdi-alpha-y::before {
  content: "\\f0b06";
}

.mdi-alpha-y-box::before {
  content: "\\f0b20";
}

.mdi-alpha-y-box-outline::before {
  content: "\\f0c33";
}

.mdi-alpha-y-circle::before {
  content: "\\f0c34";
}

.mdi-alpha-y-circle-outline::before {
  content: "\\f0c35";
}

.mdi-alpha-z::before {
  content: "\\f0b07";
}

.mdi-alpha-z-box::before {
  content: "\\f0b21";
}

.mdi-alpha-z-box-outline::before {
  content: "\\f0c36";
}

.mdi-alpha-z-circle::before {
  content: "\\f0c37";
}

.mdi-alpha-z-circle-outline::before {
  content: "\\f0c38";
}

.mdi-alphabet-aurebesh::before {
  content: "\\f132c";
}

.mdi-alphabet-cyrillic::before {
  content: "\\f132d";
}

.mdi-alphabet-greek::before {
  content: "\\f132e";
}

.mdi-alphabet-latin::before {
  content: "\\f132f";
}

.mdi-alphabet-piqad::before {
  content: "\\f1330";
}

.mdi-alphabet-tengwar::before {
  content: "\\f1337";
}

.mdi-alphabetical::before {
  content: "\\f002c";
}

.mdi-alphabetical-off::before {
  content: "\\f100c";
}

.mdi-alphabetical-variant::before {
  content: "\\f100d";
}

.mdi-alphabetical-variant-off::before {
  content: "\\f100e";
}

.mdi-altimeter::before {
  content: "\\f05d7";
}

.mdi-amazon::before {
  content: "\\f002d";
}

.mdi-amazon-alexa::before {
  content: "\\f08c6";
}

.mdi-ambulance::before {
  content: "\\f002f";
}

.mdi-ammunition::before {
  content: "\\f0ce8";
}

.mdi-ampersand::before {
  content: "\\f0a8d";
}

.mdi-amplifier::before {
  content: "\\f0030";
}

.mdi-amplifier-off::before {
  content: "\\f11b5";
}

.mdi-anchor::before {
  content: "\\f0031";
}

.mdi-android::before {
  content: "\\f0032";
}

.mdi-android-auto::before {
  content: "\\f0a8e";
}

.mdi-android-debug-bridge::before {
  content: "\\f0033";
}

.mdi-android-messages::before {
  content: "\\f0d45";
}

.mdi-android-studio::before {
  content: "\\f0034";
}

.mdi-angle-acute::before {
  content: "\\f0937";
}

.mdi-angle-obtuse::before {
  content: "\\f0938";
}

.mdi-angle-right::before {
  content: "\\f0939";
}

.mdi-angular::before {
  content: "\\f06b2";
}

.mdi-angularjs::before {
  content: "\\f06bf";
}

.mdi-animation::before {
  content: "\\f05d8";
}

.mdi-animation-outline::before {
  content: "\\f0a8f";
}

.mdi-animation-play::before {
  content: "\\f093a";
}

.mdi-animation-play-outline::before {
  content: "\\f0a90";
}

.mdi-ansible::before {
  content: "\\f109a";
}

.mdi-antenna::before {
  content: "\\f1119";
}

.mdi-anvil::before {
  content: "\\f089b";
}

.mdi-apache-kafka::before {
  content: "\\f100f";
}

.mdi-api::before {
  content: "\\f109b";
}

.mdi-api-off::before {
  content: "\\f1257";
}

.mdi-apple::before {
  content: "\\f0035";
}

.mdi-apple-airplay::before {
  content: "\\f001f";
}

.mdi-apple-finder::before {
  content: "\\f0036";
}

.mdi-apple-icloud::before {
  content: "\\f0038";
}

.mdi-apple-ios::before {
  content: "\\f0037";
}

.mdi-apple-keyboard-caps::before {
  content: "\\f0632";
}

.mdi-apple-keyboard-command::before {
  content: "\\f0633";
}

.mdi-apple-keyboard-control::before {
  content: "\\f0634";
}

.mdi-apple-keyboard-option::before {
  content: "\\f0635";
}

.mdi-apple-keyboard-shift::before {
  content: "\\f0636";
}

.mdi-apple-safari::before {
  content: "\\f0039";
}

.mdi-application::before {
  content: "\\f0614";
}

.mdi-application-export::before {
  content: "\\f0dad";
}

.mdi-application-import::before {
  content: "\\f0dae";
}

.mdi-approximately-equal::before {
  content: "\\f0f9e";
}

.mdi-approximately-equal-box::before {
  content: "\\f0f9f";
}

.mdi-apps::before {
  content: "\\f003b";
}

.mdi-apps-box::before {
  content: "\\f0d46";
}

.mdi-arch::before {
  content: "\\f08c7";
}

.mdi-archive::before {
  content: "\\f003c";
}

.mdi-archive-arrow-down::before {
  content: "\\f1259";
}

.mdi-archive-arrow-down-outline::before {
  content: "\\f125a";
}

.mdi-archive-arrow-up::before {
  content: "\\f125b";
}

.mdi-archive-arrow-up-outline::before {
  content: "\\f125c";
}

.mdi-archive-outline::before {
  content: "\\f120e";
}

.mdi-arm-flex::before {
  content: "\\f0fd7";
}

.mdi-arm-flex-outline::before {
  content: "\\f0fd6";
}

.mdi-arrange-bring-forward::before {
  content: "\\f003d";
}

.mdi-arrange-bring-to-front::before {
  content: "\\f003e";
}

.mdi-arrange-send-backward::before {
  content: "\\f003f";
}

.mdi-arrange-send-to-back::before {
  content: "\\f0040";
}

.mdi-arrow-all::before {
  content: "\\f0041";
}

.mdi-arrow-bottom-left::before {
  content: "\\f0042";
}

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\f09b7";
}

.mdi-arrow-bottom-left-thick::before {
  content: "\\f09b8";
}

.mdi-arrow-bottom-right::before {
  content: "\\f0043";
}

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\f09b9";
}

.mdi-arrow-bottom-right-thick::before {
  content: "\\f09ba";
}

.mdi-arrow-collapse::before {
  content: "\\f0615";
}

.mdi-arrow-collapse-all::before {
  content: "\\f0044";
}

.mdi-arrow-collapse-down::before {
  content: "\\f0792";
}

.mdi-arrow-collapse-horizontal::before {
  content: "\\f084c";
}

.mdi-arrow-collapse-left::before {
  content: "\\f0793";
}

.mdi-arrow-collapse-right::before {
  content: "\\f0794";
}

.mdi-arrow-collapse-up::before {
  content: "\\f0795";
}

.mdi-arrow-collapse-vertical::before {
  content: "\\f084d";
}

.mdi-arrow-decision::before {
  content: "\\f09bb";
}

.mdi-arrow-decision-auto::before {
  content: "\\f09bc";
}

.mdi-arrow-decision-auto-outline::before {
  content: "\\f09bd";
}

.mdi-arrow-decision-outline::before {
  content: "\\f09be";
}

.mdi-arrow-down::before {
  content: "\\f0045";
}

.mdi-arrow-down-bold::before {
  content: "\\f072e";
}

.mdi-arrow-down-bold-box::before {
  content: "\\f072f";
}

.mdi-arrow-down-bold-box-outline::before {
  content: "\\f0730";
}

.mdi-arrow-down-bold-circle::before {
  content: "\\f0047";
}

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\f0048";
}

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\f0049";
}

.mdi-arrow-down-bold-outline::before {
  content: "\\f09bf";
}

.mdi-arrow-down-box::before {
  content: "\\f06c0";
}

.mdi-arrow-down-circle::before {
  content: "\\f0cdb";
}

.mdi-arrow-down-circle-outline::before {
  content: "\\f0cdc";
}

.mdi-arrow-down-drop-circle::before {
  content: "\\f004a";
}

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\f004b";
}

.mdi-arrow-down-thick::before {
  content: "\\f0046";
}

.mdi-arrow-expand::before {
  content: "\\f0616";
}

.mdi-arrow-expand-all::before {
  content: "\\f004c";
}

.mdi-arrow-expand-down::before {
  content: "\\f0796";
}

.mdi-arrow-expand-horizontal::before {
  content: "\\f084e";
}

.mdi-arrow-expand-left::before {
  content: "\\f0797";
}

.mdi-arrow-expand-right::before {
  content: "\\f0798";
}

.mdi-arrow-expand-up::before {
  content: "\\f0799";
}

.mdi-arrow-expand-vertical::before {
  content: "\\f084f";
}

.mdi-arrow-horizontal-lock::before {
  content: "\\f115b";
}

.mdi-arrow-left::before {
  content: "\\f004d";
}

.mdi-arrow-left-bold::before {
  content: "\\f0731";
}

.mdi-arrow-left-bold-box::before {
  content: "\\f0732";
}

.mdi-arrow-left-bold-box-outline::before {
  content: "\\f0733";
}

.mdi-arrow-left-bold-circle::before {
  content: "\\f004f";
}

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\f0050";
}

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\f0051";
}

.mdi-arrow-left-bold-outline::before {
  content: "\\f09c0";
}

.mdi-arrow-left-box::before {
  content: "\\f06c1";
}

.mdi-arrow-left-circle::before {
  content: "\\f0cdd";
}

.mdi-arrow-left-circle-outline::before {
  content: "\\f0cde";
}

.mdi-arrow-left-drop-circle::before {
  content: "\\f0052";
}

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\f0053";
}

.mdi-arrow-left-right::before {
  content: "\\f0e73";
}

.mdi-arrow-left-right-bold::before {
  content: "\\f0e74";
}

.mdi-arrow-left-right-bold-outline::before {
  content: "\\f09c1";
}

.mdi-arrow-left-thick::before {
  content: "\\f004e";
}

.mdi-arrow-right::before {
  content: "\\f0054";
}

.mdi-arrow-right-bold::before {
  content: "\\f0734";
}

.mdi-arrow-right-bold-box::before {
  content: "\\f0735";
}

.mdi-arrow-right-bold-box-outline::before {
  content: "\\f0736";
}

.mdi-arrow-right-bold-circle::before {
  content: "\\f0056";
}

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\f0057";
}

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\f0058";
}

.mdi-arrow-right-bold-outline::before {
  content: "\\f09c2";
}

.mdi-arrow-right-box::before {
  content: "\\f06c2";
}

.mdi-arrow-right-circle::before {
  content: "\\f0cdf";
}

.mdi-arrow-right-circle-outline::before {
  content: "\\f0ce0";
}

.mdi-arrow-right-drop-circle::before {
  content: "\\f0059";
}

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\f005a";
}

.mdi-arrow-right-thick::before {
  content: "\\f0055";
}

.mdi-arrow-split-horizontal::before {
  content: "\\f093b";
}

.mdi-arrow-split-vertical::before {
  content: "\\f093c";
}

.mdi-arrow-top-left::before {
  content: "\\f005b";
}

.mdi-arrow-top-left-bold-outline::before {
  content: "\\f09c3";
}

.mdi-arrow-top-left-bottom-right::before {
  content: "\\f0e75";
}

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\f0e76";
}

.mdi-arrow-top-left-thick::before {
  content: "\\f09c4";
}

.mdi-arrow-top-right::before {
  content: "\\f005c";
}

.mdi-arrow-top-right-bold-outline::before {
  content: "\\f09c5";
}

.mdi-arrow-top-right-bottom-left::before {
  content: "\\f0e77";
}

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\f0e78";
}

.mdi-arrow-top-right-thick::before {
  content: "\\f09c6";
}

.mdi-arrow-up::before {
  content: "\\f005d";
}

.mdi-arrow-up-bold::before {
  content: "\\f0737";
}

.mdi-arrow-up-bold-box::before {
  content: "\\f0738";
}

.mdi-arrow-up-bold-box-outline::before {
  content: "\\f0739";
}

.mdi-arrow-up-bold-circle::before {
  content: "\\f005f";
}

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\f0060";
}

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\f0061";
}

.mdi-arrow-up-bold-outline::before {
  content: "\\f09c7";
}

.mdi-arrow-up-box::before {
  content: "\\f06c3";
}

.mdi-arrow-up-circle::before {
  content: "\\f0ce1";
}

.mdi-arrow-up-circle-outline::before {
  content: "\\f0ce2";
}

.mdi-arrow-up-down::before {
  content: "\\f0e79";
}

.mdi-arrow-up-down-bold::before {
  content: "\\f0e7a";
}

.mdi-arrow-up-down-bold-outline::before {
  content: "\\f09c8";
}

.mdi-arrow-up-drop-circle::before {
  content: "\\f0062";
}

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\f0063";
}

.mdi-arrow-up-thick::before {
  content: "\\f005e";
}

.mdi-arrow-vertical-lock::before {
  content: "\\f115c";
}

.mdi-artstation::before {
  content: "\\f0b5b";
}

.mdi-aspect-ratio::before {
  content: "\\f0a24";
}

.mdi-assistant::before {
  content: "\\f0064";
}

.mdi-asterisk::before {
  content: "\\f06c4";
}

.mdi-at::before {
  content: "\\f0065";
}

.mdi-atlassian::before {
  content: "\\f0804";
}

.mdi-atm::before {
  content: "\\f0d47";
}

.mdi-atom::before {
  content: "\\f0768";
}

.mdi-atom-variant::before {
  content: "\\f0e7b";
}

.mdi-attachment::before {
  content: "\\f0066";
}

.mdi-audio-video::before {
  content: "\\f093d";
}

.mdi-audio-video-off::before {
  content: "\\f11b6";
}

.mdi-augmented-reality::before {
  content: "\\f0850";
}

.mdi-auto-download::before {
  content: "\\f137e";
}

.mdi-auto-fix::before {
  content: "\\f0068";
}

.mdi-auto-upload::before {
  content: "\\f0069";
}

.mdi-autorenew::before {
  content: "\\f006a";
}

.mdi-av-timer::before {
  content: "\\f006b";
}

.mdi-aws::before {
  content: "\\f0e0f";
}

.mdi-axe::before {
  content: "\\f08c8";
}

.mdi-axis::before {
  content: "\\f0d48";
}

.mdi-axis-arrow::before {
  content: "\\f0d49";
}

.mdi-axis-arrow-lock::before {
  content: "\\f0d4a";
}

.mdi-axis-lock::before {
  content: "\\f0d4b";
}

.mdi-axis-x-arrow::before {
  content: "\\f0d4c";
}

.mdi-axis-x-arrow-lock::before {
  content: "\\f0d4d";
}

.mdi-axis-x-rotate-clockwise::before {
  content: "\\f0d4e";
}

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\f0d4f";
}

.mdi-axis-x-y-arrow-lock::before {
  content: "\\f0d50";
}

.mdi-axis-y-arrow::before {
  content: "\\f0d51";
}

.mdi-axis-y-arrow-lock::before {
  content: "\\f0d52";
}

.mdi-axis-y-rotate-clockwise::before {
  content: "\\f0d53";
}

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\f0d54";
}

.mdi-axis-z-arrow::before {
  content: "\\f0d55";
}

.mdi-axis-z-arrow-lock::before {
  content: "\\f0d56";
}

.mdi-axis-z-rotate-clockwise::before {
  content: "\\f0d57";
}

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\f0d58";
}

.mdi-babel::before {
  content: "\\f0a25";
}

.mdi-baby::before {
  content: "\\f006c";
}

.mdi-baby-bottle::before {
  content: "\\f0f39";
}

.mdi-baby-bottle-outline::before {
  content: "\\f0f3a";
}

.mdi-baby-carriage::before {
  content: "\\f068f";
}

.mdi-baby-carriage-off::before {
  content: "\\f0fa0";
}

.mdi-baby-face::before {
  content: "\\f0e7c";
}

.mdi-baby-face-outline::before {
  content: "\\f0e7d";
}

.mdi-backburger::before {
  content: "\\f006d";
}

.mdi-backspace::before {
  content: "\\f006e";
}

.mdi-backspace-outline::before {
  content: "\\f0b5c";
}

.mdi-backspace-reverse::before {
  content: "\\f0e7e";
}

.mdi-backspace-reverse-outline::before {
  content: "\\f0e7f";
}

.mdi-backup-restore::before {
  content: "\\f006f";
}

.mdi-bacteria::before {
  content: "\\f0ed5";
}

.mdi-bacteria-outline::before {
  content: "\\f0ed6";
}

.mdi-badge-account::before {
  content: "\\f0da7";
}

.mdi-badge-account-alert::before {
  content: "\\f0da8";
}

.mdi-badge-account-alert-outline::before {
  content: "\\f0da9";
}

.mdi-badge-account-horizontal::before {
  content: "\\f0e0d";
}

.mdi-badge-account-horizontal-outline::before {
  content: "\\f0e0e";
}

.mdi-badge-account-outline::before {
  content: "\\f0daa";
}

.mdi-badminton::before {
  content: "\\f0851";
}

.mdi-bag-carry-on::before {
  content: "\\f0f3b";
}

.mdi-bag-carry-on-check::before {
  content: "\\f0d65";
}

.mdi-bag-carry-on-off::before {
  content: "\\f0f3c";
}

.mdi-bag-checked::before {
  content: "\\f0f3d";
}

.mdi-bag-personal::before {
  content: "\\f0e10";
}

.mdi-bag-personal-off::before {
  content: "\\f0e11";
}

.mdi-bag-personal-off-outline::before {
  content: "\\f0e12";
}

.mdi-bag-personal-outline::before {
  content: "\\f0e13";
}

.mdi-baguette::before {
  content: "\\f0f3e";
}

.mdi-balloon::before {
  content: "\\f0a26";
}

.mdi-ballot::before {
  content: "\\f09c9";
}

.mdi-ballot-outline::before {
  content: "\\f09ca";
}

.mdi-ballot-recount::before {
  content: "\\f0c39";
}

.mdi-ballot-recount-outline::before {
  content: "\\f0c3a";
}

.mdi-bandage::before {
  content: "\\f0daf";
}

.mdi-bandcamp::before {
  content: "\\f0675";
}

.mdi-bank::before {
  content: "\\f0070";
}

.mdi-bank-minus::before {
  content: "\\f0db0";
}

.mdi-bank-outline::before {
  content: "\\f0e80";
}

.mdi-bank-plus::before {
  content: "\\f0db1";
}

.mdi-bank-remove::before {
  content: "\\f0db2";
}

.mdi-bank-transfer::before {
  content: "\\f0a27";
}

.mdi-bank-transfer-in::before {
  content: "\\f0a28";
}

.mdi-bank-transfer-out::before {
  content: "\\f0a29";
}

.mdi-barcode::before {
  content: "\\f0071";
}

.mdi-barcode-off::before {
  content: "\\f1236";
}

.mdi-barcode-scan::before {
  content: "\\f0072";
}

.mdi-barley::before {
  content: "\\f0073";
}

.mdi-barley-off::before {
  content: "\\f0b5d";
}

.mdi-barn::before {
  content: "\\f0b5e";
}

.mdi-barrel::before {
  content: "\\f0074";
}

.mdi-baseball::before {
  content: "\\f0852";
}

.mdi-baseball-bat::before {
  content: "\\f0853";
}

.mdi-bash::before {
  content: "\\f1183";
}

.mdi-basket::before {
  content: "\\f0076";
}

.mdi-basket-fill::before {
  content: "\\f0077";
}

.mdi-basket-outline::before {
  content: "\\f1181";
}

.mdi-basket-unfill::before {
  content: "\\f0078";
}

.mdi-basketball::before {
  content: "\\f0806";
}

.mdi-basketball-hoop::before {
  content: "\\f0c3b";
}

.mdi-basketball-hoop-outline::before {
  content: "\\f0c3c";
}

.mdi-bat::before {
  content: "\\f0b5f";
}

.mdi-battery::before {
  content: "\\f0079";
}

.mdi-battery-10::before {
  content: "\\f007a";
}

.mdi-battery-10-bluetooth::before {
  content: "\\f093e";
}

.mdi-battery-20::before {
  content: "\\f007b";
}

.mdi-battery-20-bluetooth::before {
  content: "\\f093f";
}

.mdi-battery-30::before {
  content: "\\f007c";
}

.mdi-battery-30-bluetooth::before {
  content: "\\f0940";
}

.mdi-battery-40::before {
  content: "\\f007d";
}

.mdi-battery-40-bluetooth::before {
  content: "\\f0941";
}

.mdi-battery-50::before {
  content: "\\f007e";
}

.mdi-battery-50-bluetooth::before {
  content: "\\f0942";
}

.mdi-battery-60::before {
  content: "\\f007f";
}

.mdi-battery-60-bluetooth::before {
  content: "\\f0943";
}

.mdi-battery-70::before {
  content: "\\f0080";
}

.mdi-battery-70-bluetooth::before {
  content: "\\f0944";
}

.mdi-battery-80::before {
  content: "\\f0081";
}

.mdi-battery-80-bluetooth::before {
  content: "\\f0945";
}

.mdi-battery-90::before {
  content: "\\f0082";
}

.mdi-battery-90-bluetooth::before {
  content: "\\f0946";
}

.mdi-battery-alert::before {
  content: "\\f0083";
}

.mdi-battery-alert-bluetooth::before {
  content: "\\f0947";
}

.mdi-battery-alert-variant::before {
  content: "\\f10cc";
}

.mdi-battery-alert-variant-outline::before {
  content: "\\f10cd";
}

.mdi-battery-bluetooth::before {
  content: "\\f0948";
}

.mdi-battery-bluetooth-variant::before {
  content: "\\f0949";
}

.mdi-battery-charging::before {
  content: "\\f0084";
}

.mdi-battery-charging-10::before {
  content: "\\f089c";
}

.mdi-battery-charging-100::before {
  content: "\\f0085";
}

.mdi-battery-charging-20::before {
  content: "\\f0086";
}

.mdi-battery-charging-30::before {
  content: "\\f0087";
}

.mdi-battery-charging-40::before {
  content: "\\f0088";
}

.mdi-battery-charging-50::before {
  content: "\\f089d";
}

.mdi-battery-charging-60::before {
  content: "\\f0089";
}

.mdi-battery-charging-70::before {
  content: "\\f089e";
}

.mdi-battery-charging-80::before {
  content: "\\f008a";
}

.mdi-battery-charging-90::before {
  content: "\\f008b";
}

.mdi-battery-charging-high::before {
  content: "\\f12a6";
}

.mdi-battery-charging-low::before {
  content: "\\f12a4";
}

.mdi-battery-charging-medium::before {
  content: "\\f12a5";
}

.mdi-battery-charging-outline::before {
  content: "\\f089f";
}

.mdi-battery-charging-wireless::before {
  content: "\\f0807";
}

.mdi-battery-charging-wireless-10::before {
  content: "\\f0808";
}

.mdi-battery-charging-wireless-20::before {
  content: "\\f0809";
}

.mdi-battery-charging-wireless-30::before {
  content: "\\f080a";
}

.mdi-battery-charging-wireless-40::before {
  content: "\\f080b";
}

.mdi-battery-charging-wireless-50::before {
  content: "\\f080c";
}

.mdi-battery-charging-wireless-60::before {
  content: "\\f080d";
}

.mdi-battery-charging-wireless-70::before {
  content: "\\f080e";
}

.mdi-battery-charging-wireless-80::before {
  content: "\\f080f";
}

.mdi-battery-charging-wireless-90::before {
  content: "\\f0810";
}

.mdi-battery-charging-wireless-alert::before {
  content: "\\f0811";
}

.mdi-battery-charging-wireless-outline::before {
  content: "\\f0812";
}

.mdi-battery-heart::before {
  content: "\\f120f";
}

.mdi-battery-heart-outline::before {
  content: "\\f1210";
}

.mdi-battery-heart-variant::before {
  content: "\\f1211";
}

.mdi-battery-high::before {
  content: "\\f12a3";
}

.mdi-battery-low::before {
  content: "\\f12a1";
}

.mdi-battery-medium::before {
  content: "\\f12a2";
}

.mdi-battery-minus::before {
  content: "\\f008c";
}

.mdi-battery-negative::before {
  content: "\\f008d";
}

.mdi-battery-off::before {
  content: "\\f125d";
}

.mdi-battery-off-outline::before {
  content: "\\f125e";
}

.mdi-battery-outline::before {
  content: "\\f008e";
}

.mdi-battery-plus::before {
  content: "\\f008f";
}

.mdi-battery-positive::before {
  content: "\\f0090";
}

.mdi-battery-unknown::before {
  content: "\\f0091";
}

.mdi-battery-unknown-bluetooth::before {
  content: "\\f094a";
}

.mdi-battlenet::before {
  content: "\\f0b60";
}

.mdi-beach::before {
  content: "\\f0092";
}

.mdi-beaker::before {
  content: "\\f0cea";
}

.mdi-beaker-alert::before {
  content: "\\f1229";
}

.mdi-beaker-alert-outline::before {
  content: "\\f122a";
}

.mdi-beaker-check::before {
  content: "\\f122b";
}

.mdi-beaker-check-outline::before {
  content: "\\f122c";
}

.mdi-beaker-minus::before {
  content: "\\f122d";
}

.mdi-beaker-minus-outline::before {
  content: "\\f122e";
}

.mdi-beaker-outline::before {
  content: "\\f0690";
}

.mdi-beaker-plus::before {
  content: "\\f122f";
}

.mdi-beaker-plus-outline::before {
  content: "\\f1230";
}

.mdi-beaker-question::before {
  content: "\\f1231";
}

.mdi-beaker-question-outline::before {
  content: "\\f1232";
}

.mdi-beaker-remove::before {
  content: "\\f1233";
}

.mdi-beaker-remove-outline::before {
  content: "\\f1234";
}

.mdi-bed::before {
  content: "\\f02e3";
}

.mdi-bed-double::before {
  content: "\\f0fd4";
}

.mdi-bed-double-outline::before {
  content: "\\f0fd3";
}

.mdi-bed-empty::before {
  content: "\\f08a0";
}

.mdi-bed-king::before {
  content: "\\f0fd2";
}

.mdi-bed-king-outline::before {
  content: "\\f0fd1";
}

.mdi-bed-outline::before {
  content: "\\f0099";
}

.mdi-bed-queen::before {
  content: "\\f0fd0";
}

.mdi-bed-queen-outline::before {
  content: "\\f0fdb";
}

.mdi-bed-single::before {
  content: "\\f106d";
}

.mdi-bed-single-outline::before {
  content: "\\f106e";
}

.mdi-bee::before {
  content: "\\f0fa1";
}

.mdi-bee-flower::before {
  content: "\\f0fa2";
}

.mdi-beehive-outline::before {
  content: "\\f10ce";
}

.mdi-beer::before {
  content: "\\f0098";
}

.mdi-beer-outline::before {
  content: "\\f130c";
}

.mdi-bell::before {
  content: "\\f009a";
}

.mdi-bell-alert::before {
  content: "\\f0d59";
}

.mdi-bell-alert-outline::before {
  content: "\\f0e81";
}

.mdi-bell-check::before {
  content: "\\f11e5";
}

.mdi-bell-check-outline::before {
  content: "\\f11e6";
}

.mdi-bell-circle::before {
  content: "\\f0d5a";
}

.mdi-bell-circle-outline::before {
  content: "\\f0d5b";
}

.mdi-bell-off::before {
  content: "\\f009b";
}

.mdi-bell-off-outline::before {
  content: "\\f0a91";
}

.mdi-bell-outline::before {
  content: "\\f009c";
}

.mdi-bell-plus::before {
  content: "\\f009d";
}

.mdi-bell-plus-outline::before {
  content: "\\f0a92";
}

.mdi-bell-ring::before {
  content: "\\f009e";
}

.mdi-bell-ring-outline::before {
  content: "\\f009f";
}

.mdi-bell-sleep::before {
  content: "\\f00a0";
}

.mdi-bell-sleep-outline::before {
  content: "\\f0a93";
}

.mdi-beta::before {
  content: "\\f00a1";
}

.mdi-betamax::before {
  content: "\\f09cb";
}

.mdi-biathlon::before {
  content: "\\f0e14";
}

.mdi-bicycle::before {
  content: "\\f109c";
}

.mdi-bicycle-basket::before {
  content: "\\f1235";
}

.mdi-bike::before {
  content: "\\f00a3";
}

.mdi-bike-fast::before {
  content: "\\f111f";
}

.mdi-billboard::before {
  content: "\\f1010";
}

.mdi-billiards::before {
  content: "\\f0b61";
}

.mdi-billiards-rack::before {
  content: "\\f0b62";
}

.mdi-binoculars::before {
  content: "\\f00a5";
}

.mdi-bio::before {
  content: "\\f00a6";
}

.mdi-biohazard::before {
  content: "\\f00a7";
}

.mdi-bitbucket::before {
  content: "\\f00a8";
}

.mdi-bitcoin::before {
  content: "\\f0813";
}

.mdi-black-mesa::before {
  content: "\\f00a9";
}

.mdi-blender::before {
  content: "\\f0ceb";
}

.mdi-blender-software::before {
  content: "\\f00ab";
}

.mdi-blinds::before {
  content: "\\f00ac";
}

.mdi-blinds-open::before {
  content: "\\f1011";
}

.mdi-block-helper::before {
  content: "\\f00ad";
}

.mdi-blogger::before {
  content: "\\f00ae";
}

.mdi-blood-bag::before {
  content: "\\f0cec";
}

.mdi-bluetooth::before {
  content: "\\f00af";
}

.mdi-bluetooth-audio::before {
  content: "\\f00b0";
}

.mdi-bluetooth-connect::before {
  content: "\\f00b1";
}

.mdi-bluetooth-off::before {
  content: "\\f00b2";
}

.mdi-bluetooth-settings::before {
  content: "\\f00b3";
}

.mdi-bluetooth-transfer::before {
  content: "\\f00b4";
}

.mdi-blur::before {
  content: "\\f00b5";
}

.mdi-blur-linear::before {
  content: "\\f00b6";
}

.mdi-blur-off::before {
  content: "\\f00b7";
}

.mdi-blur-radial::before {
  content: "\\f00b8";
}

.mdi-bolnisi-cross::before {
  content: "\\f0ced";
}

.mdi-bolt::before {
  content: "\\f0db3";
}

.mdi-bomb::before {
  content: "\\f0691";
}

.mdi-bomb-off::before {
  content: "\\f06c5";
}

.mdi-bone::before {
  content: "\\f00b9";
}

.mdi-book::before {
  content: "\\f00ba";
}

.mdi-book-account::before {
  content: "\\f13ad";
}

.mdi-book-account-outline::before {
  content: "\\f13ae";
}

.mdi-book-alphabet::before {
  content: "\\f061d";
}

.mdi-book-cross::before {
  content: "\\f00a2";
}

.mdi-book-information-variant::before {
  content: "\\f106f";
}

.mdi-book-lock::before {
  content: "\\f079a";
}

.mdi-book-lock-open::before {
  content: "\\f079b";
}

.mdi-book-minus::before {
  content: "\\f05d9";
}

.mdi-book-minus-multiple::before {
  content: "\\f0a94";
}

.mdi-book-minus-multiple-outline::before {
  content: "\\f090b";
}

.mdi-book-multiple::before {
  content: "\\f00bb";
}

.mdi-book-multiple-outline::before {
  content: "\\f0436";
}

.mdi-book-music::before {
  content: "\\f0067";
}

.mdi-book-open::before {
  content: "\\f00bd";
}

.mdi-book-open-outline::before {
  content: "\\f0b63";
}

.mdi-book-open-page-variant::before {
  content: "\\f05da";
}

.mdi-book-open-variant::before {
  content: "\\f00be";
}

.mdi-book-outline::before {
  content: "\\f0b64";
}

.mdi-book-play::before {
  content: "\\f0e82";
}

.mdi-book-play-outline::before {
  content: "\\f0e83";
}

.mdi-book-plus::before {
  content: "\\f05db";
}

.mdi-book-plus-multiple::before {
  content: "\\f0a95";
}

.mdi-book-plus-multiple-outline::before {
  content: "\\f0ade";
}

.mdi-book-remove::before {
  content: "\\f0a97";
}

.mdi-book-remove-multiple::before {
  content: "\\f0a96";
}

.mdi-book-remove-multiple-outline::before {
  content: "\\f04ca";
}

.mdi-book-search::before {
  content: "\\f0e84";
}

.mdi-book-search-outline::before {
  content: "\\f0e85";
}

.mdi-book-variant::before {
  content: "\\f00bf";
}

.mdi-book-variant-multiple::before {
  content: "\\f00bc";
}

.mdi-bookmark::before {
  content: "\\f00c0";
}

.mdi-bookmark-check::before {
  content: "\\f00c1";
}

.mdi-bookmark-check-outline::before {
  content: "\\f137b";
}

.mdi-bookmark-minus::before {
  content: "\\f09cc";
}

.mdi-bookmark-minus-outline::before {
  content: "\\f09cd";
}

.mdi-bookmark-multiple::before {
  content: "\\f0e15";
}

.mdi-bookmark-multiple-outline::before {
  content: "\\f0e16";
}

.mdi-bookmark-music::before {
  content: "\\f00c2";
}

.mdi-bookmark-music-outline::before {
  content: "\\f1379";
}

.mdi-bookmark-off::before {
  content: "\\f09ce";
}

.mdi-bookmark-off-outline::before {
  content: "\\f09cf";
}

.mdi-bookmark-outline::before {
  content: "\\f00c3";
}

.mdi-bookmark-plus::before {
  content: "\\f00c5";
}

.mdi-bookmark-plus-outline::before {
  content: "\\f00c4";
}

.mdi-bookmark-remove::before {
  content: "\\f00c6";
}

.mdi-bookmark-remove-outline::before {
  content: "\\f137a";
}

.mdi-bookshelf::before {
  content: "\\f125f";
}

.mdi-boom-gate::before {
  content: "\\f0e86";
}

.mdi-boom-gate-alert::before {
  content: "\\f0e87";
}

.mdi-boom-gate-alert-outline::before {
  content: "\\f0e88";
}

.mdi-boom-gate-down::before {
  content: "\\f0e89";
}

.mdi-boom-gate-down-outline::before {
  content: "\\f0e8a";
}

.mdi-boom-gate-outline::before {
  content: "\\f0e8b";
}

.mdi-boom-gate-up::before {
  content: "\\f0e8c";
}

.mdi-boom-gate-up-outline::before {
  content: "\\f0e8d";
}

.mdi-boombox::before {
  content: "\\f05dc";
}

.mdi-boomerang::before {
  content: "\\f10cf";
}

.mdi-bootstrap::before {
  content: "\\f06c6";
}

.mdi-border-all::before {
  content: "\\f00c7";
}

.mdi-border-all-variant::before {
  content: "\\f08a1";
}

.mdi-border-bottom::before {
  content: "\\f00c8";
}

.mdi-border-bottom-variant::before {
  content: "\\f08a2";
}

.mdi-border-color::before {
  content: "\\f00c9";
}

.mdi-border-horizontal::before {
  content: "\\f00ca";
}

.mdi-border-inside::before {
  content: "\\f00cb";
}

.mdi-border-left::before {
  content: "\\f00cc";
}

.mdi-border-left-variant::before {
  content: "\\f08a3";
}

.mdi-border-none::before {
  content: "\\f00cd";
}

.mdi-border-none-variant::before {
  content: "\\f08a4";
}

.mdi-border-outside::before {
  content: "\\f00ce";
}

.mdi-border-right::before {
  content: "\\f00cf";
}

.mdi-border-right-variant::before {
  content: "\\f08a5";
}

.mdi-border-style::before {
  content: "\\f00d0";
}

.mdi-border-top::before {
  content: "\\f00d1";
}

.mdi-border-top-variant::before {
  content: "\\f08a6";
}

.mdi-border-vertical::before {
  content: "\\f00d2";
}

.mdi-bottle-soda::before {
  content: "\\f1070";
}

.mdi-bottle-soda-classic::before {
  content: "\\f1071";
}

.mdi-bottle-soda-classic-outline::before {
  content: "\\f1363";
}

.mdi-bottle-soda-outline::before {
  content: "\\f1072";
}

.mdi-bottle-tonic::before {
  content: "\\f112e";
}

.mdi-bottle-tonic-outline::before {
  content: "\\f112f";
}

.mdi-bottle-tonic-plus::before {
  content: "\\f1130";
}

.mdi-bottle-tonic-plus-outline::before {
  content: "\\f1131";
}

.mdi-bottle-tonic-skull::before {
  content: "\\f1132";
}

.mdi-bottle-tonic-skull-outline::before {
  content: "\\f1133";
}

.mdi-bottle-wine::before {
  content: "\\f0854";
}

.mdi-bottle-wine-outline::before {
  content: "\\f1310";
}

.mdi-bow-tie::before {
  content: "\\f0678";
}

.mdi-bowl::before {
  content: "\\f028e";
}

.mdi-bowl-mix::before {
  content: "\\f0617";
}

.mdi-bowl-mix-outline::before {
  content: "\\f02e4";
}

.mdi-bowl-outline::before {
  content: "\\f02a9";
}

.mdi-bowling::before {
  content: "\\f00d3";
}

.mdi-box::before {
  content: "\\f00d4";
}

.mdi-box-cutter::before {
  content: "\\f00d5";
}

.mdi-box-cutter-off::before {
  content: "\\f0b4a";
}

.mdi-box-shadow::before {
  content: "\\f0637";
}

.mdi-boxing-glove::before {
  content: "\\f0b65";
}

.mdi-braille::before {
  content: "\\f09d0";
}

.mdi-brain::before {
  content: "\\f09d1";
}

.mdi-bread-slice::before {
  content: "\\f0cee";
}

.mdi-bread-slice-outline::before {
  content: "\\f0cef";
}

.mdi-bridge::before {
  content: "\\f0618";
}

.mdi-briefcase::before {
  content: "\\f00d6";
}

.mdi-briefcase-account::before {
  content: "\\f0cf0";
}

.mdi-briefcase-account-outline::before {
  content: "\\f0cf1";
}

.mdi-briefcase-check::before {
  content: "\\f00d7";
}

.mdi-briefcase-check-outline::before {
  content: "\\f131e";
}

.mdi-briefcase-clock::before {
  content: "\\f10d0";
}

.mdi-briefcase-clock-outline::before {
  content: "\\f10d1";
}

.mdi-briefcase-download::before {
  content: "\\f00d8";
}

.mdi-briefcase-download-outline::before {
  content: "\\f0c3d";
}

.mdi-briefcase-edit::before {
  content: "\\f0a98";
}

.mdi-briefcase-edit-outline::before {
  content: "\\f0c3e";
}

.mdi-briefcase-minus::before {
  content: "\\f0a2a";
}

.mdi-briefcase-minus-outline::before {
  content: "\\f0c3f";
}

.mdi-briefcase-outline::before {
  content: "\\f0814";
}

.mdi-briefcase-plus::before {
  content: "\\f0a2b";
}

.mdi-briefcase-plus-outline::before {
  content: "\\f0c40";
}

.mdi-briefcase-remove::before {
  content: "\\f0a2c";
}

.mdi-briefcase-remove-outline::before {
  content: "\\f0c41";
}

.mdi-briefcase-search::before {
  content: "\\f0a2d";
}

.mdi-briefcase-search-outline::before {
  content: "\\f0c42";
}

.mdi-briefcase-upload::before {
  content: "\\f00d9";
}

.mdi-briefcase-upload-outline::before {
  content: "\\f0c43";
}

.mdi-brightness-1::before {
  content: "\\f00da";
}

.mdi-brightness-2::before {
  content: "\\f00db";
}

.mdi-brightness-3::before {
  content: "\\f00dc";
}

.mdi-brightness-4::before {
  content: "\\f00dd";
}

.mdi-brightness-5::before {
  content: "\\f00de";
}

.mdi-brightness-6::before {
  content: "\\f00df";
}

.mdi-brightness-7::before {
  content: "\\f00e0";
}

.mdi-brightness-auto::before {
  content: "\\f00e1";
}

.mdi-brightness-percent::before {
  content: "\\f0cf2";
}

.mdi-broom::before {
  content: "\\f00e2";
}

.mdi-brush::before {
  content: "\\f00e3";
}

.mdi-buddhism::before {
  content: "\\f094b";
}

.mdi-buffer::before {
  content: "\\f0619";
}

.mdi-buffet::before {
  content: "\\f0578";
}

.mdi-bug::before {
  content: "\\f00e4";
}

.mdi-bug-check::before {
  content: "\\f0a2e";
}

.mdi-bug-check-outline::before {
  content: "\\f0a2f";
}

.mdi-bug-outline::before {
  content: "\\f0a30";
}

.mdi-bugle::before {
  content: "\\f0db4";
}

.mdi-bulldozer::before {
  content: "\\f0b22";
}

.mdi-bullet::before {
  content: "\\f0cf3";
}

.mdi-bulletin-board::before {
  content: "\\f00e5";
}

.mdi-bullhorn::before {
  content: "\\f00e6";
}

.mdi-bullhorn-outline::before {
  content: "\\f0b23";
}

.mdi-bullseye::before {
  content: "\\f05dd";
}

.mdi-bullseye-arrow::before {
  content: "\\f08c9";
}

.mdi-bulma::before {
  content: "\\f12e7";
}

.mdi-bunk-bed::before {
  content: "\\f1302";
}

.mdi-bunk-bed-outline::before {
  content: "\\f0097";
}

.mdi-bus::before {
  content: "\\f00e7";
}

.mdi-bus-alert::before {
  content: "\\f0a99";
}

.mdi-bus-articulated-end::before {
  content: "\\f079c";
}

.mdi-bus-articulated-front::before {
  content: "\\f079d";
}

.mdi-bus-clock::before {
  content: "\\f08ca";
}

.mdi-bus-double-decker::before {
  content: "\\f079e";
}

.mdi-bus-marker::before {
  content: "\\f1212";
}

.mdi-bus-multiple::before {
  content: "\\f0f3f";
}

.mdi-bus-school::before {
  content: "\\f079f";
}

.mdi-bus-side::before {
  content: "\\f07a0";
}

.mdi-bus-stop::before {
  content: "\\f1012";
}

.mdi-bus-stop-covered::before {
  content: "\\f1013";
}

.mdi-bus-stop-uncovered::before {
  content: "\\f1014";
}

.mdi-cable-data::before {
  content: "\\f1394";
}

.mdi-cached::before {
  content: "\\f00e8";
}

.mdi-cactus::before {
  content: "\\f0db5";
}

.mdi-cake::before {
  content: "\\f00e9";
}

.mdi-cake-layered::before {
  content: "\\f00ea";
}

.mdi-cake-variant::before {
  content: "\\f00eb";
}

.mdi-calculator::before {
  content: "\\f00ec";
}

.mdi-calculator-variant::before {
  content: "\\f0a9a";
}

.mdi-calendar::before {
  content: "\\f00ed";
}

.mdi-calendar-account::before {
  content: "\\f0ed7";
}

.mdi-calendar-account-outline::before {
  content: "\\f0ed8";
}

.mdi-calendar-alert::before {
  content: "\\f0a31";
}

.mdi-calendar-arrow-left::before {
  content: "\\f1134";
}

.mdi-calendar-arrow-right::before {
  content: "\\f1135";
}

.mdi-calendar-blank::before {
  content: "\\f00ee";
}

.mdi-calendar-blank-multiple::before {
  content: "\\f1073";
}

.mdi-calendar-blank-outline::before {
  content: "\\f0b66";
}

.mdi-calendar-check::before {
  content: "\\f00ef";
}

.mdi-calendar-check-outline::before {
  content: "\\f0c44";
}

.mdi-calendar-clock::before {
  content: "\\f00f0";
}

.mdi-calendar-edit::before {
  content: "\\f08a7";
}

.mdi-calendar-export::before {
  content: "\\f0b24";
}

.mdi-calendar-heart::before {
  content: "\\f09d2";
}

.mdi-calendar-import::before {
  content: "\\f0b25";
}

.mdi-calendar-minus::before {
  content: "\\f0d5c";
}

.mdi-calendar-month::before {
  content: "\\f0e17";
}

.mdi-calendar-month-outline::before {
  content: "\\f0e18";
}

.mdi-calendar-multiple::before {
  content: "\\f00f1";
}

.mdi-calendar-multiple-check::before {
  content: "\\f00f2";
}

.mdi-calendar-multiselect::before {
  content: "\\f0a32";
}

.mdi-calendar-outline::before {
  content: "\\f0b67";
}

.mdi-calendar-plus::before {
  content: "\\f00f3";
}

.mdi-calendar-question::before {
  content: "\\f0692";
}

.mdi-calendar-range::before {
  content: "\\f0679";
}

.mdi-calendar-range-outline::before {
  content: "\\f0b68";
}

.mdi-calendar-refresh::before {
  content: "\\f01e1";
}

.mdi-calendar-refresh-outline::before {
  content: "\\f0203";
}

.mdi-calendar-remove::before {
  content: "\\f00f4";
}

.mdi-calendar-remove-outline::before {
  content: "\\f0c45";
}

.mdi-calendar-search::before {
  content: "\\f094c";
}

.mdi-calendar-star::before {
  content: "\\f09d3";
}

.mdi-calendar-sync::before {
  content: "\\f0e8e";
}

.mdi-calendar-sync-outline::before {
  content: "\\f0e8f";
}

.mdi-calendar-text::before {
  content: "\\f00f5";
}

.mdi-calendar-text-outline::before {
  content: "\\f0c46";
}

.mdi-calendar-today::before {
  content: "\\f00f6";
}

.mdi-calendar-week::before {
  content: "\\f0a33";
}

.mdi-calendar-week-begin::before {
  content: "\\f0a34";
}

.mdi-calendar-weekend::before {
  content: "\\f0ed9";
}

.mdi-calendar-weekend-outline::before {
  content: "\\f0eda";
}

.mdi-call-made::before {
  content: "\\f00f7";
}

.mdi-call-merge::before {
  content: "\\f00f8";
}

.mdi-call-missed::before {
  content: "\\f00f9";
}

.mdi-call-received::before {
  content: "\\f00fa";
}

.mdi-call-split::before {
  content: "\\f00fb";
}

.mdi-camcorder::before {
  content: "\\f00fc";
}

.mdi-camcorder-off::before {
  content: "\\f00ff";
}

.mdi-camera::before {
  content: "\\f0100";
}

.mdi-camera-account::before {
  content: "\\f08cb";
}

.mdi-camera-burst::before {
  content: "\\f0693";
}

.mdi-camera-control::before {
  content: "\\f0b69";
}

.mdi-camera-enhance::before {
  content: "\\f0101";
}

.mdi-camera-enhance-outline::before {
  content: "\\f0b6a";
}

.mdi-camera-front::before {
  content: "\\f0102";
}

.mdi-camera-front-variant::before {
  content: "\\f0103";
}

.mdi-camera-gopro::before {
  content: "\\f07a1";
}

.mdi-camera-image::before {
  content: "\\f08cc";
}

.mdi-camera-iris::before {
  content: "\\f0104";
}

.mdi-camera-metering-center::before {
  content: "\\f07a2";
}

.mdi-camera-metering-matrix::before {
  content: "\\f07a3";
}

.mdi-camera-metering-partial::before {
  content: "\\f07a4";
}

.mdi-camera-metering-spot::before {
  content: "\\f07a5";
}

.mdi-camera-off::before {
  content: "\\f05df";
}

.mdi-camera-outline::before {
  content: "\\f0d5d";
}

.mdi-camera-party-mode::before {
  content: "\\f0105";
}

.mdi-camera-plus::before {
  content: "\\f0edb";
}

.mdi-camera-plus-outline::before {
  content: "\\f0edc";
}

.mdi-camera-rear::before {
  content: "\\f0106";
}

.mdi-camera-rear-variant::before {
  content: "\\f0107";
}

.mdi-camera-retake::before {
  content: "\\f0e19";
}

.mdi-camera-retake-outline::before {
  content: "\\f0e1a";
}

.mdi-camera-switch::before {
  content: "\\f0108";
}

.mdi-camera-switch-outline::before {
  content: "\\f084a";
}

.mdi-camera-timer::before {
  content: "\\f0109";
}

.mdi-camera-wireless::before {
  content: "\\f0db6";
}

.mdi-camera-wireless-outline::before {
  content: "\\f0db7";
}

.mdi-campfire::before {
  content: "\\f0edd";
}

.mdi-cancel::before {
  content: "\\f073a";
}

.mdi-candle::before {
  content: "\\f05e2";
}

.mdi-candycane::before {
  content: "\\f010a";
}

.mdi-cannabis::before {
  content: "\\f07a6";
}

.mdi-caps-lock::before {
  content: "\\f0a9b";
}

.mdi-car::before {
  content: "\\f010b";
}

.mdi-car-2-plus::before {
  content: "\\f1015";
}

.mdi-car-3-plus::before {
  content: "\\f1016";
}

.mdi-car-arrow-left::before {
  content: "\\f13b2";
}

.mdi-car-arrow-right::before {
  content: "\\f13b3";
}

.mdi-car-back::before {
  content: "\\f0e1b";
}

.mdi-car-battery::before {
  content: "\\f010c";
}

.mdi-car-brake-abs::before {
  content: "\\f0c47";
}

.mdi-car-brake-alert::before {
  content: "\\f0c48";
}

.mdi-car-brake-hold::before {
  content: "\\f0d5e";
}

.mdi-car-brake-parking::before {
  content: "\\f0d5f";
}

.mdi-car-brake-retarder::before {
  content: "\\f1017";
}

.mdi-car-child-seat::before {
  content: "\\f0fa3";
}

.mdi-car-clutch::before {
  content: "\\f1018";
}

.mdi-car-connected::before {
  content: "\\f010d";
}

.mdi-car-convertible::before {
  content: "\\f07a7";
}

.mdi-car-coolant-level::before {
  content: "\\f1019";
}

.mdi-car-cruise-control::before {
  content: "\\f0d60";
}

.mdi-car-defrost-front::before {
  content: "\\f0d61";
}

.mdi-car-defrost-rear::before {
  content: "\\f0d62";
}

.mdi-car-door::before {
  content: "\\f0b6b";
}

.mdi-car-door-lock::before {
  content: "\\f109d";
}

.mdi-car-electric::before {
  content: "\\f0b6c";
}

.mdi-car-esp::before {
  content: "\\f0c49";
}

.mdi-car-estate::before {
  content: "\\f07a8";
}

.mdi-car-hatchback::before {
  content: "\\f07a9";
}

.mdi-car-info::before {
  content: "\\f11be";
}

.mdi-car-key::before {
  content: "\\f0b6d";
}

.mdi-car-light-dimmed::before {
  content: "\\f0c4a";
}

.mdi-car-light-fog::before {
  content: "\\f0c4b";
}

.mdi-car-light-high::before {
  content: "\\f0c4c";
}

.mdi-car-limousine::before {
  content: "\\f08cd";
}

.mdi-car-multiple::before {
  content: "\\f0b6e";
}

.mdi-car-off::before {
  content: "\\f0e1c";
}

.mdi-car-parking-lights::before {
  content: "\\f0d63";
}

.mdi-car-pickup::before {
  content: "\\f07aa";
}

.mdi-car-seat::before {
  content: "\\f0fa4";
}

.mdi-car-seat-cooler::before {
  content: "\\f0fa5";
}

.mdi-car-seat-heater::before {
  content: "\\f0fa6";
}

.mdi-car-shift-pattern::before {
  content: "\\f0f40";
}

.mdi-car-side::before {
  content: "\\f07ab";
}

.mdi-car-sports::before {
  content: "\\f07ac";
}

.mdi-car-tire-alert::before {
  content: "\\f0c4d";
}

.mdi-car-traction-control::before {
  content: "\\f0d64";
}

.mdi-car-turbocharger::before {
  content: "\\f101a";
}

.mdi-car-wash::before {
  content: "\\f010e";
}

.mdi-car-windshield::before {
  content: "\\f101b";
}

.mdi-car-windshield-outline::before {
  content: "\\f101c";
}

.mdi-caravan::before {
  content: "\\f07ad";
}

.mdi-card::before {
  content: "\\f0b6f";
}

.mdi-card-account-details::before {
  content: "\\f05d2";
}

.mdi-card-account-details-outline::before {
  content: "\\f0dab";
}

.mdi-card-account-details-star::before {
  content: "\\f02a3";
}

.mdi-card-account-details-star-outline::before {
  content: "\\f06db";
}

.mdi-card-account-mail::before {
  content: "\\f018e";
}

.mdi-card-account-mail-outline::before {
  content: "\\f0e98";
}

.mdi-card-account-phone::before {
  content: "\\f0e99";
}

.mdi-card-account-phone-outline::before {
  content: "\\f0e9a";
}

.mdi-card-bulleted::before {
  content: "\\f0b70";
}

.mdi-card-bulleted-off::before {
  content: "\\f0b71";
}

.mdi-card-bulleted-off-outline::before {
  content: "\\f0b72";
}

.mdi-card-bulleted-outline::before {
  content: "\\f0b73";
}

.mdi-card-bulleted-settings::before {
  content: "\\f0b74";
}

.mdi-card-bulleted-settings-outline::before {
  content: "\\f0b75";
}

.mdi-card-outline::before {
  content: "\\f0b76";
}

.mdi-card-plus::before {
  content: "\\f11ff";
}

.mdi-card-plus-outline::before {
  content: "\\f1200";
}

.mdi-card-search::before {
  content: "\\f1074";
}

.mdi-card-search-outline::before {
  content: "\\f1075";
}

.mdi-card-text::before {
  content: "\\f0b77";
}

.mdi-card-text-outline::before {
  content: "\\f0b78";
}

.mdi-cards::before {
  content: "\\f0638";
}

.mdi-cards-club::before {
  content: "\\f08ce";
}

.mdi-cards-diamond::before {
  content: "\\f08cf";
}

.mdi-cards-diamond-outline::before {
  content: "\\f101d";
}

.mdi-cards-heart::before {
  content: "\\f08d0";
}

.mdi-cards-outline::before {
  content: "\\f0639";
}

.mdi-cards-playing-outline::before {
  content: "\\f063a";
}

.mdi-cards-spade::before {
  content: "\\f08d1";
}

.mdi-cards-variant::before {
  content: "\\f06c7";
}

.mdi-carrot::before {
  content: "\\f010f";
}

.mdi-cart::before {
  content: "\\f0110";
}

.mdi-cart-arrow-down::before {
  content: "\\f0d66";
}

.mdi-cart-arrow-right::before {
  content: "\\f0c4e";
}

.mdi-cart-arrow-up::before {
  content: "\\f0d67";
}

.mdi-cart-minus::before {
  content: "\\f0d68";
}

.mdi-cart-off::before {
  content: "\\f066b";
}

.mdi-cart-outline::before {
  content: "\\f0111";
}

.mdi-cart-plus::before {
  content: "\\f0112";
}

.mdi-cart-remove::before {
  content: "\\f0d69";
}

.mdi-case-sensitive-alt::before {
  content: "\\f0113";
}

.mdi-cash::before {
  content: "\\f0114";
}

.mdi-cash-100::before {
  content: "\\f0115";
}

.mdi-cash-marker::before {
  content: "\\f0db8";
}

.mdi-cash-minus::before {
  content: "\\f1260";
}

.mdi-cash-multiple::before {
  content: "\\f0116";
}

.mdi-cash-plus::before {
  content: "\\f1261";
}

.mdi-cash-refund::before {
  content: "\\f0a9c";
}

.mdi-cash-register::before {
  content: "\\f0cf4";
}

.mdi-cash-remove::before {
  content: "\\f1262";
}

.mdi-cash-usd::before {
  content: "\\f1176";
}

.mdi-cash-usd-outline::before {
  content: "\\f0117";
}

.mdi-cassette::before {
  content: "\\f09d4";
}

.mdi-cast::before {
  content: "\\f0118";
}

.mdi-cast-audio::before {
  content: "\\f101e";
}

.mdi-cast-connected::before {
  content: "\\f0119";
}

.mdi-cast-education::before {
  content: "\\f0e1d";
}

.mdi-cast-off::before {
  content: "\\f078a";
}

.mdi-castle::before {
  content: "\\f011a";
}

.mdi-cat::before {
  content: "\\f011b";
}

.mdi-cctv::before {
  content: "\\f07ae";
}

.mdi-ceiling-light::before {
  content: "\\f0769";
}

.mdi-cellphone::before {
  content: "\\f011c";
}

.mdi-cellphone-android::before {
  content: "\\f011d";
}

.mdi-cellphone-arrow-down::before {
  content: "\\f09d5";
}

.mdi-cellphone-basic::before {
  content: "\\f011e";
}

.mdi-cellphone-charging::before {
  content: "\\f1397";
}

.mdi-cellphone-cog::before {
  content: "\\f0951";
}

.mdi-cellphone-dock::before {
  content: "\\f011f";
}

.mdi-cellphone-erase::before {
  content: "\\f094d";
}

.mdi-cellphone-information::before {
  content: "\\f0f41";
}

.mdi-cellphone-iphone::before {
  content: "\\f0120";
}

.mdi-cellphone-key::before {
  content: "\\f094e";
}

.mdi-cellphone-link::before {
  content: "\\f0121";
}

.mdi-cellphone-link-off::before {
  content: "\\f0122";
}

.mdi-cellphone-lock::before {
  content: "\\f094f";
}

.mdi-cellphone-message::before {
  content: "\\f08d3";
}

.mdi-cellphone-message-off::before {
  content: "\\f10d2";
}

.mdi-cellphone-nfc::before {
  content: "\\f0e90";
}

.mdi-cellphone-nfc-off::before {
  content: "\\f12d8";
}

.mdi-cellphone-off::before {
  content: "\\f0950";
}

.mdi-cellphone-play::before {
  content: "\\f101f";
}

.mdi-cellphone-screenshot::before {
  content: "\\f0a35";
}

.mdi-cellphone-settings::before {
  content: "\\f0123";
}

.mdi-cellphone-sound::before {
  content: "\\f0952";
}

.mdi-cellphone-text::before {
  content: "\\f08d2";
}

.mdi-cellphone-wireless::before {
  content: "\\f0815";
}

.mdi-celtic-cross::before {
  content: "\\f0cf5";
}

.mdi-centos::before {
  content: "\\f111a";
}

.mdi-certificate::before {
  content: "\\f0124";
}

.mdi-certificate-outline::before {
  content: "\\f1188";
}

.mdi-chair-rolling::before {
  content: "\\f0f48";
}

.mdi-chair-school::before {
  content: "\\f0125";
}

.mdi-charity::before {
  content: "\\f0c4f";
}

.mdi-chart-arc::before {
  content: "\\f0126";
}

.mdi-chart-areaspline::before {
  content: "\\f0127";
}

.mdi-chart-areaspline-variant::before {
  content: "\\f0e91";
}

.mdi-chart-bar::before {
  content: "\\f0128";
}

.mdi-chart-bar-stacked::before {
  content: "\\f076a";
}

.mdi-chart-bell-curve::before {
  content: "\\f0c50";
}

.mdi-chart-bell-curve-cumulative::before {
  content: "\\f0fa7";
}

.mdi-chart-bubble::before {
  content: "\\f05e3";
}

.mdi-chart-donut::before {
  content: "\\f07af";
}

.mdi-chart-donut-variant::before {
  content: "\\f07b0";
}

.mdi-chart-gantt::before {
  content: "\\f066c";
}

.mdi-chart-histogram::before {
  content: "\\f0129";
}

.mdi-chart-line::before {
  content: "\\f012a";
}

.mdi-chart-line-stacked::before {
  content: "\\f076b";
}

.mdi-chart-line-variant::before {
  content: "\\f07b1";
}

.mdi-chart-multiline::before {
  content: "\\f08d4";
}

.mdi-chart-multiple::before {
  content: "\\f1213";
}

.mdi-chart-pie::before {
  content: "\\f012b";
}

.mdi-chart-ppf::before {
  content: "\\f1380";
}

.mdi-chart-sankey::before {
  content: "\\f11df";
}

.mdi-chart-sankey-variant::before {
  content: "\\f11e0";
}

.mdi-chart-scatter-plot::before {
  content: "\\f0e92";
}

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\f066d";
}

.mdi-chart-timeline::before {
  content: "\\f066e";
}

.mdi-chart-timeline-variant::before {
  content: "\\f0e93";
}

.mdi-chart-tree::before {
  content: "\\f0e94";
}

.mdi-chat::before {
  content: "\\f0b79";
}

.mdi-chat-alert::before {
  content: "\\f0b7a";
}

.mdi-chat-alert-outline::before {
  content: "\\f12c9";
}

.mdi-chat-outline::before {
  content: "\\f0ede";
}

.mdi-chat-processing::before {
  content: "\\f0b7b";
}

.mdi-chat-processing-outline::before {
  content: "\\f12ca";
}

.mdi-chat-sleep::before {
  content: "\\f12d1";
}

.mdi-chat-sleep-outline::before {
  content: "\\f12d2";
}

.mdi-check::before {
  content: "\\f012c";
}

.mdi-check-all::before {
  content: "\\f012d";
}

.mdi-check-bold::before {
  content: "\\f0e1e";
}

.mdi-check-box-multiple-outline::before {
  content: "\\f0c51";
}

.mdi-check-box-outline::before {
  content: "\\f0c52";
}

.mdi-check-circle::before {
  content: "\\f05e0";
}

.mdi-check-circle-outline::before {
  content: "\\f05e1";
}

.mdi-check-decagram::before {
  content: "\\f0791";
}

.mdi-check-network::before {
  content: "\\f0c53";
}

.mdi-check-network-outline::before {
  content: "\\f0c54";
}

.mdi-check-outline::before {
  content: "\\f0855";
}

.mdi-check-underline::before {
  content: "\\f0e1f";
}

.mdi-check-underline-circle::before {
  content: "\\f0e20";
}

.mdi-check-underline-circle-outline::before {
  content: "\\f0e21";
}

.mdi-checkbook::before {
  content: "\\f0a9d";
}

.mdi-checkbox-blank::before {
  content: "\\f012e";
}

.mdi-checkbox-blank-circle::before {
  content: "\\f012f";
}

.mdi-checkbox-blank-circle-outline::before {
  content: "\\f0130";
}

.mdi-checkbox-blank-off::before {
  content: "\\f12ec";
}

.mdi-checkbox-blank-off-outline::before {
  content: "\\f12ed";
}

.mdi-checkbox-blank-outline::before {
  content: "\\f0131";
}

.mdi-checkbox-intermediate::before {
  content: "\\f0856";
}

.mdi-checkbox-marked::before {
  content: "\\f0132";
}

.mdi-checkbox-marked-circle::before {
  content: "\\f0133";
}

.mdi-checkbox-marked-circle-outline::before {
  content: "\\f0134";
}

.mdi-checkbox-marked-outline::before {
  content: "\\f0135";
}

.mdi-checkbox-multiple-blank::before {
  content: "\\f0136";
}

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\f063b";
}

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\f063c";
}

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\f0137";
}

.mdi-checkbox-multiple-marked::before {
  content: "\\f0138";
}

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\f063d";
}

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\f063e";
}

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\f0139";
}

.mdi-checkerboard::before {
  content: "\\f013a";
}

.mdi-checkerboard-minus::before {
  content: "\\f1202";
}

.mdi-checkerboard-plus::before {
  content: "\\f1201";
}

.mdi-checkerboard-remove::before {
  content: "\\f1203";
}

.mdi-cheese::before {
  content: "\\f12b9";
}

.mdi-chef-hat::before {
  content: "\\f0b7c";
}

.mdi-chemical-weapon::before {
  content: "\\f013b";
}

.mdi-chess-bishop::before {
  content: "\\f085c";
}

.mdi-chess-king::before {
  content: "\\f0857";
}

.mdi-chess-knight::before {
  content: "\\f0858";
}

.mdi-chess-pawn::before {
  content: "\\f0859";
}

.mdi-chess-queen::before {
  content: "\\f085a";
}

.mdi-chess-rook::before {
  content: "\\f085b";
}

.mdi-chevron-double-down::before {
  content: "\\f013c";
}

.mdi-chevron-double-left::before {
  content: "\\f013d";
}

.mdi-chevron-double-right::before {
  content: "\\f013e";
}

.mdi-chevron-double-up::before {
  content: "\\f013f";
}

.mdi-chevron-down::before {
  content: "\\f0140";
}

.mdi-chevron-down-box::before {
  content: "\\f09d6";
}

.mdi-chevron-down-box-outline::before {
  content: "\\f09d7";
}

.mdi-chevron-down-circle::before {
  content: "\\f0b26";
}

.mdi-chevron-down-circle-outline::before {
  content: "\\f0b27";
}

.mdi-chevron-left::before {
  content: "\\f0141";
}

.mdi-chevron-left-box::before {
  content: "\\f09d8";
}

.mdi-chevron-left-box-outline::before {
  content: "\\f09d9";
}

.mdi-chevron-left-circle::before {
  content: "\\f0b28";
}

.mdi-chevron-left-circle-outline::before {
  content: "\\f0b29";
}

.mdi-chevron-right::before {
  content: "\\f0142";
}

.mdi-chevron-right-box::before {
  content: "\\f09da";
}

.mdi-chevron-right-box-outline::before {
  content: "\\f09db";
}

.mdi-chevron-right-circle::before {
  content: "\\f0b2a";
}

.mdi-chevron-right-circle-outline::before {
  content: "\\f0b2b";
}

.mdi-chevron-triple-down::before {
  content: "\\f0db9";
}

.mdi-chevron-triple-left::before {
  content: "\\f0dba";
}

.mdi-chevron-triple-right::before {
  content: "\\f0dbb";
}

.mdi-chevron-triple-up::before {
  content: "\\f0dbc";
}

.mdi-chevron-up::before {
  content: "\\f0143";
}

.mdi-chevron-up-box::before {
  content: "\\f09dc";
}

.mdi-chevron-up-box-outline::before {
  content: "\\f09dd";
}

.mdi-chevron-up-circle::before {
  content: "\\f0b2c";
}

.mdi-chevron-up-circle-outline::before {
  content: "\\f0b2d";
}

.mdi-chili-hot::before {
  content: "\\f07b2";
}

.mdi-chili-medium::before {
  content: "\\f07b3";
}

.mdi-chili-mild::before {
  content: "\\f07b4";
}

.mdi-chip::before {
  content: "\\f061a";
}

.mdi-christianity::before {
  content: "\\f0953";
}

.mdi-christianity-outline::before {
  content: "\\f0cf6";
}

.mdi-church::before {
  content: "\\f0144";
}

.mdi-cigar::before {
  content: "\\f1189";
}

.mdi-circle::before {
  content: "\\f0765";
}

.mdi-circle-double::before {
  content: "\\f0e95";
}

.mdi-circle-edit-outline::before {
  content: "\\f08d5";
}

.mdi-circle-expand::before {
  content: "\\f0e96";
}

.mdi-circle-half::before {
  content: "\\f1395";
}

.mdi-circle-half-full::before {
  content: "\\f1396";
}

.mdi-circle-medium::before {
  content: "\\f09de";
}

.mdi-circle-multiple::before {
  content: "\\f0b38";
}

.mdi-circle-multiple-outline::before {
  content: "\\f0695";
}

.mdi-circle-off-outline::before {
  content: "\\f10d3";
}

.mdi-circle-outline::before {
  content: "\\f0766";
}

.mdi-circle-slice-1::before {
  content: "\\f0a9e";
}

.mdi-circle-slice-2::before {
  content: "\\f0a9f";
}

.mdi-circle-slice-3::before {
  content: "\\f0aa0";
}

.mdi-circle-slice-4::before {
  content: "\\f0aa1";
}

.mdi-circle-slice-5::before {
  content: "\\f0aa2";
}

.mdi-circle-slice-6::before {
  content: "\\f0aa3";
}

.mdi-circle-slice-7::before {
  content: "\\f0aa4";
}

.mdi-circle-slice-8::before {
  content: "\\f0aa5";
}

.mdi-circle-small::before {
  content: "\\f09df";
}

.mdi-circular-saw::before {
  content: "\\f0e22";
}

.mdi-city::before {
  content: "\\f0146";
}

.mdi-city-variant::before {
  content: "\\f0a36";
}

.mdi-city-variant-outline::before {
  content: "\\f0a37";
}

.mdi-clipboard::before {
  content: "\\f0147";
}

.mdi-clipboard-account::before {
  content: "\\f0148";
}

.mdi-clipboard-account-outline::before {
  content: "\\f0c55";
}

.mdi-clipboard-alert::before {
  content: "\\f0149";
}

.mdi-clipboard-alert-outline::before {
  content: "\\f0cf7";
}

.mdi-clipboard-arrow-down::before {
  content: "\\f014a";
}

.mdi-clipboard-arrow-down-outline::before {
  content: "\\f0c56";
}

.mdi-clipboard-arrow-left::before {
  content: "\\f014b";
}

.mdi-clipboard-arrow-left-outline::before {
  content: "\\f0cf8";
}

.mdi-clipboard-arrow-right::before {
  content: "\\f0cf9";
}

.mdi-clipboard-arrow-right-outline::before {
  content: "\\f0cfa";
}

.mdi-clipboard-arrow-up::before {
  content: "\\f0c57";
}

.mdi-clipboard-arrow-up-outline::before {
  content: "\\f0c58";
}

.mdi-clipboard-check::before {
  content: "\\f014e";
}

.mdi-clipboard-check-multiple::before {
  content: "\\f1263";
}

.mdi-clipboard-check-multiple-outline::before {
  content: "\\f1264";
}

.mdi-clipboard-check-outline::before {
  content: "\\f08a8";
}

.mdi-clipboard-file::before {
  content: "\\f1265";
}

.mdi-clipboard-file-outline::before {
  content: "\\f1266";
}

.mdi-clipboard-flow::before {
  content: "\\f06c8";
}

.mdi-clipboard-flow-outline::before {
  content: "\\f1117";
}

.mdi-clipboard-list::before {
  content: "\\f10d4";
}

.mdi-clipboard-list-outline::before {
  content: "\\f10d5";
}

.mdi-clipboard-multiple::before {
  content: "\\f1267";
}

.mdi-clipboard-multiple-outline::before {
  content: "\\f1268";
}

.mdi-clipboard-outline::before {
  content: "\\f014c";
}

.mdi-clipboard-play::before {
  content: "\\f0c59";
}

.mdi-clipboard-play-multiple::before {
  content: "\\f1269";
}

.mdi-clipboard-play-multiple-outline::before {
  content: "\\f126a";
}

.mdi-clipboard-play-outline::before {
  content: "\\f0c5a";
}

.mdi-clipboard-plus::before {
  content: "\\f0751";
}

.mdi-clipboard-plus-outline::before {
  content: "\\f131f";
}

.mdi-clipboard-pulse::before {
  content: "\\f085d";
}

.mdi-clipboard-pulse-outline::before {
  content: "\\f085e";
}

.mdi-clipboard-text::before {
  content: "\\f014d";
}

.mdi-clipboard-text-multiple::before {
  content: "\\f126b";
}

.mdi-clipboard-text-multiple-outline::before {
  content: "\\f126c";
}

.mdi-clipboard-text-outline::before {
  content: "\\f0a38";
}

.mdi-clipboard-text-play::before {
  content: "\\f0c5b";
}

.mdi-clipboard-text-play-outline::before {
  content: "\\f0c5c";
}

.mdi-clippy::before {
  content: "\\f014f";
}

.mdi-clock::before {
  content: "\\f0954";
}

.mdi-clock-alert::before {
  content: "\\f0955";
}

.mdi-clock-alert-outline::before {
  content: "\\f05ce";
}

.mdi-clock-check::before {
  content: "\\f0fa8";
}

.mdi-clock-check-outline::before {
  content: "\\f0fa9";
}

.mdi-clock-digital::before {
  content: "\\f0e97";
}

.mdi-clock-end::before {
  content: "\\f0151";
}

.mdi-clock-fast::before {
  content: "\\f0152";
}

.mdi-clock-in::before {
  content: "\\f0153";
}

.mdi-clock-out::before {
  content: "\\f0154";
}

.mdi-clock-outline::before {
  content: "\\f0150";
}

.mdi-clock-start::before {
  content: "\\f0155";
}

.mdi-close::before {
  content: "\\f0156";
}

.mdi-close-box::before {
  content: "\\f0157";
}

.mdi-close-box-multiple::before {
  content: "\\f0c5d";
}

.mdi-close-box-multiple-outline::before {
  content: "\\f0c5e";
}

.mdi-close-box-outline::before {
  content: "\\f0158";
}

.mdi-close-circle::before {
  content: "\\f0159";
}

.mdi-close-circle-multiple::before {
  content: "\\f062a";
}

.mdi-close-circle-multiple-outline::before {
  content: "\\f0883";
}

.mdi-close-circle-outline::before {
  content: "\\f015a";
}

.mdi-close-network::before {
  content: "\\f015b";
}

.mdi-close-network-outline::before {
  content: "\\f0c5f";
}

.mdi-close-octagon::before {
  content: "\\f015c";
}

.mdi-close-octagon-outline::before {
  content: "\\f015d";
}

.mdi-close-outline::before {
  content: "\\f06c9";
}

.mdi-close-thick::before {
  content: "\\f1398";
}

.mdi-closed-caption::before {
  content: "\\f015e";
}

.mdi-closed-caption-outline::before {
  content: "\\f0dbd";
}

.mdi-cloud::before {
  content: "\\f015f";
}

.mdi-cloud-alert::before {
  content: "\\f09e0";
}

.mdi-cloud-braces::before {
  content: "\\f07b5";
}

.mdi-cloud-check::before {
  content: "\\f0160";
}

.mdi-cloud-check-outline::before {
  content: "\\f12cc";
}

.mdi-cloud-circle::before {
  content: "\\f0161";
}

.mdi-cloud-download::before {
  content: "\\f0162";
}

.mdi-cloud-download-outline::before {
  content: "\\f0b7d";
}

.mdi-cloud-lock::before {
  content: "\\f11f1";
}

.mdi-cloud-lock-outline::before {
  content: "\\f11f2";
}

.mdi-cloud-off-outline::before {
  content: "\\f0164";
}

.mdi-cloud-outline::before {
  content: "\\f0163";
}

.mdi-cloud-print::before {
  content: "\\f0165";
}

.mdi-cloud-print-outline::before {
  content: "\\f0166";
}

.mdi-cloud-question::before {
  content: "\\f0a39";
}

.mdi-cloud-refresh::before {
  content: "\\f052a";
}

.mdi-cloud-search::before {
  content: "\\f0956";
}

.mdi-cloud-search-outline::before {
  content: "\\f0957";
}

.mdi-cloud-sync::before {
  content: "\\f063f";
}

.mdi-cloud-sync-outline::before {
  content: "\\f12d6";
}

.mdi-cloud-tags::before {
  content: "\\f07b6";
}

.mdi-cloud-upload::before {
  content: "\\f0167";
}

.mdi-cloud-upload-outline::before {
  content: "\\f0b7e";
}

.mdi-clover::before {
  content: "\\f0816";
}

.mdi-coach-lamp::before {
  content: "\\f1020";
}

.mdi-coat-rack::before {
  content: "\\f109e";
}

.mdi-code-array::before {
  content: "\\f0168";
}

.mdi-code-braces::before {
  content: "\\f0169";
}

.mdi-code-braces-box::before {
  content: "\\f10d6";
}

.mdi-code-brackets::before {
  content: "\\f016a";
}

.mdi-code-equal::before {
  content: "\\f016b";
}

.mdi-code-greater-than::before {
  content: "\\f016c";
}

.mdi-code-greater-than-or-equal::before {
  content: "\\f016d";
}

.mdi-code-json::before {
  content: "\\f0626";
}

.mdi-code-less-than::before {
  content: "\\f016e";
}

.mdi-code-less-than-or-equal::before {
  content: "\\f016f";
}

.mdi-code-not-equal::before {
  content: "\\f0170";
}

.mdi-code-not-equal-variant::before {
  content: "\\f0171";
}

.mdi-code-parentheses::before {
  content: "\\f0172";
}

.mdi-code-parentheses-box::before {
  content: "\\f10d7";
}

.mdi-code-string::before {
  content: "\\f0173";
}

.mdi-code-tags::before {
  content: "\\f0174";
}

.mdi-code-tags-check::before {
  content: "\\f0694";
}

.mdi-codepen::before {
  content: "\\f0175";
}

.mdi-coffee::before {
  content: "\\f0176";
}

.mdi-coffee-maker::before {
  content: "\\f109f";
}

.mdi-coffee-off::before {
  content: "\\f0faa";
}

.mdi-coffee-off-outline::before {
  content: "\\f0fab";
}

.mdi-coffee-outline::before {
  content: "\\f06ca";
}

.mdi-coffee-to-go::before {
  content: "\\f0177";
}

.mdi-coffee-to-go-outline::before {
  content: "\\f130e";
}

.mdi-coffin::before {
  content: "\\f0b7f";
}

.mdi-cog::before {
  content: "\\f0493";
}

.mdi-cog-box::before {
  content: "\\f0494";
}

.mdi-cog-clockwise::before {
  content: "\\f11dd";
}

.mdi-cog-counterclockwise::before {
  content: "\\f11de";
}

.mdi-cog-outline::before {
  content: "\\f08bb";
}

.mdi-cog-transfer::before {
  content: "\\f105b";
}

.mdi-cog-transfer-outline::before {
  content: "\\f105c";
}

.mdi-cogs::before {
  content: "\\f08d6";
}

.mdi-collage::before {
  content: "\\f0640";
}

.mdi-collapse-all::before {
  content: "\\f0aa6";
}

.mdi-collapse-all-outline::before {
  content: "\\f0aa7";
}

.mdi-color-helper::before {
  content: "\\f0179";
}

.mdi-comma::before {
  content: "\\f0e23";
}

.mdi-comma-box::before {
  content: "\\f0e2b";
}

.mdi-comma-box-outline::before {
  content: "\\f0e24";
}

.mdi-comma-circle::before {
  content: "\\f0e25";
}

.mdi-comma-circle-outline::before {
  content: "\\f0e26";
}

.mdi-comment::before {
  content: "\\f017a";
}

.mdi-comment-account::before {
  content: "\\f017b";
}

.mdi-comment-account-outline::before {
  content: "\\f017c";
}

.mdi-comment-alert::before {
  content: "\\f017d";
}

.mdi-comment-alert-outline::before {
  content: "\\f017e";
}

.mdi-comment-arrow-left::before {
  content: "\\f09e1";
}

.mdi-comment-arrow-left-outline::before {
  content: "\\f09e2";
}

.mdi-comment-arrow-right::before {
  content: "\\f09e3";
}

.mdi-comment-arrow-right-outline::before {
  content: "\\f09e4";
}

.mdi-comment-check::before {
  content: "\\f017f";
}

.mdi-comment-check-outline::before {
  content: "\\f0180";
}

.mdi-comment-edit::before {
  content: "\\f11bf";
}

.mdi-comment-edit-outline::before {
  content: "\\f12c4";
}

.mdi-comment-eye::before {
  content: "\\f0a3a";
}

.mdi-comment-eye-outline::before {
  content: "\\f0a3b";
}

.mdi-comment-multiple::before {
  content: "\\f085f";
}

.mdi-comment-multiple-outline::before {
  content: "\\f0181";
}

.mdi-comment-outline::before {
  content: "\\f0182";
}

.mdi-comment-plus::before {
  content: "\\f09e5";
}

.mdi-comment-plus-outline::before {
  content: "\\f0183";
}

.mdi-comment-processing::before {
  content: "\\f0184";
}

.mdi-comment-processing-outline::before {
  content: "\\f0185";
}

.mdi-comment-question::before {
  content: "\\f0817";
}

.mdi-comment-question-outline::before {
  content: "\\f0186";
}

.mdi-comment-quote::before {
  content: "\\f1021";
}

.mdi-comment-quote-outline::before {
  content: "\\f1022";
}

.mdi-comment-remove::before {
  content: "\\f05de";
}

.mdi-comment-remove-outline::before {
  content: "\\f0187";
}

.mdi-comment-search::before {
  content: "\\f0a3c";
}

.mdi-comment-search-outline::before {
  content: "\\f0a3d";
}

.mdi-comment-text::before {
  content: "\\f0188";
}

.mdi-comment-text-multiple::before {
  content: "\\f0860";
}

.mdi-comment-text-multiple-outline::before {
  content: "\\f0861";
}

.mdi-comment-text-outline::before {
  content: "\\f0189";
}

.mdi-compare::before {
  content: "\\f018a";
}

.mdi-compass::before {
  content: "\\f018b";
}

.mdi-compass-off::before {
  content: "\\f0b80";
}

.mdi-compass-off-outline::before {
  content: "\\f0b81";
}

.mdi-compass-outline::before {
  content: "\\f018c";
}

.mdi-compass-rose::before {
  content: "\\f1382";
}

.mdi-concourse-ci::before {
  content: "\\f10a0";
}

.mdi-console::before {
  content: "\\f018d";
}

.mdi-console-line::before {
  content: "\\f07b7";
}

.mdi-console-network::before {
  content: "\\f08a9";
}

.mdi-console-network-outline::before {
  content: "\\f0c60";
}

.mdi-consolidate::before {
  content: "\\f10d8";
}

.mdi-contactless-payment::before {
  content: "\\f0d6a";
}

.mdi-contactless-payment-circle::before {
  content: "\\f0321";
}

.mdi-contactless-payment-circle-outline::before {
  content: "\\f0408";
}

.mdi-contacts::before {
  content: "\\f06cb";
}

.mdi-contacts-outline::before {
  content: "\\f05b8";
}

.mdi-contain::before {
  content: "\\f0a3e";
}

.mdi-contain-end::before {
  content: "\\f0a3f";
}

.mdi-contain-start::before {
  content: "\\f0a40";
}

.mdi-content-copy::before {
  content: "\\f018f";
}

.mdi-content-cut::before {
  content: "\\f0190";
}

.mdi-content-duplicate::before {
  content: "\\f0191";
}

.mdi-content-paste::before {
  content: "\\f0192";
}

.mdi-content-save::before {
  content: "\\f0193";
}

.mdi-content-save-alert::before {
  content: "\\f0f42";
}

.mdi-content-save-alert-outline::before {
  content: "\\f0f43";
}

.mdi-content-save-all::before {
  content: "\\f0194";
}

.mdi-content-save-all-outline::before {
  content: "\\f0f44";
}

.mdi-content-save-edit::before {
  content: "\\f0cfb";
}

.mdi-content-save-edit-outline::before {
  content: "\\f0cfc";
}

.mdi-content-save-move::before {
  content: "\\f0e27";
}

.mdi-content-save-move-outline::before {
  content: "\\f0e28";
}

.mdi-content-save-outline::before {
  content: "\\f0818";
}

.mdi-content-save-settings::before {
  content: "\\f061b";
}

.mdi-content-save-settings-outline::before {
  content: "\\f0b2e";
}

.mdi-contrast::before {
  content: "\\f0195";
}

.mdi-contrast-box::before {
  content: "\\f0196";
}

.mdi-contrast-circle::before {
  content: "\\f0197";
}

.mdi-controller-classic::before {
  content: "\\f0b82";
}

.mdi-controller-classic-outline::before {
  content: "\\f0b83";
}

.mdi-cookie::before {
  content: "\\f0198";
}

.mdi-coolant-temperature::before {
  content: "\\f03c8";
}

.mdi-copyright::before {
  content: "\\f05e6";
}

.mdi-cordova::before {
  content: "\\f0958";
}

.mdi-corn::before {
  content: "\\f07b8";
}

.mdi-counter::before {
  content: "\\f0199";
}

.mdi-cow::before {
  content: "\\f019a";
}

.mdi-cpu-32-bit::before {
  content: "\\f0edf";
}

.mdi-cpu-64-bit::before {
  content: "\\f0ee0";
}

.mdi-crane::before {
  content: "\\f0862";
}

.mdi-creation::before {
  content: "\\f0674";
}

.mdi-creative-commons::before {
  content: "\\f0d6b";
}

.mdi-credit-card::before {
  content: "\\f0fef";
}

.mdi-credit-card-clock::before {
  content: "\\f0ee1";
}

.mdi-credit-card-clock-outline::before {
  content: "\\f0ee2";
}

.mdi-credit-card-marker::before {
  content: "\\f06a8";
}

.mdi-credit-card-marker-outline::before {
  content: "\\f0dbe";
}

.mdi-credit-card-minus::before {
  content: "\\f0fac";
}

.mdi-credit-card-minus-outline::before {
  content: "\\f0fad";
}

.mdi-credit-card-multiple::before {
  content: "\\f0ff0";
}

.mdi-credit-card-multiple-outline::before {
  content: "\\f019c";
}

.mdi-credit-card-off::before {
  content: "\\f0ff1";
}

.mdi-credit-card-off-outline::before {
  content: "\\f05e4";
}

.mdi-credit-card-outline::before {
  content: "\\f019b";
}

.mdi-credit-card-plus::before {
  content: "\\f0ff2";
}

.mdi-credit-card-plus-outline::before {
  content: "\\f0676";
}

.mdi-credit-card-refund::before {
  content: "\\f0ff3";
}

.mdi-credit-card-refund-outline::before {
  content: "\\f0aa8";
}

.mdi-credit-card-remove::before {
  content: "\\f0fae";
}

.mdi-credit-card-remove-outline::before {
  content: "\\f0faf";
}

.mdi-credit-card-scan::before {
  content: "\\f0ff4";
}

.mdi-credit-card-scan-outline::before {
  content: "\\f019d";
}

.mdi-credit-card-settings::before {
  content: "\\f0ff5";
}

.mdi-credit-card-settings-outline::before {
  content: "\\f08d7";
}

.mdi-credit-card-wireless::before {
  content: "\\f0802";
}

.mdi-credit-card-wireless-off::before {
  content: "\\f057a";
}

.mdi-credit-card-wireless-off-outline::before {
  content: "\\f057b";
}

.mdi-credit-card-wireless-outline::before {
  content: "\\f0d6c";
}

.mdi-cricket::before {
  content: "\\f0d6d";
}

.mdi-crop::before {
  content: "\\f019e";
}

.mdi-crop-free::before {
  content: "\\f019f";
}

.mdi-crop-landscape::before {
  content: "\\f01a0";
}

.mdi-crop-portrait::before {
  content: "\\f01a1";
}

.mdi-crop-rotate::before {
  content: "\\f0696";
}

.mdi-crop-square::before {
  content: "\\f01a2";
}

.mdi-crosshairs::before {
  content: "\\f01a3";
}

.mdi-crosshairs-gps::before {
  content: "\\f01a4";
}

.mdi-crosshairs-off::before {
  content: "\\f0f45";
}

.mdi-crosshairs-question::before {
  content: "\\f1136";
}

.mdi-crown::before {
  content: "\\f01a5";
}

.mdi-crown-outline::before {
  content: "\\f11d0";
}

.mdi-cryengine::before {
  content: "\\f0959";
}

.mdi-crystal-ball::before {
  content: "\\f0b2f";
}

.mdi-cube::before {
  content: "\\f01a6";
}

.mdi-cube-outline::before {
  content: "\\f01a7";
}

.mdi-cube-scan::before {
  content: "\\f0b84";
}

.mdi-cube-send::before {
  content: "\\f01a8";
}

.mdi-cube-unfolded::before {
  content: "\\f01a9";
}

.mdi-cup::before {
  content: "\\f01aa";
}

.mdi-cup-off::before {
  content: "\\f05e5";
}

.mdi-cup-off-outline::before {
  content: "\\f137d";
}

.mdi-cup-outline::before {
  content: "\\f130f";
}

.mdi-cup-water::before {
  content: "\\f01ab";
}

.mdi-cupboard::before {
  content: "\\f0f46";
}

.mdi-cupboard-outline::before {
  content: "\\f0f47";
}

.mdi-cupcake::before {
  content: "\\f095a";
}

.mdi-curling::before {
  content: "\\f0863";
}

.mdi-currency-bdt::before {
  content: "\\f0864";
}

.mdi-currency-brl::before {
  content: "\\f0b85";
}

.mdi-currency-btc::before {
  content: "\\f01ac";
}

.mdi-currency-cny::before {
  content: "\\f07ba";
}

.mdi-currency-eth::before {
  content: "\\f07bb";
}

.mdi-currency-eur::before {
  content: "\\f01ad";
}

.mdi-currency-eur-off::before {
  content: "\\f1315";
}

.mdi-currency-gbp::before {
  content: "\\f01ae";
}

.mdi-currency-ils::before {
  content: "\\f0c61";
}

.mdi-currency-inr::before {
  content: "\\f01af";
}

.mdi-currency-jpy::before {
  content: "\\f07bc";
}

.mdi-currency-krw::before {
  content: "\\f07bd";
}

.mdi-currency-kzt::before {
  content: "\\f0865";
}

.mdi-currency-ngn::before {
  content: "\\f01b0";
}

.mdi-currency-php::before {
  content: "\\f09e6";
}

.mdi-currency-rial::before {
  content: "\\f0e9c";
}

.mdi-currency-rub::before {
  content: "\\f01b1";
}

.mdi-currency-sign::before {
  content: "\\f07be";
}

.mdi-currency-try::before {
  content: "\\f01b2";
}

.mdi-currency-twd::before {
  content: "\\f07bf";
}

.mdi-currency-usd::before {
  content: "\\f01c1";
}

.mdi-currency-usd-circle::before {
  content: "\\f116b";
}

.mdi-currency-usd-circle-outline::before {
  content: "\\f0178";
}

.mdi-currency-usd-off::before {
  content: "\\f067a";
}

.mdi-current-ac::before {
  content: "\\f095b";
}

.mdi-current-dc::before {
  content: "\\f095c";
}

.mdi-cursor-default::before {
  content: "\\f01c0";
}

.mdi-cursor-default-click::before {
  content: "\\f0cfd";
}

.mdi-cursor-default-click-outline::before {
  content: "\\f0cfe";
}

.mdi-cursor-default-gesture::before {
  content: "\\f1127";
}

.mdi-cursor-default-gesture-outline::before {
  content: "\\f1128";
}

.mdi-cursor-default-outline::before {
  content: "\\f01bf";
}

.mdi-cursor-move::before {
  content: "\\f01be";
}

.mdi-cursor-pointer::before {
  content: "\\f01bd";
}

.mdi-cursor-text::before {
  content: "\\f05e7";
}

.mdi-database::before {
  content: "\\f01bc";
}

.mdi-database-check::before {
  content: "\\f0aa9";
}

.mdi-database-edit::before {
  content: "\\f0b86";
}

.mdi-database-export::before {
  content: "\\f095e";
}

.mdi-database-import::before {
  content: "\\f095d";
}

.mdi-database-lock::before {
  content: "\\f0aaa";
}

.mdi-database-marker::before {
  content: "\\f12f6";
}

.mdi-database-minus::before {
  content: "\\f01bb";
}

.mdi-database-plus::before {
  content: "\\f01ba";
}

.mdi-database-refresh::before {
  content: "\\f05c2";
}

.mdi-database-remove::before {
  content: "\\f0d00";
}

.mdi-database-search::before {
  content: "\\f0866";
}

.mdi-database-settings::before {
  content: "\\f0d01";
}

.mdi-database-sync::before {
  content: "\\f0cff";
}

.mdi-death-star::before {
  content: "\\f08d8";
}

.mdi-death-star-variant::before {
  content: "\\f08d9";
}

.mdi-deathly-hallows::before {
  content: "\\f0b87";
}

.mdi-debian::before {
  content: "\\f08da";
}

.mdi-debug-step-into::before {
  content: "\\f01b9";
}

.mdi-debug-step-out::before {
  content: "\\f01b8";
}

.mdi-debug-step-over::before {
  content: "\\f01b7";
}

.mdi-decagram::before {
  content: "\\f076c";
}

.mdi-decagram-outline::before {
  content: "\\f076d";
}

.mdi-decimal::before {
  content: "\\f10a1";
}

.mdi-decimal-comma::before {
  content: "\\f10a2";
}

.mdi-decimal-comma-decrease::before {
  content: "\\f10a3";
}

.mdi-decimal-comma-increase::before {
  content: "\\f10a4";
}

.mdi-decimal-decrease::before {
  content: "\\f01b6";
}

.mdi-decimal-increase::before {
  content: "\\f01b5";
}

.mdi-delete::before {
  content: "\\f01b4";
}

.mdi-delete-alert::before {
  content: "\\f10a5";
}

.mdi-delete-alert-outline::before {
  content: "\\f10a6";
}

.mdi-delete-circle::before {
  content: "\\f0683";
}

.mdi-delete-circle-outline::before {
  content: "\\f0b88";
}

.mdi-delete-empty::before {
  content: "\\f06cc";
}

.mdi-delete-empty-outline::before {
  content: "\\f0e9d";
}

.mdi-delete-forever::before {
  content: "\\f05e8";
}

.mdi-delete-forever-outline::before {
  content: "\\f0b89";
}

.mdi-delete-off::before {
  content: "\\f10a7";
}

.mdi-delete-off-outline::before {
  content: "\\f10a8";
}

.mdi-delete-outline::before {
  content: "\\f09e7";
}

.mdi-delete-restore::before {
  content: "\\f0819";
}

.mdi-delete-sweep::before {
  content: "\\f05e9";
}

.mdi-delete-sweep-outline::before {
  content: "\\f0c62";
}

.mdi-delete-variant::before {
  content: "\\f01b3";
}

.mdi-delta::before {
  content: "\\f01c2";
}

.mdi-desk::before {
  content: "\\f1239";
}

.mdi-desk-lamp::before {
  content: "\\f095f";
}

.mdi-deskphone::before {
  content: "\\f01c3";
}

.mdi-desktop-classic::before {
  content: "\\f07c0";
}

.mdi-desktop-mac::before {
  content: "\\f01c4";
}

.mdi-desktop-mac-dashboard::before {
  content: "\\f09e8";
}

.mdi-desktop-tower::before {
  content: "\\f01c5";
}

.mdi-desktop-tower-monitor::before {
  content: "\\f0aab";
}

.mdi-details::before {
  content: "\\f01c6";
}

.mdi-dev-to::before {
  content: "\\f0d6e";
}

.mdi-developer-board::before {
  content: "\\f0697";
}

.mdi-deviantart::before {
  content: "\\f01c7";
}

.mdi-devices::before {
  content: "\\f0fb0";
}

.mdi-diabetes::before {
  content: "\\f1126";
}

.mdi-dialpad::before {
  content: "\\f061c";
}

.mdi-diameter::before {
  content: "\\f0c63";
}

.mdi-diameter-outline::before {
  content: "\\f0c64";
}

.mdi-diameter-variant::before {
  content: "\\f0c65";
}

.mdi-diamond::before {
  content: "\\f0b8a";
}

.mdi-diamond-outline::before {
  content: "\\f0b8b";
}

.mdi-diamond-stone::before {
  content: "\\f01c8";
}

.mdi-dice-1::before {
  content: "\\f01ca";
}

.mdi-dice-1-outline::before {
  content: "\\f114a";
}

.mdi-dice-2::before {
  content: "\\f01cb";
}

.mdi-dice-2-outline::before {
  content: "\\f114b";
}

.mdi-dice-3::before {
  content: "\\f01cc";
}

.mdi-dice-3-outline::before {
  content: "\\f114c";
}

.mdi-dice-4::before {
  content: "\\f01cd";
}

.mdi-dice-4-outline::before {
  content: "\\f114d";
}

.mdi-dice-5::before {
  content: "\\f01ce";
}

.mdi-dice-5-outline::before {
  content: "\\f114e";
}

.mdi-dice-6::before {
  content: "\\f01cf";
}

.mdi-dice-6-outline::before {
  content: "\\f114f";
}

.mdi-dice-d10::before {
  content: "\\f1153";
}

.mdi-dice-d10-outline::before {
  content: "\\f076f";
}

.mdi-dice-d12::before {
  content: "\\f1154";
}

.mdi-dice-d12-outline::before {
  content: "\\f0867";
}

.mdi-dice-d20::before {
  content: "\\f1155";
}

.mdi-dice-d20-outline::before {
  content: "\\f05ea";
}

.mdi-dice-d4::before {
  content: "\\f1150";
}

.mdi-dice-d4-outline::before {
  content: "\\f05eb";
}

.mdi-dice-d6::before {
  content: "\\f1151";
}

.mdi-dice-d6-outline::before {
  content: "\\f05ed";
}

.mdi-dice-d8::before {
  content: "\\f1152";
}

.mdi-dice-d8-outline::before {
  content: "\\f05ec";
}

.mdi-dice-multiple::before {
  content: "\\f076e";
}

.mdi-dice-multiple-outline::before {
  content: "\\f1156";
}

.mdi-digital-ocean::before {
  content: "\\f1237";
}

.mdi-dip-switch::before {
  content: "\\f07c1";
}

.mdi-directions::before {
  content: "\\f01d0";
}

.mdi-directions-fork::before {
  content: "\\f0641";
}

.mdi-disc::before {
  content: "\\f05ee";
}

.mdi-disc-alert::before {
  content: "\\f01d1";
}

.mdi-disc-player::before {
  content: "\\f0960";
}

.mdi-discord::before {
  content: "\\f066f";
}

.mdi-dishwasher::before {
  content: "\\f0aac";
}

.mdi-dishwasher-alert::before {
  content: "\\f11b8";
}

.mdi-dishwasher-off::before {
  content: "\\f11b9";
}

.mdi-disqus::before {
  content: "\\f01d2";
}

.mdi-distribute-horizontal-center::before {
  content: "\\f11c9";
}

.mdi-distribute-horizontal-left::before {
  content: "\\f11c8";
}

.mdi-distribute-horizontal-right::before {
  content: "\\f11ca";
}

.mdi-distribute-vertical-bottom::before {
  content: "\\f11cb";
}

.mdi-distribute-vertical-center::before {
  content: "\\f11cc";
}

.mdi-distribute-vertical-top::before {
  content: "\\f11cd";
}

.mdi-diving-flippers::before {
  content: "\\f0dbf";
}

.mdi-diving-helmet::before {
  content: "\\f0dc0";
}

.mdi-diving-scuba::before {
  content: "\\f0dc1";
}

.mdi-diving-scuba-flag::before {
  content: "\\f0dc2";
}

.mdi-diving-scuba-tank::before {
  content: "\\f0dc3";
}

.mdi-diving-scuba-tank-multiple::before {
  content: "\\f0dc4";
}

.mdi-diving-snorkel::before {
  content: "\\f0dc5";
}

.mdi-division::before {
  content: "\\f01d4";
}

.mdi-division-box::before {
  content: "\\f01d5";
}

.mdi-dlna::before {
  content: "\\f0a41";
}

.mdi-dna::before {
  content: "\\f0684";
}

.mdi-dns::before {
  content: "\\f01d6";
}

.mdi-dns-outline::before {
  content: "\\f0b8c";
}

.mdi-do-not-disturb::before {
  content: "\\f0698";
}

.mdi-do-not-disturb-off::before {
  content: "\\f0699";
}

.mdi-dock-bottom::before {
  content: "\\f10a9";
}

.mdi-dock-left::before {
  content: "\\f10aa";
}

.mdi-dock-right::before {
  content: "\\f10ab";
}

.mdi-dock-window::before {
  content: "\\f10ac";
}

.mdi-docker::before {
  content: "\\f0868";
}

.mdi-doctor::before {
  content: "\\f0a42";
}

.mdi-dog::before {
  content: "\\f0a43";
}

.mdi-dog-service::before {
  content: "\\f0aad";
}

.mdi-dog-side::before {
  content: "\\f0a44";
}

.mdi-dolby::before {
  content: "\\f06b3";
}

.mdi-dolly::before {
  content: "\\f0e9e";
}

.mdi-domain::before {
  content: "\\f01d7";
}

.mdi-domain-off::before {
  content: "\\f0d6f";
}

.mdi-domain-plus::before {
  content: "\\f10ad";
}

.mdi-domain-remove::before {
  content: "\\f10ae";
}

.mdi-domino-mask::before {
  content: "\\f1023";
}

.mdi-donkey::before {
  content: "\\f07c2";
}

.mdi-door::before {
  content: "\\f081a";
}

.mdi-door-closed::before {
  content: "\\f081b";
}

.mdi-door-closed-lock::before {
  content: "\\f10af";
}

.mdi-door-open::before {
  content: "\\f081c";
}

.mdi-doorbell::before {
  content: "\\f12e6";
}

.mdi-doorbell-video::before {
  content: "\\f0869";
}

.mdi-dot-net::before {
  content: "\\f0aae";
}

.mdi-dots-horizontal::before {
  content: "\\f01d8";
}

.mdi-dots-horizontal-circle::before {
  content: "\\f07c3";
}

.mdi-dots-horizontal-circle-outline::before {
  content: "\\f0b8d";
}

.mdi-dots-vertical::before {
  content: "\\f01d9";
}

.mdi-dots-vertical-circle::before {
  content: "\\f07c4";
}

.mdi-dots-vertical-circle-outline::before {
  content: "\\f0b8e";
}

.mdi-douban::before {
  content: "\\f069a";
}

.mdi-download::before {
  content: "\\f01da";
}

.mdi-download-lock::before {
  content: "\\f1320";
}

.mdi-download-lock-outline::before {
  content: "\\f1321";
}

.mdi-download-multiple::before {
  content: "\\f09e9";
}

.mdi-download-network::before {
  content: "\\f06f4";
}

.mdi-download-network-outline::before {
  content: "\\f0c66";
}

.mdi-download-off::before {
  content: "\\f10b0";
}

.mdi-download-off-outline::before {
  content: "\\f10b1";
}

.mdi-download-outline::before {
  content: "\\f0b8f";
}

.mdi-drag::before {
  content: "\\f01db";
}

.mdi-drag-horizontal::before {
  content: "\\f01dc";
}

.mdi-drag-horizontal-variant::before {
  content: "\\f12f0";
}

.mdi-drag-variant::before {
  content: "\\f0b90";
}

.mdi-drag-vertical::before {
  content: "\\f01dd";
}

.mdi-drag-vertical-variant::before {
  content: "\\f12f1";
}

.mdi-drama-masks::before {
  content: "\\f0d02";
}

.mdi-draw::before {
  content: "\\f0f49";
}

.mdi-drawing::before {
  content: "\\f01de";
}

.mdi-drawing-box::before {
  content: "\\f01df";
}

.mdi-dresser::before {
  content: "\\f0f4a";
}

.mdi-dresser-outline::before {
  content: "\\f0f4b";
}

.mdi-drone::before {
  content: "\\f01e2";
}

.mdi-dropbox::before {
  content: "\\f01e3";
}

.mdi-drupal::before {
  content: "\\f01e4";
}

.mdi-duck::before {
  content: "\\f01e5";
}

.mdi-dumbbell::before {
  content: "\\f01e6";
}

.mdi-dump-truck::before {
  content: "\\f0c67";
}

.mdi-ear-hearing::before {
  content: "\\f07c5";
}

.mdi-ear-hearing-off::before {
  content: "\\f0a45";
}

.mdi-earth::before {
  content: "\\f01e7";
}

.mdi-earth-arrow-right::before {
  content: "\\f1311";
}

.mdi-earth-box::before {
  content: "\\f06cd";
}

.mdi-earth-box-off::before {
  content: "\\f06ce";
}

.mdi-earth-off::before {
  content: "\\f01e8";
}

.mdi-egg::before {
  content: "\\f0aaf";
}

.mdi-egg-easter::before {
  content: "\\f0ab0";
}

.mdi-eight-track::before {
  content: "\\f09ea";
}

.mdi-eject::before {
  content: "\\f01ea";
}

.mdi-eject-outline::before {
  content: "\\f0b91";
}

.mdi-electric-switch::before {
  content: "\\f0e9f";
}

.mdi-electric-switch-closed::before {
  content: "\\f10d9";
}

.mdi-electron-framework::before {
  content: "\\f1024";
}

.mdi-elephant::before {
  content: "\\f07c6";
}

.mdi-elevation-decline::before {
  content: "\\f01eb";
}

.mdi-elevation-rise::before {
  content: "\\f01ec";
}

.mdi-elevator::before {
  content: "\\f01ed";
}

.mdi-elevator-down::before {
  content: "\\f12c2";
}

.mdi-elevator-passenger::before {
  content: "\\f1381";
}

.mdi-elevator-up::before {
  content: "\\f12c1";
}

.mdi-ellipse::before {
  content: "\\f0ea0";
}

.mdi-ellipse-outline::before {
  content: "\\f0ea1";
}

.mdi-email::before {
  content: "\\f01ee";
}

.mdi-email-alert::before {
  content: "\\f06cf";
}

.mdi-email-alert-outline::before {
  content: "\\f0d42";
}

.mdi-email-box::before {
  content: "\\f0d03";
}

.mdi-email-check::before {
  content: "\\f0ab1";
}

.mdi-email-check-outline::before {
  content: "\\f0ab2";
}

.mdi-email-edit::before {
  content: "\\f0ee3";
}

.mdi-email-edit-outline::before {
  content: "\\f0ee4";
}

.mdi-email-lock::before {
  content: "\\f01f1";
}

.mdi-email-mark-as-unread::before {
  content: "\\f0b92";
}

.mdi-email-minus::before {
  content: "\\f0ee5";
}

.mdi-email-minus-outline::before {
  content: "\\f0ee6";
}

.mdi-email-multiple::before {
  content: "\\f0ee7";
}

.mdi-email-multiple-outline::before {
  content: "\\f0ee8";
}

.mdi-email-newsletter::before {
  content: "\\f0fb1";
}

.mdi-email-open::before {
  content: "\\f01ef";
}

.mdi-email-open-multiple::before {
  content: "\\f0ee9";
}

.mdi-email-open-multiple-outline::before {
  content: "\\f0eea";
}

.mdi-email-open-outline::before {
  content: "\\f05ef";
}

.mdi-email-outline::before {
  content: "\\f01f0";
}

.mdi-email-plus::before {
  content: "\\f09eb";
}

.mdi-email-plus-outline::before {
  content: "\\f09ec";
}

.mdi-email-receive::before {
  content: "\\f10da";
}

.mdi-email-receive-outline::before {
  content: "\\f10db";
}

.mdi-email-search::before {
  content: "\\f0961";
}

.mdi-email-search-outline::before {
  content: "\\f0962";
}

.mdi-email-send::before {
  content: "\\f10dc";
}

.mdi-email-send-outline::before {
  content: "\\f10dd";
}

.mdi-email-sync::before {
  content: "\\f12c7";
}

.mdi-email-sync-outline::before {
  content: "\\f12c8";
}

.mdi-email-variant::before {
  content: "\\f05f0";
}

.mdi-ember::before {
  content: "\\f0b30";
}

.mdi-emby::before {
  content: "\\f06b4";
}

.mdi-emoticon::before {
  content: "\\f0c68";
}

.mdi-emoticon-angry::before {
  content: "\\f0c69";
}

.mdi-emoticon-angry-outline::before {
  content: "\\f0c6a";
}

.mdi-emoticon-confused::before {
  content: "\\f10de";
}

.mdi-emoticon-confused-outline::before {
  content: "\\f10df";
}

.mdi-emoticon-cool::before {
  content: "\\f0c6b";
}

.mdi-emoticon-cool-outline::before {
  content: "\\f01f3";
}

.mdi-emoticon-cry::before {
  content: "\\f0c6c";
}

.mdi-emoticon-cry-outline::before {
  content: "\\f0c6d";
}

.mdi-emoticon-dead::before {
  content: "\\f0c6e";
}

.mdi-emoticon-dead-outline::before {
  content: "\\f069b";
}

.mdi-emoticon-devil::before {
  content: "\\f0c6f";
}

.mdi-emoticon-devil-outline::before {
  content: "\\f01f4";
}

.mdi-emoticon-excited::before {
  content: "\\f0c70";
}

.mdi-emoticon-excited-outline::before {
  content: "\\f069c";
}

.mdi-emoticon-frown::before {
  content: "\\f0f4c";
}

.mdi-emoticon-frown-outline::before {
  content: "\\f0f4d";
}

.mdi-emoticon-happy::before {
  content: "\\f0c71";
}

.mdi-emoticon-happy-outline::before {
  content: "\\f01f5";
}

.mdi-emoticon-kiss::before {
  content: "\\f0c72";
}

.mdi-emoticon-kiss-outline::before {
  content: "\\f0c73";
}

.mdi-emoticon-lol::before {
  content: "\\f1214";
}

.mdi-emoticon-lol-outline::before {
  content: "\\f1215";
}

.mdi-emoticon-neutral::before {
  content: "\\f0c74";
}

.mdi-emoticon-neutral-outline::before {
  content: "\\f01f6";
}

.mdi-emoticon-outline::before {
  content: "\\f01f2";
}

.mdi-emoticon-poop::before {
  content: "\\f01f7";
}

.mdi-emoticon-poop-outline::before {
  content: "\\f0c75";
}

.mdi-emoticon-sad::before {
  content: "\\f0c76";
}

.mdi-emoticon-sad-outline::before {
  content: "\\f01f8";
}

.mdi-emoticon-tongue::before {
  content: "\\f01f9";
}

.mdi-emoticon-tongue-outline::before {
  content: "\\f0c77";
}

.mdi-emoticon-wink::before {
  content: "\\f0c78";
}

.mdi-emoticon-wink-outline::before {
  content: "\\f0c79";
}

.mdi-engine::before {
  content: "\\f01fa";
}

.mdi-engine-off::before {
  content: "\\f0a46";
}

.mdi-engine-off-outline::before {
  content: "\\f0a47";
}

.mdi-engine-outline::before {
  content: "\\f01fb";
}

.mdi-epsilon::before {
  content: "\\f10e0";
}

.mdi-equal::before {
  content: "\\f01fc";
}

.mdi-equal-box::before {
  content: "\\f01fd";
}

.mdi-equalizer::before {
  content: "\\f0ea2";
}

.mdi-equalizer-outline::before {
  content: "\\f0ea3";
}

.mdi-eraser::before {
  content: "\\f01fe";
}

.mdi-eraser-variant::before {
  content: "\\f0642";
}

.mdi-escalator::before {
  content: "\\f01ff";
}

.mdi-escalator-box::before {
  content: "\\f1399";
}

.mdi-escalator-down::before {
  content: "\\f12c0";
}

.mdi-escalator-up::before {
  content: "\\f12bf";
}

.mdi-eslint::before {
  content: "\\f0c7a";
}

.mdi-et::before {
  content: "\\f0ab3";
}

.mdi-ethereum::before {
  content: "\\f086a";
}

.mdi-ethernet::before {
  content: "\\f0200";
}

.mdi-ethernet-cable::before {
  content: "\\f0201";
}

.mdi-ethernet-cable-off::before {
  content: "\\f0202";
}

.mdi-ev-station::before {
  content: "\\f05f1";
}

.mdi-evernote::before {
  content: "\\f0204";
}

.mdi-excavator::before {
  content: "\\f1025";
}

.mdi-exclamation::before {
  content: "\\f0205";
}

.mdi-exclamation-thick::before {
  content: "\\f1238";
}

.mdi-exit-run::before {
  content: "\\f0a48";
}

.mdi-exit-to-app::before {
  content: "\\f0206";
}

.mdi-expand-all::before {
  content: "\\f0ab4";
}

.mdi-expand-all-outline::before {
  content: "\\f0ab5";
}

.mdi-expansion-card::before {
  content: "\\f08ae";
}

.mdi-expansion-card-variant::before {
  content: "\\f0fb2";
}

.mdi-exponent::before {
  content: "\\f0963";
}

.mdi-exponent-box::before {
  content: "\\f0964";
}

.mdi-export::before {
  content: "\\f0207";
}

.mdi-export-variant::before {
  content: "\\f0b93";
}

.mdi-eye::before {
  content: "\\f0208";
}

.mdi-eye-check::before {
  content: "\\f0d04";
}

.mdi-eye-check-outline::before {
  content: "\\f0d05";
}

.mdi-eye-circle::before {
  content: "\\f0b94";
}

.mdi-eye-circle-outline::before {
  content: "\\f0b95";
}

.mdi-eye-minus::before {
  content: "\\f1026";
}

.mdi-eye-minus-outline::before {
  content: "\\f1027";
}

.mdi-eye-off::before {
  content: "\\f0209";
}

.mdi-eye-off-outline::before {
  content: "\\f06d1";
}

.mdi-eye-outline::before {
  content: "\\f06d0";
}

.mdi-eye-plus::before {
  content: "\\f086b";
}

.mdi-eye-plus-outline::before {
  content: "\\f086c";
}

.mdi-eye-settings::before {
  content: "\\f086d";
}

.mdi-eye-settings-outline::before {
  content: "\\f086e";
}

.mdi-eyedropper::before {
  content: "\\f020a";
}

.mdi-eyedropper-variant::before {
  content: "\\f020b";
}

.mdi-face::before {
  content: "\\f0643";
}

.mdi-face-agent::before {
  content: "\\f0d70";
}

.mdi-face-outline::before {
  content: "\\f0b96";
}

.mdi-face-profile::before {
  content: "\\f0644";
}

.mdi-face-profile-woman::before {
  content: "\\f1076";
}

.mdi-face-recognition::before {
  content: "\\f0c7b";
}

.mdi-face-woman::before {
  content: "\\f1077";
}

.mdi-face-woman-outline::before {
  content: "\\f1078";
}

.mdi-facebook::before {
  content: "\\f020c";
}

.mdi-facebook-messenger::before {
  content: "\\f020e";
}

.mdi-facebook-workplace::before {
  content: "\\f0b31";
}

.mdi-factory::before {
  content: "\\f020f";
}

.mdi-fan::before {
  content: "\\f0210";
}

.mdi-fan-off::before {
  content: "\\f081d";
}

.mdi-fast-forward::before {
  content: "\\f0211";
}

.mdi-fast-forward-10::before {
  content: "\\f0d71";
}

.mdi-fast-forward-30::before {
  content: "\\f0d06";
}

.mdi-fast-forward-5::before {
  content: "\\f11f8";
}

.mdi-fast-forward-outline::before {
  content: "\\f06d2";
}

.mdi-fax::before {
  content: "\\f0212";
}

.mdi-feather::before {
  content: "\\f06d3";
}

.mdi-feature-search::before {
  content: "\\f0a49";
}

.mdi-feature-search-outline::before {
  content: "\\f0a4a";
}

.mdi-fedora::before {
  content: "\\f08db";
}

.mdi-ferris-wheel::before {
  content: "\\f0ea4";
}

.mdi-ferry::before {
  content: "\\f0213";
}

.mdi-file::before {
  content: "\\f0214";
}

.mdi-file-account::before {
  content: "\\f073b";
}

.mdi-file-account-outline::before {
  content: "\\f1028";
}

.mdi-file-alert::before {
  content: "\\f0a4b";
}

.mdi-file-alert-outline::before {
  content: "\\f0a4c";
}

.mdi-file-cabinet::before {
  content: "\\f0ab6";
}

.mdi-file-cad::before {
  content: "\\f0eeb";
}

.mdi-file-cad-box::before {
  content: "\\f0eec";
}

.mdi-file-cancel::before {
  content: "\\f0dc6";
}

.mdi-file-cancel-outline::before {
  content: "\\f0dc7";
}

.mdi-file-certificate::before {
  content: "\\f1186";
}

.mdi-file-certificate-outline::before {
  content: "\\f1187";
}

.mdi-file-chart::before {
  content: "\\f0215";
}

.mdi-file-chart-outline::before {
  content: "\\f1029";
}

.mdi-file-check::before {
  content: "\\f0216";
}

.mdi-file-check-outline::before {
  content: "\\f0e29";
}

.mdi-file-clock::before {
  content: "\\f12e1";
}

.mdi-file-clock-outline::before {
  content: "\\f12e2";
}

.mdi-file-cloud::before {
  content: "\\f0217";
}

.mdi-file-cloud-outline::before {
  content: "\\f102a";
}

.mdi-file-code::before {
  content: "\\f022e";
}

.mdi-file-code-outline::before {
  content: "\\f102b";
}

.mdi-file-cog::before {
  content: "\\f107b";
}

.mdi-file-cog-outline::before {
  content: "\\f107c";
}

.mdi-file-compare::before {
  content: "\\f08aa";
}

.mdi-file-delimited::before {
  content: "\\f0218";
}

.mdi-file-delimited-outline::before {
  content: "\\f0ea5";
}

.mdi-file-document::before {
  content: "\\f0219";
}

.mdi-file-document-edit::before {
  content: "\\f0dc8";
}

.mdi-file-document-edit-outline::before {
  content: "\\f0dc9";
}

.mdi-file-document-outline::before {
  content: "\\f09ee";
}

.mdi-file-download::before {
  content: "\\f0965";
}

.mdi-file-download-outline::before {
  content: "\\f0966";
}

.mdi-file-edit::before {
  content: "\\f11e7";
}

.mdi-file-edit-outline::before {
  content: "\\f11e8";
}

.mdi-file-excel::before {
  content: "\\f021b";
}

.mdi-file-excel-box::before {
  content: "\\f021c";
}

.mdi-file-excel-box-outline::before {
  content: "\\f102c";
}

.mdi-file-excel-outline::before {
  content: "\\f102d";
}

.mdi-file-export::before {
  content: "\\f021d";
}

.mdi-file-export-outline::before {
  content: "\\f102e";
}

.mdi-file-eye::before {
  content: "\\f0dca";
}

.mdi-file-eye-outline::before {
  content: "\\f0dcb";
}

.mdi-file-find::before {
  content: "\\f021e";
}

.mdi-file-find-outline::before {
  content: "\\f0b97";
}

.mdi-file-hidden::before {
  content: "\\f0613";
}

.mdi-file-image::before {
  content: "\\f021f";
}

.mdi-file-image-outline::before {
  content: "\\f0eb0";
}

.mdi-file-import::before {
  content: "\\f0220";
}

.mdi-file-import-outline::before {
  content: "\\f102f";
}

.mdi-file-key::before {
  content: "\\f1184";
}

.mdi-file-key-outline::before {
  content: "\\f1185";
}

.mdi-file-link::before {
  content: "\\f1177";
}

.mdi-file-link-outline::before {
  content: "\\f1178";
}

.mdi-file-lock::before {
  content: "\\f0221";
}

.mdi-file-lock-outline::before {
  content: "\\f1030";
}

.mdi-file-move::before {
  content: "\\f0ab9";
}

.mdi-file-move-outline::before {
  content: "\\f1031";
}

.mdi-file-multiple::before {
  content: "\\f0222";
}

.mdi-file-multiple-outline::before {
  content: "\\f1032";
}

.mdi-file-music::before {
  content: "\\f0223";
}

.mdi-file-music-outline::before {
  content: "\\f0e2a";
}

.mdi-file-outline::before {
  content: "\\f0224";
}

.mdi-file-pdf::before {
  content: "\\f0225";
}

.mdi-file-pdf-box::before {
  content: "\\f0226";
}

.mdi-file-pdf-box-outline::before {
  content: "\\f0fb3";
}

.mdi-file-pdf-outline::before {
  content: "\\f0e2d";
}

.mdi-file-percent::before {
  content: "\\f081e";
}

.mdi-file-percent-outline::before {
  content: "\\f1033";
}

.mdi-file-phone::before {
  content: "\\f1179";
}

.mdi-file-phone-outline::before {
  content: "\\f117a";
}

.mdi-file-plus::before {
  content: "\\f0752";
}

.mdi-file-plus-outline::before {
  content: "\\f0eed";
}

.mdi-file-powerpoint::before {
  content: "\\f0227";
}

.mdi-file-powerpoint-box::before {
  content: "\\f0228";
}

.mdi-file-powerpoint-box-outline::before {
  content: "\\f1034";
}

.mdi-file-powerpoint-outline::before {
  content: "\\f1035";
}

.mdi-file-presentation-box::before {
  content: "\\f0229";
}

.mdi-file-question::before {
  content: "\\f086f";
}

.mdi-file-question-outline::before {
  content: "\\f1036";
}

.mdi-file-refresh::before {
  content: "\\f0918";
}

.mdi-file-refresh-outline::before {
  content: "\\f0541";
}

.mdi-file-remove::before {
  content: "\\f0b98";
}

.mdi-file-remove-outline::before {
  content: "\\f1037";
}

.mdi-file-replace::before {
  content: "\\f0b32";
}

.mdi-file-replace-outline::before {
  content: "\\f0b33";
}

.mdi-file-restore::before {
  content: "\\f0670";
}

.mdi-file-restore-outline::before {
  content: "\\f1038";
}

.mdi-file-search::before {
  content: "\\f0c7c";
}

.mdi-file-search-outline::before {
  content: "\\f0c7d";
}

.mdi-file-send::before {
  content: "\\f022a";
}

.mdi-file-send-outline::before {
  content: "\\f1039";
}

.mdi-file-settings::before {
  content: "\\f1079";
}

.mdi-file-settings-outline::before {
  content: "\\f107a";
}

.mdi-file-star::before {
  content: "\\f103a";
}

.mdi-file-star-outline::before {
  content: "\\f103b";
}

.mdi-file-swap::before {
  content: "\\f0fb4";
}

.mdi-file-swap-outline::before {
  content: "\\f0fb5";
}

.mdi-file-sync::before {
  content: "\\f1216";
}

.mdi-file-sync-outline::before {
  content: "\\f1217";
}

.mdi-file-table::before {
  content: "\\f0c7e";
}

.mdi-file-table-box::before {
  content: "\\f10e1";
}

.mdi-file-table-box-multiple::before {
  content: "\\f10e2";
}

.mdi-file-table-box-multiple-outline::before {
  content: "\\f10e3";
}

.mdi-file-table-box-outline::before {
  content: "\\f10e4";
}

.mdi-file-table-outline::before {
  content: "\\f0c7f";
}

.mdi-file-tree::before {
  content: "\\f0645";
}

.mdi-file-undo::before {
  content: "\\f08dc";
}

.mdi-file-undo-outline::before {
  content: "\\f103c";
}

.mdi-file-upload::before {
  content: "\\f0a4d";
}

.mdi-file-upload-outline::before {
  content: "\\f0a4e";
}

.mdi-file-video::before {
  content: "\\f022b";
}

.mdi-file-video-outline::before {
  content: "\\f0e2c";
}

.mdi-file-word::before {
  content: "\\f022c";
}

.mdi-file-word-box::before {
  content: "\\f022d";
}

.mdi-file-word-box-outline::before {
  content: "\\f103d";
}

.mdi-file-word-outline::before {
  content: "\\f103e";
}

.mdi-film::before {
  content: "\\f022f";
}

.mdi-filmstrip::before {
  content: "\\f0230";
}

.mdi-filmstrip-box::before {
  content: "\\f0332";
}

.mdi-filmstrip-box-multiple::before {
  content: "\\f0d18";
}

.mdi-filmstrip-off::before {
  content: "\\f0231";
}

.mdi-filter::before {
  content: "\\f0232";
}

.mdi-filter-menu::before {
  content: "\\f10e5";
}

.mdi-filter-menu-outline::before {
  content: "\\f10e6";
}

.mdi-filter-minus::before {
  content: "\\f0eee";
}

.mdi-filter-minus-outline::before {
  content: "\\f0eef";
}

.mdi-filter-outline::before {
  content: "\\f0233";
}

.mdi-filter-plus::before {
  content: "\\f0ef0";
}

.mdi-filter-plus-outline::before {
  content: "\\f0ef1";
}

.mdi-filter-remove::before {
  content: "\\f0234";
}

.mdi-filter-remove-outline::before {
  content: "\\f0235";
}

.mdi-filter-variant::before {
  content: "\\f0236";
}

.mdi-filter-variant-minus::before {
  content: "\\f1112";
}

.mdi-filter-variant-plus::before {
  content: "\\f1113";
}

.mdi-filter-variant-remove::before {
  content: "\\f103f";
}

.mdi-finance::before {
  content: "\\f081f";
}

.mdi-find-replace::before {
  content: "\\f06d4";
}

.mdi-fingerprint::before {
  content: "\\f0237";
}

.mdi-fingerprint-off::before {
  content: "\\f0eb1";
}

.mdi-fire::before {
  content: "\\f0238";
}

.mdi-fire-extinguisher::before {
  content: "\\f0ef2";
}

.mdi-fire-hydrant::before {
  content: "\\f1137";
}

.mdi-fire-hydrant-alert::before {
  content: "\\f1138";
}

.mdi-fire-hydrant-off::before {
  content: "\\f1139";
}

.mdi-fire-truck::before {
  content: "\\f08ab";
}

.mdi-firebase::before {
  content: "\\f0967";
}

.mdi-firefox::before {
  content: "\\f0239";
}

.mdi-fireplace::before {
  content: "\\f0e2e";
}

.mdi-fireplace-off::before {
  content: "\\f0e2f";
}

.mdi-firework::before {
  content: "\\f0e30";
}

.mdi-fish::before {
  content: "\\f023a";
}

.mdi-fishbowl::before {
  content: "\\f0ef3";
}

.mdi-fishbowl-outline::before {
  content: "\\f0ef4";
}

.mdi-fit-to-page::before {
  content: "\\f0ef5";
}

.mdi-fit-to-page-outline::before {
  content: "\\f0ef6";
}

.mdi-flag::before {
  content: "\\f023b";
}

.mdi-flag-checkered::before {
  content: "\\f023c";
}

.mdi-flag-minus::before {
  content: "\\f0b99";
}

.mdi-flag-minus-outline::before {
  content: "\\f10b2";
}

.mdi-flag-outline::before {
  content: "\\f023d";
}

.mdi-flag-plus::before {
  content: "\\f0b9a";
}

.mdi-flag-plus-outline::before {
  content: "\\f10b3";
}

.mdi-flag-remove::before {
  content: "\\f0b9b";
}

.mdi-flag-remove-outline::before {
  content: "\\f10b4";
}

.mdi-flag-triangle::before {
  content: "\\f023f";
}

.mdi-flag-variant::before {
  content: "\\f0240";
}

.mdi-flag-variant-outline::before {
  content: "\\f023e";
}

.mdi-flare::before {
  content: "\\f0d72";
}

.mdi-flash::before {
  content: "\\f0241";
}

.mdi-flash-alert::before {
  content: "\\f0ef7";
}

.mdi-flash-alert-outline::before {
  content: "\\f0ef8";
}

.mdi-flash-auto::before {
  content: "\\f0242";
}

.mdi-flash-circle::before {
  content: "\\f0820";
}

.mdi-flash-off::before {
  content: "\\f0243";
}

.mdi-flash-outline::before {
  content: "\\f06d5";
}

.mdi-flash-red-eye::before {
  content: "\\f067b";
}

.mdi-flashlight::before {
  content: "\\f0244";
}

.mdi-flashlight-off::before {
  content: "\\f0245";
}

.mdi-flask::before {
  content: "\\f0093";
}

.mdi-flask-empty::before {
  content: "\\f0094";
}

.mdi-flask-empty-minus::before {
  content: "\\f123a";
}

.mdi-flask-empty-minus-outline::before {
  content: "\\f123b";
}

.mdi-flask-empty-outline::before {
  content: "\\f0095";
}

.mdi-flask-empty-plus::before {
  content: "\\f123c";
}

.mdi-flask-empty-plus-outline::before {
  content: "\\f123d";
}

.mdi-flask-empty-remove::before {
  content: "\\f123e";
}

.mdi-flask-empty-remove-outline::before {
  content: "\\f123f";
}

.mdi-flask-minus::before {
  content: "\\f1240";
}

.mdi-flask-minus-outline::before {
  content: "\\f1241";
}

.mdi-flask-outline::before {
  content: "\\f0096";
}

.mdi-flask-plus::before {
  content: "\\f1242";
}

.mdi-flask-plus-outline::before {
  content: "\\f1243";
}

.mdi-flask-remove::before {
  content: "\\f1244";
}

.mdi-flask-remove-outline::before {
  content: "\\f1245";
}

.mdi-flask-round-bottom::before {
  content: "\\f124b";
}

.mdi-flask-round-bottom-empty::before {
  content: "\\f124c";
}

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\f124d";
}

.mdi-flask-round-bottom-outline::before {
  content: "\\f124e";
}

.mdi-fleur-de-lis::before {
  content: "\\f1303";
}

.mdi-flip-horizontal::before {
  content: "\\f10e7";
}

.mdi-flip-to-back::before {
  content: "\\f0247";
}

.mdi-flip-to-front::before {
  content: "\\f0248";
}

.mdi-flip-vertical::before {
  content: "\\f10e8";
}

.mdi-floor-lamp::before {
  content: "\\f08dd";
}

.mdi-floor-lamp-dual::before {
  content: "\\f1040";
}

.mdi-floor-lamp-variant::before {
  content: "\\f1041";
}

.mdi-floor-plan::before {
  content: "\\f0821";
}

.mdi-floppy::before {
  content: "\\f0249";
}

.mdi-floppy-variant::before {
  content: "\\f09ef";
}

.mdi-flower::before {
  content: "\\f024a";
}

.mdi-flower-outline::before {
  content: "\\f09f0";
}

.mdi-flower-poppy::before {
  content: "\\f0d08";
}

.mdi-flower-tulip::before {
  content: "\\f09f1";
}

.mdi-flower-tulip-outline::before {
  content: "\\f09f2";
}

.mdi-focus-auto::before {
  content: "\\f0f4e";
}

.mdi-focus-field::before {
  content: "\\f0f4f";
}

.mdi-focus-field-horizontal::before {
  content: "\\f0f50";
}

.mdi-focus-field-vertical::before {
  content: "\\f0f51";
}

.mdi-folder::before {
  content: "\\f024b";
}

.mdi-folder-account::before {
  content: "\\f024c";
}

.mdi-folder-account-outline::before {
  content: "\\f0b9c";
}

.mdi-folder-alert::before {
  content: "\\f0dcc";
}

.mdi-folder-alert-outline::before {
  content: "\\f0dcd";
}

.mdi-folder-clock::before {
  content: "\\f0aba";
}

.mdi-folder-clock-outline::before {
  content: "\\f0abb";
}

.mdi-folder-cog::before {
  content: "\\f107f";
}

.mdi-folder-cog-outline::before {
  content: "\\f1080";
}

.mdi-folder-download::before {
  content: "\\f024d";
}

.mdi-folder-download-outline::before {
  content: "\\f10e9";
}

.mdi-folder-edit::before {
  content: "\\f08de";
}

.mdi-folder-edit-outline::before {
  content: "\\f0dce";
}

.mdi-folder-google-drive::before {
  content: "\\f024e";
}

.mdi-folder-heart::before {
  content: "\\f10ea";
}

.mdi-folder-heart-outline::before {
  content: "\\f10eb";
}

.mdi-folder-home::before {
  content: "\\f10b5";
}

.mdi-folder-home-outline::before {
  content: "\\f10b6";
}

.mdi-folder-image::before {
  content: "\\f024f";
}

.mdi-folder-information::before {
  content: "\\f10b7";
}

.mdi-folder-information-outline::before {
  content: "\\f10b8";
}

.mdi-folder-key::before {
  content: "\\f08ac";
}

.mdi-folder-key-network::before {
  content: "\\f08ad";
}

.mdi-folder-key-network-outline::before {
  content: "\\f0c80";
}

.mdi-folder-key-outline::before {
  content: "\\f10ec";
}

.mdi-folder-lock::before {
  content: "\\f0250";
}

.mdi-folder-lock-open::before {
  content: "\\f0251";
}

.mdi-folder-marker::before {
  content: "\\f126d";
}

.mdi-folder-marker-outline::before {
  content: "\\f126e";
}

.mdi-folder-move::before {
  content: "\\f0252";
}

.mdi-folder-move-outline::before {
  content: "\\f1246";
}

.mdi-folder-multiple::before {
  content: "\\f0253";
}

.mdi-folder-multiple-image::before {
  content: "\\f0254";
}

.mdi-folder-multiple-outline::before {
  content: "\\f0255";
}

.mdi-folder-music::before {
  content: "\\f1359";
}

.mdi-folder-music-outline::before {
  content: "\\f135a";
}

.mdi-folder-network::before {
  content: "\\f0870";
}

.mdi-folder-network-outline::before {
  content: "\\f0c81";
}

.mdi-folder-open::before {
  content: "\\f0770";
}

.mdi-folder-open-outline::before {
  content: "\\f0dcf";
}

.mdi-folder-outline::before {
  content: "\\f0256";
}

.mdi-folder-plus::before {
  content: "\\f0257";
}

.mdi-folder-plus-outline::before {
  content: "\\f0b9d";
}

.mdi-folder-pound::before {
  content: "\\f0d09";
}

.mdi-folder-pound-outline::before {
  content: "\\f0d0a";
}

.mdi-folder-refresh::before {
  content: "\\f0749";
}

.mdi-folder-refresh-outline::before {
  content: "\\f0542";
}

.mdi-folder-remove::before {
  content: "\\f0258";
}

.mdi-folder-remove-outline::before {
  content: "\\f0b9e";
}

.mdi-folder-search::before {
  content: "\\f0968";
}

.mdi-folder-search-outline::before {
  content: "\\f0969";
}

.mdi-folder-settings::before {
  content: "\\f107d";
}

.mdi-folder-settings-outline::before {
  content: "\\f107e";
}

.mdi-folder-star::before {
  content: "\\f069d";
}

.mdi-folder-star-outline::before {
  content: "\\f0b9f";
}

.mdi-folder-swap::before {
  content: "\\f0fb6";
}

.mdi-folder-swap-outline::before {
  content: "\\f0fb7";
}

.mdi-folder-sync::before {
  content: "\\f0d0b";
}

.mdi-folder-sync-outline::before {
  content: "\\f0d0c";
}

.mdi-folder-table::before {
  content: "\\f12e3";
}

.mdi-folder-table-outline::before {
  content: "\\f12e4";
}

.mdi-folder-text::before {
  content: "\\f0c82";
}

.mdi-folder-text-outline::before {
  content: "\\f0c83";
}

.mdi-folder-upload::before {
  content: "\\f0259";
}

.mdi-folder-upload-outline::before {
  content: "\\f10ed";
}

.mdi-folder-zip::before {
  content: "\\f06eb";
}

.mdi-folder-zip-outline::before {
  content: "\\f07b9";
}

.mdi-font-awesome::before {
  content: "\\f003a";
}

.mdi-food::before {
  content: "\\f025a";
}

.mdi-food-apple::before {
  content: "\\f025b";
}

.mdi-food-apple-outline::before {
  content: "\\f0c84";
}

.mdi-food-croissant::before {
  content: "\\f07c8";
}

.mdi-food-fork-drink::before {
  content: "\\f05f2";
}

.mdi-food-off::before {
  content: "\\f05f3";
}

.mdi-food-variant::before {
  content: "\\f025c";
}

.mdi-foot-print::before {
  content: "\\f0f52";
}

.mdi-football::before {
  content: "\\f025d";
}

.mdi-football-australian::before {
  content: "\\f025e";
}

.mdi-football-helmet::before {
  content: "\\f025f";
}

.mdi-forklift::before {
  content: "\\f07c9";
}

.mdi-format-align-bottom::before {
  content: "\\f0753";
}

.mdi-format-align-center::before {
  content: "\\f0260";
}

.mdi-format-align-justify::before {
  content: "\\f0261";
}

.mdi-format-align-left::before {
  content: "\\f0262";
}

.mdi-format-align-middle::before {
  content: "\\f0754";
}

.mdi-format-align-right::before {
  content: "\\f0263";
}

.mdi-format-align-top::before {
  content: "\\f0755";
}

.mdi-format-annotation-minus::before {
  content: "\\f0abc";
}

.mdi-format-annotation-plus::before {
  content: "\\f0646";
}

.mdi-format-bold::before {
  content: "\\f0264";
}

.mdi-format-clear::before {
  content: "\\f0265";
}

.mdi-format-color-fill::before {
  content: "\\f0266";
}

.mdi-format-color-highlight::before {
  content: "\\f0e31";
}

.mdi-format-color-marker-cancel::before {
  content: "\\f1313";
}

.mdi-format-color-text::before {
  content: "\\f069e";
}

.mdi-format-columns::before {
  content: "\\f08df";
}

.mdi-format-float-center::before {
  content: "\\f0267";
}

.mdi-format-float-left::before {
  content: "\\f0268";
}

.mdi-format-float-none::before {
  content: "\\f0269";
}

.mdi-format-float-right::before {
  content: "\\f026a";
}

.mdi-format-font::before {
  content: "\\f06d6";
}

.mdi-format-font-size-decrease::before {
  content: "\\f09f3";
}

.mdi-format-font-size-increase::before {
  content: "\\f09f4";
}

.mdi-format-header-1::before {
  content: "\\f026b";
}

.mdi-format-header-2::before {
  content: "\\f026c";
}

.mdi-format-header-3::before {
  content: "\\f026d";
}

.mdi-format-header-4::before {
  content: "\\f026e";
}

.mdi-format-header-5::before {
  content: "\\f026f";
}

.mdi-format-header-6::before {
  content: "\\f0270";
}

.mdi-format-header-decrease::before {
  content: "\\f0271";
}

.mdi-format-header-equal::before {
  content: "\\f0272";
}

.mdi-format-header-increase::before {
  content: "\\f0273";
}

.mdi-format-header-pound::before {
  content: "\\f0274";
}

.mdi-format-horizontal-align-center::before {
  content: "\\f061e";
}

.mdi-format-horizontal-align-left::before {
  content: "\\f061f";
}

.mdi-format-horizontal-align-right::before {
  content: "\\f0620";
}

.mdi-format-indent-decrease::before {
  content: "\\f0275";
}

.mdi-format-indent-increase::before {
  content: "\\f0276";
}

.mdi-format-italic::before {
  content: "\\f0277";
}

.mdi-format-letter-case::before {
  content: "\\f0b34";
}

.mdi-format-letter-case-lower::before {
  content: "\\f0b35";
}

.mdi-format-letter-case-upper::before {
  content: "\\f0b36";
}

.mdi-format-letter-ends-with::before {
  content: "\\f0fb8";
}

.mdi-format-letter-matches::before {
  content: "\\f0fb9";
}

.mdi-format-letter-starts-with::before {
  content: "\\f0fba";
}

.mdi-format-line-spacing::before {
  content: "\\f0278";
}

.mdi-format-line-style::before {
  content: "\\f05c8";
}

.mdi-format-line-weight::before {
  content: "\\f05c9";
}

.mdi-format-list-bulleted::before {
  content: "\\f0279";
}

.mdi-format-list-bulleted-square::before {
  content: "\\f0dd0";
}

.mdi-format-list-bulleted-triangle::before {
  content: "\\f0eb2";
}

.mdi-format-list-bulleted-type::before {
  content: "\\f027a";
}

.mdi-format-list-checkbox::before {
  content: "\\f096a";
}

.mdi-format-list-checks::before {
  content: "\\f0756";
}

.mdi-format-list-numbered::before {
  content: "\\f027b";
}

.mdi-format-list-numbered-rtl::before {
  content: "\\f0d0d";
}

.mdi-format-list-text::before {
  content: "\\f126f";
}

.mdi-format-overline::before {
  content: "\\f0eb3";
}

.mdi-format-page-break::before {
  content: "\\f06d7";
}

.mdi-format-paint::before {
  content: "\\f027c";
}

.mdi-format-paragraph::before {
  content: "\\f027d";
}

.mdi-format-pilcrow::before {
  content: "\\f06d8";
}

.mdi-format-quote-close::before {
  content: "\\f027e";
}

.mdi-format-quote-close-outline::before {
  content: "\\f11a8";
}

.mdi-format-quote-open::before {
  content: "\\f0757";
}

.mdi-format-quote-open-outline::before {
  content: "\\f11a7";
}

.mdi-format-rotate-90::before {
  content: "\\f06aa";
}

.mdi-format-section::before {
  content: "\\f069f";
}

.mdi-format-size::before {
  content: "\\f027f";
}

.mdi-format-strikethrough::before {
  content: "\\f0280";
}

.mdi-format-strikethrough-variant::before {
  content: "\\f0281";
}

.mdi-format-subscript::before {
  content: "\\f0282";
}

.mdi-format-superscript::before {
  content: "\\f0283";
}

.mdi-format-text::before {
  content: "\\f0284";
}

.mdi-format-text-rotation-angle-down::before {
  content: "\\f0fbb";
}

.mdi-format-text-rotation-angle-up::before {
  content: "\\f0fbc";
}

.mdi-format-text-rotation-down::before {
  content: "\\f0d73";
}

.mdi-format-text-rotation-down-vertical::before {
  content: "\\f0fbd";
}

.mdi-format-text-rotation-none::before {
  content: "\\f0d74";
}

.mdi-format-text-rotation-up::before {
  content: "\\f0fbe";
}

.mdi-format-text-rotation-vertical::before {
  content: "\\f0fbf";
}

.mdi-format-text-variant::before {
  content: "\\f0e32";
}

.mdi-format-text-wrapping-clip::before {
  content: "\\f0d0e";
}

.mdi-format-text-wrapping-overflow::before {
  content: "\\f0d0f";
}

.mdi-format-text-wrapping-wrap::before {
  content: "\\f0d10";
}

.mdi-format-textbox::before {
  content: "\\f0d11";
}

.mdi-format-textdirection-l-to-r::before {
  content: "\\f0285";
}

.mdi-format-textdirection-r-to-l::before {
  content: "\\f0286";
}

.mdi-format-title::before {
  content: "\\f05f4";
}

.mdi-format-underline::before {
  content: "\\f0287";
}

.mdi-format-vertical-align-bottom::before {
  content: "\\f0621";
}

.mdi-format-vertical-align-center::before {
  content: "\\f0622";
}

.mdi-format-vertical-align-top::before {
  content: "\\f0623";
}

.mdi-format-wrap-inline::before {
  content: "\\f0288";
}

.mdi-format-wrap-square::before {
  content: "\\f0289";
}

.mdi-format-wrap-tight::before {
  content: "\\f028a";
}

.mdi-format-wrap-top-bottom::before {
  content: "\\f028b";
}

.mdi-forum::before {
  content: "\\f028c";
}

.mdi-forum-outline::before {
  content: "\\f0822";
}

.mdi-forward::before {
  content: "\\f028d";
}

.mdi-forwardburger::before {
  content: "\\f0d75";
}

.mdi-fountain::before {
  content: "\\f096b";
}

.mdi-fountain-pen::before {
  content: "\\f0d12";
}

.mdi-fountain-pen-tip::before {
  content: "\\f0d13";
}

.mdi-freebsd::before {
  content: "\\f08e0";
}

.mdi-frequently-asked-questions::before {
  content: "\\f0eb4";
}

.mdi-fridge::before {
  content: "\\f0290";
}

.mdi-fridge-alert::before {
  content: "\\f11b1";
}

.mdi-fridge-alert-outline::before {
  content: "\\f11b2";
}

.mdi-fridge-bottom::before {
  content: "\\f0292";
}

.mdi-fridge-off::before {
  content: "\\f11af";
}

.mdi-fridge-off-outline::before {
  content: "\\f11b0";
}

.mdi-fridge-outline::before {
  content: "\\f028f";
}

.mdi-fridge-top::before {
  content: "\\f0291";
}

.mdi-fruit-cherries::before {
  content: "\\f1042";
}

.mdi-fruit-citrus::before {
  content: "\\f1043";
}

.mdi-fruit-grapes::before {
  content: "\\f1044";
}

.mdi-fruit-grapes-outline::before {
  content: "\\f1045";
}

.mdi-fruit-pineapple::before {
  content: "\\f1046";
}

.mdi-fruit-watermelon::before {
  content: "\\f1047";
}

.mdi-fuel::before {
  content: "\\f07ca";
}

.mdi-fullscreen::before {
  content: "\\f0293";
}

.mdi-fullscreen-exit::before {
  content: "\\f0294";
}

.mdi-function::before {
  content: "\\f0295";
}

.mdi-function-variant::before {
  content: "\\f0871";
}

.mdi-furigana-horizontal::before {
  content: "\\f1081";
}

.mdi-furigana-vertical::before {
  content: "\\f1082";
}

.mdi-fuse::before {
  content: "\\f0c85";
}

.mdi-fuse-blade::before {
  content: "\\f0c86";
}

.mdi-gamepad::before {
  content: "\\f0296";
}

.mdi-gamepad-circle::before {
  content: "\\f0e33";
}

.mdi-gamepad-circle-down::before {
  content: "\\f0e34";
}

.mdi-gamepad-circle-left::before {
  content: "\\f0e35";
}

.mdi-gamepad-circle-outline::before {
  content: "\\f0e36";
}

.mdi-gamepad-circle-right::before {
  content: "\\f0e37";
}

.mdi-gamepad-circle-up::before {
  content: "\\f0e38";
}

.mdi-gamepad-down::before {
  content: "\\f0e39";
}

.mdi-gamepad-left::before {
  content: "\\f0e3a";
}

.mdi-gamepad-right::before {
  content: "\\f0e3b";
}

.mdi-gamepad-round::before {
  content: "\\f0e3c";
}

.mdi-gamepad-round-down::before {
  content: "\\f0e3d";
}

.mdi-gamepad-round-left::before {
  content: "\\f0e3e";
}

.mdi-gamepad-round-outline::before {
  content: "\\f0e3f";
}

.mdi-gamepad-round-right::before {
  content: "\\f0e40";
}

.mdi-gamepad-round-up::before {
  content: "\\f0e41";
}

.mdi-gamepad-square::before {
  content: "\\f0eb5";
}

.mdi-gamepad-square-outline::before {
  content: "\\f0eb6";
}

.mdi-gamepad-up::before {
  content: "\\f0e42";
}

.mdi-gamepad-variant::before {
  content: "\\f0297";
}

.mdi-gamepad-variant-outline::before {
  content: "\\f0eb7";
}

.mdi-gamma::before {
  content: "\\f10ee";
}

.mdi-gantry-crane::before {
  content: "\\f0dd1";
}

.mdi-garage::before {
  content: "\\f06d9";
}

.mdi-garage-alert::before {
  content: "\\f0872";
}

.mdi-garage-alert-variant::before {
  content: "\\f12d5";
}

.mdi-garage-open::before {
  content: "\\f06da";
}

.mdi-garage-open-variant::before {
  content: "\\f12d4";
}

.mdi-garage-variant::before {
  content: "\\f12d3";
}

.mdi-gas-cylinder::before {
  content: "\\f0647";
}

.mdi-gas-station::before {
  content: "\\f0298";
}

.mdi-gas-station-outline::before {
  content: "\\f0eb8";
}

.mdi-gate::before {
  content: "\\f0299";
}

.mdi-gate-and::before {
  content: "\\f08e1";
}

.mdi-gate-arrow-right::before {
  content: "\\f1169";
}

.mdi-gate-nand::before {
  content: "\\f08e2";
}

.mdi-gate-nor::before {
  content: "\\f08e3";
}

.mdi-gate-not::before {
  content: "\\f08e4";
}

.mdi-gate-open::before {
  content: "\\f116a";
}

.mdi-gate-or::before {
  content: "\\f08e5";
}

.mdi-gate-xnor::before {
  content: "\\f08e6";
}

.mdi-gate-xor::before {
  content: "\\f08e7";
}

.mdi-gatsby::before {
  content: "\\f0e43";
}

.mdi-gauge::before {
  content: "\\f029a";
}

.mdi-gauge-empty::before {
  content: "\\f0873";
}

.mdi-gauge-full::before {
  content: "\\f0874";
}

.mdi-gauge-low::before {
  content: "\\f0875";
}

.mdi-gavel::before {
  content: "\\f029b";
}

.mdi-gender-female::before {
  content: "\\f029c";
}

.mdi-gender-male::before {
  content: "\\f029d";
}

.mdi-gender-male-female::before {
  content: "\\f029e";
}

.mdi-gender-male-female-variant::before {
  content: "\\f113f";
}

.mdi-gender-non-binary::before {
  content: "\\f1140";
}

.mdi-gender-transgender::before {
  content: "\\f029f";
}

.mdi-gentoo::before {
  content: "\\f08e8";
}

.mdi-gesture::before {
  content: "\\f07cb";
}

.mdi-gesture-double-tap::before {
  content: "\\f073c";
}

.mdi-gesture-pinch::before {
  content: "\\f0abd";
}

.mdi-gesture-spread::before {
  content: "\\f0abe";
}

.mdi-gesture-swipe::before {
  content: "\\f0d76";
}

.mdi-gesture-swipe-down::before {
  content: "\\f073d";
}

.mdi-gesture-swipe-horizontal::before {
  content: "\\f0abf";
}

.mdi-gesture-swipe-left::before {
  content: "\\f073e";
}

.mdi-gesture-swipe-right::before {
  content: "\\f073f";
}

.mdi-gesture-swipe-up::before {
  content: "\\f0740";
}

.mdi-gesture-swipe-vertical::before {
  content: "\\f0ac0";
}

.mdi-gesture-tap::before {
  content: "\\f0741";
}

.mdi-gesture-tap-box::before {
  content: "\\f12a9";
}

.mdi-gesture-tap-button::before {
  content: "\\f12a8";
}

.mdi-gesture-tap-hold::before {
  content: "\\f0d77";
}

.mdi-gesture-two-double-tap::before {
  content: "\\f0742";
}

.mdi-gesture-two-tap::before {
  content: "\\f0743";
}

.mdi-ghost::before {
  content: "\\f02a0";
}

.mdi-ghost-off::before {
  content: "\\f09f5";
}

.mdi-gif::before {
  content: "\\f0d78";
}

.mdi-gift::before {
  content: "\\f0e44";
}

.mdi-gift-outline::before {
  content: "\\f02a1";
}

.mdi-git::before {
  content: "\\f02a2";
}

.mdi-github::before {
  content: "\\f02a4";
}

.mdi-gitlab::before {
  content: "\\f0ba0";
}

.mdi-glass-cocktail::before {
  content: "\\f0356";
}

.mdi-glass-flute::before {
  content: "\\f02a5";
}

.mdi-glass-mug::before {
  content: "\\f02a6";
}

.mdi-glass-mug-variant::before {
  content: "\\f1116";
}

.mdi-glass-pint-outline::before {
  content: "\\f130d";
}

.mdi-glass-stange::before {
  content: "\\f02a7";
}

.mdi-glass-tulip::before {
  content: "\\f02a8";
}

.mdi-glass-wine::before {
  content: "\\f0876";
}

.mdi-glasses::before {
  content: "\\f02aa";
}

.mdi-globe-light::before {
  content: "\\f12d7";
}

.mdi-globe-model::before {
  content: "\\f08e9";
}

.mdi-gmail::before {
  content: "\\f02ab";
}

.mdi-gnome::before {
  content: "\\f02ac";
}

.mdi-go-kart::before {
  content: "\\f0d79";
}

.mdi-go-kart-track::before {
  content: "\\f0d7a";
}

.mdi-gog::before {
  content: "\\f0ba1";
}

.mdi-gold::before {
  content: "\\f124f";
}

.mdi-golf::before {
  content: "\\f0823";
}

.mdi-golf-cart::before {
  content: "\\f11a4";
}

.mdi-golf-tee::before {
  content: "\\f1083";
}

.mdi-gondola::before {
  content: "\\f0686";
}

.mdi-goodreads::before {
  content: "\\f0d7b";
}

.mdi-google::before {
  content: "\\f02ad";
}

.mdi-google-ads::before {
  content: "\\f0c87";
}

.mdi-google-analytics::before {
  content: "\\f07cc";
}

.mdi-google-assistant::before {
  content: "\\f07cd";
}

.mdi-google-cardboard::before {
  content: "\\f02ae";
}

.mdi-google-chrome::before {
  content: "\\f02af";
}

.mdi-google-circles::before {
  content: "\\f02b0";
}

.mdi-google-circles-communities::before {
  content: "\\f02b1";
}

.mdi-google-circles-extended::before {
  content: "\\f02b2";
}

.mdi-google-circles-group::before {
  content: "\\f02b3";
}

.mdi-google-classroom::before {
  content: "\\f02c0";
}

.mdi-google-cloud::before {
  content: "\\f11f6";
}

.mdi-google-controller::before {
  content: "\\f02b4";
}

.mdi-google-controller-off::before {
  content: "\\f02b5";
}

.mdi-google-downasaur::before {
  content: "\\f1362";
}

.mdi-google-drive::before {
  content: "\\f02b6";
}

.mdi-google-earth::before {
  content: "\\f02b7";
}

.mdi-google-fit::before {
  content: "\\f096c";
}

.mdi-google-glass::before {
  content: "\\f02b8";
}

.mdi-google-hangouts::before {
  content: "\\f02c9";
}

.mdi-google-home::before {
  content: "\\f0824";
}

.mdi-google-keep::before {
  content: "\\f06dc";
}

.mdi-google-lens::before {
  content: "\\f09f6";
}

.mdi-google-maps::before {
  content: "\\f05f5";
}

.mdi-google-my-business::before {
  content: "\\f1048";
}

.mdi-google-nearby::before {
  content: "\\f02b9";
}

.mdi-google-photos::before {
  content: "\\f06dd";
}

.mdi-google-play::before {
  content: "\\f02bc";
}

.mdi-google-plus::before {
  content: "\\f02bd";
}

.mdi-google-podcast::before {
  content: "\\f0eb9";
}

.mdi-google-spreadsheet::before {
  content: "\\f09f7";
}

.mdi-google-street-view::before {
  content: "\\f0c88";
}

.mdi-google-translate::before {
  content: "\\f02bf";
}

.mdi-gradient::before {
  content: "\\f06a0";
}

.mdi-grain::before {
  content: "\\f0d7c";
}

.mdi-graph::before {
  content: "\\f1049";
}

.mdi-graph-outline::before {
  content: "\\f104a";
}

.mdi-graphql::before {
  content: "\\f0877";
}

.mdi-grave-stone::before {
  content: "\\f0ba2";
}

.mdi-grease-pencil::before {
  content: "\\f0648";
}

.mdi-greater-than::before {
  content: "\\f096d";
}

.mdi-greater-than-or-equal::before {
  content: "\\f096e";
}

.mdi-grid::before {
  content: "\\f02c1";
}

.mdi-grid-large::before {
  content: "\\f0758";
}

.mdi-grid-off::before {
  content: "\\f02c2";
}

.mdi-grill::before {
  content: "\\f0e45";
}

.mdi-grill-outline::before {
  content: "\\f118a";
}

.mdi-group::before {
  content: "\\f02c3";
}

.mdi-guitar-acoustic::before {
  content: "\\f0771";
}

.mdi-guitar-electric::before {
  content: "\\f02c4";
}

.mdi-guitar-pick::before {
  content: "\\f02c5";
}

.mdi-guitar-pick-outline::before {
  content: "\\f02c6";
}

.mdi-guy-fawkes-mask::before {
  content: "\\f0825";
}

.mdi-hail::before {
  content: "\\f0ac1";
}

.mdi-hair-dryer::before {
  content: "\\f10ef";
}

.mdi-hair-dryer-outline::before {
  content: "\\f10f0";
}

.mdi-halloween::before {
  content: "\\f0ba3";
}

.mdi-hamburger::before {
  content: "\\f0685";
}

.mdi-hammer::before {
  content: "\\f08ea";
}

.mdi-hammer-screwdriver::before {
  content: "\\f1322";
}

.mdi-hammer-wrench::before {
  content: "\\f1323";
}

.mdi-hand::before {
  content: "\\f0a4f";
}

.mdi-hand-heart::before {
  content: "\\f10f1";
}

.mdi-hand-left::before {
  content: "\\f0e46";
}

.mdi-hand-okay::before {
  content: "\\f0a50";
}

.mdi-hand-peace::before {
  content: "\\f0a51";
}

.mdi-hand-peace-variant::before {
  content: "\\f0a52";
}

.mdi-hand-pointing-down::before {
  content: "\\f0a53";
}

.mdi-hand-pointing-left::before {
  content: "\\f0a54";
}

.mdi-hand-pointing-right::before {
  content: "\\f02c7";
}

.mdi-hand-pointing-up::before {
  content: "\\f0a55";
}

.mdi-hand-right::before {
  content: "\\f0e47";
}

.mdi-hand-saw::before {
  content: "\\f0e48";
}

.mdi-hand-water::before {
  content: "\\f139f";
}

.mdi-handball::before {
  content: "\\f0f53";
}

.mdi-handcuffs::before {
  content: "\\f113e";
}

.mdi-handshake::before {
  content: "\\f1218";
}

.mdi-hanger::before {
  content: "\\f02c8";
}

.mdi-hard-hat::before {
  content: "\\f096f";
}

.mdi-harddisk::before {
  content: "\\f02ca";
}

.mdi-harddisk-plus::before {
  content: "\\f104b";
}

.mdi-harddisk-remove::before {
  content: "\\f104c";
}

.mdi-hat-fedora::before {
  content: "\\f0ba4";
}

.mdi-hazard-lights::before {
  content: "\\f0c89";
}

.mdi-hdr::before {
  content: "\\f0d7d";
}

.mdi-hdr-off::before {
  content: "\\f0d7e";
}

.mdi-head::before {
  content: "\\f135e";
}

.mdi-head-alert::before {
  content: "\\f1338";
}

.mdi-head-alert-outline::before {
  content: "\\f1339";
}

.mdi-head-check::before {
  content: "\\f133a";
}

.mdi-head-check-outline::before {
  content: "\\f133b";
}

.mdi-head-cog::before {
  content: "\\f133c";
}

.mdi-head-cog-outline::before {
  content: "\\f133d";
}

.mdi-head-dots-horizontal::before {
  content: "\\f133e";
}

.mdi-head-dots-horizontal-outline::before {
  content: "\\f133f";
}

.mdi-head-flash::before {
  content: "\\f1340";
}

.mdi-head-flash-outline::before {
  content: "\\f1341";
}

.mdi-head-heart::before {
  content: "\\f1342";
}

.mdi-head-heart-outline::before {
  content: "\\f1343";
}

.mdi-head-lightbulb::before {
  content: "\\f1344";
}

.mdi-head-lightbulb-outline::before {
  content: "\\f1345";
}

.mdi-head-minus::before {
  content: "\\f1346";
}

.mdi-head-minus-outline::before {
  content: "\\f1347";
}

.mdi-head-outline::before {
  content: "\\f135f";
}

.mdi-head-plus::before {
  content: "\\f1348";
}

.mdi-head-plus-outline::before {
  content: "\\f1349";
}

.mdi-head-question::before {
  content: "\\f134a";
}

.mdi-head-question-outline::before {
  content: "\\f134b";
}

.mdi-head-remove::before {
  content: "\\f134c";
}

.mdi-head-remove-outline::before {
  content: "\\f134d";
}

.mdi-head-snowflake::before {
  content: "\\f134e";
}

.mdi-head-snowflake-outline::before {
  content: "\\f134f";
}

.mdi-head-sync::before {
  content: "\\f1350";
}

.mdi-head-sync-outline::before {
  content: "\\f1351";
}

.mdi-headphones::before {
  content: "\\f02cb";
}

.mdi-headphones-bluetooth::before {
  content: "\\f0970";
}

.mdi-headphones-box::before {
  content: "\\f02cc";
}

.mdi-headphones-off::before {
  content: "\\f07ce";
}

.mdi-headphones-settings::before {
  content: "\\f02cd";
}

.mdi-headset::before {
  content: "\\f02ce";
}

.mdi-headset-dock::before {
  content: "\\f02cf";
}

.mdi-headset-off::before {
  content: "\\f02d0";
}

.mdi-heart::before {
  content: "\\f02d1";
}

.mdi-heart-box::before {
  content: "\\f02d2";
}

.mdi-heart-box-outline::before {
  content: "\\f02d3";
}

.mdi-heart-broken::before {
  content: "\\f02d4";
}

.mdi-heart-broken-outline::before {
  content: "\\f0d14";
}

.mdi-heart-circle::before {
  content: "\\f0971";
}

.mdi-heart-circle-outline::before {
  content: "\\f0972";
}

.mdi-heart-flash::before {
  content: "\\f0ef9";
}

.mdi-heart-half::before {
  content: "\\f06df";
}

.mdi-heart-half-full::before {
  content: "\\f06de";
}

.mdi-heart-half-outline::before {
  content: "\\f06e0";
}

.mdi-heart-multiple::before {
  content: "\\f0a56";
}

.mdi-heart-multiple-outline::before {
  content: "\\f0a57";
}

.mdi-heart-off::before {
  content: "\\f0759";
}

.mdi-heart-outline::before {
  content: "\\f02d5";
}

.mdi-heart-pulse::before {
  content: "\\f05f6";
}

.mdi-helicopter::before {
  content: "\\f0ac2";
}

.mdi-help::before {
  content: "\\f02d6";
}

.mdi-help-box::before {
  content: "\\f078b";
}

.mdi-help-circle::before {
  content: "\\f02d7";
}

.mdi-help-circle-outline::before {
  content: "\\f0625";
}

.mdi-help-network::before {
  content: "\\f06f5";
}

.mdi-help-network-outline::before {
  content: "\\f0c8a";
}

.mdi-help-rhombus::before {
  content: "\\f0ba5";
}

.mdi-help-rhombus-outline::before {
  content: "\\f0ba6";
}

.mdi-hexadecimal::before {
  content: "\\f12a7";
}

.mdi-hexagon::before {
  content: "\\f02d8";
}

.mdi-hexagon-multiple::before {
  content: "\\f06e1";
}

.mdi-hexagon-multiple-outline::before {
  content: "\\f10f2";
}

.mdi-hexagon-outline::before {
  content: "\\f02d9";
}

.mdi-hexagon-slice-1::before {
  content: "\\f0ac3";
}

.mdi-hexagon-slice-2::before {
  content: "\\f0ac4";
}

.mdi-hexagon-slice-3::before {
  content: "\\f0ac5";
}

.mdi-hexagon-slice-4::before {
  content: "\\f0ac6";
}

.mdi-hexagon-slice-5::before {
  content: "\\f0ac7";
}

.mdi-hexagon-slice-6::before {
  content: "\\f0ac8";
}

.mdi-hexagram::before {
  content: "\\f0ac9";
}

.mdi-hexagram-outline::before {
  content: "\\f0aca";
}

.mdi-high-definition::before {
  content: "\\f07cf";
}

.mdi-high-definition-box::before {
  content: "\\f0878";
}

.mdi-highway::before {
  content: "\\f05f7";
}

.mdi-hiking::before {
  content: "\\f0d7f";
}

.mdi-hinduism::before {
  content: "\\f0973";
}

.mdi-history::before {
  content: "\\f02da";
}

.mdi-hockey-puck::before {
  content: "\\f0879";
}

.mdi-hockey-sticks::before {
  content: "\\f087a";
}

.mdi-hololens::before {
  content: "\\f02db";
}

.mdi-home::before {
  content: "\\f02dc";
}

.mdi-home-account::before {
  content: "\\f0826";
}

.mdi-home-alert::before {
  content: "\\f087b";
}

.mdi-home-analytics::before {
  content: "\\f0eba";
}

.mdi-home-assistant::before {
  content: "\\f07d0";
}

.mdi-home-automation::before {
  content: "\\f07d1";
}

.mdi-home-circle::before {
  content: "\\f07d2";
}

.mdi-home-circle-outline::before {
  content: "\\f104d";
}

.mdi-home-city::before {
  content: "\\f0d15";
}

.mdi-home-city-outline::before {
  content: "\\f0d16";
}

.mdi-home-currency-usd::before {
  content: "\\f08af";
}

.mdi-home-edit::before {
  content: "\\f1159";
}

.mdi-home-edit-outline::before {
  content: "\\f115a";
}

.mdi-home-export-outline::before {
  content: "\\f0f9b";
}

.mdi-home-flood::before {
  content: "\\f0efa";
}

.mdi-home-floor-0::before {
  content: "\\f0dd2";
}

.mdi-home-floor-1::before {
  content: "\\f0d80";
}

.mdi-home-floor-2::before {
  content: "\\f0d81";
}

.mdi-home-floor-3::before {
  content: "\\f0d82";
}

.mdi-home-floor-a::before {
  content: "\\f0d83";
}

.mdi-home-floor-b::before {
  content: "\\f0d84";
}

.mdi-home-floor-g::before {
  content: "\\f0d85";
}

.mdi-home-floor-l::before {
  content: "\\f0d86";
}

.mdi-home-floor-negative-1::before {
  content: "\\f0dd3";
}

.mdi-home-group::before {
  content: "\\f0dd4";
}

.mdi-home-heart::before {
  content: "\\f0827";
}

.mdi-home-import-outline::before {
  content: "\\f0f9c";
}

.mdi-home-lightbulb::before {
  content: "\\f1251";
}

.mdi-home-lightbulb-outline::before {
  content: "\\f1252";
}

.mdi-home-lock::before {
  content: "\\f08eb";
}

.mdi-home-lock-open::before {
  content: "\\f08ec";
}

.mdi-home-map-marker::before {
  content: "\\f05f8";
}

.mdi-home-minus::before {
  content: "\\f0974";
}

.mdi-home-modern::before {
  content: "\\f02dd";
}

.mdi-home-outline::before {
  content: "\\f06a1";
}

.mdi-home-plus::before {
  content: "\\f0975";
}

.mdi-home-remove::before {
  content: "\\f1247";
}

.mdi-home-roof::before {
  content: "\\f112b";
}

.mdi-home-search::before {
  content: "\\f13b0";
}

.mdi-home-search-outline::before {
  content: "\\f13b1";
}

.mdi-home-thermometer::before {
  content: "\\f0f54";
}

.mdi-home-thermometer-outline::before {
  content: "\\f0f55";
}

.mdi-home-variant::before {
  content: "\\f02de";
}

.mdi-home-variant-outline::before {
  content: "\\f0ba7";
}

.mdi-hook::before {
  content: "\\f06e2";
}

.mdi-hook-off::before {
  content: "\\f06e3";
}

.mdi-hops::before {
  content: "\\f02df";
}

.mdi-horizontal-rotate-clockwise::before {
  content: "\\f10f3";
}

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\f10f4";
}

.mdi-horseshoe::before {
  content: "\\f0a58";
}

.mdi-hospital::before {
  content: "\\f0ff6";
}

.mdi-hospital-box::before {
  content: "\\f02e0";
}

.mdi-hospital-box-outline::before {
  content: "\\f0ff7";
}

.mdi-hospital-building::before {
  content: "\\f02e1";
}

.mdi-hospital-marker::before {
  content: "\\f02e2";
}

.mdi-hot-tub::before {
  content: "\\f0828";
}

.mdi-hubspot::before {
  content: "\\f0d17";
}

.mdi-hulu::before {
  content: "\\f0829";
}

.mdi-human::before {
  content: "\\f02e6";
}

.mdi-human-baby-changing-table::before {
  content: "\\f138b";
}

.mdi-human-child::before {
  content: "\\f02e7";
}

.mdi-human-female::before {
  content: "\\f0649";
}

.mdi-human-female-boy::before {
  content: "\\f0a59";
}

.mdi-human-female-female::before {
  content: "\\f0a5a";
}

.mdi-human-female-girl::before {
  content: "\\f0a5b";
}

.mdi-human-greeting::before {
  content: "\\f064a";
}

.mdi-human-handsdown::before {
  content: "\\f064b";
}

.mdi-human-handsup::before {
  content: "\\f064c";
}

.mdi-human-male::before {
  content: "\\f064d";
}

.mdi-human-male-boy::before {
  content: "\\f0a5c";
}

.mdi-human-male-child::before {
  content: "\\f138c";
}

.mdi-human-male-female::before {
  content: "\\f02e8";
}

.mdi-human-male-girl::before {
  content: "\\f0a5d";
}

.mdi-human-male-height::before {
  content: "\\f0efb";
}

.mdi-human-male-height-variant::before {
  content: "\\f0efc";
}

.mdi-human-male-male::before {
  content: "\\f0a5e";
}

.mdi-human-pregnant::before {
  content: "\\f05cf";
}

.mdi-human-wheelchair::before {
  content: "\\f138d";
}

.mdi-humble-bundle::before {
  content: "\\f0744";
}

.mdi-hvac::before {
  content: "\\f1352";
}

.mdi-hydraulic-oil-level::before {
  content: "\\f1324";
}

.mdi-hydraulic-oil-temperature::before {
  content: "\\f1325";
}

.mdi-hydro-power::before {
  content: "\\f12e5";
}

.mdi-ice-cream::before {
  content: "\\f082a";
}

.mdi-ice-cream-off::before {
  content: "\\f0e52";
}

.mdi-ice-pop::before {
  content: "\\f0efd";
}

.mdi-id-card::before {
  content: "\\f0fc0";
}

.mdi-identifier::before {
  content: "\\f0efe";
}

.mdi-ideogram-cjk::before {
  content: "\\f1331";
}

.mdi-ideogram-cjk-variant::before {
  content: "\\f1332";
}

.mdi-iframe::before {
  content: "\\f0c8b";
}

.mdi-iframe-array::before {
  content: "\\f10f5";
}

.mdi-iframe-array-outline::before {
  content: "\\f10f6";
}

.mdi-iframe-braces::before {
  content: "\\f10f7";
}

.mdi-iframe-braces-outline::before {
  content: "\\f10f8";
}

.mdi-iframe-outline::before {
  content: "\\f0c8c";
}

.mdi-iframe-parentheses::before {
  content: "\\f10f9";
}

.mdi-iframe-parentheses-outline::before {
  content: "\\f10fa";
}

.mdi-iframe-variable::before {
  content: "\\f10fb";
}

.mdi-iframe-variable-outline::before {
  content: "\\f10fc";
}

.mdi-image::before {
  content: "\\f02e9";
}

.mdi-image-album::before {
  content: "\\f02ea";
}

.mdi-image-area::before {
  content: "\\f02eb";
}

.mdi-image-area-close::before {
  content: "\\f02ec";
}

.mdi-image-auto-adjust::before {
  content: "\\f0fc1";
}

.mdi-image-broken::before {
  content: "\\f02ed";
}

.mdi-image-broken-variant::before {
  content: "\\f02ee";
}

.mdi-image-edit::before {
  content: "\\f11e3";
}

.mdi-image-edit-outline::before {
  content: "\\f11e4";
}

.mdi-image-filter-black-white::before {
  content: "\\f02f0";
}

.mdi-image-filter-center-focus::before {
  content: "\\f02f1";
}

.mdi-image-filter-center-focus-strong::before {
  content: "\\f0eff";
}

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\f0f00";
}

.mdi-image-filter-center-focus-weak::before {
  content: "\\f02f2";
}

.mdi-image-filter-drama::before {
  content: "\\f02f3";
}

.mdi-image-filter-frames::before {
  content: "\\f02f4";
}

.mdi-image-filter-hdr::before {
  content: "\\f02f5";
}

.mdi-image-filter-none::before {
  content: "\\f02f6";
}

.mdi-image-filter-tilt-shift::before {
  content: "\\f02f7";
}

.mdi-image-filter-vintage::before {
  content: "\\f02f8";
}

.mdi-image-frame::before {
  content: "\\f0e49";
}

.mdi-image-move::before {
  content: "\\f09f8";
}

.mdi-image-multiple::before {
  content: "\\f02f9";
}

.mdi-image-multiple-outline::before {
  content: "\\f02ef";
}

.mdi-image-off::before {
  content: "\\f082b";
}

.mdi-image-off-outline::before {
  content: "\\f11d1";
}

.mdi-image-outline::before {
  content: "\\f0976";
}

.mdi-image-plus::before {
  content: "\\f087c";
}

.mdi-image-search::before {
  content: "\\f0977";
}

.mdi-image-search-outline::before {
  content: "\\f0978";
}

.mdi-image-size-select-actual::before {
  content: "\\f0c8d";
}

.mdi-image-size-select-large::before {
  content: "\\f0c8e";
}

.mdi-image-size-select-small::before {
  content: "\\f0c8f";
}

.mdi-import::before {
  content: "\\f02fa";
}

.mdi-inbox::before {
  content: "\\f0687";
}

.mdi-inbox-arrow-down::before {
  content: "\\f02fb";
}

.mdi-inbox-arrow-down-outline::before {
  content: "\\f1270";
}

.mdi-inbox-arrow-up::before {
  content: "\\f03d1";
}

.mdi-inbox-arrow-up-outline::before {
  content: "\\f1271";
}

.mdi-inbox-full::before {
  content: "\\f1272";
}

.mdi-inbox-full-outline::before {
  content: "\\f1273";
}

.mdi-inbox-multiple::before {
  content: "\\f08b0";
}

.mdi-inbox-multiple-outline::before {
  content: "\\f0ba8";
}

.mdi-inbox-outline::before {
  content: "\\f1274";
}

.mdi-incognito::before {
  content: "\\f05f9";
}

.mdi-incognito-off::before {
  content: "\\f0075";
}

.mdi-infinity::before {
  content: "\\f06e4";
}

.mdi-information::before {
  content: "\\f02fc";
}

.mdi-information-outline::before {
  content: "\\f02fd";
}

.mdi-information-variant::before {
  content: "\\f064e";
}

.mdi-instagram::before {
  content: "\\f02fe";
}

.mdi-instrument-triangle::before {
  content: "\\f104e";
}

.mdi-invert-colors::before {
  content: "\\f0301";
}

.mdi-invert-colors-off::before {
  content: "\\f0e4a";
}

.mdi-iobroker::before {
  content: "\\f12e8";
}

.mdi-ip::before {
  content: "\\f0a5f";
}

.mdi-ip-network::before {
  content: "\\f0a60";
}

.mdi-ip-network-outline::before {
  content: "\\f0c90";
}

.mdi-ipod::before {
  content: "\\f0c91";
}

.mdi-islam::before {
  content: "\\f0979";
}

.mdi-island::before {
  content: "\\f104f";
}

.mdi-iv-bag::before {
  content: "\\f10b9";
}

.mdi-jabber::before {
  content: "\\f0dd5";
}

.mdi-jeepney::before {
  content: "\\f0302";
}

.mdi-jellyfish::before {
  content: "\\f0f01";
}

.mdi-jellyfish-outline::before {
  content: "\\f0f02";
}

.mdi-jira::before {
  content: "\\f0303";
}

.mdi-jquery::before {
  content: "\\f087d";
}

.mdi-jsfiddle::before {
  content: "\\f0304";
}

.mdi-judaism::before {
  content: "\\f097a";
}

.mdi-jump-rope::before {
  content: "\\f12ff";
}

.mdi-kabaddi::before {
  content: "\\f0d87";
}

.mdi-karate::before {
  content: "\\f082c";
}

.mdi-keg::before {
  content: "\\f0305";
}

.mdi-kettle::before {
  content: "\\f05fa";
}

.mdi-kettle-alert::before {
  content: "\\f1317";
}

.mdi-kettle-alert-outline::before {
  content: "\\f1318";
}

.mdi-kettle-off::before {
  content: "\\f131b";
}

.mdi-kettle-off-outline::before {
  content: "\\f131c";
}

.mdi-kettle-outline::before {
  content: "\\f0f56";
}

.mdi-kettle-steam::before {
  content: "\\f1319";
}

.mdi-kettle-steam-outline::before {
  content: "\\f131a";
}

.mdi-kettlebell::before {
  content: "\\f1300";
}

.mdi-key::before {
  content: "\\f0306";
}

.mdi-key-arrow-right::before {
  content: "\\f1312";
}

.mdi-key-change::before {
  content: "\\f0307";
}

.mdi-key-link::before {
  content: "\\f119f";
}

.mdi-key-minus::before {
  content: "\\f0308";
}

.mdi-key-outline::before {
  content: "\\f0dd6";
}

.mdi-key-plus::before {
  content: "\\f0309";
}

.mdi-key-remove::before {
  content: "\\f030a";
}

.mdi-key-star::before {
  content: "\\f119e";
}

.mdi-key-variant::before {
  content: "\\f030b";
}

.mdi-key-wireless::before {
  content: "\\f0fc2";
}

.mdi-keyboard::before {
  content: "\\f030c";
}

.mdi-keyboard-backspace::before {
  content: "\\f030d";
}

.mdi-keyboard-caps::before {
  content: "\\f030e";
}

.mdi-keyboard-close::before {
  content: "\\f030f";
}

.mdi-keyboard-esc::before {
  content: "\\f12b7";
}

.mdi-keyboard-f1::before {
  content: "\\f12ab";
}

.mdi-keyboard-f10::before {
  content: "\\f12b4";
}

.mdi-keyboard-f11::before {
  content: "\\f12b5";
}

.mdi-keyboard-f12::before {
  content: "\\f12b6";
}

.mdi-keyboard-f2::before {
  content: "\\f12ac";
}

.mdi-keyboard-f3::before {
  content: "\\f12ad";
}

.mdi-keyboard-f4::before {
  content: "\\f12ae";
}

.mdi-keyboard-f5::before {
  content: "\\f12af";
}

.mdi-keyboard-f6::before {
  content: "\\f12b0";
}

.mdi-keyboard-f7::before {
  content: "\\f12b1";
}

.mdi-keyboard-f8::before {
  content: "\\f12b2";
}

.mdi-keyboard-f9::before {
  content: "\\f12b3";
}

.mdi-keyboard-off::before {
  content: "\\f0310";
}

.mdi-keyboard-off-outline::before {
  content: "\\f0e4b";
}

.mdi-keyboard-outline::before {
  content: "\\f097b";
}

.mdi-keyboard-return::before {
  content: "\\f0311";
}

.mdi-keyboard-settings::before {
  content: "\\f09f9";
}

.mdi-keyboard-settings-outline::before {
  content: "\\f09fa";
}

.mdi-keyboard-space::before {
  content: "\\f1050";
}

.mdi-keyboard-tab::before {
  content: "\\f0312";
}

.mdi-keyboard-variant::before {
  content: "\\f0313";
}

.mdi-khanda::before {
  content: "\\f10fd";
}

.mdi-kickstarter::before {
  content: "\\f0745";
}

.mdi-klingon::before {
  content: "\\f135b";
}

.mdi-knife::before {
  content: "\\f09fb";
}

.mdi-knife-military::before {
  content: "\\f09fc";
}

.mdi-kodi::before {
  content: "\\f0314";
}

.mdi-kubernetes::before {
  content: "\\f10fe";
}

.mdi-label::before {
  content: "\\f0315";
}

.mdi-label-multiple::before {
  content: "\\f1375";
}

.mdi-label-multiple-outline::before {
  content: "\\f1376";
}

.mdi-label-off::before {
  content: "\\f0acb";
}

.mdi-label-off-outline::before {
  content: "\\f0acc";
}

.mdi-label-outline::before {
  content: "\\f0316";
}

.mdi-label-percent::before {
  content: "\\f12ea";
}

.mdi-label-percent-outline::before {
  content: "\\f12eb";
}

.mdi-label-variant::before {
  content: "\\f0acd";
}

.mdi-label-variant-outline::before {
  content: "\\f0ace";
}

.mdi-ladybug::before {
  content: "\\f082d";
}

.mdi-lambda::before {
  content: "\\f0627";
}

.mdi-lamp::before {
  content: "\\f06b5";
}

.mdi-lan::before {
  content: "\\f0317";
}

.mdi-lan-check::before {
  content: "\\f12aa";
}

.mdi-lan-connect::before {
  content: "\\f0318";
}

.mdi-lan-disconnect::before {
  content: "\\f0319";
}

.mdi-lan-pending::before {
  content: "\\f031a";
}

.mdi-language-c::before {
  content: "\\f0671";
}

.mdi-language-cpp::before {
  content: "\\f0672";
}

.mdi-language-csharp::before {
  content: "\\f031b";
}

.mdi-language-css3::before {
  content: "\\f031c";
}

.mdi-language-fortran::before {
  content: "\\f121a";
}

.mdi-language-go::before {
  content: "\\f07d3";
}

.mdi-language-haskell::before {
  content: "\\f0c92";
}

.mdi-language-html5::before {
  content: "\\f031d";
}

.mdi-language-java::before {
  content: "\\f0b37";
}

.mdi-language-javascript::before {
  content: "\\f031e";
}

.mdi-language-kotlin::before {
  content: "\\f1219";
}

.mdi-language-lua::before {
  content: "\\f08b1";
}

.mdi-language-markdown::before {
  content: "\\f0354";
}

.mdi-language-markdown-outline::before {
  content: "\\f0f5b";
}

.mdi-language-php::before {
  content: "\\f031f";
}

.mdi-language-python::before {
  content: "\\f0320";
}

.mdi-language-r::before {
  content: "\\f07d4";
}

.mdi-language-ruby::before {
  content: "\\f0d2d";
}

.mdi-language-ruby-on-rails::before {
  content: "\\f0acf";
}

.mdi-language-swift::before {
  content: "\\f06e5";
}

.mdi-language-typescript::before {
  content: "\\f06e6";
}

.mdi-language-xaml::before {
  content: "\\f0673";
}

.mdi-laptop::before {
  content: "\\f0322";
}

.mdi-laptop-chromebook::before {
  content: "\\f0323";
}

.mdi-laptop-mac::before {
  content: "\\f0324";
}

.mdi-laptop-off::before {
  content: "\\f06e7";
}

.mdi-laptop-windows::before {
  content: "\\f0325";
}

.mdi-laravel::before {
  content: "\\f0ad0";
}

.mdi-lasso::before {
  content: "\\f0f03";
}

.mdi-lastpass::before {
  content: "\\f0446";
}

.mdi-latitude::before {
  content: "\\f0f57";
}

.mdi-launch::before {
  content: "\\f0327";
}

.mdi-lava-lamp::before {
  content: "\\f07d5";
}

.mdi-layers::before {
  content: "\\f0328";
}

.mdi-layers-minus::before {
  content: "\\f0e4c";
}

.mdi-layers-off::before {
  content: "\\f0329";
}

.mdi-layers-off-outline::before {
  content: "\\f09fd";
}

.mdi-layers-outline::before {
  content: "\\f09fe";
}

.mdi-layers-plus::before {
  content: "\\f0e4d";
}

.mdi-layers-remove::before {
  content: "\\f0e4e";
}

.mdi-layers-search::before {
  content: "\\f1206";
}

.mdi-layers-search-outline::before {
  content: "\\f1207";
}

.mdi-layers-triple::before {
  content: "\\f0f58";
}

.mdi-layers-triple-outline::before {
  content: "\\f0f59";
}

.mdi-lead-pencil::before {
  content: "\\f064f";
}

.mdi-leaf::before {
  content: "\\f032a";
}

.mdi-leaf-maple::before {
  content: "\\f0c93";
}

.mdi-leaf-maple-off::before {
  content: "\\f12da";
}

.mdi-leaf-off::before {
  content: "\\f12d9";
}

.mdi-leak::before {
  content: "\\f0dd7";
}

.mdi-leak-off::before {
  content: "\\f0dd8";
}

.mdi-led-off::before {
  content: "\\f032b";
}

.mdi-led-on::before {
  content: "\\f032c";
}

.mdi-led-outline::before {
  content: "\\f032d";
}

.mdi-led-strip::before {
  content: "\\f07d6";
}

.mdi-led-strip-variant::before {
  content: "\\f1051";
}

.mdi-led-variant-off::before {
  content: "\\f032e";
}

.mdi-led-variant-on::before {
  content: "\\f032f";
}

.mdi-led-variant-outline::before {
  content: "\\f0330";
}

.mdi-leek::before {
  content: "\\f117d";
}

.mdi-less-than::before {
  content: "\\f097c";
}

.mdi-less-than-or-equal::before {
  content: "\\f097d";
}

.mdi-library::before {
  content: "\\f0331";
}

.mdi-library-shelves::before {
  content: "\\f0ba9";
}

.mdi-license::before {
  content: "\\f0fc3";
}

.mdi-lifebuoy::before {
  content: "\\f087e";
}

.mdi-light-switch::before {
  content: "\\f097e";
}

.mdi-lightbulb::before {
  content: "\\f0335";
}

.mdi-lightbulb-cfl::before {
  content: "\\f1208";
}

.mdi-lightbulb-cfl-off::before {
  content: "\\f1209";
}

.mdi-lightbulb-cfl-spiral::before {
  content: "\\f1275";
}

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\f12c3";
}

.mdi-lightbulb-group::before {
  content: "\\f1253";
}

.mdi-lightbulb-group-off::before {
  content: "\\f12cd";
}

.mdi-lightbulb-group-off-outline::before {
  content: "\\f12ce";
}

.mdi-lightbulb-group-outline::before {
  content: "\\f1254";
}

.mdi-lightbulb-multiple::before {
  content: "\\f1255";
}

.mdi-lightbulb-multiple-off::before {
  content: "\\f12cf";
}

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\f12d0";
}

.mdi-lightbulb-multiple-outline::before {
  content: "\\f1256";
}

.mdi-lightbulb-off::before {
  content: "\\f0e4f";
}

.mdi-lightbulb-off-outline::before {
  content: "\\f0e50";
}

.mdi-lightbulb-on::before {
  content: "\\f06e8";
}

.mdi-lightbulb-on-outline::before {
  content: "\\f06e9";
}

.mdi-lightbulb-outline::before {
  content: "\\f0336";
}

.mdi-lighthouse::before {
  content: "\\f09ff";
}

.mdi-lighthouse-on::before {
  content: "\\f0a00";
}

.mdi-link::before {
  content: "\\f0337";
}

.mdi-link-box::before {
  content: "\\f0d1a";
}

.mdi-link-box-outline::before {
  content: "\\f0d1b";
}

.mdi-link-box-variant::before {
  content: "\\f0d1c";
}

.mdi-link-box-variant-outline::before {
  content: "\\f0d1d";
}

.mdi-link-lock::before {
  content: "\\f10ba";
}

.mdi-link-off::before {
  content: "\\f0338";
}

.mdi-link-plus::before {
  content: "\\f0c94";
}

.mdi-link-variant::before {
  content: "\\f0339";
}

.mdi-link-variant-minus::before {
  content: "\\f10ff";
}

.mdi-link-variant-off::before {
  content: "\\f033a";
}

.mdi-link-variant-plus::before {
  content: "\\f1100";
}

.mdi-link-variant-remove::before {
  content: "\\f1101";
}

.mdi-linkedin::before {
  content: "\\f033b";
}

.mdi-linux::before {
  content: "\\f033d";
}

.mdi-linux-mint::before {
  content: "\\f08ed";
}

.mdi-lipstick::before {
  content: "\\f13b5";
}

.mdi-litecoin::before {
  content: "\\f0a61";
}

.mdi-loading::before {
  content: "\\f0772";
}

.mdi-location-enter::before {
  content: "\\f0fc4";
}

.mdi-location-exit::before {
  content: "\\f0fc5";
}

.mdi-lock::before {
  content: "\\f033e";
}

.mdi-lock-alert::before {
  content: "\\f08ee";
}

.mdi-lock-check::before {
  content: "\\f139a";
}

.mdi-lock-clock::before {
  content: "\\f097f";
}

.mdi-lock-open::before {
  content: "\\f033f";
}

.mdi-lock-open-alert::before {
  content: "\\f139b";
}

.mdi-lock-open-check::before {
  content: "\\f139c";
}

.mdi-lock-open-outline::before {
  content: "\\f0340";
}

.mdi-lock-open-variant::before {
  content: "\\f0fc6";
}

.mdi-lock-open-variant-outline::before {
  content: "\\f0fc7";
}

.mdi-lock-outline::before {
  content: "\\f0341";
}

.mdi-lock-pattern::before {
  content: "\\f06ea";
}

.mdi-lock-plus::before {
  content: "\\f05fb";
}

.mdi-lock-question::before {
  content: "\\f08ef";
}

.mdi-lock-reset::before {
  content: "\\f0773";
}

.mdi-lock-smart::before {
  content: "\\f08b2";
}

.mdi-locker::before {
  content: "\\f07d7";
}

.mdi-locker-multiple::before {
  content: "\\f07d8";
}

.mdi-login::before {
  content: "\\f0342";
}

.mdi-login-variant::before {
  content: "\\f05fc";
}

.mdi-logout::before {
  content: "\\f0343";
}

.mdi-logout-variant::before {
  content: "\\f05fd";
}

.mdi-longitude::before {
  content: "\\f0f5a";
}

.mdi-looks::before {
  content: "\\f0344";
}

.mdi-loupe::before {
  content: "\\f0345";
}

.mdi-lumx::before {
  content: "\\f0346";
}

.mdi-lungs::before {
  content: "\\f1084";
}

.mdi-magnet::before {
  content: "\\f0347";
}

.mdi-magnet-on::before {
  content: "\\f0348";
}

.mdi-magnify::before {
  content: "\\f0349";
}

.mdi-magnify-close::before {
  content: "\\f0980";
}

.mdi-magnify-minus::before {
  content: "\\f034a";
}

.mdi-magnify-minus-cursor::before {
  content: "\\f0a62";
}

.mdi-magnify-minus-outline::before {
  content: "\\f06ec";
}

.mdi-magnify-plus::before {
  content: "\\f034b";
}

.mdi-magnify-plus-cursor::before {
  content: "\\f0a63";
}

.mdi-magnify-plus-outline::before {
  content: "\\f06ed";
}

.mdi-magnify-remove-cursor::before {
  content: "\\f120c";
}

.mdi-magnify-remove-outline::before {
  content: "\\f120d";
}

.mdi-magnify-scan::before {
  content: "\\f1276";
}

.mdi-mail::before {
  content: "\\f0ebb";
}

.mdi-mailbox::before {
  content: "\\f06ee";
}

.mdi-mailbox-open::before {
  content: "\\f0d88";
}

.mdi-mailbox-open-outline::before {
  content: "\\f0d89";
}

.mdi-mailbox-open-up::before {
  content: "\\f0d8a";
}

.mdi-mailbox-open-up-outline::before {
  content: "\\f0d8b";
}

.mdi-mailbox-outline::before {
  content: "\\f0d8c";
}

.mdi-mailbox-up::before {
  content: "\\f0d8d";
}

.mdi-mailbox-up-outline::before {
  content: "\\f0d8e";
}

.mdi-map::before {
  content: "\\f034d";
}

.mdi-map-check::before {
  content: "\\f0ebc";
}

.mdi-map-check-outline::before {
  content: "\\f0ebd";
}

.mdi-map-clock::before {
  content: "\\f0d1e";
}

.mdi-map-clock-outline::before {
  content: "\\f0d1f";
}

.mdi-map-legend::before {
  content: "\\f0a01";
}

.mdi-map-marker::before {
  content: "\\f034e";
}

.mdi-map-marker-alert::before {
  content: "\\f0f05";
}

.mdi-map-marker-alert-outline::before {
  content: "\\f0f06";
}

.mdi-map-marker-check::before {
  content: "\\f0c95";
}

.mdi-map-marker-check-outline::before {
  content: "\\f12fb";
}

.mdi-map-marker-circle::before {
  content: "\\f034f";
}

.mdi-map-marker-distance::before {
  content: "\\f08f0";
}

.mdi-map-marker-down::before {
  content: "\\f1102";
}

.mdi-map-marker-left::before {
  content: "\\f12db";
}

.mdi-map-marker-left-outline::before {
  content: "\\f12dd";
}

.mdi-map-marker-minus::before {
  content: "\\f0650";
}

.mdi-map-marker-minus-outline::before {
  content: "\\f12f9";
}

.mdi-map-marker-multiple::before {
  content: "\\f0350";
}

.mdi-map-marker-multiple-outline::before {
  content: "\\f1277";
}

.mdi-map-marker-off::before {
  content: "\\f0351";
}

.mdi-map-marker-off-outline::before {
  content: "\\f12fd";
}

.mdi-map-marker-outline::before {
  content: "\\f07d9";
}

.mdi-map-marker-path::before {
  content: "\\f0d20";
}

.mdi-map-marker-plus::before {
  content: "\\f0651";
}

.mdi-map-marker-plus-outline::before {
  content: "\\f12f8";
}

.mdi-map-marker-question::before {
  content: "\\f0f07";
}

.mdi-map-marker-question-outline::before {
  content: "\\f0f08";
}

.mdi-map-marker-radius::before {
  content: "\\f0352";
}

.mdi-map-marker-radius-outline::before {
  content: "\\f12fc";
}

.mdi-map-marker-remove::before {
  content: "\\f0f09";
}

.mdi-map-marker-remove-outline::before {
  content: "\\f12fa";
}

.mdi-map-marker-remove-variant::before {
  content: "\\f0f0a";
}

.mdi-map-marker-right::before {
  content: "\\f12dc";
}

.mdi-map-marker-right-outline::before {
  content: "\\f12de";
}

.mdi-map-marker-up::before {
  content: "\\f1103";
}

.mdi-map-minus::before {
  content: "\\f0981";
}

.mdi-map-outline::before {
  content: "\\f0982";
}

.mdi-map-plus::before {
  content: "\\f0983";
}

.mdi-map-search::before {
  content: "\\f0984";
}

.mdi-map-search-outline::before {
  content: "\\f0985";
}

.mdi-mapbox::before {
  content: "\\f0baa";
}

.mdi-margin::before {
  content: "\\f0353";
}

.mdi-marker::before {
  content: "\\f0652";
}

.mdi-marker-cancel::before {
  content: "\\f0dd9";
}

.mdi-marker-check::before {
  content: "\\f0355";
}

.mdi-mastodon::before {
  content: "\\f0ad1";
}

.mdi-material-design::before {
  content: "\\f0986";
}

.mdi-material-ui::before {
  content: "\\f0357";
}

.mdi-math-compass::before {
  content: "\\f0358";
}

.mdi-math-cos::before {
  content: "\\f0c96";
}

.mdi-math-integral::before {
  content: "\\f0fc8";
}

.mdi-math-integral-box::before {
  content: "\\f0fc9";
}

.mdi-math-log::before {
  content: "\\f1085";
}

.mdi-math-norm::before {
  content: "\\f0fca";
}

.mdi-math-norm-box::before {
  content: "\\f0fcb";
}

.mdi-math-sin::before {
  content: "\\f0c97";
}

.mdi-math-tan::before {
  content: "\\f0c98";
}

.mdi-matrix::before {
  content: "\\f0628";
}

.mdi-medal::before {
  content: "\\f0987";
}

.mdi-medal-outline::before {
  content: "\\f1326";
}

.mdi-medical-bag::before {
  content: "\\f06ef";
}

.mdi-meditation::before {
  content: "\\f117b";
}

.mdi-memory::before {
  content: "\\f035b";
}

.mdi-menu::before {
  content: "\\f035c";
}

.mdi-menu-down::before {
  content: "\\f035d";
}

.mdi-menu-down-outline::before {
  content: "\\f06b6";
}

.mdi-menu-left::before {
  content: "\\f035e";
}

.mdi-menu-left-outline::before {
  content: "\\f0a02";
}

.mdi-menu-open::before {
  content: "\\f0bab";
}

.mdi-menu-right::before {
  content: "\\f035f";
}

.mdi-menu-right-outline::before {
  content: "\\f0a03";
}

.mdi-menu-swap::before {
  content: "\\f0a64";
}

.mdi-menu-swap-outline::before {
  content: "\\f0a65";
}

.mdi-menu-up::before {
  content: "\\f0360";
}

.mdi-menu-up-outline::before {
  content: "\\f06b7";
}

.mdi-merge::before {
  content: "\\f0f5c";
}

.mdi-message::before {
  content: "\\f0361";
}

.mdi-message-alert::before {
  content: "\\f0362";
}

.mdi-message-alert-outline::before {
  content: "\\f0a04";
}

.mdi-message-arrow-left::before {
  content: "\\f12f2";
}

.mdi-message-arrow-left-outline::before {
  content: "\\f12f3";
}

.mdi-message-arrow-right::before {
  content: "\\f12f4";
}

.mdi-message-arrow-right-outline::before {
  content: "\\f12f5";
}

.mdi-message-bulleted::before {
  content: "\\f06a2";
}

.mdi-message-bulleted-off::before {
  content: "\\f06a3";
}

.mdi-message-cog::before {
  content: "\\f06f1";
}

.mdi-message-cog-outline::before {
  content: "\\f1172";
}

.mdi-message-draw::before {
  content: "\\f0363";
}

.mdi-message-image::before {
  content: "\\f0364";
}

.mdi-message-image-outline::before {
  content: "\\f116c";
}

.mdi-message-lock::before {
  content: "\\f0fcc";
}

.mdi-message-lock-outline::before {
  content: "\\f116d";
}

.mdi-message-minus::before {
  content: "\\f116e";
}

.mdi-message-minus-outline::before {
  content: "\\f116f";
}

.mdi-message-outline::before {
  content: "\\f0365";
}

.mdi-message-plus::before {
  content: "\\f0653";
}

.mdi-message-plus-outline::before {
  content: "\\f10bb";
}

.mdi-message-processing::before {
  content: "\\f0366";
}

.mdi-message-processing-outline::before {
  content: "\\f1170";
}

.mdi-message-reply::before {
  content: "\\f0367";
}

.mdi-message-reply-text::before {
  content: "\\f0368";
}

.mdi-message-settings::before {
  content: "\\f06f0";
}

.mdi-message-settings-outline::before {
  content: "\\f1171";
}

.mdi-message-text::before {
  content: "\\f0369";
}

.mdi-message-text-clock::before {
  content: "\\f1173";
}

.mdi-message-text-clock-outline::before {
  content: "\\f1174";
}

.mdi-message-text-lock::before {
  content: "\\f0fcd";
}

.mdi-message-text-lock-outline::before {
  content: "\\f1175";
}

.mdi-message-text-outline::before {
  content: "\\f036a";
}

.mdi-message-video::before {
  content: "\\f036b";
}

.mdi-meteor::before {
  content: "\\f0629";
}

.mdi-metronome::before {
  content: "\\f07da";
}

.mdi-metronome-tick::before {
  content: "\\f07db";
}

.mdi-micro-sd::before {
  content: "\\f07dc";
}

.mdi-microphone::before {
  content: "\\f036c";
}

.mdi-microphone-minus::before {
  content: "\\f08b3";
}

.mdi-microphone-off::before {
  content: "\\f036d";
}

.mdi-microphone-outline::before {
  content: "\\f036e";
}

.mdi-microphone-plus::before {
  content: "\\f08b4";
}

.mdi-microphone-settings::before {
  content: "\\f036f";
}

.mdi-microphone-variant::before {
  content: "\\f0370";
}

.mdi-microphone-variant-off::before {
  content: "\\f0371";
}

.mdi-microscope::before {
  content: "\\f0654";
}

.mdi-microsoft::before {
  content: "\\f0372";
}

.mdi-microsoft-access::before {
  content: "\\f138e";
}

.mdi-microsoft-azure::before {
  content: "\\f0805";
}

.mdi-microsoft-azure-devops::before {
  content: "\\f0fd5";
}

.mdi-microsoft-bing::before {
  content: "\\f00a4";
}

.mdi-microsoft-dynamics-365::before {
  content: "\\f0988";
}

.mdi-microsoft-edge::before {
  content: "\\f01e9";
}

.mdi-microsoft-edge-legacy::before {
  content: "\\f1250";
}

.mdi-microsoft-excel::before {
  content: "\\f138f";
}

.mdi-microsoft-internet-explorer::before {
  content: "\\f0300";
}

.mdi-microsoft-office::before {
  content: "\\f03c6";
}

.mdi-microsoft-onedrive::before {
  content: "\\f03ca";
}

.mdi-microsoft-onenote::before {
  content: "\\f0747";
}

.mdi-microsoft-outlook::before {
  content: "\\f0d22";
}

.mdi-microsoft-powerpoint::before {
  content: "\\f1390";
}

.mdi-microsoft-sharepoint::before {
  content: "\\f1391";
}

.mdi-microsoft-teams::before {
  content: "\\f02bb";
}

.mdi-microsoft-visual-studio::before {
  content: "\\f0610";
}

.mdi-microsoft-visual-studio-code::before {
  content: "\\f0a1e";
}

.mdi-microsoft-windows::before {
  content: "\\f05b3";
}

.mdi-microsoft-windows-classic::before {
  content: "\\f0a21";
}

.mdi-microsoft-word::before {
  content: "\\f1392";
}

.mdi-microsoft-xbox::before {
  content: "\\f05b9";
}

.mdi-microsoft-xbox-controller::before {
  content: "\\f05ba";
}

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\f074b";
}

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\f0a22";
}

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\f074c";
}

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\f074d";
}

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\f074e";
}

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\f074f";
}

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\f0750";
}

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\f0e6f";
}

.mdi-microsoft-xbox-controller-off::before {
  content: "\\f05bb";
}

.mdi-microsoft-xbox-controller-view::before {
  content: "\\f0e70";
}

.mdi-microsoft-yammer::before {
  content: "\\f0789";
}

.mdi-microwave::before {
  content: "\\f0c99";
}

.mdi-middleware::before {
  content: "\\f0f5d";
}

.mdi-middleware-outline::before {
  content: "\\f0f5e";
}

.mdi-midi::before {
  content: "\\f08f1";
}

.mdi-midi-port::before {
  content: "\\f08f2";
}

.mdi-mine::before {
  content: "\\f0dda";
}

.mdi-minecraft::before {
  content: "\\f0373";
}

.mdi-mini-sd::before {
  content: "\\f0a05";
}

.mdi-minidisc::before {
  content: "\\f0a06";
}

.mdi-minus::before {
  content: "\\f0374";
}

.mdi-minus-box::before {
  content: "\\f0375";
}

.mdi-minus-box-multiple::before {
  content: "\\f1141";
}

.mdi-minus-box-multiple-outline::before {
  content: "\\f1142";
}

.mdi-minus-box-outline::before {
  content: "\\f06f2";
}

.mdi-minus-circle::before {
  content: "\\f0376";
}

.mdi-minus-circle-multiple::before {
  content: "\\f035a";
}

.mdi-minus-circle-multiple-outline::before {
  content: "\\f0ad3";
}

.mdi-minus-circle-outline::before {
  content: "\\f0377";
}

.mdi-minus-network::before {
  content: "\\f0378";
}

.mdi-minus-network-outline::before {
  content: "\\f0c9a";
}

.mdi-mirror::before {
  content: "\\f11fd";
}

.mdi-mixed-martial-arts::before {
  content: "\\f0d8f";
}

.mdi-mixed-reality::before {
  content: "\\f087f";
}

.mdi-mixer::before {
  content: "\\f07dd";
}

.mdi-molecule::before {
  content: "\\f0bac";
}

.mdi-molecule-co::before {
  content: "\\f12fe";
}

.mdi-molecule-co2::before {
  content: "\\f07e4";
}

.mdi-monitor::before {
  content: "\\f0379";
}

.mdi-monitor-cellphone::before {
  content: "\\f0989";
}

.mdi-monitor-cellphone-star::before {
  content: "\\f098a";
}

.mdi-monitor-clean::before {
  content: "\\f1104";
}

.mdi-monitor-dashboard::before {
  content: "\\f0a07";
}

.mdi-monitor-edit::before {
  content: "\\f12c6";
}

.mdi-monitor-eye::before {
  content: "\\f13b4";
}

.mdi-monitor-lock::before {
  content: "\\f0ddb";
}

.mdi-monitor-multiple::before {
  content: "\\f037a";
}

.mdi-monitor-off::before {
  content: "\\f0d90";
}

.mdi-monitor-screenshot::before {
  content: "\\f0e51";
}

.mdi-monitor-speaker::before {
  content: "\\f0f5f";
}

.mdi-monitor-speaker-off::before {
  content: "\\f0f60";
}

.mdi-monitor-star::before {
  content: "\\f0ddc";
}

.mdi-moon-first-quarter::before {
  content: "\\f0f61";
}

.mdi-moon-full::before {
  content: "\\f0f62";
}

.mdi-moon-last-quarter::before {
  content: "\\f0f63";
}

.mdi-moon-new::before {
  content: "\\f0f64";
}

.mdi-moon-waning-crescent::before {
  content: "\\f0f65";
}

.mdi-moon-waning-gibbous::before {
  content: "\\f0f66";
}

.mdi-moon-waxing-crescent::before {
  content: "\\f0f67";
}

.mdi-moon-waxing-gibbous::before {
  content: "\\f0f68";
}

.mdi-moped::before {
  content: "\\f1086";
}

.mdi-more::before {
  content: "\\f037b";
}

.mdi-mother-heart::before {
  content: "\\f1314";
}

.mdi-mother-nurse::before {
  content: "\\f0d21";
}

.mdi-motion-sensor::before {
  content: "\\f0d91";
}

.mdi-motorbike::before {
  content: "\\f037c";
}

.mdi-mouse::before {
  content: "\\f037d";
}

.mdi-mouse-bluetooth::before {
  content: "\\f098b";
}

.mdi-mouse-off::before {
  content: "\\f037e";
}

.mdi-mouse-variant::before {
  content: "\\f037f";
}

.mdi-mouse-variant-off::before {
  content: "\\f0380";
}

.mdi-move-resize::before {
  content: "\\f0655";
}

.mdi-move-resize-variant::before {
  content: "\\f0656";
}

.mdi-movie::before {
  content: "\\f0381";
}

.mdi-movie-edit::before {
  content: "\\f1122";
}

.mdi-movie-edit-outline::before {
  content: "\\f1123";
}

.mdi-movie-filter::before {
  content: "\\f1124";
}

.mdi-movie-filter-outline::before {
  content: "\\f1125";
}

.mdi-movie-open::before {
  content: "\\f0fce";
}

.mdi-movie-open-outline::before {
  content: "\\f0fcf";
}

.mdi-movie-outline::before {
  content: "\\f0ddd";
}

.mdi-movie-roll::before {
  content: "\\f07de";
}

.mdi-movie-search::before {
  content: "\\f11d2";
}

.mdi-movie-search-outline::before {
  content: "\\f11d3";
}

.mdi-muffin::before {
  content: "\\f098c";
}

.mdi-multiplication::before {
  content: "\\f0382";
}

.mdi-multiplication-box::before {
  content: "\\f0383";
}

.mdi-mushroom::before {
  content: "\\f07df";
}

.mdi-mushroom-outline::before {
  content: "\\f07e0";
}

.mdi-music::before {
  content: "\\f075a";
}

.mdi-music-accidental-double-flat::before {
  content: "\\f0f69";
}

.mdi-music-accidental-double-sharp::before {
  content: "\\f0f6a";
}

.mdi-music-accidental-flat::before {
  content: "\\f0f6b";
}

.mdi-music-accidental-natural::before {
  content: "\\f0f6c";
}

.mdi-music-accidental-sharp::before {
  content: "\\f0f6d";
}

.mdi-music-box::before {
  content: "\\f0384";
}

.mdi-music-box-multiple::before {
  content: "\\f0333";
}

.mdi-music-box-multiple-outline::before {
  content: "\\f0f04";
}

.mdi-music-box-outline::before {
  content: "\\f0385";
}

.mdi-music-circle::before {
  content: "\\f0386";
}

.mdi-music-circle-outline::before {
  content: "\\f0ad4";
}

.mdi-music-clef-alto::before {
  content: "\\f0f6e";
}

.mdi-music-clef-bass::before {
  content: "\\f0f6f";
}

.mdi-music-clef-treble::before {
  content: "\\f0f70";
}

.mdi-music-note::before {
  content: "\\f0387";
}

.mdi-music-note-bluetooth::before {
  content: "\\f05fe";
}

.mdi-music-note-bluetooth-off::before {
  content: "\\f05ff";
}

.mdi-music-note-eighth::before {
  content: "\\f0388";
}

.mdi-music-note-eighth-dotted::before {
  content: "\\f0f71";
}

.mdi-music-note-half::before {
  content: "\\f0389";
}

.mdi-music-note-half-dotted::before {
  content: "\\f0f72";
}

.mdi-music-note-off::before {
  content: "\\f038a";
}

.mdi-music-note-off-outline::before {
  content: "\\f0f73";
}

.mdi-music-note-outline::before {
  content: "\\f0f74";
}

.mdi-music-note-plus::before {
  content: "\\f0dde";
}

.mdi-music-note-quarter::before {
  content: "\\f038b";
}

.mdi-music-note-quarter-dotted::before {
  content: "\\f0f75";
}

.mdi-music-note-sixteenth::before {
  content: "\\f038c";
}

.mdi-music-note-sixteenth-dotted::before {
  content: "\\f0f76";
}

.mdi-music-note-whole::before {
  content: "\\f038d";
}

.mdi-music-note-whole-dotted::before {
  content: "\\f0f77";
}

.mdi-music-off::before {
  content: "\\f075b";
}

.mdi-music-rest-eighth::before {
  content: "\\f0f78";
}

.mdi-music-rest-half::before {
  content: "\\f0f79";
}

.mdi-music-rest-quarter::before {
  content: "\\f0f7a";
}

.mdi-music-rest-sixteenth::before {
  content: "\\f0f7b";
}

.mdi-music-rest-whole::before {
  content: "\\f0f7c";
}

.mdi-nail::before {
  content: "\\f0ddf";
}

.mdi-nas::before {
  content: "\\f08f3";
}

.mdi-nativescript::before {
  content: "\\f0880";
}

.mdi-nature::before {
  content: "\\f038e";
}

.mdi-nature-people::before {
  content: "\\f038f";
}

.mdi-navigation::before {
  content: "\\f0390";
}

.mdi-near-me::before {
  content: "\\f05cd";
}

.mdi-necklace::before {
  content: "\\f0f0b";
}

.mdi-needle::before {
  content: "\\f0391";
}

.mdi-netflix::before {
  content: "\\f0746";
}

.mdi-network::before {
  content: "\\f06f3";
}

.mdi-network-off::before {
  content: "\\f0c9b";
}

.mdi-network-off-outline::before {
  content: "\\f0c9c";
}

.mdi-network-outline::before {
  content: "\\f0c9d";
}

.mdi-network-strength-1::before {
  content: "\\f08f4";
}

.mdi-network-strength-1-alert::before {
  content: "\\f08f5";
}

.mdi-network-strength-2::before {
  content: "\\f08f6";
}

.mdi-network-strength-2-alert::before {
  content: "\\f08f7";
}

.mdi-network-strength-3::before {
  content: "\\f08f8";
}

.mdi-network-strength-3-alert::before {
  content: "\\f08f9";
}

.mdi-network-strength-4::before {
  content: "\\f08fa";
}

.mdi-network-strength-4-alert::before {
  content: "\\f08fb";
}

.mdi-network-strength-off::before {
  content: "\\f08fc";
}

.mdi-network-strength-off-outline::before {
  content: "\\f08fd";
}

.mdi-network-strength-outline::before {
  content: "\\f08fe";
}

.mdi-new-box::before {
  content: "\\f0394";
}

.mdi-newspaper::before {
  content: "\\f0395";
}

.mdi-newspaper-minus::before {
  content: "\\f0f0c";
}

.mdi-newspaper-plus::before {
  content: "\\f0f0d";
}

.mdi-newspaper-variant::before {
  content: "\\f1001";
}

.mdi-newspaper-variant-multiple::before {
  content: "\\f1002";
}

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\f1003";
}

.mdi-newspaper-variant-outline::before {
  content: "\\f1004";
}

.mdi-nfc::before {
  content: "\\f0396";
}

.mdi-nfc-search-variant::before {
  content: "\\f0e53";
}

.mdi-nfc-tap::before {
  content: "\\f0397";
}

.mdi-nfc-variant::before {
  content: "\\f0398";
}

.mdi-nfc-variant-off::before {
  content: "\\f0e54";
}

.mdi-ninja::before {
  content: "\\f0774";
}

.mdi-nintendo-game-boy::before {
  content: "\\f1393";
}

.mdi-nintendo-switch::before {
  content: "\\f07e1";
}

.mdi-nintendo-wii::before {
  content: "\\f05ab";
}

.mdi-nintendo-wiiu::before {
  content: "\\f072d";
}

.mdi-nix::before {
  content: "\\f1105";
}

.mdi-nodejs::before {
  content: "\\f0399";
}

.mdi-noodles::before {
  content: "\\f117e";
}

.mdi-not-equal::before {
  content: "\\f098d";
}

.mdi-not-equal-variant::before {
  content: "\\f098e";
}

.mdi-note::before {
  content: "\\f039a";
}

.mdi-note-multiple::before {
  content: "\\f06b8";
}

.mdi-note-multiple-outline::before {
  content: "\\f06b9";
}

.mdi-note-outline::before {
  content: "\\f039b";
}

.mdi-note-plus::before {
  content: "\\f039c";
}

.mdi-note-plus-outline::before {
  content: "\\f039d";
}

.mdi-note-text::before {
  content: "\\f039e";
}

.mdi-note-text-outline::before {
  content: "\\f11d7";
}

.mdi-notebook::before {
  content: "\\f082e";
}

.mdi-notebook-multiple::before {
  content: "\\f0e55";
}

.mdi-notebook-outline::before {
  content: "\\f0ebf";
}

.mdi-notification-clear-all::before {
  content: "\\f039f";
}

.mdi-npm::before {
  content: "\\f06f7";
}

.mdi-nuke::before {
  content: "\\f06a4";
}

.mdi-null::before {
  content: "\\f07e2";
}

.mdi-numeric::before {
  content: "\\f03a0";
}

.mdi-numeric-0::before {
  content: "\\f0b39";
}

.mdi-numeric-0-box::before {
  content: "\\f03a1";
}

.mdi-numeric-0-box-multiple::before {
  content: "\\f0f0e";
}

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\f03a2";
}

.mdi-numeric-0-box-outline::before {
  content: "\\f03a3";
}

.mdi-numeric-0-circle::before {
  content: "\\f0c9e";
}

.mdi-numeric-0-circle-outline::before {
  content: "\\f0c9f";
}

.mdi-numeric-1::before {
  content: "\\f0b3a";
}

.mdi-numeric-1-box::before {
  content: "\\f03a4";
}

.mdi-numeric-1-box-multiple::before {
  content: "\\f0f0f";
}

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\f03a5";
}

.mdi-numeric-1-box-outline::before {
  content: "\\f03a6";
}

.mdi-numeric-1-circle::before {
  content: "\\f0ca0";
}

.mdi-numeric-1-circle-outline::before {
  content: "\\f0ca1";
}

.mdi-numeric-10::before {
  content: "\\f0fe9";
}

.mdi-numeric-10-box::before {
  content: "\\f0f7d";
}

.mdi-numeric-10-box-multiple::before {
  content: "\\f0fea";
}

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\f0feb";
}

.mdi-numeric-10-box-outline::before {
  content: "\\f0f7e";
}

.mdi-numeric-10-circle::before {
  content: "\\f0fec";
}

.mdi-numeric-10-circle-outline::before {
  content: "\\f0fed";
}

.mdi-numeric-2::before {
  content: "\\f0b3b";
}

.mdi-numeric-2-box::before {
  content: "\\f03a7";
}

.mdi-numeric-2-box-multiple::before {
  content: "\\f0f10";
}

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\f03a8";
}

.mdi-numeric-2-box-outline::before {
  content: "\\f03a9";
}

.mdi-numeric-2-circle::before {
  content: "\\f0ca2";
}

.mdi-numeric-2-circle-outline::before {
  content: "\\f0ca3";
}

.mdi-numeric-3::before {
  content: "\\f0b3c";
}

.mdi-numeric-3-box::before {
  content: "\\f03aa";
}

.mdi-numeric-3-box-multiple::before {
  content: "\\f0f11";
}

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\f03ab";
}

.mdi-numeric-3-box-outline::before {
  content: "\\f03ac";
}

.mdi-numeric-3-circle::before {
  content: "\\f0ca4";
}

.mdi-numeric-3-circle-outline::before {
  content: "\\f0ca5";
}

.mdi-numeric-4::before {
  content: "\\f0b3d";
}

.mdi-numeric-4-box::before {
  content: "\\f03ad";
}

.mdi-numeric-4-box-multiple::before {
  content: "\\f0f12";
}

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\f03b2";
}

.mdi-numeric-4-box-outline::before {
  content: "\\f03ae";
}

.mdi-numeric-4-circle::before {
  content: "\\f0ca6";
}

.mdi-numeric-4-circle-outline::before {
  content: "\\f0ca7";
}

.mdi-numeric-5::before {
  content: "\\f0b3e";
}

.mdi-numeric-5-box::before {
  content: "\\f03b1";
}

.mdi-numeric-5-box-multiple::before {
  content: "\\f0f13";
}

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\f03af";
}

.mdi-numeric-5-box-outline::before {
  content: "\\f03b0";
}

.mdi-numeric-5-circle::before {
  content: "\\f0ca8";
}

.mdi-numeric-5-circle-outline::before {
  content: "\\f0ca9";
}

.mdi-numeric-6::before {
  content: "\\f0b3f";
}

.mdi-numeric-6-box::before {
  content: "\\f03b3";
}

.mdi-numeric-6-box-multiple::before {
  content: "\\f0f14";
}

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\f03b4";
}

.mdi-numeric-6-box-outline::before {
  content: "\\f03b5";
}

.mdi-numeric-6-circle::before {
  content: "\\f0caa";
}

.mdi-numeric-6-circle-outline::before {
  content: "\\f0cab";
}

.mdi-numeric-7::before {
  content: "\\f0b40";
}

.mdi-numeric-7-box::before {
  content: "\\f03b6";
}

.mdi-numeric-7-box-multiple::before {
  content: "\\f0f15";
}

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\f03b7";
}

.mdi-numeric-7-box-outline::before {
  content: "\\f03b8";
}

.mdi-numeric-7-circle::before {
  content: "\\f0cac";
}

.mdi-numeric-7-circle-outline::before {
  content: "\\f0cad";
}

.mdi-numeric-8::before {
  content: "\\f0b41";
}

.mdi-numeric-8-box::before {
  content: "\\f03b9";
}

.mdi-numeric-8-box-multiple::before {
  content: "\\f0f16";
}

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\f03ba";
}

.mdi-numeric-8-box-outline::before {
  content: "\\f03bb";
}

.mdi-numeric-8-circle::before {
  content: "\\f0cae";
}

.mdi-numeric-8-circle-outline::before {
  content: "\\f0caf";
}

.mdi-numeric-9::before {
  content: "\\f0b42";
}

.mdi-numeric-9-box::before {
  content: "\\f03bc";
}

.mdi-numeric-9-box-multiple::before {
  content: "\\f0f17";
}

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\f03bd";
}

.mdi-numeric-9-box-outline::before {
  content: "\\f03be";
}

.mdi-numeric-9-circle::before {
  content: "\\f0cb0";
}

.mdi-numeric-9-circle-outline::before {
  content: "\\f0cb1";
}

.mdi-numeric-9-plus::before {
  content: "\\f0fee";
}

.mdi-numeric-9-plus-box::before {
  content: "\\f03bf";
}

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\f0f18";
}

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\f03c0";
}

.mdi-numeric-9-plus-box-outline::before {
  content: "\\f03c1";
}

.mdi-numeric-9-plus-circle::before {
  content: "\\f0cb2";
}

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\f0cb3";
}

.mdi-numeric-negative-1::before {
  content: "\\f1052";
}

.mdi-nut::before {
  content: "\\f06f8";
}

.mdi-nutrition::before {
  content: "\\f03c2";
}

.mdi-nuxt::before {
  content: "\\f1106";
}

.mdi-oar::before {
  content: "\\f067c";
}

.mdi-ocarina::before {
  content: "\\f0de0";
}

.mdi-oci::before {
  content: "\\f12e9";
}

.mdi-ocr::before {
  content: "\\f113a";
}

.mdi-octagon::before {
  content: "\\f03c3";
}

.mdi-octagon-outline::before {
  content: "\\f03c4";
}

.mdi-octagram::before {
  content: "\\f06f9";
}

.mdi-octagram-outline::before {
  content: "\\f0775";
}

.mdi-odnoklassniki::before {
  content: "\\f03c5";
}

.mdi-offer::before {
  content: "\\f121b";
}

.mdi-office-building::before {
  content: "\\f0991";
}

.mdi-oil::before {
  content: "\\f03c7";
}

.mdi-oil-lamp::before {
  content: "\\f0f19";
}

.mdi-oil-level::before {
  content: "\\f1053";
}

.mdi-oil-temperature::before {
  content: "\\f0ff8";
}

.mdi-omega::before {
  content: "\\f03c9";
}

.mdi-one-up::before {
  content: "\\f0bad";
}

.mdi-onepassword::before {
  content: "\\f0881";
}

.mdi-opacity::before {
  content: "\\f05cc";
}

.mdi-open-in-app::before {
  content: "\\f03cb";
}

.mdi-open-in-new::before {
  content: "\\f03cc";
}

.mdi-open-source-initiative::before {
  content: "\\f0bae";
}

.mdi-openid::before {
  content: "\\f03cd";
}

.mdi-opera::before {
  content: "\\f03ce";
}

.mdi-orbit::before {
  content: "\\f0018";
}

.mdi-order-alphabetical-ascending::before {
  content: "\\f020d";
}

.mdi-order-alphabetical-descending::before {
  content: "\\f0d07";
}

.mdi-order-bool-ascending::before {
  content: "\\f02be";
}

.mdi-order-bool-ascending-variant::before {
  content: "\\f098f";
}

.mdi-order-bool-descending::before {
  content: "\\f1384";
}

.mdi-order-bool-descending-variant::before {
  content: "\\f0990";
}

.mdi-order-numeric-ascending::before {
  content: "\\f0545";
}

.mdi-order-numeric-descending::before {
  content: "\\f0546";
}

.mdi-origin::before {
  content: "\\f0b43";
}

.mdi-ornament::before {
  content: "\\f03cf";
}

.mdi-ornament-variant::before {
  content: "\\f03d0";
}

.mdi-outdoor-lamp::before {
  content: "\\f1054";
}

.mdi-overscan::before {
  content: "\\f1005";
}

.mdi-owl::before {
  content: "\\f03d2";
}

.mdi-pac-man::before {
  content: "\\f0baf";
}

.mdi-package::before {
  content: "\\f03d3";
}

.mdi-package-down::before {
  content: "\\f03d4";
}

.mdi-package-up::before {
  content: "\\f03d5";
}

.mdi-package-variant::before {
  content: "\\f03d6";
}

.mdi-package-variant-closed::before {
  content: "\\f03d7";
}

.mdi-page-first::before {
  content: "\\f0600";
}

.mdi-page-last::before {
  content: "\\f0601";
}

.mdi-page-layout-body::before {
  content: "\\f06fa";
}

.mdi-page-layout-footer::before {
  content: "\\f06fb";
}

.mdi-page-layout-header::before {
  content: "\\f06fc";
}

.mdi-page-layout-header-footer::before {
  content: "\\f0f7f";
}

.mdi-page-layout-sidebar-left::before {
  content: "\\f06fd";
}

.mdi-page-layout-sidebar-right::before {
  content: "\\f06fe";
}

.mdi-page-next::before {
  content: "\\f0bb0";
}

.mdi-page-next-outline::before {
  content: "\\f0bb1";
}

.mdi-page-previous::before {
  content: "\\f0bb2";
}

.mdi-page-previous-outline::before {
  content: "\\f0bb3";
}

.mdi-palette::before {
  content: "\\f03d8";
}

.mdi-palette-advanced::before {
  content: "\\f03d9";
}

.mdi-palette-outline::before {
  content: "\\f0e0c";
}

.mdi-palette-swatch::before {
  content: "\\f08b5";
}

.mdi-palette-swatch-outline::before {
  content: "\\f135c";
}

.mdi-palm-tree::before {
  content: "\\f1055";
}

.mdi-pan::before {
  content: "\\f0bb4";
}

.mdi-pan-bottom-left::before {
  content: "\\f0bb5";
}

.mdi-pan-bottom-right::before {
  content: "\\f0bb6";
}

.mdi-pan-down::before {
  content: "\\f0bb7";
}

.mdi-pan-horizontal::before {
  content: "\\f0bb8";
}

.mdi-pan-left::before {
  content: "\\f0bb9";
}

.mdi-pan-right::before {
  content: "\\f0bba";
}

.mdi-pan-top-left::before {
  content: "\\f0bbb";
}

.mdi-pan-top-right::before {
  content: "\\f0bbc";
}

.mdi-pan-up::before {
  content: "\\f0bbd";
}

.mdi-pan-vertical::before {
  content: "\\f0bbe";
}

.mdi-panda::before {
  content: "\\f03da";
}

.mdi-pandora::before {
  content: "\\f03db";
}

.mdi-panorama::before {
  content: "\\f03dc";
}

.mdi-panorama-fisheye::before {
  content: "\\f03dd";
}

.mdi-panorama-horizontal::before {
  content: "\\f03de";
}

.mdi-panorama-vertical::before {
  content: "\\f03df";
}

.mdi-panorama-wide-angle::before {
  content: "\\f03e0";
}

.mdi-paper-cut-vertical::before {
  content: "\\f03e1";
}

.mdi-paper-roll::before {
  content: "\\f1157";
}

.mdi-paper-roll-outline::before {
  content: "\\f1158";
}

.mdi-paperclip::before {
  content: "\\f03e2";
}

.mdi-parachute::before {
  content: "\\f0cb4";
}

.mdi-parachute-outline::before {
  content: "\\f0cb5";
}

.mdi-parking::before {
  content: "\\f03e3";
}

.mdi-party-popper::before {
  content: "\\f1056";
}

.mdi-passport::before {
  content: "\\f07e3";
}

.mdi-passport-biometric::before {
  content: "\\f0de1";
}

.mdi-pasta::before {
  content: "\\f1160";
}

.mdi-patio-heater::before {
  content: "\\f0f80";
}

.mdi-patreon::before {
  content: "\\f0882";
}

.mdi-pause::before {
  content: "\\f03e4";
}

.mdi-pause-circle::before {
  content: "\\f03e5";
}

.mdi-pause-circle-outline::before {
  content: "\\f03e6";
}

.mdi-pause-octagon::before {
  content: "\\f03e7";
}

.mdi-pause-octagon-outline::before {
  content: "\\f03e8";
}

.mdi-paw::before {
  content: "\\f03e9";
}

.mdi-paw-off::before {
  content: "\\f0657";
}

.mdi-pdf-box::before {
  content: "\\f0e56";
}

.mdi-peace::before {
  content: "\\f0884";
}

.mdi-peanut::before {
  content: "\\f0ffc";
}

.mdi-peanut-off::before {
  content: "\\f0ffd";
}

.mdi-peanut-off-outline::before {
  content: "\\f0fff";
}

.mdi-peanut-outline::before {
  content: "\\f0ffe";
}

.mdi-pen::before {
  content: "\\f03ea";
}

.mdi-pen-lock::before {
  content: "\\f0de2";
}

.mdi-pen-minus::before {
  content: "\\f0de3";
}

.mdi-pen-off::before {
  content: "\\f0de4";
}

.mdi-pen-plus::before {
  content: "\\f0de5";
}

.mdi-pen-remove::before {
  content: "\\f0de6";
}

.mdi-pencil::before {
  content: "\\f03eb";
}

.mdi-pencil-box::before {
  content: "\\f03ec";
}

.mdi-pencil-box-multiple::before {
  content: "\\f1144";
}

.mdi-pencil-box-multiple-outline::before {
  content: "\\f1145";
}

.mdi-pencil-box-outline::before {
  content: "\\f03ed";
}

.mdi-pencil-circle::before {
  content: "\\f06ff";
}

.mdi-pencil-circle-outline::before {
  content: "\\f0776";
}

.mdi-pencil-lock::before {
  content: "\\f03ee";
}

.mdi-pencil-lock-outline::before {
  content: "\\f0de7";
}

.mdi-pencil-minus::before {
  content: "\\f0de8";
}

.mdi-pencil-minus-outline::before {
  content: "\\f0de9";
}

.mdi-pencil-off::before {
  content: "\\f03ef";
}

.mdi-pencil-off-outline::before {
  content: "\\f0dea";
}

.mdi-pencil-outline::before {
  content: "\\f0cb6";
}

.mdi-pencil-plus::before {
  content: "\\f0deb";
}

.mdi-pencil-plus-outline::before {
  content: "\\f0dec";
}

.mdi-pencil-remove::before {
  content: "\\f0ded";
}

.mdi-pencil-remove-outline::before {
  content: "\\f0dee";
}

.mdi-pencil-ruler::before {
  content: "\\f1353";
}

.mdi-penguin::before {
  content: "\\f0ec0";
}

.mdi-pentagon::before {
  content: "\\f0701";
}

.mdi-pentagon-outline::before {
  content: "\\f0700";
}

.mdi-percent::before {
  content: "\\f03f0";
}

.mdi-percent-outline::before {
  content: "\\f1278";
}

.mdi-periodic-table::before {
  content: "\\f08b6";
}

.mdi-perspective-less::before {
  content: "\\f0d23";
}

.mdi-perspective-more::before {
  content: "\\f0d24";
}

.mdi-pharmacy::before {
  content: "\\f03f1";
}

.mdi-phone::before {
  content: "\\f03f2";
}

.mdi-phone-alert::before {
  content: "\\f0f1a";
}

.mdi-phone-alert-outline::before {
  content: "\\f118e";
}

.mdi-phone-bluetooth::before {
  content: "\\f03f3";
}

.mdi-phone-bluetooth-outline::before {
  content: "\\f118f";
}

.mdi-phone-cancel::before {
  content: "\\f10bc";
}

.mdi-phone-cancel-outline::before {
  content: "\\f1190";
}

.mdi-phone-check::before {
  content: "\\f11a9";
}

.mdi-phone-check-outline::before {
  content: "\\f11aa";
}

.mdi-phone-classic::before {
  content: "\\f0602";
}

.mdi-phone-classic-off::before {
  content: "\\f1279";
}

.mdi-phone-forward::before {
  content: "\\f03f4";
}

.mdi-phone-forward-outline::before {
  content: "\\f1191";
}

.mdi-phone-hangup::before {
  content: "\\f03f5";
}

.mdi-phone-hangup-outline::before {
  content: "\\f1192";
}

.mdi-phone-in-talk::before {
  content: "\\f03f6";
}

.mdi-phone-in-talk-outline::before {
  content: "\\f1182";
}

.mdi-phone-incoming::before {
  content: "\\f03f7";
}

.mdi-phone-incoming-outline::before {
  content: "\\f1193";
}

.mdi-phone-lock::before {
  content: "\\f03f8";
}

.mdi-phone-lock-outline::before {
  content: "\\f1194";
}

.mdi-phone-log::before {
  content: "\\f03f9";
}

.mdi-phone-log-outline::before {
  content: "\\f1195";
}

.mdi-phone-message::before {
  content: "\\f1196";
}

.mdi-phone-message-outline::before {
  content: "\\f1197";
}

.mdi-phone-minus::before {
  content: "\\f0658";
}

.mdi-phone-minus-outline::before {
  content: "\\f1198";
}

.mdi-phone-missed::before {
  content: "\\f03fa";
}

.mdi-phone-missed-outline::before {
  content: "\\f11a5";
}

.mdi-phone-off::before {
  content: "\\f0def";
}

.mdi-phone-off-outline::before {
  content: "\\f11a6";
}

.mdi-phone-outgoing::before {
  content: "\\f03fb";
}

.mdi-phone-outgoing-outline::before {
  content: "\\f1199";
}

.mdi-phone-outline::before {
  content: "\\f0df0";
}

.mdi-phone-paused::before {
  content: "\\f03fc";
}

.mdi-phone-paused-outline::before {
  content: "\\f119a";
}

.mdi-phone-plus::before {
  content: "\\f0659";
}

.mdi-phone-plus-outline::before {
  content: "\\f119b";
}

.mdi-phone-return::before {
  content: "\\f082f";
}

.mdi-phone-return-outline::before {
  content: "\\f119c";
}

.mdi-phone-ring::before {
  content: "\\f11ab";
}

.mdi-phone-ring-outline::before {
  content: "\\f11ac";
}

.mdi-phone-rotate-landscape::before {
  content: "\\f0885";
}

.mdi-phone-rotate-portrait::before {
  content: "\\f0886";
}

.mdi-phone-settings::before {
  content: "\\f03fd";
}

.mdi-phone-settings-outline::before {
  content: "\\f119d";
}

.mdi-phone-voip::before {
  content: "\\f03fe";
}

.mdi-pi::before {
  content: "\\f03ff";
}

.mdi-pi-box::before {
  content: "\\f0400";
}

.mdi-pi-hole::before {
  content: "\\f0df1";
}

.mdi-piano::before {
  content: "\\f067d";
}

.mdi-pickaxe::before {
  content: "\\f08b7";
}

.mdi-picture-in-picture-bottom-right::before {
  content: "\\f0e57";
}

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\f0e58";
}

.mdi-picture-in-picture-top-right::before {
  content: "\\f0e59";
}

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\f0e5a";
}

.mdi-pier::before {
  content: "\\f0887";
}

.mdi-pier-crane::before {
  content: "\\f0888";
}

.mdi-pig::before {
  content: "\\f0401";
}

.mdi-pig-variant::before {
  content: "\\f1006";
}

.mdi-piggy-bank::before {
  content: "\\f1007";
}

.mdi-pill::before {
  content: "\\f0402";
}

.mdi-pillar::before {
  content: "\\f0702";
}

.mdi-pin::before {
  content: "\\f0403";
}

.mdi-pin-off::before {
  content: "\\f0404";
}

.mdi-pin-off-outline::before {
  content: "\\f0930";
}

.mdi-pin-outline::before {
  content: "\\f0931";
}

.mdi-pine-tree::before {
  content: "\\f0405";
}

.mdi-pine-tree-box::before {
  content: "\\f0406";
}

.mdi-pinterest::before {
  content: "\\f0407";
}

.mdi-pinwheel::before {
  content: "\\f0ad5";
}

.mdi-pinwheel-outline::before {
  content: "\\f0ad6";
}

.mdi-pipe::before {
  content: "\\f07e5";
}

.mdi-pipe-disconnected::before {
  content: "\\f07e6";
}

.mdi-pipe-leak::before {
  content: "\\f0889";
}

.mdi-pipe-wrench::before {
  content: "\\f1354";
}

.mdi-pirate::before {
  content: "\\f0a08";
}

.mdi-pistol::before {
  content: "\\f0703";
}

.mdi-piston::before {
  content: "\\f088a";
}

.mdi-pizza::before {
  content: "\\f0409";
}

.mdi-play::before {
  content: "\\f040a";
}

.mdi-play-box::before {
  content: "\\f127a";
}

.mdi-play-box-multiple::before {
  content: "\\f0d19";
}

.mdi-play-box-outline::before {
  content: "\\f040b";
}

.mdi-play-circle::before {
  content: "\\f040c";
}

.mdi-play-circle-outline::before {
  content: "\\f040d";
}

.mdi-play-network::before {
  content: "\\f088b";
}

.mdi-play-network-outline::before {
  content: "\\f0cb7";
}

.mdi-play-outline::before {
  content: "\\f0f1b";
}

.mdi-play-pause::before {
  content: "\\f040e";
}

.mdi-play-protected-content::before {
  content: "\\f040f";
}

.mdi-play-speed::before {
  content: "\\f08ff";
}

.mdi-playlist-check::before {
  content: "\\f05c7";
}

.mdi-playlist-edit::before {
  content: "\\f0900";
}

.mdi-playlist-minus::before {
  content: "\\f0410";
}

.mdi-playlist-music::before {
  content: "\\f0cb8";
}

.mdi-playlist-music-outline::before {
  content: "\\f0cb9";
}

.mdi-playlist-play::before {
  content: "\\f0411";
}

.mdi-playlist-plus::before {
  content: "\\f0412";
}

.mdi-playlist-remove::before {
  content: "\\f0413";
}

.mdi-playlist-star::before {
  content: "\\f0df2";
}

.mdi-plex::before {
  content: "\\f06ba";
}

.mdi-plus::before {
  content: "\\f0415";
}

.mdi-plus-box::before {
  content: "\\f0416";
}

.mdi-plus-box-multiple::before {
  content: "\\f0334";
}

.mdi-plus-box-multiple-outline::before {
  content: "\\f1143";
}

.mdi-plus-box-outline::before {
  content: "\\f0704";
}

.mdi-plus-circle::before {
  content: "\\f0417";
}

.mdi-plus-circle-multiple::before {
  content: "\\f034c";
}

.mdi-plus-circle-multiple-outline::before {
  content: "\\f0418";
}

.mdi-plus-circle-outline::before {
  content: "\\f0419";
}

.mdi-plus-minus::before {
  content: "\\f0992";
}

.mdi-plus-minus-box::before {
  content: "\\f0993";
}

.mdi-plus-network::before {
  content: "\\f041a";
}

.mdi-plus-network-outline::before {
  content: "\\f0cba";
}

.mdi-plus-one::before {
  content: "\\f041b";
}

.mdi-plus-outline::before {
  content: "\\f0705";
}

.mdi-plus-thick::before {
  content: "\\f11ec";
}

.mdi-podcast::before {
  content: "\\f0994";
}

.mdi-podium::before {
  content: "\\f0d25";
}

.mdi-podium-bronze::before {
  content: "\\f0d26";
}

.mdi-podium-gold::before {
  content: "\\f0d27";
}

.mdi-podium-silver::before {
  content: "\\f0d28";
}

.mdi-point-of-sale::before {
  content: "\\f0d92";
}

.mdi-pokeball::before {
  content: "\\f041d";
}

.mdi-pokemon-go::before {
  content: "\\f0a09";
}

.mdi-poker-chip::before {
  content: "\\f0830";
}

.mdi-polaroid::before {
  content: "\\f041e";
}

.mdi-police-badge::before {
  content: "\\f1167";
}

.mdi-police-badge-outline::before {
  content: "\\f1168";
}

.mdi-poll::before {
  content: "\\f041f";
}

.mdi-poll-box::before {
  content: "\\f0420";
}

.mdi-poll-box-outline::before {
  content: "\\f127b";
}

.mdi-polymer::before {
  content: "\\f0421";
}

.mdi-pool::before {
  content: "\\f0606";
}

.mdi-popcorn::before {
  content: "\\f0422";
}

.mdi-post::before {
  content: "\\f1008";
}

.mdi-post-outline::before {
  content: "\\f1009";
}

.mdi-postage-stamp::before {
  content: "\\f0cbb";
}

.mdi-pot::before {
  content: "\\f02e5";
}

.mdi-pot-mix::before {
  content: "\\f065b";
}

.mdi-pot-mix-outline::before {
  content: "\\f0677";
}

.mdi-pot-outline::before {
  content: "\\f02ff";
}

.mdi-pot-steam::before {
  content: "\\f065a";
}

.mdi-pot-steam-outline::before {
  content: "\\f0326";
}

.mdi-pound::before {
  content: "\\f0423";
}

.mdi-pound-box::before {
  content: "\\f0424";
}

.mdi-pound-box-outline::before {
  content: "\\f117f";
}

.mdi-power::before {
  content: "\\f0425";
}

.mdi-power-cycle::before {
  content: "\\f0901";
}

.mdi-power-off::before {
  content: "\\f0902";
}

.mdi-power-on::before {
  content: "\\f0903";
}

.mdi-power-plug::before {
  content: "\\f06a5";
}

.mdi-power-plug-off::before {
  content: "\\f06a6";
}

.mdi-power-settings::before {
  content: "\\f0426";
}

.mdi-power-sleep::before {
  content: "\\f0904";
}

.mdi-power-socket::before {
  content: "\\f0427";
}

.mdi-power-socket-au::before {
  content: "\\f0905";
}

.mdi-power-socket-de::before {
  content: "\\f1107";
}

.mdi-power-socket-eu::before {
  content: "\\f07e7";
}

.mdi-power-socket-fr::before {
  content: "\\f1108";
}

.mdi-power-socket-jp::before {
  content: "\\f1109";
}

.mdi-power-socket-uk::before {
  content: "\\f07e8";
}

.mdi-power-socket-us::before {
  content: "\\f07e9";
}

.mdi-power-standby::before {
  content: "\\f0906";
}

.mdi-powershell::before {
  content: "\\f0a0a";
}

.mdi-prescription::before {
  content: "\\f0706";
}

.mdi-presentation::before {
  content: "\\f0428";
}

.mdi-presentation-play::before {
  content: "\\f0429";
}

.mdi-printer::before {
  content: "\\f042a";
}

.mdi-printer-3d::before {
  content: "\\f042b";
}

.mdi-printer-3d-nozzle::before {
  content: "\\f0e5b";
}

.mdi-printer-3d-nozzle-alert::before {
  content: "\\f11c0";
}

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\f11c1";
}

.mdi-printer-3d-nozzle-outline::before {
  content: "\\f0e5c";
}

.mdi-printer-alert::before {
  content: "\\f042c";
}

.mdi-printer-check::before {
  content: "\\f1146";
}

.mdi-printer-off::before {
  content: "\\f0e5d";
}

.mdi-printer-pos::before {
  content: "\\f1057";
}

.mdi-printer-settings::before {
  content: "\\f0707";
}

.mdi-printer-wireless::before {
  content: "\\f0a0b";
}

.mdi-priority-high::before {
  content: "\\f0603";
}

.mdi-priority-low::before {
  content: "\\f0604";
}

.mdi-professional-hexagon::before {
  content: "\\f042d";
}

.mdi-progress-alert::before {
  content: "\\f0cbc";
}

.mdi-progress-check::before {
  content: "\\f0995";
}

.mdi-progress-clock::before {
  content: "\\f0996";
}

.mdi-progress-close::before {
  content: "\\f110a";
}

.mdi-progress-download::before {
  content: "\\f0997";
}

.mdi-progress-upload::before {
  content: "\\f0998";
}

.mdi-progress-wrench::before {
  content: "\\f0cbd";
}

.mdi-projector::before {
  content: "\\f042e";
}

.mdi-projector-screen::before {
  content: "\\f042f";
}

.mdi-propane-tank::before {
  content: "\\f1357";
}

.mdi-propane-tank-outline::before {
  content: "\\f1358";
}

.mdi-protocol::before {
  content: "\\f0fd8";
}

.mdi-publish::before {
  content: "\\f06a7";
}

.mdi-pulse::before {
  content: "\\f0430";
}

.mdi-pumpkin::before {
  content: "\\f0bbf";
}

.mdi-purse::before {
  content: "\\f0f1c";
}

.mdi-purse-outline::before {
  content: "\\f0f1d";
}

.mdi-puzzle::before {
  content: "\\f0431";
}

.mdi-puzzle-outline::before {
  content: "\\f0a66";
}

.mdi-qi::before {
  content: "\\f0999";
}

.mdi-qqchat::before {
  content: "\\f0605";
}

.mdi-qrcode::before {
  content: "\\f0432";
}

.mdi-qrcode-edit::before {
  content: "\\f08b8";
}

.mdi-qrcode-minus::before {
  content: "\\f118c";
}

.mdi-qrcode-plus::before {
  content: "\\f118b";
}

.mdi-qrcode-remove::before {
  content: "\\f118d";
}

.mdi-qrcode-scan::before {
  content: "\\f0433";
}

.mdi-quadcopter::before {
  content: "\\f0434";
}

.mdi-quality-high::before {
  content: "\\f0435";
}

.mdi-quality-low::before {
  content: "\\f0a0c";
}

.mdi-quality-medium::before {
  content: "\\f0a0d";
}

.mdi-quora::before {
  content: "\\f0d29";
}

.mdi-rabbit::before {
  content: "\\f0907";
}

.mdi-racing-helmet::before {
  content: "\\f0d93";
}

.mdi-racquetball::before {
  content: "\\f0d94";
}

.mdi-radar::before {
  content: "\\f0437";
}

.mdi-radiator::before {
  content: "\\f0438";
}

.mdi-radiator-disabled::before {
  content: "\\f0ad7";
}

.mdi-radiator-off::before {
  content: "\\f0ad8";
}

.mdi-radio::before {
  content: "\\f0439";
}

.mdi-radio-am::before {
  content: "\\f0cbe";
}

.mdi-radio-fm::before {
  content: "\\f0cbf";
}

.mdi-radio-handheld::before {
  content: "\\f043a";
}

.mdi-radio-off::before {
  content: "\\f121c";
}

.mdi-radio-tower::before {
  content: "\\f043b";
}

.mdi-radioactive::before {
  content: "\\f043c";
}

.mdi-radioactive-off::before {
  content: "\\f0ec1";
}

.mdi-radiobox-blank::before {
  content: "\\f043d";
}

.mdi-radiobox-marked::before {
  content: "\\f043e";
}

.mdi-radius::before {
  content: "\\f0cc0";
}

.mdi-radius-outline::before {
  content: "\\f0cc1";
}

.mdi-railroad-light::before {
  content: "\\f0f1e";
}

.mdi-raspberry-pi::before {
  content: "\\f043f";
}

.mdi-ray-end::before {
  content: "\\f0440";
}

.mdi-ray-end-arrow::before {
  content: "\\f0441";
}

.mdi-ray-start::before {
  content: "\\f0442";
}

.mdi-ray-start-arrow::before {
  content: "\\f0443";
}

.mdi-ray-start-end::before {
  content: "\\f0444";
}

.mdi-ray-vertex::before {
  content: "\\f0445";
}

.mdi-react::before {
  content: "\\f0708";
}

.mdi-read::before {
  content: "\\f0447";
}

.mdi-receipt::before {
  content: "\\f0449";
}

.mdi-record::before {
  content: "\\f044a";
}

.mdi-record-circle::before {
  content: "\\f0ec2";
}

.mdi-record-circle-outline::before {
  content: "\\f0ec3";
}

.mdi-record-player::before {
  content: "\\f099a";
}

.mdi-record-rec::before {
  content: "\\f044b";
}

.mdi-rectangle::before {
  content: "\\f0e5e";
}

.mdi-rectangle-outline::before {
  content: "\\f0e5f";
}

.mdi-recycle::before {
  content: "\\f044c";
}

.mdi-recycle-variant::before {
  content: "\\f139d";
}

.mdi-reddit::before {
  content: "\\f044d";
}

.mdi-redhat::before {
  content: "\\f111b";
}

.mdi-redo::before {
  content: "\\f044e";
}

.mdi-redo-variant::before {
  content: "\\f044f";
}

.mdi-reflect-horizontal::before {
  content: "\\f0a0e";
}

.mdi-reflect-vertical::before {
  content: "\\f0a0f";
}

.mdi-refresh::before {
  content: "\\f0450";
}

.mdi-refresh-circle::before {
  content: "\\f1377";
}

.mdi-regex::before {
  content: "\\f0451";
}

.mdi-registered-trademark::before {
  content: "\\f0a67";
}

.mdi-relative-scale::before {
  content: "\\f0452";
}

.mdi-reload::before {
  content: "\\f0453";
}

.mdi-reload-alert::before {
  content: "\\f110b";
}

.mdi-reminder::before {
  content: "\\f088c";
}

.mdi-remote::before {
  content: "\\f0454";
}

.mdi-remote-desktop::before {
  content: "\\f08b9";
}

.mdi-remote-off::before {
  content: "\\f0ec4";
}

.mdi-remote-tv::before {
  content: "\\f0ec5";
}

.mdi-remote-tv-off::before {
  content: "\\f0ec6";
}

.mdi-rename-box::before {
  content: "\\f0455";
}

.mdi-reorder-horizontal::before {
  content: "\\f0688";
}

.mdi-reorder-vertical::before {
  content: "\\f0689";
}

.mdi-repeat::before {
  content: "\\f0456";
}

.mdi-repeat-off::before {
  content: "\\f0457";
}

.mdi-repeat-once::before {
  content: "\\f0458";
}

.mdi-replay::before {
  content: "\\f0459";
}

.mdi-reply::before {
  content: "\\f045a";
}

.mdi-reply-all::before {
  content: "\\f045b";
}

.mdi-reply-all-outline::before {
  content: "\\f0f1f";
}

.mdi-reply-circle::before {
  content: "\\f11ae";
}

.mdi-reply-outline::before {
  content: "\\f0f20";
}

.mdi-reproduction::before {
  content: "\\f045c";
}

.mdi-resistor::before {
  content: "\\f0b44";
}

.mdi-resistor-nodes::before {
  content: "\\f0b45";
}

.mdi-resize::before {
  content: "\\f0a68";
}

.mdi-resize-bottom-right::before {
  content: "\\f045d";
}

.mdi-responsive::before {
  content: "\\f045e";
}

.mdi-restart::before {
  content: "\\f0709";
}

.mdi-restart-alert::before {
  content: "\\f110c";
}

.mdi-restart-off::before {
  content: "\\f0d95";
}

.mdi-restore::before {
  content: "\\f099b";
}

.mdi-restore-alert::before {
  content: "\\f110d";
}

.mdi-rewind::before {
  content: "\\f045f";
}

.mdi-rewind-10::before {
  content: "\\f0d2a";
}

.mdi-rewind-30::before {
  content: "\\f0d96";
}

.mdi-rewind-5::before {
  content: "\\f11f9";
}

.mdi-rewind-outline::before {
  content: "\\f070a";
}

.mdi-rhombus::before {
  content: "\\f070b";
}

.mdi-rhombus-medium::before {
  content: "\\f0a10";
}

.mdi-rhombus-outline::before {
  content: "\\f070c";
}

.mdi-rhombus-split::before {
  content: "\\f0a11";
}

.mdi-ribbon::before {
  content: "\\f0460";
}

.mdi-rice::before {
  content: "\\f07ea";
}

.mdi-ring::before {
  content: "\\f07eb";
}

.mdi-rivet::before {
  content: "\\f0e60";
}

.mdi-road::before {
  content: "\\f0461";
}

.mdi-road-variant::before {
  content: "\\f0462";
}

.mdi-robber::before {
  content: "\\f1058";
}

.mdi-robot::before {
  content: "\\f06a9";
}

.mdi-robot-industrial::before {
  content: "\\f0b46";
}

.mdi-robot-mower::before {
  content: "\\f11f7";
}

.mdi-robot-mower-outline::before {
  content: "\\f11f3";
}

.mdi-robot-vacuum::before {
  content: "\\f070d";
}

.mdi-robot-vacuum-variant::before {
  content: "\\f0908";
}

.mdi-rocket::before {
  content: "\\f0463";
}

.mdi-rocket-outline::before {
  content: "\\f13af";
}

.mdi-rodent::before {
  content: "\\f1327";
}

.mdi-roller-skate::before {
  content: "\\f0d2b";
}

.mdi-roller-skate-off::before {
  content: "\\f0145";
}

.mdi-rollerblade::before {
  content: "\\f0d2c";
}

.mdi-rollerblade-off::before {
  content: "\\f002e";
}

.mdi-rollupjs::before {
  content: "\\f0bc0";
}

.mdi-roman-numeral-1::before {
  content: "\\f1088";
}

.mdi-roman-numeral-10::before {
  content: "\\f1091";
}

.mdi-roman-numeral-2::before {
  content: "\\f1089";
}

.mdi-roman-numeral-3::before {
  content: "\\f108a";
}

.mdi-roman-numeral-4::before {
  content: "\\f108b";
}

.mdi-roman-numeral-5::before {
  content: "\\f108c";
}

.mdi-roman-numeral-6::before {
  content: "\\f108d";
}

.mdi-roman-numeral-7::before {
  content: "\\f108e";
}

.mdi-roman-numeral-8::before {
  content: "\\f108f";
}

.mdi-roman-numeral-9::before {
  content: "\\f1090";
}

.mdi-room-service::before {
  content: "\\f088d";
}

.mdi-room-service-outline::before {
  content: "\\f0d97";
}

.mdi-rotate-3d::before {
  content: "\\f0ec7";
}

.mdi-rotate-3d-variant::before {
  content: "\\f0464";
}

.mdi-rotate-left::before {
  content: "\\f0465";
}

.mdi-rotate-left-variant::before {
  content: "\\f0466";
}

.mdi-rotate-orbit::before {
  content: "\\f0d98";
}

.mdi-rotate-right::before {
  content: "\\f0467";
}

.mdi-rotate-right-variant::before {
  content: "\\f0468";
}

.mdi-rounded-corner::before {
  content: "\\f0607";
}

.mdi-router::before {
  content: "\\f11e2";
}

.mdi-router-network::before {
  content: "\\f1087";
}

.mdi-router-wireless::before {
  content: "\\f0469";
}

.mdi-router-wireless-settings::before {
  content: "\\f0a69";
}

.mdi-routes::before {
  content: "\\f046a";
}

.mdi-routes-clock::before {
  content: "\\f1059";
}

.mdi-rowing::before {
  content: "\\f0608";
}

.mdi-rss::before {
  content: "\\f046b";
}

.mdi-rss-box::before {
  content: "\\f046c";
}

.mdi-rss-off::before {
  content: "\\f0f21";
}

.mdi-rugby::before {
  content: "\\f0d99";
}

.mdi-ruler::before {
  content: "\\f046d";
}

.mdi-ruler-square::before {
  content: "\\f0cc2";
}

.mdi-ruler-square-compass::before {
  content: "\\f0ebe";
}

.mdi-run::before {
  content: "\\f070e";
}

.mdi-run-fast::before {
  content: "\\f046e";
}

.mdi-rv-truck::before {
  content: "\\f11d4";
}

.mdi-sack::before {
  content: "\\f0d2e";
}

.mdi-sack-percent::before {
  content: "\\f0d2f";
}

.mdi-safe::before {
  content: "\\f0a6a";
}

.mdi-safe-square::before {
  content: "\\f127c";
}

.mdi-safe-square-outline::before {
  content: "\\f127d";
}

.mdi-safety-goggles::before {
  content: "\\f0d30";
}

.mdi-sail-boat::before {
  content: "\\f0ec8";
}

.mdi-sale::before {
  content: "\\f046f";
}

.mdi-salesforce::before {
  content: "\\f088e";
}

.mdi-sass::before {
  content: "\\f07ec";
}

.mdi-satellite::before {
  content: "\\f0470";
}

.mdi-satellite-uplink::before {
  content: "\\f0909";
}

.mdi-satellite-variant::before {
  content: "\\f0471";
}

.mdi-sausage::before {
  content: "\\f08ba";
}

.mdi-saw-blade::before {
  content: "\\f0e61";
}

.mdi-saxophone::before {
  content: "\\f0609";
}

.mdi-scale::before {
  content: "\\f0472";
}

.mdi-scale-balance::before {
  content: "\\f05d1";
}

.mdi-scale-bathroom::before {
  content: "\\f0473";
}

.mdi-scale-off::before {
  content: "\\f105a";
}

.mdi-scanner::before {
  content: "\\f06ab";
}

.mdi-scanner-off::before {
  content: "\\f090a";
}

.mdi-scatter-plot::before {
  content: "\\f0ec9";
}

.mdi-scatter-plot-outline::before {
  content: "\\f0eca";
}

.mdi-school::before {
  content: "\\f0474";
}

.mdi-school-outline::before {
  content: "\\f1180";
}

.mdi-scissors-cutting::before {
  content: "\\f0a6b";
}

.mdi-scooter::before {
  content: "\\f11e9";
}

.mdi-scoreboard::before {
  content: "\\f127e";
}

.mdi-scoreboard-outline::before {
  content: "\\f127f";
}

.mdi-screen-rotation::before {
  content: "\\f0475";
}

.mdi-screen-rotation-lock::before {
  content: "\\f0478";
}

.mdi-screw-flat-top::before {
  content: "\\f0df3";
}

.mdi-screw-lag::before {
  content: "\\f0df4";
}

.mdi-screw-machine-flat-top::before {
  content: "\\f0df5";
}

.mdi-screw-machine-round-top::before {
  content: "\\f0df6";
}

.mdi-screw-round-top::before {
  content: "\\f0df7";
}

.mdi-screwdriver::before {
  content: "\\f0476";
}

.mdi-script::before {
  content: "\\f0bc1";
}

.mdi-script-outline::before {
  content: "\\f0477";
}

.mdi-script-text::before {
  content: "\\f0bc2";
}

.mdi-script-text-outline::before {
  content: "\\f0bc3";
}

.mdi-sd::before {
  content: "\\f0479";
}

.mdi-seal::before {
  content: "\\f047a";
}

.mdi-seal-variant::before {
  content: "\\f0fd9";
}

.mdi-search-web::before {
  content: "\\f070f";
}

.mdi-seat::before {
  content: "\\f0cc3";
}

.mdi-seat-flat::before {
  content: "\\f047b";
}

.mdi-seat-flat-angled::before {
  content: "\\f047c";
}

.mdi-seat-individual-suite::before {
  content: "\\f047d";
}

.mdi-seat-legroom-extra::before {
  content: "\\f047e";
}

.mdi-seat-legroom-normal::before {
  content: "\\f047f";
}

.mdi-seat-legroom-reduced::before {
  content: "\\f0480";
}

.mdi-seat-outline::before {
  content: "\\f0cc4";
}

.mdi-seat-passenger::before {
  content: "\\f1249";
}

.mdi-seat-recline-extra::before {
  content: "\\f0481";
}

.mdi-seat-recline-normal::before {
  content: "\\f0482";
}

.mdi-seatbelt::before {
  content: "\\f0cc5";
}

.mdi-security::before {
  content: "\\f0483";
}

.mdi-security-network::before {
  content: "\\f0484";
}

.mdi-seed::before {
  content: "\\f0e62";
}

.mdi-seed-outline::before {
  content: "\\f0e63";
}

.mdi-segment::before {
  content: "\\f0ecb";
}

.mdi-select::before {
  content: "\\f0485";
}

.mdi-select-all::before {
  content: "\\f0486";
}

.mdi-select-color::before {
  content: "\\f0d31";
}

.mdi-select-compare::before {
  content: "\\f0ad9";
}

.mdi-select-drag::before {
  content: "\\f0a6c";
}

.mdi-select-group::before {
  content: "\\f0f82";
}

.mdi-select-inverse::before {
  content: "\\f0487";
}

.mdi-select-marker::before {
  content: "\\f1280";
}

.mdi-select-multiple::before {
  content: "\\f1281";
}

.mdi-select-multiple-marker::before {
  content: "\\f1282";
}

.mdi-select-off::before {
  content: "\\f0488";
}

.mdi-select-place::before {
  content: "\\f0fda";
}

.mdi-select-search::before {
  content: "\\f1204";
}

.mdi-selection::before {
  content: "\\f0489";
}

.mdi-selection-drag::before {
  content: "\\f0a6d";
}

.mdi-selection-ellipse::before {
  content: "\\f0d32";
}

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\f0f22";
}

.mdi-selection-marker::before {
  content: "\\f1283";
}

.mdi-selection-multiple-marker::before {
  content: "\\f1284";
}

.mdi-selection-mutliple::before {
  content: "\\f1285";
}

.mdi-selection-off::before {
  content: "\\f0777";
}

.mdi-selection-search::before {
  content: "\\f1205";
}

.mdi-semantic-web::before {
  content: "\\f1316";
}

.mdi-send::before {
  content: "\\f048a";
}

.mdi-send-check::before {
  content: "\\f1161";
}

.mdi-send-check-outline::before {
  content: "\\f1162";
}

.mdi-send-circle::before {
  content: "\\f0df8";
}

.mdi-send-circle-outline::before {
  content: "\\f0df9";
}

.mdi-send-clock::before {
  content: "\\f1163";
}

.mdi-send-clock-outline::before {
  content: "\\f1164";
}

.mdi-send-lock::before {
  content: "\\f07ed";
}

.mdi-send-lock-outline::before {
  content: "\\f1166";
}

.mdi-send-outline::before {
  content: "\\f1165";
}

.mdi-serial-port::before {
  content: "\\f065c";
}

.mdi-server::before {
  content: "\\f048b";
}

.mdi-server-minus::before {
  content: "\\f048c";
}

.mdi-server-network::before {
  content: "\\f048d";
}

.mdi-server-network-off::before {
  content: "\\f048e";
}

.mdi-server-off::before {
  content: "\\f048f";
}

.mdi-server-plus::before {
  content: "\\f0490";
}

.mdi-server-remove::before {
  content: "\\f0491";
}

.mdi-server-security::before {
  content: "\\f0492";
}

.mdi-set-all::before {
  content: "\\f0778";
}

.mdi-set-center::before {
  content: "\\f0779";
}

.mdi-set-center-right::before {
  content: "\\f077a";
}

.mdi-set-left::before {
  content: "\\f077b";
}

.mdi-set-left-center::before {
  content: "\\f077c";
}

.mdi-set-left-right::before {
  content: "\\f077d";
}

.mdi-set-none::before {
  content: "\\f077e";
}

.mdi-set-right::before {
  content: "\\f077f";
}

.mdi-set-top-box::before {
  content: "\\f099f";
}

.mdi-settings-helper::before {
  content: "\\f0a6e";
}

.mdi-shaker::before {
  content: "\\f110e";
}

.mdi-shaker-outline::before {
  content: "\\f110f";
}

.mdi-shape::before {
  content: "\\f0831";
}

.mdi-shape-circle-plus::before {
  content: "\\f065d";
}

.mdi-shape-outline::before {
  content: "\\f0832";
}

.mdi-shape-oval-plus::before {
  content: "\\f11fa";
}

.mdi-shape-plus::before {
  content: "\\f0495";
}

.mdi-shape-polygon-plus::before {
  content: "\\f065e";
}

.mdi-shape-rectangle-plus::before {
  content: "\\f065f";
}

.mdi-shape-square-plus::before {
  content: "\\f0660";
}

.mdi-share::before {
  content: "\\f0496";
}

.mdi-share-all::before {
  content: "\\f11f4";
}

.mdi-share-all-outline::before {
  content: "\\f11f5";
}

.mdi-share-circle::before {
  content: "\\f11ad";
}

.mdi-share-off::before {
  content: "\\f0f23";
}

.mdi-share-off-outline::before {
  content: "\\f0f24";
}

.mdi-share-outline::before {
  content: "\\f0932";
}

.mdi-share-variant::before {
  content: "\\f0497";
}

.mdi-sheep::before {
  content: "\\f0cc6";
}

.mdi-shield::before {
  content: "\\f0498";
}

.mdi-shield-account::before {
  content: "\\f088f";
}

.mdi-shield-account-outline::before {
  content: "\\f0a12";
}

.mdi-shield-airplane::before {
  content: "\\f06bb";
}

.mdi-shield-airplane-outline::before {
  content: "\\f0cc7";
}

.mdi-shield-alert::before {
  content: "\\f0ecc";
}

.mdi-shield-alert-outline::before {
  content: "\\f0ecd";
}

.mdi-shield-car::before {
  content: "\\f0f83";
}

.mdi-shield-check::before {
  content: "\\f0565";
}

.mdi-shield-check-outline::before {
  content: "\\f0cc8";
}

.mdi-shield-cross::before {
  content: "\\f0cc9";
}

.mdi-shield-cross-outline::before {
  content: "\\f0cca";
}

.mdi-shield-edit::before {
  content: "\\f11a0";
}

.mdi-shield-edit-outline::before {
  content: "\\f11a1";
}

.mdi-shield-half::before {
  content: "\\f1360";
}

.mdi-shield-half-full::before {
  content: "\\f0780";
}

.mdi-shield-home::before {
  content: "\\f068a";
}

.mdi-shield-home-outline::before {
  content: "\\f0ccb";
}

.mdi-shield-key::before {
  content: "\\f0bc4";
}

.mdi-shield-key-outline::before {
  content: "\\f0bc5";
}

.mdi-shield-link-variant::before {
  content: "\\f0d33";
}

.mdi-shield-link-variant-outline::before {
  content: "\\f0d34";
}

.mdi-shield-lock::before {
  content: "\\f099d";
}

.mdi-shield-lock-outline::before {
  content: "\\f0ccc";
}

.mdi-shield-off::before {
  content: "\\f099e";
}

.mdi-shield-off-outline::before {
  content: "\\f099c";
}

.mdi-shield-outline::before {
  content: "\\f0499";
}

.mdi-shield-plus::before {
  content: "\\f0ada";
}

.mdi-shield-plus-outline::before {
  content: "\\f0adb";
}

.mdi-shield-refresh::before {
  content: "\\f00aa";
}

.mdi-shield-refresh-outline::before {
  content: "\\f01e0";
}

.mdi-shield-remove::before {
  content: "\\f0adc";
}

.mdi-shield-remove-outline::before {
  content: "\\f0add";
}

.mdi-shield-search::before {
  content: "\\f0d9a";
}

.mdi-shield-star::before {
  content: "\\f113b";
}

.mdi-shield-star-outline::before {
  content: "\\f113c";
}

.mdi-shield-sun::before {
  content: "\\f105d";
}

.mdi-shield-sun-outline::before {
  content: "\\f105e";
}

.mdi-shield-sync::before {
  content: "\\f11a2";
}

.mdi-shield-sync-outline::before {
  content: "\\f11a3";
}

.mdi-ship-wheel::before {
  content: "\\f0833";
}

.mdi-shoe-formal::before {
  content: "\\f0b47";
}

.mdi-shoe-heel::before {
  content: "\\f0b48";
}

.mdi-shoe-print::before {
  content: "\\f0dfa";
}

.mdi-shopping::before {
  content: "\\f049a";
}

.mdi-shopping-music::before {
  content: "\\f049b";
}

.mdi-shopping-outline::before {
  content: "\\f11d5";
}

.mdi-shopping-search::before {
  content: "\\f0f84";
}

.mdi-shovel::before {
  content: "\\f0710";
}

.mdi-shovel-off::before {
  content: "\\f0711";
}

.mdi-shower::before {
  content: "\\f09a0";
}

.mdi-shower-head::before {
  content: "\\f09a1";
}

.mdi-shredder::before {
  content: "\\f049c";
}

.mdi-shuffle::before {
  content: "\\f049d";
}

.mdi-shuffle-disabled::before {
  content: "\\f049e";
}

.mdi-shuffle-variant::before {
  content: "\\f049f";
}

.mdi-shuriken::before {
  content: "\\f137f";
}

.mdi-sigma::before {
  content: "\\f04a0";
}

.mdi-sigma-lower::before {
  content: "\\f062b";
}

.mdi-sign-caution::before {
  content: "\\f04a1";
}

.mdi-sign-direction::before {
  content: "\\f0781";
}

.mdi-sign-direction-minus::before {
  content: "\\f1000";
}

.mdi-sign-direction-plus::before {
  content: "\\f0fdc";
}

.mdi-sign-direction-remove::before {
  content: "\\f0fdd";
}

.mdi-sign-real-estate::before {
  content: "\\f1118";
}

.mdi-sign-text::before {
  content: "\\f0782";
}

.mdi-signal::before {
  content: "\\f04a2";
}

.mdi-signal-2g::before {
  content: "\\f0712";
}

.mdi-signal-3g::before {
  content: "\\f0713";
}

.mdi-signal-4g::before {
  content: "\\f0714";
}

.mdi-signal-5g::before {
  content: "\\f0a6f";
}

.mdi-signal-cellular-1::before {
  content: "\\f08bc";
}

.mdi-signal-cellular-2::before {
  content: "\\f08bd";
}

.mdi-signal-cellular-3::before {
  content: "\\f08be";
}

.mdi-signal-cellular-outline::before {
  content: "\\f08bf";
}

.mdi-signal-distance-variant::before {
  content: "\\f0e64";
}

.mdi-signal-hspa::before {
  content: "\\f0715";
}

.mdi-signal-hspa-plus::before {
  content: "\\f0716";
}

.mdi-signal-off::before {
  content: "\\f0783";
}

.mdi-signal-variant::before {
  content: "\\f060a";
}

.mdi-signature::before {
  content: "\\f0dfb";
}

.mdi-signature-freehand::before {
  content: "\\f0dfc";
}

.mdi-signature-image::before {
  content: "\\f0dfd";
}

.mdi-signature-text::before {
  content: "\\f0dfe";
}

.mdi-silo::before {
  content: "\\f0b49";
}

.mdi-silverware::before {
  content: "\\f04a3";
}

.mdi-silverware-clean::before {
  content: "\\f0fde";
}

.mdi-silverware-fork::before {
  content: "\\f04a4";
}

.mdi-silverware-fork-knife::before {
  content: "\\f0a70";
}

.mdi-silverware-spoon::before {
  content: "\\f04a5";
}

.mdi-silverware-variant::before {
  content: "\\f04a6";
}

.mdi-sim::before {
  content: "\\f04a7";
}

.mdi-sim-alert::before {
  content: "\\f04a8";
}

.mdi-sim-off::before {
  content: "\\f04a9";
}

.mdi-simple-icons::before {
  content: "\\f131d";
}

.mdi-sina-weibo::before {
  content: "\\f0adf";
}

.mdi-sitemap::before {
  content: "\\f04aa";
}

.mdi-size-l::before {
  content: "\\f13a6";
}

.mdi-size-m::before {
  content: "\\f13a5";
}

.mdi-size-s::before {
  content: "\\f13a4";
}

.mdi-size-xl::before {
  content: "\\f13a7";
}

.mdi-size-xs::before {
  content: "\\f13a3";
}

.mdi-size-xxl::before {
  content: "\\f13a8";
}

.mdi-size-xxs::before {
  content: "\\f13a2";
}

.mdi-size-xxxl::before {
  content: "\\f13a9";
}

.mdi-skate::before {
  content: "\\f0d35";
}

.mdi-skew-less::before {
  content: "\\f0d36";
}

.mdi-skew-more::before {
  content: "\\f0d37";
}

.mdi-ski::before {
  content: "\\f1304";
}

.mdi-ski-cross-country::before {
  content: "\\f1305";
}

.mdi-ski-water::before {
  content: "\\f1306";
}

.mdi-skip-backward::before {
  content: "\\f04ab";
}

.mdi-skip-backward-outline::before {
  content: "\\f0f25";
}

.mdi-skip-forward::before {
  content: "\\f04ac";
}

.mdi-skip-forward-outline::before {
  content: "\\f0f26";
}

.mdi-skip-next::before {
  content: "\\f04ad";
}

.mdi-skip-next-circle::before {
  content: "\\f0661";
}

.mdi-skip-next-circle-outline::before {
  content: "\\f0662";
}

.mdi-skip-next-outline::before {
  content: "\\f0f27";
}

.mdi-skip-previous::before {
  content: "\\f04ae";
}

.mdi-skip-previous-circle::before {
  content: "\\f0663";
}

.mdi-skip-previous-circle-outline::before {
  content: "\\f0664";
}

.mdi-skip-previous-outline::before {
  content: "\\f0f28";
}

.mdi-skull::before {
  content: "\\f068c";
}

.mdi-skull-crossbones::before {
  content: "\\f0bc6";
}

.mdi-skull-crossbones-outline::before {
  content: "\\f0bc7";
}

.mdi-skull-outline::before {
  content: "\\f0bc8";
}

.mdi-skype::before {
  content: "\\f04af";
}

.mdi-skype-business::before {
  content: "\\f04b0";
}

.mdi-slack::before {
  content: "\\f04b1";
}

.mdi-slash-forward::before {
  content: "\\f0fdf";
}

.mdi-slash-forward-box::before {
  content: "\\f0fe0";
}

.mdi-sleep::before {
  content: "\\f04b2";
}

.mdi-sleep-off::before {
  content: "\\f04b3";
}

.mdi-slope-downhill::before {
  content: "\\f0dff";
}

.mdi-slope-uphill::before {
  content: "\\f0e00";
}

.mdi-slot-machine::before {
  content: "\\f1114";
}

.mdi-slot-machine-outline::before {
  content: "\\f1115";
}

.mdi-smart-card::before {
  content: "\\f10bd";
}

.mdi-smart-card-outline::before {
  content: "\\f10be";
}

.mdi-smart-card-reader::before {
  content: "\\f10bf";
}

.mdi-smart-card-reader-outline::before {
  content: "\\f10c0";
}

.mdi-smog::before {
  content: "\\f0a71";
}

.mdi-smoke-detector::before {
  content: "\\f0392";
}

.mdi-smoking::before {
  content: "\\f04b4";
}

.mdi-smoking-off::before {
  content: "\\f04b5";
}

.mdi-snapchat::before {
  content: "\\f04b6";
}

.mdi-snowboard::before {
  content: "\\f1307";
}

.mdi-snowflake::before {
  content: "\\f0717";
}

.mdi-snowflake-alert::before {
  content: "\\f0f29";
}

.mdi-snowflake-melt::before {
  content: "\\f12cb";
}

.mdi-snowflake-variant::before {
  content: "\\f0f2a";
}

.mdi-snowman::before {
  content: "\\f04b7";
}

.mdi-soccer::before {
  content: "\\f04b8";
}

.mdi-soccer-field::before {
  content: "\\f0834";
}

.mdi-sofa::before {
  content: "\\f04b9";
}

.mdi-solar-panel::before {
  content: "\\f0d9b";
}

.mdi-solar-panel-large::before {
  content: "\\f0d9c";
}

.mdi-solar-power::before {
  content: "\\f0a72";
}

.mdi-soldering-iron::before {
  content: "\\f1092";
}

.mdi-solid::before {
  content: "\\f068d";
}

.mdi-sony-playstation::before {
  content: "\\f0414";
}

.mdi-sort::before {
  content: "\\f04ba";
}

.mdi-sort-alphabetical-ascending::before {
  content: "\\f05bd";
}

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\f1148";
}

.mdi-sort-alphabetical-descending::before {
  content: "\\f05bf";
}

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\f1149";
}

.mdi-sort-alphabetical-variant::before {
  content: "\\f04bb";
}

.mdi-sort-ascending::before {
  content: "\\f04bc";
}

.mdi-sort-bool-ascending::before {
  content: "\\f1385";
}

.mdi-sort-bool-ascending-variant::before {
  content: "\\f1386";
}

.mdi-sort-bool-descending::before {
  content: "\\f1387";
}

.mdi-sort-bool-descending-variant::before {
  content: "\\f1388";
}

.mdi-sort-descending::before {
  content: "\\f04bd";
}

.mdi-sort-numeric-ascending::before {
  content: "\\f1389";
}

.mdi-sort-numeric-ascending-variant::before {
  content: "\\f090d";
}

.mdi-sort-numeric-descending::before {
  content: "\\f138a";
}

.mdi-sort-numeric-descending-variant::before {
  content: "\\f0ad2";
}

.mdi-sort-numeric-variant::before {
  content: "\\f04be";
}

.mdi-sort-reverse-variant::before {
  content: "\\f033c";
}

.mdi-sort-variant::before {
  content: "\\f04bf";
}

.mdi-sort-variant-lock::before {
  content: "\\f0ccd";
}

.mdi-sort-variant-lock-open::before {
  content: "\\f0cce";
}

.mdi-sort-variant-remove::before {
  content: "\\f1147";
}

.mdi-soundcloud::before {
  content: "\\f04c0";
}

.mdi-source-branch::before {
  content: "\\f062c";
}

.mdi-source-commit::before {
  content: "\\f0718";
}

.mdi-source-commit-end::before {
  content: "\\f0719";
}

.mdi-source-commit-end-local::before {
  content: "\\f071a";
}

.mdi-source-commit-local::before {
  content: "\\f071b";
}

.mdi-source-commit-next-local::before {
  content: "\\f071c";
}

.mdi-source-commit-start::before {
  content: "\\f071d";
}

.mdi-source-commit-start-next-local::before {
  content: "\\f071e";
}

.mdi-source-fork::before {
  content: "\\f04c1";
}

.mdi-source-merge::before {
  content: "\\f062d";
}

.mdi-source-pull::before {
  content: "\\f04c2";
}

.mdi-source-repository::before {
  content: "\\f0ccf";
}

.mdi-source-repository-multiple::before {
  content: "\\f0cd0";
}

.mdi-soy-sauce::before {
  content: "\\f07ee";
}

.mdi-spa::before {
  content: "\\f0cd1";
}

.mdi-spa-outline::before {
  content: "\\f0cd2";
}

.mdi-space-invaders::before {
  content: "\\f0bc9";
}

.mdi-space-station::before {
  content: "\\f1383";
}

.mdi-spade::before {
  content: "\\f0e65";
}

.mdi-speaker::before {
  content: "\\f04c3";
}

.mdi-speaker-bluetooth::before {
  content: "\\f09a2";
}

.mdi-speaker-multiple::before {
  content: "\\f0d38";
}

.mdi-speaker-off::before {
  content: "\\f04c4";
}

.mdi-speaker-wireless::before {
  content: "\\f071f";
}

.mdi-speedometer::before {
  content: "\\f04c5";
}

.mdi-speedometer-medium::before {
  content: "\\f0f85";
}

.mdi-speedometer-slow::before {
  content: "\\f0f86";
}

.mdi-spellcheck::before {
  content: "\\f04c6";
}

.mdi-spider::before {
  content: "\\f11ea";
}

.mdi-spider-thread::before {
  content: "\\f11eb";
}

.mdi-spider-web::before {
  content: "\\f0bca";
}

.mdi-spotify::before {
  content: "\\f04c7";
}

.mdi-spotlight::before {
  content: "\\f04c8";
}

.mdi-spotlight-beam::before {
  content: "\\f04c9";
}

.mdi-spray::before {
  content: "\\f0665";
}

.mdi-spray-bottle::before {
  content: "\\f0ae0";
}

.mdi-sprinkler::before {
  content: "\\f105f";
}

.mdi-sprinkler-variant::before {
  content: "\\f1060";
}

.mdi-sprout::before {
  content: "\\f0e66";
}

.mdi-sprout-outline::before {
  content: "\\f0e67";
}

.mdi-square::before {
  content: "\\f0764";
}

.mdi-square-edit-outline::before {
  content: "\\f090c";
}

.mdi-square-medium::before {
  content: "\\f0a13";
}

.mdi-square-medium-outline::before {
  content: "\\f0a14";
}

.mdi-square-off::before {
  content: "\\f12ee";
}

.mdi-square-off-outline::before {
  content: "\\f12ef";
}

.mdi-square-outline::before {
  content: "\\f0763";
}

.mdi-square-root::before {
  content: "\\f0784";
}

.mdi-square-root-box::before {
  content: "\\f09a3";
}

.mdi-square-small::before {
  content: "\\f0a15";
}

.mdi-squeegee::before {
  content: "\\f0ae1";
}

.mdi-ssh::before {
  content: "\\f08c0";
}

.mdi-stack-exchange::before {
  content: "\\f060b";
}

.mdi-stack-overflow::before {
  content: "\\f04cc";
}

.mdi-stackpath::before {
  content: "\\f0359";
}

.mdi-stadium::before {
  content: "\\f0ff9";
}

.mdi-stadium-variant::before {
  content: "\\f0720";
}

.mdi-stairs::before {
  content: "\\f04cd";
}

.mdi-stairs-box::before {
  content: "\\f139e";
}

.mdi-stairs-down::before {
  content: "\\f12be";
}

.mdi-stairs-up::before {
  content: "\\f12bd";
}

.mdi-stamper::before {
  content: "\\f0d39";
}

.mdi-standard-definition::before {
  content: "\\f07ef";
}

.mdi-star::before {
  content: "\\f04ce";
}

.mdi-star-box::before {
  content: "\\f0a73";
}

.mdi-star-box-multiple::before {
  content: "\\f1286";
}

.mdi-star-box-multiple-outline::before {
  content: "\\f1287";
}

.mdi-star-box-outline::before {
  content: "\\f0a74";
}

.mdi-star-circle::before {
  content: "\\f04cf";
}

.mdi-star-circle-outline::before {
  content: "\\f09a4";
}

.mdi-star-face::before {
  content: "\\f09a5";
}

.mdi-star-four-points::before {
  content: "\\f0ae2";
}

.mdi-star-four-points-outline::before {
  content: "\\f0ae3";
}

.mdi-star-half::before {
  content: "\\f0246";
}

.mdi-star-half-full::before {
  content: "\\f04d0";
}

.mdi-star-off::before {
  content: "\\f04d1";
}

.mdi-star-outline::before {
  content: "\\f04d2";
}

.mdi-star-three-points::before {
  content: "\\f0ae4";
}

.mdi-star-three-points-outline::before {
  content: "\\f0ae5";
}

.mdi-state-machine::before {
  content: "\\f11ef";
}

.mdi-steam::before {
  content: "\\f04d3";
}

.mdi-steering::before {
  content: "\\f04d4";
}

.mdi-steering-off::before {
  content: "\\f090e";
}

.mdi-step-backward::before {
  content: "\\f04d5";
}

.mdi-step-backward-2::before {
  content: "\\f04d6";
}

.mdi-step-forward::before {
  content: "\\f04d7";
}

.mdi-step-forward-2::before {
  content: "\\f04d8";
}

.mdi-stethoscope::before {
  content: "\\f04d9";
}

.mdi-sticker::before {
  content: "\\f1364";
}

.mdi-sticker-alert::before {
  content: "\\f1365";
}

.mdi-sticker-alert-outline::before {
  content: "\\f1366";
}

.mdi-sticker-check::before {
  content: "\\f1367";
}

.mdi-sticker-check-outline::before {
  content: "\\f1368";
}

.mdi-sticker-circle-outline::before {
  content: "\\f05d0";
}

.mdi-sticker-emoji::before {
  content: "\\f0785";
}

.mdi-sticker-minus::before {
  content: "\\f1369";
}

.mdi-sticker-minus-outline::before {
  content: "\\f136a";
}

.mdi-sticker-outline::before {
  content: "\\f136b";
}

.mdi-sticker-plus::before {
  content: "\\f136c";
}

.mdi-sticker-plus-outline::before {
  content: "\\f136d";
}

.mdi-sticker-remove::before {
  content: "\\f136e";
}

.mdi-sticker-remove-outline::before {
  content: "\\f136f";
}

.mdi-stocking::before {
  content: "\\f04da";
}

.mdi-stomach::before {
  content: "\\f1093";
}

.mdi-stop::before {
  content: "\\f04db";
}

.mdi-stop-circle::before {
  content: "\\f0666";
}

.mdi-stop-circle-outline::before {
  content: "\\f0667";
}

.mdi-store::before {
  content: "\\f04dc";
}

.mdi-store-24-hour::before {
  content: "\\f04dd";
}

.mdi-store-outline::before {
  content: "\\f1361";
}

.mdi-storefront::before {
  content: "\\f07c7";
}

.mdi-storefront-outline::before {
  content: "\\f10c1";
}

.mdi-stove::before {
  content: "\\f04de";
}

.mdi-strategy::before {
  content: "\\f11d6";
}

.mdi-stretch-to-page::before {
  content: "\\f0f2b";
}

.mdi-stretch-to-page-outline::before {
  content: "\\f0f2c";
}

.mdi-string-lights::before {
  content: "\\f12ba";
}

.mdi-string-lights-off::before {
  content: "\\f12bb";
}

.mdi-subdirectory-arrow-left::before {
  content: "\\f060c";
}

.mdi-subdirectory-arrow-right::before {
  content: "\\f060d";
}

.mdi-subtitles::before {
  content: "\\f0a16";
}

.mdi-subtitles-outline::before {
  content: "\\f0a17";
}

.mdi-subway::before {
  content: "\\f06ac";
}

.mdi-subway-alert-variant::before {
  content: "\\f0d9d";
}

.mdi-subway-variant::before {
  content: "\\f04df";
}

.mdi-summit::before {
  content: "\\f0786";
}

.mdi-sunglasses::before {
  content: "\\f04e0";
}

.mdi-surround-sound::before {
  content: "\\f05c5";
}

.mdi-surround-sound-2-0::before {
  content: "\\f07f0";
}

.mdi-surround-sound-3-1::before {
  content: "\\f07f1";
}

.mdi-surround-sound-5-1::before {
  content: "\\f07f2";
}

.mdi-surround-sound-7-1::before {
  content: "\\f07f3";
}

.mdi-svg::before {
  content: "\\f0721";
}

.mdi-swap-horizontal::before {
  content: "\\f04e1";
}

.mdi-swap-horizontal-bold::before {
  content: "\\f0bcd";
}

.mdi-swap-horizontal-circle::before {
  content: "\\f0fe1";
}

.mdi-swap-horizontal-circle-outline::before {
  content: "\\f0fe2";
}

.mdi-swap-horizontal-variant::before {
  content: "\\f08c1";
}

.mdi-swap-vertical::before {
  content: "\\f04e2";
}

.mdi-swap-vertical-bold::before {
  content: "\\f0bce";
}

.mdi-swap-vertical-circle::before {
  content: "\\f0fe3";
}

.mdi-swap-vertical-circle-outline::before {
  content: "\\f0fe4";
}

.mdi-swap-vertical-variant::before {
  content: "\\f08c2";
}

.mdi-swim::before {
  content: "\\f04e3";
}

.mdi-switch::before {
  content: "\\f04e4";
}

.mdi-sword::before {
  content: "\\f04e5";
}

.mdi-sword-cross::before {
  content: "\\f0787";
}

.mdi-syllabary-hangul::before {
  content: "\\f1333";
}

.mdi-syllabary-hiragana::before {
  content: "\\f1334";
}

.mdi-syllabary-katakana::before {
  content: "\\f1335";
}

.mdi-syllabary-katakana-half-width::before {
  content: "\\f1336";
}

.mdi-symfony::before {
  content: "\\f0ae6";
}

.mdi-sync::before {
  content: "\\f04e6";
}

.mdi-sync-alert::before {
  content: "\\f04e7";
}

.mdi-sync-circle::before {
  content: "\\f1378";
}

.mdi-sync-off::before {
  content: "\\f04e8";
}

.mdi-tab::before {
  content: "\\f04e9";
}

.mdi-tab-minus::before {
  content: "\\f0b4b";
}

.mdi-tab-plus::before {
  content: "\\f075c";
}

.mdi-tab-remove::before {
  content: "\\f0b4c";
}

.mdi-tab-unselected::before {
  content: "\\f04ea";
}

.mdi-table::before {
  content: "\\f04eb";
}

.mdi-table-border::before {
  content: "\\f0a18";
}

.mdi-table-chair::before {
  content: "\\f1061";
}

.mdi-table-column::before {
  content: "\\f0835";
}

.mdi-table-column-plus-after::before {
  content: "\\f04ec";
}

.mdi-table-column-plus-before::before {
  content: "\\f04ed";
}

.mdi-table-column-remove::before {
  content: "\\f04ee";
}

.mdi-table-column-width::before {
  content: "\\f04ef";
}

.mdi-table-edit::before {
  content: "\\f04f0";
}

.mdi-table-eye::before {
  content: "\\f1094";
}

.mdi-table-furniture::before {
  content: "\\f05bc";
}

.mdi-table-headers-eye::before {
  content: "\\f121d";
}

.mdi-table-headers-eye-off::before {
  content: "\\f121e";
}

.mdi-table-large::before {
  content: "\\f04f1";
}

.mdi-table-large-plus::before {
  content: "\\f0f87";
}

.mdi-table-large-remove::before {
  content: "\\f0f88";
}

.mdi-table-merge-cells::before {
  content: "\\f09a6";
}

.mdi-table-of-contents::before {
  content: "\\f0836";
}

.mdi-table-plus::before {
  content: "\\f0a75";
}

.mdi-table-refresh::before {
  content: "\\f13a0";
}

.mdi-table-remove::before {
  content: "\\f0a76";
}

.mdi-table-row::before {
  content: "\\f0837";
}

.mdi-table-row-height::before {
  content: "\\f04f2";
}

.mdi-table-row-plus-after::before {
  content: "\\f04f3";
}

.mdi-table-row-plus-before::before {
  content: "\\f04f4";
}

.mdi-table-row-remove::before {
  content: "\\f04f5";
}

.mdi-table-search::before {
  content: "\\f090f";
}

.mdi-table-settings::before {
  content: "\\f0838";
}

.mdi-table-sync::before {
  content: "\\f13a1";
}

.mdi-table-tennis::before {
  content: "\\f0e68";
}

.mdi-tablet::before {
  content: "\\f04f6";
}

.mdi-tablet-android::before {
  content: "\\f04f7";
}

.mdi-tablet-cellphone::before {
  content: "\\f09a7";
}

.mdi-tablet-dashboard::before {
  content: "\\f0ece";
}

.mdi-tablet-ipad::before {
  content: "\\f04f8";
}

.mdi-taco::before {
  content: "\\f0762";
}

.mdi-tag::before {
  content: "\\f04f9";
}

.mdi-tag-faces::before {
  content: "\\f04fa";
}

.mdi-tag-heart::before {
  content: "\\f068b";
}

.mdi-tag-heart-outline::before {
  content: "\\f0bcf";
}

.mdi-tag-minus::before {
  content: "\\f0910";
}

.mdi-tag-minus-outline::before {
  content: "\\f121f";
}

.mdi-tag-multiple::before {
  content: "\\f04fb";
}

.mdi-tag-multiple-outline::before {
  content: "\\f12f7";
}

.mdi-tag-off::before {
  content: "\\f1220";
}

.mdi-tag-off-outline::before {
  content: "\\f1221";
}

.mdi-tag-outline::before {
  content: "\\f04fc";
}

.mdi-tag-plus::before {
  content: "\\f0722";
}

.mdi-tag-plus-outline::before {
  content: "\\f1222";
}

.mdi-tag-remove::before {
  content: "\\f0723";
}

.mdi-tag-remove-outline::before {
  content: "\\f1223";
}

.mdi-tag-text::before {
  content: "\\f1224";
}

.mdi-tag-text-outline::before {
  content: "\\f04fd";
}

.mdi-tank::before {
  content: "\\f0d3a";
}

.mdi-tanker-truck::before {
  content: "\\f0fe5";
}

.mdi-tape-measure::before {
  content: "\\f0b4d";
}

.mdi-target::before {
  content: "\\f04fe";
}

.mdi-target-account::before {
  content: "\\f0bd0";
}

.mdi-target-variant::before {
  content: "\\f0a77";
}

.mdi-taxi::before {
  content: "\\f04ff";
}

.mdi-tea::before {
  content: "\\f0d9e";
}

.mdi-tea-outline::before {
  content: "\\f0d9f";
}

.mdi-teach::before {
  content: "\\f0890";
}

.mdi-teamviewer::before {
  content: "\\f0500";
}

.mdi-telegram::before {
  content: "\\f0501";
}

.mdi-telescope::before {
  content: "\\f0b4e";
}

.mdi-television::before {
  content: "\\f0502";
}

.mdi-television-ambient-light::before {
  content: "\\f1356";
}

.mdi-television-box::before {
  content: "\\f0839";
}

.mdi-television-classic::before {
  content: "\\f07f4";
}

.mdi-television-classic-off::before {
  content: "\\f083a";
}

.mdi-television-clean::before {
  content: "\\f1110";
}

.mdi-television-guide::before {
  content: "\\f0503";
}

.mdi-television-off::before {
  content: "\\f083b";
}

.mdi-television-pause::before {
  content: "\\f0f89";
}

.mdi-television-play::before {
  content: "\\f0ecf";
}

.mdi-television-stop::before {
  content: "\\f0f8a";
}

.mdi-temperature-celsius::before {
  content: "\\f0504";
}

.mdi-temperature-fahrenheit::before {
  content: "\\f0505";
}

.mdi-temperature-kelvin::before {
  content: "\\f0506";
}

.mdi-tennis::before {
  content: "\\f0da0";
}

.mdi-tennis-ball::before {
  content: "\\f0507";
}

.mdi-tent::before {
  content: "\\f0508";
}

.mdi-terraform::before {
  content: "\\f1062";
}

.mdi-terrain::before {
  content: "\\f0509";
}

.mdi-test-tube::before {
  content: "\\f0668";
}

.mdi-test-tube-empty::before {
  content: "\\f0911";
}

.mdi-test-tube-off::before {
  content: "\\f0912";
}

.mdi-text::before {
  content: "\\f09a8";
}

.mdi-text-box::before {
  content: "\\f021a";
}

.mdi-text-box-check::before {
  content: "\\f0ea6";
}

.mdi-text-box-check-outline::before {
  content: "\\f0ea7";
}

.mdi-text-box-minus::before {
  content: "\\f0ea8";
}

.mdi-text-box-minus-outline::before {
  content: "\\f0ea9";
}

.mdi-text-box-multiple::before {
  content: "\\f0ab7";
}

.mdi-text-box-multiple-outline::before {
  content: "\\f0ab8";
}

.mdi-text-box-outline::before {
  content: "\\f09ed";
}

.mdi-text-box-plus::before {
  content: "\\f0eaa";
}

.mdi-text-box-plus-outline::before {
  content: "\\f0eab";
}

.mdi-text-box-remove::before {
  content: "\\f0eac";
}

.mdi-text-box-remove-outline::before {
  content: "\\f0ead";
}

.mdi-text-box-search::before {
  content: "\\f0eae";
}

.mdi-text-box-search-outline::before {
  content: "\\f0eaf";
}

.mdi-text-recognition::before {
  content: "\\f113d";
}

.mdi-text-shadow::before {
  content: "\\f0669";
}

.mdi-text-short::before {
  content: "\\f09a9";
}

.mdi-text-subject::before {
  content: "\\f09aa";
}

.mdi-text-to-speech::before {
  content: "\\f050a";
}

.mdi-text-to-speech-off::before {
  content: "\\f050b";
}

.mdi-textarea::before {
  content: "\\f1095";
}

.mdi-textbox::before {
  content: "\\f060e";
}

.mdi-textbox-lock::before {
  content: "\\f135d";
}

.mdi-textbox-password::before {
  content: "\\f07f5";
}

.mdi-texture::before {
  content: "\\f050c";
}

.mdi-texture-box::before {
  content: "\\f0fe6";
}

.mdi-theater::before {
  content: "\\f050d";
}

.mdi-theme-light-dark::before {
  content: "\\f050e";
}

.mdi-thermometer::before {
  content: "\\f050f";
}

.mdi-thermometer-alert::before {
  content: "\\f0e01";
}

.mdi-thermometer-chevron-down::before {
  content: "\\f0e02";
}

.mdi-thermometer-chevron-up::before {
  content: "\\f0e03";
}

.mdi-thermometer-high::before {
  content: "\\f10c2";
}

.mdi-thermometer-lines::before {
  content: "\\f0510";
}

.mdi-thermometer-low::before {
  content: "\\f10c3";
}

.mdi-thermometer-minus::before {
  content: "\\f0e04";
}

.mdi-thermometer-plus::before {
  content: "\\f0e05";
}

.mdi-thermostat::before {
  content: "\\f0393";
}

.mdi-thermostat-box::before {
  content: "\\f0891";
}

.mdi-thought-bubble::before {
  content: "\\f07f6";
}

.mdi-thought-bubble-outline::before {
  content: "\\f07f7";
}

.mdi-thumb-down::before {
  content: "\\f0511";
}

.mdi-thumb-down-outline::before {
  content: "\\f0512";
}

.mdi-thumb-up::before {
  content: "\\f0513";
}

.mdi-thumb-up-outline::before {
  content: "\\f0514";
}

.mdi-thumbs-up-down::before {
  content: "\\f0515";
}

.mdi-ticket::before {
  content: "\\f0516";
}

.mdi-ticket-account::before {
  content: "\\f0517";
}

.mdi-ticket-confirmation::before {
  content: "\\f0518";
}

.mdi-ticket-confirmation-outline::before {
  content: "\\f13aa";
}

.mdi-ticket-outline::before {
  content: "\\f0913";
}

.mdi-ticket-percent::before {
  content: "\\f0724";
}

.mdi-tie::before {
  content: "\\f0519";
}

.mdi-tilde::before {
  content: "\\f0725";
}

.mdi-timelapse::before {
  content: "\\f051a";
}

.mdi-timeline::before {
  content: "\\f0bd1";
}

.mdi-timeline-alert::before {
  content: "\\f0f95";
}

.mdi-timeline-alert-outline::before {
  content: "\\f0f98";
}

.mdi-timeline-clock::before {
  content: "\\f11fb";
}

.mdi-timeline-clock-outline::before {
  content: "\\f11fc";
}

.mdi-timeline-help::before {
  content: "\\f0f99";
}

.mdi-timeline-help-outline::before {
  content: "\\f0f9a";
}

.mdi-timeline-outline::before {
  content: "\\f0bd2";
}

.mdi-timeline-plus::before {
  content: "\\f0f96";
}

.mdi-timeline-plus-outline::before {
  content: "\\f0f97";
}

.mdi-timeline-text::before {
  content: "\\f0bd3";
}

.mdi-timeline-text-outline::before {
  content: "\\f0bd4";
}

.mdi-timer::before {
  content: "\\f13ab";
}

.mdi-timer-10::before {
  content: "\\f051c";
}

.mdi-timer-3::before {
  content: "\\f051d";
}

.mdi-timer-off::before {
  content: "\\f13ac";
}

.mdi-timer-off-outline::before {
  content: "\\f051e";
}

.mdi-timer-outline::before {
  content: "\\f051b";
}

.mdi-timer-sand::before {
  content: "\\f051f";
}

.mdi-timer-sand-empty::before {
  content: "\\f06ad";
}

.mdi-timer-sand-full::before {
  content: "\\f078c";
}

.mdi-timetable::before {
  content: "\\f0520";
}

.mdi-toaster::before {
  content: "\\f1063";
}

.mdi-toaster-off::before {
  content: "\\f11b7";
}

.mdi-toaster-oven::before {
  content: "\\f0cd3";
}

.mdi-toggle-switch::before {
  content: "\\f0521";
}

.mdi-toggle-switch-off::before {
  content: "\\f0522";
}

.mdi-toggle-switch-off-outline::before {
  content: "\\f0a19";
}

.mdi-toggle-switch-outline::before {
  content: "\\f0a1a";
}

.mdi-toilet::before {
  content: "\\f09ab";
}

.mdi-toolbox::before {
  content: "\\f09ac";
}

.mdi-toolbox-outline::before {
  content: "\\f09ad";
}

.mdi-tools::before {
  content: "\\f1064";
}

.mdi-tooltip::before {
  content: "\\f0523";
}

.mdi-tooltip-account::before {
  content: "\\f000c";
}

.mdi-tooltip-edit::before {
  content: "\\f0524";
}

.mdi-tooltip-edit-outline::before {
  content: "\\f12c5";
}

.mdi-tooltip-image::before {
  content: "\\f0525";
}

.mdi-tooltip-image-outline::before {
  content: "\\f0bd5";
}

.mdi-tooltip-outline::before {
  content: "\\f0526";
}

.mdi-tooltip-plus::before {
  content: "\\f0bd6";
}

.mdi-tooltip-plus-outline::before {
  content: "\\f0527";
}

.mdi-tooltip-text::before {
  content: "\\f0528";
}

.mdi-tooltip-text-outline::before {
  content: "\\f0bd7";
}

.mdi-tooth::before {
  content: "\\f08c3";
}

.mdi-tooth-outline::before {
  content: "\\f0529";
}

.mdi-toothbrush::before {
  content: "\\f1129";
}

.mdi-toothbrush-electric::before {
  content: "\\f112c";
}

.mdi-toothbrush-paste::before {
  content: "\\f112a";
}

.mdi-tortoise::before {
  content: "\\f0d3b";
}

.mdi-toslink::before {
  content: "\\f12b8";
}

.mdi-tournament::before {
  content: "\\f09ae";
}

.mdi-tow-truck::before {
  content: "\\f083c";
}

.mdi-tower-beach::before {
  content: "\\f0681";
}

.mdi-tower-fire::before {
  content: "\\f0682";
}

.mdi-toy-brick::before {
  content: "\\f1288";
}

.mdi-toy-brick-marker::before {
  content: "\\f1289";
}

.mdi-toy-brick-marker-outline::before {
  content: "\\f128a";
}

.mdi-toy-brick-minus::before {
  content: "\\f128b";
}

.mdi-toy-brick-minus-outline::before {
  content: "\\f128c";
}

.mdi-toy-brick-outline::before {
  content: "\\f128d";
}

.mdi-toy-brick-plus::before {
  content: "\\f128e";
}

.mdi-toy-brick-plus-outline::before {
  content: "\\f128f";
}

.mdi-toy-brick-remove::before {
  content: "\\f1290";
}

.mdi-toy-brick-remove-outline::before {
  content: "\\f1291";
}

.mdi-toy-brick-search::before {
  content: "\\f1292";
}

.mdi-toy-brick-search-outline::before {
  content: "\\f1293";
}

.mdi-track-light::before {
  content: "\\f0914";
}

.mdi-trackpad::before {
  content: "\\f07f8";
}

.mdi-trackpad-lock::before {
  content: "\\f0933";
}

.mdi-tractor::before {
  content: "\\f0892";
}

.mdi-trademark::before {
  content: "\\f0a78";
}

.mdi-traffic-cone::before {
  content: "\\f137c";
}

.mdi-traffic-light::before {
  content: "\\f052b";
}

.mdi-train::before {
  content: "\\f052c";
}

.mdi-train-car::before {
  content: "\\f0bd8";
}

.mdi-train-variant::before {
  content: "\\f08c4";
}

.mdi-tram::before {
  content: "\\f052d";
}

.mdi-tram-side::before {
  content: "\\f0fe7";
}

.mdi-transcribe::before {
  content: "\\f052e";
}

.mdi-transcribe-close::before {
  content: "\\f052f";
}

.mdi-transfer::before {
  content: "\\f1065";
}

.mdi-transfer-down::before {
  content: "\\f0da1";
}

.mdi-transfer-left::before {
  content: "\\f0da2";
}

.mdi-transfer-right::before {
  content: "\\f0530";
}

.mdi-transfer-up::before {
  content: "\\f0da3";
}

.mdi-transit-connection::before {
  content: "\\f0d3c";
}

.mdi-transit-connection-variant::before {
  content: "\\f0d3d";
}

.mdi-transit-detour::before {
  content: "\\f0f8b";
}

.mdi-transit-transfer::before {
  content: "\\f06ae";
}

.mdi-transition::before {
  content: "\\f0915";
}

.mdi-transition-masked::before {
  content: "\\f0916";
}

.mdi-translate::before {
  content: "\\f05ca";
}

.mdi-translate-off::before {
  content: "\\f0e06";
}

.mdi-transmission-tower::before {
  content: "\\f0d3e";
}

.mdi-trash-can::before {
  content: "\\f0a79";
}

.mdi-trash-can-outline::before {
  content: "\\f0a7a";
}

.mdi-tray::before {
  content: "\\f1294";
}

.mdi-tray-alert::before {
  content: "\\f1295";
}

.mdi-tray-full::before {
  content: "\\f1296";
}

.mdi-tray-minus::before {
  content: "\\f1297";
}

.mdi-tray-plus::before {
  content: "\\f1298";
}

.mdi-tray-remove::before {
  content: "\\f1299";
}

.mdi-treasure-chest::before {
  content: "\\f0726";
}

.mdi-tree::before {
  content: "\\f0531";
}

.mdi-tree-outline::before {
  content: "\\f0e69";
}

.mdi-trello::before {
  content: "\\f0532";
}

.mdi-trending-down::before {
  content: "\\f0533";
}

.mdi-trending-neutral::before {
  content: "\\f0534";
}

.mdi-trending-up::before {
  content: "\\f0535";
}

.mdi-triangle::before {
  content: "\\f0536";
}

.mdi-triangle-outline::before {
  content: "\\f0537";
}

.mdi-triforce::before {
  content: "\\f0bd9";
}

.mdi-trophy::before {
  content: "\\f0538";
}

.mdi-trophy-award::before {
  content: "\\f0539";
}

.mdi-trophy-broken::before {
  content: "\\f0da4";
}

.mdi-trophy-outline::before {
  content: "\\f053a";
}

.mdi-trophy-variant::before {
  content: "\\f053b";
}

.mdi-trophy-variant-outline::before {
  content: "\\f053c";
}

.mdi-truck::before {
  content: "\\f053d";
}

.mdi-truck-check::before {
  content: "\\f0cd4";
}

.mdi-truck-check-outline::before {
  content: "\\f129a";
}

.mdi-truck-delivery::before {
  content: "\\f053e";
}

.mdi-truck-delivery-outline::before {
  content: "\\f129b";
}

.mdi-truck-fast::before {
  content: "\\f0788";
}

.mdi-truck-fast-outline::before {
  content: "\\f129c";
}

.mdi-truck-outline::before {
  content: "\\f129d";
}

.mdi-truck-trailer::before {
  content: "\\f0727";
}

.mdi-trumpet::before {
  content: "\\f1096";
}

.mdi-tshirt-crew::before {
  content: "\\f0a7b";
}

.mdi-tshirt-crew-outline::before {
  content: "\\f053f";
}

.mdi-tshirt-v::before {
  content: "\\f0a7c";
}

.mdi-tshirt-v-outline::before {
  content: "\\f0540";
}

.mdi-tumble-dryer::before {
  content: "\\f0917";
}

.mdi-tumble-dryer-alert::before {
  content: "\\f11ba";
}

.mdi-tumble-dryer-off::before {
  content: "\\f11bb";
}

.mdi-tune::before {
  content: "\\f062e";
}

.mdi-tune-vertical::before {
  content: "\\f066a";
}

.mdi-turnstile::before {
  content: "\\f0cd5";
}

.mdi-turnstile-outline::before {
  content: "\\f0cd6";
}

.mdi-turtle::before {
  content: "\\f0cd7";
}

.mdi-twitch::before {
  content: "\\f0543";
}

.mdi-twitter::before {
  content: "\\f0544";
}

.mdi-twitter-retweet::before {
  content: "\\f0547";
}

.mdi-two-factor-authentication::before {
  content: "\\f09af";
}

.mdi-typewriter::before {
  content: "\\f0f2d";
}

.mdi-ubisoft::before {
  content: "\\f0bda";
}

.mdi-ubuntu::before {
  content: "\\f0548";
}

.mdi-ufo::before {
  content: "\\f10c4";
}

.mdi-ufo-outline::before {
  content: "\\f10c5";
}

.mdi-ultra-high-definition::before {
  content: "\\f07f9";
}

.mdi-umbraco::before {
  content: "\\f0549";
}

.mdi-umbrella::before {
  content: "\\f054a";
}

.mdi-umbrella-closed::before {
  content: "\\f09b0";
}

.mdi-umbrella-outline::before {
  content: "\\f054b";
}

.mdi-undo::before {
  content: "\\f054c";
}

.mdi-undo-variant::before {
  content: "\\f054d";
}

.mdi-unfold-less-horizontal::before {
  content: "\\f054e";
}

.mdi-unfold-less-vertical::before {
  content: "\\f0760";
}

.mdi-unfold-more-horizontal::before {
  content: "\\f054f";
}

.mdi-unfold-more-vertical::before {
  content: "\\f0761";
}

.mdi-ungroup::before {
  content: "\\f0550";
}

.mdi-unicode::before {
  content: "\\f0ed0";
}

.mdi-unity::before {
  content: "\\f06af";
}

.mdi-unreal::before {
  content: "\\f09b1";
}

.mdi-untappd::before {
  content: "\\f0551";
}

.mdi-update::before {
  content: "\\f06b0";
}

.mdi-upload::before {
  content: "\\f0552";
}

.mdi-upload-lock::before {
  content: "\\f1373";
}

.mdi-upload-lock-outline::before {
  content: "\\f1374";
}

.mdi-upload-multiple::before {
  content: "\\f083d";
}

.mdi-upload-network::before {
  content: "\\f06f6";
}

.mdi-upload-network-outline::before {
  content: "\\f0cd8";
}

.mdi-upload-off::before {
  content: "\\f10c6";
}

.mdi-upload-off-outline::before {
  content: "\\f10c7";
}

.mdi-upload-outline::before {
  content: "\\f0e07";
}

.mdi-usb::before {
  content: "\\f0553";
}

.mdi-usb-flash-drive::before {
  content: "\\f129e";
}

.mdi-usb-flash-drive-outline::before {
  content: "\\f129f";
}

.mdi-usb-port::before {
  content: "\\f11f0";
}

.mdi-valve::before {
  content: "\\f1066";
}

.mdi-valve-closed::before {
  content: "\\f1067";
}

.mdi-valve-open::before {
  content: "\\f1068";
}

.mdi-van-passenger::before {
  content: "\\f07fa";
}

.mdi-van-utility::before {
  content: "\\f07fb";
}

.mdi-vanish::before {
  content: "\\f07fc";
}

.mdi-vanity-light::before {
  content: "\\f11e1";
}

.mdi-variable::before {
  content: "\\f0ae7";
}

.mdi-variable-box::before {
  content: "\\f1111";
}

.mdi-vector-arrange-above::before {
  content: "\\f0554";
}

.mdi-vector-arrange-below::before {
  content: "\\f0555";
}

.mdi-vector-bezier::before {
  content: "\\f0ae8";
}

.mdi-vector-circle::before {
  content: "\\f0556";
}

.mdi-vector-circle-variant::before {
  content: "\\f0557";
}

.mdi-vector-combine::before {
  content: "\\f0558";
}

.mdi-vector-curve::before {
  content: "\\f0559";
}

.mdi-vector-difference::before {
  content: "\\f055a";
}

.mdi-vector-difference-ab::before {
  content: "\\f055b";
}

.mdi-vector-difference-ba::before {
  content: "\\f055c";
}

.mdi-vector-ellipse::before {
  content: "\\f0893";
}

.mdi-vector-intersection::before {
  content: "\\f055d";
}

.mdi-vector-line::before {
  content: "\\f055e";
}

.mdi-vector-link::before {
  content: "\\f0fe8";
}

.mdi-vector-point::before {
  content: "\\f055f";
}

.mdi-vector-polygon::before {
  content: "\\f0560";
}

.mdi-vector-polyline::before {
  content: "\\f0561";
}

.mdi-vector-polyline-edit::before {
  content: "\\f1225";
}

.mdi-vector-polyline-minus::before {
  content: "\\f1226";
}

.mdi-vector-polyline-plus::before {
  content: "\\f1227";
}

.mdi-vector-polyline-remove::before {
  content: "\\f1228";
}

.mdi-vector-radius::before {
  content: "\\f074a";
}

.mdi-vector-rectangle::before {
  content: "\\f05c6";
}

.mdi-vector-selection::before {
  content: "\\f0562";
}

.mdi-vector-square::before {
  content: "\\f0001";
}

.mdi-vector-triangle::before {
  content: "\\f0563";
}

.mdi-vector-union::before {
  content: "\\f0564";
}

.mdi-vhs::before {
  content: "\\f0a1b";
}

.mdi-vibrate::before {
  content: "\\f0566";
}

.mdi-vibrate-off::before {
  content: "\\f0cd9";
}

.mdi-video::before {
  content: "\\f0567";
}

.mdi-video-3d::before {
  content: "\\f07fd";
}

.mdi-video-3d-variant::before {
  content: "\\f0ed1";
}

.mdi-video-4k-box::before {
  content: "\\f083e";
}

.mdi-video-account::before {
  content: "\\f0919";
}

.mdi-video-box::before {
  content: "\\f00fd";
}

.mdi-video-box-off::before {
  content: "\\f00fe";
}

.mdi-video-check::before {
  content: "\\f1069";
}

.mdi-video-check-outline::before {
  content: "\\f106a";
}

.mdi-video-image::before {
  content: "\\f091a";
}

.mdi-video-input-antenna::before {
  content: "\\f083f";
}

.mdi-video-input-component::before {
  content: "\\f0840";
}

.mdi-video-input-hdmi::before {
  content: "\\f0841";
}

.mdi-video-input-scart::before {
  content: "\\f0f8c";
}

.mdi-video-input-svideo::before {
  content: "\\f0842";
}

.mdi-video-minus::before {
  content: "\\f09b2";
}

.mdi-video-minus-outline::before {
  content: "\\f02ba";
}

.mdi-video-off::before {
  content: "\\f0568";
}

.mdi-video-off-outline::before {
  content: "\\f0bdb";
}

.mdi-video-outline::before {
  content: "\\f0bdc";
}

.mdi-video-plus::before {
  content: "\\f09b3";
}

.mdi-video-plus-outline::before {
  content: "\\f01d3";
}

.mdi-video-stabilization::before {
  content: "\\f091b";
}

.mdi-video-switch::before {
  content: "\\f0569";
}

.mdi-video-switch-outline::before {
  content: "\\f0790";
}

.mdi-video-vintage::before {
  content: "\\f0a1c";
}

.mdi-video-wireless::before {
  content: "\\f0ed2";
}

.mdi-video-wireless-outline::before {
  content: "\\f0ed3";
}

.mdi-view-agenda::before {
  content: "\\f056a";
}

.mdi-view-agenda-outline::before {
  content: "\\f11d8";
}

.mdi-view-array::before {
  content: "\\f056b";
}

.mdi-view-carousel::before {
  content: "\\f056c";
}

.mdi-view-column::before {
  content: "\\f056d";
}

.mdi-view-comfy::before {
  content: "\\f0e6a";
}

.mdi-view-compact::before {
  content: "\\f0e6b";
}

.mdi-view-compact-outline::before {
  content: "\\f0e6c";
}

.mdi-view-dashboard::before {
  content: "\\f056e";
}

.mdi-view-dashboard-outline::before {
  content: "\\f0a1d";
}

.mdi-view-dashboard-variant::before {
  content: "\\f0843";
}

.mdi-view-day::before {
  content: "\\f056f";
}

.mdi-view-grid::before {
  content: "\\f0570";
}

.mdi-view-grid-outline::before {
  content: "\\f11d9";
}

.mdi-view-grid-plus::before {
  content: "\\f0f8d";
}

.mdi-view-grid-plus-outline::before {
  content: "\\f11da";
}

.mdi-view-headline::before {
  content: "\\f0571";
}

.mdi-view-list::before {
  content: "\\f0572";
}

.mdi-view-module::before {
  content: "\\f0573";
}

.mdi-view-parallel::before {
  content: "\\f0728";
}

.mdi-view-quilt::before {
  content: "\\f0574";
}

.mdi-view-sequential::before {
  content: "\\f0729";
}

.mdi-view-split-horizontal::before {
  content: "\\f0bcb";
}

.mdi-view-split-vertical::before {
  content: "\\f0bcc";
}

.mdi-view-stream::before {
  content: "\\f0575";
}

.mdi-view-week::before {
  content: "\\f0576";
}

.mdi-vimeo::before {
  content: "\\f0577";
}

.mdi-violin::before {
  content: "\\f060f";
}

.mdi-virtual-reality::before {
  content: "\\f0894";
}

.mdi-vk::before {
  content: "\\f0579";
}

.mdi-vlc::before {
  content: "\\f057c";
}

.mdi-voice-off::before {
  content: "\\f0ed4";
}

.mdi-voicemail::before {
  content: "\\f057d";
}

.mdi-volleyball::before {
  content: "\\f09b4";
}

.mdi-volume-high::before {
  content: "\\f057e";
}

.mdi-volume-low::before {
  content: "\\f057f";
}

.mdi-volume-medium::before {
  content: "\\f0580";
}

.mdi-volume-minus::before {
  content: "\\f075e";
}

.mdi-volume-mute::before {
  content: "\\f075f";
}

.mdi-volume-off::before {
  content: "\\f0581";
}

.mdi-volume-plus::before {
  content: "\\f075d";
}

.mdi-volume-source::before {
  content: "\\f1120";
}

.mdi-volume-variant-off::before {
  content: "\\f0e08";
}

.mdi-volume-vibrate::before {
  content: "\\f1121";
}

.mdi-vote::before {
  content: "\\f0a1f";
}

.mdi-vote-outline::before {
  content: "\\f0a20";
}

.mdi-vpn::before {
  content: "\\f0582";
}

.mdi-vuejs::before {
  content: "\\f0844";
}

.mdi-vuetify::before {
  content: "\\f0e6d";
}

.mdi-walk::before {
  content: "\\f0583";
}

.mdi-wall::before {
  content: "\\f07fe";
}

.mdi-wall-sconce::before {
  content: "\\f091c";
}

.mdi-wall-sconce-flat::before {
  content: "\\f091d";
}

.mdi-wall-sconce-flat-variant::before {
  content: "\\f041c";
}

.mdi-wall-sconce-round::before {
  content: "\\f0748";
}

.mdi-wall-sconce-round-variant::before {
  content: "\\f091e";
}

.mdi-wallet::before {
  content: "\\f0584";
}

.mdi-wallet-giftcard::before {
  content: "\\f0585";
}

.mdi-wallet-membership::before {
  content: "\\f0586";
}

.mdi-wallet-outline::before {
  content: "\\f0bdd";
}

.mdi-wallet-plus::before {
  content: "\\f0f8e";
}

.mdi-wallet-plus-outline::before {
  content: "\\f0f8f";
}

.mdi-wallet-travel::before {
  content: "\\f0587";
}

.mdi-wallpaper::before {
  content: "\\f0e09";
}

.mdi-wan::before {
  content: "\\f0588";
}

.mdi-wardrobe::before {
  content: "\\f0f90";
}

.mdi-wardrobe-outline::before {
  content: "\\f0f91";
}

.mdi-warehouse::before {
  content: "\\f0f81";
}

.mdi-washing-machine::before {
  content: "\\f072a";
}

.mdi-washing-machine-alert::before {
  content: "\\f11bc";
}

.mdi-washing-machine-off::before {
  content: "\\f11bd";
}

.mdi-watch::before {
  content: "\\f0589";
}

.mdi-watch-export::before {
  content: "\\f058a";
}

.mdi-watch-export-variant::before {
  content: "\\f0895";
}

.mdi-watch-import::before {
  content: "\\f058b";
}

.mdi-watch-import-variant::before {
  content: "\\f0896";
}

.mdi-watch-variant::before {
  content: "\\f0897";
}

.mdi-watch-vibrate::before {
  content: "\\f06b1";
}

.mdi-watch-vibrate-off::before {
  content: "\\f0cda";
}

.mdi-water::before {
  content: "\\f058c";
}

.mdi-water-boiler::before {
  content: "\\f0f92";
}

.mdi-water-boiler-alert::before {
  content: "\\f11b3";
}

.mdi-water-boiler-off::before {
  content: "\\f11b4";
}

.mdi-water-off::before {
  content: "\\f058d";
}

.mdi-water-outline::before {
  content: "\\f0e0a";
}

.mdi-water-percent::before {
  content: "\\f058e";
}

.mdi-water-polo::before {
  content: "\\f12a0";
}

.mdi-water-pump::before {
  content: "\\f058f";
}

.mdi-water-pump-off::before {
  content: "\\f0f93";
}

.mdi-water-well::before {
  content: "\\f106b";
}

.mdi-water-well-outline::before {
  content: "\\f106c";
}

.mdi-watermark::before {
  content: "\\f0612";
}

.mdi-wave::before {
  content: "\\f0f2e";
}

.mdi-waves::before {
  content: "\\f078d";
}

.mdi-waze::before {
  content: "\\f0bde";
}

.mdi-weather-cloudy::before {
  content: "\\f0590";
}

.mdi-weather-cloudy-alert::before {
  content: "\\f0f2f";
}

.mdi-weather-cloudy-arrow-right::before {
  content: "\\f0e6e";
}

.mdi-weather-fog::before {
  content: "\\f0591";
}

.mdi-weather-hail::before {
  content: "\\f0592";
}

.mdi-weather-hazy::before {
  content: "\\f0f30";
}

.mdi-weather-hurricane::before {
  content: "\\f0898";
}

.mdi-weather-lightning::before {
  content: "\\f0593";
}

.mdi-weather-lightning-rainy::before {
  content: "\\f067e";
}

.mdi-weather-night::before {
  content: "\\f0594";
}

.mdi-weather-night-partly-cloudy::before {
  content: "\\f0f31";
}

.mdi-weather-partly-cloudy::before {
  content: "\\f0595";
}

.mdi-weather-partly-lightning::before {
  content: "\\f0f32";
}

.mdi-weather-partly-rainy::before {
  content: "\\f0f33";
}

.mdi-weather-partly-snowy::before {
  content: "\\f0f34";
}

.mdi-weather-partly-snowy-rainy::before {
  content: "\\f0f35";
}

.mdi-weather-pouring::before {
  content: "\\f0596";
}

.mdi-weather-rainy::before {
  content: "\\f0597";
}

.mdi-weather-snowy::before {
  content: "\\f0598";
}

.mdi-weather-snowy-heavy::before {
  content: "\\f0f36";
}

.mdi-weather-snowy-rainy::before {
  content: "\\f067f";
}

.mdi-weather-sunny::before {
  content: "\\f0599";
}

.mdi-weather-sunny-alert::before {
  content: "\\f0f37";
}

.mdi-weather-sunset::before {
  content: "\\f059a";
}

.mdi-weather-sunset-down::before {
  content: "\\f059b";
}

.mdi-weather-sunset-up::before {
  content: "\\f059c";
}

.mdi-weather-tornado::before {
  content: "\\f0f38";
}

.mdi-weather-windy::before {
  content: "\\f059d";
}

.mdi-weather-windy-variant::before {
  content: "\\f059e";
}

.mdi-web::before {
  content: "\\f059f";
}

.mdi-web-box::before {
  content: "\\f0f94";
}

.mdi-web-clock::before {
  content: "\\f124a";
}

.mdi-webcam::before {
  content: "\\f05a0";
}

.mdi-webhook::before {
  content: "\\f062f";
}

.mdi-webpack::before {
  content: "\\f072b";
}

.mdi-webrtc::before {
  content: "\\f1248";
}

.mdi-wechat::before {
  content: "\\f0611";
}

.mdi-weight::before {
  content: "\\f05a1";
}

.mdi-weight-gram::before {
  content: "\\f0d3f";
}

.mdi-weight-kilogram::before {
  content: "\\f05a2";
}

.mdi-weight-lifter::before {
  content: "\\f115d";
}

.mdi-weight-pound::before {
  content: "\\f09b5";
}

.mdi-whatsapp::before {
  content: "\\f05a3";
}

.mdi-wheelchair-accessibility::before {
  content: "\\f05a4";
}

.mdi-whistle::before {
  content: "\\f09b6";
}

.mdi-whistle-outline::before {
  content: "\\f12bc";
}

.mdi-white-balance-auto::before {
  content: "\\f05a5";
}

.mdi-white-balance-incandescent::before {
  content: "\\f05a6";
}

.mdi-white-balance-iridescent::before {
  content: "\\f05a7";
}

.mdi-white-balance-sunny::before {
  content: "\\f05a8";
}

.mdi-widgets::before {
  content: "\\f072c";
}

.mdi-widgets-outline::before {
  content: "\\f1355";
}

.mdi-wifi::before {
  content: "\\f05a9";
}

.mdi-wifi-off::before {
  content: "\\f05aa";
}

.mdi-wifi-star::before {
  content: "\\f0e0b";
}

.mdi-wifi-strength-1::before {
  content: "\\f091f";
}

.mdi-wifi-strength-1-alert::before {
  content: "\\f0920";
}

.mdi-wifi-strength-1-lock::before {
  content: "\\f0921";
}

.mdi-wifi-strength-2::before {
  content: "\\f0922";
}

.mdi-wifi-strength-2-alert::before {
  content: "\\f0923";
}

.mdi-wifi-strength-2-lock::before {
  content: "\\f0924";
}

.mdi-wifi-strength-3::before {
  content: "\\f0925";
}

.mdi-wifi-strength-3-alert::before {
  content: "\\f0926";
}

.mdi-wifi-strength-3-lock::before {
  content: "\\f0927";
}

.mdi-wifi-strength-4::before {
  content: "\\f0928";
}

.mdi-wifi-strength-4-alert::before {
  content: "\\f0929";
}

.mdi-wifi-strength-4-lock::before {
  content: "\\f092a";
}

.mdi-wifi-strength-alert-outline::before {
  content: "\\f092b";
}

.mdi-wifi-strength-lock-outline::before {
  content: "\\f092c";
}

.mdi-wifi-strength-off::before {
  content: "\\f092d";
}

.mdi-wifi-strength-off-outline::before {
  content: "\\f092e";
}

.mdi-wifi-strength-outline::before {
  content: "\\f092f";
}

.mdi-wikipedia::before {
  content: "\\f05ac";
}

.mdi-wind-turbine::before {
  content: "\\f0da5";
}

.mdi-window-close::before {
  content: "\\f05ad";
}

.mdi-window-closed::before {
  content: "\\f05ae";
}

.mdi-window-closed-variant::before {
  content: "\\f11db";
}

.mdi-window-maximize::before {
  content: "\\f05af";
}

.mdi-window-minimize::before {
  content: "\\f05b0";
}

.mdi-window-open::before {
  content: "\\f05b1";
}

.mdi-window-open-variant::before {
  content: "\\f11dc";
}

.mdi-window-restore::before {
  content: "\\f05b2";
}

.mdi-window-shutter::before {
  content: "\\f111c";
}

.mdi-window-shutter-alert::before {
  content: "\\f111d";
}

.mdi-window-shutter-open::before {
  content: "\\f111e";
}

.mdi-wiper::before {
  content: "\\f0ae9";
}

.mdi-wiper-wash::before {
  content: "\\f0da6";
}

.mdi-wordpress::before {
  content: "\\f05b4";
}

.mdi-wrap::before {
  content: "\\f05b6";
}

.mdi-wrap-disabled::before {
  content: "\\f0bdf";
}

.mdi-wrench::before {
  content: "\\f05b7";
}

.mdi-wrench-outline::before {
  content: "\\f0be0";
}

.mdi-xamarin::before {
  content: "\\f0845";
}

.mdi-xamarin-outline::before {
  content: "\\f0846";
}

.mdi-xing::before {
  content: "\\f05be";
}

.mdi-xml::before {
  content: "\\f05c0";
}

.mdi-xmpp::before {
  content: "\\f07ff";
}

.mdi-y-combinator::before {
  content: "\\f0624";
}

.mdi-yahoo::before {
  content: "\\f0b4f";
}

.mdi-yeast::before {
  content: "\\f05c1";
}

.mdi-yin-yang::before {
  content: "\\f0680";
}

.mdi-yoga::before {
  content: "\\f117c";
}

.mdi-youtube::before {
  content: "\\f05c3";
}

.mdi-youtube-gaming::before {
  content: "\\f0848";
}

.mdi-youtube-studio::before {
  content: "\\f0847";
}

.mdi-youtube-subscription::before {
  content: "\\f0d40";
}

.mdi-youtube-tv::before {
  content: "\\f0448";
}

.mdi-z-wave::before {
  content: "\\f0aea";
}

.mdi-zend::before {
  content: "\\f0aeb";
}

.mdi-zigbee::before {
  content: "\\f0d41";
}

.mdi-zip-box::before {
  content: "\\f05c4";
}

.mdi-zip-box-outline::before {
  content: "\\f0ffa";
}

.mdi-zip-disk::before {
  content: "\\f0a23";
}

.mdi-zodiac-aquarius::before {
  content: "\\f0a7d";
}

.mdi-zodiac-aries::before {
  content: "\\f0a7e";
}

.mdi-zodiac-cancer::before {
  content: "\\f0a7f";
}

.mdi-zodiac-capricorn::before {
  content: "\\f0a80";
}

.mdi-zodiac-gemini::before {
  content: "\\f0a81";
}

.mdi-zodiac-leo::before {
  content: "\\f0a82";
}

.mdi-zodiac-libra::before {
  content: "\\f0a83";
}

.mdi-zodiac-pisces::before {
  content: "\\f0a84";
}

.mdi-zodiac-sagittarius::before {
  content: "\\f0a85";
}

.mdi-zodiac-scorpio::before {
  content: "\\f0a86";
}

.mdi-zodiac-taurus::before {
  content: "\\f0a87";
}

.mdi-zodiac-virgo::before {
  content: "\\f0a88";
}

.mdi-blank::before {
  content: "\\f68c";
  visibility: hidden;
}

.mdi-18px.mdi-set,
.mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set,
.mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set,
.mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set,
.mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: white;
}

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-45:before {
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-90:before {
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-135:before {
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-180:before {
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-225:before {
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-270:before {
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-315:before {
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear;
}
@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

/*
* Remix Icon v2.3.0
* https://remixicon.com
* https://github.com/Remix-Design/RemixIcon
*
* Copyright RemixIcon.com
* Released under the Apache License Version 2.0
*
* Date: 2020-02-04
*/
@font-face {
  font-family: "remixicon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); /* IE9*/
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("svg"); /* iOS 4.1- */
  font-display: swap;
}
[class^=ri-],
[class*=" ri-"] {
  font-family: "remixicon" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ri-lg {
  font-size: 1.3333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.ri-xl {
  font-size: 1.5em;
  line-height: 0.6666em;
  vertical-align: -0.075em;
}

.ri-xxs {
  font-size: 0.5em;
}

.ri-xs {
  font-size: 0.75em;
}

.ri-sm {
  font-size: 0.875em;
}

.ri-1x {
  font-size: 1em;
}

.ri-2x {
  font-size: 2em;
}

.ri-3x {
  font-size: 3em;
}

.ri-4x {
  font-size: 4em;
}

.ri-5x {
  font-size: 5em;
}

.ri-6x {
  font-size: 6em;
}

.ri-7x {
  font-size: 7em;
}

.ri-8x {
  font-size: 8em;
}

.ri-9x {
  font-size: 9em;
}

.ri-10x {
  font-size: 10em;
}

.ri-fw {
  text-align: center;
  width: 1.25em;
}

.ri-4k-fill:before {
  content: "\\ea01";
}

.ri-4k-line:before {
  content: "\\ea02";
}

.ri-a-b:before {
  content: "\\ea03";
}

.ri-account-box-fill:before {
  content: "\\ea04";
}

.ri-account-box-line:before {
  content: "\\ea05";
}

.ri-account-circle-fill:before {
  content: "\\ea06";
}

.ri-account-circle-line:before {
  content: "\\ea07";
}

.ri-account-pin-box-fill:before {
  content: "\\ea08";
}

.ri-account-pin-box-line:before {
  content: "\\ea09";
}

.ri-account-pin-circle-fill:before {
  content: "\\ea0a";
}

.ri-account-pin-circle-line:before {
  content: "\\ea0b";
}

.ri-add-box-fill:before {
  content: "\\ea0c";
}

.ri-add-box-line:before {
  content: "\\ea0d";
}

.ri-add-circle-fill:before {
  content: "\\ea0e";
}

.ri-add-circle-line:before {
  content: "\\ea0f";
}

.ri-add-fill:before {
  content: "\\ea10";
}

.ri-add-line:before {
  content: "\\ea11";
}

.ri-admin-fill:before {
  content: "\\ea12";
}

.ri-admin-line:before {
  content: "\\ea13";
}

.ri-advertisement-fill:before {
  content: "\\ea14";
}

.ri-advertisement-line:before {
  content: "\\ea15";
}

.ri-airplay-fill:before {
  content: "\\ea16";
}

.ri-airplay-line:before {
  content: "\\ea17";
}

.ri-alarm-fill:before {
  content: "\\ea18";
}

.ri-alarm-line:before {
  content: "\\ea19";
}

.ri-alarm-warning-fill:before {
  content: "\\ea1a";
}

.ri-alarm-warning-line:before {
  content: "\\ea1b";
}

.ri-album-fill:before {
  content: "\\ea1c";
}

.ri-album-line:before {
  content: "\\ea1d";
}

.ri-alert-fill:before {
  content: "\\ea1e";
}

.ri-alert-line:before {
  content: "\\ea1f";
}

.ri-aliens-fill:before {
  content: "\\ea20";
}

.ri-aliens-line:before {
  content: "\\ea21";
}

.ri-align-bottom:before {
  content: "\\ea22";
}

.ri-align-center:before {
  content: "\\ea23";
}

.ri-align-justify:before {
  content: "\\ea24";
}

.ri-align-left:before {
  content: "\\ea25";
}

.ri-align-right:before {
  content: "\\ea26";
}

.ri-align-top:before {
  content: "\\ea27";
}

.ri-align-vertically:before {
  content: "\\ea28";
}

.ri-alipay-fill:before {
  content: "\\ea29";
}

.ri-alipay-line:before {
  content: "\\ea2a";
}

.ri-amazon-fill:before {
  content: "\\ea2b";
}

.ri-amazon-line:before {
  content: "\\ea2c";
}

.ri-anchor-fill:before {
  content: "\\ea2d";
}

.ri-anchor-line:before {
  content: "\\ea2e";
}

.ri-ancient-gate-fill:before {
  content: "\\ea2f";
}

.ri-ancient-gate-line:before {
  content: "\\ea30";
}

.ri-ancient-pavilion-fill:before {
  content: "\\ea31";
}

.ri-ancient-pavilion-line:before {
  content: "\\ea32";
}

.ri-android-fill:before {
  content: "\\ea33";
}

.ri-android-line:before {
  content: "\\ea34";
}

.ri-angularjs-fill:before {
  content: "\\ea35";
}

.ri-angularjs-line:before {
  content: "\\ea36";
}

.ri-anticlockwise-2-fill:before {
  content: "\\ea37";
}

.ri-anticlockwise-2-line:before {
  content: "\\ea38";
}

.ri-anticlockwise-fill:before {
  content: "\\ea39";
}

.ri-anticlockwise-line:before {
  content: "\\ea3a";
}

.ri-app-store-fill:before {
  content: "\\ea3b";
}

.ri-app-store-line:before {
  content: "\\ea3c";
}

.ri-apple-fill:before {
  content: "\\ea3d";
}

.ri-apple-line:before {
  content: "\\ea3e";
}

.ri-apps-2-fill:before {
  content: "\\ea3f";
}

.ri-apps-2-line:before {
  content: "\\ea40";
}

.ri-apps-fill:before {
  content: "\\ea41";
}

.ri-apps-line:before {
  content: "\\ea42";
}

.ri-archive-drawer-fill:before {
  content: "\\ea43";
}

.ri-archive-drawer-line:before {
  content: "\\ea44";
}

.ri-archive-fill:before {
  content: "\\ea45";
}

.ri-archive-line:before {
  content: "\\ea46";
}

.ri-arrow-down-circle-fill:before {
  content: "\\ea47";
}

.ri-arrow-down-circle-line:before {
  content: "\\ea48";
}

.ri-arrow-down-fill:before {
  content: "\\ea49";
}

.ri-arrow-down-line:before {
  content: "\\ea4a";
}

.ri-arrow-down-s-fill:before {
  content: "\\ea4b";
}

.ri-arrow-down-s-line:before {
  content: "\\ea4c";
}

.ri-arrow-drop-down-fill:before {
  content: "\\ea4d";
}

.ri-arrow-drop-down-line:before {
  content: "\\ea4e";
}

.ri-arrow-drop-left-fill:before {
  content: "\\ea4f";
}

.ri-arrow-drop-left-line:before {
  content: "\\ea50";
}

.ri-arrow-drop-right-fill:before {
  content: "\\ea51";
}

.ri-arrow-drop-right-line:before {
  content: "\\ea52";
}

.ri-arrow-drop-up-fill:before {
  content: "\\ea53";
}

.ri-arrow-drop-up-line:before {
  content: "\\ea54";
}

.ri-arrow-go-back-fill:before {
  content: "\\ea55";
}

.ri-arrow-go-back-line:before {
  content: "\\ea56";
}

.ri-arrow-go-forward-fill:before {
  content: "\\ea57";
}

.ri-arrow-go-forward-line:before {
  content: "\\ea58";
}

.ri-arrow-left-circle-fill:before {
  content: "\\ea59";
}

.ri-arrow-left-circle-line:before {
  content: "\\ea5a";
}

.ri-arrow-left-down-fill:before {
  content: "\\ea5b";
}

.ri-arrow-left-down-line:before {
  content: "\\ea5c";
}

.ri-arrow-left-fill:before {
  content: "\\ea5d";
}

.ri-arrow-left-line:before {
  content: "\\ea5e";
}

.ri-arrow-left-right-fill:before {
  content: "\\ea5f";
}

.ri-arrow-left-right-line:before {
  content: "\\ea60";
}

.ri-arrow-left-s-fill:before {
  content: "\\ea61";
}

.ri-arrow-left-s-line:before {
  content: "\\ea62";
}

.ri-arrow-left-up-fill:before {
  content: "\\ea63";
}

.ri-arrow-left-up-line:before {
  content: "\\ea64";
}

.ri-arrow-right-circle-fill:before {
  content: "\\ea65";
}

.ri-arrow-right-circle-line:before {
  content: "\\ea66";
}

.ri-arrow-right-down-fill:before {
  content: "\\ea67";
}

.ri-arrow-right-down-line:before {
  content: "\\ea68";
}

.ri-arrow-right-fill:before {
  content: "\\ea69";
}

.ri-arrow-right-line:before {
  content: "\\ea6a";
}

.ri-arrow-right-s-fill:before {
  content: "\\ea6b";
}

.ri-arrow-right-s-line:before {
  content: "\\ea6c";
}

.ri-arrow-right-up-fill:before {
  content: "\\ea6d";
}

.ri-arrow-right-up-line:before {
  content: "\\ea6e";
}

.ri-arrow-up-circle-fill:before {
  content: "\\ea6f";
}

.ri-arrow-up-circle-line:before {
  content: "\\ea70";
}

.ri-arrow-up-down-fill:before {
  content: "\\ea71";
}

.ri-arrow-up-down-line:before {
  content: "\\ea72";
}

.ri-arrow-up-fill:before {
  content: "\\ea73";
}

.ri-arrow-up-line:before {
  content: "\\ea74";
}

.ri-arrow-up-s-fill:before {
  content: "\\ea75";
}

.ri-arrow-up-s-line:before {
  content: "\\ea76";
}

.ri-artboard-2-fill:before {
  content: "\\ea77";
}

.ri-artboard-2-line:before {
  content: "\\ea78";
}

.ri-artboard-fill:before {
  content: "\\ea79";
}

.ri-artboard-line:before {
  content: "\\ea7a";
}

.ri-article-fill:before {
  content: "\\ea7b";
}

.ri-article-line:before {
  content: "\\ea7c";
}

.ri-aspect-ratio-fill:before {
  content: "\\ea7d";
}

.ri-aspect-ratio-line:before {
  content: "\\ea7e";
}

.ri-asterisk:before {
  content: "\\ea7f";
}

.ri-at-fill:before {
  content: "\\ea80";
}

.ri-at-line:before {
  content: "\\ea81";
}

.ri-attachment-2:before {
  content: "\\ea82";
}

.ri-attachment-fill:before {
  content: "\\ea83";
}

.ri-attachment-line:before {
  content: "\\ea84";
}

.ri-auction-fill:before {
  content: "\\ea85";
}

.ri-auction-line:before {
  content: "\\ea86";
}

.ri-award-fill:before {
  content: "\\ea87";
}

.ri-award-line:before {
  content: "\\ea88";
}

.ri-baidu-fill:before {
  content: "\\ea89";
}

.ri-baidu-line:before {
  content: "\\ea8a";
}

.ri-ball-pen-fill:before {
  content: "\\ea8b";
}

.ri-ball-pen-line:before {
  content: "\\ea8c";
}

.ri-bank-card-2-fill:before {
  content: "\\ea8d";
}

.ri-bank-card-2-line:before {
  content: "\\ea8e";
}

.ri-bank-card-fill:before {
  content: "\\ea8f";
}

.ri-bank-card-line:before {
  content: "\\ea90";
}

.ri-bank-fill:before {
  content: "\\ea91";
}

.ri-bank-line:before {
  content: "\\ea92";
}

.ri-bar-chart-2-fill:before {
  content: "\\ea93";
}

.ri-bar-chart-2-line:before {
  content: "\\ea94";
}

.ri-bar-chart-box-fill:before {
  content: "\\ea95";
}

.ri-bar-chart-box-line:before {
  content: "\\ea96";
}

.ri-bar-chart-fill:before {
  content: "\\ea97";
}

.ri-bar-chart-grouped-fill:before {
  content: "\\ea98";
}

.ri-bar-chart-grouped-line:before {
  content: "\\ea99";
}

.ri-bar-chart-horizontal-fill:before {
  content: "\\ea9a";
}

.ri-bar-chart-horizontal-line:before {
  content: "\\ea9b";
}

.ri-bar-chart-line:before {
  content: "\\ea9c";
}

.ri-barcode-box-fill:before {
  content: "\\ea9d";
}

.ri-barcode-box-line:before {
  content: "\\ea9e";
}

.ri-barcode-fill:before {
  content: "\\ea9f";
}

.ri-barcode-line:before {
  content: "\\eaa0";
}

.ri-barricade-fill:before {
  content: "\\eaa1";
}

.ri-barricade-line:before {
  content: "\\eaa2";
}

.ri-base-station-fill:before {
  content: "\\eaa3";
}

.ri-base-station-line:before {
  content: "\\eaa4";
}

.ri-basketball-fill:before {
  content: "\\eaa5";
}

.ri-basketball-line:before {
  content: "\\eaa6";
}

.ri-battery-2-charge-fill:before {
  content: "\\eaa7";
}

.ri-battery-2-charge-line:before {
  content: "\\eaa8";
}

.ri-battery-2-fill:before {
  content: "\\eaa9";
}

.ri-battery-2-line:before {
  content: "\\eaaa";
}

.ri-battery-charge-fill:before {
  content: "\\eaab";
}

.ri-battery-charge-line:before {
  content: "\\eaac";
}

.ri-battery-fill:before {
  content: "\\eaad";
}

.ri-battery-line:before {
  content: "\\eaae";
}

.ri-battery-low-fill:before {
  content: "\\eaaf";
}

.ri-battery-low-line:before {
  content: "\\eab0";
}

.ri-battery-saver-fill:before {
  content: "\\eab1";
}

.ri-battery-saver-line:before {
  content: "\\eab2";
}

.ri-battery-share-fill:before {
  content: "\\eab3";
}

.ri-battery-share-line:before {
  content: "\\eab4";
}

.ri-bear-smile-fill:before {
  content: "\\eab5";
}

.ri-bear-smile-line:before {
  content: "\\eab6";
}

.ri-behance-fill:before {
  content: "\\eab7";
}

.ri-behance-line:before {
  content: "\\eab8";
}

.ri-bell-fill:before {
  content: "\\eab9";
}

.ri-bell-line:before {
  content: "\\eaba";
}

.ri-bike-fill:before {
  content: "\\eabb";
}

.ri-bike-line:before {
  content: "\\eabc";
}

.ri-bilibili-fill:before {
  content: "\\eabd";
}

.ri-bilibili-line:before {
  content: "\\eabe";
}

.ri-bill-fill:before {
  content: "\\eabf";
}

.ri-bill-line:before {
  content: "\\eac0";
}

.ri-billiards-fill:before {
  content: "\\eac1";
}

.ri-billiards-line:before {
  content: "\\eac2";
}

.ri-bit-coin-fill:before {
  content: "\\eac3";
}

.ri-bit-coin-line:before {
  content: "\\eac4";
}

.ri-blaze-fill:before {
  content: "\\eac5";
}

.ri-blaze-line:before {
  content: "\\eac6";
}

.ri-bluetooth-connect-fill:before {
  content: "\\eac7";
}

.ri-bluetooth-connect-line:before {
  content: "\\eac8";
}

.ri-bluetooth-fill:before {
  content: "\\eac9";
}

.ri-bluetooth-line:before {
  content: "\\eaca";
}

.ri-blur-off-fill:before {
  content: "\\eacb";
}

.ri-blur-off-line:before {
  content: "\\eacc";
}

.ri-body-scan-fill:before {
  content: "\\eacd";
}

.ri-body-scan-line:before {
  content: "\\eace";
}

.ri-bold:before {
  content: "\\eacf";
}

.ri-book-2-fill:before {
  content: "\\ead0";
}

.ri-book-2-line:before {
  content: "\\ead1";
}

.ri-book-3-fill:before {
  content: "\\ead2";
}

.ri-book-3-line:before {
  content: "\\ead3";
}

.ri-book-fill:before {
  content: "\\ead4";
}

.ri-book-line:before {
  content: "\\ead5";
}

.ri-book-mark-fill:before {
  content: "\\ead6";
}

.ri-book-mark-line:before {
  content: "\\ead7";
}

.ri-book-open-fill:before {
  content: "\\ead8";
}

.ri-book-open-line:before {
  content: "\\ead9";
}

.ri-book-read-fill:before {
  content: "\\eada";
}

.ri-book-read-line:before {
  content: "\\eadb";
}

.ri-booklet-fill:before {
  content: "\\eadc";
}

.ri-booklet-line:before {
  content: "\\eadd";
}

.ri-bookmark-2-fill:before {
  content: "\\eade";
}

.ri-bookmark-2-line:before {
  content: "\\eadf";
}

.ri-bookmark-3-fill:before {
  content: "\\eae0";
}

.ri-bookmark-3-line:before {
  content: "\\eae1";
}

.ri-bookmark-fill:before {
  content: "\\eae2";
}

.ri-bookmark-line:before {
  content: "\\eae3";
}

.ri-boxing-fill:before {
  content: "\\eae4";
}

.ri-boxing-line:before {
  content: "\\eae5";
}

.ri-braces-fill:before {
  content: "\\eae6";
}

.ri-braces-line:before {
  content: "\\eae7";
}

.ri-brackets-fill:before {
  content: "\\eae8";
}

.ri-brackets-line:before {
  content: "\\eae9";
}

.ri-briefcase-2-fill:before {
  content: "\\eaea";
}

.ri-briefcase-2-line:before {
  content: "\\eaeb";
}

.ri-briefcase-3-fill:before {
  content: "\\eaec";
}

.ri-briefcase-3-line:before {
  content: "\\eaed";
}

.ri-briefcase-4-fill:before {
  content: "\\eaee";
}

.ri-briefcase-4-line:before {
  content: "\\eaef";
}

.ri-briefcase-5-fill:before {
  content: "\\eaf0";
}

.ri-briefcase-5-line:before {
  content: "\\eaf1";
}

.ri-briefcase-fill:before {
  content: "\\eaf2";
}

.ri-briefcase-line:before {
  content: "\\eaf3";
}

.ri-broadcast-fill:before {
  content: "\\eaf4";
}

.ri-broadcast-line:before {
  content: "\\eaf5";
}

.ri-brush-2-fill:before {
  content: "\\eaf6";
}

.ri-brush-2-line:before {
  content: "\\eaf7";
}

.ri-brush-3-fill:before {
  content: "\\eaf8";
}

.ri-brush-3-line:before {
  content: "\\eaf9";
}

.ri-brush-4-fill:before {
  content: "\\eafa";
}

.ri-brush-4-line:before {
  content: "\\eafb";
}

.ri-brush-fill:before {
  content: "\\eafc";
}

.ri-brush-line:before {
  content: "\\eafd";
}

.ri-bug-2-fill:before {
  content: "\\eafe";
}

.ri-bug-2-line:before {
  content: "\\eaff";
}

.ri-bug-fill:before {
  content: "\\eb00";
}

.ri-bug-line:before {
  content: "\\eb01";
}

.ri-building-2-fill:before {
  content: "\\eb02";
}

.ri-building-2-line:before {
  content: "\\eb03";
}

.ri-building-3-fill:before {
  content: "\\eb04";
}

.ri-building-3-line:before {
  content: "\\eb05";
}

.ri-building-4-fill:before {
  content: "\\eb06";
}

.ri-building-4-line:before {
  content: "\\eb07";
}

.ri-building-fill:before {
  content: "\\eb08";
}

.ri-building-line:before {
  content: "\\eb09";
}

.ri-bus-2-fill:before {
  content: "\\eb0a";
}

.ri-bus-2-line:before {
  content: "\\eb0b";
}

.ri-bus-fill:before {
  content: "\\eb0c";
}

.ri-bus-line:before {
  content: "\\eb0d";
}

.ri-bus-wifi-fill:before {
  content: "\\eb0e";
}

.ri-bus-wifi-line:before {
  content: "\\eb0f";
}

.ri-cake-2-fill:before {
  content: "\\eb10";
}

.ri-cake-2-line:before {
  content: "\\eb11";
}

.ri-cake-3-fill:before {
  content: "\\eb12";
}

.ri-cake-3-line:before {
  content: "\\eb13";
}

.ri-cake-fill:before {
  content: "\\eb14";
}

.ri-cake-line:before {
  content: "\\eb15";
}

.ri-calculator-fill:before {
  content: "\\eb16";
}

.ri-calculator-line:before {
  content: "\\eb17";
}

.ri-calendar-2-fill:before {
  content: "\\eb18";
}

.ri-calendar-2-line:before {
  content: "\\eb19";
}

.ri-calendar-check-fill:before {
  content: "\\eb1a";
}

.ri-calendar-check-line:before {
  content: "\\eb1b";
}

.ri-calendar-event-fill:before {
  content: "\\eb1c";
}

.ri-calendar-event-line:before {
  content: "\\eb1d";
}

.ri-calendar-fill:before {
  content: "\\eb1e";
}

.ri-calendar-line:before {
  content: "\\eb1f";
}

.ri-calendar-todo-fill:before {
  content: "\\eb20";
}

.ri-calendar-todo-line:before {
  content: "\\eb21";
}

.ri-camera-2-fill:before {
  content: "\\eb22";
}

.ri-camera-2-line:before {
  content: "\\eb23";
}

.ri-camera-3-fill:before {
  content: "\\eb24";
}

.ri-camera-3-line:before {
  content: "\\eb25";
}

.ri-camera-fill:before {
  content: "\\eb26";
}

.ri-camera-lens-fill:before {
  content: "\\eb27";
}

.ri-camera-lens-line:before {
  content: "\\eb28";
}

.ri-camera-line:before {
  content: "\\eb29";
}

.ri-camera-off-fill:before {
  content: "\\eb2a";
}

.ri-camera-off-line:before {
  content: "\\eb2b";
}

.ri-camera-switch-fill:before {
  content: "\\eb2c";
}

.ri-camera-switch-line:before {
  content: "\\eb2d";
}

.ri-car-fill:before {
  content: "\\eb2e";
}

.ri-car-line:before {
  content: "\\eb2f";
}

.ri-car-washing-fill:before {
  content: "\\eb30";
}

.ri-car-washing-line:before {
  content: "\\eb31";
}

.ri-cast-fill:before {
  content: "\\eb32";
}

.ri-cast-line:before {
  content: "\\eb33";
}

.ri-cellphone-fill:before {
  content: "\\eb34";
}

.ri-cellphone-line:before {
  content: "\\eb35";
}

.ri-celsius-fill:before {
  content: "\\eb36";
}

.ri-celsius-line:before {
  content: "\\eb37";
}

.ri-character-recognition-fill:before {
  content: "\\eb38";
}

.ri-character-recognition-line:before {
  content: "\\eb39";
}

.ri-charging-pile-2-fill:before {
  content: "\\eb3a";
}

.ri-charging-pile-2-line:before {
  content: "\\eb3b";
}

.ri-charging-pile-fill:before {
  content: "\\eb3c";
}

.ri-charging-pile-line:before {
  content: "\\eb3d";
}

.ri-chat-1-fill:before {
  content: "\\eb3e";
}

.ri-chat-1-line:before {
  content: "\\eb3f";
}

.ri-chat-2-fill:before {
  content: "\\eb40";
}

.ri-chat-2-line:before {
  content: "\\eb41";
}

.ri-chat-3-fill:before {
  content: "\\eb42";
}

.ri-chat-3-line:before {
  content: "\\eb43";
}

.ri-chat-4-fill:before {
  content: "\\eb44";
}

.ri-chat-4-line:before {
  content: "\\eb45";
}

.ri-chat-check-fill:before {
  content: "\\eb46";
}

.ri-chat-check-line:before {
  content: "\\eb47";
}

.ri-chat-delete-fill:before {
  content: "\\eb48";
}

.ri-chat-delete-line:before {
  content: "\\eb49";
}

.ri-chat-download-fill:before {
  content: "\\eb4a";
}

.ri-chat-download-line:before {
  content: "\\eb4b";
}

.ri-chat-forward-fill:before {
  content: "\\eb4c";
}

.ri-chat-forward-line:before {
  content: "\\eb4d";
}

.ri-chat-heart-fill:before {
  content: "\\eb4e";
}

.ri-chat-heart-line:before {
  content: "\\eb4f";
}

.ri-chat-new-fill:before {
  content: "\\eb50";
}

.ri-chat-new-line:before {
  content: "\\eb51";
}

.ri-chat-off-fill:before {
  content: "\\eb52";
}

.ri-chat-off-line:before {
  content: "\\eb53";
}

.ri-chat-settings-fill:before {
  content: "\\eb54";
}

.ri-chat-settings-line:before {
  content: "\\eb55";
}

.ri-chat-smile-2-fill:before {
  content: "\\eb56";
}

.ri-chat-smile-2-line:before {
  content: "\\eb57";
}

.ri-chat-smile-3-fill:before {
  content: "\\eb58";
}

.ri-chat-smile-3-line:before {
  content: "\\eb59";
}

.ri-chat-smile-fill:before {
  content: "\\eb5a";
}

.ri-chat-smile-line:before {
  content: "\\eb5b";
}

.ri-chat-upload-fill:before {
  content: "\\eb5c";
}

.ri-chat-upload-line:before {
  content: "\\eb5d";
}

.ri-chat-voice-fill:before {
  content: "\\eb5e";
}

.ri-chat-voice-line:before {
  content: "\\eb5f";
}

.ri-check-double-fill:before {
  content: "\\eb60";
}

.ri-check-double-line:before {
  content: "\\eb61";
}

.ri-check-fill:before {
  content: "\\eb62";
}

.ri-check-line:before {
  content: "\\eb63";
}

.ri-checkbox-blank-circle-fill:before {
  content: "\\eb64";
}

.ri-checkbox-blank-circle-line:before {
  content: "\\eb65";
}

.ri-checkbox-blank-fill:before {
  content: "\\eb66";
}

.ri-checkbox-blank-line:before {
  content: "\\eb67";
}

.ri-checkbox-circle-fill:before {
  content: "\\eb68";
}

.ri-checkbox-circle-line:before {
  content: "\\eb69";
}

.ri-checkbox-fill:before {
  content: "\\eb6a";
}

.ri-checkbox-indeterminate-fill:before {
  content: "\\eb6b";
}

.ri-checkbox-indeterminate-line:before {
  content: "\\eb6c";
}

.ri-checkbox-line:before {
  content: "\\eb6d";
}

.ri-checkbox-multiple-blank-fill:before {
  content: "\\eb6e";
}

.ri-checkbox-multiple-blank-line:before {
  content: "\\eb6f";
}

.ri-checkbox-multiple-fill:before {
  content: "\\eb70";
}

.ri-checkbox-multiple-line:before {
  content: "\\eb71";
}

.ri-china-railway-fill:before {
  content: "\\eb72";
}

.ri-china-railway-line:before {
  content: "\\eb73";
}

.ri-chrome-fill:before {
  content: "\\eb74";
}

.ri-chrome-line:before {
  content: "\\eb75";
}

.ri-clapperboard-fill:before {
  content: "\\eb76";
}

.ri-clapperboard-line:before {
  content: "\\eb77";
}

.ri-clipboard-fill:before {
  content: "\\eb78";
}

.ri-clipboard-line:before {
  content: "\\eb79";
}

.ri-clockwise-2-fill:before {
  content: "\\eb7a";
}

.ri-clockwise-2-line:before {
  content: "\\eb7b";
}

.ri-clockwise-fill:before {
  content: "\\eb7c";
}

.ri-clockwise-line:before {
  content: "\\eb7d";
}

.ri-close-circle-fill:before {
  content: "\\eb7e";
}

.ri-close-circle-line:before {
  content: "\\eb7f";
}

.ri-close-fill:before {
  content: "\\eb80";
}

.ri-close-line:before {
  content: "\\eb81";
}

.ri-cloud-fill:before {
  content: "\\eb82";
}

.ri-cloud-line:before {
  content: "\\eb83";
}

.ri-cloud-off-fill:before {
  content: "\\eb84";
}

.ri-cloud-off-line:before {
  content: "\\eb85";
}

.ri-cloud-windy-fill:before {
  content: "\\eb86";
}

.ri-cloud-windy-line:before {
  content: "\\eb87";
}

.ri-cloudy-2-fill:before {
  content: "\\eb88";
}

.ri-cloudy-2-line:before {
  content: "\\eb89";
}

.ri-cloudy-fill:before {
  content: "\\eb8a";
}

.ri-cloudy-line:before {
  content: "\\eb8b";
}

.ri-code-box-fill:before {
  content: "\\eb8c";
}

.ri-code-box-line:before {
  content: "\\eb8d";
}

.ri-code-fill:before {
  content: "\\eb8e";
}

.ri-code-line:before {
  content: "\\eb8f";
}

.ri-code-s-fill:before {
  content: "\\eb90";
}

.ri-code-s-line:before {
  content: "\\eb91";
}

.ri-code-s-slash-fill:before {
  content: "\\eb92";
}

.ri-code-s-slash-line:before {
  content: "\\eb93";
}

.ri-code-view:before {
  content: "\\eb94";
}

.ri-codepen-fill:before {
  content: "\\eb95";
}

.ri-codepen-line:before {
  content: "\\eb96";
}

.ri-coin-fill:before {
  content: "\\eb97";
}

.ri-coin-line:before {
  content: "\\eb98";
}

.ri-coins-fill:before {
  content: "\\eb99";
}

.ri-coins-line:before {
  content: "\\eb9a";
}

.ri-command-fill:before {
  content: "\\eb9b";
}

.ri-command-line:before {
  content: "\\eb9c";
}

.ri-community-fill:before {
  content: "\\eb9d";
}

.ri-community-line:before {
  content: "\\eb9e";
}

.ri-compass-2-fill:before {
  content: "\\eb9f";
}

.ri-compass-2-line:before {
  content: "\\eba0";
}

.ri-compass-3-fill:before {
  content: "\\eba1";
}

.ri-compass-3-line:before {
  content: "\\eba2";
}

.ri-compass-4-fill:before {
  content: "\\eba3";
}

.ri-compass-4-line:before {
  content: "\\eba4";
}

.ri-compass-discover-fill:before {
  content: "\\eba5";
}

.ri-compass-discover-line:before {
  content: "\\eba6";
}

.ri-compass-fill:before {
  content: "\\eba7";
}

.ri-compass-line:before {
  content: "\\eba8";
}

.ri-compasses-2-fill:before {
  content: "\\eba9";
}

.ri-compasses-2-line:before {
  content: "\\ebaa";
}

.ri-compasses-fill:before {
  content: "\\ebab";
}

.ri-compasses-line:before {
  content: "\\ebac";
}

.ri-computer-fill:before {
  content: "\\ebad";
}

.ri-computer-line:before {
  content: "\\ebae";
}

.ri-contacts-book-2-fill:before {
  content: "\\ebaf";
}

.ri-contacts-book-2-line:before {
  content: "\\ebb0";
}

.ri-contacts-book-fill:before {
  content: "\\ebb1";
}

.ri-contacts-book-line:before {
  content: "\\ebb2";
}

.ri-contacts-book-upload-fill:before {
  content: "\\ebb3";
}

.ri-contacts-book-upload-line:before {
  content: "\\ebb4";
}

.ri-contacts-fill:before {
  content: "\\ebb5";
}

.ri-contacts-line:before {
  content: "\\ebb6";
}

.ri-contrast-2-fill:before {
  content: "\\ebb7";
}

.ri-contrast-2-line:before {
  content: "\\ebb8";
}

.ri-contrast-drop-2-fill:before {
  content: "\\ebb9";
}

.ri-contrast-drop-2-line:before {
  content: "\\ebba";
}

.ri-contrast-drop-fill:before {
  content: "\\ebbb";
}

.ri-contrast-drop-line:before {
  content: "\\ebbc";
}

.ri-contrast-fill:before {
  content: "\\ebbd";
}

.ri-contrast-line:before {
  content: "\\ebbe";
}

.ri-copper-coin-fill:before {
  content: "\\ebbf";
}

.ri-copper-coin-line:before {
  content: "\\ebc0";
}

.ri-copper-diamond-fill:before {
  content: "\\ebc1";
}

.ri-copper-diamond-line:before {
  content: "\\ebc2";
}

.ri-copyright-fill:before {
  content: "\\ebc3";
}

.ri-copyright-line:before {
  content: "\\ebc4";
}

.ri-coreos-fill:before {
  content: "\\ebc5";
}

.ri-coreos-line:before {
  content: "\\ebc6";
}

.ri-coupon-2-fill:before {
  content: "\\ebc7";
}

.ri-coupon-2-line:before {
  content: "\\ebc8";
}

.ri-coupon-3-fill:before {
  content: "\\ebc9";
}

.ri-coupon-3-line:before {
  content: "\\ebca";
}

.ri-coupon-4-fill:before {
  content: "\\ebcb";
}

.ri-coupon-4-line:before {
  content: "\\ebcc";
}

.ri-coupon-5-fill:before {
  content: "\\ebcd";
}

.ri-coupon-5-line:before {
  content: "\\ebce";
}

.ri-coupon-fill:before {
  content: "\\ebcf";
}

.ri-coupon-line:before {
  content: "\\ebd0";
}

.ri-cpu-fill:before {
  content: "\\ebd1";
}

.ri-cpu-line:before {
  content: "\\ebd2";
}

.ri-creative-commons-by-fill:before {
  content: "\\ebd3";
}

.ri-creative-commons-by-line:before {
  content: "\\ebd4";
}

.ri-creative-commons-fill:before {
  content: "\\ebd5";
}

.ri-creative-commons-line:before {
  content: "\\ebd6";
}

.ri-creative-commons-nc-fill:before {
  content: "\\ebd7";
}

.ri-creative-commons-nc-line:before {
  content: "\\ebd8";
}

.ri-creative-commons-nd-fill:before {
  content: "\\ebd9";
}

.ri-creative-commons-nd-line:before {
  content: "\\ebda";
}

.ri-creative-commons-sa-fill:before {
  content: "\\ebdb";
}

.ri-creative-commons-sa-line:before {
  content: "\\ebdc";
}

.ri-creative-commons-zero-fill:before {
  content: "\\ebdd";
}

.ri-creative-commons-zero-line:before {
  content: "\\ebde";
}

.ri-criminal-fill:before {
  content: "\\ebdf";
}

.ri-criminal-line:before {
  content: "\\ebe0";
}

.ri-crop-2-fill:before {
  content: "\\ebe1";
}

.ri-crop-2-line:before {
  content: "\\ebe2";
}

.ri-crop-fill:before {
  content: "\\ebe3";
}

.ri-crop-line:before {
  content: "\\ebe4";
}

.ri-css3-fill:before {
  content: "\\ebe5";
}

.ri-css3-line:before {
  content: "\\ebe6";
}

.ri-cup-fill:before {
  content: "\\ebe7";
}

.ri-cup-line:before {
  content: "\\ebe8";
}

.ri-currency-fill:before {
  content: "\\ebe9";
}

.ri-currency-line:before {
  content: "\\ebea";
}

.ri-cursor-fill:before {
  content: "\\ebeb";
}

.ri-cursor-line:before {
  content: "\\ebec";
}

.ri-customer-service-2-fill:before {
  content: "\\ebed";
}

.ri-customer-service-2-line:before {
  content: "\\ebee";
}

.ri-customer-service-fill:before {
  content: "\\ebef";
}

.ri-customer-service-line:before {
  content: "\\ebf0";
}

.ri-dashboard-fill:before {
  content: "\\ebf1";
}

.ri-dashboard-line:before {
  content: "\\ebf2";
}

.ri-database-2-fill:before {
  content: "\\ebf3";
}

.ri-database-2-line:before {
  content: "\\ebf4";
}

.ri-database-fill:before {
  content: "\\ebf5";
}

.ri-database-line:before {
  content: "\\ebf6";
}

.ri-delete-back-2-fill:before {
  content: "\\ebf7";
}

.ri-delete-back-2-line:before {
  content: "\\ebf8";
}

.ri-delete-back-fill:before {
  content: "\\ebf9";
}

.ri-delete-back-line:before {
  content: "\\ebfa";
}

.ri-delete-bin-2-fill:before {
  content: "\\ebfb";
}

.ri-delete-bin-2-line:before {
  content: "\\ebfc";
}

.ri-delete-bin-3-fill:before {
  content: "\\ebfd";
}

.ri-delete-bin-3-line:before {
  content: "\\ebfe";
}

.ri-delete-bin-4-fill:before {
  content: "\\ebff";
}

.ri-delete-bin-4-line:before {
  content: "\\ec00";
}

.ri-delete-bin-5-fill:before {
  content: "\\ec01";
}

.ri-delete-bin-5-line:before {
  content: "\\ec02";
}

.ri-delete-bin-6-fill:before {
  content: "\\ec03";
}

.ri-delete-bin-6-line:before {
  content: "\\ec04";
}

.ri-delete-bin-7-fill:before {
  content: "\\ec05";
}

.ri-delete-bin-7-line:before {
  content: "\\ec06";
}

.ri-delete-bin-fill:before {
  content: "\\ec07";
}

.ri-delete-bin-line:before {
  content: "\\ec08";
}

.ri-device-fill:before {
  content: "\\ec09";
}

.ri-device-line:before {
  content: "\\ec0a";
}

.ri-device-recover-fill:before {
  content: "\\ec0b";
}

.ri-device-recover-line:before {
  content: "\\ec0c";
}

.ri-dingding-fill:before {
  content: "\\ec0d";
}

.ri-dingding-line:before {
  content: "\\ec0e";
}

.ri-direction-fill:before {
  content: "\\ec0f";
}

.ri-direction-line:before {
  content: "\\ec10";
}

.ri-disc-fill:before {
  content: "\\ec11";
}

.ri-disc-line:before {
  content: "\\ec12";
}

.ri-discord-fill:before {
  content: "\\ec13";
}

.ri-discord-line:before {
  content: "\\ec14";
}

.ri-discuss-fill:before {
  content: "\\ec15";
}

.ri-discuss-line:before {
  content: "\\ec16";
}

.ri-divide-fill:before {
  content: "\\ec17";
}

.ri-divide-line:before {
  content: "\\ec18";
}

.ri-door-lock-box-fill:before {
  content: "\\ec19";
}

.ri-door-lock-box-line:before {
  content: "\\ec1a";
}

.ri-door-lock-fill:before {
  content: "\\ec1b";
}

.ri-door-lock-line:before {
  content: "\\ec1c";
}

.ri-douban-fill:before {
  content: "\\ec1d";
}

.ri-douban-line:before {
  content: "\\ec1e";
}

.ri-double-quotes-l:before {
  content: "\\ec1f";
}

.ri-double-quotes-r:before {
  content: "\\ec20";
}

.ri-download-2-fill:before {
  content: "\\ec21";
}

.ri-download-2-line:before {
  content: "\\ec22";
}

.ri-download-cloud-2-fill:before {
  content: "\\ec23";
}

.ri-download-cloud-2-line:before {
  content: "\\ec24";
}

.ri-download-cloud-fill:before {
  content: "\\ec25";
}

.ri-download-cloud-line:before {
  content: "\\ec26";
}

.ri-download-fill:before {
  content: "\\ec27";
}

.ri-download-line:before {
  content: "\\ec28";
}

.ri-drag-drop-fill:before {
  content: "\\ec29";
}

.ri-drag-drop-line:before {
  content: "\\ec2a";
}

.ri-drag-move-2-fill:before {
  content: "\\ec2b";
}

.ri-drag-move-2-line:before {
  content: "\\ec2c";
}

.ri-drag-move-fill:before {
  content: "\\ec2d";
}

.ri-drag-move-line:before {
  content: "\\ec2e";
}

.ri-dribbble-fill:before {
  content: "\\ec2f";
}

.ri-dribbble-line:before {
  content: "\\ec30";
}

.ri-drive-fill:before {
  content: "\\ec31";
}

.ri-drive-line:before {
  content: "\\ec32";
}

.ri-drizzle-fill:before {
  content: "\\ec33";
}

.ri-drizzle-line:before {
  content: "\\ec34";
}

.ri-drop-fill:before {
  content: "\\ec35";
}

.ri-drop-line:before {
  content: "\\ec36";
}

.ri-dropbox-fill:before {
  content: "\\ec37";
}

.ri-dropbox-line:before {
  content: "\\ec38";
}

.ri-dual-sim-1-fill:before {
  content: "\\ec39";
}

.ri-dual-sim-1-line:before {
  content: "\\ec3a";
}

.ri-dual-sim-2-fill:before {
  content: "\\ec3b";
}

.ri-dual-sim-2-line:before {
  content: "\\ec3c";
}

.ri-dv-fill:before {
  content: "\\ec3d";
}

.ri-dv-line:before {
  content: "\\ec3e";
}

.ri-dvd-fill:before {
  content: "\\ec3f";
}

.ri-dvd-line:before {
  content: "\\ec40";
}

.ri-e-bike-2-fill:before {
  content: "\\ec41";
}

.ri-e-bike-2-line:before {
  content: "\\ec42";
}

.ri-e-bike-fill:before {
  content: "\\ec43";
}

.ri-e-bike-line:before {
  content: "\\ec44";
}

.ri-earth-fill:before {
  content: "\\ec45";
}

.ri-earth-line:before {
  content: "\\ec46";
}

.ri-earthquake-fill:before {
  content: "\\ec47";
}

.ri-earthquake-line:before {
  content: "\\ec48";
}

.ri-edge-fill:before {
  content: "\\ec49";
}

.ri-edge-line:before {
  content: "\\ec4a";
}

.ri-edit-2-fill:before {
  content: "\\ec4b";
}

.ri-edit-2-line:before {
  content: "\\ec4c";
}

.ri-edit-box-fill:before {
  content: "\\ec4d";
}

.ri-edit-box-line:before {
  content: "\\ec4e";
}

.ri-edit-circle-fill:before {
  content: "\\ec4f";
}

.ri-edit-circle-line:before {
  content: "\\ec50";
}

.ri-edit-fill:before {
  content: "\\ec51";
}

.ri-edit-line:before {
  content: "\\ec52";
}

.ri-eject-fill:before {
  content: "\\ec53";
}

.ri-eject-line:before {
  content: "\\ec54";
}

.ri-emotion-2-fill:before {
  content: "\\ec55";
}

.ri-emotion-2-line:before {
  content: "\\ec56";
}

.ri-emotion-fill:before {
  content: "\\ec57";
}

.ri-emotion-happy-fill:before {
  content: "\\ec58";
}

.ri-emotion-happy-line:before {
  content: "\\ec59";
}

.ri-emotion-laugh-fill:before {
  content: "\\ec5a";
}

.ri-emotion-laugh-line:before {
  content: "\\ec5b";
}

.ri-emotion-line:before {
  content: "\\ec5c";
}

.ri-emotion-normal-fill:before {
  content: "\\ec5d";
}

.ri-emotion-normal-line:before {
  content: "\\ec5e";
}

.ri-emotion-sad-fill:before {
  content: "\\ec5f";
}

.ri-emotion-sad-line:before {
  content: "\\ec60";
}

.ri-emotion-unhappy-fill:before {
  content: "\\ec61";
}

.ri-emotion-unhappy-line:before {
  content: "\\ec62";
}

.ri-emphasis-cn:before {
  content: "\\ec63";
}

.ri-emphasis:before {
  content: "\\ec64";
}

.ri-english-input:before {
  content: "\\ec65";
}

.ri-equalizer-fill:before {
  content: "\\ec66";
}

.ri-equalizer-line:before {
  content: "\\ec67";
}

.ri-eraser-fill:before {
  content: "\\ec68";
}

.ri-eraser-line:before {
  content: "\\ec69";
}

.ri-error-warning-fill:before {
  content: "\\ec6a";
}

.ri-error-warning-line:before {
  content: "\\ec6b";
}

.ri-evernote-fill:before {
  content: "\\ec6c";
}

.ri-evernote-line:before {
  content: "\\ec6d";
}

.ri-exchange-box-fill:before {
  content: "\\ec6e";
}

.ri-exchange-box-line:before {
  content: "\\ec6f";
}

.ri-exchange-cny-fill:before {
  content: "\\ec70";
}

.ri-exchange-cny-line:before {
  content: "\\ec71";
}

.ri-exchange-dollar-fill:before {
  content: "\\ec72";
}

.ri-exchange-dollar-line:before {
  content: "\\ec73";
}

.ri-exchange-fill:before {
  content: "\\ec74";
}

.ri-exchange-funds-fill:before {
  content: "\\ec75";
}

.ri-exchange-funds-line:before {
  content: "\\ec76";
}

.ri-exchange-line:before {
  content: "\\ec77";
}

.ri-external-link-fill:before {
  content: "\\ec78";
}

.ri-external-link-line:before {
  content: "\\ec79";
}

.ri-eye-2-fill:before {
  content: "\\ec7a";
}

.ri-eye-2-line:before {
  content: "\\ec7b";
}

.ri-eye-close-fill:before {
  content: "\\ec7c";
}

.ri-eye-close-line:before {
  content: "\\ec7d";
}

.ri-eye-fill:before {
  content: "\\ec7e";
}

.ri-eye-line:before {
  content: "\\ec7f";
}

.ri-eye-off-fill:before {
  content: "\\ec80";
}

.ri-eye-off-line:before {
  content: "\\ec81";
}

.ri-facebook-box-fill:before {
  content: "\\ec82";
}

.ri-facebook-box-line:before {
  content: "\\ec83";
}

.ri-facebook-circle-fill:before {
  content: "\\ec84";
}

.ri-facebook-circle-line:before {
  content: "\\ec85";
}

.ri-facebook-fill:before {
  content: "\\ec86";
}

.ri-facebook-line:before {
  content: "\\ec87";
}

.ri-fahrenheit-fill:before {
  content: "\\ec88";
}

.ri-fahrenheit-line:before {
  content: "\\ec89";
}

.ri-feedback-fill:before {
  content: "\\ec8a";
}

.ri-feedback-line:before {
  content: "\\ec8b";
}

.ri-file-2-fill:before {
  content: "\\ec8c";
}

.ri-file-2-line:before {
  content: "\\ec8d";
}

.ri-file-3-fill:before {
  content: "\\ec8e";
}

.ri-file-3-line:before {
  content: "\\ec8f";
}

.ri-file-4-fill:before {
  content: "\\ec90";
}

.ri-file-4-line:before {
  content: "\\ec91";
}

.ri-file-add-fill:before {
  content: "\\ec92";
}

.ri-file-add-line:before {
  content: "\\ec93";
}

.ri-file-chart-2-fill:before {
  content: "\\ec94";
}

.ri-file-chart-2-line:before {
  content: "\\ec95";
}

.ri-file-chart-fill:before {
  content: "\\ec96";
}

.ri-file-chart-line:before {
  content: "\\ec97";
}

.ri-file-cloud-fill:before {
  content: "\\ec98";
}

.ri-file-cloud-line:before {
  content: "\\ec99";
}

.ri-file-code-fill:before {
  content: "\\ec9a";
}

.ri-file-code-line:before {
  content: "\\ec9b";
}

.ri-file-copy-2-fill:before {
  content: "\\ec9c";
}

.ri-file-copy-2-line:before {
  content: "\\ec9d";
}

.ri-file-copy-fill:before {
  content: "\\ec9e";
}

.ri-file-copy-line:before {
  content: "\\ec9f";
}

.ri-file-damage-fill:before {
  content: "\\eca0";
}

.ri-file-damage-line:before {
  content: "\\eca1";
}

.ri-file-download-fill:before {
  content: "\\eca2";
}

.ri-file-download-line:before {
  content: "\\eca3";
}

.ri-file-edit-fill:before {
  content: "\\eca4";
}

.ri-file-edit-line:before {
  content: "\\eca5";
}

.ri-file-excel-2-fill:before {
  content: "\\eca6";
}

.ri-file-excel-2-line:before {
  content: "\\eca7";
}

.ri-file-excel-fill:before {
  content: "\\eca8";
}

.ri-file-excel-line:before {
  content: "\\eca9";
}

.ri-file-fill:before {
  content: "\\ecaa";
}

.ri-file-forbid-fill:before {
  content: "\\ecab";
}

.ri-file-forbid-line:before {
  content: "\\ecac";
}

.ri-file-hwp-fill:before {
  content: "\\ecad";
}

.ri-file-hwp-line:before {
  content: "\\ecae";
}

.ri-file-info-fill:before {
  content: "\\ecaf";
}

.ri-file-info-line:before {
  content: "\\ecb0";
}

.ri-file-line:before {
  content: "\\ecb1";
}

.ri-file-list-2-fill:before {
  content: "\\ecb2";
}

.ri-file-list-2-line:before {
  content: "\\ecb3";
}

.ri-file-list-3-fill:before {
  content: "\\ecb4";
}

.ri-file-list-3-line:before {
  content: "\\ecb5";
}

.ri-file-list-fill:before {
  content: "\\ecb6";
}

.ri-file-list-line:before {
  content: "\\ecb7";
}

.ri-file-lock-fill:before {
  content: "\\ecb8";
}

.ri-file-lock-line:before {
  content: "\\ecb9";
}

.ri-file-mark-fill:before {
  content: "\\ecba";
}

.ri-file-mark-line:before {
  content: "\\ecbb";
}

.ri-file-music-fill:before {
  content: "\\ecbc";
}

.ri-file-music-line:before {
  content: "\\ecbd";
}

.ri-file-paper-2-fill:before {
  content: "\\ecbe";
}

.ri-file-paper-2-line:before {
  content: "\\ecbf";
}

.ri-file-paper-fill:before {
  content: "\\ecc0";
}

.ri-file-paper-line:before {
  content: "\\ecc1";
}

.ri-file-pdf-fill:before {
  content: "\\ecc2";
}

.ri-file-pdf-line:before {
  content: "\\ecc3";
}

.ri-file-ppt-2-fill:before {
  content: "\\ecc4";
}

.ri-file-ppt-2-line:before {
  content: "\\ecc5";
}

.ri-file-ppt-fill:before {
  content: "\\ecc6";
}

.ri-file-ppt-line:before {
  content: "\\ecc7";
}

.ri-file-reduce-fill:before {
  content: "\\ecc8";
}

.ri-file-reduce-line:before {
  content: "\\ecc9";
}

.ri-file-search-fill:before {
  content: "\\ecca";
}

.ri-file-search-line:before {
  content: "\\eccb";
}

.ri-file-settings-fill:before {
  content: "\\eccc";
}

.ri-file-settings-line:before {
  content: "\\eccd";
}

.ri-file-shield-2-fill:before {
  content: "\\ecce";
}

.ri-file-shield-2-line:before {
  content: "\\eccf";
}

.ri-file-shield-fill:before {
  content: "\\ecd0";
}

.ri-file-shield-line:before {
  content: "\\ecd1";
}

.ri-file-shred-fill:before {
  content: "\\ecd2";
}

.ri-file-shred-line:before {
  content: "\\ecd3";
}

.ri-file-text-fill:before {
  content: "\\ecd4";
}

.ri-file-text-line:before {
  content: "\\ecd5";
}

.ri-file-transfer-fill:before {
  content: "\\ecd6";
}

.ri-file-transfer-line:before {
  content: "\\ecd7";
}

.ri-file-unknow-fill:before {
  content: "\\ecd8";
}

.ri-file-unknow-line:before {
  content: "\\ecd9";
}

.ri-file-upload-fill:before {
  content: "\\ecda";
}

.ri-file-upload-line:before {
  content: "\\ecdb";
}

.ri-file-user-fill:before {
  content: "\\ecdc";
}

.ri-file-user-line:before {
  content: "\\ecdd";
}

.ri-file-warning-fill:before {
  content: "\\ecde";
}

.ri-file-warning-line:before {
  content: "\\ecdf";
}

.ri-file-word-2-fill:before {
  content: "\\ece0";
}

.ri-file-word-2-line:before {
  content: "\\ece1";
}

.ri-file-word-fill:before {
  content: "\\ece2";
}

.ri-file-word-line:before {
  content: "\\ece3";
}

.ri-file-zip-fill:before {
  content: "\\ece4";
}

.ri-file-zip-line:before {
  content: "\\ece5";
}

.ri-film-fill:before {
  content: "\\ece6";
}

.ri-film-line:before {
  content: "\\ece7";
}

.ri-filter-2-fill:before {
  content: "\\ece8";
}

.ri-filter-2-line:before {
  content: "\\ece9";
}

.ri-filter-3-fill:before {
  content: "\\ecea";
}

.ri-filter-3-line:before {
  content: "\\eceb";
}

.ri-filter-fill:before {
  content: "\\ecec";
}

.ri-filter-line:before {
  content: "\\eced";
}

.ri-find-replace-fill:before {
  content: "\\ecee";
}

.ri-find-replace-line:before {
  content: "\\ecef";
}

.ri-fingerprint-2-fill:before {
  content: "\\ecf0";
}

.ri-fingerprint-2-line:before {
  content: "\\ecf1";
}

.ri-fingerprint-fill:before {
  content: "\\ecf2";
}

.ri-fingerprint-line:before {
  content: "\\ecf3";
}

.ri-fire-fill:before {
  content: "\\ecf4";
}

.ri-fire-line:before {
  content: "\\ecf5";
}

.ri-firefox-fill:before {
  content: "\\ecf6";
}

.ri-firefox-line:before {
  content: "\\ecf7";
}

.ri-flag-2-fill:before {
  content: "\\ecf8";
}

.ri-flag-2-line:before {
  content: "\\ecf9";
}

.ri-flag-fill:before {
  content: "\\ecfa";
}

.ri-flag-line:before {
  content: "\\ecfb";
}

.ri-flashlight-fill:before {
  content: "\\ecfc";
}

.ri-flashlight-line:before {
  content: "\\ecfd";
}

.ri-flask-fill:before {
  content: "\\ecfe";
}

.ri-flask-line:before {
  content: "\\ecff";
}

.ri-flight-land-fill:before {
  content: "\\ed00";
}

.ri-flight-land-line:before {
  content: "\\ed01";
}

.ri-flight-takeoff-fill:before {
  content: "\\ed02";
}

.ri-flight-takeoff-line:before {
  content: "\\ed03";
}

.ri-flood-fill:before {
  content: "\\ed04";
}

.ri-flood-line:before {
  content: "\\ed05";
}

.ri-flutter-fill:before {
  content: "\\ed06";
}

.ri-flutter-line:before {
  content: "\\ed07";
}

.ri-focus-2-fill:before {
  content: "\\ed08";
}

.ri-focus-2-line:before {
  content: "\\ed09";
}

.ri-focus-3-fill:before {
  content: "\\ed0a";
}

.ri-focus-3-line:before {
  content: "\\ed0b";
}

.ri-focus-fill:before {
  content: "\\ed0c";
}

.ri-focus-line:before {
  content: "\\ed0d";
}

.ri-foggy-fill:before {
  content: "\\ed0e";
}

.ri-foggy-line:before {
  content: "\\ed0f";
}

.ri-folder-2-fill:before {
  content: "\\ed10";
}

.ri-folder-2-line:before {
  content: "\\ed11";
}

.ri-folder-3-fill:before {
  content: "\\ed12";
}

.ri-folder-3-line:before {
  content: "\\ed13";
}

.ri-folder-4-fill:before {
  content: "\\ed14";
}

.ri-folder-4-line:before {
  content: "\\ed15";
}

.ri-folder-5-fill:before {
  content: "\\ed16";
}

.ri-folder-5-line:before {
  content: "\\ed17";
}

.ri-folder-add-fill:before {
  content: "\\ed18";
}

.ri-folder-add-line:before {
  content: "\\ed19";
}

.ri-folder-chart-2-fill:before {
  content: "\\ed1a";
}

.ri-folder-chart-2-line:before {
  content: "\\ed1b";
}

.ri-folder-chart-fill:before {
  content: "\\ed1c";
}

.ri-folder-chart-line:before {
  content: "\\ed1d";
}

.ri-folder-download-fill:before {
  content: "\\ed1e";
}

.ri-folder-download-line:before {
  content: "\\ed1f";
}

.ri-folder-fill:before {
  content: "\\ed20";
}

.ri-folder-forbid-fill:before {
  content: "\\ed21";
}

.ri-folder-forbid-line:before {
  content: "\\ed22";
}

.ri-folder-info-fill:before {
  content: "\\ed23";
}

.ri-folder-info-line:before {
  content: "\\ed24";
}

.ri-folder-keyhole-fill:before {
  content: "\\ed25";
}

.ri-folder-keyhole-line:before {
  content: "\\ed26";
}

.ri-folder-line:before {
  content: "\\ed27";
}

.ri-folder-lock-fill:before {
  content: "\\ed28";
}

.ri-folder-lock-line:before {
  content: "\\ed29";
}

.ri-folder-music-fill:before {
  content: "\\ed2a";
}

.ri-folder-music-line:before {
  content: "\\ed2b";
}

.ri-folder-open-fill:before {
  content: "\\ed2c";
}

.ri-folder-open-line:before {
  content: "\\ed2d";
}

.ri-folder-received-fill:before {
  content: "\\ed2e";
}

.ri-folder-received-line:before {
  content: "\\ed2f";
}

.ri-folder-reduce-fill:before {
  content: "\\ed30";
}

.ri-folder-reduce-line:before {
  content: "\\ed31";
}

.ri-folder-settings-fill:before {
  content: "\\ed32";
}

.ri-folder-settings-line:before {
  content: "\\ed33";
}

.ri-folder-shared-fill:before {
  content: "\\ed34";
}

.ri-folder-shared-line:before {
  content: "\\ed35";
}

.ri-folder-shield-2-fill:before {
  content: "\\ed36";
}

.ri-folder-shield-2-line:before {
  content: "\\ed37";
}

.ri-folder-shield-fill:before {
  content: "\\ed38";
}

.ri-folder-shield-line:before {
  content: "\\ed39";
}

.ri-folder-transfer-fill:before {
  content: "\\ed3a";
}

.ri-folder-transfer-line:before {
  content: "\\ed3b";
}

.ri-folder-unknow-fill:before {
  content: "\\ed3c";
}

.ri-folder-unknow-line:before {
  content: "\\ed3d";
}

.ri-folder-upload-fill:before {
  content: "\\ed3e";
}

.ri-folder-upload-line:before {
  content: "\\ed3f";
}

.ri-folder-user-fill:before {
  content: "\\ed40";
}

.ri-folder-user-line:before {
  content: "\\ed41";
}

.ri-folder-warning-fill:before {
  content: "\\ed42";
}

.ri-folder-warning-line:before {
  content: "\\ed43";
}

.ri-folder-zip-fill:before {
  content: "\\ed44";
}

.ri-folder-zip-line:before {
  content: "\\ed45";
}

.ri-folders-fill:before {
  content: "\\ed46";
}

.ri-folders-line:before {
  content: "\\ed47";
}

.ri-font-color:before {
  content: "\\ed48";
}

.ri-font-size-2:before {
  content: "\\ed49";
}

.ri-font-size:before {
  content: "\\ed4a";
}

.ri-football-fill:before {
  content: "\\ed4b";
}

.ri-football-line:before {
  content: "\\ed4c";
}

.ri-footprint-fill:before {
  content: "\\ed4d";
}

.ri-footprint-line:before {
  content: "\\ed4e";
}

.ri-forbid-2-fill:before {
  content: "\\ed4f";
}

.ri-forbid-2-line:before {
  content: "\\ed50";
}

.ri-forbid-fill:before {
  content: "\\ed51";
}

.ri-forbid-line:before {
  content: "\\ed52";
}

.ri-format-clear:before {
  content: "\\ed53";
}

.ri-fullscreen-exit-fill:before {
  content: "\\ed54";
}

.ri-fullscreen-exit-line:before {
  content: "\\ed55";
}

.ri-fullscreen-fill:before {
  content: "\\ed56";
}

.ri-fullscreen-line:before {
  content: "\\ed57";
}

.ri-function-fill:before {
  content: "\\ed58";
}

.ri-function-line:before {
  content: "\\ed59";
}

.ri-functions:before {
  content: "\\ed5a";
}

.ri-funds-box-fill:before {
  content: "\\ed5b";
}

.ri-funds-box-line:before {
  content: "\\ed5c";
}

.ri-funds-fill:before {
  content: "\\ed5d";
}

.ri-funds-line:before {
  content: "\\ed5e";
}

.ri-gallery-fill:before {
  content: "\\ed5f";
}

.ri-gallery-line:before {
  content: "\\ed60";
}

.ri-gallery-upload-fill:before {
  content: "\\ed61";
}

.ri-gallery-upload-line:before {
  content: "\\ed62";
}

.ri-game-fill:before {
  content: "\\ed63";
}

.ri-game-line:before {
  content: "\\ed64";
}

.ri-gamepad-fill:before {
  content: "\\ed65";
}

.ri-gamepad-line:before {
  content: "\\ed66";
}

.ri-gas-station-fill:before {
  content: "\\ed67";
}

.ri-gas-station-line:before {
  content: "\\ed68";
}

.ri-gatsby-fill:before {
  content: "\\ed69";
}

.ri-gatsby-line:before {
  content: "\\ed6a";
}

.ri-genderless-fill:before {
  content: "\\ed6b";
}

.ri-genderless-line:before {
  content: "\\ed6c";
}

.ri-ghost-2-fill:before {
  content: "\\ed6d";
}

.ri-ghost-2-line:before {
  content: "\\ed6e";
}

.ri-ghost-fill:before {
  content: "\\ed6f";
}

.ri-ghost-line:before {
  content: "\\ed70";
}

.ri-ghost-smile-fill:before {
  content: "\\ed71";
}

.ri-ghost-smile-line:before {
  content: "\\ed72";
}

.ri-gift-2-fill:before {
  content: "\\ed73";
}

.ri-gift-2-line:before {
  content: "\\ed74";
}

.ri-gift-fill:before {
  content: "\\ed75";
}

.ri-gift-line:before {
  content: "\\ed76";
}

.ri-git-branch-fill:before {
  content: "\\ed77";
}

.ri-git-branch-line:before {
  content: "\\ed78";
}

.ri-git-commit-fill:before {
  content: "\\ed79";
}

.ri-git-commit-line:before {
  content: "\\ed7a";
}

.ri-git-merge-fill:before {
  content: "\\ed7b";
}

.ri-git-merge-line:before {
  content: "\\ed7c";
}

.ri-git-pull-request-fill:before {
  content: "\\ed7d";
}

.ri-git-pull-request-line:before {
  content: "\\ed7e";
}

.ri-git-repository-commits-fill:before {
  content: "\\ed7f";
}

.ri-git-repository-commits-line:before {
  content: "\\ed80";
}

.ri-git-repository-fill:before {
  content: "\\ed81";
}

.ri-git-repository-line:before {
  content: "\\ed82";
}

.ri-git-repository-private-fill:before {
  content: "\\ed83";
}

.ri-git-repository-private-line:before {
  content: "\\ed84";
}

.ri-github-fill:before {
  content: "\\ed85";
}

.ri-github-line:before {
  content: "\\ed86";
}

.ri-gitlab-fill:before {
  content: "\\ed87";
}

.ri-gitlab-line:before {
  content: "\\ed88";
}

.ri-global-fill:before {
  content: "\\ed89";
}

.ri-global-line:before {
  content: "\\ed8a";
}

.ri-globe-fill:before {
  content: "\\ed8b";
}

.ri-globe-line:before {
  content: "\\ed8c";
}

.ri-goblet-fill:before {
  content: "\\ed8d";
}

.ri-goblet-line:before {
  content: "\\ed8e";
}

.ri-google-fill:before {
  content: "\\ed8f";
}

.ri-google-line:before {
  content: "\\ed90";
}

.ri-google-play-fill:before {
  content: "\\ed91";
}

.ri-google-play-line:before {
  content: "\\ed92";
}

.ri-government-fill:before {
  content: "\\ed93";
}

.ri-government-line:before {
  content: "\\ed94";
}

.ri-gps-fill:before {
  content: "\\ed95";
}

.ri-gps-line:before {
  content: "\\ed96";
}

.ri-gradienter-fill:before {
  content: "\\ed97";
}

.ri-gradienter-line:before {
  content: "\\ed98";
}

.ri-grid-fill:before {
  content: "\\ed99";
}

.ri-grid-line:before {
  content: "\\ed9a";
}

.ri-group-2-fill:before {
  content: "\\ed9b";
}

.ri-group-2-line:before {
  content: "\\ed9c";
}

.ri-group-fill:before {
  content: "\\ed9d";
}

.ri-group-line:before {
  content: "\\ed9e";
}

.ri-guide-fill:before {
  content: "\\ed9f";
}

.ri-guide-line:before {
  content: "\\eda0";
}

.ri-hail-fill:before {
  content: "\\eda1";
}

.ri-hail-line:before {
  content: "\\eda2";
}

.ri-hammer-fill:before {
  content: "\\eda3";
}

.ri-hammer-line:before {
  content: "\\eda4";
}

.ri-hand-coin-fill:before {
  content: "\\eda5";
}

.ri-hand-coin-line:before {
  content: "\\eda6";
}

.ri-hand-heart-fill:before {
  content: "\\eda7";
}

.ri-hand-heart-line:before {
  content: "\\eda8";
}

.ri-handbag-fill:before {
  content: "\\eda9";
}

.ri-handbag-line:before {
  content: "\\edaa";
}

.ri-hard-drive-2-fill:before {
  content: "\\edab";
}

.ri-hard-drive-2-line:before {
  content: "\\edac";
}

.ri-hard-drive-fill:before {
  content: "\\edad";
}

.ri-hard-drive-line:before {
  content: "\\edae";
}

.ri-hashtag:before {
  content: "\\edaf";
}

.ri-haze-2-fill:before {
  content: "\\edb0";
}

.ri-haze-2-line:before {
  content: "\\edb1";
}

.ri-haze-fill:before {
  content: "\\edb2";
}

.ri-haze-line:before {
  content: "\\edb3";
}

.ri-hd-fill:before {
  content: "\\edb4";
}

.ri-hd-line:before {
  content: "\\edb5";
}

.ri-heading:before {
  content: "\\edb6";
}

.ri-headphone-fill:before {
  content: "\\edb7";
}

.ri-headphone-line:before {
  content: "\\edb8";
}

.ri-heart-2-fill:before {
  content: "\\edb9";
}

.ri-heart-2-line:before {
  content: "\\edba";
}

.ri-heart-add-fill:before {
  content: "\\edbb";
}

.ri-heart-add-line:before {
  content: "\\edbc";
}

.ri-heart-fill:before {
  content: "\\edbd";
}

.ri-heart-line:before {
  content: "\\edbe";
}

.ri-hearts-fill:before {
  content: "\\edbf";
}

.ri-hearts-line:before {
  content: "\\edc0";
}

.ri-heavy-showers-fill:before {
  content: "\\edc1";
}

.ri-heavy-showers-line:before {
  content: "\\edc2";
}

.ri-home-2-fill:before {
  content: "\\edc3";
}

.ri-home-2-line:before {
  content: "\\edc4";
}

.ri-home-3-fill:before {
  content: "\\edc5";
}

.ri-home-3-line:before {
  content: "\\edc6";
}

.ri-home-4-fill:before {
  content: "\\edc7";
}

.ri-home-4-line:before {
  content: "\\edc8";
}

.ri-home-5-fill:before {
  content: "\\edc9";
}

.ri-home-5-line:before {
  content: "\\edca";
}

.ri-home-6-fill:before {
  content: "\\edcb";
}

.ri-home-6-line:before {
  content: "\\edcc";
}

.ri-home-7-fill:before {
  content: "\\edcd";
}

.ri-home-7-line:before {
  content: "\\edce";
}

.ri-home-8-fill:before {
  content: "\\edcf";
}

.ri-home-8-line:before {
  content: "\\edd0";
}

.ri-home-fill:before {
  content: "\\edd1";
}

.ri-home-gear-fill:before {
  content: "\\edd2";
}

.ri-home-gear-line:before {
  content: "\\edd3";
}

.ri-home-heart-fill:before {
  content: "\\edd4";
}

.ri-home-heart-line:before {
  content: "\\edd5";
}

.ri-home-line:before {
  content: "\\edd6";
}

.ri-home-smile-2-fill:before {
  content: "\\edd7";
}

.ri-home-smile-2-line:before {
  content: "\\edd8";
}

.ri-home-smile-fill:before {
  content: "\\edd9";
}

.ri-home-smile-line:before {
  content: "\\edda";
}

.ri-home-wifi-fill:before {
  content: "\\eddb";
}

.ri-home-wifi-line:before {
  content: "\\eddc";
}

.ri-honour-fill:before {
  content: "\\eddd";
}

.ri-honour-line:before {
  content: "\\edde";
}

.ri-hospital-fill:before {
  content: "\\eddf";
}

.ri-hospital-line:before {
  content: "\\ede0";
}

.ri-hotel-bed-fill:before {
  content: "\\ede1";
}

.ri-hotel-bed-line:before {
  content: "\\ede2";
}

.ri-hotel-fill:before {
  content: "\\ede3";
}

.ri-hotel-line:before {
  content: "\\ede4";
}

.ri-hotspot-fill:before {
  content: "\\ede5";
}

.ri-hotspot-line:before {
  content: "\\ede6";
}

.ri-hq-fill:before {
  content: "\\ede7";
}

.ri-hq-line:before {
  content: "\\ede8";
}

.ri-html5-fill:before {
  content: "\\ede9";
}

.ri-html5-line:before {
  content: "\\edea";
}

.ri-ie-fill:before {
  content: "\\edeb";
}

.ri-ie-line:before {
  content: "\\edec";
}

.ri-image-2-fill:before {
  content: "\\eded";
}

.ri-image-2-line:before {
  content: "\\edee";
}

.ri-image-add-fill:before {
  content: "\\edef";
}

.ri-image-add-line:before {
  content: "\\edf0";
}

.ri-image-fill:before {
  content: "\\edf1";
}

.ri-image-line:before {
  content: "\\edf2";
}

.ri-inbox-archive-fill:before {
  content: "\\edf3";
}

.ri-inbox-archive-line:before {
  content: "\\edf4";
}

.ri-inbox-fill:before {
  content: "\\edf5";
}

.ri-inbox-line:before {
  content: "\\edf6";
}

.ri-inbox-unarchive-fill:before {
  content: "\\edf7";
}

.ri-inbox-unarchive-line:before {
  content: "\\edf8";
}

.ri-increase-decrease-fill:before {
  content: "\\edf9";
}

.ri-increase-decrease-line:before {
  content: "\\edfa";
}

.ri-indent-decrease:before {
  content: "\\edfb";
}

.ri-indent-increase:before {
  content: "\\edfc";
}

.ri-indeterminate-circle-fill:before {
  content: "\\edfd";
}

.ri-indeterminate-circle-line:before {
  content: "\\edfe";
}

.ri-information-fill:before {
  content: "\\edff";
}

.ri-information-line:before {
  content: "\\ee00";
}

.ri-input-cursor-move:before {
  content: "\\ee01";
}

.ri-input-method-fill:before {
  content: "\\ee02";
}

.ri-input-method-line:before {
  content: "\\ee03";
}

.ri-instagram-fill:before {
  content: "\\ee04";
}

.ri-instagram-line:before {
  content: "\\ee05";
}

.ri-install-fill:before {
  content: "\\ee06";
}

.ri-install-line:before {
  content: "\\ee07";
}

.ri-invision-fill:before {
  content: "\\ee08";
}

.ri-invision-line:before {
  content: "\\ee09";
}

.ri-italic:before {
  content: "\\ee0a";
}

.ri-kakao-talk-fill:before {
  content: "\\ee0b";
}

.ri-kakao-talk-line:before {
  content: "\\ee0c";
}

.ri-key-2-fill:before {
  content: "\\ee0d";
}

.ri-key-2-line:before {
  content: "\\ee0e";
}

.ri-key-fill:before {
  content: "\\ee0f";
}

.ri-key-line:before {
  content: "\\ee10";
}

.ri-keyboard-box-fill:before {
  content: "\\ee11";
}

.ri-keyboard-box-line:before {
  content: "\\ee12";
}

.ri-keyboard-fill:before {
  content: "\\ee13";
}

.ri-keyboard-line:before {
  content: "\\ee14";
}

.ri-keynote-fill:before {
  content: "\\ee15";
}

.ri-keynote-line:before {
  content: "\\ee16";
}

.ri-knife-blood-fill:before {
  content: "\\ee17";
}

.ri-knife-blood-line:before {
  content: "\\ee18";
}

.ri-knife-fill:before {
  content: "\\ee19";
}

.ri-knife-line:before {
  content: "\\ee1a";
}

.ri-landscape-fill:before {
  content: "\\ee1b";
}

.ri-landscape-line:before {
  content: "\\ee1c";
}

.ri-layout-2-fill:before {
  content: "\\ee1d";
}

.ri-layout-2-line:before {
  content: "\\ee1e";
}

.ri-layout-3-fill:before {
  content: "\\ee1f";
}

.ri-layout-3-line:before {
  content: "\\ee20";
}

.ri-layout-4-fill:before {
  content: "\\ee21";
}

.ri-layout-4-line:before {
  content: "\\ee22";
}

.ri-layout-5-fill:before {
  content: "\\ee23";
}

.ri-layout-5-line:before {
  content: "\\ee24";
}

.ri-layout-6-fill:before {
  content: "\\ee25";
}

.ri-layout-6-line:before {
  content: "\\ee26";
}

.ri-layout-bottom-2-fill:before {
  content: "\\ee27";
}

.ri-layout-bottom-2-line:before {
  content: "\\ee28";
}

.ri-layout-bottom-fill:before {
  content: "\\ee29";
}

.ri-layout-bottom-line:before {
  content: "\\ee2a";
}

.ri-layout-column-fill:before {
  content: "\\ee2b";
}

.ri-layout-column-line:before {
  content: "\\ee2c";
}

.ri-layout-fill:before {
  content: "\\ee2d";
}

.ri-layout-grid-fill:before {
  content: "\\ee2e";
}

.ri-layout-grid-line:before {
  content: "\\ee2f";
}

.ri-layout-left-2-fill:before {
  content: "\\ee30";
}

.ri-layout-left-2-line:before {
  content: "\\ee31";
}

.ri-layout-left-fill:before {
  content: "\\ee32";
}

.ri-layout-left-line:before {
  content: "\\ee33";
}

.ri-layout-line:before {
  content: "\\ee34";
}

.ri-layout-masonry-fill:before {
  content: "\\ee35";
}

.ri-layout-masonry-line:before {
  content: "\\ee36";
}

.ri-layout-right-2-fill:before {
  content: "\\ee37";
}

.ri-layout-right-2-line:before {
  content: "\\ee38";
}

.ri-layout-right-fill:before {
  content: "\\ee39";
}

.ri-layout-right-line:before {
  content: "\\ee3a";
}

.ri-layout-row-fill:before {
  content: "\\ee3b";
}

.ri-layout-row-line:before {
  content: "\\ee3c";
}

.ri-layout-top-2-fill:before {
  content: "\\ee3d";
}

.ri-layout-top-2-line:before {
  content: "\\ee3e";
}

.ri-layout-top-fill:before {
  content: "\\ee3f";
}

.ri-layout-top-line:before {
  content: "\\ee40";
}

.ri-lifebuoy-fill:before {
  content: "\\ee41";
}

.ri-lifebuoy-line:before {
  content: "\\ee42";
}

.ri-lightbulb-fill:before {
  content: "\\ee43";
}

.ri-lightbulb-flash-fill:before {
  content: "\\ee44";
}

.ri-lightbulb-flash-line:before {
  content: "\\ee45";
}

.ri-lightbulb-line:before {
  content: "\\ee46";
}

.ri-line-fill:before {
  content: "\\ee47";
}

.ri-line-height:before {
  content: "\\ee48";
}

.ri-line-line:before {
  content: "\\ee49";
}

.ri-link-m:before {
  content: "\\ee4a";
}

.ri-link-unlink-m:before {
  content: "\\ee4b";
}

.ri-link-unlink:before {
  content: "\\ee4c";
}

.ri-link:before {
  content: "\\ee4d";
}

.ri-linkedin-box-fill:before {
  content: "\\ee4e";
}

.ri-linkedin-box-line:before {
  content: "\\ee4f";
}

.ri-linkedin-fill:before {
  content: "\\ee50";
}

.ri-linkedin-line:before {
  content: "\\ee51";
}

.ri-links-fill:before {
  content: "\\ee52";
}

.ri-links-line:before {
  content: "\\ee53";
}

.ri-list-check-2:before {
  content: "\\ee54";
}

.ri-list-check:before {
  content: "\\ee55";
}

.ri-list-ordered:before {
  content: "\\ee56";
}

.ri-list-settings-fill:before {
  content: "\\ee57";
}

.ri-list-settings-line:before {
  content: "\\ee58";
}

.ri-list-unordered:before {
  content: "\\ee59";
}

.ri-live-fill:before {
  content: "\\ee5a";
}

.ri-live-line:before {
  content: "\\ee5b";
}

.ri-loader-2-fill:before {
  content: "\\ee5c";
}

.ri-loader-2-line:before {
  content: "\\ee5d";
}

.ri-loader-3-fill:before {
  content: "\\ee5e";
}

.ri-loader-3-line:before {
  content: "\\ee5f";
}

.ri-loader-4-fill:before {
  content: "\\ee60";
}

.ri-loader-4-line:before {
  content: "\\ee61";
}

.ri-loader-5-fill:before {
  content: "\\ee62";
}

.ri-loader-5-line:before {
  content: "\\ee63";
}

.ri-loader-fill:before {
  content: "\\ee64";
}

.ri-loader-line:before {
  content: "\\ee65";
}

.ri-lock-2-fill:before {
  content: "\\ee66";
}

.ri-lock-2-line:before {
  content: "\\ee67";
}

.ri-lock-fill:before {
  content: "\\ee68";
}

.ri-lock-line:before {
  content: "\\ee69";
}

.ri-lock-password-fill:before {
  content: "\\ee6a";
}

.ri-lock-password-line:before {
  content: "\\ee6b";
}

.ri-lock-unlock-fill:before {
  content: "\\ee6c";
}

.ri-lock-unlock-line:before {
  content: "\\ee6d";
}

.ri-login-box-fill:before {
  content: "\\ee6e";
}

.ri-login-box-line:before {
  content: "\\ee6f";
}

.ri-login-circle-fill:before {
  content: "\\ee70";
}

.ri-login-circle-line:before {
  content: "\\ee71";
}

.ri-logout-box-fill:before {
  content: "\\ee72";
}

.ri-logout-box-line:before {
  content: "\\ee73";
}

.ri-logout-box-r-fill:before {
  content: "\\ee74";
}

.ri-logout-box-r-line:before {
  content: "\\ee75";
}

.ri-logout-circle-fill:before {
  content: "\\ee76";
}

.ri-logout-circle-line:before {
  content: "\\ee77";
}

.ri-logout-circle-r-fill:before {
  content: "\\ee78";
}

.ri-logout-circle-r-line:before {
  content: "\\ee79";
}

.ri-mac-fill:before {
  content: "\\ee7a";
}

.ri-mac-line:before {
  content: "\\ee7b";
}

.ri-macbook-fill:before {
  content: "\\ee7c";
}

.ri-macbook-line:before {
  content: "\\ee7d";
}

.ri-magic-fill:before {
  content: "\\ee7e";
}

.ri-magic-line:before {
  content: "\\ee7f";
}

.ri-mail-add-fill:before {
  content: "\\ee80";
}

.ri-mail-add-line:before {
  content: "\\ee81";
}

.ri-mail-check-fill:before {
  content: "\\ee82";
}

.ri-mail-check-line:before {
  content: "\\ee83";
}

.ri-mail-close-fill:before {
  content: "\\ee84";
}

.ri-mail-close-line:before {
  content: "\\ee85";
}

.ri-mail-download-fill:before {
  content: "\\ee86";
}

.ri-mail-download-line:before {
  content: "\\ee87";
}

.ri-mail-fill:before {
  content: "\\ee88";
}

.ri-mail-forbid-fill:before {
  content: "\\ee89";
}

.ri-mail-forbid-line:before {
  content: "\\ee8a";
}

.ri-mail-line:before {
  content: "\\ee8b";
}

.ri-mail-lock-fill:before {
  content: "\\ee8c";
}

.ri-mail-lock-line:before {
  content: "\\ee8d";
}

.ri-mail-open-fill:before {
  content: "\\ee8e";
}

.ri-mail-open-line:before {
  content: "\\ee8f";
}

.ri-mail-send-fill:before {
  content: "\\ee90";
}

.ri-mail-send-line:before {
  content: "\\ee91";
}

.ri-mail-settings-fill:before {
  content: "\\ee92";
}

.ri-mail-settings-line:before {
  content: "\\ee93";
}

.ri-mail-star-fill:before {
  content: "\\ee94";
}

.ri-mail-star-line:before {
  content: "\\ee95";
}

.ri-mail-unread-fill:before {
  content: "\\ee96";
}

.ri-mail-unread-line:before {
  content: "\\ee97";
}

.ri-mail-volume-fill:before {
  content: "\\ee98";
}

.ri-mail-volume-line:before {
  content: "\\ee99";
}

.ri-map-2-fill:before {
  content: "\\ee9a";
}

.ri-map-2-line:before {
  content: "\\ee9b";
}

.ri-map-fill:before {
  content: "\\ee9c";
}

.ri-map-line:before {
  content: "\\ee9d";
}

.ri-map-pin-2-fill:before {
  content: "\\ee9e";
}

.ri-map-pin-2-line:before {
  content: "\\ee9f";
}

.ri-map-pin-3-fill:before {
  content: "\\eea0";
}

.ri-map-pin-3-line:before {
  content: "\\eea1";
}

.ri-map-pin-4-fill:before {
  content: "\\eea2";
}

.ri-map-pin-4-line:before {
  content: "\\eea3";
}

.ri-map-pin-5-fill:before {
  content: "\\eea4";
}

.ri-map-pin-5-line:before {
  content: "\\eea5";
}

.ri-map-pin-add-fill:before {
  content: "\\eea6";
}

.ri-map-pin-add-line:before {
  content: "\\eea7";
}

.ri-map-pin-fill:before {
  content: "\\eea8";
}

.ri-map-pin-line:before {
  content: "\\eea9";
}

.ri-map-pin-range-fill:before {
  content: "\\eeaa";
}

.ri-map-pin-range-line:before {
  content: "\\eeab";
}

.ri-map-pin-time-fill:before {
  content: "\\eeac";
}

.ri-map-pin-time-line:before {
  content: "\\eead";
}

.ri-map-pin-user-fill:before {
  content: "\\eeae";
}

.ri-map-pin-user-line:before {
  content: "\\eeaf";
}

.ri-mark-pen-fill:before {
  content: "\\eeb0";
}

.ri-mark-pen-line:before {
  content: "\\eeb1";
}

.ri-markdown-fill:before {
  content: "\\eeb2";
}

.ri-markdown-line:before {
  content: "\\eeb3";
}

.ri-markup-fill:before {
  content: "\\eeb4";
}

.ri-markup-line:before {
  content: "\\eeb5";
}

.ri-mastercard-fill:before {
  content: "\\eeb6";
}

.ri-mastercard-line:before {
  content: "\\eeb7";
}

.ri-mastodon-fill:before {
  content: "\\eeb8";
}

.ri-mastodon-line:before {
  content: "\\eeb9";
}

.ri-medal-2-fill:before {
  content: "\\eeba";
}

.ri-medal-2-line:before {
  content: "\\eebb";
}

.ri-medal-fill:before {
  content: "\\eebc";
}

.ri-medal-line:before {
  content: "\\eebd";
}

.ri-medium-fill:before {
  content: "\\eebe";
}

.ri-medium-line:before {
  content: "\\eebf";
}

.ri-men-fill:before {
  content: "\\eec0";
}

.ri-men-line:before {
  content: "\\eec1";
}

.ri-menu-2-fill:before {
  content: "\\eec2";
}

.ri-menu-2-line:before {
  content: "\\eec3";
}

.ri-menu-3-fill:before {
  content: "\\eec4";
}

.ri-menu-3-line:before {
  content: "\\eec5";
}

.ri-menu-4-fill:before {
  content: "\\eec6";
}

.ri-menu-4-line:before {
  content: "\\eec7";
}

.ri-menu-5-fill:before {
  content: "\\eec8";
}

.ri-menu-5-line:before {
  content: "\\eec9";
}

.ri-menu-add-fill:before {
  content: "\\eeca";
}

.ri-menu-add-line:before {
  content: "\\eecb";
}

.ri-menu-fill:before {
  content: "\\eecc";
}

.ri-menu-line:before {
  content: "\\eecd";
}

.ri-message-2-fill:before {
  content: "\\eece";
}

.ri-message-2-line:before {
  content: "\\eecf";
}

.ri-message-3-fill:before {
  content: "\\eed0";
}

.ri-message-3-line:before {
  content: "\\eed1";
}

.ri-message-fill:before {
  content: "\\eed2";
}

.ri-message-line:before {
  content: "\\eed3";
}

.ri-messenger-fill:before {
  content: "\\eed4";
}

.ri-messenger-line:before {
  content: "\\eed5";
}

.ri-meteor-fill:before {
  content: "\\eed6";
}

.ri-meteor-line:before {
  content: "\\eed7";
}

.ri-mic-2-fill:before {
  content: "\\eed8";
}

.ri-mic-2-line:before {
  content: "\\eed9";
}

.ri-mic-fill:before {
  content: "\\eeda";
}

.ri-mic-line:before {
  content: "\\eedb";
}

.ri-mic-off-fill:before {
  content: "\\eedc";
}

.ri-mic-off-line:before {
  content: "\\eedd";
}

.ri-mickey-fill:before {
  content: "\\eede";
}

.ri-mickey-line:before {
  content: "\\eedf";
}

.ri-mini-program-fill:before {
  content: "\\eee0";
}

.ri-mini-program-line:before {
  content: "\\eee1";
}

.ri-mist-fill:before {
  content: "\\eee2";
}

.ri-mist-line:before {
  content: "\\eee3";
}

.ri-money-cny-box-fill:before {
  content: "\\eee4";
}

.ri-money-cny-box-line:before {
  content: "\\eee5";
}

.ri-money-cny-circle-fill:before {
  content: "\\eee6";
}

.ri-money-cny-circle-line:before {
  content: "\\eee7";
}

.ri-money-dollar-box-fill:before {
  content: "\\eee8";
}

.ri-money-dollar-box-line:before {
  content: "\\eee9";
}

.ri-money-dollar-circle-fill:before {
  content: "\\eeea";
}

.ri-money-dollar-circle-line:before {
  content: "\\eeeb";
}

.ri-money-euro-box-fill:before {
  content: "\\eeec";
}

.ri-money-euro-box-line:before {
  content: "\\eeed";
}

.ri-money-euro-circle-fill:before {
  content: "\\eeee";
}

.ri-money-euro-circle-line:before {
  content: "\\eeef";
}

.ri-money-pound-box-fill:before {
  content: "\\eef0";
}

.ri-money-pound-box-line:before {
  content: "\\eef1";
}

.ri-money-pound-circle-fill:before {
  content: "\\eef2";
}

.ri-money-pound-circle-line:before {
  content: "\\eef3";
}

.ri-moon-clear-fill:before {
  content: "\\eef4";
}

.ri-moon-clear-line:before {
  content: "\\eef5";
}

.ri-moon-cloudy-fill:before {
  content: "\\eef6";
}

.ri-moon-cloudy-line:before {
  content: "\\eef7";
}

.ri-moon-fill:before {
  content: "\\eef8";
}

.ri-moon-foggy-fill:before {
  content: "\\eef9";
}

.ri-moon-foggy-line:before {
  content: "\\eefa";
}

.ri-moon-line:before {
  content: "\\eefb";
}

.ri-more-2-fill:before {
  content: "\\eefc";
}

.ri-more-2-line:before {
  content: "\\eefd";
}

.ri-more-fill:before {
  content: "\\eefe";
}

.ri-more-line:before {
  content: "\\eeff";
}

.ri-motorbike-fill:before {
  content: "\\ef00";
}

.ri-motorbike-line:before {
  content: "\\ef01";
}

.ri-mouse-fill:before {
  content: "\\ef02";
}

.ri-mouse-line:before {
  content: "\\ef03";
}

.ri-movie-2-fill:before {
  content: "\\ef04";
}

.ri-movie-2-line:before {
  content: "\\ef05";
}

.ri-movie-fill:before {
  content: "\\ef06";
}

.ri-movie-line:before {
  content: "\\ef07";
}

.ri-music-2-fill:before {
  content: "\\ef08";
}

.ri-music-2-line:before {
  content: "\\ef09";
}

.ri-music-fill:before {
  content: "\\ef0a";
}

.ri-music-line:before {
  content: "\\ef0b";
}

.ri-mv-fill:before {
  content: "\\ef0c";
}

.ri-mv-line:before {
  content: "\\ef0d";
}

.ri-navigation-fill:before {
  content: "\\ef0e";
}

.ri-navigation-line:before {
  content: "\\ef0f";
}

.ri-netease-cloud-music-fill:before {
  content: "\\ef10";
}

.ri-netease-cloud-music-line:before {
  content: "\\ef11";
}

.ri-netflix-fill:before {
  content: "\\ef12";
}

.ri-netflix-line:before {
  content: "\\ef13";
}

.ri-newspaper-fill:before {
  content: "\\ef14";
}

.ri-newspaper-line:before {
  content: "\\ef15";
}

.ri-notification-2-fill:before {
  content: "\\ef16";
}

.ri-notification-2-line:before {
  content: "\\ef17";
}

.ri-notification-3-fill:before {
  content: "\\ef18";
}

.ri-notification-3-line:before {
  content: "\\ef19";
}

.ri-notification-4-fill:before {
  content: "\\ef1a";
}

.ri-notification-4-line:before {
  content: "\\ef1b";
}

.ri-notification-badge-fill:before {
  content: "\\ef1c";
}

.ri-notification-badge-line:before {
  content: "\\ef1d";
}

.ri-notification-fill:before {
  content: "\\ef1e";
}

.ri-notification-line:before {
  content: "\\ef1f";
}

.ri-notification-off-fill:before {
  content: "\\ef20";
}

.ri-notification-off-line:before {
  content: "\\ef21";
}

.ri-number-0:before {
  content: "\\ef22";
}

.ri-number-1:before {
  content: "\\ef23";
}

.ri-number-2:before {
  content: "\\ef24";
}

.ri-number-3:before {
  content: "\\ef25";
}

.ri-number-4:before {
  content: "\\ef26";
}

.ri-number-5:before {
  content: "\\ef27";
}

.ri-number-6:before {
  content: "\\ef28";
}

.ri-number-7:before {
  content: "\\ef29";
}

.ri-number-8:before {
  content: "\\ef2a";
}

.ri-number-9:before {
  content: "\\ef2b";
}

.ri-numbers-fill:before {
  content: "\\ef2c";
}

.ri-numbers-line:before {
  content: "\\ef2d";
}

.ri-oil-fill:before {
  content: "\\ef2e";
}

.ri-oil-line:before {
  content: "\\ef2f";
}

.ri-omega:before {
  content: "\\ef30";
}

.ri-open-arm-fill:before {
  content: "\\ef31";
}

.ri-open-arm-line:before {
  content: "\\ef32";
}

.ri-opera-fill:before {
  content: "\\ef33";
}

.ri-opera-line:before {
  content: "\\ef34";
}

.ri-order-play-fill:before {
  content: "\\ef35";
}

.ri-order-play-line:before {
  content: "\\ef36";
}

.ri-outlet-2-fill:before {
  content: "\\ef37";
}

.ri-outlet-2-line:before {
  content: "\\ef38";
}

.ri-outlet-fill:before {
  content: "\\ef39";
}

.ri-outlet-line:before {
  content: "\\ef3a";
}

.ri-page-separator:before {
  content: "\\ef3b";
}

.ri-pages-fill:before {
  content: "\\ef3c";
}

.ri-pages-line:before {
  content: "\\ef3d";
}

.ri-paint-brush-fill:before {
  content: "\\ef3e";
}

.ri-paint-brush-line:before {
  content: "\\ef3f";
}

.ri-paint-fill:before {
  content: "\\ef40";
}

.ri-paint-line:before {
  content: "\\ef41";
}

.ri-palette-fill:before {
  content: "\\ef42";
}

.ri-palette-line:before {
  content: "\\ef43";
}

.ri-pantone-fill:before {
  content: "\\ef44";
}

.ri-pantone-line:before {
  content: "\\ef45";
}

.ri-paragraph:before {
  content: "\\ef46";
}

.ri-parent-fill:before {
  content: "\\ef47";
}

.ri-parent-line:before {
  content: "\\ef48";
}

.ri-parentheses-fill:before {
  content: "\\ef49";
}

.ri-parentheses-line:before {
  content: "\\ef4a";
}

.ri-parking-box-fill:before {
  content: "\\ef4b";
}

.ri-parking-box-line:before {
  content: "\\ef4c";
}

.ri-parking-fill:before {
  content: "\\ef4d";
}

.ri-parking-line:before {
  content: "\\ef4e";
}

.ri-passport-fill:before {
  content: "\\ef4f";
}

.ri-passport-line:before {
  content: "\\ef50";
}

.ri-patreon-fill:before {
  content: "\\ef51";
}

.ri-patreon-line:before {
  content: "\\ef52";
}

.ri-pause-circle-fill:before {
  content: "\\ef53";
}

.ri-pause-circle-line:before {
  content: "\\ef54";
}

.ri-pause-fill:before {
  content: "\\ef55";
}

.ri-pause-line:before {
  content: "\\ef56";
}

.ri-pause-mini-fill:before {
  content: "\\ef57";
}

.ri-pause-mini-line:before {
  content: "\\ef58";
}

.ri-paypal-fill:before {
  content: "\\ef59";
}

.ri-paypal-line:before {
  content: "\\ef5a";
}

.ri-pen-nib-fill:before {
  content: "\\ef5b";
}

.ri-pen-nib-line:before {
  content: "\\ef5c";
}

.ri-pencil-fill:before {
  content: "\\ef5d";
}

.ri-pencil-line:before {
  content: "\\ef5e";
}

.ri-pencil-ruler-2-fill:before {
  content: "\\ef5f";
}

.ri-pencil-ruler-2-line:before {
  content: "\\ef60";
}

.ri-pencil-ruler-fill:before {
  content: "\\ef61";
}

.ri-pencil-ruler-line:before {
  content: "\\ef62";
}

.ri-percent-fill:before {
  content: "\\ef63";
}

.ri-percent-line:before {
  content: "\\ef64";
}

.ri-phone-camera-fill:before {
  content: "\\ef65";
}

.ri-phone-camera-line:before {
  content: "\\ef66";
}

.ri-phone-fill:before {
  content: "\\ef67";
}

.ri-phone-find-fill:before {
  content: "\\ef68";
}

.ri-phone-find-line:before {
  content: "\\ef69";
}

.ri-phone-line:before {
  content: "\\ef6a";
}

.ri-phone-lock-fill:before {
  content: "\\ef6b";
}

.ri-phone-lock-line:before {
  content: "\\ef6c";
}

.ri-picture-in-picture-2-fill:before {
  content: "\\ef6d";
}

.ri-picture-in-picture-2-line:before {
  content: "\\ef6e";
}

.ri-picture-in-picture-exit-fill:before {
  content: "\\ef6f";
}

.ri-picture-in-picture-exit-line:before {
  content: "\\ef70";
}

.ri-picture-in-picture-fill:before {
  content: "\\ef71";
}

.ri-picture-in-picture-line:before {
  content: "\\ef72";
}

.ri-pie-chart-2-fill:before {
  content: "\\ef73";
}

.ri-pie-chart-2-line:before {
  content: "\\ef74";
}

.ri-pie-chart-box-fill:before {
  content: "\\ef75";
}

.ri-pie-chart-box-line:before {
  content: "\\ef76";
}

.ri-pie-chart-fill:before {
  content: "\\ef77";
}

.ri-pie-chart-line:before {
  content: "\\ef78";
}

.ri-pin-distance-fill:before {
  content: "\\ef79";
}

.ri-pin-distance-line:before {
  content: "\\ef7a";
}

.ri-ping-pong-fill:before {
  content: "\\ef7b";
}

.ri-ping-pong-line:before {
  content: "\\ef7c";
}

.ri-pinterest-fill:before {
  content: "\\ef7d";
}

.ri-pinterest-line:before {
  content: "\\ef7e";
}

.ri-pinyin-input:before {
  content: "\\ef7f";
}

.ri-plane-fill:before {
  content: "\\ef80";
}

.ri-plane-line:before {
  content: "\\ef81";
}

.ri-play-circle-fill:before {
  content: "\\ef82";
}

.ri-play-circle-line:before {
  content: "\\ef83";
}

.ri-play-fill:before {
  content: "\\ef84";
}

.ri-play-line:before {
  content: "\\ef85";
}

.ri-play-list-add-fill:before {
  content: "\\ef86";
}

.ri-play-list-add-line:before {
  content: "\\ef87";
}

.ri-play-list-fill:before {
  content: "\\ef88";
}

.ri-play-list-line:before {
  content: "\\ef89";
}

.ri-play-mini-fill:before {
  content: "\\ef8a";
}

.ri-play-mini-line:before {
  content: "\\ef8b";
}

.ri-playstation-fill:before {
  content: "\\ef8c";
}

.ri-playstation-line:before {
  content: "\\ef8d";
}

.ri-plug-2-fill:before {
  content: "\\ef8e";
}

.ri-plug-2-line:before {
  content: "\\ef8f";
}

.ri-plug-fill:before {
  content: "\\ef90";
}

.ri-plug-line:before {
  content: "\\ef91";
}

.ri-polaroid-2-fill:before {
  content: "\\ef92";
}

.ri-polaroid-2-line:before {
  content: "\\ef93";
}

.ri-polaroid-fill:before {
  content: "\\ef94";
}

.ri-polaroid-line:before {
  content: "\\ef95";
}

.ri-police-car-fill:before {
  content: "\\ef96";
}

.ri-police-car-line:before {
  content: "\\ef97";
}

.ri-price-tag-2-fill:before {
  content: "\\ef98";
}

.ri-price-tag-2-line:before {
  content: "\\ef99";
}

.ri-price-tag-3-fill:before {
  content: "\\ef9a";
}

.ri-price-tag-3-line:before {
  content: "\\ef9b";
}

.ri-price-tag-fill:before {
  content: "\\ef9c";
}

.ri-price-tag-line:before {
  content: "\\ef9d";
}

.ri-printer-cloud-fill:before {
  content: "\\ef9e";
}

.ri-printer-cloud-line:before {
  content: "\\ef9f";
}

.ri-printer-fill:before {
  content: "\\efa0";
}

.ri-printer-line:before {
  content: "\\efa1";
}

.ri-product-hunt-fill:before {
  content: "\\efa2";
}

.ri-product-hunt-line:before {
  content: "\\efa3";
}

.ri-profile-fill:before {
  content: "\\efa4";
}

.ri-profile-line:before {
  content: "\\efa5";
}

.ri-projector-2-fill:before {
  content: "\\efa6";
}

.ri-projector-2-line:before {
  content: "\\efa7";
}

.ri-projector-fill:before {
  content: "\\efa8";
}

.ri-projector-line:before {
  content: "\\efa9";
}

.ri-pushpin-2-fill:before {
  content: "\\efaa";
}

.ri-pushpin-2-line:before {
  content: "\\efab";
}

.ri-pushpin-fill:before {
  content: "\\efac";
}

.ri-pushpin-line:before {
  content: "\\efad";
}

.ri-qq-fill:before {
  content: "\\efae";
}

.ri-qq-line:before {
  content: "\\efaf";
}

.ri-qr-code-fill:before {
  content: "\\efb0";
}

.ri-qr-code-line:before {
  content: "\\efb1";
}

.ri-qr-scan-2-fill:before {
  content: "\\efb2";
}

.ri-qr-scan-2-line:before {
  content: "\\efb3";
}

.ri-qr-scan-fill:before {
  content: "\\efb4";
}

.ri-qr-scan-line:before {
  content: "\\efb5";
}

.ri-question-answer-fill:before {
  content: "\\efb6";
}

.ri-question-answer-line:before {
  content: "\\efb7";
}

.ri-question-fill:before {
  content: "\\efb8";
}

.ri-question-line:before {
  content: "\\efb9";
}

.ri-questionnaire-fill:before {
  content: "\\efba";
}

.ri-questionnaire-line:before {
  content: "\\efbb";
}

.ri-quill-pen-fill:before {
  content: "\\efbc";
}

.ri-quill-pen-line:before {
  content: "\\efbd";
}

.ri-radar-fill:before {
  content: "\\efbe";
}

.ri-radar-line:before {
  content: "\\efbf";
}

.ri-radio-2-fill:before {
  content: "\\efc0";
}

.ri-radio-2-line:before {
  content: "\\efc1";
}

.ri-radio-button-fill:before {
  content: "\\efc2";
}

.ri-radio-button-line:before {
  content: "\\efc3";
}

.ri-radio-fill:before {
  content: "\\efc4";
}

.ri-radio-line:before {
  content: "\\efc5";
}

.ri-rainbow-fill:before {
  content: "\\efc6";
}

.ri-rainbow-line:before {
  content: "\\efc7";
}

.ri-rainy-fill:before {
  content: "\\efc8";
}

.ri-rainy-line:before {
  content: "\\efc9";
}

.ri-reactjs-fill:before {
  content: "\\efca";
}

.ri-reactjs-line:before {
  content: "\\efcb";
}

.ri-record-circle-fill:before {
  content: "\\efcc";
}

.ri-record-circle-line:before {
  content: "\\efcd";
}

.ri-record-mail-fill:before {
  content: "\\efce";
}

.ri-record-mail-line:before {
  content: "\\efcf";
}

.ri-red-packet-fill:before {
  content: "\\efd0";
}

.ri-red-packet-line:before {
  content: "\\efd1";
}

.ri-reddit-fill:before {
  content: "\\efd2";
}

.ri-reddit-line:before {
  content: "\\efd3";
}

.ri-refresh-fill:before {
  content: "\\efd4";
}

.ri-refresh-line:before {
  content: "\\efd5";
}

.ri-refund-2-fill:before {
  content: "\\efd6";
}

.ri-refund-2-line:before {
  content: "\\efd7";
}

.ri-refund-fill:before {
  content: "\\efd8";
}

.ri-refund-line:before {
  content: "\\efd9";
}

.ri-registered-fill:before {
  content: "\\efda";
}

.ri-registered-line:before {
  content: "\\efdb";
}

.ri-remixicon-fill:before {
  content: "\\efdc";
}

.ri-remixicon-line:before {
  content: "\\efdd";
}

.ri-remote-control-2-fill:before {
  content: "\\efde";
}

.ri-remote-control-2-line:before {
  content: "\\efdf";
}

.ri-remote-control-fill:before {
  content: "\\efe0";
}

.ri-remote-control-line:before {
  content: "\\efe1";
}

.ri-repeat-2-fill:before {
  content: "\\efe2";
}

.ri-repeat-2-line:before {
  content: "\\efe3";
}

.ri-repeat-fill:before {
  content: "\\efe4";
}

.ri-repeat-line:before {
  content: "\\efe5";
}

.ri-repeat-one-fill:before {
  content: "\\efe6";
}

.ri-repeat-one-line:before {
  content: "\\efe7";
}

.ri-reply-fill:before {
  content: "\\efe8";
}

.ri-reply-line:before {
  content: "\\efe9";
}

.ri-reserved-fill:before {
  content: "\\efea";
}

.ri-reserved-line:before {
  content: "\\efeb";
}

.ri-restart-fill:before {
  content: "\\efec";
}

.ri-restart-line:before {
  content: "\\efed";
}

.ri-restaurant-2-fill:before {
  content: "\\efee";
}

.ri-restaurant-2-line:before {
  content: "\\efef";
}

.ri-restaurant-fill:before {
  content: "\\eff0";
}

.ri-restaurant-line:before {
  content: "\\eff1";
}

.ri-rewind-fill:before {
  content: "\\eff2";
}

.ri-rewind-line:before {
  content: "\\eff3";
}

.ri-rewind-mini-fill:before {
  content: "\\eff4";
}

.ri-rewind-mini-line:before {
  content: "\\eff5";
}

.ri-rhythm-fill:before {
  content: "\\eff6";
}

.ri-rhythm-line:before {
  content: "\\eff7";
}

.ri-riding-fill:before {
  content: "\\eff8";
}

.ri-riding-line:before {
  content: "\\eff9";
}

.ri-road-map-fill:before {
  content: "\\effa";
}

.ri-road-map-line:before {
  content: "\\effb";
}

.ri-roadster-fill:before {
  content: "\\effc";
}

.ri-roadster-line:before {
  content: "\\effd";
}

.ri-robot-fill:before {
  content: "\\effe";
}

.ri-robot-line:before {
  content: "\\efff";
}

.ri-rocket-2-fill:before {
  content: "\\f000";
}

.ri-rocket-2-line:before {
  content: "\\f001";
}

.ri-rocket-fill:before {
  content: "\\f002";
}

.ri-rocket-line:before {
  content: "\\f003";
}

.ri-rotate-lock-fill:before {
  content: "\\f004";
}

.ri-rotate-lock-line:before {
  content: "\\f005";
}

.ri-route-fill:before {
  content: "\\f006";
}

.ri-route-line:before {
  content: "\\f007";
}

.ri-router-fill:before {
  content: "\\f008";
}

.ri-router-line:before {
  content: "\\f009";
}

.ri-rss-fill:before {
  content: "\\f00a";
}

.ri-rss-line:before {
  content: "\\f00b";
}

.ri-ruler-2-fill:before {
  content: "\\f00c";
}

.ri-ruler-2-line:before {
  content: "\\f00d";
}

.ri-ruler-fill:before {
  content: "\\f00e";
}

.ri-ruler-line:before {
  content: "\\f00f";
}

.ri-run-fill:before {
  content: "\\f010";
}

.ri-run-line:before {
  content: "\\f011";
}

.ri-safari-fill:before {
  content: "\\f012";
}

.ri-safari-line:before {
  content: "\\f013";
}

.ri-safe-2-fill:before {
  content: "\\f014";
}

.ri-safe-2-line:before {
  content: "\\f015";
}

.ri-safe-fill:before {
  content: "\\f016";
}

.ri-safe-line:before {
  content: "\\f017";
}

.ri-sailboat-fill:before {
  content: "\\f018";
}

.ri-sailboat-line:before {
  content: "\\f019";
}

.ri-save-2-fill:before {
  content: "\\f01a";
}

.ri-save-2-line:before {
  content: "\\f01b";
}

.ri-save-3-fill:before {
  content: "\\f01c";
}

.ri-save-3-line:before {
  content: "\\f01d";
}

.ri-save-fill:before {
  content: "\\f01e";
}

.ri-save-line:before {
  content: "\\f01f";
}

.ri-scan-2-fill:before {
  content: "\\f020";
}

.ri-scan-2-line:before {
  content: "\\f021";
}

.ri-scan-fill:before {
  content: "\\f022";
}

.ri-scan-line:before {
  content: "\\f023";
}

.ri-scissors-2-fill:before {
  content: "\\f024";
}

.ri-scissors-2-line:before {
  content: "\\f025";
}

.ri-scissors-cut-fill:before {
  content: "\\f026";
}

.ri-scissors-cut-line:before {
  content: "\\f027";
}

.ri-scissors-fill:before {
  content: "\\f028";
}

.ri-scissors-line:before {
  content: "\\f029";
}

.ri-screenshot-2-fill:before {
  content: "\\f02a";
}

.ri-screenshot-2-line:before {
  content: "\\f02b";
}

.ri-screenshot-fill:before {
  content: "\\f02c";
}

.ri-screenshot-line:before {
  content: "\\f02d";
}

.ri-sd-card-fill:before {
  content: "\\f02e";
}

.ri-sd-card-line:before {
  content: "\\f02f";
}

.ri-sd-card-mini-fill:before {
  content: "\\f030";
}

.ri-sd-card-mini-line:before {
  content: "\\f031";
}

.ri-search-2-fill:before {
  content: "\\f032";
}

.ri-search-2-line:before {
  content: "\\f033";
}

.ri-search-eye-fill:before {
  content: "\\f034";
}

.ri-search-eye-line:before {
  content: "\\f035";
}

.ri-search-fill:before {
  content: "\\f036";
}

.ri-search-line:before {
  content: "\\f037";
}

.ri-secure-payment-fill:before {
  content: "\\f038";
}

.ri-secure-payment-line:before {
  content: "\\f039";
}

.ri-send-plane-2-fill:before {
  content: "\\f03a";
}

.ri-send-plane-2-line:before {
  content: "\\f03b";
}

.ri-send-plane-fill:before {
  content: "\\f03c";
}

.ri-send-plane-line:before {
  content: "\\f03d";
}

.ri-sensor-fill:before {
  content: "\\f03e";
}

.ri-sensor-line:before {
  content: "\\f03f";
}

.ri-separator:before {
  content: "\\f040";
}

.ri-server-fill:before {
  content: "\\f041";
}

.ri-server-line:before {
  content: "\\f042";
}

.ri-service-fill:before {
  content: "\\f043";
}

.ri-service-line:before {
  content: "\\f044";
}

.ri-settings-2-fill:before {
  content: "\\f045";
}

.ri-settings-2-line:before {
  content: "\\f046";
}

.ri-settings-3-fill:before {
  content: "\\f047";
}

.ri-settings-3-line:before {
  content: "\\f048";
}

.ri-settings-4-fill:before {
  content: "\\f049";
}

.ri-settings-4-line:before {
  content: "\\f04a";
}

.ri-settings-5-fill:before {
  content: "\\f04b";
}

.ri-settings-5-line:before {
  content: "\\f04c";
}

.ri-settings-6-fill:before {
  content: "\\f04d";
}

.ri-settings-6-line:before {
  content: "\\f04e";
}

.ri-settings-fill:before {
  content: "\\f04f";
}

.ri-settings-line:before {
  content: "\\f050";
}

.ri-shape-2-fill:before {
  content: "\\f051";
}

.ri-shape-2-line:before {
  content: "\\f052";
}

.ri-shape-fill:before {
  content: "\\f053";
}

.ri-shape-line:before {
  content: "\\f054";
}

.ri-share-box-fill:before {
  content: "\\f055";
}

.ri-share-box-line:before {
  content: "\\f056";
}

.ri-share-circle-fill:before {
  content: "\\f057";
}

.ri-share-circle-line:before {
  content: "\\f058";
}

.ri-share-fill:before {
  content: "\\f059";
}

.ri-share-forward-2-fill:before {
  content: "\\f05a";
}

.ri-share-forward-2-line:before {
  content: "\\f05b";
}

.ri-share-forward-box-fill:before {
  content: "\\f05c";
}

.ri-share-forward-box-line:before {
  content: "\\f05d";
}

.ri-share-forward-fill:before {
  content: "\\f05e";
}

.ri-share-forward-line:before {
  content: "\\f05f";
}

.ri-share-line:before {
  content: "\\f060";
}

.ri-shield-cross-fill:before {
  content: "\\f061";
}

.ri-shield-cross-line:before {
  content: "\\f062";
}

.ri-shield-fill:before {
  content: "\\f063";
}

.ri-shield-flash-fill:before {
  content: "\\f064";
}

.ri-shield-flash-line:before {
  content: "\\f065";
}

.ri-shield-keyhole-fill:before {
  content: "\\f066";
}

.ri-shield-keyhole-line:before {
  content: "\\f067";
}

.ri-shield-line:before {
  content: "\\f068";
}

.ri-shield-star-fill:before {
  content: "\\f069";
}

.ri-shield-star-line:before {
  content: "\\f06a";
}

.ri-shield-user-fill:before {
  content: "\\f06b";
}

.ri-shield-user-line:before {
  content: "\\f06c";
}

.ri-ship-2-fill:before {
  content: "\\f06d";
}

.ri-ship-2-line:before {
  content: "\\f06e";
}

.ri-ship-fill:before {
  content: "\\f06f";
}

.ri-ship-line:before {
  content: "\\f070";
}

.ri-shirt-fill:before {
  content: "\\f071";
}

.ri-shirt-line:before {
  content: "\\f072";
}

.ri-shopping-bag-2-fill:before {
  content: "\\f073";
}

.ri-shopping-bag-2-line:before {
  content: "\\f074";
}

.ri-shopping-bag-3-fill:before {
  content: "\\f075";
}

.ri-shopping-bag-3-line:before {
  content: "\\f076";
}

.ri-shopping-bag-fill:before {
  content: "\\f077";
}

.ri-shopping-bag-line:before {
  content: "\\f078";
}

.ri-shopping-basket-2-fill:before {
  content: "\\f079";
}

.ri-shopping-basket-2-line:before {
  content: "\\f07a";
}

.ri-shopping-basket-fill:before {
  content: "\\f07b";
}

.ri-shopping-basket-line:before {
  content: "\\f07c";
}

.ri-shopping-cart-2-fill:before {
  content: "\\f07d";
}

.ri-shopping-cart-2-line:before {
  content: "\\f07e";
}

.ri-shopping-cart-fill:before {
  content: "\\f07f";
}

.ri-shopping-cart-line:before {
  content: "\\f080";
}

.ri-showers-fill:before {
  content: "\\f081";
}

.ri-showers-line:before {
  content: "\\f082";
}

.ri-shuffle-fill:before {
  content: "\\f083";
}

.ri-shuffle-line:before {
  content: "\\f084";
}

.ri-shut-down-fill:before {
  content: "\\f085";
}

.ri-shut-down-line:before {
  content: "\\f086";
}

.ri-side-bar-fill:before {
  content: "\\f087";
}

.ri-side-bar-line:before {
  content: "\\f088";
}

.ri-signal-tower-fill:before {
  content: "\\f089";
}

.ri-signal-tower-line:before {
  content: "\\f08a";
}

.ri-sim-card-2-fill:before {
  content: "\\f08b";
}

.ri-sim-card-2-line:before {
  content: "\\f08c";
}

.ri-sim-card-fill:before {
  content: "\\f08d";
}

.ri-sim-card-line:before {
  content: "\\f08e";
}

.ri-single-quotes-l:before {
  content: "\\f08f";
}

.ri-single-quotes-r:before {
  content: "\\f090";
}

.ri-sip-fill:before {
  content: "\\f091";
}

.ri-sip-line:before {
  content: "\\f092";
}

.ri-skip-back-fill:before {
  content: "\\f093";
}

.ri-skip-back-line:before {
  content: "\\f094";
}

.ri-skip-back-mini-fill:before {
  content: "\\f095";
}

.ri-skip-back-mini-line:before {
  content: "\\f096";
}

.ri-skip-forward-fill:before {
  content: "\\f097";
}

.ri-skip-forward-line:before {
  content: "\\f098";
}

.ri-skip-forward-mini-fill:before {
  content: "\\f099";
}

.ri-skip-forward-mini-line:before {
  content: "\\f09a";
}

.ri-skull-2-fill:before {
  content: "\\f09b";
}

.ri-skull-2-line:before {
  content: "\\f09c";
}

.ri-skull-fill:before {
  content: "\\f09d";
}

.ri-skull-line:before {
  content: "\\f09e";
}

.ri-skype-fill:before {
  content: "\\f09f";
}

.ri-skype-line:before {
  content: "\\f0a0";
}

.ri-slack-fill:before {
  content: "\\f0a1";
}

.ri-slack-line:before {
  content: "\\f0a2";
}

.ri-slice-fill:before {
  content: "\\f0a3";
}

.ri-slice-line:before {
  content: "\\f0a4";
}

.ri-slideshow-2-fill:before {
  content: "\\f0a5";
}

.ri-slideshow-2-line:before {
  content: "\\f0a6";
}

.ri-slideshow-3-fill:before {
  content: "\\f0a7";
}

.ri-slideshow-3-line:before {
  content: "\\f0a8";
}

.ri-slideshow-4-fill:before {
  content: "\\f0a9";
}

.ri-slideshow-4-line:before {
  content: "\\f0aa";
}

.ri-slideshow-fill:before {
  content: "\\f0ab";
}

.ri-slideshow-line:before {
  content: "\\f0ac";
}

.ri-smartphone-fill:before {
  content: "\\f0ad";
}

.ri-smartphone-line:before {
  content: "\\f0ae";
}

.ri-snapchat-fill:before {
  content: "\\f0af";
}

.ri-snapchat-line:before {
  content: "\\f0b0";
}

.ri-snowy-fill:before {
  content: "\\f0b1";
}

.ri-snowy-line:before {
  content: "\\f0b2";
}

.ri-sound-module-fill:before {
  content: "\\f0b3";
}

.ri-sound-module-line:before {
  content: "\\f0b4";
}

.ri-soundcloud-fill:before {
  content: "\\f0b5";
}

.ri-soundcloud-line:before {
  content: "\\f0b6";
}

.ri-space-ship-fill:before {
  content: "\\f0b7";
}

.ri-space-ship-line:before {
  content: "\\f0b8";
}

.ri-space:before {
  content: "\\f0b9";
}

.ri-spam-2-fill:before {
  content: "\\f0ba";
}

.ri-spam-2-line:before {
  content: "\\f0bb";
}

.ri-spam-3-fill:before {
  content: "\\f0bc";
}

.ri-spam-3-line:before {
  content: "\\f0bd";
}

.ri-spam-fill:before {
  content: "\\f0be";
}

.ri-spam-line:before {
  content: "\\f0bf";
}

.ri-speaker-2-fill:before {
  content: "\\f0c0";
}

.ri-speaker-2-line:before {
  content: "\\f0c1";
}

.ri-speaker-3-fill:before {
  content: "\\f0c2";
}

.ri-speaker-3-line:before {
  content: "\\f0c3";
}

.ri-speaker-fill:before {
  content: "\\f0c4";
}

.ri-speaker-line:before {
  content: "\\f0c5";
}

.ri-spectrum-fill:before {
  content: "\\f0c6";
}

.ri-spectrum-line:before {
  content: "\\f0c7";
}

.ri-speed-fill:before {
  content: "\\f0c8";
}

.ri-speed-line:before {
  content: "\\f0c9";
}

.ri-speed-mini-fill:before {
  content: "\\f0ca";
}

.ri-speed-mini-line:before {
  content: "\\f0cb";
}

.ri-spotify-fill:before {
  content: "\\f0cc";
}

.ri-spotify-line:before {
  content: "\\f0cd";
}

.ri-spy-fill:before {
  content: "\\f0ce";
}

.ri-spy-line:before {
  content: "\\f0cf";
}

.ri-stack-fill:before {
  content: "\\f0d0";
}

.ri-stack-line:before {
  content: "\\f0d1";
}

.ri-stack-overflow-fill:before {
  content: "\\f0d2";
}

.ri-stack-overflow-line:before {
  content: "\\f0d3";
}

.ri-stackshare-fill:before {
  content: "\\f0d4";
}

.ri-stackshare-line:before {
  content: "\\f0d5";
}

.ri-star-fill:before {
  content: "\\f0d6";
}

.ri-star-half-fill:before {
  content: "\\f0d7";
}

.ri-star-half-line:before {
  content: "\\f0d8";
}

.ri-star-half-s-fill:before {
  content: "\\f0d9";
}

.ri-star-half-s-line:before {
  content: "\\f0da";
}

.ri-star-line:before {
  content: "\\f0db";
}

.ri-star-s-fill:before {
  content: "\\f0dc";
}

.ri-star-s-line:before {
  content: "\\f0dd";
}

.ri-star-smile-fill:before {
  content: "\\f0de";
}

.ri-star-smile-line:before {
  content: "\\f0df";
}

.ri-steering-2-fill:before {
  content: "\\f0e0";
}

.ri-steering-2-line:before {
  content: "\\f0e1";
}

.ri-steering-fill:before {
  content: "\\f0e2";
}

.ri-steering-line:before {
  content: "\\f0e3";
}

.ri-sticky-note-2-fill:before {
  content: "\\f0e4";
}

.ri-sticky-note-2-line:before {
  content: "\\f0e5";
}

.ri-sticky-note-fill:before {
  content: "\\f0e6";
}

.ri-sticky-note-line:before {
  content: "\\f0e7";
}

.ri-stock-fill:before {
  content: "\\f0e8";
}

.ri-stock-line:before {
  content: "\\f0e9";
}

.ri-stop-circle-fill:before {
  content: "\\f0ea";
}

.ri-stop-circle-line:before {
  content: "\\f0eb";
}

.ri-stop-fill:before {
  content: "\\f0ec";
}

.ri-stop-line:before {
  content: "\\f0ed";
}

.ri-stop-mini-fill:before {
  content: "\\f0ee";
}

.ri-stop-mini-line:before {
  content: "\\f0ef";
}

.ri-store-2-fill:before {
  content: "\\f0f0";
}

.ri-store-2-line:before {
  content: "\\f0f1";
}

.ri-store-3-fill:before {
  content: "\\f0f2";
}

.ri-store-3-line:before {
  content: "\\f0f3";
}

.ri-store-fill:before {
  content: "\\f0f4";
}

.ri-store-line:before {
  content: "\\f0f5";
}

.ri-strikethrough-2:before {
  content: "\\f0f6";
}

.ri-strikethrough:before {
  content: "\\f0f7";
}

.ri-subscript-2:before {
  content: "\\f0f8";
}

.ri-subscript:before {
  content: "\\f0f9";
}

.ri-subtract-fill:before {
  content: "\\f0fa";
}

.ri-subtract-line:before {
  content: "\\f0fb";
}

.ri-subway-fill:before {
  content: "\\f0fc";
}

.ri-subway-line:before {
  content: "\\f0fd";
}

.ri-subway-wifi-fill:before {
  content: "\\f0fe";
}

.ri-subway-wifi-line:before {
  content: "\\f0ff";
}

.ri-sun-cloudy-fill:before {
  content: "\\f100";
}

.ri-sun-cloudy-line:before {
  content: "\\f101";
}

.ri-sun-fill:before {
  content: "\\f102";
}

.ri-sun-foggy-fill:before {
  content: "\\f103";
}

.ri-sun-foggy-line:before {
  content: "\\f104";
}

.ri-sun-line:before {
  content: "\\f105";
}

.ri-superscript-2:before {
  content: "\\f106";
}

.ri-superscript:before {
  content: "\\f107";
}

.ri-surround-sound-fill:before {
  content: "\\f108";
}

.ri-surround-sound-line:before {
  content: "\\f109";
}

.ri-swap-box-fill:before {
  content: "\\f10a";
}

.ri-swap-box-line:before {
  content: "\\f10b";
}

.ri-swap-fill:before {
  content: "\\f10c";
}

.ri-swap-line:before {
  content: "\\f10d";
}

.ri-switch-fill:before {
  content: "\\f10e";
}

.ri-switch-line:before {
  content: "\\f10f";
}

.ri-sword-fill:before {
  content: "\\f110";
}

.ri-sword-line:before {
  content: "\\f111";
}

.ri-t-box-fill:before {
  content: "\\f112";
}

.ri-t-box-line:before {
  content: "\\f113";
}

.ri-t-shirt-2-fill:before {
  content: "\\f114";
}

.ri-t-shirt-2-line:before {
  content: "\\f115";
}

.ri-t-shirt-air-fill:before {
  content: "\\f116";
}

.ri-t-shirt-air-line:before {
  content: "\\f117";
}

.ri-t-shirt-fill:before {
  content: "\\f118";
}

.ri-t-shirt-line:before {
  content: "\\f119";
}

.ri-table-2:before {
  content: "\\f11a";
}

.ri-table-alt-fill:before {
  content: "\\f11b";
}

.ri-table-alt-line:before {
  content: "\\f11c";
}

.ri-table-fill:before {
  content: "\\f11d";
}

.ri-table-line:before {
  content: "\\f11e";
}

.ri-tablet-fill:before {
  content: "\\f11f";
}

.ri-tablet-line:before {
  content: "\\f120";
}

.ri-takeaway-fill:before {
  content: "\\f121";
}

.ri-takeaway-line:before {
  content: "\\f122";
}

.ri-taobao-fill:before {
  content: "\\f123";
}

.ri-taobao-line:before {
  content: "\\f124";
}

.ri-tape-fill:before {
  content: "\\f125";
}

.ri-tape-line:before {
  content: "\\f126";
}

.ri-task-fill:before {
  content: "\\f127";
}

.ri-task-line:before {
  content: "\\f128";
}

.ri-taxi-fill:before {
  content: "\\f129";
}

.ri-taxi-line:before {
  content: "\\f12a";
}

.ri-taxi-wifi-fill:before {
  content: "\\f12b";
}

.ri-taxi-wifi-line:before {
  content: "\\f12c";
}

.ri-team-fill:before {
  content: "\\f12d";
}

.ri-team-line:before {
  content: "\\f12e";
}

.ri-telegram-fill:before {
  content: "\\f12f";
}

.ri-telegram-line:before {
  content: "\\f130";
}

.ri-temp-cold-fill:before {
  content: "\\f131";
}

.ri-temp-cold-line:before {
  content: "\\f132";
}

.ri-temp-hot-fill:before {
  content: "\\f133";
}

.ri-temp-hot-line:before {
  content: "\\f134";
}

.ri-terminal-box-fill:before {
  content: "\\f135";
}

.ri-terminal-box-line:before {
  content: "\\f136";
}

.ri-terminal-fill:before {
  content: "\\f137";
}

.ri-terminal-line:before {
  content: "\\f138";
}

.ri-terminal-window-fill:before {
  content: "\\f139";
}

.ri-terminal-window-line:before {
  content: "\\f13a";
}

.ri-text-direction-l:before {
  content: "\\f13b";
}

.ri-text-direction-r:before {
  content: "\\f13c";
}

.ri-text-spacing:before {
  content: "\\f13d";
}

.ri-text-wrap:before {
  content: "\\f13e";
}

.ri-text:before {
  content: "\\f13f";
}

.ri-thumb-down-fill:before {
  content: "\\f140";
}

.ri-thumb-down-line:before {
  content: "\\f141";
}

.ri-thumb-up-fill:before {
  content: "\\f142";
}

.ri-thumb-up-line:before {
  content: "\\f143";
}

.ri-thunderstorms-fill:before {
  content: "\\f144";
}

.ri-thunderstorms-line:before {
  content: "\\f145";
}

.ri-ticket-2-fill:before {
  content: "\\f146";
}

.ri-ticket-2-line:before {
  content: "\\f147";
}

.ri-ticket-fill:before {
  content: "\\f148";
}

.ri-ticket-line:before {
  content: "\\f149";
}

.ri-time-fill:before {
  content: "\\f14a";
}

.ri-time-line:before {
  content: "\\f14b";
}

.ri-timer-2-fill:before {
  content: "\\f14c";
}

.ri-timer-2-line:before {
  content: "\\f14d";
}

.ri-timer-fill:before {
  content: "\\f14e";
}

.ri-timer-flash-fill:before {
  content: "\\f14f";
}

.ri-timer-flash-line:before {
  content: "\\f150";
}

.ri-timer-line:before {
  content: "\\f151";
}

.ri-todo-fill:before {
  content: "\\f152";
}

.ri-todo-line:before {
  content: "\\f153";
}

.ri-toggle-fill:before {
  content: "\\f154";
}

.ri-toggle-line:before {
  content: "\\f155";
}

.ri-tools-fill:before {
  content: "\\f156";
}

.ri-tools-line:before {
  content: "\\f157";
}

.ri-tornado-fill:before {
  content: "\\f158";
}

.ri-tornado-line:before {
  content: "\\f159";
}

.ri-trademark-fill:before {
  content: "\\f15a";
}

.ri-trademark-line:before {
  content: "\\f15b";
}

.ri-traffic-light-fill:before {
  content: "\\f15c";
}

.ri-traffic-light-line:before {
  content: "\\f15d";
}

.ri-train-fill:before {
  content: "\\f15e";
}

.ri-train-line:before {
  content: "\\f15f";
}

.ri-train-wifi-fill:before {
  content: "\\f160";
}

.ri-train-wifi-line:before {
  content: "\\f161";
}

.ri-translate-2:before {
  content: "\\f162";
}

.ri-translate:before {
  content: "\\f163";
}

.ri-travesti-fill:before {
  content: "\\f164";
}

.ri-travesti-line:before {
  content: "\\f165";
}

.ri-treasure-map-fill:before {
  content: "\\f166";
}

.ri-treasure-map-line:before {
  content: "\\f167";
}

.ri-trello-fill:before {
  content: "\\f168";
}

.ri-trello-line:before {
  content: "\\f169";
}

.ri-trophy-fill:before {
  content: "\\f16a";
}

.ri-trophy-line:before {
  content: "\\f16b";
}

.ri-truck-fill:before {
  content: "\\f16c";
}

.ri-truck-line:before {
  content: "\\f16d";
}

.ri-tumblr-fill:before {
  content: "\\f16e";
}

.ri-tumblr-line:before {
  content: "\\f16f";
}

.ri-tv-2-fill:before {
  content: "\\f170";
}

.ri-tv-2-line:before {
  content: "\\f171";
}

.ri-tv-fill:before {
  content: "\\f172";
}

.ri-tv-line:before {
  content: "\\f173";
}

.ri-twitch-fill:before {
  content: "\\f174";
}

.ri-twitch-line:before {
  content: "\\f175";
}

.ri-twitter-fill:before {
  content: "\\f176";
}

.ri-twitter-line:before {
  content: "\\f177";
}

.ri-typhoon-fill:before {
  content: "\\f178";
}

.ri-typhoon-line:before {
  content: "\\f179";
}

.ri-u-disk-fill:before {
  content: "\\f17a";
}

.ri-u-disk-line:before {
  content: "\\f17b";
}

.ri-ubuntu-fill:before {
  content: "\\f17c";
}

.ri-ubuntu-line:before {
  content: "\\f17d";
}

.ri-umbrella-fill:before {
  content: "\\f17e";
}

.ri-umbrella-line:before {
  content: "\\f17f";
}

.ri-underline:before {
  content: "\\f180";
}

.ri-uninstall-fill:before {
  content: "\\f181";
}

.ri-uninstall-line:before {
  content: "\\f182";
}

.ri-upload-2-fill:before {
  content: "\\f183";
}

.ri-upload-2-line:before {
  content: "\\f184";
}

.ri-upload-cloud-2-fill:before {
  content: "\\f185";
}

.ri-upload-cloud-2-line:before {
  content: "\\f186";
}

.ri-upload-cloud-fill:before {
  content: "\\f187";
}

.ri-upload-cloud-line:before {
  content: "\\f188";
}

.ri-upload-fill:before {
  content: "\\f189";
}

.ri-upload-line:before {
  content: "\\f18a";
}

.ri-user-2-fill:before {
  content: "\\f18b";
}

.ri-user-2-line:before {
  content: "\\f18c";
}

.ri-user-3-fill:before {
  content: "\\f18d";
}

.ri-user-3-line:before {
  content: "\\f18e";
}

.ri-user-4-fill:before {
  content: "\\f18f";
}

.ri-user-4-line:before {
  content: "\\f190";
}

.ri-user-5-fill:before {
  content: "\\f191";
}

.ri-user-5-line:before {
  content: "\\f192";
}

.ri-user-6-fill:before {
  content: "\\f193";
}

.ri-user-6-line:before {
  content: "\\f194";
}

.ri-user-add-fill:before {
  content: "\\f195";
}

.ri-user-add-line:before {
  content: "\\f196";
}

.ri-user-fill:before {
  content: "\\f197";
}

.ri-user-follow-fill:before {
  content: "\\f198";
}

.ri-user-follow-line:before {
  content: "\\f199";
}

.ri-user-heart-fill:before {
  content: "\\f19a";
}

.ri-user-heart-line:before {
  content: "\\f19b";
}

.ri-user-line:before {
  content: "\\f19c";
}

.ri-user-location-fill:before {
  content: "\\f19d";
}

.ri-user-location-line:before {
  content: "\\f19e";
}

.ri-user-received-2-fill:before {
  content: "\\f19f";
}

.ri-user-received-2-line:before {
  content: "\\f1a0";
}

.ri-user-received-fill:before {
  content: "\\f1a1";
}

.ri-user-received-line:before {
  content: "\\f1a2";
}

.ri-user-search-fill:before {
  content: "\\f1a3";
}

.ri-user-search-line:before {
  content: "\\f1a4";
}

.ri-user-settings-fill:before {
  content: "\\f1a5";
}

.ri-user-settings-line:before {
  content: "\\f1a6";
}

.ri-user-shared-2-fill:before {
  content: "\\f1a7";
}

.ri-user-shared-2-line:before {
  content: "\\f1a8";
}

.ri-user-shared-fill:before {
  content: "\\f1a9";
}

.ri-user-shared-line:before {
  content: "\\f1aa";
}

.ri-user-smile-fill:before {
  content: "\\f1ab";
}

.ri-user-smile-line:before {
  content: "\\f1ac";
}

.ri-user-star-fill:before {
  content: "\\f1ad";
}

.ri-user-star-line:before {
  content: "\\f1ae";
}

.ri-user-unfollow-fill:before {
  content: "\\f1af";
}

.ri-user-unfollow-line:before {
  content: "\\f1b0";
}

.ri-user-voice-fill:before {
  content: "\\f1b1";
}

.ri-user-voice-line:before {
  content: "\\f1b2";
}

.ri-video-chat-fill:before {
  content: "\\f1b3";
}

.ri-video-chat-line:before {
  content: "\\f1b4";
}

.ri-video-fill:before {
  content: "\\f1b5";
}

.ri-video-line:before {
  content: "\\f1b6";
}

.ri-vidicon-2-fill:before {
  content: "\\f1b7";
}

.ri-vidicon-2-line:before {
  content: "\\f1b8";
}

.ri-vidicon-fill:before {
  content: "\\f1b9";
}

.ri-vidicon-line:before {
  content: "\\f1ba";
}

.ri-vip-crown-2-fill:before {
  content: "\\f1bb";
}

.ri-vip-crown-2-line:before {
  content: "\\f1bc";
}

.ri-vip-crown-fill:before {
  content: "\\f1bd";
}

.ri-vip-crown-line:before {
  content: "\\f1be";
}

.ri-vip-diamond-fill:before {
  content: "\\f1bf";
}

.ri-vip-diamond-line:before {
  content: "\\f1c0";
}

.ri-vip-fill:before {
  content: "\\f1c1";
}

.ri-vip-line:before {
  content: "\\f1c2";
}

.ri-visa-fill:before {
  content: "\\f1c3";
}

.ri-visa-line:before {
  content: "\\f1c4";
}

.ri-voice-recognition-fill:before {
  content: "\\f1c5";
}

.ri-voice-recognition-line:before {
  content: "\\f1c6";
}

.ri-voiceprint-fill:before {
  content: "\\f1c7";
}

.ri-voiceprint-line:before {
  content: "\\f1c8";
}

.ri-volume-down-fill:before {
  content: "\\f1c9";
}

.ri-volume-down-line:before {
  content: "\\f1ca";
}

.ri-volume-mute-fill:before {
  content: "\\f1cb";
}

.ri-volume-mute-line:before {
  content: "\\f1cc";
}

.ri-volume-off-vibrate-fill:before {
  content: "\\f1cd";
}

.ri-volume-off-vibrate-line:before {
  content: "\\f1ce";
}

.ri-volume-up-fill:before {
  content: "\\f1cf";
}

.ri-volume-up-line:before {
  content: "\\f1d0";
}

.ri-volume-vibrate-fill:before {
  content: "\\f1d1";
}

.ri-volume-vibrate-line:before {
  content: "\\f1d2";
}

.ri-vuejs-fill:before {
  content: "\\f1d3";
}

.ri-vuejs-line:before {
  content: "\\f1d4";
}

.ri-walk-fill:before {
  content: "\\f1d5";
}

.ri-walk-line:before {
  content: "\\f1d6";
}

.ri-wallet-2-fill:before {
  content: "\\f1d7";
}

.ri-wallet-2-line:before {
  content: "\\f1d8";
}

.ri-wallet-3-fill:before {
  content: "\\f1d9";
}

.ri-wallet-3-line:before {
  content: "\\f1da";
}

.ri-wallet-fill:before {
  content: "\\f1db";
}

.ri-wallet-line:before {
  content: "\\f1dc";
}

.ri-water-flash-fill:before {
  content: "\\f1dd";
}

.ri-water-flash-line:before {
  content: "\\f1de";
}

.ri-webcam-fill:before {
  content: "\\f1df";
}

.ri-webcam-line:before {
  content: "\\f1e0";
}

.ri-wechat-2-fill:before {
  content: "\\f1e1";
}

.ri-wechat-2-line:before {
  content: "\\f1e2";
}

.ri-wechat-fill:before {
  content: "\\f1e3";
}

.ri-wechat-line:before {
  content: "\\f1e4";
}

.ri-wechat-pay-fill:before {
  content: "\\f1e5";
}

.ri-wechat-pay-line:before {
  content: "\\f1e6";
}

.ri-weibo-fill:before {
  content: "\\f1e7";
}

.ri-weibo-line:before {
  content: "\\f1e8";
}

.ri-whatsapp-fill:before {
  content: "\\f1e9";
}

.ri-whatsapp-line:before {
  content: "\\f1ea";
}

.ri-wifi-fill:before {
  content: "\\f1eb";
}

.ri-wifi-line:before {
  content: "\\f1ec";
}

.ri-wifi-off-fill:before {
  content: "\\f1ed";
}

.ri-wifi-off-line:before {
  content: "\\f1ee";
}

.ri-window-2-fill:before {
  content: "\\f1ef";
}

.ri-window-2-line:before {
  content: "\\f1f0";
}

.ri-window-fill:before {
  content: "\\f1f1";
}

.ri-window-line:before {
  content: "\\f1f2";
}

.ri-windows-fill:before {
  content: "\\f1f3";
}

.ri-windows-line:before {
  content: "\\f1f4";
}

.ri-windy-fill:before {
  content: "\\f1f5";
}

.ri-windy-line:before {
  content: "\\f1f6";
}

.ri-women-fill:before {
  content: "\\f1f7";
}

.ri-women-line:before {
  content: "\\f1f8";
}

.ri-wubi-input:before {
  content: "\\f1f9";
}

.ri-xbox-fill:before {
  content: "\\f1fa";
}

.ri-xbox-line:before {
  content: "\\f1fb";
}

.ri-xing-fill:before {
  content: "\\f1fc";
}

.ri-xing-line:before {
  content: "\\f1fd";
}

.ri-youtube-fill:before {
  content: "\\f1fe";
}

.ri-youtube-line:before {
  content: "\\f1ff";
}

.ri-zcool-fill:before {
  content: "\\f200";
}

.ri-zcool-line:before {
  content: "\\f201";
}

.ri-zhihu-fill:before {
  content: "\\f202";
}

.ri-zhihu-line:before {
  content: "\\f203";
}

.ri-zoom-in-fill:before {
  content: "\\f204";
}

.ri-zoom-in-line:before {
  content: "\\f205";
}

.ri-zoom-out-fill:before {
  content: "\\f206";
}

.ri-zoom-out-line:before {
  content: "\\f207";
}

/*
Template Name: Chat Sms.by
Author: Themesbrand
Version: 2.0.0
Website: https://themesbrand.com/
Contact: themesbrand@gmail.com
File: Custom Bootstrap Css File
*/
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #7269ef;
  --bs-indigo: #564ab1;
  --bs-purple: #8e4aec;
  --bs-pink: #e83e8c;
  --bs-red: #ef476f;
  --bs-orange: #fc814a;
  --bs-yellow: #ffd166;
  --bs-green: #06d6a0;
  --bs-teal: #050505;
  --bs-cyan: #50a5f1;
  --bs-white: #fff;
  --bs-gray: #7a7f9a;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #f5f7fb;
  --bs-gray-300: #f0eff5;
  --bs-gray-400: #e6ebf5;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #7a7f9a;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #7269ef;
  --bs-secondary: #7a7f9a;
  --bs-success: #06d6a0;
  --bs-info: #50a5f1;
  --bs-warning: #ffd166;
  --bs-danger: #ef476f;
  --bs-light: #e6ebf5;
  --bs-dark: #343a40;
  --bs-primary-rgb: 114, 105, 239;
  --bs-secondary-rgb: 122, 127, 154;
  --bs-success-rgb: 6, 214, 160;
  --bs-info-rgb: 80, 165, 241;
  --bs-warning-rgb: 255, 209, 102;
  --bs-danger-rgb: 239, 71, 111;
  --bs-light-rgb: 230, 235, 245;
  --bs-dark-rgb: 52, 58, 64;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: "Public Sans", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: "Public Sans", sans-serif;
  --bs-body-font-size: 0.9375rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #495057;
  --bs-body-color-rgb: 73, 80, 87;
  --bs-body-bg: #ffffff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #7269ef;
  --bs-link-color-rgb: 114, 105, 239;
  --bs-link-decoration: none;
  --bs-link-hover-color: rgb(96.9, 89.25, 203.15);
  --bs-link-hover-color-rgb: 97, 89, 203;
  --bs-link-hover-decoration: underline;
  --bs-code-color: #e83e8c;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fcf8e3;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #f0eff5;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.25rem;
  --bs-border-radius-sm: 0.2rem;
  --bs-border-radius-lg: 0.4rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.359375rem + 1.3125vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.34375rem;
  }
}

h2, .h2 {
  font-size: calc(1.3125rem + 0.75vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.875rem;
  }
}

h3, .h3 {
  font-size: calc(1.2890625rem + 0.46875vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.640625rem;
  }
}

h4, .h4 {
  font-size: calc(1.25625rem + 0.075vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.3125rem;
  }
}

h5, .h5 {
  font-size: 1.171875rem;
}

h6, .h6 {
  font-size: 0.9375rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.2em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
  text-decoration: underline;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 0.875em;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #7a7f9a;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.171875rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.171875rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #7a7f9a;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #ffffff;
  border: 1px solid #f0eff5;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: #7a7f9a;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 12px;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 24px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: #495057;
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: #f0eff5;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #495057;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #495057;
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  --bs-table-hover-color: #495057;
  --bs-table-hover-bg: #f8f9fa;
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(1px * 2) solid currentColor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #212529;
  --bs-table-bg: rgb(226.8, 225, 251.8);
  --bs-table-border-color: rgb(207.42, 206.2, 230.72);
  --bs-table-striped-bg: rgb(217.11, 215.6, 241.26);
  --bs-table-striped-color: #212529;
  --bs-table-active-bg: rgb(207.42, 206.2, 230.72);
  --bs-table-active-color: #212529;
  --bs-table-hover-bg: rgb(212.265, 210.9, 235.99);
  --bs-table-hover-color: #212529;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #212529;
  --bs-table-bg: rgb(228.4, 229.4, 234.8);
  --bs-table-border-color: rgb(208.86, 210.16, 215.42);
  --bs-table-striped-bg: rgb(218.63, 219.78, 225.11);
  --bs-table-striped-color: #212529;
  --bs-table-active-bg: rgb(208.86, 210.16, 215.42);
  --bs-table-active-color: #212529;
  --bs-table-hover-bg: rgb(213.745, 214.97, 220.265);
  --bs-table-hover-color: #212529;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #212529;
  --bs-table-bg: rgb(205.2, 246.8, 236);
  --bs-table-border-color: rgb(187.98, 225.82, 216.5);
  --bs-table-striped-bg: rgb(196.59, 236.31, 226.25);
  --bs-table-striped-color: #212529;
  --bs-table-active-bg: rgb(187.98, 225.82, 216.5);
  --bs-table-active-color: #212529;
  --bs-table-hover-bg: rgb(192.285, 231.065, 221.375);
  --bs-table-hover-color: #212529;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #212529;
  --bs-table-bg: rgb(220, 237, 252.2);
  --bs-table-border-color: rgb(201.3, 217, 231.08);
  --bs-table-striped-bg: rgb(210.65, 227, 241.64);
  --bs-table-striped-color: #212529;
  --bs-table-active-bg: rgb(201.3, 217, 231.08);
  --bs-table-active-color: #212529;
  --bs-table-hover-bg: rgb(205.975, 222, 236.36);
  --bs-table-hover-color: #212529;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #212529;
  --bs-table-bg: rgb(255, 245.8, 224.4);
  --bs-table-border-color: rgb(232.8, 224.92, 206.06);
  --bs-table-striped-bg: rgb(243.9, 235.36, 215.23);
  --bs-table-striped-color: #212529;
  --bs-table-active-bg: rgb(232.8, 224.92, 206.06);
  --bs-table-active-color: #212529;
  --bs-table-hover-bg: rgb(238.35, 230.14, 210.645);
  --bs-table-hover-color: #212529;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #212529;
  --bs-table-bg: rgb(251.8, 218.2, 226.2);
  --bs-table-border-color: rgb(229.92, 200.08, 207.68);
  --bs-table-striped-bg: rgb(240.86, 209.14, 216.94);
  --bs-table-striped-color: #212529;
  --bs-table-active-bg: rgb(229.92, 200.08, 207.68);
  --bs-table-active-color: #212529;
  --bs-table-hover-bg: rgb(235.39, 204.61, 212.31);
  --bs-table-hover-color: #212529;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #212529;
  --bs-table-bg: #e6ebf5;
  --bs-table-border-color: rgb(210.3, 215.2, 224.6);
  --bs-table-striped-bg: rgb(220.15, 225.1, 234.8);
  --bs-table-striped-color: #212529;
  --bs-table-active-bg: rgb(210.3, 215.2, 224.6);
  --bs-table-active-color: #212529;
  --bs-table-hover-bg: rgb(215.225, 220.15, 229.7);
  --bs-table-hover-color: #212529;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #343a40;
  --bs-table-border-color: rgb(72.3, 77.7, 83.1);
  --bs-table-striped-bg: rgb(62.15, 67.85, 73.55);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(72.3, 77.7, 83.1);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(67.225, 72.775, 78.325);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 0.875rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.8203125rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #7a7f9a;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  appearance: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e6ebf5;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(207, 211.5, 220.5);
  outline: 0;
  box-shadow: none;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: #7a7f9a;
  opacity: 1;
}
.form-control:disabled {
  background-color: #fff;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
  color: #495057;
  background-color: #f5f7fb;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: rgb(232.75, 234.65, 238.45);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + calc(0.5rem + 2px));
  padding: 0.25rem 0.5rem;
  font-size: 0.8203125rem;
  border-radius: 0.2rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + calc(1rem + 6px));
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  border-radius: 0.4rem;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + calc(1rem + 2px));
}
textarea.form-control-sm {
  min-height: calc(1.5em + calc(0.5rem + 2px));
}
textarea.form-control-lg {
  min-height: calc(1.5em + calc(1rem + 6px));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + calc(1rem + 2px));
  padding: 0.5rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + calc(0.5rem + 2px));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + calc(1rem + 6px));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  display: block;
  width: 100%;
  padding: 0.5rem 1rem 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  appearance: none;
  background-color: #fff;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 8px 10px;
  border: 1px solid #e6ebf5;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(207, 211.5, 220.5);
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(114, 105, 239, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 1rem;
  background-image: none;
}
.form-select:disabled {
  color: #7a7f9a;
  background-color: #f5f7fb;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.8203125rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.form-check {
  display: block;
  min-height: 1.40625rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: #ffffff;
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-check-input {
    transition: none;
  }
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(207, 211.5, 220.5);
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(114, 105, 239, 0.25);
}
.form-check-input:checked {
  background-color: #7269ef;
  border-color: #7269ef;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #7269ef;
  border-color: #7269ef;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.form-range {
  width: 100%;
  height: 1.3rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #ffffff, none;
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #ffffff, none;
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #7269ef;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(212.7, 210, 250.2);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #f0eff5;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #7269ef;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(212.7, 210, 250.2);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #f0eff5;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  min-height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 1rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 1rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.5rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: #fff;
  border-radius: 0.25rem;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: #fff;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #f5f7fb;
  border: 1px solid #e6ebf5;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  border-radius: 0.4rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.8203125rem;
  border-radius: 0.2rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 2rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(1px * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #06d6a0;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.8203125rem;
  color: #fff;
  background-color: rgba(6, 214, 160, 0.9);
  border-radius: 0.25rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #06d6a0;
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #06d6a0;
  box-shadow: 0 0 0 0.15rem rgba(6, 214, 160, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #06d6a0;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  padding-right: calc(0.75em + 2.75rem);
  background-position: right 1rem center, center right 2rem;
  background-size: 8px 10px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #06d6a0;
  box-shadow: 0 0 0 0.15rem rgba(6, 214, 160, 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #06d6a0;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #06d6a0;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.15rem rgba(6, 214, 160, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #06d6a0;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #ef476f;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.8203125rem;
  color: #fff;
  background-color: rgba(239, 71, 111, 0.9);
  border-radius: 0.25rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #ef476f;
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #ef476f;
  box-shadow: 0 0 0 0.15rem rgba(239, 71, 111, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #ef476f;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  padding-right: calc(0.75em + 2.75rem);
  background-position: right 1rem center, center right 2rem;
  background-size: 8px 10px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #ef476f;
  box-shadow: 0 0 0 0.15rem rgba(239, 71, 111, 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #ef476f;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #ef476f;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.15rem rgba(239, 71, 111, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #ef476f;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.47rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.9375rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.25rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  text-decoration: none;
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #7269ef;
  --bs-btn-border-color: #7269ef;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(96.9, 89.25, 203.15);
  --bs-btn-hover-border-color: rgb(91.2, 84, 191.2);
  --bs-btn-focus-shadow-rgb: 135, 128, 241;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(91.2, 84, 191.2);
  --bs-btn-active-border-color: rgb(85.5, 78.75, 179.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #7269ef;
  --bs-btn-disabled-border-color: #7269ef;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #7a7f9a;
  --bs-btn-border-color: #7a7f9a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(103.7, 107.95, 130.9);
  --bs-btn-hover-border-color: rgb(97.6, 101.6, 123.2);
  --bs-btn-focus-shadow-rgb: 142, 146, 169;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(97.6, 101.6, 123.2);
  --bs-btn-active-border-color: rgb(91.5, 95.25, 115.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #7a7f9a;
  --bs-btn-disabled-border-color: #7a7f9a;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #06d6a0;
  --bs-btn-border-color: #06d6a0;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(5.1, 181.9, 136);
  --bs-btn-hover-border-color: rgb(4.8, 171.2, 128);
  --bs-btn-focus-shadow-rgb: 43, 220, 174;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(4.8, 171.2, 128);
  --bs-btn-active-border-color: rgb(4.5, 160.5, 120);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #06d6a0;
  --bs-btn-disabled-border-color: #06d6a0;
}

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #50a5f1;
  --bs-btn-border-color: #50a5f1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(68, 140.25, 204.85);
  --bs-btn-hover-border-color: rgb(64, 132, 192.8);
  --bs-btn-focus-shadow-rgb: 106, 179, 243;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(64, 132, 192.8);
  --bs-btn-active-border-color: rgb(60, 123.75, 180.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #50a5f1;
  --bs-btn-disabled-border-color: #50a5f1;
}

.btn-warning {
  --bs-btn-color: #212529;
  --bs-btn-bg: #ffd166;
  --bs-btn-border-color: #ffd166;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: rgb(255, 215.9, 124.95);
  --bs-btn-hover-border-color: rgb(255, 213.6, 117.3);
  --bs-btn-focus-shadow-rgb: 222, 183, 93;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: rgb(255, 218.2, 132.6);
  --bs-btn-active-border-color: rgb(255, 213.6, 117.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: #ffd166;
  --bs-btn-disabled-border-color: #ffd166;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #ef476f;
  --bs-btn-border-color: #ef476f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(203.15, 60.35, 94.35);
  --bs-btn-hover-border-color: rgb(191.2, 56.8, 88.8);
  --bs-btn-focus-shadow-rgb: 241, 99, 133;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(191.2, 56.8, 88.8);
  --bs-btn-active-border-color: rgb(179.25, 53.25, 83.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #ef476f;
  --bs-btn-disabled-border-color: #ef476f;
}

.btn-light {
  --bs-btn-color: #212529;
  --bs-btn-bg: #e6ebf5;
  --bs-btn-border-color: #e6ebf5;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: rgb(195.5, 199.75, 208.25);
  --bs-btn-hover-border-color: #b8bcc4;
  --bs-btn-focus-shadow-rgb: 200, 205, 214;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b8bcc4;
  --bs-btn-active-border-color: rgb(172.5, 176.25, 183.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: #e6ebf5;
  --bs-btn-disabled-border-color: #e6ebf5;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(82.45, 87.55, 92.65);
  --bs-btn-hover-border-color: rgb(72.3, 77.7, 83.1);
  --bs-btn-focus-shadow-rgb: 82, 88, 93;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(92.6, 97.4, 102.2);
  --bs-btn-active-border-color: rgb(72.3, 77.7, 83.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #343a40;
  --bs-btn-disabled-border-color: #343a40;
}

.btn-outline-primary {
  --bs-btn-color: #7269ef;
  --bs-btn-border-color: #7269ef;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #7269ef;
  --bs-btn-hover-border-color: #7269ef;
  --bs-btn-focus-shadow-rgb: 114, 105, 239;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #7269ef;
  --bs-btn-active-border-color: #7269ef;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #7269ef;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7269ef;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #7a7f9a;
  --bs-btn-border-color: #7a7f9a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #7a7f9a;
  --bs-btn-hover-border-color: #7a7f9a;
  --bs-btn-focus-shadow-rgb: 122, 127, 154;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #7a7f9a;
  --bs-btn-active-border-color: #7a7f9a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #7a7f9a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7a7f9a;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #06d6a0;
  --bs-btn-border-color: #06d6a0;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #06d6a0;
  --bs-btn-hover-border-color: #06d6a0;
  --bs-btn-focus-shadow-rgb: 6, 214, 160;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #06d6a0;
  --bs-btn-active-border-color: #06d6a0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #06d6a0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #06d6a0;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #50a5f1;
  --bs-btn-border-color: #50a5f1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #50a5f1;
  --bs-btn-hover-border-color: #50a5f1;
  --bs-btn-focus-shadow-rgb: 80, 165, 241;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #50a5f1;
  --bs-btn-active-border-color: #50a5f1;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #50a5f1;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #50a5f1;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffd166;
  --bs-btn-border-color: #ffd166;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #ffd166;
  --bs-btn-hover-border-color: #ffd166;
  --bs-btn-focus-shadow-rgb: 255, 209, 102;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #ffd166;
  --bs-btn-active-border-color: #ffd166;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffd166;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffd166;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #ef476f;
  --bs-btn-border-color: #ef476f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ef476f;
  --bs-btn-hover-border-color: #ef476f;
  --bs-btn-focus-shadow-rgb: 239, 71, 111;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ef476f;
  --bs-btn-active-border-color: #ef476f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ef476f;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ef476f;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #e6ebf5;
  --bs-btn-border-color: #e6ebf5;
  --bs-btn-hover-color: #212529;
  --bs-btn-hover-bg: #e6ebf5;
  --bs-btn-hover-border-color: #e6ebf5;
  --bs-btn-focus-shadow-rgb: 230, 235, 245;
  --bs-btn-active-color: #212529;
  --bs-btn-active-bg: #e6ebf5;
  --bs-btn-active-border-color: #e6ebf5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e6ebf5;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e6ebf5;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343a40;
  --bs-btn-hover-border-color: #343a40;
  --bs-btn-focus-shadow-rgb: 52, 58, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #343a40;
  --bs-btn-active-border-color: #343a40;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #343a40;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343a40;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: #7269ef;
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: rgb(96.9, 89.25, 203.15);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: rgb(96.9, 89.25, 203.15);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #7a7f9a;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: none;
}
.btn-link:hover, .btn-link:focus-visible {
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.171875rem;
  --bs-btn-border-radius: 0.4rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.8203125rem;
  --bs-btn-border-radius: 0.2rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.9375rem;
  --bs-dropdown-color: #495057;
  --bs-dropdown-bg: #fff;
  --bs-dropdown-border-color: #f0eff5;
  --bs-dropdown-border-radius: 0.25rem;
  --bs-dropdown-border-width: 1px;
  --bs-dropdown-inner-border-radius: calc(0.25rem - 1px);
  --bs-dropdown-divider-bg: #f0eff5;
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  --bs-dropdown-link-color: #212529;
  --bs-dropdown-link-hover-color: rgb(31.35, 35.15, 38.95);
  --bs-dropdown-link-hover-bg: #f8f9fa;
  --bs-dropdown-link-active-color: rgb(21.6283783784, 24.25, 26.8716216216);
  --bs-dropdown-link-active-bg: #f8f9fa;
  --bs-dropdown-link-disabled-color: #7a7f9a;
  --bs-dropdown-item-padding-x: 1.5rem;
  --bs-dropdown-item-padding-y: 0.35rem;
  --bs-dropdown-header-color: #7a7f9a;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.8203125rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #f0eff5;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: #f0eff5;
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #f0eff5;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: #f0eff5;
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: rgb(21.6283783784, 24.25, 26.8716216216);
  --bs-dropdown-link-active-bg: #f8f9fa;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.25rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(1px * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(1px * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: #7a7f9a;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
  text-decoration: none;
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: #e6ebf5;
  --bs-nav-tabs-border-radius: 0.25rem;
  --bs-nav-tabs-link-hover-border-color: #f5f7fb #f5f7fb #e6ebf5;
  --bs-nav-tabs-link-active-color: #495057;
  --bs-nav-tabs-link-active-bg: #ffffff;
  --bs-nav-tabs-link-active-border-color: #e6ebf5 #e6ebf5 #ffffff;
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.25rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #7269ef;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 1rem;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(0, 0, 0, 0.55);
  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-padding-y: 0.32421875rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.171875rem;
  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.171875rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: 0.25rem;
  --bs-navbar-toggler-focus-width: 0.15rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
  text-decoration: none;
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.card {
  --bs-card-spacer-y: 1.25rem;
  --bs-card-spacer-x: 1.25rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 0;
  --bs-card-border-color: #f5f7fb;
  --bs-card-border-radius: 0.25rem;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: 0.25rem;
  --bs-card-cap-padding-y: 0.75rem;
  --bs-card-cap-padding-x: 1.25rem;
  --bs-card-cap-bg: #f5f7fb;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #fff;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: #495057;
  --bs-accordion-bg: #fff;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: #f0eff5;
  --bs-accordion-border-width: 0;
  --bs-accordion-border-radius: 0.25rem;
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 0.75rem;
  --bs-accordion-btn-color: #495057;
  --bs-accordion-btn-bg: #f5f7fb;
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  --bs-accordion-btn-icon-width: 0.75rem;
  --bs-accordion-btn-icon-transform: rotate(180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1.25rem;
  --bs-accordion-active-color: #495057;
  --bs-accordion-active-bg: #f5f7fb;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.9375rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #7a7f9a;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #7a7f9a;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: #7269ef;
  --bs-pagination-bg: #fff;
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: #f0eff5;
  --bs-pagination-border-radius: 0.25rem;
  --bs-pagination-hover-color: rgb(96.9, 89.25, 203.15);
  --bs-pagination-hover-bg: #f5f7fb;
  --bs-pagination-hover-border-color: #f0eff5;
  --bs-pagination-focus-color: rgb(96.9, 89.25, 203.15);
  --bs-pagination-focus-bg: #f5f7fb;
  --bs-pagination-focus-box-shadow: 0 0 0 0.15rem rgba(114, 105, 239, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #7269ef;
  --bs-pagination-active-border-color: #7269ef;
  --bs-pagination-disabled-color: #7a7f9a;
  --bs-pagination-disabled-bg: #fff;
  --bs-pagination-disabled-border-color: #f0eff5;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  text-decoration: none;
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item .page-link {
  border-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.171875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.8203125rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.6em;
  --bs-badge-padding-y: 0.25em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 500;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1.25rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.25rem;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.9375rem 1.25rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.703125rem;
  --bs-progress-bg: #f5f7fb;
  --bs-progress-border-radius: 0.25rem;
  --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #7269ef;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: #fff;
  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.25rem;
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: #495057;
  --bs-list-group-action-hover-color: #495057;
  --bs-list-group-action-hover-bg: #f8f9fa;
  --bs-list-group-action-active-color: #495057;
  --bs-list-group-action-active-bg: #f5f7fb;
  --bs-list-group-disabled-color: #7a7f9a;
  --bs-list-group-disabled-bg: #fff;
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #7269ef;
  --bs-list-group-active-border-color: #7269ef;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: none;
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 0.6em;
  height: 0.6em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/0.6em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 12px;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: rgba(0, 0, 0, 0.1);
  --bs-toast-border-radius: 0.25rem;
  --bs-toast-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --bs-toast-header-color: #7a7f9a;
  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1050;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: #fff;
  --bs-modal-border-color: #f0eff5;
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.4rem;
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius: calc(0.4rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: #f0eff5;
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: #f0eff5;
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1040;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1070;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.8203125rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #000;
  --bs-tooltip-border-radius: 0.25rem;
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: "Public Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1060;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.8203125rem;
  --bs-popover-bg: #fff;
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: rgba(0, 0, 0, 0.2);
  --bs-popover-border-radius: 0.4rem;
  --bs-popover-inner-border-radius: calc(0.4rem - 1px);
  --bs-popover-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: rgb(239.7, 239.7, 239.7);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: #495057;
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: "Public Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #212529 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #212529 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(97, 89, 203, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(97, 89, 203, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(104, 108, 131, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(104, 108, 131, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(5, 182, 136, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(5, 182, 136, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(68, 140, 205, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(68, 140, 205, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 216, 125, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 216, 125, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(203, 60, 94, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(203, 60, 94, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(234, 238, 247, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(234, 238, 247, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(44, 49, 54, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(44, 49, 54, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-0 {
  border-width: 0 !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.359375rem + 1.3125vw) !important;
}

.fs-2 {
  font-size: calc(1.3125rem + 0.75vw) !important;
}

.fs-3 {
  font-size: calc(1.2890625rem + 0.46875vw) !important;
}

.fs-4 {
  font-size: calc(1.25625rem + 0.075vw) !important;
}

.fs-5 {
  font-size: 1.171875rem !important;
}

.fs-6 {
  font-size: 0.9375rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.34375rem !important;
  }
  .fs-2 {
    font-size: 1.875rem !important;
  }
  .fs-3 {
    font-size: 1.640625rem !important;
  }
  .fs-4 {
    font-size: 1.3125rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/* =============
   General
============= */
html {
  position: relative;
  min-height: 100%;
}

.h1, .h2, .h3, .h4, .h5, .h6,
h1, h2, h3, h4, h5, h6 {
  color: #495057;
  font-family: "Public Sans", sans-serif;
  font-weight: 600;
}

a {
  text-decoration: none !important;
}

label {
  font-weight: 500;
}

@media (min-width: 1400px) {
  .container {
    max-width: 1140px;
  }
}
.bg-soft-primary {
  background-color: rgba(114, 105, 239, 0.25) !important;
}

.bg-soft-secondary {
  background-color: rgba(122, 127, 154, 0.25) !important;
}

.bg-soft-success {
  background-color: rgba(6, 214, 160, 0.25) !important;
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.25) !important;
}

.bg-soft-warning {
  background-color: rgba(255, 209, 102, 0.25) !important;
}

.bg-soft-danger {
  background-color: rgba(239, 71, 111, 0.25) !important;
}

.bg-soft-light {
  background-color: rgba(230, 235, 245, 0.25) !important;
}

.bg-soft-dark {
  background-color: rgba(52, 58, 64, 0.25) !important;
}

.badge-soft-primary {
  color: #7269ef;
  background-color: rgba(114, 105, 239, 0.18);
}
.badge-soft-primary[href] {
  color: #7269ef;
  text-decoration: none;
  background-color: rgba(114, 105, 239, 0.4);
}

.badge-soft-secondary {
  color: #7a7f9a;
  background-color: rgba(122, 127, 154, 0.18);
}
.badge-soft-secondary[href] {
  color: #7a7f9a;
  text-decoration: none;
  background-color: rgba(122, 127, 154, 0.4);
}

.badge-soft-success {
  color: #06d6a0;
  background-color: rgba(6, 214, 160, 0.18);
}
.badge-soft-success[href] {
  color: #06d6a0;
  text-decoration: none;
  background-color: rgba(6, 214, 160, 0.4);
}

.badge-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18);
}
.badge-soft-info[href] {
  color: #50a5f1;
  text-decoration: none;
  background-color: rgba(80, 165, 241, 0.4);
}

.badge-soft-warning {
  color: #ffd166;
  background-color: rgba(255, 209, 102, 0.18);
}
.badge-soft-warning[href] {
  color: #ffd166;
  text-decoration: none;
  background-color: rgba(255, 209, 102, 0.4);
}

.badge-soft-danger {
  color: #ef476f;
  background-color: rgba(239, 71, 111, 0.18);
}
.badge-soft-danger[href] {
  color: #ef476f;
  text-decoration: none;
  background-color: rgba(239, 71, 111, 0.4);
}

.badge-soft-light {
  color: #e6ebf5;
  background-color: rgba(230, 235, 245, 0.18);
}
.badge-soft-light[href] {
  color: #e6ebf5;
  text-decoration: none;
  background-color: rgba(230, 235, 245, 0.4);
}

.badge-soft-dark {
  color: #343a40;
  background-color: rgba(52, 58, 64, 0.18);
}
.badge-soft-dark[href] {
  color: #343a40;
  text-decoration: none;
  background-color: rgba(52, 58, 64, 0.4);
}

.badge-dark {
  color: #e6ebf5;
}

button, a {
  outline: none !important;
}

.btn-rounded {
  border-radius: 30px;
  border-radius: 30px;
}

.btn-dark, .btn-secondary {
  color: #f5f7fb !important;
}

.btn-outline-light {
  color: #212529;
}

.user-profile-show.disabled {
  border: 0;
}

.breadcrumb-item > a {
  color: #495057;
}
.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
}

.card {
  margin-bottom: 24px;
}

.card-drop {
  color: #495057;
}

.card-title {
  font-size: 15px;
  margin: 0 0 7px 0;
  font-weight: 600;
}

.card-title-desc {
  color: #7a7f9a;
  margin-bottom: 24px;
}

.dropdown-menu {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  position: absolute;
  z-index: 1000;
}
.dropdown-menu.dropdown-megamenu {
  padding: 20px;
  left: 0 !important;
  right: 0 !important;
}
.dropdown-menu[data-popper-placement=top-start] {
  animation-name: DropDownSlideDown;
}

@keyframes DropDownSlide {
  100% {
    margin-top: -1px;
  }
  0% {
    margin-top: 8px;
  }
}
@keyframes DropDownSlideDown {
  100% {
    margin-bottom: 0;
  }
  0% {
    margin-bottom: 8px;
  }
}
.dropdown-menu-end[style] {
  right: 0 !important;
  left: auto !important;
}

@media (min-width: 600px) {
  .dropdown-menu-lg {
    width: 320px;
  }
  .dropdown-menu-md {
    width: 240px;
  }
}
.dropdown-divider {
  border-top-color: #f0eff5;
}

.nav-tabs > li > a, .nav-pills > li > a {
  color: #495057;
  font-weight: 500;
}

.nav-pills > a {
  color: #495057;
  font-weight: 500;
}

.nav-tabs-custom {
  border-bottom: 2px solid #f0eff5;
}
.nav-tabs-custom .nav-item {
  position: relative;
  color: #343a40;
}
.nav-tabs-custom .nav-item .nav-link {
  border: none;
}
.nav-tabs-custom .nav-item .nav-link::after {
  content: "";
  background: #7269ef;
  height: 2px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -1px;
  transition: all 250ms ease 0s;
  transform: scale(0);
}
.nav-tabs-custom .nav-item .nav-link.active {
  color: #7269ef;
}
.nav-tabs-custom .nav-item .nav-link.active:after {
  transform: scale(1);
}

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px;
}
.vertical-nav .nav .nav-link .nav-icon {
  font-size: 24px;
}

.table th {
  font-weight: 700;
}

.table-centered td, .table-centered th {
  vertical-align: middle !important;
}

.table-nowrap th, .table-nowrap td {
  white-space: nowrap;
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px;
  border: none;
  width: 32px;
  height: 32px;
  padding: 0;
  text-align: center;
  line-height: 32px;
}

.progress-sm {
  height: 5px;
}

.progress-md {
  height: 8px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 16px;
}

/*
Template Name: Chat Sms.by
Author: Themesbrand
Version: 2.0.0
Website: https://themesbrand.com/
Contact: themesbrand@gmail.com
File: Main Css File
*/
/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none;
}

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
}

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2);
}

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}

.waves-notransition {
  transition: none !important;
}

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
}

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1;
}

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em;
}

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em;
}

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom;
}

.waves-input-wrapper.waves-button {
  padding: 0;
}

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%;
}

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms;
}

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);
}

.waves-block {
  display: block;
}

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4);
}

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(114, 105, 239, 0.4);
}

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(6, 214, 160, 0.4);
}

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(80, 165, 241, 0.4);
}

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(255, 209, 102, 0.4);
}

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(239, 71, 111, 0.4);
}

.avatar-xs {
  height: 2.2rem;
  width: 2.2rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-lg {
  height: 6rem;
  width: 6rem;
}

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  background-color: #7269ef;
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.fw-medium {
  font-weight: 500;
}

.fw-semibold {
  font-weight: 600;
}

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 4px);
  display: block;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
  text-align: center;
  transition: all 0.4s;
}
.social-list-item:hover {
  color: #7a7f9a;
  background-color: #f5f7fb;
}

.w-xs {
  min-width: 80px;
}

.w-sm {
  min-width: 95px;
}

.w-md {
  min-width: 110px;
}

.w-lg {
  min-width: 140px;
}

.w-xl {
  min-width: 160px;
}

.flex-1 {
  flex: 1 1 !important;
}

.custom-accordion .card + .card {
  margin-top: 0.5rem;
}
.custom-accordion a i.accor-plus-icon {
  font-size: 16px;
}
.custom-accordion a.collapsed i.accor-plus-icon:before {
  content: "\\f0142";
}

.accordion-button:after {
  margin-left: auto;
  margin-right: 0;
}

[type=tel]::placeholder,
[type=url]::placeholder,
[type=email]::placeholder,
[type=number]::placeholder {
  text-align: left; /*rtl: right*/
}

.custom-checkbox-primary .custom-control-input:checked ~ .custom-control-label:before, .custom-radio-primary .custom-control-input:checked ~ .custom-control-label:before {
  background-color: #7269ef;
  border-color: #7269ef;
}

.custom-checkbox-secondary .custom-control-input:checked ~ .custom-control-label:before, .custom-radio-secondary .custom-control-input:checked ~ .custom-control-label:before {
  background-color: #7a7f9a;
  border-color: #7a7f9a;
}

.custom-checkbox-success .custom-control-input:checked ~ .custom-control-label:before, .custom-radio-success .custom-control-input:checked ~ .custom-control-label:before {
  background-color: #06d6a0;
  border-color: #06d6a0;
}

.custom-checkbox-info .custom-control-input:checked ~ .custom-control-label:before, .custom-radio-info .custom-control-input:checked ~ .custom-control-label:before {
  background-color: #50a5f1;
  border-color: #50a5f1;
}

.custom-checkbox-warning .custom-control-input:checked ~ .custom-control-label:before, .custom-radio-warning .custom-control-input:checked ~ .custom-control-label:before {
  background-color: #ffd166;
  border-color: #ffd166;
}

.custom-checkbox-danger .custom-control-input:checked ~ .custom-control-label:before, .custom-radio-danger .custom-control-input:checked ~ .custom-control-label:before {
  background-color: #ef476f;
  border-color: #ef476f;
}

.custom-checkbox-light .custom-control-input:checked ~ .custom-control-label:before, .custom-radio-light .custom-control-input:checked ~ .custom-control-label:before {
  background-color: #e6ebf5;
  border-color: #e6ebf5;
}

.custom-checkbox-dark .custom-control-input:checked ~ .custom-control-label:before, .custom-radio-dark .custom-control-input:checked ~ .custom-control-label:before {
  background-color: #343a40;
  border-color: #343a40;
}

.custom-checkbox-dark .custom-control-input:checked ~ .custom-control-label:before, .custom-radio-dark .custom-control-input:checked ~ .custom-control-label:before {
  color: #343a40;
}

.custom-control-label {
  cursor: pointer;
}

.custom-switch-md {
  padding-left: 3rem;
}
.custom-switch-md .custom-control-label {
  line-height: 20px;
}
.custom-switch-md .custom-control-label:before {
  width: 40px;
  height: 20px;
  border-radius: 30px;
  left: -3rem;
}
.custom-switch-md .custom-control-label:after {
  width: 16px;
  height: 16px;
  left: calc(-3rem + 2px);
}
.custom-switch-md .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(1.25rem);
}

.custom-switch-lg {
  padding-left: 3.75rem;
}
.custom-switch-lg .custom-control-label {
  line-height: 24px;
}
.custom-switch-lg .custom-control-label:before {
  width: 48px;
  height: 24px;
  border-radius: 30px;
  left: -3.75rem;
}
.custom-switch-lg .custom-control-label:after {
  width: 20px;
  height: 20px;
  left: calc(-3.75rem + 2px);
  border-radius: 50%;
}
.custom-switch-lg .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(1.5rem);
}

.custom-control-label::before {
  background-color: #fff;
}

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%;
  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto;
  /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%;
  /* Not required for horizontal scroll to trigger */
  max-height: 100%;
  /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.simplebar-content:before,
.simplebar-content:after {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 7px;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.custom-scroll {
  height: 100%;
}

.main-page {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.main-page .title {
  width: 50%;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
}

.side-menu {
  width: 100%;
  background-color: #edeef0;
  display: flex;
  z-index: 9;
}
.side-menu .go-back {
  display: none;
  position: absolute;
  left: 10px;
}
.side-menu .go-back a {
  font-size: 20px;
  color: #7a7f9a;
}
@media (max-width: 991.98px) {
  .side-menu {
    position: fixed;
    bottom: 0;
    height: 80px;
    min-width: 100%;
    min-height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .side-menu .go-back {
    display: block;
  }
  .side-menu .side-menu-nav .logo {
    display: none;
  }
}
.side-menu .navbar-brand-box {
  text-align: center;
}
@media (max-width: 991.98px) {
  .side-menu .navbar-brand-box {
    display: none;
  }
}
.side-menu .navbar-brand-box .logo {
  line-height: 70px;
}
.side-menu .navbar-brand-box .logo-dark {
  display: block;
}
.side-menu .navbar-brand-box .logo-light {
  display: none;
}
.side-menu .theme-mode-icon:before {
  content: "\\eefb";
}

.side-menu-nav .logo {
  margin: 30px 0;
}
.side-menu-nav .nav-item {
  width: 24px;
  /*64px;*/
  height: 24px;
  /*64px;*/
  border: 0 none;
  border-radius: 32px;
  background-color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px 0;
  padding: 27px;
}
.side-menu-nav .nav-item.active {
  background-color: #fff;
}
.side-menu-nav .nav-item .disabled {
  opacity: 0.7;
  pointer-events: none;
  cursor: default;
}

.chat-leftsidebar {
  background-color: #fff;
  height: 100vh;
  width: 380px;
  border-right: 1px solid #f2f2f2;
}
.chat-leftsidebar .title-block {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #4a4a4a;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 35px;
}
.chat-leftsidebar .title-block .avatar-wrapper {
  position: relative;
  margin: 16px 0;
}
.chat-leftsidebar .title-block .avatar-wrapper .avatar {
  height: 80px;
  width: 80px;
  border: 0 none;
  border-radius: 32px;
}
.chat-leftsidebar .title-block .avatar-wrapper label {
  display: none;
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: pointer;
  width: 32px;
  height: 32px;
}
.chat-leftsidebar .title-block .avatar-wrapper label img {
  width: 32px;
  height: 32px;
}
.chat-leftsidebar .title-block .avatar-wrapper label input {
  display: none;
}
.chat-leftsidebar .title-block .avatar-wrapper:hover label {
  display: block;
}
.chat-leftsidebar .title-block .title {
  font-size: 18px;
  line-height: 18px;
  font-weight: 500;
  max-width: 250px;
}
.chat-leftsidebar .title-block .subtitle {
  font-size: 12px;
  line-height: 15px;
  font-weight: 400;
  margin-top: 4px;
}
.chat-leftsidebar .search-block {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #4a4a4a;
  border-bottom: 1px solid #f2f2f2;
  padding: 16px;
  height: 69px;
}
.chat-leftsidebar .search-block .input-group-text,
.chat-leftsidebar .search-block .form-control {
  border: 1px solid #e2e2e2;
  border-right: 0;
  border-radius: 18px;
  background-color: #f4f5f5;
  height: 36px;
  color: #818c99;
}
.chat-leftsidebar .search-block .input-group-text {
  padding: 0 0 0 11px;
}
.chat-leftsidebar .search-block .form-control {
  border-left: 0 none;
  font-size: 13px;
  line-height: 15px;
  padding-left: 9px;
}
.chat-leftsidebar .search-block .clear-search-input.input-group-text {
  cursor: pointer;
  padding-right: 12px;
}
@media (max-width: 991.98px) {
  .chat-leftsidebar {
    width: auto;
  }
}
.chat-leftsidebar .user-status-box {
  background-color: #e6ebf5;
  padding: 8px;
  border-radius: 8px;
  text-align: center;
  margin-top: 16px;
  display: block;
}
.chat-leftsidebar .user-status-box .chat-user-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.chat-search-box .search-color {
  background: #e6ebf5 !important;
}
.chat-search-box .form-control {
  border: 0;
}
.chat-search-box .search-icon-btn {
  font-size: 16px;
  position: absolute;
  right: 13px;
  top: 0;
}

.chat-group-list {
  height: calc(100vh - 160px);
}
@media (max-width: 991.98px) {
  .chat-group-list {
    height: calc(100vh - 194px);
  }
}

.chat-list {
  margin: 0;
}
.chat-list li.active a {
  background-color: #e6ebf5;
}
.chat-list li a {
  position: relative;
  display: block;
  padding: 15px 20px;
  color: #7a7f9a;
  transition: all 0.4s;
  border-top: 1px solid #f5f7fb;
  border-radius: 4px;
}
.chat-list li a:hover {
  background-color: #e6ebf5;
}
.chat-list li .chat-user-message {
  font-size: 14px;
}
.chat-list li.typing .chat-user-message {
  color: #7269ef;
  font-weight: 500;
}
.chat-list li.typing .chat-user-message .dot {
  background-color: #7269ef;
}
.chat-list li .unread-message {
  position: absolute;
  display: inline-block;
  right: 24px;
  left: auto;
  top: 33px;
}
.chat-list li .unread-message .badge {
  line-height: 16px;
  font-weight: 600;
  font-size: 10px;
}

.chat-user-img {
  position: relative;
}
.chat-user-img .user-status {
  width: 10px;
  height: 10px;
  background-color: #adb5bd;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  right: 0;
  left: auto;
  bottom: 0;
}
.chat-user-img.online .user-status {
  background-color: #06d6a0;
}
.chat-user-img.away .user-status {
  background-color: #ffd166;
}

.contact-list li {
  cursor: pointer;
  padding: 10px 20px;
}

.profile-user {
  position: relative;
  display: inline-block;
}
.profile-user .profile-photo-edit {
  position: absolute;
  right: 0;
  left: auto;
  bottom: 0;
}

.user-chat .main-content .user-block .user-left-block {
  display: flex;
  flex-direction: row;
  align-items: left;
  width: auto;
  cursor: pointer;
  text-align: left;
}
.user-chat .main-content .user-block .user-left-block .user-message .msg-user-name {
  font-size: 11px;
  font-weight: bolder;
}
.user-chat .main-content .user-block .user-left-block .user-message .secondary-id {
  padding-left: 7px;
  font-weight: 400;
  font-size: 11px;
}
.user-chat .main-content .user-block .user-left-block .user-profile-show {
  height: 24px;
  width: 24px;
  box-shadow: none;
  padding: 0;
  margin-right: 16px;
}
.user-chat .main-content .send-message-block .send-message-wrapper {
  position: relative;
}
.user-chat .main-content .send-message-block .send-message-wrapper .add-file {
  position: absolute;
  left: 14px;
  bottom: 14px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
}
.user-chat .main-content .send-message-block .send-message-wrapper .add-file input {
  display: none;
}
.user-chat .main-content .send-message-block .send-message-wrapper .add-emoji {
  position: absolute;
  left: 40px;
  top: 0;
  width: 24px;
  height: 100%;
  display: flex;
  align-items: center;
}
.user-chat .main-content .send-message-block .send-message-wrapper .add-emoji button {
  padding: 0;
  background-color: #fff;
  border: 0 none;
}
.user-chat .main-content .send-message-block .send-message-wrapper .send-message-error {
  position: absolute;
  width: 20%;
  min-width: 120px;
  text-align: center;
  top: -50px;
  left: 30%;
  padding: 5px;
  border-radius: 10px;
  background-color: red;
  color: #fff;
}
.user-chat .main-content .send-message-block .send-button {
  height: 40px;
  width: 40px;
  margin-bottom: 5.5px;
}
.user-chat .main-content .send-message-block .send-button button {
  padding: 0;
  background-color: transparent;
  border: 0 none;
  box-shadow: none;
  outline: none;
}

.chat-conversation {
  color: #4a4a4a;
}
.chat-conversation ul {
  margin: 0 20px;
  padding-left: 0;
  list-style: none;
}
.chat-conversation ul li {
  display: flex;
}
.chat-conversation ul li.right {
  justify-content: flex-end;
}
.chat-conversation .chat-avatar {
  margin: 0 16px 0 0;
}
.chat-conversation .chat-avatar img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.chat-conversation .chat-day-title {
  position: relative;
  margin-bottom: 32px;
  margin-top: 32px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.chat-conversation .chat-day-title .title {
  font-size: 12px;
  line-height: 12px;
  color: #a8a8a8;
  z-index: 1;
}
.chat-conversation .chat-day-title .badge {
  font-size: 12px;
}
.chat-conversation .conversation-list {
  display: flex;
  width: 70%;
}
.chat-conversation .conversation-list .user-avatar {
  width: 32px;
  height: 32px;
  border: 0 none;
  border-radius: 12px;
  margin-right: 8px;
}
.chat-conversation .conversation-list .user-avatar img {
  width: 32px;
  height: auto;
  display: block;
}
.chat-conversation .conversation-list .ctext-wrap-content {
  padding: 6px 12px;
  background-color: #efefef;
  border-radius: 8px 8px 8px 0;
  word-break: break-word;
  white-space: pre-wrap;
  position: relative;
  border-radius: 8px;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 8px;
}
.chat-conversation .conversation-list .conversation-name {
  font-weight: 500;
  font-size: 14px;
}
.chat-conversation .conversation-list .dropdown .dropdown-toggle {
  font-size: 18px;
  padding: 4px;
  color: #7a7f9a;
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list .dropdown .dropdown-toggle {
    display: none;
  }
}
.chat-conversation .conversation-list .chat-time {
  font-size: 12px;
  line-height: 12px;
  font-width: 500;
  margin-top: 4px;
  text-align: right;
  color: #a8a8a8;
  margin-bottom: 0;
}
.chat-conversation .conversation-list .chat-party {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  line-height: 12px;
  margin-bottom: 0;
}
.chat-conversation .conversation-list .message-img {
  border-radius: 0.2rem;
  position: relative;
}
.chat-conversation .conversation-list .message-img .message-img-list {
  position: relative;
}
.chat-conversation .conversation-list .message-img img {
  max-width: 150px;
}
.chat-conversation .conversation-list .message-img .message-img-link {
  position: absolute;
  right: 10px;
  left: auto;
  bottom: 10px;
}
.chat-conversation .conversation-list .message-img .message-img-link li > a {
  font-size: 18px;
  color: #fff;
  display: inline-block;
  line-height: 30px;
  width: 30px;
  height: 30px;
  text-align: center;
}
.chat-conversation .right .conversation-list {
  justify-content: flex-end;
}
.chat-conversation .right .conversation-list .ctext-wrap-content {
  order: 2;
  background-color: #d8ebff;
  border-radius: 8px;
}
.chat-conversation .right .conversation-list .ctext-wrap-content .chat-time img {
  margin-left: 5px;
  width: 16px;
  height: 16px;
}
.chat-conversation .right .conversation-list .dropdown {
  order: 1;
}
.chat-conversation .right .dot {
  background-color: #343a40;
}

.chat-input-links .list-inline-item:not(:last-child) {
  margin: 0;
}

.animate-typing .dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  margin-right: -1px;
  background: #fff;
  animation: wave 1.3s linear infinite;
  opacity: 0.6;
}
.animate-typing .dot:nth-child(2) {
  animation-delay: -1.1s;
}
.animate-typing .dot:nth-child(3) {
  animation-delay: -0.9s;
}

@keyframes wave {
  0%, 60%, 100% {
    transform: initial;
  }
  30% {
    transform: translateY(-5px);
  }
}
.user-profile-sidebar {
  height: 100vh;
  background-color: #fff;
  display: none;
  min-width: 380px;
  max-width: 380px;
  height: 100vh;
  overflow-y: auto;
}
@media (min-width: 992px) {
  .user-profile-sidebar {
    border-left: 1px solid #F2F2F2;
  }
}
@media (max-width: 1199.98px) {
  .user-profile-sidebar {
    position: fixed;
    right: 0;
    top: 0;
    z-index: 99;
  }
}
@media (max-width: 575.98px) {
  .user-profile-sidebar {
    min-width: 100%;
  }
}
.user-profile-sidebar .profile-block {
  margin: 16px;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.user-profile-sidebar .profile-block .close-button {
  padding: 0;
  position: absolute;
  right: 0;
}
.user-profile-sidebar .profile-block .avatar-wrapper {
  margin: 0 0 12px 0;
}
.user-profile-sidebar .profile-block .avatar-wrapper .avatar {
  height: 80px;
  width: 80px;
  border: 0 none;
  border-radius: 40px;
}
.user-profile-sidebar .profile-block .title-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}
.user-profile-sidebar .profile-block .title-wrapper .title {
  font-size: 24px;
  line-height: 36px;
  font-weight: 600;
  max-width: 250px;
  color: #515361;
}
.user-profile-sidebar .profile-block .title-wrapper .user-profile-edit {
  padding: 0;
  position: absolute;
  right: 0;
}
.user-profile-sidebar .profile-block .phone {
  font-size: 16px;
  line-height: 28px;
  font-weight: 500;
  color: #71737E;
  margin-bottom: 24px;
}
.user-profile-sidebar .profile-block .form-group {
  width: 100%;
  margin-bottom: 24px;
}
.user-profile-sidebar .profile-block .form-group label {
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: #515361;
  margin: 0;
}
.user-profile-sidebar .profile-block .form-group .description {
  font-size: 16px;
  line-height: 28px;
  font-weight: 500;
  color: #515361;
}
.user-profile-sidebar .profile-block.profile-block-editing .avatar-wrapper {
  position: relative;
  margin: 0 0 24px 0;
}
.user-profile-sidebar .profile-block.profile-block-editing .avatar-wrapper label {
  position: absolute;
  bottom: 0;
  right: 0px;
  cursor: pointer;
  width: 32px;
  height: 32px;
}
.user-profile-sidebar .profile-block.profile-block-editing .avatar-wrapper label img {
  width: 32px;
  height: 32px;
}
.user-profile-sidebar .profile-block.profile-block-editing .avatar-wrapper label input {
  display: none;
}
.user-profile-sidebar .profile-block.profile-block-editing .form-group {
  width: 100%;
  margin-bottom: 24px;
}
.user-profile-sidebar .profile-block.profile-block-editing .form-group label {
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  color: #515361;
  margin: 0 16px 12px 16px;
}
.user-profile-sidebar .profile-block.profile-block-editing .form-group input {
  display: flex;
  padding: 4px 16px;
  width: 100%;
  height: 36px;
  border: 1px solid #DEDFE1;
  border-radius: 4px;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: #515361;
}
.user-profile-sidebar .profile-block.profile-block-editing .form-group input:disabled {
  color: #818C99;
}
.user-profile-sidebar .profile-block.profile-block-editing .form-group input:invalid {
  border-color: red;
}
.user-profile-sidebar .profile-block.profile-block-editing .form-group button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 24px;
  width: 100%;
  height: 36px;
  box-shadow: 2px 4px 4px rgba(37, 40, 57, 0.15);
  border-radius: 24px;
  border: 0 none;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: #252839 !important;
  margin-bottom: 20px;
}
.user-profile-sidebar .profile-block.profile-block-editing .form-group .save-button {
  background: #FFB300;
  margin-top: 24px;
}
.user-profile-sidebar .profile-block.profile-block-editing .form-group .cancel-button {
  background: #FFFFFF;
  border: 1px solid #FFB300;
}

.user-profile-desc {
  height: calc(100vh - 300px);
}
@media (max-width: 991.98px) {
  .user-profile-desc {
    height: calc(100vh - 324px);
  }
}

.nav-item {
  cursor: pointer;
}

.dropdown {
  cursor: pointer;
}

.slick-slide {
  margin-left: 8px;
  margin-right: 8px;
}

.slick-arrow {
  display: none;
}

.emoji-mart {
  border: none !important;
}

.emoji-mart-preview {
  display: none !important;
}

.emoji-mart-bar {
  border: none !important;
}

.alice-carousel__stage-item {
  margin-left: 8px;
  margin-right: 8px !important;
  width: 71px !important;
}

.input-file label {
  margin-bottom: 0;
}
.input-file input[type=file] {
  display: none;
}

.emoji-mart-light {
  background-color: #fff !important;
}

.emoji-mart-search input {
  background-color: #fff !important;
  border-color: #f5f7fb !important;
}

.emoji-mart-category-label span {
  background-color: #fff !important;
  color: #495057;
}

.emoji-mart-category .emoji-mart-emoji:hover {
  background-color: #f0eff5 !important;
}
.emoji-mart-category .emoji-mart-emoji::before {
  background-color: #f0eff5 !important;
  border-radius: 100% !important;
}

.w-70 {
  width: 73% !important;
}

.ctext-wrap-content {
  animation: flyIn 0.6s ease-in-out;
}

.blank-div {
  width: 36px;
  height: 36px;
}

.profile-user-dropdown .dropdown-item.active {
  color: #ffffff;
  text-decoration: none;
  background-color: #7269ef;
}

.dot_remove .alice-carousel__dots,
.dot_remove .alice-carousel__prev-btn,
.dot_remove .alice-carousel__next-btn {
  display: none !important;
}

.close {
  background: transparent;
  border: 0;
  font-size: 30px;
  margin: 10px;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.5;
  width: 1em;
  height: 1em;
  z-index: 2;
}

.main-page {
  width: 100%;
  display: flex;
}

.form-control {
  caret-color: #000000;
}

.button {
  border-radius: 8px;
  padding: 7px 23px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  box-shadow: 0px 3px 6px rgba(40, 40, 90, 0.0901960784);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.button.default {
  color: #4a596a;
  border: 1px solid #c4ccd6;
  background-color: #ffffff;
}
.button.default:hover {
  outline: 2px solid rgba(40, 40, 90, 0.0901960784) !important;
}
.button.primary {
  color: #ffffff;
  background-color: #5f8fdf;
  border: 1px solid #5f8fdf;
}
.button.primary:hover {
  outline: 2px solid rgba(95, 143, 223, 0.3) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/themes_.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/custom/plugins/icons/_materialdesignicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_remixicon.scss","webpack://./src/assets/scss/bootstrap.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/_variables.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/.pnpm/bootstrap@5.3.3_@popperjs+core@2.11.8/node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/custom/components/_reboot.scss","webpack://./src/assets/scss/custom/components/_backgrounds.scss","webpack://./src/assets/scss/custom/components/_badge.scss","webpack://./src/assets/scss/custom/components/_buttons.scss","webpack://./src/assets/scss/custom/components/_breadcrumb.scss","webpack://./src/assets/scss/custom/components/_card.scss","webpack://./src/assets/scss/custom/components/_dropdown.scss","webpack://./src/assets/scss/custom/components/_nav.scss","webpack://./src/assets/scss/custom/components/_table.scss","webpack://./src/assets/scss/custom/components/_pagination.scss","webpack://./src/assets/scss/custom/components/_progress.scss","webpack://./src/assets/scss/app_.scss","webpack://./src/assets/scss/custom/components/_waves.scss","webpack://./src/assets/scss/custom/components/_avatar.scss","webpack://./src/assets/scss/custom/components/_helper.scss","webpack://./src/assets/scss/custom/components/_accordion.scss","webpack://./src/assets/scss/custom/components/_forms.scss","webpack://./src/assets/scss/custom/plugins/_custom-scrollbar.scss","webpack://./src/assets/scss/custom/structure/_sidemenu_.scss","webpack://./src/assets/scss/custom/pages/_chat-leftsidebar_.scss","webpack://./src/assets/scss/custom/pages/_user-chat_.scss","webpack://./src/assets/scss/custom/pages/_user-profile-details_.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;CAAA;ACAA,4BAAA;AACA;EACE,oCAAA;EACA,4CAAA;EACA,qPAAA;EAQA,mBAAA;EACA,kBAAA;AFIF;AEDA;;EAEE,qBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,iBAAA;AFGF;;AEAA;EACE,gBAAA;EACA,kBAAA;AFGF;;AEAA;;EAEE,eAAA;AFGF;;AEAA;;EAEE,eAAA;AFGF;;AEAA;;EAEE,eAAA;AFGF;;AEAA;;EAEE,eAAA;AFGF;;AEAA;EACE,0BAAA;AFGF;;AEAA;EACE,0BAAA;AFGF;;AEAA;EACE,YAAA;AFGF;;AEAA;EACE,+BAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,wBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,wBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,yBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,yBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,yBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,yBAAA;AFGF;;AEAA;EACE;;;;;;;;;;;;;;;SAAA;AFkBF;;AEAA;EAGE,yBAAA;AFGF;;AEAA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFGF;;AEAA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFGF;;AEAA;EAEE,sCAAA;AFGF;AEWA;EACE;IAEE,uBAAA;EFEF;EEAA;IAEE,yBAAA;EFEF;AACF;;AG/+nBA;;;;;;;;;CAAA;AAUA;EACE,wBAAA;EACA,4CAAA,EAAA,OAAA;EACA,6SAAA,EAQmB,aAAA;EACnB,kBAAA;AH0+nBF;AGv+nBA;;EAEE,mCAAA;EACA,kBAAA;EACA,mCAAA;EACA,kCAAA;AHy+nBF;;AGt+nBA;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;AHy+nBF;;AGv+nBA;EACE,gBAAA;EACA,qBAAA;EACA,wBAAA;AH0+nBF;;AGx+nBA;EACE,gBAAA;AH2+nBF;;AGz+nBA;EACE,iBAAA;AH4+nBF;;AG1+nBA;EACE,kBAAA;AH6+nBF;;AG3+nBA;EACE,cAAA;AH8+nBF;;AG5+nBA;EACE,cAAA;AH++nBF;;AG7+nBA;EACE,cAAA;AHg/nBF;;AG9+nBA;EACE,cAAA;AHi/nBF;;AG/+nBA;EACE,cAAA;AHk/nBF;;AGh/nBA;EACE,cAAA;AHm/nBF;;AGj/nBA;EACE,cAAA;AHo/nBF;;AGl/nBA;EACE,cAAA;AHq/nBF;;AGn/nBA;EACE,cAAA;AHs/nBF;;AGp/nBA;EACE,eAAA;AHu/nBF;;AGr/nBA;EACE,kBAAA;EACA,aAAA;AHw/nBF;;AGr/nBA;EACE,gBAAA;AHw/nBF;;AGt/nBA;EACE,gBAAA;AHy/nBF;;AGv/nBA;EACE,gBAAA;AH0/nBF;;AGx/nBA;EACE,gBAAA;AH2/nBF;;AGz/nBA;EACE,gBAAA;AH4/nBF;;AG1/nBA;EACE,gBAAA;AH6/nBF;;AG3/nBA;EACE,gBAAA;AH8/nBF;;AG5/nBA;EACE,gBAAA;AH+/nBF;;AG7/nBA;EACE,gBAAA;AHggoBF;;AG9/nBA;EACE,gBAAA;AHigoBF;;AG//nBA;EACE,gBAAA;AHkgoBF;;AGhgoBA;EACE,gBAAA;AHmgoBF;;AGjgoBA;EACE,gBAAA;AHogoBF;;AGlgoBA;EACE,gBAAA;AHqgoBF;;AGngoBA;EACE,gBAAA;AHsgoBF;;AGpgoBA;EACE,gBAAA;AHugoBF;;AGrgoBA;EACE,gBAAA;AHwgoBF;;AGtgoBA;EACE,gBAAA;AHygoBF;;AGvgoBA;EACE,gBAAA;AH0goBF;;AGxgoBA;EACE,gBAAA;AH2goBF;;AGzgoBA;EACE,gBAAA;AH4goBF;;AG1goBA;EACE,gBAAA;AH6goBF;;AG3goBA;EACE,gBAAA;AH8goBF;;AG5goBA;EACE,gBAAA;AH+goBF;;AG7goBA;EACE,gBAAA;AHghoBF;;AG9goBA;EACE,gBAAA;AHihoBF;;AG/goBA;EACE,gBAAA;AHkhoBF;;AGhhoBA;EACE,gBAAA;AHmhoBF;;AGjhoBA;EACE,gBAAA;AHohoBF;;AGlhoBA;EACE,gBAAA;AHqhoBF;;AGnhoBA;EACE,gBAAA;AHshoBF;;AGphoBA;EACE,gBAAA;AHuhoBF;;AGrhoBA;EACE,gBAAA;AHwhoBF;;AGthoBA;EACE,gBAAA;AHyhoBF;;AGvhoBA;EACE,gBAAA;AH0hoBF;;AGxhoBA;EACE,gBAAA;AH2hoBF;;AGzhoBA;EACE,gBAAA;AH4hoBF;;AG1hoBA;EACE,gBAAA;AH6hoBF;;AG3hoBA;EACE,gBAAA;AH8hoBF;;AG5hoBA;EACE,gBAAA;AH+hoBF;;AG7hoBA;EACE,gBAAA;AHgioBF;;AG9hoBA;EACE,gBAAA;AHiioBF;;AG/hoBA;EACE,gBAAA;AHkioBF;;AGhioBA;EACE,gBAAA;AHmioBF;;AGjioBA;EACE,gBAAA;AHoioBF;;AGlioBA;EACE,gBAAA;AHqioBF;;AGnioBA;EACE,gBAAA;AHsioBF;;AGpioBA;EACE,gBAAA;AHuioBF;;AGrioBA;EACE,gBAAA;AHwioBF;;AGtioBA;EACE,gBAAA;AHyioBF;;AGvioBA;EACE,gBAAA;AH0ioBF;;AGxioBA;EACE,gBAAA;AH2ioBF;;AGzioBA;EACE,gBAAA;AH4ioBF;;AG1ioBA;EACE,gBAAA;AH6ioBF;;AG3ioBA;EACE,gBAAA;AH8ioBF;;AG5ioBA;EACE,gBAAA;AH+ioBF;;AG7ioBA;EACE,gBAAA;AHgjoBF;;AG9ioBA;EACE,gBAAA;AHijoBF;;AG/ioBA;EACE,gBAAA;AHkjoBF;;AGhjoBA;EACE,gBAAA;AHmjoBF;;AGjjoBA;EACE,gBAAA;AHojoBF;;AGljoBA;EACE,gBAAA;AHqjoBF;;AGnjoBA;EACE,gBAAA;AHsjoBF;;AGpjoBA;EACE,gBAAA;AHujoBF;;AGrjoBA;EACE,gBAAA;AHwjoBF;;AGtjoBA;EACE,gBAAA;AHyjoBF;;AGvjoBA;EACE,gBAAA;AH0joBF;;AGxjoBA;EACE,gBAAA;AH2joBF;;AGzjoBA;EACE,gBAAA;AH4joBF;;AG1joBA;EACE,gBAAA;AH6joBF;;AG3joBA;EACE,gBAAA;AH8joBF;;AG5joBA;EACE,gBAAA;AH+joBF;;AG7joBA;EACE,gBAAA;AHgkoBF;;AG9joBA;EACE,gBAAA;AHikoBF;;AG/joBA;EACE,gBAAA;AHkkoBF;;AGhkoBA;EACE,gBAAA;AHmkoBF;;AGjkoBA;EACE,gBAAA;AHokoBF;;AGlkoBA;EACE,gBAAA;AHqkoBF;;AGnkoBA;EACE,gBAAA;AHskoBF;;AGpkoBA;EACE,gBAAA;AHukoBF;;AGrkoBA;EACE,gBAAA;AHwkoBF;;AGtkoBA;EACE,gBAAA;AHykoBF;;AGvkoBA;EACE,gBAAA;AH0koBF;;AGxkoBA;EACE,gBAAA;AH2koBF;;AGzkoBA;EACE,gBAAA;AH4koBF;;AG1koBA;EACE,gBAAA;AH6koBF;;AG3koBA;EACE,gBAAA;AH8koBF;;AG5koBA;EACE,gBAAA;AH+koBF;;AG7koBA;EACE,gBAAA;AHgloBF;;AG9koBA;EACE,gBAAA;AHiloBF;;AG/koBA;EACE,gBAAA;AHkloBF;;AGhloBA;EACE,gBAAA;AHmloBF;;AGjloBA;EACE,gBAAA;AHoloBF;;AGlloBA;EACE,gBAAA;AHqloBF;;AGnloBA;EACE,gBAAA;AHsloBF;;AGploBA;EACE,gBAAA;AHuloBF;;AGrloBA;EACE,gBAAA;AHwloBF;;AGtloBA;EACE,gBAAA;AHyloBF;;AGvloBA;EACE,gBAAA;AH0loBF;;AGxloBA;EACE,gBAAA;AH2loBF;;AGzloBA;EACE,gBAAA;AH4loBF;;AG1loBA;EACE,gBAAA;AH6loBF;;AG3loBA;EACE,gBAAA;AH8loBF;;AG5loBA;EACE,gBAAA;AH+loBF;;AG7loBA;EACE,gBAAA;AHgmoBF;;AG9loBA;EACE,gBAAA;AHimoBF;;AG/loBA;EACE,gBAAA;AHkmoBF;;AGhmoBA;EACE,gBAAA;AHmmoBF;;AGjmoBA;EACE,gBAAA;AHomoBF;;AGlmoBA;EACE,gBAAA;AHqmoBF;;AGnmoBA;EACE,gBAAA;AHsmoBF;;AGpmoBA;EACE,gBAAA;AHumoBF;;AGrmoBA;EACE,gBAAA;AHwmoBF;;AGtmoBA;EACE,gBAAA;AHymoBF;;AGvmoBA;EACE,gBAAA;AH0moBF;;AGxmoBA;EACE,gBAAA;AH2moBF;;AGzmoBA;EACE,gBAAA;AH4moBF;;AG1moBA;EACE,gBAAA;AH6moBF;;AG3moBA;EACE,gBAAA;AH8moBF;;AG5moBA;EACE,gBAAA;AH+moBF;;AG7moBA;EACE,gBAAA;AHgnoBF;;AG9moBA;EACE,gBAAA;AHinoBF;;AG/moBA;EACE,gBAAA;AHknoBF;;AGhnoBA;EACE,gBAAA;AHmnoBF;;AGjnoBA;EACE,gBAAA;AHonoBF;;AGlnoBA;EACE,gBAAA;AHqnoBF;;AGnnoBA;EACE,gBAAA;AHsnoBF;;AGpnoBA;EACE,gBAAA;AHunoBF;;AGrnoBA;EACE,gBAAA;AHwnoBF;;AGtnoBA;EACE,gBAAA;AHynoBF;;AGvnoBA;EACE,gBAAA;AH0noBF;;AGxnoBA;EACE,gBAAA;AH2noBF;;AGznoBA;EACE,gBAAA;AH4noBF;;AG1noBA;EACE,gBAAA;AH6noBF;;AG3noBA;EACE,gBAAA;AH8noBF;;AG5noBA;EACE,gBAAA;AH+noBF;;AG7noBA;EACE,gBAAA;AHgooBF;;AG9noBA;EACE,gBAAA;AHiooBF;;AG/noBA;EACE,gBAAA;AHkooBF;;AGhooBA;EACE,gBAAA;AHmooBF;;AGjooBA;EACE,gBAAA;AHoooBF;;AGlooBA;EACE,gBAAA;AHqooBF;;AGnooBA;EACE,gBAAA;AHsooBF;;AGpooBA;EACE,gBAAA;AHuooBF;;AGrooBA;EACE,gBAAA;AHwooBF;;AGtooBA;EACE,gBAAA;AHyooBF;;AGvooBA;EACE,gBAAA;AH0ooBF;;AGxooBA;EACE,gBAAA;AH2ooBF;;AGzooBA;EACE,gBAAA;AH4ooBF;;AG1ooBA;EACE,gBAAA;AH6ooBF;;AG3ooBA;EACE,gBAAA;AH8ooBF;;AG5ooBA;EACE,gBAAA;AH+ooBF;;AG7ooBA;EACE,gBAAA;AHgpoBF;;AG9ooBA;EACE,gBAAA;AHipoBF;;AG/ooBA;EACE,gBAAA;AHkpoBF;;AGhpoBA;EACE,gBAAA;AHmpoBF;;AGjpoBA;EACE,gBAAA;AHopoBF;;AGlpoBA;EACE,gBAAA;AHqpoBF;;AGnpoBA;EACE,gBAAA;AHspoBF;;AGppoBA;EACE,gBAAA;AHupoBF;;AGrpoBA;EACE,gBAAA;AHwpoBF;;AGtpoBA;EACE,gBAAA;AHypoBF;;AGvpoBA;EACE,gBAAA;AH0poBF;;AGxpoBA;EACE,gBAAA;AH2poBF;;AGzpoBA;EACE,gBAAA;AH4poBF;;AG1poBA;EACE,gBAAA;AH6poBF;;AG3poBA;EACE,gBAAA;AH8poBF;;AG5poBA;EACE,gBAAA;AH+poBF;;AG7poBA;EACE,gBAAA;AHgqoBF;;AG9poBA;EACE,gBAAA;AHiqoBF;;AG/poBA;EACE,gBAAA;AHkqoBF;;AGhqoBA;EACE,gBAAA;AHmqoBF;;AGjqoBA;EACE,gBAAA;AHoqoBF;;AGlqoBA;EACE,gBAAA;AHqqoBF;;AGnqoBA;EACE,gBAAA;AHsqoBF;;AGpqoBA;EACE,gBAAA;AHuqoBF;;AGrqoBA;EACE,gBAAA;AHwqoBF;;AGtqoBA;EACE,gBAAA;AHyqoBF;;AGvqoBA;EACE,gBAAA;AH0qoBF;;AGxqoBA;EACE,gBAAA;AH2qoBF;;AGzqoBA;EACE,gBAAA;AH4qoBF;;AG1qoBA;EACE,gBAAA;AH6qoBF;;AG3qoBA;EACE,gBAAA;AH8qoBF;;AG5qoBA;EACE,gBAAA;AH+qoBF;;AG7qoBA;EACE,gBAAA;AHgroBF;;AG9qoBA;EACE,gBAAA;AHiroBF;;AG/qoBA;EACE,gBAAA;AHkroBF;;AGhroBA;EACE,gBAAA;AHmroBF;;AGjroBA;EACE,gBAAA;AHoroBF;;AGlroBA;EACE,gBAAA;AHqroBF;;AGnroBA;EACE,gBAAA;AHsroBF;;AGproBA;EACE,gBAAA;AHuroBF;;AGrroBA;EACE,gBAAA;AHwroBF;;AGtroBA;EACE,gBAAA;AHyroBF;;AGvroBA;EACE,gBAAA;AH0roBF;;AGxroBA;EACE,gBAAA;AH2roBF;;AGzroBA;EACE,gBAAA;AH4roBF;;AG1roBA;EACE,gBAAA;AH6roBF;;AG3roBA;EACE,gBAAA;AH8roBF;;AG5roBA;EACE,gBAAA;AH+roBF;;AG7roBA;EACE,gBAAA;AHgsoBF;;AG9roBA;EACE,gBAAA;AHisoBF;;AG/roBA;EACE,gBAAA;AHksoBF;;AGhsoBA;EACE,gBAAA;AHmsoBF;;AGjsoBA;EACE,gBAAA;AHosoBF;;AGlsoBA;EACE,gBAAA;AHqsoBF;;AGnsoBA;EACE,gBAAA;AHssoBF;;AGpsoBA;EACE,gBAAA;AHusoBF;;AGrsoBA;EACE,gBAAA;AHwsoBF;;AGtsoBA;EACE,gBAAA;AHysoBF;;AGvsoBA;EACE,gBAAA;AH0soBF;;AGxsoBA;EACE,gBAAA;AH2soBF;;AGzsoBA;EACE,gBAAA;AH4soBF;;AG1soBA;EACE,gBAAA;AH6soBF;;AG3soBA;EACE,gBAAA;AH8soBF;;AG5soBA;EACE,gBAAA;AH+soBF;;AG7soBA;EACE,gBAAA;AHgtoBF;;AG9soBA;EACE,gBAAA;AHitoBF;;AG/soBA;EACE,gBAAA;AHktoBF;;AGhtoBA;EACE,gBAAA;AHmtoBF;;AGjtoBA;EACE,gBAAA;AHotoBF;;AGltoBA;EACE,gBAAA;AHqtoBF;;AGntoBA;EACE,gBAAA;AHstoBF;;AGptoBA;EACE,gBAAA;AHutoBF;;AGrtoBA;EACE,gBAAA;AHwtoBF;;AGttoBA;EACE,gBAAA;AHytoBF;;AGvtoBA;EACE,gBAAA;AH0toBF;;AGxtoBA;EACE,gBAAA;AH2toBF;;AGztoBA;EACE,gBAAA;AH4toBF;;AG1toBA;EACE,gBAAA;AH6toBF;;AG3toBA;EACE,gBAAA;AH8toBF;;AG5toBA;EACE,gBAAA;AH+toBF;;AG7toBA;EACE,gBAAA;AHguoBF;;AG9toBA;EACE,gBAAA;AHiuoBF;;AG/toBA;EACE,gBAAA;AHkuoBF;;AGhuoBA;EACE,gBAAA;AHmuoBF;;AGjuoBA;EACE,gBAAA;AHouoBF;;AGluoBA;EACE,gBAAA;AHquoBF;;AGnuoBA;EACE,gBAAA;AHsuoBF;;AGpuoBA;EACE,gBAAA;AHuuoBF;;AGruoBA;EACE,gBAAA;AHwuoBF;;AGtuoBA;EACE,gBAAA;AHyuoBF;;AGvuoBA;EACE,gBAAA;AH0uoBF;;AGxuoBA;EACE,gBAAA;AH2uoBF;;AGzuoBA;EACE,gBAAA;AH4uoBF;;AG1uoBA;EACE,gBAAA;AH6uoBF;;AG3uoBA;EACE,gBAAA;AH8uoBF;;AG5uoBA;EACE,gBAAA;AH+uoBF;;AG7uoBA;EACE,gBAAA;AHgvoBF;;AG9uoBA;EACE,gBAAA;AHivoBF;;AG/uoBA;EACE,gBAAA;AHkvoBF;;AGhvoBA;EACE,gBAAA;AHmvoBF;;AGjvoBA;EACE,gBAAA;AHovoBF;;AGlvoBA;EACE,gBAAA;AHqvoBF;;AGnvoBA;EACE,gBAAA;AHsvoBF;;AGpvoBA;EACE,gBAAA;AHuvoBF;;AGrvoBA;EACE,gBAAA;AHwvoBF;;AGtvoBA;EACE,gBAAA;AHyvoBF;;AGvvoBA;EACE,gBAAA;AH0voBF;;AGxvoBA;EACE,gBAAA;AH2voBF;;AGzvoBA;EACE,gBAAA;AH4voBF;;AG1voBA;EACE,gBAAA;AH6voBF;;AG3voBA;EACE,gBAAA;AH8voBF;;AG5voBA;EACE,gBAAA;AH+voBF;;AG7voBA;EACE,gBAAA;AHgwoBF;;AG9voBA;EACE,gBAAA;AHiwoBF;;AG/voBA;EACE,gBAAA;AHkwoBF;;AGhwoBA;EACE,gBAAA;AHmwoBF;;AGjwoBA;EACE,gBAAA;AHowoBF;;AGlwoBA;EACE,gBAAA;AHqwoBF;;AGnwoBA;EACE,gBAAA;AHswoBF;;AGpwoBA;EACE,gBAAA;AHuwoBF;;AGrwoBA;EACE,gBAAA;AHwwoBF;;AGtwoBA;EACE,gBAAA;AHywoBF;;AGvwoBA;EACE,gBAAA;AH0woBF;;AGxwoBA;EACE,gBAAA;AH2woBF;;AGzwoBA;EACE,gBAAA;AH4woBF;;AG1woBA;EACE,gBAAA;AH6woBF;;AG3woBA;EACE,gBAAA;AH8woBF;;AG5woBA;EACE,gBAAA;AH+woBF;;AG7woBA;EACE,gBAAA;AHgxoBF;;AG9woBA;EACE,gBAAA;AHixoBF;;AG/woBA;EACE,gBAAA;AHkxoBF;;AGhxoBA;EACE,gBAAA;AHmxoBF;;AGjxoBA;EACE,gBAAA;AHoxoBF;;AGlxoBA;EACE,gBAAA;AHqxoBF;;AGnxoBA;EACE,gBAAA;AHsxoBF;;AGpxoBA;EACE,gBAAA;AHuxoBF;;AGrxoBA;EACE,gBAAA;AHwxoBF;;AGtxoBA;EACE,gBAAA;AHyxoBF;;AGvxoBA;EACE,gBAAA;AH0xoBF;;AGxxoBA;EACE,gBAAA;AH2xoBF;;AGzxoBA;EACE,gBAAA;AH4xoBF;;AG1xoBA;EACE,gBAAA;AH6xoBF;;AG3xoBA;EACE,gBAAA;AH8xoBF;;AG5xoBA;EACE,gBAAA;AH+xoBF;;AG7xoBA;EACE,gBAAA;AHgyoBF;;AG9xoBA;EACE,gBAAA;AHiyoBF;;AG/xoBA;EACE,gBAAA;AHkyoBF;;AGhyoBA;EACE,gBAAA;AHmyoBF;;AGjyoBA;EACE,gBAAA;AHoyoBF;;AGlyoBA;EACE,gBAAA;AHqyoBF;;AGnyoBA;EACE,gBAAA;AHsyoBF;;AGpyoBA;EACE,gBAAA;AHuyoBF;;AGryoBA;EACE,gBAAA;AHwyoBF;;AGtyoBA;EACE,gBAAA;AHyyoBF;;AGvyoBA;EACE,gBAAA;AH0yoBF;;AGxyoBA;EACE,gBAAA;AH2yoBF;;AGzyoBA;EACE,gBAAA;AH4yoBF;;AG1yoBA;EACE,gBAAA;AH6yoBF;;AG3yoBA;EACE,gBAAA;AH8yoBF;;AG5yoBA;EACE,gBAAA;AH+yoBF;;AG7yoBA;EACE,gBAAA;AHgzoBF;;AG9yoBA;EACE,gBAAA;AHizoBF;;AG/yoBA;EACE,gBAAA;AHkzoBF;;AGhzoBA;EACE,gBAAA;AHmzoBF;;AGjzoBA;EACE,gBAAA;AHozoBF;;AGlzoBA;EACE,gBAAA;AHqzoBF;;AGnzoBA;EACE,gBAAA;AHszoBF;;AGpzoBA;EACE,gBAAA;AHuzoBF;;AGrzoBA;EACE,gBAAA;AHwzoBF;;AGtzoBA;EACE,gBAAA;AHyzoBF;;AGvzoBA;EACE,gBAAA;AH0zoBF;;AGxzoBA;EACE,gBAAA;AH2zoBF;;AGzzoBA;EACE,gBAAA;AH4zoBF;;AG1zoBA;EACE,gBAAA;AH6zoBF;;AG3zoBA;EACE,gBAAA;AH8zoBF;;AG5zoBA;EACE,gBAAA;AH+zoBF;;AG7zoBA;EACE,gBAAA;AHg0oBF;;AG9zoBA;EACE,gBAAA;AHi0oBF;;AG/zoBA;EACE,gBAAA;AHk0oBF;;AGh0oBA;EACE,gBAAA;AHm0oBF;;AGj0oBA;EACE,gBAAA;AHo0oBF;;AGl0oBA;EACE,gBAAA;AHq0oBF;;AGn0oBA;EACE,gBAAA;AHs0oBF;;AGp0oBA;EACE,gBAAA;AHu0oBF;;AGr0oBA;EACE,gBAAA;AHw0oBF;;AGt0oBA;EACE,gBAAA;AHy0oBF;;AGv0oBA;EACE,gBAAA;AH00oBF;;AGx0oBA;EACE,gBAAA;AH20oBF;;AGz0oBA;EACE,gBAAA;AH40oBF;;AG10oBA;EACE,gBAAA;AH60oBF;;AG30oBA;EACE,gBAAA;AH80oBF;;AG50oBA;EACE,gBAAA;AH+0oBF;;AG70oBA;EACE,gBAAA;AHg1oBF;;AG90oBA;EACE,gBAAA;AHi1oBF;;AG/0oBA;EACE,gBAAA;AHk1oBF;;AGh1oBA;EACE,gBAAA;AHm1oBF;;AGj1oBA;EACE,gBAAA;AHo1oBF;;AGl1oBA;EACE,gBAAA;AHq1oBF;;AGn1oBA;EACE,gBAAA;AHs1oBF;;AGp1oBA;EACE,gBAAA;AHu1oBF;;AGr1oBA;EACE,gBAAA;AHw1oBF;;AGt1oBA;EACE,gBAAA;AHy1oBF;;AGv1oBA;EACE,gBAAA;AH01oBF;;AGx1oBA;EACE,gBAAA;AH21oBF;;AGz1oBA;EACE,gBAAA;AH41oBF;;AG11oBA;EACE,gBAAA;AH61oBF;;AG31oBA;EACE,gBAAA;AH81oBF;;AG51oBA;EACE,gBAAA;AH+1oBF;;AG71oBA;EACE,gBAAA;AHg2oBF;;AG91oBA;EACE,gBAAA;AHi2oBF;;AG/1oBA;EACE,gBAAA;AHk2oBF;;AGh2oBA;EACE,gBAAA;AHm2oBF;;AGj2oBA;EACE,gBAAA;AHo2oBF;;AGl2oBA;EACE,gBAAA;AHq2oBF;;AGn2oBA;EACE,gBAAA;AHs2oBF;;AGp2oBA;EACE,gBAAA;AHu2oBF;;AGr2oBA;EACE,gBAAA;AHw2oBF;;AGt2oBA;EACE,gBAAA;AHy2oBF;;AGv2oBA;EACE,gBAAA;AH02oBF;;AGx2oBA;EACE,gBAAA;AH22oBF;;AGz2oBA;EACE,gBAAA;AH42oBF;;AG12oBA;EACE,gBAAA;AH62oBF;;AG32oBA;EACE,gBAAA;AH82oBF;;AG52oBA;EACE,gBAAA;AH+2oBF;;AG72oBA;EACE,gBAAA;AHg3oBF;;AG92oBA;EACE,gBAAA;AHi3oBF;;AG/2oBA;EACE,gBAAA;AHk3oBF;;AGh3oBA;EACE,gBAAA;AHm3oBF;;AGj3oBA;EACE,gBAAA;AHo3oBF;;AGl3oBA;EACE,gBAAA;AHq3oBF;;AGn3oBA;EACE,gBAAA;AHs3oBF;;AGp3oBA;EACE,gBAAA;AHu3oBF;;AGr3oBA;EACE,gBAAA;AHw3oBF;;AGt3oBA;EACE,gBAAA;AHy3oBF;;AGv3oBA;EACE,gBAAA;AH03oBF;;AGx3oBA;EACE,gBAAA;AH23oBF;;AGz3oBA;EACE,gBAAA;AH43oBF;;AG13oBA;EACE,gBAAA;AH63oBF;;AG33oBA;EACE,gBAAA;AH83oBF;;AG53oBA;EACE,gBAAA;AH+3oBF;;AG73oBA;EACE,gBAAA;AHg4oBF;;AG93oBA;EACE,gBAAA;AHi4oBF;;AG/3oBA;EACE,gBAAA;AHk4oBF;;AGh4oBA;EACE,gBAAA;AHm4oBF;;AGj4oBA;EACE,gBAAA;AHo4oBF;;AGl4oBA;EACE,gBAAA;AHq4oBF;;AGn4oBA;EACE,gBAAA;AHs4oBF;;AGp4oBA;EACE,gBAAA;AHu4oBF;;AGr4oBA;EACE,gBAAA;AHw4oBF;;AGt4oBA;EACE,gBAAA;AHy4oBF;;AGv4oBA;EACE,gBAAA;AH04oBF;;AGx4oBA;EACE,gBAAA;AH24oBF;;AGz4oBA;EACE,gBAAA;AH44oBF;;AG14oBA;EACE,gBAAA;AH64oBF;;AG34oBA;EACE,gBAAA;AH84oBF;;AG54oBA;EACE,gBAAA;AH+4oBF;;AG74oBA;EACE,gBAAA;AHg5oBF;;AG94oBA;EACE,gBAAA;AHi5oBF;;AG/4oBA;EACE,gBAAA;AHk5oBF;;AGh5oBA;EACE,gBAAA;AHm5oBF;;AGj5oBA;EACE,gBAAA;AHo5oBF;;AGl5oBA;EACE,gBAAA;AHq5oBF;;AGn5oBA;EACE,gBAAA;AHs5oBF;;AGp5oBA;EACE,gBAAA;AHu5oBF;;AGr5oBA;EACE,gBAAA;AHw5oBF;;AGt5oBA;EACE,gBAAA;AHy5oBF;;AGv5oBA;EACE,gBAAA;AH05oBF;;AGx5oBA;EACE,gBAAA;AH25oBF;;AGz5oBA;EACE,gBAAA;AH45oBF;;AG15oBA;EACE,gBAAA;AH65oBF;;AG35oBA;EACE,gBAAA;AH85oBF;;AG55oBA;EACE,gBAAA;AH+5oBF;;AG75oBA;EACE,gBAAA;AHg6oBF;;AG95oBA;EACE,gBAAA;AHi6oBF;;AG/5oBA;EACE,gBAAA;AHk6oBF;;AGh6oBA;EACE,gBAAA;AHm6oBF;;AGj6oBA;EACE,gBAAA;AHo6oBF;;AGl6oBA;EACE,gBAAA;AHq6oBF;;AGn6oBA;EACE,gBAAA;AHs6oBF;;AGp6oBA;EACE,gBAAA;AHu6oBF;;AGr6oBA;EACE,gBAAA;AHw6oBF;;AGt6oBA;EACE,gBAAA;AHy6oBF;;AGv6oBA;EACE,gBAAA;AH06oBF;;AGx6oBA;EACE,gBAAA;AH26oBF;;AGz6oBA;EACE,gBAAA;AH46oBF;;AG16oBA;EACE,gBAAA;AH66oBF;;AG36oBA;EACE,gBAAA;AH86oBF;;AG56oBA;EACE,gBAAA;AH+6oBF;;AG76oBA;EACE,gBAAA;AHg7oBF;;AG96oBA;EACE,gBAAA;AHi7oBF;;AG/6oBA;EACE,gBAAA;AHk7oBF;;AGh7oBA;EACE,gBAAA;AHm7oBF;;AGj7oBA;EACE,gBAAA;AHo7oBF;;AGl7oBA;EACE,gBAAA;AHq7oBF;;AGn7oBA;EACE,gBAAA;AHs7oBF;;AGp7oBA;EACE,gBAAA;AHu7oBF;;AGr7oBA;EACE,gBAAA;AHw7oBF;;AGt7oBA;EACE,gBAAA;AHy7oBF;;AGv7oBA;EACE,gBAAA;AH07oBF;;AGx7oBA;EACE,gBAAA;AH27oBF;;AGz7oBA;EACE,gBAAA;AH47oBF;;AG17oBA;EACE,gBAAA;AH67oBF;;AG37oBA;EACE,gBAAA;AH87oBF;;AG57oBA;EACE,gBAAA;AH+7oBF;;AG77oBA;EACE,gBAAA;AHg8oBF;;AG97oBA;EACE,gBAAA;AHi8oBF;;AG/7oBA;EACE,gBAAA;AHk8oBF;;AGh8oBA;EACE,gBAAA;AHm8oBF;;AGj8oBA;EACE,gBAAA;AHo8oBF;;AGl8oBA;EACE,gBAAA;AHq8oBF;;AGn8oBA;EACE,gBAAA;AHs8oBF;;AGp8oBA;EACE,gBAAA;AHu8oBF;;AGr8oBA;EACE,gBAAA;AHw8oBF;;AGt8oBA;EACE,gBAAA;AHy8oBF;;AGv8oBA;EACE,gBAAA;AH08oBF;;AGx8oBA;EACE,gBAAA;AH28oBF;;AGz8oBA;EACE,gBAAA;AH48oBF;;AG18oBA;EACE,gBAAA;AH68oBF;;AG38oBA;EACE,gBAAA;AH88oBF;;AG58oBA;EACE,gBAAA;AH+8oBF;;AG78oBA;EACE,gBAAA;AHg9oBF;;AG98oBA;EACE,gBAAA;AHi9oBF;;AG/8oBA;EACE,gBAAA;AHk9oBF;;AGh9oBA;EACE,gBAAA;AHm9oBF;;AGj9oBA;EACE,gBAAA;AHo9oBF;;AGl9oBA;EACE,gBAAA;AHq9oBF;;AGn9oBA;EACE,gBAAA;AHs9oBF;;AGp9oBA;EACE,gBAAA;AHu9oBF;;AGr9oBA;EACE,gBAAA;AHw9oBF;;AGt9oBA;EACE,gBAAA;AHy9oBF;;AGv9oBA;EACE,gBAAA;AH09oBF;;AGx9oBA;EACE,gBAAA;AH29oBF;;AGz9oBA;EACE,gBAAA;AH49oBF;;AG19oBA;EACE,gBAAA;AH69oBF;;AG39oBA;EACE,gBAAA;AH89oBF;;AG59oBA;EACE,gBAAA;AH+9oBF;;AG79oBA;EACE,gBAAA;AHg+oBF;;AG99oBA;EACE,gBAAA;AHi+oBF;;AG/9oBA;EACE,gBAAA;AHk+oBF;;AGh+oBA;EACE,gBAAA;AHm+oBF;;AGj+oBA;EACE,gBAAA;AHo+oBF;;AGl+oBA;EACE,gBAAA;AHq+oBF;;AGn+oBA;EACE,gBAAA;AHs+oBF;;AGp+oBA;EACE,gBAAA;AHu+oBF;;AGr+oBA;EACE,gBAAA;AHw+oBF;;AGt+oBA;EACE,gBAAA;AHy+oBF;;AGv+oBA;EACE,gBAAA;AH0+oBF;;AGx+oBA;EACE,gBAAA;AH2+oBF;;AGz+oBA;EACE,gBAAA;AH4+oBF;;AG1+oBA;EACE,gBAAA;AH6+oBF;;AG3+oBA;EACE,gBAAA;AH8+oBF;;AG5+oBA;EACE,gBAAA;AH++oBF;;AG7+oBA;EACE,gBAAA;AHg/oBF;;AG9+oBA;EACE,gBAAA;AHi/oBF;;AG/+oBA;EACE,gBAAA;AHk/oBF;;AGh/oBA;EACE,gBAAA;AHm/oBF;;AGj/oBA;EACE,gBAAA;AHo/oBF;;AGl/oBA;EACE,gBAAA;AHq/oBF;;AGn/oBA;EACE,gBAAA;AHs/oBF;;AGp/oBA;EACE,gBAAA;AHu/oBF;;AGr/oBA;EACE,gBAAA;AHw/oBF;;AGt/oBA;EACE,gBAAA;AHy/oBF;;AGv/oBA;EACE,gBAAA;AH0/oBF;;AGx/oBA;EACE,gBAAA;AH2/oBF;;AGz/oBA;EACE,gBAAA;AH4/oBF;;AG1/oBA;EACE,gBAAA;AH6/oBF;;AG3/oBA;EACE,gBAAA;AH8/oBF;;AG5/oBA;EACE,gBAAA;AH+/oBF;;AG7/oBA;EACE,gBAAA;AHggpBF;;AG9/oBA;EACE,gBAAA;AHigpBF;;AG//oBA;EACE,gBAAA;AHkgpBF;;AGhgpBA;EACE,gBAAA;AHmgpBF;;AGjgpBA;EACE,gBAAA;AHogpBF;;AGlgpBA;EACE,gBAAA;AHqgpBF;;AGngpBA;EACE,gBAAA;AHsgpBF;;AGpgpBA;EACE,gBAAA;AHugpBF;;AGrgpBA;EACE,gBAAA;AHwgpBF;;AGtgpBA;EACE,gBAAA;AHygpBF;;AGvgpBA;EACE,gBAAA;AH0gpBF;;AGxgpBA;EACE,gBAAA;AH2gpBF;;AGzgpBA;EACE,gBAAA;AH4gpBF;;AG1gpBA;EACE,gBAAA;AH6gpBF;;AG3gpBA;EACE,gBAAA;AH8gpBF;;AG5gpBA;EACE,gBAAA;AH+gpBF;;AG7gpBA;EACE,gBAAA;AHghpBF;;AG9gpBA;EACE,gBAAA;AHihpBF;;AG/gpBA;EACE,gBAAA;AHkhpBF;;AGhhpBA;EACE,gBAAA;AHmhpBF;;AGjhpBA;EACE,gBAAA;AHohpBF;;AGlhpBA;EACE,gBAAA;AHqhpBF;;AGnhpBA;EACE,gBAAA;AHshpBF;;AGphpBA;EACE,gBAAA;AHuhpBF;;AGrhpBA;EACE,gBAAA;AHwhpBF;;AGthpBA;EACE,gBAAA;AHyhpBF;;AGvhpBA;EACE,gBAAA;AH0hpBF;;AGxhpBA;EACE,gBAAA;AH2hpBF;;AGzhpBA;EACE,gBAAA;AH4hpBF;;AG1hpBA;EACE,gBAAA;AH6hpBF;;AG3hpBA;EACE,gBAAA;AH8hpBF;;AG5hpBA;EACE,gBAAA;AH+hpBF;;AG7hpBA;EACE,gBAAA;AHgipBF;;AG9hpBA;EACE,gBAAA;AHiipBF;;AG/hpBA;EACE,gBAAA;AHkipBF;;AGhipBA;EACE,gBAAA;AHmipBF;;AGjipBA;EACE,gBAAA;AHoipBF;;AGlipBA;EACE,gBAAA;AHqipBF;;AGnipBA;EACE,gBAAA;AHsipBF;;AGpipBA;EACE,gBAAA;AHuipBF;;AGripBA;EACE,gBAAA;AHwipBF;;AGtipBA;EACE,gBAAA;AHyipBF;;AGvipBA;EACE,gBAAA;AH0ipBF;;AGxipBA;EACE,gBAAA;AH2ipBF;;AGzipBA;EACE,gBAAA;AH4ipBF;;AG1ipBA;EACE,gBAAA;AH6ipBF;;AG3ipBA;EACE,gBAAA;AH8ipBF;;AG5ipBA;EACE,gBAAA;AH+ipBF;;AG7ipBA;EACE,gBAAA;AHgjpBF;;AG9ipBA;EACE,gBAAA;AHijpBF;;AG/ipBA;EACE,gBAAA;AHkjpBF;;AGhjpBA;EACE,gBAAA;AHmjpBF;;AGjjpBA;EACE,gBAAA;AHojpBF;;AGljpBA;EACE,gBAAA;AHqjpBF;;AGnjpBA;EACE,gBAAA;AHsjpBF;;AGpjpBA;EACE,gBAAA;AHujpBF;;AGrjpBA;EACE,gBAAA;AHwjpBF;;AGtjpBA;EACE,gBAAA;AHyjpBF;;AGvjpBA;EACE,gBAAA;AH0jpBF;;AGxjpBA;EACE,gBAAA;AH2jpBF;;AGzjpBA;EACE,gBAAA;AH4jpBF;;AG1jpBA;EACE,gBAAA;AH6jpBF;;AG3jpBA;EACE,gBAAA;AH8jpBF;;AG5jpBA;EACE,gBAAA;AH+jpBF;;AG7jpBA;EACE,gBAAA;AHgkpBF;;AG9jpBA;EACE,gBAAA;AHikpBF;;AG/jpBA;EACE,gBAAA;AHkkpBF;;AGhkpBA;EACE,gBAAA;AHmkpBF;;AGjkpBA;EACE,gBAAA;AHokpBF;;AGlkpBA;EACE,gBAAA;AHqkpBF;;AGnkpBA;EACE,gBAAA;AHskpBF;;AGpkpBA;EACE,gBAAA;AHukpBF;;AGrkpBA;EACE,gBAAA;AHwkpBF;;AGtkpBA;EACE,gBAAA;AHykpBF;;AGvkpBA;EACE,gBAAA;AH0kpBF;;AGxkpBA;EACE,gBAAA;AH2kpBF;;AGzkpBA;EACE,gBAAA;AH4kpBF;;AG1kpBA;EACE,gBAAA;AH6kpBF;;AG3kpBA;EACE,gBAAA;AH8kpBF;;AG5kpBA;EACE,gBAAA;AH+kpBF;;AG7kpBA;EACE,gBAAA;AHglpBF;;AG9kpBA;EACE,gBAAA;AHilpBF;;AG/kpBA;EACE,gBAAA;AHklpBF;;AGhlpBA;EACE,gBAAA;AHmlpBF;;AGjlpBA;EACE,gBAAA;AHolpBF;;AGllpBA;EACE,gBAAA;AHqlpBF;;AGnlpBA;EACE,gBAAA;AHslpBF;;AGplpBA;EACE,gBAAA;AHulpBF;;AGrlpBA;EACE,gBAAA;AHwlpBF;;AGtlpBA;EACE,gBAAA;AHylpBF;;AGvlpBA;EACE,gBAAA;AH0lpBF;;AGxlpBA;EACE,gBAAA;AH2lpBF;;AGzlpBA;EACE,gBAAA;AH4lpBF;;AG1lpBA;EACE,gBAAA;AH6lpBF;;AG3lpBA;EACE,gBAAA;AH8lpBF;;AG5lpBA;EACE,gBAAA;AH+lpBF;;AG7lpBA;EACE,gBAAA;AHgmpBF;;AG9lpBA;EACE,gBAAA;AHimpBF;;AG/lpBA;EACE,gBAAA;AHkmpBF;;AGhmpBA;EACE,gBAAA;AHmmpBF;;AGjmpBA;EACE,gBAAA;AHompBF;;AGlmpBA;EACE,gBAAA;AHqmpBF;;AGnmpBA;EACE,gBAAA;AHsmpBF;;AGpmpBA;EACE,gBAAA;AHumpBF;;AGrmpBA;EACE,gBAAA;AHwmpBF;;AGtmpBA;EACE,gBAAA;AHympBF;;AGvmpBA;EACE,gBAAA;AH0mpBF;;AGxmpBA;EACE,gBAAA;AH2mpBF;;AGzmpBA;EACE,gBAAA;AH4mpBF;;AG1mpBA;EACE,gBAAA;AH6mpBF;;AG3mpBA;EACE,gBAAA;AH8mpBF;;AG5mpBA;EACE,gBAAA;AH+mpBF;;AG7mpBA;EACE,gBAAA;AHgnpBF;;AG9mpBA;EACE,gBAAA;AHinpBF;;AG/mpBA;EACE,gBAAA;AHknpBF;;AGhnpBA;EACE,gBAAA;AHmnpBF;;AGjnpBA;EACE,gBAAA;AHonpBF;;AGlnpBA;EACE,gBAAA;AHqnpBF;;AGnnpBA;EACE,gBAAA;AHsnpBF;;AGpnpBA;EACE,gBAAA;AHunpBF;;AGrnpBA;EACE,gBAAA;AHwnpBF;;AGtnpBA;EACE,gBAAA;AHynpBF;;AGvnpBA;EACE,gBAAA;AH0npBF;;AGxnpBA;EACE,gBAAA;AH2npBF;;AGznpBA;EACE,gBAAA;AH4npBF;;AG1npBA;EACE,gBAAA;AH6npBF;;AG3npBA;EACE,gBAAA;AH8npBF;;AG5npBA;EACE,gBAAA;AH+npBF;;AG7npBA;EACE,gBAAA;AHgopBF;;AG9npBA;EACE,gBAAA;AHiopBF;;AG/npBA;EACE,gBAAA;AHkopBF;;AGhopBA;EACE,gBAAA;AHmopBF;;AGjopBA;EACE,gBAAA;AHoopBF;;AGlopBA;EACE,gBAAA;AHqopBF;;AGnopBA;EACE,gBAAA;AHsopBF;;AGpopBA;EACE,gBAAA;AHuopBF;;AGropBA;EACE,gBAAA;AHwopBF;;AGtopBA;EACE,gBAAA;AHyopBF;;AGvopBA;EACE,gBAAA;AH0opBF;;AGxopBA;EACE,gBAAA;AH2opBF;;AGzopBA;EACE,gBAAA;AH4opBF;;AG1opBA;EACE,gBAAA;AH6opBF;;AG3opBA;EACE,gBAAA;AH8opBF;;AG5opBA;EACE,gBAAA;AH+opBF;;AG7opBA;EACE,gBAAA;AHgppBF;;AG9opBA;EACE,gBAAA;AHippBF;;AG/opBA;EACE,gBAAA;AHkppBF;;AGhppBA;EACE,gBAAA;AHmppBF;;AGjppBA;EACE,gBAAA;AHoppBF;;AGlppBA;EACE,gBAAA;AHqppBF;;AGnppBA;EACE,gBAAA;AHsppBF;;AGpppBA;EACE,gBAAA;AHuppBF;;AGrppBA;EACE,gBAAA;AHwppBF;;AGtppBA;EACE,gBAAA;AHyppBF;;AGvppBA;EACE,gBAAA;AH0ppBF;;AGxppBA;EACE,gBAAA;AH2ppBF;;AGzppBA;EACE,gBAAA;AH4ppBF;;AG1ppBA;EACE,gBAAA;AH6ppBF;;AG3ppBA;EACE,gBAAA;AH8ppBF;;AG5ppBA;EACE,gBAAA;AH+ppBF;;AG7ppBA;EACE,gBAAA;AHgqpBF;;AG9ppBA;EACE,gBAAA;AHiqpBF;;AG/ppBA;EACE,gBAAA;AHkqpBF;;AGhqpBA;EACE,gBAAA;AHmqpBF;;AGjqpBA;EACE,gBAAA;AHoqpBF;;AGlqpBA;EACE,gBAAA;AHqqpBF;;AGnqpBA;EACE,gBAAA;AHsqpBF;;AGpqpBA;EACE,gBAAA;AHuqpBF;;AGrqpBA;EACE,gBAAA;AHwqpBF;;AGtqpBA;EACE,gBAAA;AHyqpBF;;AGvqpBA;EACE,gBAAA;AH0qpBF;;AGxqpBA;EACE,gBAAA;AH2qpBF;;AGzqpBA;EACE,gBAAA;AH4qpBF;;AG1qpBA;EACE,gBAAA;AH6qpBF;;AG3qpBA;EACE,gBAAA;AH8qpBF;;AG5qpBA;EACE,gBAAA;AH+qpBF;;AG7qpBA;EACE,gBAAA;AHgrpBF;;AG9qpBA;EACE,gBAAA;AHirpBF;;AG/qpBA;EACE,gBAAA;AHkrpBF;;AGhrpBA;EACE,gBAAA;AHmrpBF;;AGjrpBA;EACE,gBAAA;AHorpBF;;AGlrpBA;EACE,gBAAA;AHqrpBF;;AGnrpBA;EACE,gBAAA;AHsrpBF;;AGprpBA;EACE,gBAAA;AHurpBF;;AGrrpBA;EACE,gBAAA;AHwrpBF;;AGtrpBA;EACE,gBAAA;AHyrpBF;;AGvrpBA;EACE,gBAAA;AH0rpBF;;AGxrpBA;EACE,gBAAA;AH2rpBF;;AGzrpBA;EACE,gBAAA;AH4rpBF;;AG1rpBA;EACE,gBAAA;AH6rpBF;;AG3rpBA;EACE,gBAAA;AH8rpBF;;AG5rpBA;EACE,gBAAA;AH+rpBF;;AG7rpBA;EACE,gBAAA;AHgspBF;;AG9rpBA;EACE,gBAAA;AHispBF;;AG/rpBA;EACE,gBAAA;AHkspBF;;AGhspBA;EACE,gBAAA;AHmspBF;;AGjspBA;EACE,gBAAA;AHospBF;;AGlspBA;EACE,gBAAA;AHqspBF;;AGnspBA;EACE,gBAAA;AHsspBF;;AGpspBA;EACE,gBAAA;AHuspBF;;AGrspBA;EACE,gBAAA;AHwspBF;;AGtspBA;EACE,gBAAA;AHyspBF;;AGvspBA;EACE,gBAAA;AH0spBF;;AGxspBA;EACE,gBAAA;AH2spBF;;AGzspBA;EACE,gBAAA;AH4spBF;;AG1spBA;EACE,gBAAA;AH6spBF;;AG3spBA;EACE,gBAAA;AH8spBF;;AG5spBA;EACE,gBAAA;AH+spBF;;AG7spBA;EACE,gBAAA;AHgtpBF;;AG9spBA;EACE,gBAAA;AHitpBF;;AG/spBA;EACE,gBAAA;AHktpBF;;AGhtpBA;EACE,gBAAA;AHmtpBF;;AGjtpBA;EACE,gBAAA;AHotpBF;;AGltpBA;EACE,gBAAA;AHqtpBF;;AGntpBA;EACE,gBAAA;AHstpBF;;AGptpBA;EACE,gBAAA;AHutpBF;;AGrtpBA;EACE,gBAAA;AHwtpBF;;AGttpBA;EACE,gBAAA;AHytpBF;;AGvtpBA;EACE,gBAAA;AH0tpBF;;AGxtpBA;EACE,gBAAA;AH2tpBF;;AGztpBA;EACE,gBAAA;AH4tpBF;;AG1tpBA;EACE,gBAAA;AH6tpBF;;AG3tpBA;EACE,gBAAA;AH8tpBF;;AG5tpBA;EACE,gBAAA;AH+tpBF;;AG7tpBA;EACE,gBAAA;AHgupBF;;AG9tpBA;EACE,gBAAA;AHiupBF;;AG/tpBA;EACE,gBAAA;AHkupBF;;AGhupBA;EACE,gBAAA;AHmupBF;;AGjupBA;EACE,gBAAA;AHoupBF;;AGlupBA;EACE,gBAAA;AHqupBF;;AGnupBA;EACE,gBAAA;AHsupBF;;AGpupBA;EACE,gBAAA;AHuupBF;;AGrupBA;EACE,gBAAA;AHwupBF;;AGtupBA;EACE,gBAAA;AHyupBF;;AGvupBA;EACE,gBAAA;AH0upBF;;AGxupBA;EACE,gBAAA;AH2upBF;;AGzupBA;EACE,gBAAA;AH4upBF;;AG1upBA;EACE,gBAAA;AH6upBF;;AG3upBA;EACE,gBAAA;AH8upBF;;AG5upBA;EACE,gBAAA;AH+upBF;;AG7upBA;EACE,gBAAA;AHgvpBF;;AG9upBA;EACE,gBAAA;AHivpBF;;AG/upBA;EACE,gBAAA;AHkvpBF;;AGhvpBA;EACE,gBAAA;AHmvpBF;;AGjvpBA;EACE,gBAAA;AHovpBF;;AGlvpBA;EACE,gBAAA;AHqvpBF;;AGnvpBA;EACE,gBAAA;AHsvpBF;;AGpvpBA;EACE,gBAAA;AHuvpBF;;AGrvpBA;EACE,gBAAA;AHwvpBF;;AGtvpBA;EACE,gBAAA;AHyvpBF;;AGvvpBA;EACE,gBAAA;AH0vpBF;;AGxvpBA;EACE,gBAAA;AH2vpBF;;AGzvpBA;EACE,gBAAA;AH4vpBF;;AG1vpBA;EACE,gBAAA;AH6vpBF;;AG3vpBA;EACE,gBAAA;AH8vpBF;;AG5vpBA;EACE,gBAAA;AH+vpBF;;AG7vpBA;EACE,gBAAA;AHgwpBF;;AG9vpBA;EACE,gBAAA;AHiwpBF;;AG/vpBA;EACE,gBAAA;AHkwpBF;;AGhwpBA;EACE,gBAAA;AHmwpBF;;AGjwpBA;EACE,gBAAA;AHowpBF;;AGlwpBA;EACE,gBAAA;AHqwpBF;;AGnwpBA;EACE,gBAAA;AHswpBF;;AGpwpBA;EACE,gBAAA;AHuwpBF;;AGrwpBA;EACE,gBAAA;AHwwpBF;;AGtwpBA;EACE,gBAAA;AHywpBF;;AGvwpBA;EACE,gBAAA;AH0wpBF;;AGxwpBA;EACE,gBAAA;AH2wpBF;;AGzwpBA;EACE,gBAAA;AH4wpBF;;AG1wpBA;EACE,gBAAA;AH6wpBF;;AG3wpBA;EACE,gBAAA;AH8wpBF;;AG5wpBA;EACE,gBAAA;AH+wpBF;;AG7wpBA;EACE,gBAAA;AHgxpBF;;AG9wpBA;EACE,gBAAA;AHixpBF;;AG/wpBA;EACE,gBAAA;AHkxpBF;;AGhxpBA;EACE,gBAAA;AHmxpBF;;AGjxpBA;EACE,gBAAA;AHoxpBF;;AGlxpBA;EACE,gBAAA;AHqxpBF;;AGnxpBA;EACE,gBAAA;AHsxpBF;;AGpxpBA;EACE,gBAAA;AHuxpBF;;AGrxpBA;EACE,gBAAA;AHwxpBF;;AGtxpBA;EACE,gBAAA;AHyxpBF;;AGvxpBA;EACE,gBAAA;AH0xpBF;;AGxxpBA;EACE,gBAAA;AH2xpBF;;AGzxpBA;EACE,gBAAA;AH4xpBF;;AG1xpBA;EACE,gBAAA;AH6xpBF;;AG3xpBA;EACE,gBAAA;AH8xpBF;;AG5xpBA;EACE,gBAAA;AH+xpBF;;AG7xpBA;EACE,gBAAA;AHgypBF;;AG9xpBA;EACE,gBAAA;AHiypBF;;AG/xpBA;EACE,gBAAA;AHkypBF;;AGhypBA;EACE,gBAAA;AHmypBF;;AGjypBA;EACE,gBAAA;AHoypBF;;AGlypBA;EACE,gBAAA;AHqypBF;;AGnypBA;EACE,gBAAA;AHsypBF;;AGpypBA;EACE,gBAAA;AHuypBF;;AGrypBA;EACE,gBAAA;AHwypBF;;AGtypBA;EACE,gBAAA;AHyypBF;;AGvypBA;EACE,gBAAA;AH0ypBF;;AGxypBA;EACE,gBAAA;AH2ypBF;;AGzypBA;EACE,gBAAA;AH4ypBF;;AG1ypBA;EACE,gBAAA;AH6ypBF;;AG3ypBA;EACE,gBAAA;AH8ypBF;;AG5ypBA;EACE,gBAAA;AH+ypBF;;AG7ypBA;EACE,gBAAA;AHgzpBF;;AG9ypBA;EACE,gBAAA;AHizpBF;;AG/ypBA;EACE,gBAAA;AHkzpBF;;AGhzpBA;EACE,gBAAA;AHmzpBF;;AGjzpBA;EACE,gBAAA;AHozpBF;;AGlzpBA;EACE,gBAAA;AHqzpBF;;AGnzpBA;EACE,gBAAA;AHszpBF;;AGpzpBA;EACE,gBAAA;AHuzpBF;;AGrzpBA;EACE,gBAAA;AHwzpBF;;AGtzpBA;EACE,gBAAA;AHyzpBF;;AGvzpBA;EACE,gBAAA;AH0zpBF;;AGxzpBA;EACE,gBAAA;AH2zpBF;;AGzzpBA;EACE,gBAAA;AH4zpBF;;AG1zpBA;EACE,gBAAA;AH6zpBF;;AG3zpBA;EACE,gBAAA;AH8zpBF;;AG5zpBA;EACE,gBAAA;AH+zpBF;;AG7zpBA;EACE,gBAAA;AHg0pBF;;AG9zpBA;EACE,gBAAA;AHi0pBF;;AG/zpBA;EACE,gBAAA;AHk0pBF;;AGh0pBA;EACE,gBAAA;AHm0pBF;;AGj0pBA;EACE,gBAAA;AHo0pBF;;AGl0pBA;EACE,gBAAA;AHq0pBF;;AGn0pBA;EACE,gBAAA;AHs0pBF;;AGp0pBA;EACE,gBAAA;AHu0pBF;;AGr0pBA;EACE,gBAAA;AHw0pBF;;AGt0pBA;EACE,gBAAA;AHy0pBF;;AGv0pBA;EACE,gBAAA;AH00pBF;;AGx0pBA;EACE,gBAAA;AH20pBF;;AGz0pBA;EACE,gBAAA;AH40pBF;;AG10pBA;EACE,gBAAA;AH60pBF;;AG30pBA;EACE,gBAAA;AH80pBF;;AG50pBA;EACE,gBAAA;AH+0pBF;;AG70pBA;EACE,gBAAA;AHg1pBF;;AG90pBA;EACE,gBAAA;AHi1pBF;;AG/0pBA;EACE,gBAAA;AHk1pBF;;AGh1pBA;EACE,gBAAA;AHm1pBF;;AGj1pBA;EACE,gBAAA;AHo1pBF;;AGl1pBA;EACE,gBAAA;AHq1pBF;;AGn1pBA;EACE,gBAAA;AHs1pBF;;AGp1pBA;EACE,gBAAA;AHu1pBF;;AGr1pBA;EACE,gBAAA;AHw1pBF;;AGt1pBA;EACE,gBAAA;AHy1pBF;;AGv1pBA;EACE,gBAAA;AH01pBF;;AGx1pBA;EACE,gBAAA;AH21pBF;;AGz1pBA;EACE,gBAAA;AH41pBF;;AG11pBA;EACE,gBAAA;AH61pBF;;AG31pBA;EACE,gBAAA;AH81pBF;;AG51pBA;EACE,gBAAA;AH+1pBF;;AG71pBA;EACE,gBAAA;AHg2pBF;;AG91pBA;EACE,gBAAA;AHi2pBF;;AG/1pBA;EACE,gBAAA;AHk2pBF;;AGh2pBA;EACE,gBAAA;AHm2pBF;;AGj2pBA;EACE,gBAAA;AHo2pBF;;AGl2pBA;EACE,gBAAA;AHq2pBF;;AGn2pBA;EACE,gBAAA;AHs2pBF;;AGp2pBA;EACE,gBAAA;AHu2pBF;;AGr2pBA;EACE,gBAAA;AHw2pBF;;AGt2pBA;EACE,gBAAA;AHy2pBF;;AGv2pBA;EACE,gBAAA;AH02pBF;;AGx2pBA;EACE,gBAAA;AH22pBF;;AGz2pBA;EACE,gBAAA;AH42pBF;;AG12pBA;EACE,gBAAA;AH62pBF;;AG32pBA;EACE,gBAAA;AH82pBF;;AG52pBA;EACE,gBAAA;AH+2pBF;;AG72pBA;EACE,gBAAA;AHg3pBF;;AG92pBA;EACE,gBAAA;AHi3pBF;;AG/2pBA;EACE,gBAAA;AHk3pBF;;AGh3pBA;EACE,gBAAA;AHm3pBF;;AGj3pBA;EACE,gBAAA;AHo3pBF;;AGl3pBA;EACE,gBAAA;AHq3pBF;;AGn3pBA;EACE,gBAAA;AHs3pBF;;AGp3pBA;EACE,gBAAA;AHu3pBF;;AGr3pBA;EACE,gBAAA;AHw3pBF;;AGt3pBA;EACE,gBAAA;AHy3pBF;;AGv3pBA;EACE,gBAAA;AH03pBF;;AGx3pBA;EACE,gBAAA;AH23pBF;;AGz3pBA;EACE,gBAAA;AH43pBF;;AG13pBA;EACE,gBAAA;AH63pBF;;AG33pBA;EACE,gBAAA;AH83pBF;;AG53pBA;EACE,gBAAA;AH+3pBF;;AG73pBA;EACE,gBAAA;AHg4pBF;;AG93pBA;EACE,gBAAA;AHi4pBF;;AG/3pBA;EACE,gBAAA;AHk4pBF;;AGh4pBA;EACE,gBAAA;AHm4pBF;;AGj4pBA;EACE,gBAAA;AHo4pBF;;AGl4pBA;EACE,gBAAA;AHq4pBF;;AGn4pBA;EACE,gBAAA;AHs4pBF;;AGp4pBA;EACE,gBAAA;AHu4pBF;;AGr4pBA;EACE,gBAAA;AHw4pBF;;AGt4pBA;EACE,gBAAA;AHy4pBF;;AGv4pBA;EACE,gBAAA;AH04pBF;;AGx4pBA;EACE,gBAAA;AH24pBF;;AGz4pBA;EACE,gBAAA;AH44pBF;;AG14pBA;EACE,gBAAA;AH64pBF;;AG34pBA;EACE,gBAAA;AH84pBF;;AG54pBA;EACE,gBAAA;AH+4pBF;;AG74pBA;EACE,gBAAA;AHg5pBF;;AG94pBA;EACE,gBAAA;AHi5pBF;;AG/4pBA;EACE,gBAAA;AHk5pBF;;AGh5pBA;EACE,gBAAA;AHm5pBF;;AGj5pBA;EACE,gBAAA;AHo5pBF;;AGl5pBA;EACE,gBAAA;AHq5pBF;;AGn5pBA;EACE,gBAAA;AHs5pBF;;AGp5pBA;EACE,gBAAA;AHu5pBF;;AGr5pBA;EACE,gBAAA;AHw5pBF;;AGt5pBA;EACE,gBAAA;AHy5pBF;;AGv5pBA;EACE,gBAAA;AH05pBF;;AGx5pBA;EACE,gBAAA;AH25pBF;;AGz5pBA;EACE,gBAAA;AH45pBF;;AG15pBA;EACE,gBAAA;AH65pBF;;AG35pBA;EACE,gBAAA;AH85pBF;;AG55pBA;EACE,gBAAA;AH+5pBF;;AG75pBA;EACE,gBAAA;AHg6pBF;;AG95pBA;EACE,gBAAA;AHi6pBF;;AG/5pBA;EACE,gBAAA;AHk6pBF;;AGh6pBA;EACE,gBAAA;AHm6pBF;;AGj6pBA;EACE,gBAAA;AHo6pBF;;AGl6pBA;EACE,gBAAA;AHq6pBF;;AGn6pBA;EACE,gBAAA;AHs6pBF;;AGp6pBA;EACE,gBAAA;AHu6pBF;;AGr6pBA;EACE,gBAAA;AHw6pBF;;AGt6pBA;EACE,gBAAA;AHy6pBF;;AGv6pBA;EACE,gBAAA;AH06pBF;;AGx6pBA;EACE,gBAAA;AH26pBF;;AGz6pBA;EACE,gBAAA;AH46pBF;;AG16pBA;EACE,gBAAA;AH66pBF;;AG36pBA;EACE,gBAAA;AH86pBF;;AG56pBA;EACE,gBAAA;AH+6pBF;;AG76pBA;EACE,gBAAA;AHg7pBF;;AG96pBA;EACE,gBAAA;AHi7pBF;;AG/6pBA;EACE,gBAAA;AHk7pBF;;AGh7pBA;EACE,gBAAA;AHm7pBF;;AGj7pBA;EACE,gBAAA;AHo7pBF;;AGl7pBA;EACE,gBAAA;AHq7pBF;;AGn7pBA;EACE,gBAAA;AHs7pBF;;AGp7pBA;EACE,gBAAA;AHu7pBF;;AGr7pBA;EACE,gBAAA;AHw7pBF;;AGt7pBA;EACE,gBAAA;AHy7pBF;;AGv7pBA;EACE,gBAAA;AH07pBF;;AGx7pBA;EACE,gBAAA;AH27pBF;;AGz7pBA;EACE,gBAAA;AH47pBF;;AG17pBA;EACE,gBAAA;AH67pBF;;AG37pBA;EACE,gBAAA;AH87pBF;;AG57pBA;EACE,gBAAA;AH+7pBF;;AG77pBA;EACE,gBAAA;AHg8pBF;;AG97pBA;EACE,gBAAA;AHi8pBF;;AG/7pBA;EACE,gBAAA;AHk8pBF;;AGh8pBA;EACE,gBAAA;AHm8pBF;;AGj8pBA;EACE,gBAAA;AHo8pBF;;AGl8pBA;EACE,gBAAA;AHq8pBF;;AGn8pBA;EACE,gBAAA;AHs8pBF;;AGp8pBA;EACE,gBAAA;AHu8pBF;;AGr8pBA;EACE,gBAAA;AHw8pBF;;AGt8pBA;EACE,gBAAA;AHy8pBF;;AGv8pBA;EACE,gBAAA;AH08pBF;;AGx8pBA;EACE,gBAAA;AH28pBF;;AGz8pBA;EACE,gBAAA;AH48pBF;;AG18pBA;EACE,gBAAA;AH68pBF;;AG38pBA;EACE,gBAAA;AH88pBF;;AG58pBA;EACE,gBAAA;AH+8pBF;;AG78pBA;EACE,gBAAA;AHg9pBF;;AG98pBA;EACE,gBAAA;AHi9pBF;;AG/8pBA;EACE,gBAAA;AHk9pBF;;AGh9pBA;EACE,gBAAA;AHm9pBF;;AGj9pBA;EACE,gBAAA;AHo9pBF;;AGl9pBA;EACE,gBAAA;AHq9pBF;;AGn9pBA;EACE,gBAAA;AHs9pBF;;AGp9pBA;EACE,gBAAA;AHu9pBF;;AGr9pBA;EACE,gBAAA;AHw9pBF;;AGt9pBA;EACE,gBAAA;AHy9pBF;;AGv9pBA;EACE,gBAAA;AH09pBF;;AGx9pBA;EACE,gBAAA;AH29pBF;;AGz9pBA;EACE,gBAAA;AH49pBF;;AG19pBA;EACE,gBAAA;AH69pBF;;AG39pBA;EACE,gBAAA;AH89pBF;;AG59pBA;EACE,gBAAA;AH+9pBF;;AG79pBA;EACE,gBAAA;AHg+pBF;;AG99pBA;EACE,gBAAA;AHi+pBF;;AG/9pBA;EACE,gBAAA;AHk+pBF;;AGh+pBA;EACE,gBAAA;AHm+pBF;;AGj+pBA;EACE,gBAAA;AHo+pBF;;AGl+pBA;EACE,gBAAA;AHq+pBF;;AGn+pBA;EACE,gBAAA;AHs+pBF;;AGp+pBA;EACE,gBAAA;AHu+pBF;;AGr+pBA;EACE,gBAAA;AHw+pBF;;AGt+pBA;EACE,gBAAA;AHy+pBF;;AGv+pBA;EACE,gBAAA;AH0+pBF;;AGx+pBA;EACE,gBAAA;AH2+pBF;;AGz+pBA;EACE,gBAAA;AH4+pBF;;AG1+pBA;EACE,gBAAA;AH6+pBF;;AG3+pBA;EACE,gBAAA;AH8+pBF;;AG5+pBA;EACE,gBAAA;AH++pBF;;AG7+pBA;EACE,gBAAA;AHg/pBF;;AG9+pBA;EACE,gBAAA;AHi/pBF;;AG/+pBA;EACE,gBAAA;AHk/pBF;;AGh/pBA;EACE,gBAAA;AHm/pBF;;AGj/pBA;EACE,gBAAA;AHo/pBF;;AGl/pBA;EACE,gBAAA;AHq/pBF;;AGn/pBA;EACE,gBAAA;AHs/pBF;;AGp/pBA;EACE,gBAAA;AHu/pBF;;AGr/pBA;EACE,gBAAA;AHw/pBF;;AGt/pBA;EACE,gBAAA;AHy/pBF;;AGv/pBA;EACE,gBAAA;AH0/pBF;;AGx/pBA;EACE,gBAAA;AH2/pBF;;AGz/pBA;EACE,gBAAA;AH4/pBF;;AG1/pBA;EACE,gBAAA;AH6/pBF;;AG3/pBA;EACE,gBAAA;AH8/pBF;;AG5/pBA;EACE,gBAAA;AH+/pBF;;AG7/pBA;EACE,gBAAA;AHggqBF;;AG9/pBA;EACE,gBAAA;AHigqBF;;AG//pBA;EACE,gBAAA;AHkgqBF;;AGhgqBA;EACE,gBAAA;AHmgqBF;;AGjgqBA;EACE,gBAAA;AHogqBF;;AGlgqBA;EACE,gBAAA;AHqgqBF;;AGngqBA;EACE,gBAAA;AHsgqBF;;AGpgqBA;EACE,gBAAA;AHugqBF;;AGrgqBA;EACE,gBAAA;AHwgqBF;;AGtgqBA;EACE,gBAAA;AHygqBF;;AGvgqBA;EACE,gBAAA;AH0gqBF;;AGxgqBA;EACE,gBAAA;AH2gqBF;;AGzgqBA;EACE,gBAAA;AH4gqBF;;AG1gqBA;EACE,gBAAA;AH6gqBF;;AG3gqBA;EACE,gBAAA;AH8gqBF;;AG5gqBA;EACE,gBAAA;AH+gqBF;;AG7gqBA;EACE,gBAAA;AHghqBF;;AG9gqBA;EACE,gBAAA;AHihqBF;;AG/gqBA;EACE,gBAAA;AHkhqBF;;AGhhqBA;EACE,gBAAA;AHmhqBF;;AGjhqBA;EACE,gBAAA;AHohqBF;;AGlhqBA;EACE,gBAAA;AHqhqBF;;AGnhqBA;EACE,gBAAA;AHshqBF;;AGphqBA;EACE,gBAAA;AHuhqBF;;AGrhqBA;EACE,gBAAA;AHwhqBF;;AGthqBA;EACE,gBAAA;AHyhqBF;;AGvhqBA;EACE,gBAAA;AH0hqBF;;AGxhqBA;EACE,gBAAA;AH2hqBF;;AGzhqBA;EACE,gBAAA;AH4hqBF;;AG1hqBA;EACE,gBAAA;AH6hqBF;;AG3hqBA;EACE,gBAAA;AH8hqBF;;AG5hqBA;EACE,gBAAA;AH+hqBF;;AG7hqBA;EACE,gBAAA;AHgiqBF;;AG9hqBA;EACE,gBAAA;AHiiqBF;;AG/hqBA;EACE,gBAAA;AHkiqBF;;AGhiqBA;EACE,gBAAA;AHmiqBF;;AGjiqBA;EACE,gBAAA;AHoiqBF;;AGliqBA;EACE,gBAAA;AHqiqBF;;AGniqBA;EACE,gBAAA;AHsiqBF;;AGpiqBA;EACE,gBAAA;AHuiqBF;;AGriqBA;EACE,gBAAA;AHwiqBF;;AGtiqBA;EACE,gBAAA;AHyiqBF;;AGviqBA;EACE,gBAAA;AH0iqBF;;AGxiqBA;EACE,gBAAA;AH2iqBF;;AGziqBA;EACE,gBAAA;AH4iqBF;;AG1iqBA;EACE,gBAAA;AH6iqBF;;AG3iqBA;EACE,gBAAA;AH8iqBF;;AG5iqBA;EACE,gBAAA;AH+iqBF;;AG7iqBA;EACE,gBAAA;AHgjqBF;;AG9iqBA;EACE,gBAAA;AHijqBF;;AG/iqBA;EACE,gBAAA;AHkjqBF;;AGhjqBA;EACE,gBAAA;AHmjqBF;;AGjjqBA;EACE,gBAAA;AHojqBF;;AGljqBA;EACE,gBAAA;AHqjqBF;;AGnjqBA;EACE,gBAAA;AHsjqBF;;AGpjqBA;EACE,gBAAA;AHujqBF;;AGrjqBA;EACE,gBAAA;AHwjqBF;;AGtjqBA;EACE,gBAAA;AHyjqBF;;AGvjqBA;EACE,gBAAA;AH0jqBF;;AGxjqBA;EACE,gBAAA;AH2jqBF;;AGzjqBA;EACE,gBAAA;AH4jqBF;;AG1jqBA;EACE,gBAAA;AH6jqBF;;AG3jqBA;EACE,gBAAA;AH8jqBF;;AG5jqBA;EACE,gBAAA;AH+jqBF;;AG7jqBA;EACE,gBAAA;AHgkqBF;;AG9jqBA;EACE,gBAAA;AHikqBF;;AG/jqBA;EACE,gBAAA;AHkkqBF;;AGhkqBA;EACE,gBAAA;AHmkqBF;;AGjkqBA;EACE,gBAAA;AHokqBF;;AGlkqBA;EACE,gBAAA;AHqkqBF;;AGnkqBA;EACE,gBAAA;AHskqBF;;AGpkqBA;EACE,gBAAA;AHukqBF;;AGrkqBA;EACE,gBAAA;AHwkqBF;;AGtkqBA;EACE,gBAAA;AHykqBF;;AGvkqBA;EACE,gBAAA;AH0kqBF;;AGxkqBA;EACE,gBAAA;AH2kqBF;;AGzkqBA;EACE,gBAAA;AH4kqBF;;AG1kqBA;EACE,gBAAA;AH6kqBF;;AG3kqBA;EACE,gBAAA;AH8kqBF;;AG5kqBA;EACE,gBAAA;AH+kqBF;;AG7kqBA;EACE,gBAAA;AHglqBF;;AG9kqBA;EACE,gBAAA;AHilqBF;;AG/kqBA;EACE,gBAAA;AHklqBF;;AGhlqBA;EACE,gBAAA;AHmlqBF;;AGjlqBA;EACE,gBAAA;AHolqBF;;AGllqBA;EACE,gBAAA;AHqlqBF;;AGnlqBA;EACE,gBAAA;AHslqBF;;AGplqBA;EACE,gBAAA;AHulqBF;;AGrlqBA;EACE,gBAAA;AHwlqBF;;AGtlqBA;EACE,gBAAA;AHylqBF;;AGvlqBA;EACE,gBAAA;AH0lqBF;;AGxlqBA;EACE,gBAAA;AH2lqBF;;AGzlqBA;EACE,gBAAA;AH4lqBF;;AG1lqBA;EACE,gBAAA;AH6lqBF;;AG3lqBA;EACE,gBAAA;AH8lqBF;;AG5lqBA;EACE,gBAAA;AH+lqBF;;AG7lqBA;EACE,gBAAA;AHgmqBF;;AG9lqBA;EACE,gBAAA;AHimqBF;;AG/lqBA;EACE,gBAAA;AHkmqBF;;AGhmqBA;EACE,gBAAA;AHmmqBF;;AGjmqBA;EACE,gBAAA;AHomqBF;;AGlmqBA;EACE,gBAAA;AHqmqBF;;AGnmqBA;EACE,gBAAA;AHsmqBF;;AGpmqBA;EACE,gBAAA;AHumqBF;;AGrmqBA;EACE,gBAAA;AHwmqBF;;AGtmqBA;EACE,gBAAA;AHymqBF;;AGvmqBA;EACE,gBAAA;AH0mqBF;;AGxmqBA;EACE,gBAAA;AH2mqBF;;AGzmqBA;EACE,gBAAA;AH4mqBF;;AG1mqBA;EACE,gBAAA;AH6mqBF;;AG3mqBA;EACE,gBAAA;AH8mqBF;;AG5mqBA;EACE,gBAAA;AH+mqBF;;AG7mqBA;EACE,gBAAA;AHgnqBF;;AG9mqBA;EACE,gBAAA;AHinqBF;;AG/mqBA;EACE,gBAAA;AHknqBF;;AGhnqBA;EACE,gBAAA;AHmnqBF;;AGjnqBA;EACE,gBAAA;AHonqBF;;AGlnqBA;EACE,gBAAA;AHqnqBF;;AGnnqBA;EACE,gBAAA;AHsnqBF;;AGpnqBA;EACE,gBAAA;AHunqBF;;AGrnqBA;EACE,gBAAA;AHwnqBF;;AGtnqBA;EACE,gBAAA;AHynqBF;;AGvnqBA;EACE,gBAAA;AH0nqBF;;AGxnqBA;EACE,gBAAA;AH2nqBF;;AGznqBA;EACE,gBAAA;AH4nqBF;;AG1nqBA;EACE,gBAAA;AH6nqBF;;AG3nqBA;EACE,gBAAA;AH8nqBF;;AG5nqBA;EACE,gBAAA;AH+nqBF;;AG7nqBA;EACE,gBAAA;AHgoqBF;;AG9nqBA;EACE,gBAAA;AHioqBF;;AG/nqBA;EACE,gBAAA;AHkoqBF;;AGhoqBA;EACE,gBAAA;AHmoqBF;;AGjoqBA;EACE,gBAAA;AHooqBF;;AGloqBA;EACE,gBAAA;AHqoqBF;;AGnoqBA;EACE,gBAAA;AHsoqBF;;AGpoqBA;EACE,gBAAA;AHuoqBF;;AGroqBA;EACE,gBAAA;AHwoqBF;;AGtoqBA;EACE,gBAAA;AHyoqBF;;AGvoqBA;EACE,gBAAA;AH0oqBF;;AGxoqBA;EACE,gBAAA;AH2oqBF;;AGzoqBA;EACE,gBAAA;AH4oqBF;;AG1oqBA;EACE,gBAAA;AH6oqBF;;AG3oqBA;EACE,gBAAA;AH8oqBF;;AG5oqBA;EACE,gBAAA;AH+oqBF;;AG7oqBA;EACE,gBAAA;AHgpqBF;;AG9oqBA;EACE,gBAAA;AHipqBF;;AG/oqBA;EACE,gBAAA;AHkpqBF;;AGhpqBA;EACE,gBAAA;AHmpqBF;;AGjpqBA;EACE,gBAAA;AHopqBF;;AGlpqBA;EACE,gBAAA;AHqpqBF;;AGnpqBA;EACE,gBAAA;AHspqBF;;AGppqBA;EACE,gBAAA;AHupqBF;;AGrpqBA;EACE,gBAAA;AHwpqBF;;AGtpqBA;EACE,gBAAA;AHypqBF;;AGvpqBA;EACE,gBAAA;AH0pqBF;;AGxpqBA;EACE,gBAAA;AH2pqBF;;AGzpqBA;EACE,gBAAA;AH4pqBF;;AG1pqBA;EACE,gBAAA;AH6pqBF;;AG3pqBA;EACE,gBAAA;AH8pqBF;;AG5pqBA;EACE,gBAAA;AH+pqBF;;AG7pqBA;EACE,gBAAA;AHgqqBF;;AG9pqBA;EACE,gBAAA;AHiqqBF;;AG/pqBA;EACE,gBAAA;AHkqqBF;;AGhqqBA;EACE,gBAAA;AHmqqBF;;AGjqqBA;EACE,gBAAA;AHoqqBF;;AGlqqBA;EACE,gBAAA;AHqqqBF;;AGnqqBA;EACE,gBAAA;AHsqqBF;;AGpqqBA;EACE,gBAAA;AHuqqBF;;AGrqqBA;EACE,gBAAA;AHwqqBF;;AGtqqBA;EACE,gBAAA;AHyqqBF;;AGvqqBA;EACE,gBAAA;AH0qqBF;;AGxqqBA;EACE,gBAAA;AH2qqBF;;AGzqqBA;EACE,gBAAA;AH4qqBF;;AG1qqBA;EACE,gBAAA;AH6qqBF;;AG3qqBA;EACE,gBAAA;AH8qqBF;;AG5qqBA;EACE,gBAAA;AH+qqBF;;AG7qqBA;EACE,gBAAA;AHgrqBF;;AG9qqBA;EACE,gBAAA;AHirqBF;;AG/qqBA;EACE,gBAAA;AHkrqBF;;AGhrqBA;EACE,gBAAA;AHmrqBF;;AGjrqBA;EACE,gBAAA;AHorqBF;;AGlrqBA;EACE,gBAAA;AHqrqBF;;AGnrqBA;EACE,gBAAA;AHsrqBF;;AGprqBA;EACE,gBAAA;AHurqBF;;AGrrqBA;EACE,gBAAA;AHwrqBF;;AGtrqBA;EACE,gBAAA;AHyrqBF;;AGvrqBA;EACE,gBAAA;AH0rqBF;;AGxrqBA;EACE,gBAAA;AH2rqBF;;AGzrqBA;EACE,gBAAA;AH4rqBF;;AG1rqBA;EACE,gBAAA;AH6rqBF;;AG3rqBA;EACE,gBAAA;AH8rqBF;;AG5rqBA;EACE,gBAAA;AH+rqBF;;AG7rqBA;EACE,gBAAA;AHgsqBF;;AG9rqBA;EACE,gBAAA;AHisqBF;;AG/rqBA;EACE,gBAAA;AHksqBF;;AGhsqBA;EACE,gBAAA;AHmsqBF;;AGjsqBA;EACE,gBAAA;AHosqBF;;AGlsqBA;EACE,gBAAA;AHqsqBF;;AGnsqBA;EACE,gBAAA;AHssqBF;;AGpsqBA;EACE,gBAAA;AHusqBF;;AGrsqBA;EACE,gBAAA;AHwsqBF;;AGtsqBA;EACE,gBAAA;AHysqBF;;AGvsqBA;EACE,gBAAA;AH0sqBF;;AGxsqBA;EACE,gBAAA;AH2sqBF;;AGzsqBA;EACE,gBAAA;AH4sqBF;;AG1sqBA;EACE,gBAAA;AH6sqBF;;AG3sqBA;EACE,gBAAA;AH8sqBF;;AG5sqBA;EACE,gBAAA;AH+sqBF;;AG7sqBA;EACE,gBAAA;AHgtqBF;;AG9sqBA;EACE,gBAAA;AHitqBF;;AG/sqBA;EACE,gBAAA;AHktqBF;;AGhtqBA;EACE,gBAAA;AHmtqBF;;AGjtqBA;EACE,gBAAA;AHotqBF;;AGltqBA;EACE,gBAAA;AHqtqBF;;AGntqBA;EACE,gBAAA;AHstqBF;;AGptqBA;EACE,gBAAA;AHutqBF;;AGrtqBA;EACE,gBAAA;AHwtqBF;;AGttqBA;EACE,gBAAA;AHytqBF;;AGvtqBA;EACE,gBAAA;AH0tqBF;;AGxtqBA;EACE,gBAAA;AH2tqBF;;AGztqBA;EACE,gBAAA;AH4tqBF;;AG1tqBA;EACE,gBAAA;AH6tqBF;;AG3tqBA;EACE,gBAAA;AH8tqBF;;AG5tqBA;EACE,gBAAA;AH+tqBF;;AG7tqBA;EACE,gBAAA;AHguqBF;;AG9tqBA;EACE,gBAAA;AHiuqBF;;AG/tqBA;EACE,gBAAA;AHkuqBF;;AGhuqBA;EACE,gBAAA;AHmuqBF;;AGjuqBA;EACE,gBAAA;AHouqBF;;AGluqBA;EACE,gBAAA;AHquqBF;;AGnuqBA;EACE,gBAAA;AHsuqBF;;AGpuqBA;EACE,gBAAA;AHuuqBF;;AGruqBA;EACE,gBAAA;AHwuqBF;;AGtuqBA;EACE,gBAAA;AHyuqBF;;AGvuqBA;EACE,gBAAA;AH0uqBF;;AGxuqBA;EACE,gBAAA;AH2uqBF;;AGzuqBA;EACE,gBAAA;AH4uqBF;;AG1uqBA;EACE,gBAAA;AH6uqBF;;AG3uqBA;EACE,gBAAA;AH8uqBF;;AG5uqBA;EACE,gBAAA;AH+uqBF;;AG7uqBA;EACE,gBAAA;AHgvqBF;;AG9uqBA;EACE,gBAAA;AHivqBF;;AG/uqBA;EACE,gBAAA;AHkvqBF;;AGhvqBA;EACE,gBAAA;AHmvqBF;;AGjvqBA;EACE,gBAAA;AHovqBF;;AGlvqBA;EACE,gBAAA;AHqvqBF;;AGnvqBA;EACE,gBAAA;AHsvqBF;;AGpvqBA;EACE,gBAAA;AHuvqBF;;AGrvqBA;EACE,gBAAA;AHwvqBF;;AGtvqBA;EACE,gBAAA;AHyvqBF;;AGvvqBA;EACE,gBAAA;AH0vqBF;;AGxvqBA;EACE,gBAAA;AH2vqBF;;AGzvqBA;EACE,gBAAA;AH4vqBF;;AG1vqBA;EACE,gBAAA;AH6vqBF;;AG3vqBA;EACE,gBAAA;AH8vqBF;;AG5vqBA;EACE,gBAAA;AH+vqBF;;AG7vqBA;EACE,gBAAA;AHgwqBF;;AG9vqBA;EACE,gBAAA;AHiwqBF;;AG/vqBA;EACE,gBAAA;AHkwqBF;;AGhwqBA;EACE,gBAAA;AHmwqBF;;AGjwqBA;EACE,gBAAA;AHowqBF;;AGlwqBA;EACE,gBAAA;AHqwqBF;;AGnwqBA;EACE,gBAAA;AHswqBF;;AGpwqBA;EACE,gBAAA;AHuwqBF;;AGrwqBA;EACE,gBAAA;AHwwqBF;;AGtwqBA;EACE,gBAAA;AHywqBF;;AGvwqBA;EACE,gBAAA;AH0wqBF;;AGxwqBA;EACE,gBAAA;AH2wqBF;;AGzwqBA;EACE,gBAAA;AH4wqBF;;AG1wqBA;EACE,gBAAA;AH6wqBF;;AG3wqBA;EACE,gBAAA;AH8wqBF;;AG5wqBA;EACE,gBAAA;AH+wqBF;;AG7wqBA;EACE,gBAAA;AHgxqBF;;AG9wqBA;EACE,gBAAA;AHixqBF;;AG/wqBA;EACE,gBAAA;AHkxqBF;;AGhxqBA;EACE,gBAAA;AHmxqBF;;AGjxqBA;EACE,gBAAA;AHoxqBF;;AGlxqBA;EACE,gBAAA;AHqxqBF;;AGnxqBA;EACE,gBAAA;AHsxqBF;;AGpxqBA;EACE,gBAAA;AHuxqBF;;AGrxqBA;EACE,gBAAA;AHwxqBF;;AGtxqBA;EACE,gBAAA;AHyxqBF;;AGvxqBA;EACE,gBAAA;AH0xqBF;;AGxxqBA;EACE,gBAAA;AH2xqBF;;AGzxqBA;EACE,gBAAA;AH4xqBF;;AG1xqBA;EACE,gBAAA;AH6xqBF;;AG3xqBA;EACE,gBAAA;AH8xqBF;;AG5xqBA;EACE,gBAAA;AH+xqBF;;AG7xqBA;EACE,gBAAA;AHgyqBF;;AG9xqBA;EACE,gBAAA;AHiyqBF;;AG/xqBA;EACE,gBAAA;AHkyqBF;;AGhyqBA;EACE,gBAAA;AHmyqBF;;AGjyqBA;EACE,gBAAA;AHoyqBF;;AGlyqBA;EACE,gBAAA;AHqyqBF;;AGnyqBA;EACE,gBAAA;AHsyqBF;;AGpyqBA;EACE,gBAAA;AHuyqBF;;AGryqBA;EACE,gBAAA;AHwyqBF;;AGtyqBA;EACE,gBAAA;AHyyqBF;;AGvyqBA;EACE,gBAAA;AH0yqBF;;AGxyqBA;EACE,gBAAA;AH2yqBF;;AGzyqBA;EACE,gBAAA;AH4yqBF;;AG1yqBA;EACE,gBAAA;AH6yqBF;;AG3yqBA;EACE,gBAAA;AH8yqBF;;AG5yqBA;EACE,gBAAA;AH+yqBF;;AG7yqBA;EACE,gBAAA;AHgzqBF;;AG9yqBA;EACE,gBAAA;AHizqBF;;AG/yqBA;EACE,gBAAA;AHkzqBF;;AGhzqBA;EACE,gBAAA;AHmzqBF;;AGjzqBA;EACE,gBAAA;AHozqBF;;AGlzqBA;EACE,gBAAA;AHqzqBF;;AGnzqBA;EACE,gBAAA;AHszqBF;;AGpzqBA;EACE,gBAAA;AHuzqBF;;AGrzqBA;EACE,gBAAA;AHwzqBF;;AGtzqBA;EACE,gBAAA;AHyzqBF;;AGvzqBA;EACE,gBAAA;AH0zqBF;;AGxzqBA;EACE,gBAAA;AH2zqBF;;AGzzqBA;EACE,gBAAA;AH4zqBF;;AG1zqBA;EACE,gBAAA;AH6zqBF;;AG3zqBA;EACE,gBAAA;AH8zqBF;;AG5zqBA;EACE,gBAAA;AH+zqBF;;AG7zqBA;EACE,gBAAA;AHg0qBF;;AG9zqBA;EACE,gBAAA;AHi0qBF;;AG/zqBA;EACE,gBAAA;AHk0qBF;;AGh0qBA;EACE,gBAAA;AHm0qBF;;AGj0qBA;EACE,gBAAA;AHo0qBF;;AGl0qBA;EACE,gBAAA;AHq0qBF;;AGn0qBA;EACE,gBAAA;AHs0qBF;;AGp0qBA;EACE,gBAAA;AHu0qBF;;AGr0qBA;EACE,gBAAA;AHw0qBF;;AGt0qBA;EACE,gBAAA;AHy0qBF;;AGv0qBA;EACE,gBAAA;AH00qBF;;AGx0qBA;EACE,gBAAA;AH20qBF;;AGz0qBA;EACE,gBAAA;AH40qBF;;AG10qBA;EACE,gBAAA;AH60qBF;;AG30qBA;EACE,gBAAA;AH80qBF;;AG50qBA;EACE,gBAAA;AH+0qBF;;AG70qBA;EACE,gBAAA;AHg1qBF;;AG90qBA;EACE,gBAAA;AHi1qBF;;AG/0qBA;EACE,gBAAA;AHk1qBF;;AGh1qBA;EACE,gBAAA;AHm1qBF;;AGj1qBA;EACE,gBAAA;AHo1qBF;;AGl1qBA;EACE,gBAAA;AHq1qBF;;AGn1qBA;EACE,gBAAA;AHs1qBF;;AGp1qBA;EACE,gBAAA;AHu1qBF;;AGr1qBA;EACE,gBAAA;AHw1qBF;;AGt1qBA;EACE,gBAAA;AHy1qBF;;AGv1qBA;EACE,gBAAA;AH01qBF;;AGx1qBA;EACE,gBAAA;AH21qBF;;AGz1qBA;EACE,gBAAA;AH41qBF;;AG11qBA;EACE,gBAAA;AH61qBF;;AG31qBA;EACE,gBAAA;AH81qBF;;AG51qBA;EACE,gBAAA;AH+1qBF;;AG71qBA;EACE,gBAAA;AHg2qBF;;AG91qBA;EACE,gBAAA;AHi2qBF;;AG/1qBA;EACE,gBAAA;AHk2qBF;;AGh2qBA;EACE,gBAAA;AHm2qBF;;AGj2qBA;EACE,gBAAA;AHo2qBF;;AGl2qBA;EACE,gBAAA;AHq2qBF;;AGn2qBA;EACE,gBAAA;AHs2qBF;;AGp2qBA;EACE,gBAAA;AHu2qBF;;AGr2qBA;EACE,gBAAA;AHw2qBF;;AGt2qBA;EACE,gBAAA;AHy2qBF;;AGv2qBA;EACE,gBAAA;AH02qBF;;AGx2qBA;EACE,gBAAA;AH22qBF;;AGz2qBA;EACE,gBAAA;AH42qBF;;AG12qBA;EACE,gBAAA;AH62qBF;;AG32qBA;EACE,gBAAA;AH82qBF;;AG52qBA;EACE,gBAAA;AH+2qBF;;AG72qBA;EACE,gBAAA;AHg3qBF;;AG92qBA;EACE,gBAAA;AHi3qBF;;AG/2qBA;EACE,gBAAA;AHk3qBF;;AGh3qBA;EACE,gBAAA;AHm3qBF;;AGj3qBA;EACE,gBAAA;AHo3qBF;;AGl3qBA;EACE,gBAAA;AHq3qBF;;AGn3qBA;EACE,gBAAA;AHs3qBF;;AGp3qBA;EACE,gBAAA;AHu3qBF;;AGr3qBA;EACE,gBAAA;AHw3qBF;;AGt3qBA;EACE,gBAAA;AHy3qBF;;AGv3qBA;EACE,gBAAA;AH03qBF;;AGx3qBA;EACE,gBAAA;AH23qBF;;AGz3qBA;EACE,gBAAA;AH43qBF;;AG13qBA;EACE,gBAAA;AH63qBF;;AG33qBA;EACE,gBAAA;AH83qBF;;AG53qBA;EACE,gBAAA;AH+3qBF;;AG73qBA;EACE,gBAAA;AHg4qBF;;AG93qBA;EACE,gBAAA;AHi4qBF;;AG/3qBA;EACE,gBAAA;AHk4qBF;;AGh4qBA;EACE,gBAAA;AHm4qBF;;AGj4qBA;EACE,gBAAA;AHo4qBF;;AGl4qBA;EACE,gBAAA;AHq4qBF;;AGn4qBA;EACE,gBAAA;AHs4qBF;;AGp4qBA;EACE,gBAAA;AHu4qBF;;AGr4qBA;EACE,gBAAA;AHw4qBF;;AGt4qBA;EACE,gBAAA;AHy4qBF;;AGv4qBA;EACE,gBAAA;AH04qBF;;AGx4qBA;EACE,gBAAA;AH24qBF;;AGz4qBA;EACE,gBAAA;AH44qBF;;AG14qBA;EACE,gBAAA;AH64qBF;;AG34qBA;EACE,gBAAA;AH84qBF;;AG54qBA;EACE,gBAAA;AH+4qBF;;AG74qBA;EACE,gBAAA;AHg5qBF;;AG94qBA;EACE,gBAAA;AHi5qBF;;AG/4qBA;EACE,gBAAA;AHk5qBF;;AGh5qBA;EACE,gBAAA;AHm5qBF;;AGj5qBA;EACE,gBAAA;AHo5qBF;;AGl5qBA;EACE,gBAAA;AHq5qBF;;AGn5qBA;EACE,gBAAA;AHs5qBF;;AGp5qBA;EACE,gBAAA;AHu5qBF;;AGr5qBA;EACE,gBAAA;AHw5qBF;;AGt5qBA;EACE,gBAAA;AHy5qBF;;AGv5qBA;EACE,gBAAA;AH05qBF;;AGx5qBA;EACE,gBAAA;AH25qBF;;AGz5qBA;EACE,gBAAA;AH45qBF;;AG15qBA;EACE,gBAAA;AH65qBF;;AG35qBA;EACE,gBAAA;AH85qBF;;AG55qBA;EACE,gBAAA;AH+5qBF;;AG75qBA;EACE,gBAAA;AHg6qBF;;AG95qBA;EACE,gBAAA;AHi6qBF;;AG/5qBA;EACE,gBAAA;AHk6qBF;;AGh6qBA;EACE,gBAAA;AHm6qBF;;AGj6qBA;EACE,gBAAA;AHo6qBF;;AGl6qBA;EACE,gBAAA;AHq6qBF;;AGn6qBA;EACE,gBAAA;AHs6qBF;;AGp6qBA;EACE,gBAAA;AHu6qBF;;AGr6qBA;EACE,gBAAA;AHw6qBF;;AGt6qBA;EACE,gBAAA;AHy6qBF;;AGv6qBA;EACE,gBAAA;AH06qBF;;AGx6qBA;EACE,gBAAA;AH26qBF;;AGz6qBA;EACE,gBAAA;AH46qBF;;AG16qBA;EACE,gBAAA;AH66qBF;;AG36qBA;EACE,gBAAA;AH86qBF;;AG56qBA;EACE,gBAAA;AH+6qBF;;AG76qBA;EACE,gBAAA;AHg7qBF;;AG96qBA;EACE,gBAAA;AHi7qBF;;AG/6qBA;EACE,gBAAA;AHk7qBF;;AGh7qBA;EACE,gBAAA;AHm7qBF;;AGj7qBA;EACE,gBAAA;AHo7qBF;;AGl7qBA;EACE,gBAAA;AHq7qBF;;AGn7qBA;EACE,gBAAA;AHs7qBF;;AGp7qBA;EACE,gBAAA;AHu7qBF;;AGr7qBA;EACE,gBAAA;AHw7qBF;;AGt7qBA;EACE,gBAAA;AHy7qBF;;AGv7qBA;EACE,gBAAA;AH07qBF;;AGx7qBA;EACE,gBAAA;AH27qBF;;AGz7qBA;EACE,gBAAA;AH47qBF;;AG17qBA;EACE,gBAAA;AH67qBF;;AG37qBA;EACE,gBAAA;AH87qBF;;AG57qBA;EACE,gBAAA;AH+7qBF;;AG77qBA;EACE,gBAAA;AHg8qBF;;AG97qBA;EACE,gBAAA;AHi8qBF;;AG/7qBA;EACE,gBAAA;AHk8qBF;;AGh8qBA;EACE,gBAAA;AHm8qBF;;AGj8qBA;EACE,gBAAA;AHo8qBF;;AGl8qBA;EACE,gBAAA;AHq8qBF;;AGn8qBA;EACE,gBAAA;AHs8qBF;;AGp8qBA;EACE,gBAAA;AHu8qBF;;AGr8qBA;EACE,gBAAA;AHw8qBF;;AGt8qBA;EACE,gBAAA;AHy8qBF;;AGv8qBA;EACE,gBAAA;AH08qBF;;AGx8qBA;EACE,gBAAA;AH28qBF;;AGz8qBA;EACE,gBAAA;AH48qBF;;AG18qBA;EACE,gBAAA;AH68qBF;;AG38qBA;EACE,gBAAA;AH88qBF;;AG58qBA;EACE,gBAAA;AH+8qBF;;AG78qBA;EACE,gBAAA;AHg9qBF;;AG98qBA;EACE,gBAAA;AHi9qBF;;AG/8qBA;EACE,gBAAA;AHk9qBF;;AGh9qBA;EACE,gBAAA;AHm9qBF;;AGj9qBA;EACE,gBAAA;AHo9qBF;;AGl9qBA;EACE,gBAAA;AHq9qBF;;AGn9qBA;EACE,gBAAA;AHs9qBF;;AGp9qBA;EACE,gBAAA;AHu9qBF;;AGr9qBA;EACE,gBAAA;AHw9qBF;;AGt9qBA;EACE,gBAAA;AHy9qBF;;AGv9qBA;EACE,gBAAA;AH09qBF;;AGx9qBA;EACE,gBAAA;AH29qBF;;AGz9qBA;EACE,gBAAA;AH49qBF;;AG19qBA;EACE,gBAAA;AH69qBF;;AG39qBA;EACE,gBAAA;AH89qBF;;AG59qBA;EACE,gBAAA;AH+9qBF;;AG79qBA;EACE,gBAAA;AHg+qBF;;AG99qBA;EACE,gBAAA;AHi+qBF;;AG/9qBA;EACE,gBAAA;AHk+qBF;;AGh+qBA;EACE,gBAAA;AHm+qBF;;AGj+qBA;EACE,gBAAA;AHo+qBF;;AGl+qBA;EACE,gBAAA;AHq+qBF;;AGn+qBA;EACE,gBAAA;AHs+qBF;;AGp+qBA;EACE,gBAAA;AHu+qBF;;AGr+qBA;EACE,gBAAA;AHw+qBF;;AGt+qBA;EACE,gBAAA;AHy+qBF;;AGv+qBA;EACE,gBAAA;AH0+qBF;;AGx+qBA;EACE,gBAAA;AH2+qBF;;AGz+qBA;EACE,gBAAA;AH4+qBF;;AG1+qBA;EACE,gBAAA;AH6+qBF;;AG3+qBA;EACE,gBAAA;AH8+qBF;;AG5+qBA;EACE,gBAAA;AH++qBF;;AG7+qBA;EACE,gBAAA;AHg/qBF;;AG9+qBA;EACE,gBAAA;AHi/qBF;;AG/+qBA;EACE,gBAAA;AHk/qBF;;AGh/qBA;EACE,gBAAA;AHm/qBF;;AGj/qBA;EACE,gBAAA;AHo/qBF;;AGl/qBA;EACE,gBAAA;AHq/qBF;;AGn/qBA;EACE,gBAAA;AHs/qBF;;AGp/qBA;EACE,gBAAA;AHu/qBF;;AGr/qBA;EACE,gBAAA;AHw/qBF;;AGt/qBA;EACE,gBAAA;AHy/qBF;;AGv/qBA;EACE,gBAAA;AH0/qBF;;AGx/qBA;EACE,gBAAA;AH2/qBF;;AGz/qBA;EACE,gBAAA;AH4/qBF;;AG1/qBA;EACE,gBAAA;AH6/qBF;;AG3/qBA;EACE,gBAAA;AH8/qBF;;AG5/qBA;EACE,gBAAA;AH+/qBF;;AG7/qBA;EACE,gBAAA;AHggrBF;;AG9/qBA;EACE,gBAAA;AHigrBF;;AG//qBA;EACE,gBAAA;AHkgrBF;;AGhgrBA;EACE,gBAAA;AHmgrBF;;AGjgrBA;EACE,gBAAA;AHogrBF;;AGlgrBA;EACE,gBAAA;AHqgrBF;;AGngrBA;EACE,gBAAA;AHsgrBF;;AGpgrBA;EACE,gBAAA;AHugrBF;;AGrgrBA;EACE,gBAAA;AHwgrBF;;AGtgrBA;EACE,gBAAA;AHygrBF;;AGvgrBA;EACE,gBAAA;AH0grBF;;AGxgrBA;EACE,gBAAA;AH2grBF;;AGzgrBA;EACE,gBAAA;AH4grBF;;AG1grBA;EACE,gBAAA;AH6grBF;;AG3grBA;EACE,gBAAA;AH8grBF;;AG5grBA;EACE,gBAAA;AH+grBF;;AG7grBA;EACE,gBAAA;AHghrBF;;AG9grBA;EACE,gBAAA;AHihrBF;;AG/grBA;EACE,gBAAA;AHkhrBF;;AGhhrBA;EACE,gBAAA;AHmhrBF;;AGjhrBA;EACE,gBAAA;AHohrBF;;AGlhrBA;EACE,gBAAA;AHqhrBF;;AGnhrBA;EACE,gBAAA;AHshrBF;;AGphrBA;EACE,gBAAA;AHuhrBF;;AGrhrBA;EACE,gBAAA;AHwhrBF;;AGthrBA;EACE,gBAAA;AHyhrBF;;AGvhrBA;EACE,gBAAA;AH0hrBF;;AGxhrBA;EACE,gBAAA;AH2hrBF;;AGzhrBA;EACE,gBAAA;AH4hrBF;;AG1hrBA;EACE,gBAAA;AH6hrBF;;AG3hrBA;EACE,gBAAA;AH8hrBF;;AG5hrBA;EACE,gBAAA;AH+hrBF;;AG7hrBA;EACE,gBAAA;AHgirBF;;AG9hrBA;EACE,gBAAA;AHiirBF;;AG/hrBA;EACE,gBAAA;AHkirBF;;AGhirBA;EACE,gBAAA;AHmirBF;;AGjirBA;EACE,gBAAA;AHoirBF;;AGlirBA;EACE,gBAAA;AHqirBF;;AGnirBA;EACE,gBAAA;AHsirBF;;AGpirBA;EACE,gBAAA;AHuirBF;;AGrirBA;EACE,gBAAA;AHwirBF;;AGtirBA;EACE,gBAAA;AHyirBF;;AGvirBA;EACE,gBAAA;AH0irBF;;AGxirBA;EACE,gBAAA;AH2irBF;;AGzirBA;EACE,gBAAA;AH4irBF;;AG1irBA;EACE,gBAAA;AH6irBF;;AG3irBA;EACE,gBAAA;AH8irBF;;AG5irBA;EACE,gBAAA;AH+irBF;;AG7irBA;EACE,gBAAA;AHgjrBF;;AG9irBA;EACE,gBAAA;AHijrBF;;AG/irBA;EACE,gBAAA;AHkjrBF;;AGhjrBA;EACE,gBAAA;AHmjrBF;;AGjjrBA;EACE,gBAAA;AHojrBF;;AGljrBA;EACE,gBAAA;AHqjrBF;;AGnjrBA;EACE,gBAAA;AHsjrBF;;AGpjrBA;EACE,gBAAA;AHujrBF;;AGrjrBA;EACE,gBAAA;AHwjrBF;;AGtjrBA;EACE,gBAAA;AHyjrBF;;AGvjrBA;EACE,gBAAA;AH0jrBF;;AGxjrBA;EACE,gBAAA;AH2jrBF;;AGzjrBA;EACE,gBAAA;AH4jrBF;;AG1jrBA;EACE,gBAAA;AH6jrBF;;AG3jrBA;EACE,gBAAA;AH8jrBF;;AG5jrBA;EACE,gBAAA;AH+jrBF;;AG7jrBA;EACE,gBAAA;AHgkrBF;;AG9jrBA;EACE,gBAAA;AHikrBF;;AG/jrBA;EACE,gBAAA;AHkkrBF;;AGhkrBA;EACE,gBAAA;AHmkrBF;;AGjkrBA;EACE,gBAAA;AHokrBF;;AGlkrBA;EACE,gBAAA;AHqkrBF;;AGnkrBA;EACE,gBAAA;AHskrBF;;AGpkrBA;EACE,gBAAA;AHukrBF;;AGrkrBA;EACE,gBAAA;AHwkrBF;;AGtkrBA;EACE,gBAAA;AHykrBF;;AGvkrBA;EACE,gBAAA;AH0krBF;;AGxkrBA;EACE,gBAAA;AH2krBF;;AGzkrBA;EACE,gBAAA;AH4krBF;;AG1krBA;EACE,gBAAA;AH6krBF;;AG3krBA;EACE,gBAAA;AH8krBF;;AG5krBA;EACE,gBAAA;AH+krBF;;AG7krBA;EACE,gBAAA;AHglrBF;;AG9krBA;EACE,gBAAA;AHilrBF;;AG/krBA;EACE,gBAAA;AHklrBF;;AGhlrBA;EACE,gBAAA;AHmlrBF;;AGjlrBA;EACE,gBAAA;AHolrBF;;AGllrBA;EACE,gBAAA;AHqlrBF;;AGnlrBA;EACE,gBAAA;AHslrBF;;AGplrBA;EACE,gBAAA;AHulrBF;;AGrlrBA;EACE,gBAAA;AHwlrBF;;AGtlrBA;EACE,gBAAA;AHylrBF;;AGvlrBA;EACE,gBAAA;AH0lrBF;;AGxlrBA;EACE,gBAAA;AH2lrBF;;AGzlrBA;EACE,gBAAA;AH4lrBF;;AG1lrBA;EACE,gBAAA;AH6lrBF;;AG3lrBA;EACE,gBAAA;AH8lrBF;;AG5lrBA;EACE,gBAAA;AH+lrBF;;AG7lrBA;EACE,gBAAA;AHgmrBF;;AG9lrBA;EACE,gBAAA;AHimrBF;;AG/lrBA;EACE,gBAAA;AHkmrBF;;AGhmrBA;EACE,gBAAA;AHmmrBF;;AGjmrBA;EACE,gBAAA;AHomrBF;;AGlmrBA;EACE,gBAAA;AHqmrBF;;AGnmrBA;EACE,gBAAA;AHsmrBF;;AGpmrBA;EACE,gBAAA;AHumrBF;;AGrmrBA;EACE,gBAAA;AHwmrBF;;AGtmrBA;EACE,gBAAA;AHymrBF;;AGvmrBA;EACE,gBAAA;AH0mrBF;;AGxmrBA;EACE,gBAAA;AH2mrBF;;AGzmrBA;EACE,gBAAA;AH4mrBF;;AG1mrBA;EACE,gBAAA;AH6mrBF;;AG3mrBA;EACE,gBAAA;AH8mrBF;;AG5mrBA;EACE,gBAAA;AH+mrBF;;AG7mrBA;EACE,gBAAA;AHgnrBF;;AG9mrBA;EACE,gBAAA;AHinrBF;;AG/mrBA;EACE,gBAAA;AHknrBF;;AGhnrBA;EACE,gBAAA;AHmnrBF;;AGjnrBA;EACE,gBAAA;AHonrBF;;AGlnrBA;EACE,gBAAA;AHqnrBF;;AGnnrBA;EACE,gBAAA;AHsnrBF;;AGpnrBA;EACE,gBAAA;AHunrBF;;AGrnrBA;EACE,gBAAA;AHwnrBF;;AGtnrBA;EACE,gBAAA;AHynrBF;;AGvnrBA;EACE,gBAAA;AH0nrBF;;AGxnrBA;EACE,gBAAA;AH2nrBF;;AGznrBA;EACE,gBAAA;AH4nrBF;;AG1nrBA;EACE,gBAAA;AH6nrBF;;AG3nrBA;EACE,gBAAA;AH8nrBF;;AG5nrBA;EACE,gBAAA;AH+nrBF;;AG7nrBA;EACE,gBAAA;AHgorBF;;AG9nrBA;EACE,gBAAA;AHiorBF;;AG/nrBA;EACE,gBAAA;AHkorBF;;AGhorBA;EACE,gBAAA;AHmorBF;;AGjorBA;EACE,gBAAA;AHoorBF;;AGlorBA;EACE,gBAAA;AHqorBF;;AGnorBA;EACE,gBAAA;AHsorBF;;AGporBA;EACE,gBAAA;AHuorBF;;AGrorBA;EACE,gBAAA;AHworBF;;AGtorBA;EACE,gBAAA;AHyorBF;;AGvorBA;EACE,gBAAA;AH0orBF;;AGxorBA;EACE,gBAAA;AH2orBF;;AGzorBA;EACE,gBAAA;AH4orBF;;AG1orBA;EACE,gBAAA;AH6orBF;;AG3orBA;EACE,gBAAA;AH8orBF;;AG5orBA;EACE,gBAAA;AH+orBF;;AG7orBA;EACE,gBAAA;AHgprBF;;AG9orBA;EACE,gBAAA;AHiprBF;;AG/orBA;EACE,gBAAA;AHkprBF;;AGhprBA;EACE,gBAAA;AHmprBF;;AGjprBA;EACE,gBAAA;AHoprBF;;AGlprBA;EACE,gBAAA;AHqprBF;;AGnprBA;EACE,gBAAA;AHsprBF;;AGpprBA;EACE,gBAAA;AHuprBF;;AGrprBA;EACE,gBAAA;AHwprBF;;AGtprBA;EACE,gBAAA;AHyprBF;;AGvprBA;EACE,gBAAA;AH0prBF;;AGxprBA;EACE,gBAAA;AH2prBF;;AGzprBA;EACE,gBAAA;AH4prBF;;AG1prBA;EACE,gBAAA;AH6prBF;;AG3prBA;EACE,gBAAA;AH8prBF;;AG5prBA;EACE,gBAAA;AH+prBF;;AG7prBA;EACE,gBAAA;AHgqrBF;;AG9prBA;EACE,gBAAA;AHiqrBF;;AG/prBA;EACE,gBAAA;AHkqrBF;;AGhqrBA;EACE,gBAAA;AHmqrBF;;AGjqrBA;EACE,gBAAA;AHoqrBF;;AGlqrBA;EACE,gBAAA;AHqqrBF;;AGnqrBA;EACE,gBAAA;AHsqrBF;;AGpqrBA;EACE,gBAAA;AHuqrBF;;AGrqrBA;EACE,gBAAA;AHwqrBF;;AGtqrBA;EACE,gBAAA;AHyqrBF;;AGvqrBA;EACE,gBAAA;AH0qrBF;;AGxqrBA;EACE,gBAAA;AH2qrBF;;AGzqrBA;EACE,gBAAA;AH4qrBF;;AG1qrBA;EACE,gBAAA;AH6qrBF;;AG3qrBA;EACE,gBAAA;AH8qrBF;;AG5qrBA;EACE,gBAAA;AH+qrBF;;AG7qrBA;EACE,gBAAA;AHgrrBF;;AG9qrBA;EACE,gBAAA;AHirrBF;;AG/qrBA;EACE,gBAAA;AHkrrBF;;AGhrrBA;EACE,gBAAA;AHmrrBF;;AGjrrBA;EACE,gBAAA;AHorrBF;;AGlrrBA;EACE,gBAAA;AHqrrBF;;AGnrrBA;EACE,gBAAA;AHsrrBF;;AGprrBA;EACE,gBAAA;AHurrBF;;AGrrrBA;EACE,gBAAA;AHwrrBF;;AGtrrBA;EACE,gBAAA;AHyrrBF;;AGvrrBA;EACE,gBAAA;AH0rrBF;;AGxrrBA;EACE,gBAAA;AH2rrBF;;AGzrrBA;EACE,gBAAA;AH4rrBF;;AG1rrBA;EACE,gBAAA;AH6rrBF;;AG3rrBA;EACE,gBAAA;AH8rrBF;;AG5rrBA;EACE,gBAAA;AH+rrBF;;AG7rrBA;EACE,gBAAA;AHgsrBF;;AG9rrBA;EACE,gBAAA;AHisrBF;;AG/rrBA;EACE,gBAAA;AHksrBF;;AGhsrBA;EACE,gBAAA;AHmsrBF;;AGjsrBA;EACE,gBAAA;AHosrBF;;AGlsrBA;EACE,gBAAA;AHqsrBF;;AGnsrBA;EACE,gBAAA;AHssrBF;;AGpsrBA;EACE,gBAAA;AHusrBF;;AGrsrBA;EACE,gBAAA;AHwsrBF;;AGtsrBA;EACE,gBAAA;AHysrBF;;AGvsrBA;EACE,gBAAA;AH0srBF;;AGxsrBA;EACE,gBAAA;AH2srBF;;AGzsrBA;EACE,gBAAA;AH4srBF;;AG1srBA;EACE,gBAAA;AH6srBF;;AG3srBA;EACE,gBAAA;AH8srBF;;AG5srBA;EACE,gBAAA;AH+srBF;;AG7srBA;EACE,gBAAA;AHgtrBF;;AG9srBA;EACE,gBAAA;AHitrBF;;AG/srBA;EACE,gBAAA;AHktrBF;;AGhtrBA;EACE,gBAAA;AHmtrBF;;AGjtrBA;EACE,gBAAA;AHotrBF;;AGltrBA;EACE,gBAAA;AHqtrBF;;AGntrBA;EACE,gBAAA;AHstrBF;;AGptrBA;EACE,gBAAA;AHutrBF;;AGrtrBA;EACE,gBAAA;AHwtrBF;;AGttrBA;EACE,gBAAA;AHytrBF;;AGvtrBA;EACE,gBAAA;AH0trBF;;AGxtrBA;EACE,gBAAA;AH2trBF;;AGztrBA;EACE,gBAAA;AH4trBF;;AG1trBA;EACE,gBAAA;AH6trBF;;AG3trBA;EACE,gBAAA;AH8trBF;;AG5trBA;EACE,gBAAA;AH+trBF;;AG7trBA;EACE,gBAAA;AHgurBF;;AG9trBA;EACE,gBAAA;AHiurBF;;AG/trBA;EACE,gBAAA;AHkurBF;;AGhurBA;EACE,gBAAA;AHmurBF;;AGjurBA;EACE,gBAAA;AHourBF;;AGlurBA;EACE,gBAAA;AHqurBF;;AGnurBA;EACE,gBAAA;AHsurBF;;AGpurBA;EACE,gBAAA;AHuurBF;;AGrurBA;EACE,gBAAA;AHwurBF;;AGturBA;EACE,gBAAA;AHyurBF;;AGvurBA;EACE,gBAAA;AH0urBF;;AGxurBA;EACE,gBAAA;AH2urBF;;AGzurBA;EACE,gBAAA;AH4urBF;;AG1urBA;EACE,gBAAA;AH6urBF;;AG3urBA;EACE,gBAAA;AH8urBF;;AG5urBA;EACE,gBAAA;AH+urBF;;AG7urBA;EACE,gBAAA;AHgvrBF;;AG9urBA;EACE,gBAAA;AHivrBF;;AG/urBA;EACE,gBAAA;AHkvrBF;;AGhvrBA;EACE,gBAAA;AHmvrBF;;AGjvrBA;EACE,gBAAA;AHovrBF;;AGlvrBA;EACE,gBAAA;AHqvrBF;;AGnvrBA;EACE,gBAAA;AHsvrBF;;AGpvrBA;EACE,gBAAA;AHuvrBF;;AGrvrBA;EACE,gBAAA;AHwvrBF;;AGtvrBA;EACE,gBAAA;AHyvrBF;;AGvvrBA;EACE,gBAAA;AH0vrBF;;AGxvrBA;EACE,gBAAA;AH2vrBF;;AGzvrBA;EACE,gBAAA;AH4vrBF;;AG1vrBA;EACE,gBAAA;AH6vrBF;;AG3vrBA;EACE,gBAAA;AH8vrBF;;AG5vrBA;EACE,gBAAA;AH+vrBF;;AG7vrBA;EACE,gBAAA;AHgwrBF;;AG9vrBA;EACE,gBAAA;AHiwrBF;;AG/vrBA;EACE,gBAAA;AHkwrBF;;AGhwrBA;EACE,gBAAA;AHmwrBF;;AGjwrBA;EACE,gBAAA;AHowrBF;;AGlwrBA;EACE,gBAAA;AHqwrBF;;AGnwrBA;EACE,gBAAA;AHswrBF;;AGpwrBA;EACE,gBAAA;AHuwrBF;;AGrwrBA;EACE,gBAAA;AHwwrBF;;AGtwrBA;EACE,gBAAA;AHywrBF;;AGvwrBA;EACE,gBAAA;AH0wrBF;;AGxwrBA;EACE,gBAAA;AH2wrBF;;AGzwrBA;EACE,gBAAA;AH4wrBF;;AG1wrBA;EACE,gBAAA;AH6wrBF;;AG3wrBA;EACE,gBAAA;AH8wrBF;;AG5wrBA;EACE,gBAAA;AH+wrBF;;AG7wrBA;EACE,gBAAA;AHgxrBF;;AG9wrBA;EACE,gBAAA;AHixrBF;;AG/wrBA;EACE,gBAAA;AHkxrBF;;AGhxrBA;EACE,gBAAA;AHmxrBF;;AGjxrBA;EACE,gBAAA;AHoxrBF;;AGlxrBA;EACE,gBAAA;AHqxrBF;;AGnxrBA;EACE,gBAAA;AHsxrBF;;AGpxrBA;EACE,gBAAA;AHuxrBF;;AGrxrBA;EACE,gBAAA;AHwxrBF;;AGtxrBA;EACE,gBAAA;AHyxrBF;;AGvxrBA;EACE,gBAAA;AH0xrBF;;AGxxrBA;EACE,gBAAA;AH2xrBF;;AGzxrBA;EACE,gBAAA;AH4xrBF;;AG1xrBA;EACE,gBAAA;AH6xrBF;;AG3xrBA;EACE,gBAAA;AH8xrBF;;AG5xrBA;EACE,gBAAA;AH+xrBF;;AG7xrBA;EACE,gBAAA;AHgyrBF;;AG9xrBA;EACE,gBAAA;AHiyrBF;;AG/xrBA;EACE,gBAAA;AHkyrBF;;AGhyrBA;EACE,gBAAA;AHmyrBF;;AGjyrBA;EACE,gBAAA;AHoyrBF;;AGlyrBA;EACE,gBAAA;AHqyrBF;;AGnyrBA;EACE,gBAAA;AHsyrBF;;AGpyrBA;EACE,gBAAA;AHuyrBF;;AGryrBA;EACE,gBAAA;AHwyrBF;;AGtyrBA;EACE,gBAAA;AHyyrBF;;AGvyrBA;EACE,gBAAA;AH0yrBF;;AGxyrBA;EACE,gBAAA;AH2yrBF;;AGzyrBA;EACE,gBAAA;AH4yrBF;;AG1yrBA;EACE,gBAAA;AH6yrBF;;AG3yrBA;EACE,gBAAA;AH8yrBF;;AG5yrBA;EACE,gBAAA;AH+yrBF;;AG7yrBA;EACE,gBAAA;AHgzrBF;;AG9yrBA;EACE,gBAAA;AHizrBF;;AG/yrBA;EACE,gBAAA;AHkzrBF;;AGhzrBA;EACE,gBAAA;AHmzrBF;;AGjzrBA;EACE,gBAAA;AHozrBF;;AGlzrBA;EACE,gBAAA;AHqzrBF;;AGnzrBA;EACE,gBAAA;AHszrBF;;AGpzrBA;EACE,gBAAA;AHuzrBF;;AGrzrBA;EACE,gBAAA;AHwzrBF;;AGtzrBA;EACE,gBAAA;AHyzrBF;;AGvzrBA;EACE,gBAAA;AH0zrBF;;AGxzrBA;EACE,gBAAA;AH2zrBF;;AGzzrBA;EACE,gBAAA;AH4zrBF;;AG1zrBA;EACE,gBAAA;AH6zrBF;;AG3zrBA;EACE,gBAAA;AH8zrBF;;AG5zrBA;EACE,gBAAA;AH+zrBF;;AG7zrBA;EACE,gBAAA;AHg0rBF;;AG9zrBA;EACE,gBAAA;AHi0rBF;;AG/zrBA;EACE,gBAAA;AHk0rBF;;AGh0rBA;EACE,gBAAA;AHm0rBF;;AGj0rBA;EACE,gBAAA;AHo0rBF;;AGl0rBA;EACE,gBAAA;AHq0rBF;;AGn0rBA;EACE,gBAAA;AHs0rBF;;AGp0rBA;EACE,gBAAA;AHu0rBF;;AGr0rBA;EACE,gBAAA;AHw0rBF;;AGt0rBA;EACE,gBAAA;AHy0rBF;;AGv0rBA;EACE,gBAAA;AH00rBF;;AGx0rBA;EACE,gBAAA;AH20rBF;;AGz0rBA;EACE,gBAAA;AH40rBF;;AG10rBA;EACE,gBAAA;AH60rBF;;AG30rBA;EACE,gBAAA;AH80rBF;;AG50rBA;EACE,gBAAA;AH+0rBF;;AG70rBA;EACE,gBAAA;AHg1rBF;;AG90rBA;EACE,gBAAA;AHi1rBF;;AG/0rBA;EACE,gBAAA;AHk1rBF;;AGh1rBA;EACE,gBAAA;AHm1rBF;;AGj1rBA;EACE,gBAAA;AHo1rBF;;AGl1rBA;EACE,gBAAA;AHq1rBF;;AGn1rBA;EACE,gBAAA;AHs1rBF;;AGp1rBA;EACE,gBAAA;AHu1rBF;;AGr1rBA;EACE,gBAAA;AHw1rBF;;AGt1rBA;EACE,gBAAA;AHy1rBF;;AGv1rBA;EACE,gBAAA;AH01rBF;;AGx1rBA;EACE,gBAAA;AH21rBF;;AGz1rBA;EACE,gBAAA;AH41rBF;;AG11rBA;EACE,gBAAA;AH61rBF;;AG31rBA;EACE,gBAAA;AH81rBF;;AG51rBA;EACE,gBAAA;AH+1rBF;;AG71rBA;EACE,gBAAA;AHg2rBF;;AG91rBA;EACE,gBAAA;AHi2rBF;;AG/1rBA;EACE,gBAAA;AHk2rBF;;AGh2rBA;EACE,gBAAA;AHm2rBF;;AGj2rBA;EACE,gBAAA;AHo2rBF;;AGl2rBA;EACE,gBAAA;AHq2rBF;;AGn2rBA;EACE,gBAAA;AHs2rBF;;AGp2rBA;EACE,gBAAA;AHu2rBF;;AGr2rBA;EACE,gBAAA;AHw2rBF;;AGt2rBA;EACE,gBAAA;AHy2rBF;;AGv2rBA;EACE,gBAAA;AH02rBF;;AGx2rBA;EACE,gBAAA;AH22rBF;;AGz2rBA;EACE,gBAAA;AH42rBF;;AG12rBA;EACE,gBAAA;AH62rBF;;AG32rBA;EACE,gBAAA;AH82rBF;;AG52rBA;EACE,gBAAA;AH+2rBF;;AG72rBA;EACE,gBAAA;AHg3rBF;;AG92rBA;EACE,gBAAA;AHi3rBF;;AG/2rBA;EACE,gBAAA;AHk3rBF;;AGh3rBA;EACE,gBAAA;AHm3rBF;;AGj3rBA;EACE,gBAAA;AHo3rBF;;AGl3rBA;EACE,gBAAA;AHq3rBF;;AGn3rBA;EACE,gBAAA;AHs3rBF;;AGp3rBA;EACE,gBAAA;AHu3rBF;;AGr3rBA;EACE,gBAAA;AHw3rBF;;AGt3rBA;EACE,gBAAA;AHy3rBF;;AGv3rBA;EACE,gBAAA;AH03rBF;;AGx3rBA;EACE,gBAAA;AH23rBF;;AGz3rBA;EACE,gBAAA;AH43rBF;;AG13rBA;EACE,gBAAA;AH63rBF;;AG33rBA;EACE,gBAAA;AH83rBF;;AG53rBA;EACE,gBAAA;AH+3rBF;;AG73rBA;EACE,gBAAA;AHg4rBF;;AG93rBA;EACE,gBAAA;AHi4rBF;;AG/3rBA;EACE,gBAAA;AHk4rBF;;AGh4rBA;EACE,gBAAA;AHm4rBF;;AGj4rBA;EACE,gBAAA;AHo4rBF;;AGl4rBA;EACE,gBAAA;AHq4rBF;;AGn4rBA;EACE,gBAAA;AHs4rBF;;AGp4rBA;EACE,gBAAA;AHu4rBF;;AGr4rBA;EACE,gBAAA;AHw4rBF;;AGt4rBA;EACE,gBAAA;AHy4rBF;;AGv4rBA;EACE,gBAAA;AH04rBF;;AGx4rBA;EACE,gBAAA;AH24rBF;;AGz4rBA;EACE,gBAAA;AH44rBF;;AG14rBA;EACE,gBAAA;AH64rBF;;AG34rBA;EACE,gBAAA;AH84rBF;;AG54rBA;EACE,gBAAA;AH+4rBF;;AG74rBA;EACE,gBAAA;AHg5rBF;;AG94rBA;EACE,gBAAA;AHi5rBF;;AG/4rBA;EACE,gBAAA;AHk5rBF;;AGh5rBA;EACE,gBAAA;AHm5rBF;;AGj5rBA;EACE,gBAAA;AHo5rBF;;AGl5rBA;EACE,gBAAA;AHq5rBF;;AGn5rBA;EACE,gBAAA;AHs5rBF;;AGp5rBA;EACE,gBAAA;AHu5rBF;;AGr5rBA;EACE,gBAAA;AHw5rBF;;AGt5rBA;EACE,gBAAA;AHy5rBF;;AGv5rBA;EACE,gBAAA;AH05rBF;;AGx5rBA;EACE,gBAAA;AH25rBF;;AGz5rBA;EACE,gBAAA;AH45rBF;;AG15rBA;EACE,gBAAA;AH65rBF;;AG35rBA;EACE,gBAAA;AH85rBF;;AG55rBA;EACE,gBAAA;AH+5rBF;;AG75rBA;EACE,gBAAA;AHg6rBF;;AG95rBA;EACE,gBAAA;AHi6rBF;;AG/5rBA;EACE,gBAAA;AHk6rBF;;AGh6rBA;EACE,gBAAA;AHm6rBF;;AGj6rBA;EACE,gBAAA;AHo6rBF;;AGl6rBA;EACE,gBAAA;AHq6rBF;;AGn6rBA;EACE,gBAAA;AHs6rBF;;AGp6rBA;EACE,gBAAA;AHu6rBF;;AGr6rBA;EACE,gBAAA;AHw6rBF;;AGt6rBA;EACE,gBAAA;AHy6rBF;;AGv6rBA;EACE,gBAAA;AH06rBF;;AGx6rBA;EACE,gBAAA;AH26rBF;;AGz6rBA;EACE,gBAAA;AH46rBF;;AG16rBA;EACE,gBAAA;AH66rBF;;AG36rBA;EACE,gBAAA;AH86rBF;;AG56rBA;EACE,gBAAA;AH+6rBF;;AG76rBA;EACE,gBAAA;AHg7rBF;;AG96rBA;EACE,gBAAA;AHi7rBF;;AG/6rBA;EACE,gBAAA;AHk7rBF;;AGh7rBA;EACE,gBAAA;AHm7rBF;;AGj7rBA;EACE,gBAAA;AHo7rBF;;AGl7rBA;EACE,gBAAA;AHq7rBF;;AGn7rBA;EACE,gBAAA;AHs7rBF;;AGp7rBA;EACE,gBAAA;AHu7rBF;;AGr7rBA;EACE,gBAAA;AHw7rBF;;AGt7rBA;EACE,gBAAA;AHy7rBF;;AGv7rBA;EACE,gBAAA;AH07rBF;;AGx7rBA;EACE,gBAAA;AH27rBF;;AGz7rBA;EACE,gBAAA;AH47rBF;;AG17rBA;EACE,gBAAA;AH67rBF;;AG37rBA;EACE,gBAAA;AH87rBF;;AG57rBA;EACE,gBAAA;AH+7rBF;;AG77rBA;EACE,gBAAA;AHg8rBF;;AG97rBA;EACE,gBAAA;AHi8rBF;;AG/7rBA;EACE,gBAAA;AHk8rBF;;AGh8rBA;EACE,gBAAA;AHm8rBF;;AGj8rBA;EACE,gBAAA;AHo8rBF;;AGl8rBA;EACE,gBAAA;AHq8rBF;;AGn8rBA;EACE,gBAAA;AHs8rBF;;AGp8rBA;EACE,gBAAA;AHu8rBF;;AGr8rBA;EACE,gBAAA;AHw8rBF;;AGt8rBA;EACE,gBAAA;AHy8rBF;;AGv8rBA;EACE,gBAAA;AH08rBF;;AGx8rBA;EACE,gBAAA;AH28rBF;;AGz8rBA;EACE,gBAAA;AH48rBF;;AG18rBA;EACE,gBAAA;AH68rBF;;AG38rBA;EACE,gBAAA;AH88rBF;;AG58rBA;EACE,gBAAA;AH+8rBF;;AG78rBA;EACE,gBAAA;AHg9rBF;;AG98rBA;EACE,gBAAA;AHi9rBF;;AG/8rBA;EACE,gBAAA;AHk9rBF;;AGh9rBA;EACE,gBAAA;AHm9rBF;;AGj9rBA;EACE,gBAAA;AHo9rBF;;AGl9rBA;EACE,gBAAA;AHq9rBF;;AGn9rBA;EACE,gBAAA;AHs9rBF;;AGp9rBA;EACE,gBAAA;AHu9rBF;;AGr9rBA;EACE,gBAAA;AHw9rBF;;AGt9rBA;EACE,gBAAA;AHy9rBF;;AGv9rBA;EACE,gBAAA;AH09rBF;;AGx9rBA;EACE,gBAAA;AH29rBF;;AGz9rBA;EACE,gBAAA;AH49rBF;;AG19rBA;EACE,gBAAA;AH69rBF;;AG39rBA;EACE,gBAAA;AH89rBF;;AG59rBA;EACE,gBAAA;AH+9rBF;;AG79rBA;EACE,gBAAA;AHg+rBF;;AG99rBA;EACE,gBAAA;AHi+rBF;;AG/9rBA;EACE,gBAAA;AHk+rBF;;AGh+rBA;EACE,gBAAA;AHm+rBF;;AGj+rBA;EACE,gBAAA;AHo+rBF;;AGl+rBA;EACE,gBAAA;AHq+rBF;;AGn+rBA;EACE,gBAAA;AHs+rBF;;AGp+rBA;EACE,gBAAA;AHu+rBF;;AGr+rBA;EACE,gBAAA;AHw+rBF;;AGt+rBA;EACE,gBAAA;AHy+rBF;;AGv+rBA;EACE,gBAAA;AH0+rBF;;AGx+rBA;EACE,gBAAA;AH2+rBF;;AGz+rBA;EACE,gBAAA;AH4+rBF;;AG1+rBA;EACE,gBAAA;AH6+rBF;;AG3+rBA;EACE,gBAAA;AH8+rBF;;AG5+rBA;EACE,gBAAA;AH++rBF;;AG7+rBA;EACE,gBAAA;AHg/rBF;;AG9+rBA;EACE,gBAAA;AHi/rBF;;AG/+rBA;EACE,gBAAA;AHk/rBF;;AGh/rBA;EACE,gBAAA;AHm/rBF;;AGj/rBA;EACE,gBAAA;AHo/rBF;;AGl/rBA;EACE,gBAAA;AHq/rBF;;AGn/rBA;EACE,gBAAA;AHs/rBF;;AGp/rBA;EACE,gBAAA;AHu/rBF;;AGr/rBA;EACE,gBAAA;AHw/rBF;;AGt/rBA;EACE,gBAAA;AHy/rBF;;AGv/rBA;EACE,gBAAA;AH0/rBF;;AGx/rBA;EACE,gBAAA;AH2/rBF;;AGz/rBA;EACE,gBAAA;AH4/rBF;;AG1/rBA;EACE,gBAAA;AH6/rBF;;AG3/rBA;EACE,gBAAA;AH8/rBF;;AIxm4BA;;;;;;;CAAA;ACCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,+CAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,8BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,kCAAA;EACA,0BAAA;EAEA,+CAAA;EACA,sCAAA;EAGE,qCAAA;EAGF,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,iDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AN+m4BF;;AQ/t4BI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;AN+m4BJ;;ASvx4BA;;;EAGE,sBAAA;AT0x4BF;;AS3w4BI;EANJ;IAOM,uBAAA;ET+w4BJ;AACF;;ASlw4BA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ATqw4BF;;AS5v4BA;EACE,cAAA;EACA,cC2aS;ED1aT,SAAA;EACA,wCAAA;EACA,aC0aW;AVq13Bb;;ASrv4BA;EACE,aAAA;EACA,qBCsXuB;EDnXvB,gBCsXqB;EDrXrB,gBCsXqB;EDrXrB,8BAAA;ATsv4BF;;ASnv4BA;EFuMQ,uCAAA;APgj4BR;AO5s4BI;EE3CJ;IF8MQ,qBAAA;EP6i4BN;AACF;;ASvv4BA;EFkMQ,mCAAA;APyj4BR;AOrt4BI;EEtCJ;IFyMQ,mBAAA;EPsj4BN;AACF;;AS3v4BA;EF6LQ,yCAAA;APkk4BR;AO9t4BI;EEjCJ;IFoMQ,sBAAA;EP+j4BN;AACF;;AS/v4BA;EFwLQ,qCAAA;AP2k4BR;AOvu4BI;EE5BJ;IF+LQ,oBAAA;EPwk4BN;AACF;;ASnw4BA;EF+KM,sBALI;AP6l4BV;;ASlw4BA;EF0KM,oBALI;APim4BV;;AS3v4BA;EACE,aAAA;EACA,mBCoLwB;AV0k4B1B;;ASpv4BA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;ATuv4BF;;ASjv4BA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ATov4BF;;AS9u4BA;;EAEE,kBAAA;ATiv4BF;;AS9u4BA;;;EAGE,aAAA;EACA,mBAAA;ATiv4BF;;AS9u4BA;;;;EAIE,gBAAA;ATiv4BF;;AS9u4BA;EACE,gBC6PiB;AVo/3BnB;;AS5u4BA;EACE,qBAAA;EACA,cAAA;AT+u4BF;;ASzu4BA;EACE,gBAAA;AT4u4BF;;ASpu4BA;;EAEE,mBCsOmB;AVig4BrB;;AS/t4BA;EF6EM,kBALI;AP2p4BV;;AS5t4BA;EACE,cC8Ra;ED7Rb,gCAAA;EACA,wCAAA;AT+t4BF;;AStt4BA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ATyt4BF;;AStt4BA;EAAM,eAAA;AT0t4BN;;ASzt4BA;EAAM,WAAA;AT6t4BN;;ASxt4BA;EACE,gEAAA;EACA,qBCqDgB;AVsq4BlB;ASzt4BE;EACE,mDAAA;EACA,0BCoDoB;AVuq4BxB;;ASjt4BE;EAEE,cAAA;EACA,qBAAA;ATmt4BJ;;AS5s4BA;;;;EAIE,qCCkJiB;EHpIb,cALI;APus4BV;;ASxs4BA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AP+s4BV;ASvs4BE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ATys4BJ;;ASrs4BA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;ATws4BF;ASrs4BE;EACE,cAAA;ATus4BJ;;ASns4BA;EACE,sBAAA;EFtBI,kBALI;EE6BR,WCjRM;EDkRN,yBCzQS;EC5BP,qBAAA;AX4+4BJ;ASps4BE;EACE,UAAA;EF7BE,cALI;EEoCN,gBCiHe;AVql4BnB;;AS7r4BA;EACE,gBAAA;ATgs4BF;;AS1r4BA;;EAEE,sBAAA;AT6r4BF;;ASrr4BA;EACE,oBAAA;EACA,yBAAA;ATwr4BF;;ASrr4BA;EACE,mBCyKqB;EDxKrB,sBCwKqB;EDvKrB,cCpTS;EDqTT,gBAAA;ATwr4BF;;ASjr4BA;EAEE,mBAAA;EACA,gCAAA;ATmr4BF;;AShr4BA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ATmr4BF;;AS3q4BA;EACE,qBAAA;AT8q4BF;;ASxq4BA;EAEE,gBAAA;AT0q4BF;;ASlq4BA;EACE,UAAA;ATqq4BF;;AShq4BA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ATmq4BF;;AS/p4BA;;EAEE,oBAAA;ATkq4BF;;AS7p4BA;EACE,eAAA;ATgq4BF;;AS7p4BA;EAGE,iBAAA;AT8p4BF;AS3p4BE;EACE,UAAA;AT6p4BJ;;AStp4BA;EACE,wBAAA;ATyp4BF;;ASjp4BA;;;;EAIE,0BAAA;ATop4BF;ASjp4BI;;;;EACE,eAAA;ATsp4BN;;AS/o4BA;EACE,UAAA;EACA,kBAAA;ATkp4BF;;AS7o4BA;EACE,gBAAA;ATgp4BF;;ASto4BA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ATyo4BF;;ASjo4BA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EFjNM,iCAAA;EEoNN,oBAAA;ATmo4BF;AOn/4BI;EEyWJ;IFtMQ,iBAAA;EPo14BN;AACF;ASto4BE;EACE,WAAA;ATwo4BJ;;ASjo4BA;;;;;;;EAOE,UAAA;AToo4BF;;ASjo4BA;EACE,YAAA;AToo4BF;;AS3n4BA;EACE,6BAAA;EACA,oBAAA;AT8n4BF;;AStn4BA;;;;;;;CAAA;AAWA;EACE,wBAAA;ATsn4BF;;ASjn4BA;EACE,UAAA;ATon4BF;;AS7m4BA;EACE,aAAA;EACA,0BAAA;ATgn4BF;;AS3m4BA;EACE,qBAAA;AT8m4BF;;ASzm4BA;EACE,SAAA;AT4m4BF;;ASrm4BA;EACE,kBAAA;EACA,eAAA;ATwm4BF;;AShm4BA;EACE,wBAAA;ATmm4BF;;AS3l4BA;EACE,wBAAA;AT8l4BF;;AYnq5BA;ELmQM,sBALI;EK5PR,gBFkciB;AVou4BnB;;AYjq5BE;ELgQM,iCAAA;EK5PJ,gBFobkB;EEnblB,gBFsamB;AV4v4BvB;AOnk5BI;EKpGF;ILuQM,eAAA;EPo64BN;AACF;;AY5q5BE;ELgQM,iCAAA;EK5PJ,gBFobkB;EEnblB,gBFsamB;AVuw4BvB;AO9k5BI;EKpGF;ILuQM,iBAAA;EP+64BN;AACF;;AYvr5BE;ELgQM,iCAAA;EK5PJ,gBFobkB;EEnblB,gBFsamB;AVkx4BvB;AOzl5BI;EKpGF;ILuQM,eAAA;EP074BN;AACF;;AYls5BE;ELgQM,iCAAA;EK5PJ,gBFobkB;EEnblB,gBFsamB;AV6x4BvB;AOpm5BI;EKpGF;ILuQM,iBAAA;EPq84BN;AACF;;AY7s5BE;ELgQM,iCAAA;EK5PJ,gBFobkB;EEnblB,gBFsamB;AVwy4BvB;AO/m5BI;EKpGF;ILuQM,eAAA;EPg94BN;AACF;;AYxt5BE;ELgQM,iCAAA;EK5PJ,gBFobkB;EEnblB,gBFsamB;AVmz4BvB;AO1n5BI;EKpGF;ILuQM,iBAAA;EP294BN;AACF;;AY3s5BA;ECvDE,eAAA;EACA,gBAAA;Absw5BF;;AY3s5BA;EC5DE,eAAA;EACA,gBAAA;Ab2w5BF;;AY7s5BA;EACE,qBAAA;AZgt5BF;AY9s5BE;EACE,oBFubkB;AVyx4BtB;;AYts5BA;EL8MM,kBALI;EKvMR,yBAAA;AZys5BF;;AYrs5BA;EACE,mBF+KO;EHwBH,sBALI;APug5BV;AYts5BE;EACE,gBAAA;AZws5BJ;;AYps5BA;EACE,iBAAA;EACA,mBFqKO;EHwBH,kBALI;EKtLR,cFxDS;AV+v5BX;AYrs5BE;EACE,aAAA;AZus5BJ;;Acvy5BA;ECIE,eAAA;EAGA,YAAA;Afqy5BF;;Acty5BA;EACE,gBJ0uCkB;EIzuClB,yBJkRQ;EIjRR,yBAAA;EHGE,sBAAA;EIRF,eAAA;EAGA,YAAA;Af8y5BF;;Achy5BA;EAEE,qBAAA;Adky5BF;;Ac/x5BA;EACE,qBAAA;EACA,cAAA;Adky5BF;;Ac/x5BA;EPyPM,kBALI;EOlPR,cJIS;AV8x5BX;;AgBp05BE;;;;;;;ECHA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AjBi15BF;;AkB3x5BI;EF5CE;IACE,gBN4Te;EV+g5BrB;AACF;AkBjy5BI;EF5CE;IACE,gBN4Te;EVoh5BrB;AACF;AkBty5BI;EF5CE;IACE,gBN4Te;EVyh5BrB;AACF;AkB3y5BI;EF5CE;IACE,iBN4Te;EV8h5BrB;AACF;AkBhz5BI;EF5CE;IACE,iBN4Te;EVmi5BrB;AACF;AmBh35BA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AnBs35BJ;;AmBj35BE;ECNA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;ApB035BF;AmBx35BI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;ApBo35BF;;AoBr05BM;EACE,SAAA;ApBw05BR;;AoBr05BM;EApCJ,cAAA;EACA,WAAA;ApB625BF;;AoB/15BE;EACE,cAAA;EACA,WAAA;ApBk25BJ;;AoBp25BE;EACE,cAAA;EACA,UAAA;ApBu25BJ;;AoBz25BE;EACE,cAAA;EACA,mBAAA;ApB425BJ;;AoB925BE;EACE,cAAA;EACA,UAAA;ApBi35BJ;;AoBn35BE;EACE,cAAA;EACA,UAAA;ApBs35BJ;;AoBx35BE;EACE,cAAA;EACA,mBAAA;ApB235BJ;;AoB515BM;EAhDJ,cAAA;EACA,WAAA;ApBg55BF;;AoB315BU;EAhEN,cAAA;EACA,kBAAA;ApB+55BJ;;AoBh25BU;EAhEN,cAAA;EACA,mBAAA;ApBo65BJ;;AoBr25BU;EAhEN,cAAA;EACA,UAAA;ApBy65BJ;;AoB125BU;EAhEN,cAAA;EACA,mBAAA;ApB865BJ;;AoB/25BU;EAhEN,cAAA;EACA,mBAAA;ApBm75BJ;;AoBp35BU;EAhEN,cAAA;EACA,UAAA;ApBw75BJ;;AoBz35BU;EAhEN,cAAA;EACA,mBAAA;ApB675BJ;;AoB935BU;EAhEN,cAAA;EACA,mBAAA;ApBk85BJ;;AoBn45BU;EAhEN,cAAA;EACA,UAAA;ApBu85BJ;;AoBx45BU;EAhEN,cAAA;EACA,mBAAA;ApB485BJ;;AoB745BU;EAhEN,cAAA;EACA,mBAAA;ApBi95BJ;;AoBl55BU;EAhEN,cAAA;EACA,WAAA;ApBs95BJ;;AoB/45BY;EAxDV,wBAAA;ApB285BF;;AoBn55BY;EAxDV,yBAAA;ApB+85BF;;AoBv55BY;EAxDV,gBAAA;ApBm95BF;;AoB355BY;EAxDV,yBAAA;ApBu95BF;;AoB/55BY;EAxDV,yBAAA;ApB295BF;;AoBn65BY;EAxDV,gBAAA;ApB+95BF;;AoBv65BY;EAxDV,yBAAA;ApBm+5BF;;AoB365BY;EAxDV,yBAAA;ApBu+5BF;;AoB/65BY;EAxDV,gBAAA;ApB2+5BF;;AoBn75BY;EAxDV,yBAAA;ApB++5BF;;AoBv75BY;EAxDV,yBAAA;ApBm/5BF;;AoBh75BQ;;EAEE,gBAAA;ApBm75BV;;AoBh75BQ;;EAEE,gBAAA;ApBm75BV;;AoB175BQ;;EAEE,sBAAA;ApB675BV;;AoB175BQ;;EAEE,sBAAA;ApB675BV;;AoBp85BQ;;EAEE,qBAAA;ApBu85BV;;AoBp85BQ;;EAEE,qBAAA;ApBu85BV;;AoB985BQ;;EAEE,mBAAA;ApBi95BV;;AoB985BQ;;EAEE,mBAAA;ApBi95BV;;AoBx95BQ;;EAEE,qBAAA;ApB295BV;;AoBx95BQ;;EAEE,qBAAA;ApB295BV;;AoBl+5BQ;;EAEE,mBAAA;ApBq+5BV;;AoBl+5BQ;;EAEE,mBAAA;ApBq+5BV;;AkB/h6BI;EEUE;IACE,SAAA;EpByh6BN;EoBth6BI;IApCJ,cAAA;IACA,WAAA;EpB6j6BA;EoB/i6BA;IACE,cAAA;IACA,WAAA;EpBij6BF;EoBnj6BA;IACE,cAAA;IACA,UAAA;EpBqj6BF;EoBvj6BA;IACE,cAAA;IACA,mBAAA;EpByj6BF;EoB3j6BA;IACE,cAAA;IACA,UAAA;EpB6j6BF;EoB/j6BA;IACE,cAAA;IACA,UAAA;EpBik6BF;EoBnk6BA;IACE,cAAA;IACA,mBAAA;EpBqk6BF;EoBti6BI;IAhDJ,cAAA;IACA,WAAA;EpByl6BA;EoBpi6BQ;IAhEN,cAAA;IACA,kBAAA;EpBum6BF;EoBxi6BQ;IAhEN,cAAA;IACA,mBAAA;EpB2m6BF;EoB5i6BQ;IAhEN,cAAA;IACA,UAAA;EpB+m6BF;EoBhj6BQ;IAhEN,cAAA;IACA,mBAAA;EpBmn6BF;EoBpj6BQ;IAhEN,cAAA;IACA,mBAAA;EpBun6BF;EoBxj6BQ;IAhEN,cAAA;IACA,UAAA;EpB2n6BF;EoB5j6BQ;IAhEN,cAAA;IACA,mBAAA;EpB+n6BF;EoBhk6BQ;IAhEN,cAAA;IACA,mBAAA;EpBmo6BF;EoBpk6BQ;IAhEN,cAAA;IACA,UAAA;EpBuo6BF;EoBxk6BQ;IAhEN,cAAA;IACA,mBAAA;EpB2o6BF;EoB5k6BQ;IAhEN,cAAA;IACA,mBAAA;EpB+o6BF;EoBhl6BQ;IAhEN,cAAA;IACA,WAAA;EpBmp6BF;EoB5k6BU;IAxDV,cAAA;EpBuo6BA;EoB/k6BU;IAxDV,wBAAA;EpB0o6BA;EoBll6BU;IAxDV,yBAAA;EpB6o6BA;EoBrl6BU;IAxDV,gBAAA;EpBgp6BA;EoBxl6BU;IAxDV,yBAAA;EpBmp6BA;EoB3l6BU;IAxDV,yBAAA;EpBsp6BA;EoB9l6BU;IAxDV,gBAAA;EpByp6BA;EoBjm6BU;IAxDV,yBAAA;EpB4p6BA;EoBpm6BU;IAxDV,yBAAA;EpB+p6BA;EoBvm6BU;IAxDV,gBAAA;EpBkq6BA;EoB1m6BU;IAxDV,yBAAA;EpBqq6BA;EoB7m6BU;IAxDV,yBAAA;EpBwq6BA;EoBrm6BM;;IAEE,gBAAA;EpBum6BR;EoBpm6BM;;IAEE,gBAAA;EpBsm6BR;EoB7m6BM;;IAEE,sBAAA;EpB+m6BR;EoB5m6BM;;IAEE,sBAAA;EpB8m6BR;EoBrn6BM;;IAEE,qBAAA;EpBun6BR;EoBpn6BM;;IAEE,qBAAA;EpBsn6BR;EoB7n6BM;;IAEE,mBAAA;EpB+n6BR;EoB5n6BM;;IAEE,mBAAA;EpB8n6BR;EoBro6BM;;IAEE,qBAAA;EpBuo6BR;EoBpo6BM;;IAEE,qBAAA;EpBso6BR;EoB7o6BM;;IAEE,mBAAA;EpB+o6BR;EoB5o6BM;;IAEE,mBAAA;EpB8o6BR;AACF;AkBzs6BI;EEUE;IACE,SAAA;EpBks6BN;EoB/r6BI;IApCJ,cAAA;IACA,WAAA;EpBsu6BA;EoBxt6BA;IACE,cAAA;IACA,WAAA;EpB0t6BF;EoB5t6BA;IACE,cAAA;IACA,UAAA;EpB8t6BF;EoBhu6BA;IACE,cAAA;IACA,mBAAA;EpBku6BF;EoBpu6BA;IACE,cAAA;IACA,UAAA;EpBsu6BF;EoBxu6BA;IACE,cAAA;IACA,UAAA;EpB0u6BF;EoB5u6BA;IACE,cAAA;IACA,mBAAA;EpB8u6BF;EoB/s6BI;IAhDJ,cAAA;IACA,WAAA;EpBkw6BA;EoB7s6BQ;IAhEN,cAAA;IACA,kBAAA;EpBgx6BF;EoBjt6BQ;IAhEN,cAAA;IACA,mBAAA;EpBox6BF;EoBrt6BQ;IAhEN,cAAA;IACA,UAAA;EpBwx6BF;EoBzt6BQ;IAhEN,cAAA;IACA,mBAAA;EpB4x6BF;EoB7t6BQ;IAhEN,cAAA;IACA,mBAAA;EpBgy6BF;EoBju6BQ;IAhEN,cAAA;IACA,UAAA;EpBoy6BF;EoBru6BQ;IAhEN,cAAA;IACA,mBAAA;EpBwy6BF;EoBzu6BQ;IAhEN,cAAA;IACA,mBAAA;EpB4y6BF;EoB7u6BQ;IAhEN,cAAA;IACA,UAAA;EpBgz6BF;EoBjv6BQ;IAhEN,cAAA;IACA,mBAAA;EpBoz6BF;EoBrv6BQ;IAhEN,cAAA;IACA,mBAAA;EpBwz6BF;EoBzv6BQ;IAhEN,cAAA;IACA,WAAA;EpB4z6BF;EoBrv6BU;IAxDV,cAAA;EpBgz6BA;EoBxv6BU;IAxDV,wBAAA;EpBmz6BA;EoB3v6BU;IAxDV,yBAAA;EpBsz6BA;EoB9v6BU;IAxDV,gBAAA;EpByz6BA;EoBjw6BU;IAxDV,yBAAA;EpB4z6BA;EoBpw6BU;IAxDV,yBAAA;EpB+z6BA;EoBvw6BU;IAxDV,gBAAA;EpBk06BA;EoB1w6BU;IAxDV,yBAAA;EpBq06BA;EoB7w6BU;IAxDV,yBAAA;EpBw06BA;EoBhx6BU;IAxDV,gBAAA;EpB206BA;EoBnx6BU;IAxDV,yBAAA;EpB806BA;EoBtx6BU;IAxDV,yBAAA;EpBi16BA;EoB9w6BM;;IAEE,gBAAA;EpBgx6BR;EoB7w6BM;;IAEE,gBAAA;EpB+w6BR;EoBtx6BM;;IAEE,sBAAA;EpBwx6BR;EoBrx6BM;;IAEE,sBAAA;EpBux6BR;EoB9x6BM;;IAEE,qBAAA;EpBgy6BR;EoB7x6BM;;IAEE,qBAAA;EpB+x6BR;EoBty6BM;;IAEE,mBAAA;EpBwy6BR;EoBry6BM;;IAEE,mBAAA;EpBuy6BR;EoB9y6BM;;IAEE,qBAAA;EpBgz6BR;EoB7y6BM;;IAEE,qBAAA;EpB+y6BR;EoBtz6BM;;IAEE,mBAAA;EpBwz6BR;EoBrz6BM;;IAEE,mBAAA;EpBuz6BR;AACF;AkBl36BI;EEUE;IACE,SAAA;EpB226BN;EoBx26BI;IApCJ,cAAA;IACA,WAAA;EpB+46BA;EoBj46BA;IACE,cAAA;IACA,WAAA;EpBm46BF;EoBr46BA;IACE,cAAA;IACA,UAAA;EpBu46BF;EoBz46BA;IACE,cAAA;IACA,mBAAA;EpB246BF;EoB746BA;IACE,cAAA;IACA,UAAA;EpB+46BF;EoBj56BA;IACE,cAAA;IACA,UAAA;EpBm56BF;EoBr56BA;IACE,cAAA;IACA,mBAAA;EpBu56BF;EoBx36BI;IAhDJ,cAAA;IACA,WAAA;EpB266BA;EoBt36BQ;IAhEN,cAAA;IACA,kBAAA;EpBy76BF;EoB136BQ;IAhEN,cAAA;IACA,mBAAA;EpB676BF;EoB936BQ;IAhEN,cAAA;IACA,UAAA;EpBi86BF;EoBl46BQ;IAhEN,cAAA;IACA,mBAAA;EpBq86BF;EoBt46BQ;IAhEN,cAAA;IACA,mBAAA;EpBy86BF;EoB146BQ;IAhEN,cAAA;IACA,UAAA;EpB686BF;EoB946BQ;IAhEN,cAAA;IACA,mBAAA;EpBi96BF;EoBl56BQ;IAhEN,cAAA;IACA,mBAAA;EpBq96BF;EoBt56BQ;IAhEN,cAAA;IACA,UAAA;EpBy96BF;EoB156BQ;IAhEN,cAAA;IACA,mBAAA;EpB696BF;EoB956BQ;IAhEN,cAAA;IACA,mBAAA;EpBi+6BF;EoBl66BQ;IAhEN,cAAA;IACA,WAAA;EpBq+6BF;EoB956BU;IAxDV,cAAA;EpBy96BA;EoBj66BU;IAxDV,wBAAA;EpB496BA;EoBp66BU;IAxDV,yBAAA;EpB+96BA;EoBv66BU;IAxDV,gBAAA;EpBk+6BA;EoB166BU;IAxDV,yBAAA;EpBq+6BA;EoB766BU;IAxDV,yBAAA;EpBw+6BA;EoBh76BU;IAxDV,gBAAA;EpB2+6BA;EoBn76BU;IAxDV,yBAAA;EpB8+6BA;EoBt76BU;IAxDV,yBAAA;EpBi/6BA;EoBz76BU;IAxDV,gBAAA;EpBo/6BA;EoB576BU;IAxDV,yBAAA;EpBu/6BA;EoB/76BU;IAxDV,yBAAA;EpB0/6BA;EoBv76BM;;IAEE,gBAAA;EpBy76BR;EoBt76BM;;IAEE,gBAAA;EpBw76BR;EoB/76BM;;IAEE,sBAAA;EpBi86BR;EoB976BM;;IAEE,sBAAA;EpBg86BR;EoBv86BM;;IAEE,qBAAA;EpBy86BR;EoBt86BM;;IAEE,qBAAA;EpBw86BR;EoB/86BM;;IAEE,mBAAA;EpBi96BR;EoB986BM;;IAEE,mBAAA;EpBg96BR;EoBv96BM;;IAEE,qBAAA;EpBy96BR;EoBt96BM;;IAEE,qBAAA;EpBw96BR;EoB/96BM;;IAEE,mBAAA;EpBi+6BR;EoB996BM;;IAEE,mBAAA;EpBg+6BR;AACF;AkB3h7BI;EEUE;IACE,SAAA;EpBoh7BN;EoBjh7BI;IApCJ,cAAA;IACA,WAAA;EpBwj7BA;EoB1i7BA;IACE,cAAA;IACA,WAAA;EpB4i7BF;EoB9i7BA;IACE,cAAA;IACA,UAAA;EpBgj7BF;EoBlj7BA;IACE,cAAA;IACA,mBAAA;EpBoj7BF;EoBtj7BA;IACE,cAAA;IACA,UAAA;EpBwj7BF;EoB1j7BA;IACE,cAAA;IACA,UAAA;EpB4j7BF;EoB9j7BA;IACE,cAAA;IACA,mBAAA;EpBgk7BF;EoBji7BI;IAhDJ,cAAA;IACA,WAAA;EpBol7BA;EoB/h7BQ;IAhEN,cAAA;IACA,kBAAA;EpBkm7BF;EoBni7BQ;IAhEN,cAAA;IACA,mBAAA;EpBsm7BF;EoBvi7BQ;IAhEN,cAAA;IACA,UAAA;EpB0m7BF;EoB3i7BQ;IAhEN,cAAA;IACA,mBAAA;EpB8m7BF;EoB/i7BQ;IAhEN,cAAA;IACA,mBAAA;EpBkn7BF;EoBnj7BQ;IAhEN,cAAA;IACA,UAAA;EpBsn7BF;EoBvj7BQ;IAhEN,cAAA;IACA,mBAAA;EpB0n7BF;EoB3j7BQ;IAhEN,cAAA;IACA,mBAAA;EpB8n7BF;EoB/j7BQ;IAhEN,cAAA;IACA,UAAA;EpBko7BF;EoBnk7BQ;IAhEN,cAAA;IACA,mBAAA;EpBso7BF;EoBvk7BQ;IAhEN,cAAA;IACA,mBAAA;EpB0o7BF;EoB3k7BQ;IAhEN,cAAA;IACA,WAAA;EpB8o7BF;EoBvk7BU;IAxDV,cAAA;EpBko7BA;EoB1k7BU;IAxDV,wBAAA;EpBqo7BA;EoB7k7BU;IAxDV,yBAAA;EpBwo7BA;EoBhl7BU;IAxDV,gBAAA;EpB2o7BA;EoBnl7BU;IAxDV,yBAAA;EpB8o7BA;EoBtl7BU;IAxDV,yBAAA;EpBip7BA;EoBzl7BU;IAxDV,gBAAA;EpBop7BA;EoB5l7BU;IAxDV,yBAAA;EpBup7BA;EoB/l7BU;IAxDV,yBAAA;EpB0p7BA;EoBlm7BU;IAxDV,gBAAA;EpB6p7BA;EoBrm7BU;IAxDV,yBAAA;EpBgq7BA;EoBxm7BU;IAxDV,yBAAA;EpBmq7BA;EoBhm7BM;;IAEE,gBAAA;EpBkm7BR;EoB/l7BM;;IAEE,gBAAA;EpBim7BR;EoBxm7BM;;IAEE,sBAAA;EpB0m7BR;EoBvm7BM;;IAEE,sBAAA;EpBym7BR;EoBhn7BM;;IAEE,qBAAA;EpBkn7BR;EoB/m7BM;;IAEE,qBAAA;EpBin7BR;EoBxn7BM;;IAEE,mBAAA;EpB0n7BR;EoBvn7BM;;IAEE,mBAAA;EpByn7BR;EoBho7BM;;IAEE,qBAAA;EpBko7BR;EoB/n7BM;;IAEE,qBAAA;EpBio7BR;EoBxo7BM;;IAEE,mBAAA;EpB0o7BR;EoBvo7BM;;IAEE,mBAAA;EpByo7BR;AACF;AkBps7BI;EEUE;IACE,SAAA;EpB6r7BN;EoB1r7BI;IApCJ,cAAA;IACA,WAAA;EpBiu7BA;EoBnt7BA;IACE,cAAA;IACA,WAAA;EpBqt7BF;EoBvt7BA;IACE,cAAA;IACA,UAAA;EpByt7BF;EoB3t7BA;IACE,cAAA;IACA,mBAAA;EpB6t7BF;EoB/t7BA;IACE,cAAA;IACA,UAAA;EpBiu7BF;EoBnu7BA;IACE,cAAA;IACA,UAAA;EpBqu7BF;EoBvu7BA;IACE,cAAA;IACA,mBAAA;EpByu7BF;EoB1s7BI;IAhDJ,cAAA;IACA,WAAA;EpB6v7BA;EoBxs7BQ;IAhEN,cAAA;IACA,kBAAA;EpB2w7BF;EoB5s7BQ;IAhEN,cAAA;IACA,mBAAA;EpB+w7BF;EoBht7BQ;IAhEN,cAAA;IACA,UAAA;EpBmx7BF;EoBpt7BQ;IAhEN,cAAA;IACA,mBAAA;EpBux7BF;EoBxt7BQ;IAhEN,cAAA;IACA,mBAAA;EpB2x7BF;EoB5t7BQ;IAhEN,cAAA;IACA,UAAA;EpB+x7BF;EoBhu7BQ;IAhEN,cAAA;IACA,mBAAA;EpBmy7BF;EoBpu7BQ;IAhEN,cAAA;IACA,mBAAA;EpBuy7BF;EoBxu7BQ;IAhEN,cAAA;IACA,UAAA;EpB2y7BF;EoB5u7BQ;IAhEN,cAAA;IACA,mBAAA;EpB+y7BF;EoBhv7BQ;IAhEN,cAAA;IACA,mBAAA;EpBmz7BF;EoBpv7BQ;IAhEN,cAAA;IACA,WAAA;EpBuz7BF;EoBhv7BU;IAxDV,cAAA;EpB2y7BA;EoBnv7BU;IAxDV,wBAAA;EpB8y7BA;EoBtv7BU;IAxDV,yBAAA;EpBiz7BA;EoBzv7BU;IAxDV,gBAAA;EpBoz7BA;EoB5v7BU;IAxDV,yBAAA;EpBuz7BA;EoB/v7BU;IAxDV,yBAAA;EpB0z7BA;EoBlw7BU;IAxDV,gBAAA;EpB6z7BA;EoBrw7BU;IAxDV,yBAAA;EpBg07BA;EoBxw7BU;IAxDV,yBAAA;EpBm07BA;EoB3w7BU;IAxDV,gBAAA;EpBs07BA;EoB9w7BU;IAxDV,yBAAA;EpBy07BA;EoBjx7BU;IAxDV,yBAAA;EpB407BA;EoBzw7BM;;IAEE,gBAAA;EpB2w7BR;EoBxw7BM;;IAEE,gBAAA;EpB0w7BR;EoBjx7BM;;IAEE,sBAAA;EpBmx7BR;EoBhx7BM;;IAEE,sBAAA;EpBkx7BR;EoBzx7BM;;IAEE,qBAAA;EpB2x7BR;EoBxx7BM;;IAEE,qBAAA;EpB0x7BR;EoBjy7BM;;IAEE,mBAAA;EpBmy7BR;EoBhy7BM;;IAEE,mBAAA;EpBky7BR;EoBzy7BM;;IAEE,qBAAA;EpB2y7BR;EoBxy7BM;;IAEE,qBAAA;EpB0y7BR;EoBjz7BM;;IAEE,mBAAA;EpBmz7BR;EoBhz7BM;;IAEE,mBAAA;EpBkz7BR;AACF;AqBx67BA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,yBAAA;EACA,gCAAA;EACA,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,0CAAA;EACA,gCAAA;EACA,+DAAA;EACA,+BAAA;EACA,4BAAA;EAEA,WAAA;EACA,mBXgPO;EW/OP,mBXof0B;EWnf1B,0CAAA;ArBu67BF;AqBh67BE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,wBXwUW;EWvUX,2GAAA;ArBi67BJ;AqB957BE;EACE,uBAAA;ArBg67BJ;AqB757BE;EACE,sBAAA;ArB+57BJ;;AqB357BA;EACE,4CAAA;ArB857BF;;AqBv57BA;EACE,iBAAA;ArB057BF;;AqBh57BE;EACE,wBAAA;ArBm57BJ;;AqBp47BE;EACE,mBAAA;ArBu47BJ;AqBp47BI;EACE,mBAAA;ArBs47BN;;AqB/37BE;EACE,sBAAA;ArBk47BJ;AqB/37BE;EACE,mBAAA;ArBi47BJ;;AqBv37BE;EACE,oDAAA;EACA,8CAAA;ArB037BJ;;AqBp37BE;EACE,oDAAA;EACA,8CAAA;ArBu37BJ;;AqB/27BA;EACE,oDAAA;EACA,8CAAA;ArBk37BF;;AqB127BE;EACE,mDAAA;EACA,6CAAA;ArB627BJ;;AsBz/7BE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,gDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AtBq/7BJ;;AsBvg8BE;EAOE,yBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AtBmg8BJ;;AsBrh8BE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,mDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AtBih8BJ;;AsBni8BE;EAOE,yBAAA;EACA,mCAAA;EACA,gDAAA;EACA,+CAAA;EACA,iCAAA;EACA,6CAAA;EACA,gCAAA;EACA,8CAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AtB+h8BJ;;AsBjj8BE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,iDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AtB6i8BJ;;AsB/j8BE;EAOE,yBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gCAAA;EACA,gDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AtB2j8BJ;;AsB7k8BE;EAOE,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,gDAAA;EACA,iCAAA;EACA,8CAAA;EACA,gCAAA;EACA,gDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AtByk8BJ;;AsB3l8BE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,+CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AtBul8BJ;;AqBt87BI;EACE,gBAAA;EACA,iCAAA;ArBy87BN;;AkBpi8BI;EGyFA;IACE,gBAAA;IACA,iCAAA;ErB+87BJ;AACF;AkB3i8BI;EGyFA;IACE,gBAAA;IACA,iCAAA;ErBq97BJ;AACF;AkBjj8BI;EGyFA;IACE,gBAAA;IACA,iCAAA;ErB297BJ;AACF;AkBvj8BI;EGyFA;IACE,gBAAA;IACA,iCAAA;ErBi+7BJ;AACF;AkB7j8BI;EGyFA;IACE,gBAAA;IACA,iCAAA;ErBu+7BJ;AACF;AuB3o8BA;EACE,qBbgoByB;AV6g7B3B;;AuBpo8BA;EACE,+BAAA;EACA,kCAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+ZiB;AVsu7BnB;;AuBjo8BA;EACE,+BAAA;EACA,kCAAA;EhBoQI,mBALI;APs47BV;;AuBjo8BA;EACE,gCAAA;EACA,mCAAA;EhB8PI,uBALI;AP447BV;;AwBlq8BA;EACE,mBd0nBqB;EHhWjB,kBALI;EiBjRR,cdmCS;AVgo8BX;;AyBxq8BA;EACE,cAAA;EACA,WAAA;EACA,oBAAA;ElBwRI,mBALI;EkBhRR,gBfoamB;EenanB,gBfyaiB;EexajB,cfiCS;EehCT,gBAAA;EACA,sBfwBM;EevBN,4BAAA;EACA,yBAAA;EdGE,sBAAA;EeHE,wEDMJ;AzBsq8BF;A0Bxq8BM;EDhBN;ICiBQ,gBAAA;E1B2q8BN;AACF;AyBzq8BE;EACE,gBAAA;AzB2q8BJ;AyBzq8BI;EACE,eAAA;AzB2q8BN;AyBtq8BE;EACE,cfWO;EeVP,sBfGI;EeFJ,oCfooBuB;EenoBvB,UAAA;EAKE,gBfioBmB;AVmi7BzB;AyBhq8BE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AzBop8BJ;AyB/o8BE;EACE,cAAA;EACA,UAAA;AzBip8BJ;AyB7o8BE;EACE,cf/BO;EeiCP,UAAA;AzB8o8BJ;AyBto8BE;EAEE,sBfjDI;EeoDJ,UAAA;AzBqo8BJ;AyBjo8BE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2dkB;Ee1dlB,cfrDO;EiBzCT,yBjBoCS;Ee4DP,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BfqQW;EepQX,gBAAA;ECzFE,qID0FF;AzBmo8BJ;A0Bzt8BM;ED0EJ;ICzEM,gBAAA;E1B4t8BN;AACF;AyBro8BE;EACE,6CfitBwB;AVs76B5B;;AyB9n8BA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBfwTiB;EevTjB,cfhFS;EeiFT,6BAAA;EACA,yBAAA;EACA,mBAAA;AzBio8BF;AyB/n8BE;EACE,UAAA;AzBio8BJ;AyB9n8BE;EAEE,gBAAA;EACA,eAAA;AzB+n8BJ;;AyBpn8BA;EACE,4CfkiBgB;EejiBhB,uBAAA;ElByII,uBALI;EIvQN,qBAAA;AX4v8BJ;AyBrn8BE;EACE,uBAAA;EACA,wBAAA;EACA,yBf0aqB;AV6s7BzB;;AyBnn8BA;EACE,0CfshBgB;EerhBhB,oBAAA;ElB4HI,mBALI;EIvQN,qBAAA;AXww8BJ;AyBpn8BE;EACE,oBAAA;EACA,qBAAA;EACA,uBfiaqB;AVqt7BzB;;AyB9m8BE;EACE,0CfmgBW;AV8m7Bf;AyB9m8BE;EACE,4CfggBc;AVgn7BlB;AyB7m8BE;EACE,0Cf6fc;AVkn7BlB;;AyB1m8BA;EACE,WGquBsC;EHpuBtC,sCfofa;Eenfb,efwXoB;AVqv7BtB;AyB3m8BE;EACE,eAAA;AzB6m8BJ;AyB1m8BE;EACE,oBAAA;EdvLA,sBAAA;AXoy8BJ;AyBzm8BE;EACE,oBAAA;Ed5LA,sBAAA;AXwy8BJ;AyBxm8BE;EAAoB,wCfoeJ;AVuo7BlB;AyB1m8BE;EAAoB,sCfoeJ;AVyo7BlB;;A6B5z8BA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,gCAAA;EtBqRI,mBALI;EsB7QR,gBnBiamB;EmBhanB,gBnBsaiB;EmBrajB,cnB8BS;EmB7BT,gBAAA;EACA,sBnBqBM;EmBpBN,mFAAA;EACA,4BAAA;EACA,sCnBmvBwB;EmBlvBxB,yBnBmvBoB;EmBlvBpB,yBAAA;ElBHE,sBAAA;EeHE,wEGSJ;A7B4z8BF;A0Bj08BM;EGfN;IHgBQ,gBAAA;E1Bo08BN;AACF;A6B/z8BE;EACE,oCnB4oBuB;EmB3oBvB,UAAA;EAKE,mDnByvByB;AVok7B/B;A6Bzz8BE;EAEE,mBnBohBkB;EmBnhBlB,sBAAA;A7B0z8BJ;A6Bvz8BE;EACE,cnBDO;EmBEP,yBnBNO;AV+z8BX;A6Bpz8BE;EACE,kBAAA;EACA,0BAAA;A7Bsz8BJ;;A6Blz8BA;EACE,oBnB4gBuB;EmB3gBvB,uBnB2gBuB;EmB1gBvB,oBnB2gBuB;EHxSnB,uBALI;EIvQN,yCAAA;AXg28BJ;;A6Blz8BA;EACE,mBnBwgBuB;EmBvgBvB,sBnBugBuB;EmBtgBvB,kBnBugBuB;EH5SnB,mBALI;EIvQN,yCAAA;AXw28BJ;;A6Bhz8BI;EACE,iEAAA;A7Bmz8BN;;A8B338BA;EACE,cAAA;EACA,sBpB4rBsB;EoB3rBtB,mBpB4rByB;EoB3rBzB,uBpB4rByB;AVks7B3B;A8B538BE;EACE,WAAA;EACA,mBAAA;A9B838BJ;;A8B138BA;EACE,oBpBkrByB;EoBjrBzB,eAAA;EACA,iBAAA;A9B638BF;A8B338BE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A9B638BJ;;A8Bz38BA;EACE,2BAAA;EAEA,cAAA;EACA,UpBiqBuB;EoBhqBvB,WpBgqBuB;EoB/pBvB,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qCpBsqBwB;EoBrqBxB,iCAAA;UAAA,yBAAA;EJ3BI,mJI4BJ;A9B238BF;A0Bn58BM;EIQN;IJPQ,gBAAA;E1Bs58BN;AACF;A8B938BE;EnB3BE,qBAAA;AX458BJ;A8B738BE;EAEE,kBpB8pB6B;AVgu7BjC;A8B338BE;EACE,uBpBqpB6B;AVwu7BjC;A8B138BE;EACE,oCpB4mBuB;EoB3mBvB,UAAA;EACA,mDpBsgByB;AVs37B7B;A8Bz38BE;EACE,yBpBFG;EoBGH,qBpBHG;AV838BP;A8Bz38BI;EAII,kEAAA;A9Bw38BR;A8Bp38BI;EAII,kEAAA;A9Bm38BR;A8B928BE;EACE,yBpBvBG;EoBwBH,qBpBxBG;EoB6BD,kEAAA;A9B428BN;A8Bx28BE;EACE,oBAAA;EACA,YAAA;EACA,YpB6nBgC;AV6u7BpC;A8Bn28BI;EACE,eAAA;EACA,YpBonB8B;AViv7BpC;;A8Bv18BA;EACE,mBpB2mB0B;AV+u7B5B;A8Bx18BE;EACE,6DAAA;EAEA,UpBqmBgB;EoBpmBhB,mBAAA;EACA,0CAAA;EACA,gCAAA;EnBjHA,kBAAA;EeHE,iDIsHF;A9By18BJ;A0B388BM;EI0GJ;IJzGM,gBAAA;E1B888BN;AACF;A8B518BI;EACE,6DAAA;A9B818BN;A8B318BI;EACE,iCpBmmB4B;EoB9lB1B,6DAAA;A9By18BR;A8Bp18BE;EACE,oBpB+kBwB;EoB9kBxB,eAAA;A9Bs18BJ;A8Bp18BI;EACE,oBAAA;EACA,cAAA;A9Bs18BN;;A8Bj18BA;EACE,qBAAA;EACA,kBpB8kB6B;AVsw7B/B;;A8Bj18BA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A9Bo18BF;A8Bh18BI;EACE,oBAAA;EACA,YAAA;EACA,apB0biB;AVw57BvB;;A8B308BI;EACE,6DAAA;A9B808BN;;A+Bjg9BA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A/Bog9BF;A+Blg9BE;EACE,UAAA;A/Bog9BJ;A+Bhg9BI;EAA0B,mCrBiyB5B;AVku7BF;A+Blg9BI;EAA0B,mCrBgyB5B;AVqu7BF;A+Blg9BE;EACE,SAAA;A/Bog9BJ;A+Bjg9BE;EACE,WrBixBqB;EqBhxBrB,YrBgxBqB;EqB/wBrB,oBAAA;EACA,gBAAA;EJ1BF,yBjB4DK;EqBhCH,SrB+wBsB;EC5xBtB,mBAAA;EeHE,oHKmBF;ELnBE,4GKmBF;A/Bkg9BJ;A0Bjh9BM;EKMJ;ILLM,wBAAA;IAAA,gBAAA;E1Boh9BN;AACF;A+Brg9BI;EJjCF,wCjBkzB2B;AVuv7B7B;A+Bng9BE;EACE,WrB0vBqB;EqBzvBrB,crB0vBsB;EqBzvBtB,kBAAA;EACA,erByvBsB;EqBxvBtB,yBrBNO;EqBOP,yBAAA;EpB7BA,mBAAA;AXmi9BJ;A+Bjg9BE;EACE,WrBsvBqB;EqBrvBrB,YrBqvBqB;EqBpvBrB,gBAAA;EJpDF,yBjB4DK;EqBNH,SrBqvBsB;EC5xBtB,mBAAA;EeHE,iHK6CF;EL7CE,4GK6CF;A/Bkg9BJ;A0B3i9BM;EKiCJ;ILhCM,qBAAA;IAAA,gBAAA;E1B8i9BN;AACF;A+Brg9BI;EJ3DF,wCjBkzB2B;AVix7B7B;A+Bng9BE;EACE,WrBguBqB;EqB/tBrB,crBguBsB;EqB/tBtB,kBAAA;EACA,erB+tBsB;EqB9tBtB,yBrBhCO;EqBiCP,yBAAA;EpBvDA,mBAAA;AX6j9BJ;A+Bjg9BE;EACE,oBAAA;A/Bmg9BJ;A+Bjg9BI;EACE,yBrBxCK;AV2i9BX;A+Bhg9BI;EACE,yBrB5CK;AV8i9BX;;AgCzl9BA;EACE,kBAAA;AhC4l9BF;AgC1l9BE;;;EAGE,0BtB2zBmB;EsB1zBnB,8BtB0zBmB;EsBzzBnB,iBJuiCoC;A5Bqj7BxC;AgCzl9BE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ENRE,gEMSF;AhC2l9BJ;A0Bhm9BM;EMTJ;INUM,gBAAA;E1Bmm9BN;AACF;AgC7l9BE;;EAEE,kBAAA;AhC+l9BJ;AgC7l9BI;;EACE,kBAAA;AhCgm9BN;AgC7l9BI;;;EAEE,qBtB8xB0B;EsB7xB1B,wBtB8xB0B;AVk07BhC;AgC7l9BI;;EACE,qBtByxB0B;EsBxxB1B,wBtByxB0B;AVu07BhC;AgC5l9BE;EACE,qBtBmxB4B;EsBlxB5B,wBtBmxB4B;AV207BhC;AgCvl9BI;;;;EACE,2CAAA;EACA,8DtB4wB0B;AVg17BhC;AgC1l9BM;;;;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aJm/BgC;EIl/BhC,WAAA;EACA,sBtB7BA;ECnBJ,sBAAA;AXgp9BJ;AgCzl9BI;EACE,2CAAA;EACA,8DtB2vB0B;AVg27BhC;AgCtl9BI;EACE,mBAAA;AhCwl9BN;AgCpl9BE;;EAEE,cJ1EO;A5Bgq9BX;AgCpl9BI;;EACE,sBtBrDE;AV4o9BR;;AiC9q9BA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AjCir9BF;AiC/q9BE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AjCir9BJ;AiC7q9BE;;;EAGE,UAAA;AjC+q9BJ;AiCzq9BE;EACE,kBAAA;EACA,UAAA;AjC2q9BJ;AiCzq9BI;EACE,UAAA;AjC2q9BN;;AiChq9BA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;E1B8OI,mBALI;E0BvOR,gBvB2XmB;EuB1XnB,gBvBgYiB;EuB/XjB,cvBRS;EuBST,kBAAA;EACA,mBAAA;EACA,yBvBhBS;EuBiBT,yBAAA;EtBtCE,sBAAA;AX0s9BJ;;AiC1p9BA;;;;EAIE,oBAAA;E1BwNI,mBALI;EIvQN,qBAAA;AXmt9BJ;;AiC1p9BA;;;;EAIE,uBAAA;E1B+MI,uBALI;EIvQN,qBAAA;AX4t9BJ;;AiC1p9BA;;EAEE,mBAAA;AjC6p9BF;;AiChp9BI;;;;EtBjEA,0BAAA;EACA,6BAAA;AXwt9BJ;AiC/o9BI;;;;EtB1EA,0BAAA;EACA,6BAAA;AX+t9BJ;AiCzo9BE;EACE,2BAAA;EtB1EA,yBAAA;EACA,4BAAA;AXst9BJ;AiCzo9BE;;EtB9EE,yBAAA;EACA,4BAAA;AX2t9BJ;;AkCnv9BE;EACE,aAAA;EACA,WAAA;EACA,mBxBkmBmB;EHhWjB,kBALI;E2B1PN,cxB0zBqB;AV277BzB;;AkClv9BE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BqPE,uBALI;E2B7ON,WAxBc;EAyBd,wCAxBiB;EvBHjB,sBAAA;AXgx9BJ;;AkChv9BI;;;;EAEE,cAAA;AlCqv9BN;;AkCpy9BI;EAqDE,qBxB+xBmB;EwB5xBjB,iCxBonBa;EwBnnBb,0DAAA;EACA,4BAAA;EACA,yDAAA;EACA,4DAAA;AlCiv9BR;AkC9u9BM;EACE,qBxBoxBiB;EwB/wBf,iDApDW;AlCgy9BrB;;AkCjz9BI;EA+EI,iCxB6lBa;EwB5lBb,8EAAA;AlCsu9BR;;AkCtz9BI;EAuFE,qBxB6vBmB;AVs+7BzB;AkChu9BQ;EAEE,kEAAA;EACA,qCxByqB8B;EwBxqB9B,yDAAA;EACA,sEAAA;AlCiu9BV;AkC7t9BM;EACE,qBxBgvBiB;EwB3uBf,iDAxFW;AlCmz9BrB;;AkCp09BI;EAkHI,sCAAA;AlCst9BR;;AkCx09BI;EAyHE,qBxB2tBmB;AVw/7BzB;AkCjt9BM;EACE,yBxBwtBiB;AV2/7BzB;AkCht9BM;EACE,iDA/Ga;AlCi09BrB;AkC/s9BM;EACE,cxBgtBiB;AVig8BzB;;AkC5s9BI;EACE,kBAAA;AlC+s9BN;;AkCz19BI;;;;;EAoJM,UAAA;AlC6s9BV;;AkC709BE;EACE,aAAA;EACA,WAAA;EACA,mBxBkmBmB;EHhWjB,kBALI;E2B1PN,cxB0zBqB;AVqh8BzB;;AkC509BE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BqPE,uBALI;E2B7ON,WAxBc;EAyBd,yCAxBiB;EvBHjB,sBAAA;AX029BJ;;AkC109BI;;;;EAEE,cAAA;AlC+09BN;;AkC939BI;EAqDE,qBxB+xBmB;EwB5xBjB,iCxBonBa;EwBnnBb,0DAAA;EACA,4BAAA;EACA,yDAAA;EACA,4DAAA;AlC209BR;AkCx09BM;EACE,qBxBoxBiB;EwB/wBf,kDApDW;AlC039BrB;;AkC349BI;EA+EI,iCxB6lBa;EwB5lBb,8EAAA;AlCg09BR;;AkCh59BI;EAuFE,qBxB6vBmB;AVgk8BzB;AkC1z9BQ;EAEE,kEAAA;EACA,qCxByqB8B;EwBxqB9B,yDAAA;EACA,sEAAA;AlC2z9BV;AkCvz9BM;EACE,qBxBgvBiB;EwB3uBf,kDAxFW;AlC649BrB;;AkC959BI;EAkHI,sCAAA;AlCgz9BR;;AkCl69BI;EAyHE,qBxB2tBmB;AVkl8BzB;AkC3y9BM;EACE,yBxBwtBiB;AVql8BzB;AkC1y9BM;EACE,kDA/Ga;AlC259BrB;AkCzy9BM;EACE,cxBgtBiB;AV2l8BzB;;AkCty9BI;EACE,kBAAA;AlCyy9BN;;AkCn79BI;;;;;EAsJM,UAAA;AlCqy9BV;;AmC779BA;EAEE,2BAAA;EACA,2BAAA;EACA,sBAAA;E5BuRI,6BALI;E4BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,+BAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E5BsQI,kCALI;E4B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;ExBjBE,0CAAA;EgBfF,kCQkCqB;ETtBjB,qISwBJ;AnC079BF;A0B989BM;EShBN;ITiBQ,gBAAA;E1Bi99BN;AACF;AmC779BE;EACE,gCAAA;EACA,qBAAA;EACA,wCAAA;EACA,8CAAA;AnC+79BJ;AmC579BE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AnC679BJ;AmC179BE;EACE,gCAAA;ERrDF,wCQsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AnCw79BN;AmCp79BE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AnCk79BN;AmC969BE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AnC069BJ;AmCv69BI;EAKI,0CAAA;AnCq69BR;AmCh69BE;EAKI,0CAAA;AnC859BN;AmC159BE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AnCy59BJ;;AmC749BE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCgg+BF;;AmC959BE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,wCAAA;EACA,2BAAA;EACA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCih+BF;;AmC/69BE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,uCAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCki+BF;;AmCh89BE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,gDAAA;EACA,wCAAA;EACA,2BAAA;EACA,uCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCmj+BF;;AmCj99BE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0CAAA;EACA,mDAAA;EACA,uCAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;ApCok+BF;;AmCl+9BE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,mDAAA;EACA,uCAAA;EACA,2BAAA;EACA,0CAAA;EACA,uDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCql+BF;;AmCn/9BE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,6CAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,wDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;ApCsm+BF;;AmCpg+BE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCun+BF;;AmC3/9BE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC+m+BF;;AmC5g+BE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCgo+BF;;AmC7h+BE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCip+BF;;AmC9i+BE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCkq+BF;;AmC/j+BE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCmr+BF;;AmChl+BE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCos+BF;;AmCjm+BE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCqt+BF;;AmCln+BE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCsu+BF;;AmCvn+BA;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,8CAAA;EACA,wCAAA;EACA,+CAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,qBzBmHgB;AVsg+BlB;AmCpn+BE;EAEE,0BzB+GoB;AVsg+BxB;AmCln+BE;EACE,0BAAA;AnCon+BJ;AmCjn+BE;EACE,gCAAA;AnCmn+BJ;;AmCxm+BA;ECjJE,0BAAA;EACA,wBAAA;E7B8NI,+BALI;E6BvNR,8BAAA;ApC6v+BF;;AmC3m+BA;ECrJE,2BAAA;EACA,0BAAA;E7B8NI,gCALI;E6BvNR,8BAAA;ApCow+BF;;AqCv0+BA;EXgBM,gCWfJ;ArC00+BF;A0Bvz+BM;EWpBN;IXqBQ,gBAAA;E1B0z+BN;AACF;AqC70+BE;EACE,UAAA;ArC+0+BJ;;AqCz0+BE;EACE,aAAA;ArC40+BJ;;AqCx0+BA;EACE,SAAA;EACA,gBAAA;EXDI,6BWEJ;ArC20+BF;A0Bz0+BM;EWLN;IXMQ,gBAAA;E1B40+BN;AACF;AqC90+BE;EACE,QAAA;EACA,YAAA;EXNE,4BWOF;ArCg1+BJ;A0Bn1+BM;EWAJ;IXCM,gBAAA;E1Bs1+BN;AACF;;AsC32+BA;;;;;;EAME,kBAAA;AtC82+BF;;AsC32+BA;EACE,mBAAA;AtC82+BF;;AsCv2+BA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E/BuQI,kCALI;E+BhQR,4BAAA;EACA,sBAAA;EACA,mCAAA;EACA,oCAAA;EACA,+BAAA;EACA,sDAAA;EACA,iCAAA;EACA,sCAAA;EACA,4DAAA;EACA,iCAAA;EACA,wDAAA;EACA,oCAAA;EACA,yEAAA;EACA,qCAAA;EACA,0CAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E/B0OI,uCALI;E+BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E3BzCE,+CAAA;AXi5+BJ;AsCp2+BE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AtCs2+BJ;;AsC90+BI;EACE,oBAAA;AtCi1+BN;AsC/0+BM;EACE,WAAA;EACA,OAAA;AtCi1+BR;;AsC70+BI;EACE,kBAAA;AtCg1+BN;AsC90+BM;EACE,QAAA;EACA,UAAA;AtCg1+BR;;AkB13+BI;EoB4BA;IACE,oBAAA;EtCk2+BJ;EsCh2+BI;IACE,WAAA;IACA,OAAA;EtCk2+BN;EsC91+BE;IACE,kBAAA;EtCg2+BJ;EsC91+BI;IACE,QAAA;IACA,UAAA;EtCg2+BN;AACF;AkB34+BI;EoB4BA;IACE,oBAAA;EtCk3+BJ;EsCh3+BI;IACE,WAAA;IACA,OAAA;EtCk3+BN;EsC92+BE;IACE,kBAAA;EtCg3+BJ;EsC92+BI;IACE,QAAA;IACA,UAAA;EtCg3+BN;AACF;AkB35+BI;EoB4BA;IACE,oBAAA;EtCk4+BJ;EsCh4+BI;IACE,WAAA;IACA,OAAA;EtCk4+BN;EsC93+BE;IACE,kBAAA;EtCg4+BJ;EsC93+BI;IACE,QAAA;IACA,UAAA;EtCg4+BN;AACF;AkB36+BI;EoB4BA;IACE,oBAAA;EtCk5+BJ;EsCh5+BI;IACE,WAAA;IACA,OAAA;EtCk5+BN;EsC94+BE;IACE,kBAAA;EtCg5+BJ;EsC94+BI;IACE,QAAA;IACA,UAAA;EtCg5+BN;AACF;AkB37+BI;EoB4BA;IACE,oBAAA;EtCk6+BJ;EsCh6+BI;IACE,WAAA;IACA,OAAA;EtCk6+BN;EsC95+BE;IACE,kBAAA;EtCg6+BJ;EsC95+BI;IACE,QAAA;IACA,UAAA;EtCg6+BN;AACF;AsCv5+BE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AtCy5+BJ;AsCh5+BE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AtCk5+BJ;AsC74+BI;EACE,iBAAA;AtC+4+BN;;AsCz4+BE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AtC44+BJ;AsCv4+BI;EACE,iBAAA;AtCy4+BN;;AsCl4+BA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AtCq4+BF;;AsC/3+BA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB5B2PmB;E4B1PnB,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;E3BtKE,uDAAA;AXwi/BJ;AsC/3+BE;EAEE,0CAAA;EACA,qBAAA;EX3LF,kDW4LuB;AtCg4+BzB;AsC73+BE;EAEE,2CAAA;EACA,qBAAA;EXlMF,mDWmMuB;AtC83+BzB;AsC33+BE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AtC43+BJ;;AsCt3+BA;EACE,cAAA;AtCy3+BF;;AsCr3+BA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E/BmEI,uBALI;E+B5DR,sCAAA;EACA,mBAAA;AtCw3+BF;;AsCp3+BA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AtCu3+BF;;AsCn3+BA;EAEE,4BAAA;EACA,yBAAA;EACA,mCAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,iCAAA;EACA,sDAAA;EACA,yEAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AtCq3+BF;;AuC3m/BA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AvC8m/BF;AuC5m/BE;;EACE,kBAAA;EACA,cAAA;AvC+m/BJ;AuC1m/BE;;;;;;;;;;;;EAME,UAAA;AvCkn/BJ;;AuC7m/BA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AvCgn/BF;AuC9m/BE;EACE,WAAA;AvCgn/BJ;;AuC5m/BA;E5BhBI,sBAAA;AXgo/BJ;AuC5m/BE;;EAEE,2BAAA;AvC8m/BJ;AuC1m/BE;;;E5BVE,0BAAA;EACA,6BAAA;AXyn/BJ;AuCtm/BE;;;E5BNE,yBAAA;EACA,4BAAA;AXin/BJ;;AuCzl/BA;EACE,wBAAA;EACA,uBAAA;AvC4l/BF;AuC1l/BE;EAGE,cAAA;AvC0l/BJ;AuCvl/BE;EACE,eAAA;AvCyl/BJ;;AuCrl/BA;EACE,uBAAA;EACA,sBAAA;AvCwl/BF;;AuCrl/BA;EACE,sBAAA;EACA,qBAAA;AvCwl/BF;;AuCpk/BA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AvCuk/BF;AuCrk/BE;;EAEE,WAAA;AvCuk/BJ;AuCpk/BE;;EAEE,0BAAA;AvCsk/BJ;AuClk/BE;;E5B1FE,6BAAA;EACA,4BAAA;AXgq/BJ;AuClk/BE;;E5B7GE,yBAAA;EACA,0BAAA;AXmr/BJ;;AwC3s/BA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,qCAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AxC0s/BF;;AwCvs/BA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EAEA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;AxCys/BF;A0Brt/BM;EcGN;IdFQ,gBAAA;E1Bwt/BN;AACF;AwC5s/BE;EAEE,qCAAA;EACA,qBAAA;AxC6s/BJ;AwC1s/BE;EACE,UAAA;EACA,kDZkhBoB;A5B0r+BxB;AwCxs/BE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AxCys/BJ;;AwCjs/BA;EAEE,+BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8DAAA;EACA,wCAAA;EACA,qCAAA;EACA,+DAAA;EAGA,oFAAA;AxCis/BF;AwC/r/BE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AX+u/BJ;AwChs/BI;EAGE,kBAAA;EACA,wDAAA;AxCgs/BN;AwC5r/BE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AxC8r/BJ;AwC3r/BE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AX8v/BJ;;AwCnr/BA;EAEE,qCAAA;EACA,sCAAA;EACA,sCAAA;AxCqr/BF;AwClr/BE;E7B5FE,gDAAA;AXix/BJ;AwCjr/BE;;EAEE,4CAAA;EbjHF,oDakHuB;AxCmr/BzB;;AwC1q/BA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AxC0q/BF;AwCxq/BE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AxC0q/BJ;AwCxq/BI;EAEE,iCAAA;AxCyq/BN;AwCrq/BE;;EAEE,gB9B0Re;E8BzRf,gDAAA;EACA,iCAAA;AxCuq/BJ;;AwC7p/BE;;EAEE,cAAA;EACA,kBAAA;AxCgq/BJ;;AwC3p/BE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AxC8p/BJ;;AwCxp/BE;;EACE,WAAA;AxC4p/BJ;;AwClp/BE;EACE,aAAA;AxCqp/BJ;AwCnp/BE;EACE,cAAA;AxCqp/BJ;;AyCl1/BA;EAEE,2BAAA;EACA,6BAAA;EACA,sCAAA;EACA,2CAAA;EACA,8CAAA;EACA,4CAAA;EACA,0CAAA;EACA,kCAAA;EACA,wCAAA;EACA,2CAAA;EACA,iDAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EACA,qEAAA;EACA,oDAAA;EACA,0CAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AzCk1/BF;AyC50/BE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AzCo1/BJ;AyCh0/BA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EAEA,mBAAA;AzCi0/BF;AyC/z/BE;EAEE,yCAAA;EACA,qBAAA;AzCg0/BJ;;AyCvz/BA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AzCsz/BF;AyCnz/BI;EAEE,oCAAA;AzCoz/BN;AyChz/BE;EACE,gBAAA;AzCkz/BJ;;AyCzy/BA;EACE,mB/B+vBmB;E+B9vBnB,sB/B8vBmB;E+B7vBnB,6BAAA;AzC4y/BF;AyC1y/BE;;;EAGE,oCAAA;AzC4y/BJ;;AyC/x/BA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AzCgy/BF;;AyC5x/BA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;AzC+x/BF;A0Bx6/BM;EeiIN;IfhIQ,gBAAA;E1B26/BN;AACF;AyCly/BE;EACE,qBAAA;AzCoy/BJ;AyCjy/BE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AzCmy/BJ;;AyC7x/BA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AzCgy/BF;;AyC7x/BA;EACE,yCAAA;EACA,gBAAA;AzCgy/BF;;AkB15/BI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EzCux/BN;EyCrx/BM;IACE,mBAAA;EzCux/BR;EyCrx/BQ;IACE,kBAAA;EzCux/BV;EyCpx/BQ;IACE,kDAAA;IACA,iDAAA;EzCsx/BV;EyClx/BM;IACE,iBAAA;EzCox/BR;EyCjx/BM;IACE,wBAAA;IACA,gBAAA;EzCmx/BR;EyChx/BM;IACE,aAAA;EzCkx/BR;EyC/w/BM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EzC+w/BR;EyC5w/BQ;IACE,aAAA;EzC8w/BV;EyC3w/BQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzC6w/BV;AACF;AkB18/BI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EzCs0/BN;EyCp0/BM;IACE,mBAAA;EzCs0/BR;EyCp0/BQ;IACE,kBAAA;EzCs0/BV;EyCn0/BQ;IACE,kDAAA;IACA,iDAAA;EzCq0/BV;EyCj0/BM;IACE,iBAAA;EzCm0/BR;EyCh0/BM;IACE,wBAAA;IACA,gBAAA;EzCk0/BR;EyC/z/BM;IACE,aAAA;EzCi0/BR;EyC9z/BM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EzC8z/BR;EyC3z/BQ;IACE,aAAA;EzC6z/BV;EyC1z/BQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzC4z/BV;AACF;AkBz//BI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EzCq3/BN;EyCn3/BM;IACE,mBAAA;EzCq3/BR;EyCn3/BQ;IACE,kBAAA;EzCq3/BV;EyCl3/BQ;IACE,kDAAA;IACA,iDAAA;EzCo3/BV;EyCh3/BM;IACE,iBAAA;EzCk3/BR;EyC/2/BM;IACE,wBAAA;IACA,gBAAA;EzCi3/BR;EyC92/BM;IACE,aAAA;EzCg3/BR;EyC72/BM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EzC62/BR;EyC12/BQ;IACE,aAAA;EzC42/BV;EyCz2/BQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzC22/BV;AACF;AkBxigCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EzCo6/BN;EyCl6/BM;IACE,mBAAA;EzCo6/BR;EyCl6/BQ;IACE,kBAAA;EzCo6/BV;EyCj6/BQ;IACE,kDAAA;IACA,iDAAA;EzCm6/BV;EyC/5/BM;IACE,iBAAA;EzCi6/BR;EyC95/BM;IACE,wBAAA;IACA,gBAAA;EzCg6/BR;EyC75/BM;IACE,aAAA;EzC+5/BR;EyC55/BM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EzC45/BR;EyCz5/BQ;IACE,aAAA;EzC25/BV;EyCx5/BQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzC05/BV;AACF;AkBvlgCI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EzCm9/BN;EyCj9/BM;IACE,mBAAA;EzCm9/BR;EyCj9/BQ;IACE,kBAAA;EzCm9/BV;EyCh9/BQ;IACE,kDAAA;IACA,iDAAA;EzCk9/BV;EyC98/BM;IACE,iBAAA;EzCg9/BR;EyC78/BM;IACE,wBAAA;IACA,gBAAA;EzC+8/BR;EyC58/BM;IACE,aAAA;EzC88/BR;EyC38/BM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EzC28/BR;EyCx8/BQ;IACE,aAAA;EzC08/BV;EyCv8/BQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzCy8/BV;AACF;AyChggCI;EAEI,iBAAA;EACA,2BAAA;AzCiggCR;AyC///BQ;EACE,mBAAA;AzCiggCV;AyC///BU;EACE,kBAAA;AzCiggCZ;AyC9//BU;EACE,kDAAA;EACA,iDAAA;AzCgggCZ;AyC5//BQ;EACE,iBAAA;AzC8//BV;AyC3//BQ;EACE,wBAAA;EACA,gBAAA;AzC6//BV;AyC1//BQ;EACE,aAAA;AzC4//BV;AyCz//BQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AzCy//BV;AyCt//BU;EACE,aAAA;AzCw//BZ;AyCr//BU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AzCu//BZ;;AyCt+/BA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AzCw+/BF;;AyCl+/BI;EACE,qEAAA;AzCq+/BN;;A0C9vgCA;EAEE,2BAAA;EACA,2BAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;EACA,gCAAA;EACA,sBAAA;EACA,sCAAA;EACA,gCAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,4BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;AXgxgCJ;A0C3vgCE;EACE,eAAA;EACA,cAAA;A1C6vgCJ;A0C1vgCE;EACE,mBAAA;EACA,sBAAA;A1C4vgCJ;A0C1vgCI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AXmxgCJ;A0C1vgCI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AX0wgCJ;A0CvvgCE;;EAEE,aAAA;A1CyvgCJ;;A0CrvgCA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;A1CsvgCF;;A0CnvgCA;EACE,4CAAA;EACA,iCAAA;A1CsvgCF;;A0CnvgCA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;A1CsvgCF;;A0CnvgCA;EACE,gBAAA;A1CsvgCF;;A0ClvgCE;EACE,qBAAA;A1CqvgCJ;A0ClvgCE;EACE,oCAAA;A1CovgCJ;;A0C5ugCA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;A1C+ugCF;A0C7ugCE;E/B7FE,wFAAA;AX60gCJ;;A0C3ugCA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;A1C8ugCF;A0C5ugCE;E/BxGE,wFAAA;AXu1gCJ;;A0CrugCA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;A1CwugCF;A0CtugCE;EACE,mCAAA;EACA,sCAAA;A1CwugCJ;;A0CpugCA;EACE,uDAAA;EACA,sDAAA;A1CuugCF;;A0CnugCA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AXi3gCJ;;A0CnugCA;;;EAGE,WAAA;A1CsugCF;;A0CnugCA;;E/B3II,0DAAA;EACA,2DAAA;AXm3gCJ;;A0CpugCA;;E/BlII,8DAAA;EACA,6DAAA;AX22gCJ;;A0C7tgCE;EACE,0CAAA;A1CgugCJ;AkB31gCI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;E1CgugCF;E0C7tgCE;IAEE,SAAA;IACA,gBAAA;E1C8tgCJ;E0C5tgCI;IACE,cAAA;IACA,cAAA;E1C8tgCN;E0CztgCM;I/B3KJ,0BAAA;IACA,6BAAA;EXu4gCF;E0C1tgCQ;;IAGE,0BAAA;E1C2tgCV;E0CztgCQ;;IAGE,6BAAA;E1C0tgCV;E0CttgCM;I/B5KJ,yBAAA;IACA,4BAAA;EXq4gCF;E0CvtgCQ;;IAGE,yBAAA;E1CwtgCV;E0CttgCQ;;IAGE,4BAAA;E1CutgCV;AACF;;A2C57gCA;EAEE,6BAAA;EACA,uBAAA;EACA,8KAAA;EACA,oCAAA;EACA,8BAAA;EACA,qCAAA;EACA,4FAAA;EACA,qCAAA;EACA,qCAAA;EACA,iCAAA;EACA,8BAAA;EACA,iEAAA;EACA,sCAAA;EACA,iDAAA;EACA,8DAAA;EACA,wEAAA;EACA,yCAAA;EACA,sCAAA;EACA,sCAAA;EACA,oCAAA;EACA,iCAAA;A3C87gCF;;A2C17gCA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,oBALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;A3C67gCF;A0Bp9gCM;EiBUN;IjBTQ,gBAAA;E1Bu9gCN;AACF;A2Ch8gCE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;A3Ck8gCJ;A2Ch8gCI;EACE,qDAAA;EACA,iDAAA;A3Ck8gCN;A2C77gCE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;A3C+7gCJ;A0B7+gCM;EiBqCJ;IjBpCM,gBAAA;E1Bg/gCN;AACF;A2Cj8gCE;EACE,UAAA;A3Cm8gCJ;A2Ch8gCE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;A3Ck8gCJ;;A2C97gCA;EACE,gBAAA;A3Ci8gCF;;A2C97gCA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;A3Ci8gCF;A2C/7gCE;EhC7DE,yDAAA;EACA,0DAAA;AX+/gCJ;A2Ch8gCI;EhChEA,+DAAA;EACA,gEAAA;AXmghCJ;A2C/7gCE;EACE,aAAA;A3Ci8gCJ;A2C77gCE;EhC5DE,6DAAA;EACA,4DAAA;AX4/gCJ;A2C77gCM;EhChEF,mEAAA;EACA,kEAAA;AXgghCJ;A2C57gCI;EhCrEA,6DAAA;EACA,4DAAA;AXoghCJ;;A2C17gCA;EACE,8EAAA;A3C67gCF;;A2Cp7gCE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;AXsihCJ;A2Cr7gCI;EAAgB,aAAA;A3Cw7gCpB;A2Cv7gCI;EAAe,gBAAA;A3C07gCnB;A2Ct7gCM;EhCtHF,gBAAA;AX+ihCJ;A2Cl7gCI;EhC7HA,gBAAA;AXkjhCJ;;A2C76gCI;EACE,iEAAA;EACA,wEAAA;A3Cg7gCN;;A4C1khCA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AX0khCJ;;A4CpkhCE;EACE,iDAAA;A5CukhCJ;A4CrkhCI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A5CukhCN;A4CnkhCE;EACE,6CAAA;A5CqkhCJ;;A6C1mhCA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,8BAAA;EACA,wBAAA;EACA,iCAAA;EACA,qCAAA;EACA,sCAAA;EACA,qDAAA;EACA,iCAAA;EACA,2CAAA;EACA,qDAAA;EACA,iCAAA;EACA,yEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,uCAAA;EACA,iCAAA;EACA,8CAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;Ab+nhCF;;A6CxmhCA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EAEA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A7C0mhCF;A0B3nhCM;EmBQN;InBPQ,gBAAA;E1B8nhCN;AACF;A6C7mhCE;EACE,UAAA;EACA,uCAAA;EACA,qBAAA;EACA,+CAAA;EACA,qDAAA;A7C+mhCJ;A6C5mhCE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnCs8BuB;EmCr8BvB,iDAAA;A7C8mhCJ;A6C3mhCE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A7C4mhCJ;A6CzmhCE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A7C0mhCJ;;A6CrmhCE;EACE,iBnCy6BsB;AV+r/B1B;A6CvlhCI;ElCxEA,iDAAA;AXkqhCJ;;A6C/khCA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,sCALI;EuCnRR,yDAAA;A9CqrhCF;;A6CllhCA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,uCALI;EuCnRR,yDAAA;A9C4rhCF;;A+C9rhCA;EAEE,2BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iCAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;AXmshCJ;A+C1rhCE;EACE,aAAA;A/C4rhCJ;;A+CvrhCA;EACE,kBAAA;EACA,SAAA;A/C0rhCF;;AgD1thCA;EAEE,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yDAAA;EACA,iCAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AX8thCJ;;AgDtthCA;EAEE,cAAA;AhDwthCF;;AgDpthCA;EACE,gBtC6YiB;EsC5YjB,iCAAA;AhDuthCF;;AgD/shCA;EACE,sBtCiqC4B;AVij/B9B;AgD/shCE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;AhDithCJ;;AgDzshCE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AhD4shCJ;;AgDhthCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;AhDmthCJ;;AgDvthCE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AhD0thCJ;;AgD9thCE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AhDiuhCJ;;AgDruhCE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AhDwuhCJ;;AgD5uhCE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AhD+uhCJ;;AgDnvhCE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;AhDsvhCJ;;AgD1vhCE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AhD6vhCJ;;AiDzzhCE;EACE;IAAK,2BvC4sCS;EVin/BhB;AACF;AiDzzhCA;;EAGE,0BAAA;E1CkRI,oCALI;E0C3QR,yBAAA;EACA,oCAAA;EACA,8DAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;AXi0hCJ;;AiDpzhCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;AjDuzhCF;A0B50hCM;EuBYN;IvBXQ,gBAAA;E1B+0hCN;AACF;;AiDzzhCA;EtBAE,qMAAA;EsBEA,oEAAA;AjD4zhCF;;AiDzzhCA;EACE,iBAAA;AjD4zhCF;;AiDzzhCA;EACE,WAAA;AjD4zhCF;;AiDxzhCE;EACE,kDAAA;AjD2zhCJ;AiDxzhCM;EAJJ;IAKM,eAAA;EjD2zhCN;AACF;;AkDv3hCA;EAEE,2CAAA;EACA,wBAAA;EACA,kDAAA;EACA,iCAAA;EACA,sCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,2CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EACA,uCAAA;EACA,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AXi4hCJ;;AkDl3hCA;EACE,qBAAA;EACA,sBAAA;AlDq3hCF;AkDn3hCE;EAEE,oCAAA;EACA,0BAAA;AlDo3hCJ;;AkD32hCA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AlD82hCF;AkD32hCE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AlD42hCJ;AkDz2hCE;EACE,+CAAA;EACA,uDAAA;AlD22hCJ;;AkDn2hCA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;AlDq2hCF;AkDn2hCE;EvCvDE,+BAAA;EACA,gCAAA;AX65hCJ;AkDn2hCE;EvC7CE,mCAAA;EACA,kCAAA;AXm5hCJ;AkDn2hCE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AlDo2hCJ;AkDh2hCE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AlDk2hCJ;AkD91hCE;EACE,mBAAA;AlDg2hCJ;AkD91hCI;EACE,wDAAA;EACA,mDAAA;AlDg2hCN;;AkDn1hCI;EACE,mBAAA;AlDs1hCN;AkDn1hCQ;EvCvDJ,6DAAA;EAZA,0BAAA;AX05hCJ;AkDl1hCQ;EvCxEJ,2DAAA;EAYA,4BAAA;AXk5hCJ;AkDj1hCQ;EACE,aAAA;AlDm1hCV;AkDh1hCQ;EACE,mDAAA;EACA,oBAAA;AlDk1hCV;AkDh1hCU;EACE,yDAAA;EACA,oDAAA;AlDk1hCZ;;AkBx6hCI;EgC8DA;IACE,mBAAA;ElD82hCJ;EkD32hCM;IvCvDJ,6DAAA;IAZA,0BAAA;EXk7hCF;EkD12hCM;IvCxEJ,2DAAA;IAYA,4BAAA;EX06hCF;EkDz2hCM;IACE,aAAA;ElD22hCR;EkDx2hCM;IACE,mDAAA;IACA,oBAAA;ElD02hCR;EkDx2hCQ;IACE,yDAAA;IACA,oDAAA;ElD02hCV;AACF;AkBj8hCI;EgC8DA;IACE,mBAAA;ElDs4hCJ;EkDn4hCM;IvCvDJ,6DAAA;IAZA,0BAAA;EX08hCF;EkDl4hCM;IvCxEJ,2DAAA;IAYA,4BAAA;EXk8hCF;EkDj4hCM;IACE,aAAA;ElDm4hCR;EkDh4hCM;IACE,mDAAA;IACA,oBAAA;ElDk4hCR;EkDh4hCQ;IACE,yDAAA;IACA,oDAAA;ElDk4hCV;AACF;AkBz9hCI;EgC8DA;IACE,mBAAA;ElD85hCJ;EkD35hCM;IvCvDJ,6DAAA;IAZA,0BAAA;EXk+hCF;EkD15hCM;IvCxEJ,2DAAA;IAYA,4BAAA;EX09hCF;EkDz5hCM;IACE,aAAA;ElD25hCR;EkDx5hCM;IACE,mDAAA;IACA,oBAAA;ElD05hCR;EkDx5hCQ;IACE,yDAAA;IACA,oDAAA;ElD05hCV;AACF;AkBj/hCI;EgC8DA;IACE,mBAAA;ElDs7hCJ;EkDn7hCM;IvCvDJ,6DAAA;IAZA,0BAAA;EX0/hCF;EkDl7hCM;IvCxEJ,2DAAA;IAYA,4BAAA;EXk/hCF;EkDj7hCM;IACE,aAAA;ElDm7hCR;EkDh7hCM;IACE,mDAAA;IACA,oBAAA;ElDk7hCR;EkDh7hCQ;IACE,yDAAA;IACA,oDAAA;ElDk7hCV;AACF;AkBzgiCI;EgC8DA;IACE,mBAAA;ElD88hCJ;EkD38hCM;IvCvDJ,6DAAA;IAZA,0BAAA;EXkhiCF;EkD18hCM;IvCxEJ,2DAAA;IAYA,4BAAA;EX0giCF;EkDz8hCM;IACE,aAAA;ElD28hCR;EkDx8hCM;IACE,mDAAA;IACA,oBAAA;ElD08hCR;EkDx8hCQ;IACE,yDAAA;IACA,oDAAA;ElD08hCV;AACF;AkD77hCA;EvChJI,gBAAA;AXgliCJ;AkD77hCE;EACE,mDAAA;AlD+7hCJ;AkD77hCI;EACE,sBAAA;AlD+7hCN;;AkDl7hCE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AlDq7hCJ;;AkD/7hCE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AlDk8hCJ;;AkD58hCE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AlD+8hCJ;;AkDz9hCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AlD49hCJ;;AkDt+hCE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AlDy+hCJ;;AkDn/hCE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AlDs/hCJ;;AkDhgiCE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AlDmgiCJ;;AkD7giCE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AlDghiCJ;;AmD5siCA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,iCAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,YzC+yCgB;EyC9yChB,azC8yCgB;EyC7yChB,sBAAA;EACA,gCAAA;EACA,0EAAA;EACA,SAAA;ExCJE,sBAAA;EwCMF,oCAAA;AnD4siCF;AmDzsiCE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AnD2siCJ;AmDxsiCE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AnD0siCJ;AmDvsiCE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AnDwsiCJ;;AmDhsiCA;EAHE,wCAAA;AnDusiCF;;AmD9riCI;EATF,wCAAA;AnD2siCF;;AoD5viCA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,2CAAA;EACA,iCAAA;EACA,uDAAA;EACA,gCAAA;EACA,+CAAA;EACA,mDAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;AXqwiCJ;AoD1viCE;EACE,UAAA;ApD4viCJ;AoDzviCE;EACE,aAAA;ApD2viCJ;;AoDvviCA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;ApDyviCF;AoDvviCE;EACE,sCAAA;ApDyviCJ;;AoDrviCA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;AXyxiCJ;AoDvviCE;EACE,oDAAA;EACA,sCAAA;ApDyviCJ;;AoDrviCA;EACE,kCAAA;EACA,qBAAA;ApDwviCF;;AqDtziCA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,8DAAA;EACA,kDAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,uCAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,uCAAA;EACA,mCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;ArDoziCF;;AqD7yiCA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;ArD+yiCF;AqD5yiCE;E3B5CI,mC2B6CF;EACA,8B3C2nCmB;AVmrgCvB;A0Bx1iCM;E2BwCJ;I3BvCM,gBAAA;E1B21iCN;AACF;AqDjziCE;EACE,e3CynCmB;AV0rgCvB;AqD/yiCE;EACE,sB3CsnCoB;AV2rgCxB;;AqD7yiCA;EACE,+CAAA;ArDgziCF;AqD9yiCE;EACE,gBAAA;EACA,gBAAA;ArDgziCJ;AqD7yiCE;EACE,gBAAA;ArD+yiCJ;;AqD3yiCA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;ArD8yiCF;;AqD1yiCA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;ArD0yiCF;;AqDtyiCA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;ArD4yiC9D;AsDx5iCE;EAAS,UAAA;AtD25iCX;AsD15iCE;EAAS,mCD2GiF;ArDkziC5F;;AqD7yiCA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;AXs5iCJ;AqD/yiCE;EACE,kGAAA;EACA,sJAAA;ArDiziCJ;;AqD5yiCA;EACE,gBAAA;EACA,8CAAA;ArD+yiCF;;AqD1yiCA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;ArD2yiCF;;AqDvyiCA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1CzHE,+DAAA;EACA,8DAAA;AXo6iCJ;AqDtyiCE;EACE,8CAAA;ArDwyiCJ;;AkBn5iCI;EmCiHF;IACE,0BAAA;IACA,uDAAA;ErDsyiCF;EqDlyiCA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ErDoyiCF;EqDjyiCA;IACE,uBAAA;ErDmyiCF;AACF;AkBl6iCI;EmCmIF;;IAEE,uBAAA;ErDkyiCF;AACF;AkBx6iCI;EmC0IF;IACE,wBAAA;ErDiyiCF;AACF;AqDxxiCI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;ArD0xiCN;AqDxxiCM;EACE,YAAA;EACA,SAAA;E1CzMJ,gBAAA;AXo+iCJ;AqDvxiCM;;E1C7MF,gBAAA;AXw+iCJ;AqDtxiCM;EACE,gBAAA;ArDwxiCR;;AkBl7iCI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErD8yiCJ;EqD5yiCI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EXw/iCF;EqD3yiCI;;I1C7MF,gBAAA;EX4/iCF;EqD1yiCI;IACE,gBAAA;ErD4yiCN;AACF;AkBv8iCI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDk0iCJ;EqDh0iCI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EX4gjCF;EqD/ziCI;;I1C7MF,gBAAA;EXghjCF;EqD9ziCI;IACE,gBAAA;ErDg0iCN;AACF;AkB39iCI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDs1iCJ;EqDp1iCI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EXgijCF;EqDn1iCI;;I1C7MF,gBAAA;EXoijCF;EqDl1iCI;IACE,gBAAA;ErDo1iCN;AACF;AkB/+iCI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErD02iCJ;EqDx2iCI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EXojjCF;EqDv2iCI;;I1C7MF,gBAAA;EXwjjCF;EqDt2iCI;IACE,gBAAA;ErDw2iCN;AACF;AkBngjCI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErD83iCJ;EqD53iCI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EXwkjCF;EqD33iCI;;I1C7MF,gBAAA;EX4kjCF;EqD13iCI;IACE,gBAAA;ErD43iCN;AACF;AuDlmjCA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,sBAAA;EhDwRI,oCALI;EgDjRR,wBAAA;EACA,qBAAA;EACA,mCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C6ZuB;E8C3ZvB,kBAAA;EACA,gB9C0amB;E8CzanB,gB9C+aiB;E8C9ajB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AvD0mjCF;AuDxmjCE;EAAS,kCAAA;AvD2mjCX;AuDzmjCE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AvD2mjCJ;AuDzmjCI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AvD2mjCN;;AuDtmjCA;EACE,iDAAA;AvDymjCF;AuDvmjCE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AvDymjCJ;;AuDrmjCA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AvDwmjCF;AuDtmjCE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AvDwmjCJ;;AuDpmjCA,mBAAA;AAEA;EACE,8CAAA;AvDsmjCF;AuDpmjCE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AvDsmjCJ;;AuDlmjCA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AvDqmjCF;AuDnmjCE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AvDqmjCJ;;AuDjmjCA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;AXqrjCJ;;AyDxsjCA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,oCALI;EkDrRR,qBAAA;EACA,8BAAA;EACA,6CAAA;EACA,kCAAA;EACA,oDAAA;EACA,yDAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,gDAAA;EACA,iCAAA;EACA,iCAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C6ZuB;E8C3ZvB,kBAAA;EACA,gB9C0amB;E8CzanB,gB9C+aiB;E8C9ajB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;AXmujCJ;AyD/sjCE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AzDitjCJ;AyD/sjCI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AzDgtjCN;;AyD1sjCE;EACE,oFAAA;AzD6sjCJ;AyD3sjCI;EAEE,wFAAA;AzD4sjCN;AyDzsjCI;EACE,SAAA;EACA,gDAAA;AzD2sjCN;AyDxsjCI;EACE,sCAAA;EACA,sCAAA;AzD0sjCN;;AyDrsjCA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AzDusjCJ;AyDrsjCI;EAEE,kIAAA;AzDssjCN;AyDnsjCI;EACE,OAAA;EACA,kDAAA;AzDqsjCN;AyDlsjCI;EACE,oCAAA;EACA,wCAAA;AzDosjCN;;AyD/rjCA,mBAAA;AAGE;EACE,iFAAA;AzDgsjCJ;AyD9rjCI;EAEE,wFAAA;AzD+rjCN;AyD5rjCI;EACE,MAAA;EACA,mDAAA;AzD8rjCN;AyD3rjCI;EACE,mCAAA;EACA,yCAAA;AzD6rjCN;AyDxrjCE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AzD0rjCJ;;AyDtrjCA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AzDwrjCJ;AyDtrjCI;EAEE,kIAAA;AzDurjCN;AyDprjCI;EACE,QAAA;EACA,iDAAA;AzDsrjCN;AyDnrjCI;EACE,qCAAA;EACA,uCAAA;AzDqrjCN;;AyDhrjCA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AX+zjCJ;AyDjqjCE;EACE,aAAA;AzDmqjCJ;;AyD/pjCA;EACE,0EAAA;EACA,mCAAA;AzDkqjCF;;A0Dv1jCA;EACE,kBAAA;A1D01jCF;;A0Dv1jCA;EACE,mBAAA;A1D01jCF;;A0Dv1jCA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A1D01jCF;A2Dh3jCE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A3Dk3jCJ;;A0D31jCA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;A1D81jCF;A0B72jCM;EgCQN;IhCPQ,gBAAA;E1Bg3jCN;AACF;;A0Dh2jCA;;;EAGE,cAAA;A1Dm2jCF;;A0Dh2jCA;;EAEE,2BAAA;A1Dm2jCF;;A0Dh2jCA;;EAEE,4BAAA;A1Dm2jCF;;A0D11jCE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A1D61jCJ;A0D11jCE;;;EAGE,UAAA;EACA,UAAA;A1D41jCJ;A0Dz1jCE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;A1D21jCJ;A0Bp5jCM;EgCqDJ;;IhCpDM,gBAAA;E1Bw5jCN;AACF;;A0Dx1jCA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDqrCuB;EgDprCvB,UAAA;EACA,WhD5DM;EgD6DN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhDgrCyB;EgBtwCrB,8BgCuFJ;A1D01jCF;A0B76jCM;EgCkEN;;IhCjEQ,gBAAA;E1Bi7jCN;AACF;A0D71jCE;;;EAEE,WhDtEI;EgDuEJ,qBAAA;EACA,UAAA;EACA,YhDwqC6B;AVwrhCjC;;A0D71jCA;EACE,OAAA;A1Dg2jCF;;A0D71jCA;EACE,QAAA;A1Dg2jCF;;A0D31jCA;;EAEE,qBAAA;EACA,WhDyqC4B;EgDxqC5B,YhDwqC4B;EgDvqC5B,4BAAA;EACA,wBAAA;EACA,0BAAA;A1D81jCF;;A0D31jCA;EACE,2TAAA;A1D81jCF;;A0D51jCA;EACE,0TAAA;A1D+1jCF;;A0Dv1jCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDynCuB;EgDxnCvB,mBAAA;EACA,gBhDunCuB;AVkuhCzB;A0Dv1jCE;EACE,uBAAA;EACA,cAAA;EACA,WhDunCuB;EgDtnCvB,WhDunCwB;EgDtnCxB,UAAA;EACA,iBhDunCwB;EgDtnCxB,gBhDsnCwB;EgDrnCxB,mBAAA;EACA,eAAA;EACA,sBhDpII;EgDqIJ,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD8mCyB;EgB9wCvB,6BgCiKF;A1Dw1jCJ;A0Br/jCM;EgC4IJ;IhC3IM,gBAAA;E1Bw/jCN;AACF;A0D11jCE;EACE,UhD2mCgC;AVivhCpC;;A0Dn1jCA;EACE,kBAAA;EACA,UAAA;EACA,ehDqmCwB;EgDpmCxB,SAAA;EACA,oBhDkmC2B;EgDjmC3B,uBhDimC2B;EgDhmC3B,WhD/JM;EgDgKN,kBAAA;A1Ds1jCF;;A0Dh1jCE;;EAEE,gChDomCgC;AV+uhCpC;A0Dh1jCE;EACE,sBhDlKI;AVo/jCR;A0D/0jCE;EACE,WhDtKI;AVu/jCR;;A0D31jCE;;;EAEE,gChDomCgC;AV2vhCpC;A0D51jCE;EACE,sBhDlKI;AVggkCR;A0D31jCE;EACE,WhDtKI;AVmgkCR;;A4D/ikCA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A5DijkCF;;A4D7ikCA;EACE;IAAK,0CAAA;E5DijkCL;AACF;A4D9ikCA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A5D6ikCF;;A4D1ikCA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A5D4ikCF;;A4DnikCA;EACE;IACE,mBAAA;E5DsikCF;E4DpikCA;IACE,UAAA;IACA,eAAA;E5DsikCF;AACF;A4DlikCA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A5DiikCF;;A4D9hkCA;EACE,wBAAA;EACA,yBAAA;A5DiikCF;;A4D7hkCE;EACE;;IAEE,kCAAA;E5DgikCJ;AACF;A6DhnkCA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;A7DinkCF;;AkBpjkCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E7DkmkCJ;AACF;A0B7nkCM;EmCYJ;InCXM,gBAAA;E1BgokCN;AACF;AkB1kkCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E7DymkCN;E6DtmkCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E7DwmkCN;E6DrmkCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E7DumkCN;E6DpmkCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E7DsmkCN;E6DnmkCI;IAEE,eAAA;E7DomkCN;E6DjmkCI;IAGE,mBAAA;E7DimkCN;AACF;AkB9nkCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E7DgmkCN;E6D9lkCM;IACE,aAAA;E7DgmkCR;E6D7lkCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7D8lkCR;AACF;;AkBlokCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E7DgrkCJ;AACF;A0B3skCM;EmCYJ;InCXM,gBAAA;E1B8skCN;AACF;AkBxpkCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E7DurkCN;E6DprkCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E7DsrkCN;E6DnrkCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E7DqrkCN;E6DlrkCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E7DorkCN;E6DjrkCI;IAEE,eAAA;E7DkrkCN;E6D/qkCI;IAGE,mBAAA;E7D+qkCN;AACF;AkB5skCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E7D8qkCN;E6D5qkCM;IACE,aAAA;E7D8qkCR;E6D3qkCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7D4qkCR;AACF;;AkBhtkCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E7D8vkCJ;AACF;A0BzxkCM;EmCYJ;InCXM,gBAAA;E1B4xkCN;AACF;AkBtukCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E7DqwkCN;E6DlwkCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E7DowkCN;E6DjwkCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E7DmwkCN;E6DhwkCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E7DkwkCN;E6D/vkCI;IAEE,eAAA;E7DgwkCN;E6D7vkCI;IAGE,mBAAA;E7D6vkCN;AACF;AkB1xkCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E7D4vkCN;E6D1vkCM;IACE,aAAA;E7D4vkCR;E6DzvkCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7D0vkCR;AACF;;AkB9xkCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E7D40kCJ;AACF;A0Bv2kCM;EmCYJ;InCXM,gBAAA;E1B02kCN;AACF;AkBpzkCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E7Dm1kCN;E6Dh1kCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E7Dk1kCN;E6D/0kCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E7Di1kCN;E6D90kCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E7Dg1kCN;E6D70kCI;IAEE,eAAA;E7D80kCN;E6D30kCI;IAGE,mBAAA;E7D20kCN;AACF;AkBx2kCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E7D00kCN;E6Dx0kCM;IACE,aAAA;E7D00kCR;E6Dv0kCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7Dw0kCR;AACF;;AkB52kCI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E7D05kCJ;AACF;A0Br7kCM;EmCYJ;InCXM,gBAAA;E1Bw7kCN;AACF;AkBl4kCI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E7Di6kCN;E6D95kCI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E7Dg6kCN;E6D75kCI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E7D+5kCN;E6D55kCI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E7D85kCN;E6D35kCI;IAEE,eAAA;E7D45kCN;E6Dz5kCI;IAGE,mBAAA;E7Dy5kCN;AACF;AkBt7kCI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E7Dw5kCN;E6Dt5kCM;IACE,aAAA;E7Dw5kCR;E6Dr5kCM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7Ds5kCR;AACF;;A6Dt+kCE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A7Du+kCN;A0BjglCM;EmCYJ;InCXM,gBAAA;E1BoglCN;AACF;A6D1+kCM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A7D4+kCR;A6Dz+kCM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A7D2+kCR;A6Dx+kCM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A7D0+kCR;A6Dv+kCM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A7Dy+kCR;A6Dt+kCM;EAEE,eAAA;A7Du+kCR;A6Dp+kCM;EAGE,mBAAA;A7Do+kCR;;A6Dz8kCA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a1B0mCkC;E0BzmClC,YAAA;EACA,aAAA;EACA,sB1BUS;A5BujlCX;AsD9jlCE;EAAS,UAAA;AtDiklCX;AsDhklCE;EAAS,Y1Bm+CyB;A5BgmiCpC;;A6Dr9kCA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A7Dw9kCF;A6Dt9kCE;EACE,4FAAA;EACA,6IAAA;A7Dw9kCJ;;A6Dp9kCA;EACE,gBAAA;EACA,kDAAA;A7Du9kCF;;A6Dp9kCA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A7Du9kCF;;A8DpmlCA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YlCgzCkC;A5BuziCpC;A8DrmlCE;EACE,qBAAA;EACA,WAAA;A9DumlCJ;;A8DlmlCA;EACE,iBAAA;A9DqmlCF;;A8DlmlCA;EACE,iBAAA;A9DqmlCF;;A8DlmlCA;EACE,iBAAA;A9DqmlCF;;A8DhmlCE;EACE,mDAAA;A9DmmlCJ;;A8D/llCA;EACE;IACE,YlCmxCgC;E5B+0iClC;AACF;A8D/llCA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A9DimlCF;;A8D9llCA;EACE;IACE,uBAAA;E9DimlCF;AACF;A2DhplCE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A3DkplCJ;;A+DrplCE;EACE,sBAAA;EACA,iFAAA;A/DwplCJ;;A+D1plCE;EACE,sBAAA;EACA,mFAAA;A/D6plCJ;;A+D/plCE;EACE,sBAAA;EACA,iFAAA;A/DkqlCJ;;A+DpqlCE;EACE,sBAAA;EACA,8EAAA;A/DuqlCJ;;A+DzqlCE;EACE,yBAAA;EACA,iFAAA;A/D4qlCJ;;A+D9qlCE;EACE,sBAAA;EACA,gFAAA;A/DirlCJ;;A+DnrlCE;EACE,yBAAA;EACA,+EAAA;A/DsrlCJ;;A+DxrlCE;EACE,sBAAA;EACA,8EAAA;A/D2rlCJ;;AgE7rlCE;EACE,wEAAA;EACA,kGAAA;AhEgslCJ;AgE7rlCM;EAGE,8DAAA;EACA,wFAAA;AhE6rlCR;;AgEtslCE;EACE,0EAAA;EACA,oGAAA;AhEyslCJ;AgEtslCM;EAGE,gEAAA;EACA,0FAAA;AhEsslCR;;AgE/slCE;EACE,wEAAA;EACA,kGAAA;AhEktlCJ;AgE/slCM;EAGE,8DAAA;EACA,wFAAA;AhE+slCR;;AgExtlCE;EACE,qEAAA;EACA,+FAAA;AhE2tlCJ;AgExtlCM;EAGE,+DAAA;EACA,yFAAA;AhEwtlCR;;AgEjulCE;EACE,wEAAA;EACA,kGAAA;AhEoulCJ;AgEjulCM;EAGE,gEAAA;EACA,0FAAA;AhEiulCR;;AgE1ulCE;EACE,uEAAA;EACA,iGAAA;AhE6ulCJ;AgE1ulCM;EAGE,8DAAA;EACA,wFAAA;AhE0ulCR;;AgEnvlCE;EACE,sEAAA;EACA,gGAAA;AhEsvlCJ;AgEnvlCM;EAGE,gEAAA;EACA,0FAAA;AhEmvlCR;;AgE5vlCE;EACE,qEAAA;EACA,+FAAA;AhE+vlCJ;AgE5vlCM;EAGE,6DAAA;EACA,uFAAA;AhE4vlCR;;AgErvlCA;EACE,+EAAA;EACA,yGAAA;AhEwvlCF;AgErvlCI;EAEE,kFAAA;EACA,4GAAA;AhEsvlCN;;AiEhxlCA;EACE,UAAA;EAEA,kJAAA;AjEkxlCF;;AkErxlCA;EACE,oBAAA;EACA,atC6c4B;EsC5c5B,mBAAA;EACA,kFAAA;EACA,6BtC2c4B;EsC1c5B,2BAAA;AlEwxlCF;AkEtxlCE;EACE,cAAA;EACA,UtCuc0B;EsCtc1B,WtCsc0B;EsCrc1B,kBAAA;ExCIE,sCwCHF;AlEwxlCJ;A0BjxlCM;EwCZJ;IxCaM,gBAAA;E1BoxlCN;AACF;;AkEtxlCI;EACE,mEAAA;AlEyxlCN;;AmE5ylCA;EACE,kBAAA;EACA,WAAA;AnE+ylCF;AmE7ylCE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AnE+ylCJ;AmE5ylCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AnE8ylCJ;;AmEzylCE;EACE,uBAAA;AnE4ylCJ;;AmE7ylCE;EACE,sBAAA;AnEgzlCJ;;AmEjzlCE;EACE,yBAAA;AnEozlCJ;;AmErzlCE;EACE,iCAAA;AnEwzlCJ;;AoE70lCA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1Du2Ba;AVy+jCf;;AoE70lCA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+1Ba;AVi/jCf;;AoEx0lCI;EACE,gBAAA;EACA,MAAA;EACA,a1Dm1BU;AVw/jChB;;AoEx0lCI;EACE,gBAAA;EACA,SAAA;EACA,a1D60BU;AV8/jChB;;AkB5ylCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1Dm1BU;EVqgkCd;EoEr1lCE;IACE,gBAAA;IACA,SAAA;IACA,a1D60BU;EV0gkCd;AACF;AkBzzlCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1Dm1BU;EVihkCd;EoEj2lCE;IACE,gBAAA;IACA,SAAA;IACA,a1D60BU;EVshkCd;AACF;AkBr0lCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1Dm1BU;EV6hkCd;EoE72lCE;IACE,gBAAA;IACA,SAAA;IACA,a1D60BU;EVkikCd;AACF;AkBj1lCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1Dm1BU;EVyikCd;EoEz3lCE;IACE,gBAAA;IACA,SAAA;IACA,a1D60BU;EV8ikCd;AACF;AkB71lCI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1Dm1BU;EVqjkCd;EoEr4lCE;IACE,gBAAA;IACA,SAAA;IACA,a1D60BU;EV0jkCd;AACF;AqEv6lCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;ArEy6lCF;;AqEt6lCA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;ArEy6lCF;;AsEj7lCA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AvEk7lCF;AuE/6lCE;;EACE,6BAAA;AvEk7lCJ;;AwEh8lCE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DqSqB;E8DpSrB,WAAA;AxEm8lCJ;;AyE38lCA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A1E+8lCF;;A2Er9lCA;EACE,qBAAA;EACA,mBAAA;EACA,6B/CisB4B;E+ChsB5B,eAAA;EACA,8BAAA;EACA,ajE4eW;AV4+kCb;;A4E55lCQ;EAOI,mCAAA;A5Ey5lCZ;;A4Eh6lCQ;EAOI,8BAAA;A5E65lCZ;;A4Ep6lCQ;EAOI,iCAAA;A5Ei6lCZ;;A4Ex6lCQ;EAOI,iCAAA;A5Eq6lCZ;;A4E56lCQ;EAOI,sCAAA;A5Ey6lCZ;;A4Eh7lCQ;EAOI,mCAAA;A5E66lCZ;;A4Ep7lCQ;EAOI,sBAAA;A5Ei7lCZ;;A4Ex7lCQ;EAOI,uBAAA;A5Eq7lCZ;;A4E57lCQ;EAOI,sBAAA;A5Ey7lCZ;;A4Eh8lCQ;EAOI,8BAAA;A5E67lCZ;;A4Ep8lCQ;EAOI,4BAAA;A5Ei8lCZ;;A4Ex8lCQ;EAOI,2BAAA;A5Eq8lCZ;;A4E58lCQ;EAOI,iCAAA;A5Ey8lCZ;;A4Eh9lCQ;EAOI,2BAAA;A5E68lCZ;;A4Ep9lCQ;EAOI,qBAAA;A5Ei9lCZ;;A4Ex9lCQ;EAOI,wBAAA;A5Eq9lCZ;;A4E59lCQ;EAOI,uBAAA;A5Ey9lCZ;;A4Eh+lCQ;EAOI,wBAAA;A5E69lCZ;;A4Ep+lCQ;EAOI,qBAAA;A5Ei+lCZ;;A4Ex+lCQ;EAOI,yBAAA;A5Eq+lCZ;;A4E5+lCQ;EAOI,2BAAA;A5Ey+lCZ;;A4Eh/lCQ;EAOI,4BAAA;A5E6+lCZ;;A4Ep/lCQ;EAOI,2BAAA;A5Ei/lCZ;;A4Ex/lCQ;EAOI,2BAAA;A5Eq/lCZ;;A4E5/lCQ;EAOI,6BAAA;A5Ey/lCZ;;A4EhgmCQ;EAOI,8BAAA;A5E6/lCZ;;A4EpgmCQ;EAOI,6BAAA;A5EigmCZ;;A4ExgmCQ;EAOI,2BAAA;A5EqgmCZ;;A4E5gmCQ;EAOI,6BAAA;A5EygmCZ;;A4EhhmCQ;EAOI,8BAAA;A5E6gmCZ;;A4EphmCQ;EAOI,6BAAA;A5EihmCZ;;A4ExhmCQ;EAOI,0BAAA;A5EqhmCZ;;A4E5hmCQ;EAOI,gCAAA;A5EyhmCZ;;A4EhimCQ;EAOI,yBAAA;A5E6hmCZ;;A4EpimCQ;EAOI,wBAAA;A5EiimCZ;;A4EximCQ;EAOI,+BAAA;A5EqimCZ;;A4E5imCQ;EAOI,yBAAA;A5EyimCZ;;A4EhjmCQ;EAOI,6BAAA;A5E6imCZ;;A4EpjmCQ;EAOI,8BAAA;A5EijmCZ;;A4ExjmCQ;EAOI,wBAAA;A5EqjmCZ;;A4E5jmCQ;EAOI,+BAAA;A5EyjmCZ;;A4EhkmCQ;EAOI,wBAAA;A5E6jmCZ;;A4EpkmCQ;EAOI,2CAAA;A5EikmCZ;;A4ExkmCQ;EAOI,8CAAA;A5EqkmCZ;;A4E5kmCQ;EAOI,8CAAA;A5EykmCZ;;A4EhlmCQ;EAOI,2BAAA;A5E6kmCZ;;A4E9lmCQ;EACE,gFAAA;A5EimmCV;;A4ElmmCQ;EACE,kFAAA;A5EqmmCV;;A4EtmmCQ;EACE,gFAAA;A5EymmCV;;A4E1mmCQ;EACE,6EAAA;A5E6mmCV;;A4E9mmCQ;EACE,gFAAA;A5EinmCV;;A4ElnmCQ;EACE,+EAAA;A5EqnmCV;;A4EtnmCQ;EACE,8EAAA;A5EynmCV;;A4E1nmCQ;EACE,6EAAA;A5E6nmCV;;A4EpnmCQ;EAOI,2BAAA;A5EinmCZ;;A4ExnmCQ;EAOI,6BAAA;A5EqnmCZ;;A4E5nmCQ;EAOI,6BAAA;A5EynmCZ;;A4EhomCQ;EAOI,0BAAA;A5E6nmCZ;;A4EpomCQ;EAOI,2BAAA;A5EiomCZ;;A4ExomCQ;EAOI,iBAAA;A5EqomCZ;;A4E5omCQ;EAOI,mBAAA;A5EyomCZ;;A4EhpmCQ;EAOI,oBAAA;A5E6omCZ;;A4EppmCQ;EAOI,oBAAA;A5EipmCZ;;A4ExpmCQ;EAOI,sBAAA;A5EqpmCZ;;A4E5pmCQ;EAOI,uBAAA;A5EypmCZ;;A4EhqmCQ;EAOI,kBAAA;A5E6pmCZ;;A4EpqmCQ;EAOI,oBAAA;A5EiqmCZ;;A4ExqmCQ;EAOI,qBAAA;A5EqqmCZ;;A4E5qmCQ;EAOI,mBAAA;A5EyqmCZ;;A4EhrmCQ;EAOI,qBAAA;A5E6qmCZ;;A4EprmCQ;EAOI,sBAAA;A5EirmCZ;;A4ExrmCQ;EAOI,2CAAA;A5EqrmCZ;;A4E5rmCQ;EAOI,sCAAA;A5EyrmCZ;;A4EhsmCQ;EAOI,sCAAA;A5E6rmCZ;;A4EpsmCQ;EAOI,uFAAA;A5EismCZ;;A4ExsmCQ;EAOI,oBAAA;A5EqsmCZ;;A4E5smCQ;EAOI,2FAAA;A5EysmCZ;;A4EhtmCQ;EAOI,wBAAA;A5E6smCZ;;A4EptmCQ;EAOI,6FAAA;A5EitmCZ;;A4ExtmCQ;EAOI,0BAAA;A5EqtmCZ;;A4E5tmCQ;EAOI,8FAAA;A5EytmCZ;;A4EhumCQ;EAOI,2BAAA;A5E6tmCZ;;A4EpumCQ;EAOI,4FAAA;A5EiumCZ;;A4ExumCQ;EAOI,yBAAA;A5EqumCZ;;A4E5umCQ;EAIQ,sBAAA;EAGJ,8EAAA;A5E0umCZ;;A4EjvmCQ;EAIQ,sBAAA;EAGJ,gFAAA;A5E+umCZ;;A4EtvmCQ;EAIQ,sBAAA;EAGJ,8EAAA;A5EovmCZ;;A4E3vmCQ;EAIQ,sBAAA;EAGJ,2EAAA;A5EyvmCZ;;A4EhwmCQ;EAIQ,sBAAA;EAGJ,8EAAA;A5E8vmCZ;;A4ErwmCQ;EAIQ,sBAAA;EAGJ,6EAAA;A5EmwmCZ;;A4E1wmCQ;EAIQ,sBAAA;EAGJ,4EAAA;A5EwwmCZ;;A4E/wmCQ;EAIQ,sBAAA;EAGJ,2EAAA;A5E6wmCZ;;A4EpxmCQ;EAIQ,sBAAA;EAGJ,4EAAA;A5EkxmCZ;;A4EzxmCQ;EAIQ,sBAAA;EAGJ,4EAAA;A5EuxmCZ;;A4E9xmCQ;EAOI,wDAAA;A5E2xmCZ;;A4ElymCQ;EAOI,0DAAA;A5E+xmCZ;;A4EtymCQ;EAOI,wDAAA;A5EmymCZ;;A4E1ymCQ;EAOI,qDAAA;A5EuymCZ;;A4E9ymCQ;EAOI,wDAAA;A5E2ymCZ;;A4ElzmCQ;EAOI,uDAAA;A5E+ymCZ;;A4EtzmCQ;EAOI,sDAAA;A5EmzmCZ;;A4E1zmCQ;EAOI,qDAAA;A5EuzmCZ;;A4E9zmCQ;EAOI,0BAAA;A5E2zmCZ;;A4El0mCQ;EAOI,4BAAA;A5E+zmCZ;;A4Et0mCQ;EAOI,4BAAA;A5Em0mCZ;;A4E10mCQ;EAOI,4BAAA;A5Eu0mCZ;;A4E90mCQ;EAOI,4BAAA;A5E20mCZ;;A4El1mCQ;EAOI,4BAAA;A5E+0mCZ;;A4Eh2mCQ;EACE,wBAAA;A5Em2mCV;;A4Ep2mCQ;EACE,yBAAA;A5Eu2mCV;;A4Ex2mCQ;EACE,wBAAA;A5E22mCV;;A4E52mCQ;EACE,yBAAA;A5E+2mCV;;A4Eh3mCQ;EACE,sBAAA;A5Em3mCV;;A4E12mCQ;EAOI,qBAAA;A5Eu2mCZ;;A4E92mCQ;EAOI,qBAAA;A5E22mCZ;;A4El3mCQ;EAOI,qBAAA;A5E+2mCZ;;A4Et3mCQ;EAOI,sBAAA;A5Em3mCZ;;A4E13mCQ;EAOI,sBAAA;A5Eu3mCZ;;A4E93mCQ;EAOI,0BAAA;A5E23mCZ;;A4El4mCQ;EAOI,uBAAA;A5E+3mCZ;;A4Et4mCQ;EAOI,2BAAA;A5Em4mCZ;;A4E14mCQ;EAOI,sBAAA;A5Eu4mCZ;;A4E94mCQ;EAOI,sBAAA;A5E24mCZ;;A4El5mCQ;EAOI,sBAAA;A5E+4mCZ;;A4Et5mCQ;EAOI,uBAAA;A5Em5mCZ;;A4E15mCQ;EAOI,uBAAA;A5Eu5mCZ;;A4E95mCQ;EAOI,2BAAA;A5E25mCZ;;A4El6mCQ;EAOI,wBAAA;A5E+5mCZ;;A4Et6mCQ;EAOI,4BAAA;A5Em6mCZ;;A4E16mCQ;EAOI,yBAAA;A5Eu6mCZ;;A4E96mCQ;EAOI,8BAAA;A5E26mCZ;;A4El7mCQ;EAOI,iCAAA;A5E+6mCZ;;A4Et7mCQ;EAOI,sCAAA;A5Em7mCZ;;A4E17mCQ;EAOI,yCAAA;A5Eu7mCZ;;A4E97mCQ;EAOI,uBAAA;A5E27mCZ;;A4El8mCQ;EAOI,uBAAA;A5E+7mCZ;;A4Et8mCQ;EAOI,yBAAA;A5Em8mCZ;;A4E18mCQ;EAOI,yBAAA;A5Eu8mCZ;;A4E98mCQ;EAOI,0BAAA;A5E28mCZ;;A4El9mCQ;EAOI,4BAAA;A5E+8mCZ;;A4Et9mCQ;EAOI,kCAAA;A5Em9mCZ;;A4E19mCQ;EAOI,sCAAA;A5Eu9mCZ;;A4E99mCQ;EAOI,oCAAA;A5E29mCZ;;A4El+mCQ;EAOI,kCAAA;A5E+9mCZ;;A4Et+mCQ;EAOI,yCAAA;A5Em+mCZ;;A4E1+mCQ;EAOI,wCAAA;A5Eu+mCZ;;A4E9+mCQ;EAOI,wCAAA;A5E2+mCZ;;A4El/mCQ;EAOI,kCAAA;A5E++mCZ;;A4Et/mCQ;EAOI,gCAAA;A5Em/mCZ;;A4E1/mCQ;EAOI,8BAAA;A5Eu/mCZ;;A4E9/mCQ;EAOI,gCAAA;A5E2/mCZ;;A4ElgnCQ;EAOI,+BAAA;A5E+/mCZ;;A4EtgnCQ;EAOI,oCAAA;A5EmgnCZ;;A4E1gnCQ;EAOI,kCAAA;A5EugnCZ;;A4E9gnCQ;EAOI,gCAAA;A5E2gnCZ;;A4ElhnCQ;EAOI,uCAAA;A5E+gnCZ;;A4EthnCQ;EAOI,sCAAA;A5EmhnCZ;;A4E1hnCQ;EAOI,iCAAA;A5EuhnCZ;;A4E9hnCQ;EAOI,2BAAA;A5E2hnCZ;;A4ElinCQ;EAOI,iCAAA;A5E+hnCZ;;A4EtinCQ;EAOI,+BAAA;A5EminCZ;;A4E1inCQ;EAOI,6BAAA;A5EuinCZ;;A4E9inCQ;EAOI,+BAAA;A5E2inCZ;;A4EljnCQ;EAOI,8BAAA;A5E+inCZ;;A4EtjnCQ;EAOI,oBAAA;A5EmjnCZ;;A4E1jnCQ;EAOI,mBAAA;A5EujnCZ;;A4E9jnCQ;EAOI,mBAAA;A5E2jnCZ;;A4ElknCQ;EAOI,mBAAA;A5E+jnCZ;;A4EtknCQ;EAOI,mBAAA;A5EmknCZ;;A4E1knCQ;EAOI,mBAAA;A5EuknCZ;;A4E9knCQ;EAOI,mBAAA;A5E2knCZ;;A4EllnCQ;EAOI,mBAAA;A5E+knCZ;;A4EtlnCQ;EAOI,oBAAA;A5EmlnCZ;;A4E1lnCQ;EAOI,0BAAA;A5EulnCZ;;A4E9lnCQ;EAOI,yBAAA;A5E2lnCZ;;A4ElmnCQ;EAOI,uBAAA;A5E+lnCZ;;A4EtmnCQ;EAOI,yBAAA;A5EmmnCZ;;A4E1mnCQ;EAOI,uBAAA;A5EumnCZ;;A4E9mnCQ;EAOI,uBAAA;A5E2mnCZ;;A4ElnnCQ;EAOI,0BAAA;EAAA,yBAAA;A5EgnnCZ;;A4EvnnCQ;EAOI,gCAAA;EAAA,+BAAA;A5EqnnCZ;;A4E5nnCQ;EAOI,+BAAA;EAAA,8BAAA;A5E0nnCZ;;A4EjonCQ;EAOI,6BAAA;EAAA,4BAAA;A5E+nnCZ;;A4EtonCQ;EAOI,+BAAA;EAAA,8BAAA;A5EoonCZ;;A4E3onCQ;EAOI,6BAAA;EAAA,4BAAA;A5EyonCZ;;A4EhpnCQ;EAOI,6BAAA;EAAA,4BAAA;A5E8onCZ;;A4ErpnCQ;EAOI,wBAAA;EAAA,2BAAA;A5EmpnCZ;;A4E1pnCQ;EAOI,8BAAA;EAAA,iCAAA;A5EwpnCZ;;A4E/pnCQ;EAOI,6BAAA;EAAA,gCAAA;A5E6pnCZ;;A4EpqnCQ;EAOI,2BAAA;EAAA,8BAAA;A5EkqnCZ;;A4EzqnCQ;EAOI,6BAAA;EAAA,gCAAA;A5EuqnCZ;;A4E9qnCQ;EAOI,2BAAA;EAAA,8BAAA;A5E4qnCZ;;A4EnrnCQ;EAOI,2BAAA;EAAA,8BAAA;A5EirnCZ;;A4ExrnCQ;EAOI,wBAAA;A5EqrnCZ;;A4E5rnCQ;EAOI,8BAAA;A5EyrnCZ;;A4EhsnCQ;EAOI,6BAAA;A5E6rnCZ;;A4EpsnCQ;EAOI,2BAAA;A5EisnCZ;;A4ExsnCQ;EAOI,6BAAA;A5EqsnCZ;;A4E5snCQ;EAOI,2BAAA;A5EysnCZ;;A4EhtnCQ;EAOI,2BAAA;A5E6snCZ;;A4EptnCQ;EAOI,0BAAA;A5EitnCZ;;A4ExtnCQ;EAOI,gCAAA;A5EqtnCZ;;A4E5tnCQ;EAOI,+BAAA;A5EytnCZ;;A4EhunCQ;EAOI,6BAAA;A5E6tnCZ;;A4EpunCQ;EAOI,+BAAA;A5EiunCZ;;A4ExunCQ;EAOI,6BAAA;A5EqunCZ;;A4E5unCQ;EAOI,6BAAA;A5EyunCZ;;A4EhvnCQ;EAOI,2BAAA;A5E6unCZ;;A4EpvnCQ;EAOI,iCAAA;A5EivnCZ;;A4ExvnCQ;EAOI,gCAAA;A5EqvnCZ;;A4E5vnCQ;EAOI,8BAAA;A5EyvnCZ;;A4EhwnCQ;EAOI,gCAAA;A5E6vnCZ;;A4EpwnCQ;EAOI,8BAAA;A5EiwnCZ;;A4ExwnCQ;EAOI,8BAAA;A5EqwnCZ;;A4E5wnCQ;EAOI,yBAAA;A5EywnCZ;;A4EhxnCQ;EAOI,+BAAA;A5E6wnCZ;;A4EpxnCQ;EAOI,8BAAA;A5EixnCZ;;A4ExxnCQ;EAOI,4BAAA;A5EqxnCZ;;A4E5xnCQ;EAOI,8BAAA;A5EyxnCZ;;A4EhynCQ;EAOI,4BAAA;A5E6xnCZ;;A4EpynCQ;EAOI,4BAAA;A5EiynCZ;;A4ExynCQ;EAOI,qBAAA;A5EqynCZ;;A4E5ynCQ;EAOI,2BAAA;A5EyynCZ;;A4EhznCQ;EAOI,0BAAA;A5E6ynCZ;;A4EpznCQ;EAOI,wBAAA;A5EiznCZ;;A4ExznCQ;EAOI,0BAAA;A5EqznCZ;;A4E5znCQ;EAOI,wBAAA;A5EyznCZ;;A4Eh0nCQ;EAOI,2BAAA;EAAA,0BAAA;A5E8znCZ;;A4Er0nCQ;EAOI,iCAAA;EAAA,gCAAA;A5Em0nCZ;;A4E10nCQ;EAOI,gCAAA;EAAA,+BAAA;A5Ew0nCZ;;A4E/0nCQ;EAOI,8BAAA;EAAA,6BAAA;A5E60nCZ;;A4Ep1nCQ;EAOI,gCAAA;EAAA,+BAAA;A5Ek1nCZ;;A4Ez1nCQ;EAOI,8BAAA;EAAA,6BAAA;A5Eu1nCZ;;A4E91nCQ;EAOI,yBAAA;EAAA,4BAAA;A5E41nCZ;;A4En2nCQ;EAOI,+BAAA;EAAA,kCAAA;A5Ei2nCZ;;A4Ex2nCQ;EAOI,8BAAA;EAAA,iCAAA;A5Es2nCZ;;A4E72nCQ;EAOI,4BAAA;EAAA,+BAAA;A5E22nCZ;;A4El3nCQ;EAOI,8BAAA;EAAA,iCAAA;A5Eg3nCZ;;A4Ev3nCQ;EAOI,4BAAA;EAAA,+BAAA;A5Eq3nCZ;;A4E53nCQ;EAOI,yBAAA;A5Ey3nCZ;;A4Eh4nCQ;EAOI,+BAAA;A5E63nCZ;;A4Ep4nCQ;EAOI,8BAAA;A5Ei4nCZ;;A4Ex4nCQ;EAOI,4BAAA;A5Eq4nCZ;;A4E54nCQ;EAOI,8BAAA;A5Ey4nCZ;;A4Eh5nCQ;EAOI,4BAAA;A5E64nCZ;;A4Ep5nCQ;EAOI,2BAAA;A5Ei5nCZ;;A4Ex5nCQ;EAOI,iCAAA;A5Eq5nCZ;;A4E55nCQ;EAOI,gCAAA;A5Ey5nCZ;;A4Eh6nCQ;EAOI,8BAAA;A5E65nCZ;;A4Ep6nCQ;EAOI,gCAAA;A5Ei6nCZ;;A4Ex6nCQ;EAOI,8BAAA;A5Eq6nCZ;;A4E56nCQ;EAOI,4BAAA;A5Ey6nCZ;;A4Eh7nCQ;EAOI,kCAAA;A5E66nCZ;;A4Ep7nCQ;EAOI,iCAAA;A5Ei7nCZ;;A4Ex7nCQ;EAOI,+BAAA;A5Eq7nCZ;;A4E57nCQ;EAOI,iCAAA;A5Ey7nCZ;;A4Eh8nCQ;EAOI,+BAAA;A5E67nCZ;;A4Ep8nCQ;EAOI,0BAAA;A5Ei8nCZ;;A4Ex8nCQ;EAOI,gCAAA;A5Eq8nCZ;;A4E58nCQ;EAOI,+BAAA;A5Ey8nCZ;;A4Eh9nCQ;EAOI,6BAAA;A5E68nCZ;;A4Ep9nCQ;EAOI,+BAAA;A5Ei9nCZ;;A4Ex9nCQ;EAOI,6BAAA;A5Eq9nCZ;;A4E59nCQ;EAOI,iBAAA;A5Ey9nCZ;;A4Eh+nCQ;EAOI,uBAAA;A5E69nCZ;;A4Ep+nCQ;EAOI,sBAAA;A5Ei+nCZ;;A4Ex+nCQ;EAOI,oBAAA;A5Eq+nCZ;;A4E5+nCQ;EAOI,sBAAA;A5Ey+nCZ;;A4Eh/nCQ;EAOI,oBAAA;A5E6+nCZ;;A4Ep/nCQ;EAOI,qBAAA;A5Ei/nCZ;;A4Ex/nCQ;EAOI,2BAAA;A5Eq/nCZ;;A4E5/nCQ;EAOI,0BAAA;A5Ey/nCZ;;A4EhgoCQ;EAOI,wBAAA;A5E6/nCZ;;A4EpgoCQ;EAOI,0BAAA;A5EigoCZ;;A4ExgoCQ;EAOI,wBAAA;A5EqgoCZ;;A4E5goCQ;EAOI,wBAAA;A5EygoCZ;;A4EhhoCQ;EAOI,8BAAA;A5E6goCZ;;A4EphoCQ;EAOI,6BAAA;A5EihoCZ;;A4ExhoCQ;EAOI,2BAAA;A5EqhoCZ;;A4E5hoCQ;EAOI,6BAAA;A5EyhoCZ;;A4EhioCQ;EAOI,2BAAA;A5E6hoCZ;;A4EpioCQ;EAOI,gDAAA;A5EiioCZ;;A4ExioCQ;EAOI,kDAAA;A5EqioCZ;;A4E5ioCQ;EAOI,8CAAA;A5EyioCZ;;A4EhjoCQ;EAOI,oDAAA;A5E6ioCZ;;A4EpjoCQ;EAOI,gDAAA;A5EijoCZ;;A4ExjoCQ;EAOI,iCAAA;A5EqjoCZ;;A4E5joCQ;EAOI,+BAAA;A5EyjoCZ;;A4EhkoCQ;EAOI,6BAAA;A5E6joCZ;;A4EpkoCQ;EAOI,6BAAA;A5EikoCZ;;A4ExkoCQ;EAOI,+BAAA;A5EqkoCZ;;A4E5koCQ;EAOI,2BAAA;A5EykoCZ;;A4EhloCQ;EAOI,2BAAA;A5E6koCZ;;A4EploCQ;EAOI,2BAAA;A5EiloCZ;;A4ExloCQ;EAOI,2BAAA;A5EqloCZ;;A4E5loCQ;EAOI,2BAAA;A5EyloCZ;;A4EhmoCQ;EAOI,8BAAA;A5E6loCZ;;A4EpmoCQ;EAOI,yBAAA;A5EimoCZ;;A4ExmoCQ;EAOI,4BAAA;A5EqmoCZ;;A4E5moCQ;EAOI,2BAAA;A5EymoCZ;;A4EhnoCQ;EAOI,yBAAA;A5E6moCZ;;A4EpnoCQ;EAOI,2BAAA;A5EinoCZ;;A4ExnoCQ;EAOI,4BAAA;A5EqnoCZ;;A4E5noCQ;EAOI,6BAAA;A5EynoCZ;;A4EhooCQ;EAOI,gCAAA;A5E6noCZ;;A4EpooCQ;EAOI,qCAAA;A5EiooCZ;;A4ExooCQ;EAOI,wCAAA;A5EqooCZ;;A4E5ooCQ;EAOI,oCAAA;A5EyooCZ;;A4EhpoCQ;EAOI,oCAAA;A5E6ooCZ;;A4EppoCQ;EAOI,qCAAA;A5EipoCZ;;A4ExpoCQ;EAOI,8BAAA;A5EqpoCZ;;A4E5poCQ;EAOI,8BAAA;A5EypoCZ;;A4E9qoCQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A5E+poCZ;;A4E5ooCQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A5EqqoCZ;;A4E5qoCQ;EAIQ,oBAAA;EAGJ,uEAAA;A5E0qoCZ;;A4EjroCQ;EAIQ,oBAAA;EAGJ,qEAAA;A5E+qoCZ;;A4EtroCQ;EAIQ,oBAAA;EAGJ,kEAAA;A5EoroCZ;;A4E3roCQ;EAIQ,oBAAA;EAGJ,qEAAA;A5EyroCZ;;A4EhsoCQ;EAIQ,oBAAA;EAGJ,oEAAA;A5E8roCZ;;A4ErsoCQ;EAIQ,oBAAA;EAGJ,mEAAA;A5EmsoCZ;;A4E1soCQ;EAIQ,oBAAA;EAGJ,kEAAA;A5EwsoCZ;;A4E/soCQ;EAIQ,oBAAA;EAGJ,mEAAA;A5E6soCZ;;A4EptoCQ;EAIQ,oBAAA;EAGJ,mEAAA;A5EktoCZ;;A4EztoCQ;EAIQ,oBAAA;EAGJ,wEAAA;A5EutoCZ;;A4E9toCQ;EAIQ,oBAAA;EAGJ,2CAAA;A5E4toCZ;;A4EnuoCQ;EAIQ,oBAAA;EAGJ,oCAAA;A5EiuoCZ;;A4ExuoCQ;EAIQ,oBAAA;EAGJ,0CAAA;A5EsuoCZ;;A4E7uoCQ;EAIQ,oBAAA;EAGJ,2CAAA;A5E2uoCZ;;A4ElvoCQ;EAIQ,oBAAA;EAGJ,0CAAA;A5EgvoCZ;;A4EvvoCQ;EAIQ,oBAAA;EAGJ,0CAAA;A5EqvoCZ;;A4E5voCQ;EAIQ,oBAAA;EAGJ,yBAAA;A5E0voCZ;;A4E3woCQ;EACE,uBAAA;A5E8woCV;;A4E/woCQ;EACE,sBAAA;A5EkxoCV;;A4EnxoCQ;EACE,uBAAA;A5EsxoCV;;A4EvxoCQ;EACE,oBAAA;A5E0xoCV;;A4EjxoCQ;EAOI,iDAAA;A5E8woCZ;;A4ErxoCQ;EAOI,mDAAA;A5EkxoCZ;;A4EzxoCQ;EAOI,iDAAA;A5EsxoCZ;;A4E7xoCQ;EAOI,8CAAA;A5E0xoCZ;;A4EjyoCQ;EAOI,iDAAA;A5E8xoCZ;;A4EryoCQ;EAOI,gDAAA;A5EkyoCZ;;A4EzyoCQ;EAOI,+CAAA;A5EsyoCZ;;A4E7yoCQ;EAOI,8CAAA;A5E0yoCZ;;A4E3zoCQ;EACE,sBAAA;A5E8zoCV;;A4E1zoCU;EACE,sBAAA;A5E6zoCZ;;A4En0oCQ;EACE,uBAAA;A5Es0oCV;;A4El0oCU;EACE,uBAAA;A5Eq0oCZ;;A4E30oCQ;EACE,sBAAA;A5E80oCV;;A4E10oCU;EACE,sBAAA;A5E60oCZ;;A4En1oCQ;EACE,uBAAA;A5Es1oCV;;A4El1oCU;EACE,uBAAA;A5Eq1oCZ;;A4E31oCQ;EACE,oBAAA;A5E81oCV;;A4E11oCU;EACE,oBAAA;A5E61oCZ;;A4Ez1oCQ;EAOI,yCAAA;A5Es1oCZ;;A4Ej1oCU;EAOI,yCAAA;A5E80oCd;;A4Ej2oCQ;EAOI,wCAAA;A5E81oCZ;;A4Ez1oCU;EAOI,wCAAA;A5Es1oCd;;A4Ez2oCQ;EAOI,yCAAA;A5Es2oCZ;;A4Ej2oCU;EAOI,yCAAA;A5E81oCd;;A4Ej3oCQ;EAIQ,8BAAA;EAGJ,+FAAA;A5E+2oCZ;;A4Et3oCQ;EAIQ,8BAAA;EAGJ,iGAAA;A5Eo3oCZ;;A4E33oCQ;EAIQ,8BAAA;EAGJ,+FAAA;A5Ey3oCZ;;A4Eh4oCQ;EAIQ,8BAAA;EAGJ,4FAAA;A5E83oCZ;;A4Er4oCQ;EAIQ,8BAAA;EAGJ,+FAAA;A5Em4oCZ;;A4E14oCQ;EAIQ,8BAAA;EAGJ,8FAAA;A5Ew4oCZ;;A4E/4oCQ;EAIQ,8BAAA;EAGJ,6FAAA;A5E64oCZ;;A4Ep5oCQ;EAIQ,8BAAA;EAGJ,4FAAA;A5Ek5oCZ;;A4Ez5oCQ;EAIQ,8BAAA;EAGJ,qGAAA;A5Eu5oCZ;;A4Ex6oCQ;EACE,8BAAA;A5E26oCV;;A4Ev6oCU;EACE,8BAAA;A5E06oCZ;;A4Eh7oCQ;EACE,gCAAA;A5Em7oCV;;A4E/6oCU;EACE,gCAAA;A5Ek7oCZ;;A4Ex7oCQ;EACE,iCAAA;A5E27oCV;;A4Ev7oCU;EACE,iCAAA;A5E07oCZ;;A4Eh8oCQ;EACE,gCAAA;A5Em8oCV;;A4E/7oCU;EACE,gCAAA;A5Ek8oCZ;;A4Ex8oCQ;EACE,iCAAA;A5E28oCV;;A4Ev8oCU;EACE,iCAAA;A5E08oCZ;;A4Eh9oCQ;EACE,8BAAA;A5Em9oCV;;A4E/8oCU;EACE,8BAAA;A5Ek9oCZ;;A4E98oCQ;EAIQ,kBAAA;EAGJ,8EAAA;A5E48oCZ;;A4En9oCQ;EAIQ,kBAAA;EAGJ,gFAAA;A5Ei9oCZ;;A4Ex9oCQ;EAIQ,kBAAA;EAGJ,8EAAA;A5Es9oCZ;;A4E79oCQ;EAIQ,kBAAA;EAGJ,2EAAA;A5E29oCZ;;A4El+oCQ;EAIQ,kBAAA;EAGJ,8EAAA;A5Eg+oCZ;;A4Ev+oCQ;EAIQ,kBAAA;EAGJ,6EAAA;A5Eq+oCZ;;A4E5+oCQ;EAIQ,kBAAA;EAGJ,4EAAA;A5E0+oCZ;;A4Ej/oCQ;EAIQ,kBAAA;EAGJ,2EAAA;A5E++oCZ;;A4Et/oCQ;EAIQ,kBAAA;EAGJ,4EAAA;A5Eo/oCZ;;A4E3/oCQ;EAIQ,kBAAA;EAGJ,4EAAA;A5Ey/oCZ;;A4EhgpCQ;EAIQ,kBAAA;EAGJ,8EAAA;A5E8/oCZ;;A4ErgpCQ;EAIQ,kBAAA;EAGJ,wCAAA;A5EmgpCZ;;A4E1gpCQ;EAIQ,kBAAA;EAGJ,mFAAA;A5EwgpCZ;;A4E/gpCQ;EAIQ,kBAAA;EAGJ,kFAAA;A5E6gpCZ;;A4E9hpCQ;EACE,oBAAA;A5EiipCV;;A4ElipCQ;EACE,qBAAA;A5EqipCV;;A4EtipCQ;EACE,oBAAA;A5EyipCV;;A4E1ipCQ;EACE,qBAAA;A5E6ipCV;;A4E9ipCQ;EACE,kBAAA;A5EijpCV;;A4ExipCQ;EAOI,wDAAA;A5EqipCZ;;A4E5ipCQ;EAOI,0DAAA;A5EyipCZ;;A4EhjpCQ;EAOI,wDAAA;A5E6ipCZ;;A4EpjpCQ;EAOI,qDAAA;A5EijpCZ;;A4ExjpCQ;EAOI,wDAAA;A5EqjpCZ;;A4E5jpCQ;EAOI,uDAAA;A5EyjpCZ;;A4EhkpCQ;EAOI,sDAAA;A5E6jpCZ;;A4EpkpCQ;EAOI,qDAAA;A5EikpCZ;;A4ExkpCQ;EAOI,+CAAA;A5EqkpCZ;;A4E5kpCQ;EAOI,mCAAA;UAAA,2BAAA;A5EykpCZ;;A4EhlpCQ;EAOI,oCAAA;UAAA,4BAAA;A5E6kpCZ;;A4EplpCQ;EAOI,oCAAA;UAAA,4BAAA;A5EilpCZ;;A4ExlpCQ;EAOI,+BAAA;A5EqlpCZ;;A4E5lpCQ;EAOI,+BAAA;A5EylpCZ;;A4EhmpCQ;EAOI,iDAAA;A5E6lpCZ;;A4EpmpCQ;EAOI,2BAAA;A5EimpCZ;;A4ExmpCQ;EAOI,oDAAA;A5EqmpCZ;;A4E5mpCQ;EAOI,iDAAA;A5EympCZ;;A4EhnpCQ;EAOI,oDAAA;A5E6mpCZ;;A4EpnpCQ;EAOI,oDAAA;A5EinpCZ;;A4ExnpCQ;EAOI,qDAAA;A5EqnpCZ;;A4E5npCQ;EAOI,6BAAA;A5EynpCZ;;A4EhopCQ;EAOI,sDAAA;A5E6npCZ;;A4EpopCQ;EAOI,0DAAA;EAAA,2DAAA;A5EkopCZ;;A4EzopCQ;EAOI,oCAAA;EAAA,qCAAA;A5EuopCZ;;A4E9opCQ;EAOI,6DAAA;EAAA,8DAAA;A5E4opCZ;;A4EnppCQ;EAOI,0DAAA;EAAA,2DAAA;A5EippCZ;;A4ExppCQ;EAOI,6DAAA;EAAA,8DAAA;A5EsppCZ;;A4E7ppCQ;EAOI,6DAAA;EAAA,8DAAA;A5E2ppCZ;;A4ElqpCQ;EAOI,8DAAA;EAAA,+DAAA;A5EgqpCZ;;A4EvqpCQ;EAOI,sCAAA;EAAA,uCAAA;A5EqqpCZ;;A4E5qpCQ;EAOI,+DAAA;EAAA,gEAAA;A5E0qpCZ;;A4EjrpCQ;EAOI,2DAAA;EAAA,8DAAA;A5E+qpCZ;;A4EtrpCQ;EAOI,qCAAA;EAAA,wCAAA;A5EorpCZ;;A4E3rpCQ;EAOI,8DAAA;EAAA,iEAAA;A5EyrpCZ;;A4EhspCQ;EAOI,2DAAA;EAAA,8DAAA;A5E8rpCZ;;A4ErspCQ;EAOI,8DAAA;EAAA,iEAAA;A5EmspCZ;;A4E1spCQ;EAOI,8DAAA;EAAA,iEAAA;A5EwspCZ;;A4E/spCQ;EAOI,+DAAA;EAAA,kEAAA;A5E6spCZ;;A4EptpCQ;EAOI,uCAAA;EAAA,0CAAA;A5EktpCZ;;A4EztpCQ;EAOI,gEAAA;EAAA,mEAAA;A5EutpCZ;;A4E9tpCQ;EAOI,8DAAA;EAAA,6DAAA;A5E4tpCZ;;A4EnupCQ;EAOI,wCAAA;EAAA,uCAAA;A5EiupCZ;;A4ExupCQ;EAOI,iEAAA;EAAA,gEAAA;A5EsupCZ;;A4E7upCQ;EAOI,8DAAA;EAAA,6DAAA;A5E2upCZ;;A4ElvpCQ;EAOI,iEAAA;EAAA,gEAAA;A5EgvpCZ;;A4EvvpCQ;EAOI,iEAAA;EAAA,gEAAA;A5EqvpCZ;;A4E5vpCQ;EAOI,kEAAA;EAAA,iEAAA;A5E0vpCZ;;A4EjwpCQ;EAOI,0CAAA;EAAA,yCAAA;A5E+vpCZ;;A4EtwpCQ;EAOI,mEAAA;EAAA,kEAAA;A5EowpCZ;;A4E3wpCQ;EAOI,6DAAA;EAAA,0DAAA;A5EywpCZ;;A4EhxpCQ;EAOI,uCAAA;EAAA,oCAAA;A5E8wpCZ;;A4ErxpCQ;EAOI,gEAAA;EAAA,6DAAA;A5EmxpCZ;;A4E1xpCQ;EAOI,6DAAA;EAAA,0DAAA;A5EwxpCZ;;A4E/xpCQ;EAOI,gEAAA;EAAA,6DAAA;A5E6xpCZ;;A4EpypCQ;EAOI,gEAAA;EAAA,6DAAA;A5EkypCZ;;A4EzypCQ;EAOI,iEAAA;EAAA,8DAAA;A5EuypCZ;;A4E9ypCQ;EAOI,yCAAA;EAAA,sCAAA;A5E4ypCZ;;A4EnzpCQ;EAOI,kEAAA;EAAA,+DAAA;A5EizpCZ;;A4ExzpCQ;EAOI,8BAAA;A5EqzpCZ;;A4E5zpCQ;EAOI,6BAAA;A5EyzpCZ;;A4Eh0pCQ;EAOI,sBAAA;A5E6zpCZ;;A4Ep0pCQ;EAOI,qBAAA;A5Ei0pCZ;;A4Ex0pCQ;EAOI,qBAAA;A5Eq0pCZ;;A4E50pCQ;EAOI,qBAAA;A5Ey0pCZ;;A4Eh1pCQ;EAOI,qBAAA;A5E60pCZ;;AkBv1pCI;E0DGI;IAOI,sBAAA;E5Ek1pCV;E4Ez1pCM;IAOI,uBAAA;E5Eq1pCV;E4E51pCM;IAOI,sBAAA;E5Ew1pCV;E4E/1pCM;IAOI,8BAAA;E5E21pCV;E4El2pCM;IAOI,4BAAA;E5E81pCV;E4Er2pCM;IAOI,2BAAA;E5Ei2pCV;E4Ex2pCM;IAOI,iCAAA;E5Eo2pCV;E4E32pCM;IAOI,2BAAA;E5Eu2pCV;E4E92pCM;IAOI,0BAAA;E5E02pCV;E4Ej3pCM;IAOI,gCAAA;E5E62pCV;E4Ep3pCM;IAOI,yBAAA;E5Eg3pCV;E4Ev3pCM;IAOI,wBAAA;E5Em3pCV;E4E13pCM;IAOI,+BAAA;E5Es3pCV;E4E73pCM;IAOI,yBAAA;E5Ey3pCV;E4Eh4pCM;IAOI,6BAAA;E5E43pCV;E4En4pCM;IAOI,8BAAA;E5E+3pCV;E4Et4pCM;IAOI,wBAAA;E5Ek4pCV;E4Ez4pCM;IAOI,+BAAA;E5Eq4pCV;E4E54pCM;IAOI,wBAAA;E5Ew4pCV;E4E/4pCM;IAOI,yBAAA;E5E24pCV;E4El5pCM;IAOI,8BAAA;E5E84pCV;E4Er5pCM;IAOI,iCAAA;E5Ei5pCV;E4Ex5pCM;IAOI,sCAAA;E5Eo5pCV;E4E35pCM;IAOI,yCAAA;E5Eu5pCV;E4E95pCM;IAOI,uBAAA;E5E05pCV;E4Ej6pCM;IAOI,uBAAA;E5E65pCV;E4Ep6pCM;IAOI,yBAAA;E5Eg6pCV;E4Ev6pCM;IAOI,yBAAA;E5Em6pCV;E4E16pCM;IAOI,0BAAA;E5Es6pCV;E4E76pCM;IAOI,4BAAA;E5Ey6pCV;E4Eh7pCM;IAOI,kCAAA;E5E46pCV;E4En7pCM;IAOI,sCAAA;E5E+6pCV;E4Et7pCM;IAOI,oCAAA;E5Ek7pCV;E4Ez7pCM;IAOI,kCAAA;E5Eq7pCV;E4E57pCM;IAOI,yCAAA;E5Ew7pCV;E4E/7pCM;IAOI,wCAAA;E5E27pCV;E4El8pCM;IAOI,wCAAA;E5E87pCV;E4Er8pCM;IAOI,kCAAA;E5Ei8pCV;E4Ex8pCM;IAOI,gCAAA;E5Eo8pCV;E4E38pCM;IAOI,8BAAA;E5Eu8pCV;E4E98pCM;IAOI,gCAAA;E5E08pCV;E4Ej9pCM;IAOI,+BAAA;E5E68pCV;E4Ep9pCM;IAOI,oCAAA;E5Eg9pCV;E4Ev9pCM;IAOI,kCAAA;E5Em9pCV;E4E19pCM;IAOI,gCAAA;E5Es9pCV;E4E79pCM;IAOI,uCAAA;E5Ey9pCV;E4Eh+pCM;IAOI,sCAAA;E5E49pCV;E4En+pCM;IAOI,iCAAA;E5E+9pCV;E4Et+pCM;IAOI,2BAAA;E5Ek+pCV;E4Ez+pCM;IAOI,iCAAA;E5Eq+pCV;E4E5+pCM;IAOI,+BAAA;E5Ew+pCV;E4E/+pCM;IAOI,6BAAA;E5E2+pCV;E4El/pCM;IAOI,+BAAA;E5E8+pCV;E4Er/pCM;IAOI,8BAAA;E5Ei/pCV;E4Ex/pCM;IAOI,oBAAA;E5Eo/pCV;E4E3/pCM;IAOI,mBAAA;E5Eu/pCV;E4E9/pCM;IAOI,mBAAA;E5E0/pCV;E4EjgqCM;IAOI,mBAAA;E5E6/pCV;E4EpgqCM;IAOI,mBAAA;E5EggqCV;E4EvgqCM;IAOI,mBAAA;E5EmgqCV;E4E1gqCM;IAOI,mBAAA;E5EsgqCV;E4E7gqCM;IAOI,mBAAA;E5EygqCV;E4EhhqCM;IAOI,oBAAA;E5E4gqCV;E4EnhqCM;IAOI,0BAAA;E5E+gqCV;E4EthqCM;IAOI,yBAAA;E5EkhqCV;E4EzhqCM;IAOI,uBAAA;E5EqhqCV;E4E5hqCM;IAOI,yBAAA;E5EwhqCV;E4E/hqCM;IAOI,uBAAA;E5E2hqCV;E4EliqCM;IAOI,uBAAA;E5E8hqCV;E4EriqCM;IAOI,0BAAA;IAAA,yBAAA;E5EkiqCV;E4EziqCM;IAOI,gCAAA;IAAA,+BAAA;E5EsiqCV;E4E7iqCM;IAOI,+BAAA;IAAA,8BAAA;E5E0iqCV;E4EjjqCM;IAOI,6BAAA;IAAA,4BAAA;E5E8iqCV;E4ErjqCM;IAOI,+BAAA;IAAA,8BAAA;E5EkjqCV;E4EzjqCM;IAOI,6BAAA;IAAA,4BAAA;E5EsjqCV;E4E7jqCM;IAOI,6BAAA;IAAA,4BAAA;E5E0jqCV;E4EjkqCM;IAOI,wBAAA;IAAA,2BAAA;E5E8jqCV;E4ErkqCM;IAOI,8BAAA;IAAA,iCAAA;E5EkkqCV;E4EzkqCM;IAOI,6BAAA;IAAA,gCAAA;E5EskqCV;E4E7kqCM;IAOI,2BAAA;IAAA,8BAAA;E5E0kqCV;E4EjlqCM;IAOI,6BAAA;IAAA,gCAAA;E5E8kqCV;E4ErlqCM;IAOI,2BAAA;IAAA,8BAAA;E5EklqCV;E4EzlqCM;IAOI,2BAAA;IAAA,8BAAA;E5EslqCV;E4E7lqCM;IAOI,wBAAA;E5EylqCV;E4EhmqCM;IAOI,8BAAA;E5E4lqCV;E4EnmqCM;IAOI,6BAAA;E5E+lqCV;E4EtmqCM;IAOI,2BAAA;E5EkmqCV;E4EzmqCM;IAOI,6BAAA;E5EqmqCV;E4E5mqCM;IAOI,2BAAA;E5EwmqCV;E4E/mqCM;IAOI,2BAAA;E5E2mqCV;E4ElnqCM;IAOI,0BAAA;E5E8mqCV;E4ErnqCM;IAOI,gCAAA;E5EinqCV;E4ExnqCM;IAOI,+BAAA;E5EonqCV;E4E3nqCM;IAOI,6BAAA;E5EunqCV;E4E9nqCM;IAOI,+BAAA;E5E0nqCV;E4EjoqCM;IAOI,6BAAA;E5E6nqCV;E4EpoqCM;IAOI,6BAAA;E5EgoqCV;E4EvoqCM;IAOI,2BAAA;E5EmoqCV;E4E1oqCM;IAOI,iCAAA;E5EsoqCV;E4E7oqCM;IAOI,gCAAA;E5EyoqCV;E4EhpqCM;IAOI,8BAAA;E5E4oqCV;E4EnpqCM;IAOI,gCAAA;E5E+oqCV;E4EtpqCM;IAOI,8BAAA;E5EkpqCV;E4EzpqCM;IAOI,8BAAA;E5EqpqCV;E4E5pqCM;IAOI,yBAAA;E5EwpqCV;E4E/pqCM;IAOI,+BAAA;E5E2pqCV;E4ElqqCM;IAOI,8BAAA;E5E8pqCV;E4ErqqCM;IAOI,4BAAA;E5EiqqCV;E4ExqqCM;IAOI,8BAAA;E5EoqqCV;E4E3qqCM;IAOI,4BAAA;E5EuqqCV;E4E9qqCM;IAOI,4BAAA;E5E0qqCV;E4EjrqCM;IAOI,qBAAA;E5E6qqCV;E4EprqCM;IAOI,2BAAA;E5EgrqCV;E4EvrqCM;IAOI,0BAAA;E5EmrqCV;E4E1rqCM;IAOI,wBAAA;E5EsrqCV;E4E7rqCM;IAOI,0BAAA;E5EyrqCV;E4EhsqCM;IAOI,wBAAA;E5E4rqCV;E4EnsqCM;IAOI,2BAAA;IAAA,0BAAA;E5EgsqCV;E4EvsqCM;IAOI,iCAAA;IAAA,gCAAA;E5EosqCV;E4E3sqCM;IAOI,gCAAA;IAAA,+BAAA;E5EwsqCV;E4E/sqCM;IAOI,8BAAA;IAAA,6BAAA;E5E4sqCV;E4EntqCM;IAOI,gCAAA;IAAA,+BAAA;E5EgtqCV;E4EvtqCM;IAOI,8BAAA;IAAA,6BAAA;E5EotqCV;E4E3tqCM;IAOI,yBAAA;IAAA,4BAAA;E5EwtqCV;E4E/tqCM;IAOI,+BAAA;IAAA,kCAAA;E5E4tqCV;E4EnuqCM;IAOI,8BAAA;IAAA,iCAAA;E5EguqCV;E4EvuqCM;IAOI,4BAAA;IAAA,+BAAA;E5EouqCV;E4E3uqCM;IAOI,8BAAA;IAAA,iCAAA;E5EwuqCV;E4E/uqCM;IAOI,4BAAA;IAAA,+BAAA;E5E4uqCV;E4EnvqCM;IAOI,yBAAA;E5E+uqCV;E4EtvqCM;IAOI,+BAAA;E5EkvqCV;E4EzvqCM;IAOI,8BAAA;E5EqvqCV;E4E5vqCM;IAOI,4BAAA;E5EwvqCV;E4E/vqCM;IAOI,8BAAA;E5E2vqCV;E4ElwqCM;IAOI,4BAAA;E5E8vqCV;E4ErwqCM;IAOI,2BAAA;E5EiwqCV;E4ExwqCM;IAOI,iCAAA;E5EowqCV;E4E3wqCM;IAOI,gCAAA;E5EuwqCV;E4E9wqCM;IAOI,8BAAA;E5E0wqCV;E4EjxqCM;IAOI,gCAAA;E5E6wqCV;E4EpxqCM;IAOI,8BAAA;E5EgxqCV;E4EvxqCM;IAOI,4BAAA;E5EmxqCV;E4E1xqCM;IAOI,kCAAA;E5EsxqCV;E4E7xqCM;IAOI,iCAAA;E5EyxqCV;E4EhyqCM;IAOI,+BAAA;E5E4xqCV;E4EnyqCM;IAOI,iCAAA;E5E+xqCV;E4EtyqCM;IAOI,+BAAA;E5EkyqCV;E4EzyqCM;IAOI,0BAAA;E5EqyqCV;E4E5yqCM;IAOI,gCAAA;E5EwyqCV;E4E/yqCM;IAOI,+BAAA;E5E2yqCV;E4ElzqCM;IAOI,6BAAA;E5E8yqCV;E4ErzqCM;IAOI,+BAAA;E5EizqCV;E4ExzqCM;IAOI,6BAAA;E5EozqCV;E4E3zqCM;IAOI,iBAAA;E5EuzqCV;E4E9zqCM;IAOI,uBAAA;E5E0zqCV;E4Ej0qCM;IAOI,sBAAA;E5E6zqCV;E4Ep0qCM;IAOI,oBAAA;E5Eg0qCV;E4Ev0qCM;IAOI,sBAAA;E5Em0qCV;E4E10qCM;IAOI,oBAAA;E5Es0qCV;E4E70qCM;IAOI,qBAAA;E5Ey0qCV;E4Eh1qCM;IAOI,2BAAA;E5E40qCV;E4En1qCM;IAOI,0BAAA;E5E+0qCV;E4Et1qCM;IAOI,wBAAA;E5Ek1qCV;E4Ez1qCM;IAOI,0BAAA;E5Eq1qCV;E4E51qCM;IAOI,wBAAA;E5Ew1qCV;E4E/1qCM;IAOI,wBAAA;E5E21qCV;E4El2qCM;IAOI,8BAAA;E5E81qCV;E4Er2qCM;IAOI,6BAAA;E5Ei2qCV;E4Ex2qCM;IAOI,2BAAA;E5Eo2qCV;E4E32qCM;IAOI,6BAAA;E5Eu2qCV;E4E92qCM;IAOI,2BAAA;E5E02qCV;E4Ej3qCM;IAOI,2BAAA;E5E62qCV;E4Ep3qCM;IAOI,4BAAA;E5Eg3qCV;E4Ev3qCM;IAOI,6BAAA;E5Em3qCV;AACF;AkB93qCI;E0DGI;IAOI,sBAAA;E5Ew3qCV;E4E/3qCM;IAOI,uBAAA;E5E23qCV;E4El4qCM;IAOI,sBAAA;E5E83qCV;E4Er4qCM;IAOI,8BAAA;E5Ei4qCV;E4Ex4qCM;IAOI,4BAAA;E5Eo4qCV;E4E34qCM;IAOI,2BAAA;E5Eu4qCV;E4E94qCM;IAOI,iCAAA;E5E04qCV;E4Ej5qCM;IAOI,2BAAA;E5E64qCV;E4Ep5qCM;IAOI,0BAAA;E5Eg5qCV;E4Ev5qCM;IAOI,gCAAA;E5Em5qCV;E4E15qCM;IAOI,yBAAA;E5Es5qCV;E4E75qCM;IAOI,wBAAA;E5Ey5qCV;E4Eh6qCM;IAOI,+BAAA;E5E45qCV;E4En6qCM;IAOI,yBAAA;E5E+5qCV;E4Et6qCM;IAOI,6BAAA;E5Ek6qCV;E4Ez6qCM;IAOI,8BAAA;E5Eq6qCV;E4E56qCM;IAOI,wBAAA;E5Ew6qCV;E4E/6qCM;IAOI,+BAAA;E5E26qCV;E4El7qCM;IAOI,wBAAA;E5E86qCV;E4Er7qCM;IAOI,yBAAA;E5Ei7qCV;E4Ex7qCM;IAOI,8BAAA;E5Eo7qCV;E4E37qCM;IAOI,iCAAA;E5Eu7qCV;E4E97qCM;IAOI,sCAAA;E5E07qCV;E4Ej8qCM;IAOI,yCAAA;E5E67qCV;E4Ep8qCM;IAOI,uBAAA;E5Eg8qCV;E4Ev8qCM;IAOI,uBAAA;E5Em8qCV;E4E18qCM;IAOI,yBAAA;E5Es8qCV;E4E78qCM;IAOI,yBAAA;E5Ey8qCV;E4Eh9qCM;IAOI,0BAAA;E5E48qCV;E4En9qCM;IAOI,4BAAA;E5E+8qCV;E4Et9qCM;IAOI,kCAAA;E5Ek9qCV;E4Ez9qCM;IAOI,sCAAA;E5Eq9qCV;E4E59qCM;IAOI,oCAAA;E5Ew9qCV;E4E/9qCM;IAOI,kCAAA;E5E29qCV;E4El+qCM;IAOI,yCAAA;E5E89qCV;E4Er+qCM;IAOI,wCAAA;E5Ei+qCV;E4Ex+qCM;IAOI,wCAAA;E5Eo+qCV;E4E3+qCM;IAOI,kCAAA;E5Eu+qCV;E4E9+qCM;IAOI,gCAAA;E5E0+qCV;E4Ej/qCM;IAOI,8BAAA;E5E6+qCV;E4Ep/qCM;IAOI,gCAAA;E5Eg/qCV;E4Ev/qCM;IAOI,+BAAA;E5Em/qCV;E4E1/qCM;IAOI,oCAAA;E5Es/qCV;E4E7/qCM;IAOI,kCAAA;E5Ey/qCV;E4EhgrCM;IAOI,gCAAA;E5E4/qCV;E4EngrCM;IAOI,uCAAA;E5E+/qCV;E4EtgrCM;IAOI,sCAAA;E5EkgrCV;E4EzgrCM;IAOI,iCAAA;E5EqgrCV;E4E5grCM;IAOI,2BAAA;E5EwgrCV;E4E/grCM;IAOI,iCAAA;E5E2grCV;E4ElhrCM;IAOI,+BAAA;E5E8grCV;E4ErhrCM;IAOI,6BAAA;E5EihrCV;E4ExhrCM;IAOI,+BAAA;E5EohrCV;E4E3hrCM;IAOI,8BAAA;E5EuhrCV;E4E9hrCM;IAOI,oBAAA;E5E0hrCV;E4EjirCM;IAOI,mBAAA;E5E6hrCV;E4EpirCM;IAOI,mBAAA;E5EgirCV;E4EvirCM;IAOI,mBAAA;E5EmirCV;E4E1irCM;IAOI,mBAAA;E5EsirCV;E4E7irCM;IAOI,mBAAA;E5EyirCV;E4EhjrCM;IAOI,mBAAA;E5E4irCV;E4EnjrCM;IAOI,mBAAA;E5E+irCV;E4EtjrCM;IAOI,oBAAA;E5EkjrCV;E4EzjrCM;IAOI,0BAAA;E5EqjrCV;E4E5jrCM;IAOI,yBAAA;E5EwjrCV;E4E/jrCM;IAOI,uBAAA;E5E2jrCV;E4ElkrCM;IAOI,yBAAA;E5E8jrCV;E4ErkrCM;IAOI,uBAAA;E5EikrCV;E4ExkrCM;IAOI,uBAAA;E5EokrCV;E4E3krCM;IAOI,0BAAA;IAAA,yBAAA;E5EwkrCV;E4E/krCM;IAOI,gCAAA;IAAA,+BAAA;E5E4krCV;E4EnlrCM;IAOI,+BAAA;IAAA,8BAAA;E5EglrCV;E4EvlrCM;IAOI,6BAAA;IAAA,4BAAA;E5EolrCV;E4E3lrCM;IAOI,+BAAA;IAAA,8BAAA;E5EwlrCV;E4E/lrCM;IAOI,6BAAA;IAAA,4BAAA;E5E4lrCV;E4EnmrCM;IAOI,6BAAA;IAAA,4BAAA;E5EgmrCV;E4EvmrCM;IAOI,wBAAA;IAAA,2BAAA;E5EomrCV;E4E3mrCM;IAOI,8BAAA;IAAA,iCAAA;E5EwmrCV;E4E/mrCM;IAOI,6BAAA;IAAA,gCAAA;E5E4mrCV;E4EnnrCM;IAOI,2BAAA;IAAA,8BAAA;E5EgnrCV;E4EvnrCM;IAOI,6BAAA;IAAA,gCAAA;E5EonrCV;E4E3nrCM;IAOI,2BAAA;IAAA,8BAAA;E5EwnrCV;E4E/nrCM;IAOI,2BAAA;IAAA,8BAAA;E5E4nrCV;E4EnorCM;IAOI,wBAAA;E5E+nrCV;E4EtorCM;IAOI,8BAAA;E5EkorCV;E4EzorCM;IAOI,6BAAA;E5EqorCV;E4E5orCM;IAOI,2BAAA;E5EworCV;E4E/orCM;IAOI,6BAAA;E5E2orCV;E4ElprCM;IAOI,2BAAA;E5E8orCV;E4ErprCM;IAOI,2BAAA;E5EiprCV;E4ExprCM;IAOI,0BAAA;E5EoprCV;E4E3prCM;IAOI,gCAAA;E5EuprCV;E4E9prCM;IAOI,+BAAA;E5E0prCV;E4EjqrCM;IAOI,6BAAA;E5E6prCV;E4EpqrCM;IAOI,+BAAA;E5EgqrCV;E4EvqrCM;IAOI,6BAAA;E5EmqrCV;E4E1qrCM;IAOI,6BAAA;E5EsqrCV;E4E7qrCM;IAOI,2BAAA;E5EyqrCV;E4EhrrCM;IAOI,iCAAA;E5E4qrCV;E4EnrrCM;IAOI,gCAAA;E5E+qrCV;E4EtrrCM;IAOI,8BAAA;E5EkrrCV;E4EzrrCM;IAOI,gCAAA;E5EqrrCV;E4E5rrCM;IAOI,8BAAA;E5EwrrCV;E4E/rrCM;IAOI,8BAAA;E5E2rrCV;E4ElsrCM;IAOI,yBAAA;E5E8rrCV;E4ErsrCM;IAOI,+BAAA;E5EisrCV;E4ExsrCM;IAOI,8BAAA;E5EosrCV;E4E3srCM;IAOI,4BAAA;E5EusrCV;E4E9srCM;IAOI,8BAAA;E5E0srCV;E4EjtrCM;IAOI,4BAAA;E5E6srCV;E4EptrCM;IAOI,4BAAA;E5EgtrCV;E4EvtrCM;IAOI,qBAAA;E5EmtrCV;E4E1trCM;IAOI,2BAAA;E5EstrCV;E4E7trCM;IAOI,0BAAA;E5EytrCV;E4EhurCM;IAOI,wBAAA;E5E4trCV;E4EnurCM;IAOI,0BAAA;E5E+trCV;E4EturCM;IAOI,wBAAA;E5EkurCV;E4EzurCM;IAOI,2BAAA;IAAA,0BAAA;E5EsurCV;E4E7urCM;IAOI,iCAAA;IAAA,gCAAA;E5E0urCV;E4EjvrCM;IAOI,gCAAA;IAAA,+BAAA;E5E8urCV;E4ErvrCM;IAOI,8BAAA;IAAA,6BAAA;E5EkvrCV;E4EzvrCM;IAOI,gCAAA;IAAA,+BAAA;E5EsvrCV;E4E7vrCM;IAOI,8BAAA;IAAA,6BAAA;E5E0vrCV;E4EjwrCM;IAOI,yBAAA;IAAA,4BAAA;E5E8vrCV;E4ErwrCM;IAOI,+BAAA;IAAA,kCAAA;E5EkwrCV;E4EzwrCM;IAOI,8BAAA;IAAA,iCAAA;E5EswrCV;E4E7wrCM;IAOI,4BAAA;IAAA,+BAAA;E5E0wrCV;E4EjxrCM;IAOI,8BAAA;IAAA,iCAAA;E5E8wrCV;E4ErxrCM;IAOI,4BAAA;IAAA,+BAAA;E5EkxrCV;E4EzxrCM;IAOI,yBAAA;E5EqxrCV;E4E5xrCM;IAOI,+BAAA;E5EwxrCV;E4E/xrCM;IAOI,8BAAA;E5E2xrCV;E4ElyrCM;IAOI,4BAAA;E5E8xrCV;E4EryrCM;IAOI,8BAAA;E5EiyrCV;E4ExyrCM;IAOI,4BAAA;E5EoyrCV;E4E3yrCM;IAOI,2BAAA;E5EuyrCV;E4E9yrCM;IAOI,iCAAA;E5E0yrCV;E4EjzrCM;IAOI,gCAAA;E5E6yrCV;E4EpzrCM;IAOI,8BAAA;E5EgzrCV;E4EvzrCM;IAOI,gCAAA;E5EmzrCV;E4E1zrCM;IAOI,8BAAA;E5EszrCV;E4E7zrCM;IAOI,4BAAA;E5EyzrCV;E4Eh0rCM;IAOI,kCAAA;E5E4zrCV;E4En0rCM;IAOI,iCAAA;E5E+zrCV;E4Et0rCM;IAOI,+BAAA;E5Ek0rCV;E4Ez0rCM;IAOI,iCAAA;E5Eq0rCV;E4E50rCM;IAOI,+BAAA;E5Ew0rCV;E4E/0rCM;IAOI,0BAAA;E5E20rCV;E4El1rCM;IAOI,gCAAA;E5E80rCV;E4Er1rCM;IAOI,+BAAA;E5Ei1rCV;E4Ex1rCM;IAOI,6BAAA;E5Eo1rCV;E4E31rCM;IAOI,+BAAA;E5Eu1rCV;E4E91rCM;IAOI,6BAAA;E5E01rCV;E4Ej2rCM;IAOI,iBAAA;E5E61rCV;E4Ep2rCM;IAOI,uBAAA;E5Eg2rCV;E4Ev2rCM;IAOI,sBAAA;E5Em2rCV;E4E12rCM;IAOI,oBAAA;E5Es2rCV;E4E72rCM;IAOI,sBAAA;E5Ey2rCV;E4Eh3rCM;IAOI,oBAAA;E5E42rCV;E4En3rCM;IAOI,qBAAA;E5E+2rCV;E4Et3rCM;IAOI,2BAAA;E5Ek3rCV;E4Ez3rCM;IAOI,0BAAA;E5Eq3rCV;E4E53rCM;IAOI,wBAAA;E5Ew3rCV;E4E/3rCM;IAOI,0BAAA;E5E23rCV;E4El4rCM;IAOI,wBAAA;E5E83rCV;E4Er4rCM;IAOI,wBAAA;E5Ei4rCV;E4Ex4rCM;IAOI,8BAAA;E5Eo4rCV;E4E34rCM;IAOI,6BAAA;E5Eu4rCV;E4E94rCM;IAOI,2BAAA;E5E04rCV;E4Ej5rCM;IAOI,6BAAA;E5E64rCV;E4Ep5rCM;IAOI,2BAAA;E5Eg5rCV;E4Ev5rCM;IAOI,2BAAA;E5Em5rCV;E4E15rCM;IAOI,4BAAA;E5Es5rCV;E4E75rCM;IAOI,6BAAA;E5Ey5rCV;AACF;AkBp6rCI;E0DGI;IAOI,sBAAA;E5E85rCV;E4Er6rCM;IAOI,uBAAA;E5Ei6rCV;E4Ex6rCM;IAOI,sBAAA;E5Eo6rCV;E4E36rCM;IAOI,8BAAA;E5Eu6rCV;E4E96rCM;IAOI,4BAAA;E5E06rCV;E4Ej7rCM;IAOI,2BAAA;E5E66rCV;E4Ep7rCM;IAOI,iCAAA;E5Eg7rCV;E4Ev7rCM;IAOI,2BAAA;E5Em7rCV;E4E17rCM;IAOI,0BAAA;E5Es7rCV;E4E77rCM;IAOI,gCAAA;E5Ey7rCV;E4Eh8rCM;IAOI,yBAAA;E5E47rCV;E4En8rCM;IAOI,wBAAA;E5E+7rCV;E4Et8rCM;IAOI,+BAAA;E5Ek8rCV;E4Ez8rCM;IAOI,yBAAA;E5Eq8rCV;E4E58rCM;IAOI,6BAAA;E5Ew8rCV;E4E/8rCM;IAOI,8BAAA;E5E28rCV;E4El9rCM;IAOI,wBAAA;E5E88rCV;E4Er9rCM;IAOI,+BAAA;E5Ei9rCV;E4Ex9rCM;IAOI,wBAAA;E5Eo9rCV;E4E39rCM;IAOI,yBAAA;E5Eu9rCV;E4E99rCM;IAOI,8BAAA;E5E09rCV;E4Ej+rCM;IAOI,iCAAA;E5E69rCV;E4Ep+rCM;IAOI,sCAAA;E5Eg+rCV;E4Ev+rCM;IAOI,yCAAA;E5Em+rCV;E4E1+rCM;IAOI,uBAAA;E5Es+rCV;E4E7+rCM;IAOI,uBAAA;E5Ey+rCV;E4Eh/rCM;IAOI,yBAAA;E5E4+rCV;E4En/rCM;IAOI,yBAAA;E5E++rCV;E4Et/rCM;IAOI,0BAAA;E5Ek/rCV;E4Ez/rCM;IAOI,4BAAA;E5Eq/rCV;E4E5/rCM;IAOI,kCAAA;E5Ew/rCV;E4E//rCM;IAOI,sCAAA;E5E2/rCV;E4ElgsCM;IAOI,oCAAA;E5E8/rCV;E4ErgsCM;IAOI,kCAAA;E5EigsCV;E4ExgsCM;IAOI,yCAAA;E5EogsCV;E4E3gsCM;IAOI,wCAAA;E5EugsCV;E4E9gsCM;IAOI,wCAAA;E5E0gsCV;E4EjhsCM;IAOI,kCAAA;E5E6gsCV;E4EphsCM;IAOI,gCAAA;E5EghsCV;E4EvhsCM;IAOI,8BAAA;E5EmhsCV;E4E1hsCM;IAOI,gCAAA;E5EshsCV;E4E7hsCM;IAOI,+BAAA;E5EyhsCV;E4EhisCM;IAOI,oCAAA;E5E4hsCV;E4EnisCM;IAOI,kCAAA;E5E+hsCV;E4EtisCM;IAOI,gCAAA;E5EkisCV;E4EzisCM;IAOI,uCAAA;E5EqisCV;E4E5isCM;IAOI,sCAAA;E5EwisCV;E4E/isCM;IAOI,iCAAA;E5E2isCV;E4EljsCM;IAOI,2BAAA;E5E8isCV;E4ErjsCM;IAOI,iCAAA;E5EijsCV;E4ExjsCM;IAOI,+BAAA;E5EojsCV;E4E3jsCM;IAOI,6BAAA;E5EujsCV;E4E9jsCM;IAOI,+BAAA;E5E0jsCV;E4EjksCM;IAOI,8BAAA;E5E6jsCV;E4EpksCM;IAOI,oBAAA;E5EgksCV;E4EvksCM;IAOI,mBAAA;E5EmksCV;E4E1ksCM;IAOI,mBAAA;E5EsksCV;E4E7ksCM;IAOI,mBAAA;E5EyksCV;E4EhlsCM;IAOI,mBAAA;E5E4ksCV;E4EnlsCM;IAOI,mBAAA;E5E+ksCV;E4EtlsCM;IAOI,mBAAA;E5EklsCV;E4EzlsCM;IAOI,mBAAA;E5EqlsCV;E4E5lsCM;IAOI,oBAAA;E5EwlsCV;E4E/lsCM;IAOI,0BAAA;E5E2lsCV;E4ElmsCM;IAOI,yBAAA;E5E8lsCV;E4ErmsCM;IAOI,uBAAA;E5EimsCV;E4ExmsCM;IAOI,yBAAA;E5EomsCV;E4E3msCM;IAOI,uBAAA;E5EumsCV;E4E9msCM;IAOI,uBAAA;E5E0msCV;E4EjnsCM;IAOI,0BAAA;IAAA,yBAAA;E5E8msCV;E4ErnsCM;IAOI,gCAAA;IAAA,+BAAA;E5EknsCV;E4EznsCM;IAOI,+BAAA;IAAA,8BAAA;E5EsnsCV;E4E7nsCM;IAOI,6BAAA;IAAA,4BAAA;E5E0nsCV;E4EjosCM;IAOI,+BAAA;IAAA,8BAAA;E5E8nsCV;E4ErosCM;IAOI,6BAAA;IAAA,4BAAA;E5EkosCV;E4EzosCM;IAOI,6BAAA;IAAA,4BAAA;E5EsosCV;E4E7osCM;IAOI,wBAAA;IAAA,2BAAA;E5E0osCV;E4EjpsCM;IAOI,8BAAA;IAAA,iCAAA;E5E8osCV;E4ErpsCM;IAOI,6BAAA;IAAA,gCAAA;E5EkpsCV;E4EzpsCM;IAOI,2BAAA;IAAA,8BAAA;E5EspsCV;E4E7psCM;IAOI,6BAAA;IAAA,gCAAA;E5E0psCV;E4EjqsCM;IAOI,2BAAA;IAAA,8BAAA;E5E8psCV;E4ErqsCM;IAOI,2BAAA;IAAA,8BAAA;E5EkqsCV;E4EzqsCM;IAOI,wBAAA;E5EqqsCV;E4E5qsCM;IAOI,8BAAA;E5EwqsCV;E4E/qsCM;IAOI,6BAAA;E5E2qsCV;E4ElrsCM;IAOI,2BAAA;E5E8qsCV;E4ErrsCM;IAOI,6BAAA;E5EirsCV;E4ExrsCM;IAOI,2BAAA;E5EorsCV;E4E3rsCM;IAOI,2BAAA;E5EursCV;E4E9rsCM;IAOI,0BAAA;E5E0rsCV;E4EjssCM;IAOI,gCAAA;E5E6rsCV;E4EpssCM;IAOI,+BAAA;E5EgssCV;E4EvssCM;IAOI,6BAAA;E5EmssCV;E4E1ssCM;IAOI,+BAAA;E5EsssCV;E4E7ssCM;IAOI,6BAAA;E5EyssCV;E4EhtsCM;IAOI,6BAAA;E5E4ssCV;E4EntsCM;IAOI,2BAAA;E5E+ssCV;E4EttsCM;IAOI,iCAAA;E5EktsCV;E4EztsCM;IAOI,gCAAA;E5EqtsCV;E4E5tsCM;IAOI,8BAAA;E5EwtsCV;E4E/tsCM;IAOI,gCAAA;E5E2tsCV;E4ElusCM;IAOI,8BAAA;E5E8tsCV;E4ErusCM;IAOI,8BAAA;E5EiusCV;E4ExusCM;IAOI,yBAAA;E5EousCV;E4E3usCM;IAOI,+BAAA;E5EuusCV;E4E9usCM;IAOI,8BAAA;E5E0usCV;E4EjvsCM;IAOI,4BAAA;E5E6usCV;E4EpvsCM;IAOI,8BAAA;E5EgvsCV;E4EvvsCM;IAOI,4BAAA;E5EmvsCV;E4E1vsCM;IAOI,4BAAA;E5EsvsCV;E4E7vsCM;IAOI,qBAAA;E5EyvsCV;E4EhwsCM;IAOI,2BAAA;E5E4vsCV;E4EnwsCM;IAOI,0BAAA;E5E+vsCV;E4EtwsCM;IAOI,wBAAA;E5EkwsCV;E4EzwsCM;IAOI,0BAAA;E5EqwsCV;E4E5wsCM;IAOI,wBAAA;E5EwwsCV;E4E/wsCM;IAOI,2BAAA;IAAA,0BAAA;E5E4wsCV;E4EnxsCM;IAOI,iCAAA;IAAA,gCAAA;E5EgxsCV;E4EvxsCM;IAOI,gCAAA;IAAA,+BAAA;E5EoxsCV;E4E3xsCM;IAOI,8BAAA;IAAA,6BAAA;E5EwxsCV;E4E/xsCM;IAOI,gCAAA;IAAA,+BAAA;E5E4xsCV;E4EnysCM;IAOI,8BAAA;IAAA,6BAAA;E5EgysCV;E4EvysCM;IAOI,yBAAA;IAAA,4BAAA;E5EoysCV;E4E3ysCM;IAOI,+BAAA;IAAA,kCAAA;E5EwysCV;E4E/ysCM;IAOI,8BAAA;IAAA,iCAAA;E5E4ysCV;E4EnzsCM;IAOI,4BAAA;IAAA,+BAAA;E5EgzsCV;E4EvzsCM;IAOI,8BAAA;IAAA,iCAAA;E5EozsCV;E4E3zsCM;IAOI,4BAAA;IAAA,+BAAA;E5EwzsCV;E4E/zsCM;IAOI,yBAAA;E5E2zsCV;E4El0sCM;IAOI,+BAAA;E5E8zsCV;E4Er0sCM;IAOI,8BAAA;E5Ei0sCV;E4Ex0sCM;IAOI,4BAAA;E5Eo0sCV;E4E30sCM;IAOI,8BAAA;E5Eu0sCV;E4E90sCM;IAOI,4BAAA;E5E00sCV;E4Ej1sCM;IAOI,2BAAA;E5E60sCV;E4Ep1sCM;IAOI,iCAAA;E5Eg1sCV;E4Ev1sCM;IAOI,gCAAA;E5Em1sCV;E4E11sCM;IAOI,8BAAA;E5Es1sCV;E4E71sCM;IAOI,gCAAA;E5Ey1sCV;E4Eh2sCM;IAOI,8BAAA;E5E41sCV;E4En2sCM;IAOI,4BAAA;E5E+1sCV;E4Et2sCM;IAOI,kCAAA;E5Ek2sCV;E4Ez2sCM;IAOI,iCAAA;E5Eq2sCV;E4E52sCM;IAOI,+BAAA;E5Ew2sCV;E4E/2sCM;IAOI,iCAAA;E5E22sCV;E4El3sCM;IAOI,+BAAA;E5E82sCV;E4Er3sCM;IAOI,0BAAA;E5Ei3sCV;E4Ex3sCM;IAOI,gCAAA;E5Eo3sCV;E4E33sCM;IAOI,+BAAA;E5Eu3sCV;E4E93sCM;IAOI,6BAAA;E5E03sCV;E4Ej4sCM;IAOI,+BAAA;E5E63sCV;E4Ep4sCM;IAOI,6BAAA;E5Eg4sCV;E4Ev4sCM;IAOI,iBAAA;E5Em4sCV;E4E14sCM;IAOI,uBAAA;E5Es4sCV;E4E74sCM;IAOI,sBAAA;E5Ey4sCV;E4Eh5sCM;IAOI,oBAAA;E5E44sCV;E4En5sCM;IAOI,sBAAA;E5E+4sCV;E4Et5sCM;IAOI,oBAAA;E5Ek5sCV;E4Ez5sCM;IAOI,qBAAA;E5Eq5sCV;E4E55sCM;IAOI,2BAAA;E5Ew5sCV;E4E/5sCM;IAOI,0BAAA;E5E25sCV;E4El6sCM;IAOI,wBAAA;E5E85sCV;E4Er6sCM;IAOI,0BAAA;E5Ei6sCV;E4Ex6sCM;IAOI,wBAAA;E5Eo6sCV;E4E36sCM;IAOI,wBAAA;E5Eu6sCV;E4E96sCM;IAOI,8BAAA;E5E06sCV;E4Ej7sCM;IAOI,6BAAA;E5E66sCV;E4Ep7sCM;IAOI,2BAAA;E5Eg7sCV;E4Ev7sCM;IAOI,6BAAA;E5Em7sCV;E4E17sCM;IAOI,2BAAA;E5Es7sCV;E4E77sCM;IAOI,2BAAA;E5Ey7sCV;E4Eh8sCM;IAOI,4BAAA;E5E47sCV;E4En8sCM;IAOI,6BAAA;E5E+7sCV;AACF;AkB18sCI;E0DGI;IAOI,sBAAA;E5Eo8sCV;E4E38sCM;IAOI,uBAAA;E5Eu8sCV;E4E98sCM;IAOI,sBAAA;E5E08sCV;E4Ej9sCM;IAOI,8BAAA;E5E68sCV;E4Ep9sCM;IAOI,4BAAA;E5Eg9sCV;E4Ev9sCM;IAOI,2BAAA;E5Em9sCV;E4E19sCM;IAOI,iCAAA;E5Es9sCV;E4E79sCM;IAOI,2BAAA;E5Ey9sCV;E4Eh+sCM;IAOI,0BAAA;E5E49sCV;E4En+sCM;IAOI,gCAAA;E5E+9sCV;E4Et+sCM;IAOI,yBAAA;E5Ek+sCV;E4Ez+sCM;IAOI,wBAAA;E5Eq+sCV;E4E5+sCM;IAOI,+BAAA;E5Ew+sCV;E4E/+sCM;IAOI,yBAAA;E5E2+sCV;E4El/sCM;IAOI,6BAAA;E5E8+sCV;E4Er/sCM;IAOI,8BAAA;E5Ei/sCV;E4Ex/sCM;IAOI,wBAAA;E5Eo/sCV;E4E3/sCM;IAOI,+BAAA;E5Eu/sCV;E4E9/sCM;IAOI,wBAAA;E5E0/sCV;E4EjgtCM;IAOI,yBAAA;E5E6/sCV;E4EpgtCM;IAOI,8BAAA;E5EggtCV;E4EvgtCM;IAOI,iCAAA;E5EmgtCV;E4E1gtCM;IAOI,sCAAA;E5EsgtCV;E4E7gtCM;IAOI,yCAAA;E5EygtCV;E4EhhtCM;IAOI,uBAAA;E5E4gtCV;E4EnhtCM;IAOI,uBAAA;E5E+gtCV;E4EthtCM;IAOI,yBAAA;E5EkhtCV;E4EzhtCM;IAOI,yBAAA;E5EqhtCV;E4E5htCM;IAOI,0BAAA;E5EwhtCV;E4E/htCM;IAOI,4BAAA;E5E2htCV;E4ElitCM;IAOI,kCAAA;E5E8htCV;E4EritCM;IAOI,sCAAA;E5EiitCV;E4ExitCM;IAOI,oCAAA;E5EoitCV;E4E3itCM;IAOI,kCAAA;E5EuitCV;E4E9itCM;IAOI,yCAAA;E5E0itCV;E4EjjtCM;IAOI,wCAAA;E5E6itCV;E4EpjtCM;IAOI,wCAAA;E5EgjtCV;E4EvjtCM;IAOI,kCAAA;E5EmjtCV;E4E1jtCM;IAOI,gCAAA;E5EsjtCV;E4E7jtCM;IAOI,8BAAA;E5EyjtCV;E4EhktCM;IAOI,gCAAA;E5E4jtCV;E4EnktCM;IAOI,+BAAA;E5E+jtCV;E4EtktCM;IAOI,oCAAA;E5EkktCV;E4EzktCM;IAOI,kCAAA;E5EqktCV;E4E5ktCM;IAOI,gCAAA;E5EwktCV;E4E/ktCM;IAOI,uCAAA;E5E2ktCV;E4ElltCM;IAOI,sCAAA;E5E8ktCV;E4ErltCM;IAOI,iCAAA;E5EiltCV;E4ExltCM;IAOI,2BAAA;E5EoltCV;E4E3ltCM;IAOI,iCAAA;E5EultCV;E4E9ltCM;IAOI,+BAAA;E5E0ltCV;E4EjmtCM;IAOI,6BAAA;E5E6ltCV;E4EpmtCM;IAOI,+BAAA;E5EgmtCV;E4EvmtCM;IAOI,8BAAA;E5EmmtCV;E4E1mtCM;IAOI,oBAAA;E5EsmtCV;E4E7mtCM;IAOI,mBAAA;E5EymtCV;E4EhntCM;IAOI,mBAAA;E5E4mtCV;E4EnntCM;IAOI,mBAAA;E5E+mtCV;E4EtntCM;IAOI,mBAAA;E5EkntCV;E4EzntCM;IAOI,mBAAA;E5EqntCV;E4E5ntCM;IAOI,mBAAA;E5EwntCV;E4E/ntCM;IAOI,mBAAA;E5E2ntCV;E4ElotCM;IAOI,oBAAA;E5E8ntCV;E4ErotCM;IAOI,0BAAA;E5EiotCV;E4ExotCM;IAOI,yBAAA;E5EootCV;E4E3otCM;IAOI,uBAAA;E5EuotCV;E4E9otCM;IAOI,yBAAA;E5E0otCV;E4EjptCM;IAOI,uBAAA;E5E6otCV;E4EpptCM;IAOI,uBAAA;E5EgptCV;E4EvptCM;IAOI,0BAAA;IAAA,yBAAA;E5EoptCV;E4E3ptCM;IAOI,gCAAA;IAAA,+BAAA;E5EwptCV;E4E/ptCM;IAOI,+BAAA;IAAA,8BAAA;E5E4ptCV;E4EnqtCM;IAOI,6BAAA;IAAA,4BAAA;E5EgqtCV;E4EvqtCM;IAOI,+BAAA;IAAA,8BAAA;E5EoqtCV;E4E3qtCM;IAOI,6BAAA;IAAA,4BAAA;E5EwqtCV;E4E/qtCM;IAOI,6BAAA;IAAA,4BAAA;E5E4qtCV;E4EnrtCM;IAOI,wBAAA;IAAA,2BAAA;E5EgrtCV;E4EvrtCM;IAOI,8BAAA;IAAA,iCAAA;E5EortCV;E4E3rtCM;IAOI,6BAAA;IAAA,gCAAA;E5EwrtCV;E4E/rtCM;IAOI,2BAAA;IAAA,8BAAA;E5E4rtCV;E4EnstCM;IAOI,6BAAA;IAAA,gCAAA;E5EgstCV;E4EvstCM;IAOI,2BAAA;IAAA,8BAAA;E5EostCV;E4E3stCM;IAOI,2BAAA;IAAA,8BAAA;E5EwstCV;E4E/stCM;IAOI,wBAAA;E5E2stCV;E4ElttCM;IAOI,8BAAA;E5E8stCV;E4ErttCM;IAOI,6BAAA;E5EittCV;E4ExttCM;IAOI,2BAAA;E5EottCV;E4E3ttCM;IAOI,6BAAA;E5EuttCV;E4E9ttCM;IAOI,2BAAA;E5E0ttCV;E4EjutCM;IAOI,2BAAA;E5E6ttCV;E4EputCM;IAOI,0BAAA;E5EgutCV;E4EvutCM;IAOI,gCAAA;E5EmutCV;E4E1utCM;IAOI,+BAAA;E5EsutCV;E4E7utCM;IAOI,6BAAA;E5EyutCV;E4EhvtCM;IAOI,+BAAA;E5E4utCV;E4EnvtCM;IAOI,6BAAA;E5E+utCV;E4EtvtCM;IAOI,6BAAA;E5EkvtCV;E4EzvtCM;IAOI,2BAAA;E5EqvtCV;E4E5vtCM;IAOI,iCAAA;E5EwvtCV;E4E/vtCM;IAOI,gCAAA;E5E2vtCV;E4ElwtCM;IAOI,8BAAA;E5E8vtCV;E4ErwtCM;IAOI,gCAAA;E5EiwtCV;E4ExwtCM;IAOI,8BAAA;E5EowtCV;E4E3wtCM;IAOI,8BAAA;E5EuwtCV;E4E9wtCM;IAOI,yBAAA;E5E0wtCV;E4EjxtCM;IAOI,+BAAA;E5E6wtCV;E4EpxtCM;IAOI,8BAAA;E5EgxtCV;E4EvxtCM;IAOI,4BAAA;E5EmxtCV;E4E1xtCM;IAOI,8BAAA;E5EsxtCV;E4E7xtCM;IAOI,4BAAA;E5EyxtCV;E4EhytCM;IAOI,4BAAA;E5E4xtCV;E4EnytCM;IAOI,qBAAA;E5E+xtCV;E4EtytCM;IAOI,2BAAA;E5EkytCV;E4EzytCM;IAOI,0BAAA;E5EqytCV;E4E5ytCM;IAOI,wBAAA;E5EwytCV;E4E/ytCM;IAOI,0BAAA;E5E2ytCV;E4ElztCM;IAOI,wBAAA;E5E8ytCV;E4ErztCM;IAOI,2BAAA;IAAA,0BAAA;E5EkztCV;E4EzztCM;IAOI,iCAAA;IAAA,gCAAA;E5EsztCV;E4E7ztCM;IAOI,gCAAA;IAAA,+BAAA;E5E0ztCV;E4Ej0tCM;IAOI,8BAAA;IAAA,6BAAA;E5E8ztCV;E4Er0tCM;IAOI,gCAAA;IAAA,+BAAA;E5Ek0tCV;E4Ez0tCM;IAOI,8BAAA;IAAA,6BAAA;E5Es0tCV;E4E70tCM;IAOI,yBAAA;IAAA,4BAAA;E5E00tCV;E4Ej1tCM;IAOI,+BAAA;IAAA,kCAAA;E5E80tCV;E4Er1tCM;IAOI,8BAAA;IAAA,iCAAA;E5Ek1tCV;E4Ez1tCM;IAOI,4BAAA;IAAA,+BAAA;E5Es1tCV;E4E71tCM;IAOI,8BAAA;IAAA,iCAAA;E5E01tCV;E4Ej2tCM;IAOI,4BAAA;IAAA,+BAAA;E5E81tCV;E4Er2tCM;IAOI,yBAAA;E5Ei2tCV;E4Ex2tCM;IAOI,+BAAA;E5Eo2tCV;E4E32tCM;IAOI,8BAAA;E5Eu2tCV;E4E92tCM;IAOI,4BAAA;E5E02tCV;E4Ej3tCM;IAOI,8BAAA;E5E62tCV;E4Ep3tCM;IAOI,4BAAA;E5Eg3tCV;E4Ev3tCM;IAOI,2BAAA;E5Em3tCV;E4E13tCM;IAOI,iCAAA;E5Es3tCV;E4E73tCM;IAOI,gCAAA;E5Ey3tCV;E4Eh4tCM;IAOI,8BAAA;E5E43tCV;E4En4tCM;IAOI,gCAAA;E5E+3tCV;E4Et4tCM;IAOI,8BAAA;E5Ek4tCV;E4Ez4tCM;IAOI,4BAAA;E5Eq4tCV;E4E54tCM;IAOI,kCAAA;E5Ew4tCV;E4E/4tCM;IAOI,iCAAA;E5E24tCV;E4El5tCM;IAOI,+BAAA;E5E84tCV;E4Er5tCM;IAOI,iCAAA;E5Ei5tCV;E4Ex5tCM;IAOI,+BAAA;E5Eo5tCV;E4E35tCM;IAOI,0BAAA;E5Eu5tCV;E4E95tCM;IAOI,gCAAA;E5E05tCV;E4Ej6tCM;IAOI,+BAAA;E5E65tCV;E4Ep6tCM;IAOI,6BAAA;E5Eg6tCV;E4Ev6tCM;IAOI,+BAAA;E5Em6tCV;E4E16tCM;IAOI,6BAAA;E5Es6tCV;E4E76tCM;IAOI,iBAAA;E5Ey6tCV;E4Eh7tCM;IAOI,uBAAA;E5E46tCV;E4En7tCM;IAOI,sBAAA;E5E+6tCV;E4Et7tCM;IAOI,oBAAA;E5Ek7tCV;E4Ez7tCM;IAOI,sBAAA;E5Eq7tCV;E4E57tCM;IAOI,oBAAA;E5Ew7tCV;E4E/7tCM;IAOI,qBAAA;E5E27tCV;E4El8tCM;IAOI,2BAAA;E5E87tCV;E4Er8tCM;IAOI,0BAAA;E5Ei8tCV;E4Ex8tCM;IAOI,wBAAA;E5Eo8tCV;E4E38tCM;IAOI,0BAAA;E5Eu8tCV;E4E98tCM;IAOI,wBAAA;E5E08tCV;E4Ej9tCM;IAOI,wBAAA;E5E68tCV;E4Ep9tCM;IAOI,8BAAA;E5Eg9tCV;E4Ev9tCM;IAOI,6BAAA;E5Em9tCV;E4E19tCM;IAOI,2BAAA;E5Es9tCV;E4E79tCM;IAOI,6BAAA;E5Ey9tCV;E4Eh+tCM;IAOI,2BAAA;E5E49tCV;E4En+tCM;IAOI,2BAAA;E5E+9tCV;E4Et+tCM;IAOI,4BAAA;E5Ek+tCV;E4Ez+tCM;IAOI,6BAAA;E5Eq+tCV;AACF;AkBh/tCI;E0DGI;IAOI,sBAAA;E5E0+tCV;E4Ej/tCM;IAOI,uBAAA;E5E6+tCV;E4Ep/tCM;IAOI,sBAAA;E5Eg/tCV;E4Ev/tCM;IAOI,8BAAA;E5Em/tCV;E4E1/tCM;IAOI,4BAAA;E5Es/tCV;E4E7/tCM;IAOI,2BAAA;E5Ey/tCV;E4EhguCM;IAOI,iCAAA;E5E4/tCV;E4EnguCM;IAOI,2BAAA;E5E+/tCV;E4EtguCM;IAOI,0BAAA;E5EkguCV;E4EzguCM;IAOI,gCAAA;E5EqguCV;E4E5guCM;IAOI,yBAAA;E5EwguCV;E4E/guCM;IAOI,wBAAA;E5E2guCV;E4ElhuCM;IAOI,+BAAA;E5E8guCV;E4ErhuCM;IAOI,yBAAA;E5EihuCV;E4ExhuCM;IAOI,6BAAA;E5EohuCV;E4E3huCM;IAOI,8BAAA;E5EuhuCV;E4E9huCM;IAOI,wBAAA;E5E0huCV;E4EjiuCM;IAOI,+BAAA;E5E6huCV;E4EpiuCM;IAOI,wBAAA;E5EgiuCV;E4EviuCM;IAOI,yBAAA;E5EmiuCV;E4E1iuCM;IAOI,8BAAA;E5EsiuCV;E4E7iuCM;IAOI,iCAAA;E5EyiuCV;E4EhjuCM;IAOI,sCAAA;E5E4iuCV;E4EnjuCM;IAOI,yCAAA;E5E+iuCV;E4EtjuCM;IAOI,uBAAA;E5EkjuCV;E4EzjuCM;IAOI,uBAAA;E5EqjuCV;E4E5juCM;IAOI,yBAAA;E5EwjuCV;E4E/juCM;IAOI,yBAAA;E5E2juCV;E4ElkuCM;IAOI,0BAAA;E5E8juCV;E4ErkuCM;IAOI,4BAAA;E5EikuCV;E4ExkuCM;IAOI,kCAAA;E5EokuCV;E4E3kuCM;IAOI,sCAAA;E5EukuCV;E4E9kuCM;IAOI,oCAAA;E5E0kuCV;E4EjluCM;IAOI,kCAAA;E5E6kuCV;E4EpluCM;IAOI,yCAAA;E5EgluCV;E4EvluCM;IAOI,wCAAA;E5EmluCV;E4E1luCM;IAOI,wCAAA;E5EsluCV;E4E7luCM;IAOI,kCAAA;E5EyluCV;E4EhmuCM;IAOI,gCAAA;E5E4luCV;E4EnmuCM;IAOI,8BAAA;E5E+luCV;E4EtmuCM;IAOI,gCAAA;E5EkmuCV;E4EzmuCM;IAOI,+BAAA;E5EqmuCV;E4E5muCM;IAOI,oCAAA;E5EwmuCV;E4E/muCM;IAOI,kCAAA;E5E2muCV;E4ElnuCM;IAOI,gCAAA;E5E8muCV;E4ErnuCM;IAOI,uCAAA;E5EinuCV;E4ExnuCM;IAOI,sCAAA;E5EonuCV;E4E3nuCM;IAOI,iCAAA;E5EunuCV;E4E9nuCM;IAOI,2BAAA;E5E0nuCV;E4EjouCM;IAOI,iCAAA;E5E6nuCV;E4EpouCM;IAOI,+BAAA;E5EgouCV;E4EvouCM;IAOI,6BAAA;E5EmouCV;E4E1ouCM;IAOI,+BAAA;E5EsouCV;E4E7ouCM;IAOI,8BAAA;E5EyouCV;E4EhpuCM;IAOI,oBAAA;E5E4ouCV;E4EnpuCM;IAOI,mBAAA;E5E+ouCV;E4EtpuCM;IAOI,mBAAA;E5EkpuCV;E4EzpuCM;IAOI,mBAAA;E5EqpuCV;E4E5puCM;IAOI,mBAAA;E5EwpuCV;E4E/puCM;IAOI,mBAAA;E5E2puCV;E4ElquCM;IAOI,mBAAA;E5E8puCV;E4ErquCM;IAOI,mBAAA;E5EiquCV;E4ExquCM;IAOI,oBAAA;E5EoquCV;E4E3quCM;IAOI,0BAAA;E5EuquCV;E4E9quCM;IAOI,yBAAA;E5E0quCV;E4EjruCM;IAOI,uBAAA;E5E6quCV;E4EpruCM;IAOI,yBAAA;E5EgruCV;E4EvruCM;IAOI,uBAAA;E5EmruCV;E4E1ruCM;IAOI,uBAAA;E5EsruCV;E4E7ruCM;IAOI,0BAAA;IAAA,yBAAA;E5E0ruCV;E4EjsuCM;IAOI,gCAAA;IAAA,+BAAA;E5E8ruCV;E4ErsuCM;IAOI,+BAAA;IAAA,8BAAA;E5EksuCV;E4EzsuCM;IAOI,6BAAA;IAAA,4BAAA;E5EssuCV;E4E7suCM;IAOI,+BAAA;IAAA,8BAAA;E5E0suCV;E4EjtuCM;IAOI,6BAAA;IAAA,4BAAA;E5E8suCV;E4ErtuCM;IAOI,6BAAA;IAAA,4BAAA;E5EktuCV;E4EztuCM;IAOI,wBAAA;IAAA,2BAAA;E5EstuCV;E4E7tuCM;IAOI,8BAAA;IAAA,iCAAA;E5E0tuCV;E4EjuuCM;IAOI,6BAAA;IAAA,gCAAA;E5E8tuCV;E4EruuCM;IAOI,2BAAA;IAAA,8BAAA;E5EkuuCV;E4EzuuCM;IAOI,6BAAA;IAAA,gCAAA;E5EsuuCV;E4E7uuCM;IAOI,2BAAA;IAAA,8BAAA;E5E0uuCV;E4EjvuCM;IAOI,2BAAA;IAAA,8BAAA;E5E8uuCV;E4ErvuCM;IAOI,wBAAA;E5EivuCV;E4ExvuCM;IAOI,8BAAA;E5EovuCV;E4E3vuCM;IAOI,6BAAA;E5EuvuCV;E4E9vuCM;IAOI,2BAAA;E5E0vuCV;E4EjwuCM;IAOI,6BAAA;E5E6vuCV;E4EpwuCM;IAOI,2BAAA;E5EgwuCV;E4EvwuCM;IAOI,2BAAA;E5EmwuCV;E4E1wuCM;IAOI,0BAAA;E5EswuCV;E4E7wuCM;IAOI,gCAAA;E5EywuCV;E4EhxuCM;IAOI,+BAAA;E5E4wuCV;E4EnxuCM;IAOI,6BAAA;E5E+wuCV;E4EtxuCM;IAOI,+BAAA;E5EkxuCV;E4EzxuCM;IAOI,6BAAA;E5EqxuCV;E4E5xuCM;IAOI,6BAAA;E5EwxuCV;E4E/xuCM;IAOI,2BAAA;E5E2xuCV;E4ElyuCM;IAOI,iCAAA;E5E8xuCV;E4EryuCM;IAOI,gCAAA;E5EiyuCV;E4ExyuCM;IAOI,8BAAA;E5EoyuCV;E4E3yuCM;IAOI,gCAAA;E5EuyuCV;E4E9yuCM;IAOI,8BAAA;E5E0yuCV;E4EjzuCM;IAOI,8BAAA;E5E6yuCV;E4EpzuCM;IAOI,yBAAA;E5EgzuCV;E4EvzuCM;IAOI,+BAAA;E5EmzuCV;E4E1zuCM;IAOI,8BAAA;E5EszuCV;E4E7zuCM;IAOI,4BAAA;E5EyzuCV;E4Eh0uCM;IAOI,8BAAA;E5E4zuCV;E4En0uCM;IAOI,4BAAA;E5E+zuCV;E4Et0uCM;IAOI,4BAAA;E5Ek0uCV;E4Ez0uCM;IAOI,qBAAA;E5Eq0uCV;E4E50uCM;IAOI,2BAAA;E5Ew0uCV;E4E/0uCM;IAOI,0BAAA;E5E20uCV;E4El1uCM;IAOI,wBAAA;E5E80uCV;E4Er1uCM;IAOI,0BAAA;E5Ei1uCV;E4Ex1uCM;IAOI,wBAAA;E5Eo1uCV;E4E31uCM;IAOI,2BAAA;IAAA,0BAAA;E5Ew1uCV;E4E/1uCM;IAOI,iCAAA;IAAA,gCAAA;E5E41uCV;E4En2uCM;IAOI,gCAAA;IAAA,+BAAA;E5Eg2uCV;E4Ev2uCM;IAOI,8BAAA;IAAA,6BAAA;E5Eo2uCV;E4E32uCM;IAOI,gCAAA;IAAA,+BAAA;E5Ew2uCV;E4E/2uCM;IAOI,8BAAA;IAAA,6BAAA;E5E42uCV;E4En3uCM;IAOI,yBAAA;IAAA,4BAAA;E5Eg3uCV;E4Ev3uCM;IAOI,+BAAA;IAAA,kCAAA;E5Eo3uCV;E4E33uCM;IAOI,8BAAA;IAAA,iCAAA;E5Ew3uCV;E4E/3uCM;IAOI,4BAAA;IAAA,+BAAA;E5E43uCV;E4En4uCM;IAOI,8BAAA;IAAA,iCAAA;E5Eg4uCV;E4Ev4uCM;IAOI,4BAAA;IAAA,+BAAA;E5Eo4uCV;E4E34uCM;IAOI,yBAAA;E5Eu4uCV;E4E94uCM;IAOI,+BAAA;E5E04uCV;E4Ej5uCM;IAOI,8BAAA;E5E64uCV;E4Ep5uCM;IAOI,4BAAA;E5Eg5uCV;E4Ev5uCM;IAOI,8BAAA;E5Em5uCV;E4E15uCM;IAOI,4BAAA;E5Es5uCV;E4E75uCM;IAOI,2BAAA;E5Ey5uCV;E4Eh6uCM;IAOI,iCAAA;E5E45uCV;E4En6uCM;IAOI,gCAAA;E5E+5uCV;E4Et6uCM;IAOI,8BAAA;E5Ek6uCV;E4Ez6uCM;IAOI,gCAAA;E5Eq6uCV;E4E56uCM;IAOI,8BAAA;E5Ew6uCV;E4E/6uCM;IAOI,4BAAA;E5E26uCV;E4El7uCM;IAOI,kCAAA;E5E86uCV;E4Er7uCM;IAOI,iCAAA;E5Ei7uCV;E4Ex7uCM;IAOI,+BAAA;E5Eo7uCV;E4E37uCM;IAOI,iCAAA;E5Eu7uCV;E4E97uCM;IAOI,+BAAA;E5E07uCV;E4Ej8uCM;IAOI,0BAAA;E5E67uCV;E4Ep8uCM;IAOI,gCAAA;E5Eg8uCV;E4Ev8uCM;IAOI,+BAAA;E5Em8uCV;E4E18uCM;IAOI,6BAAA;E5Es8uCV;E4E78uCM;IAOI,+BAAA;E5Ey8uCV;E4Eh9uCM;IAOI,6BAAA;E5E48uCV;E4En9uCM;IAOI,iBAAA;E5E+8uCV;E4Et9uCM;IAOI,uBAAA;E5Ek9uCV;E4Ez9uCM;IAOI,sBAAA;E5Eq9uCV;E4E59uCM;IAOI,oBAAA;E5Ew9uCV;E4E/9uCM;IAOI,sBAAA;E5E29uCV;E4El+uCM;IAOI,oBAAA;E5E89uCV;E4Er+uCM;IAOI,qBAAA;E5Ei+uCV;E4Ex+uCM;IAOI,2BAAA;E5Eo+uCV;E4E3+uCM;IAOI,0BAAA;E5Eu+uCV;E4E9+uCM;IAOI,wBAAA;E5E0+uCV;E4Ej/uCM;IAOI,0BAAA;E5E6+uCV;E4Ep/uCM;IAOI,wBAAA;E5Eg/uCV;E4Ev/uCM;IAOI,wBAAA;E5Em/uCV;E4E1/uCM;IAOI,8BAAA;E5Es/uCV;E4E7/uCM;IAOI,6BAAA;E5Ey/uCV;E4EhgvCM;IAOI,2BAAA;E5E4/uCV;E4EngvCM;IAOI,6BAAA;E5E+/uCV;E4EtgvCM;IAOI,2BAAA;E5EkgvCV;E4EzgvCM;IAOI,2BAAA;E5EqgvCV;E4E5gvCM;IAOI,4BAAA;E5EwgvCV;E4E/gvCM;IAOI,6BAAA;E5E2gvCV;AACF;A6ElkvCA;ED+CQ;IAOI,gCAAA;E5EghvCV;E4EvhvCM;IAOI,8BAAA;E5EmhvCV;E4E1hvCM;IAOI,iCAAA;E5EshvCV;E4E7hvCM;IAOI,+BAAA;E5EyhvCV;AACF;A6E7jvCA;ED4BQ;IAOI,0BAAA;E5E8hvCV;E4ErivCM;IAOI,gCAAA;E5EiivCV;E4ExivCM;IAOI,yBAAA;E5EoivCV;E4E3ivCM;IAOI,wBAAA;E5EuivCV;E4E9ivCM;IAOI,+BAAA;E5E0ivCV;E4EjjvCM;IAOI,yBAAA;E5E6ivCV;E4EpjvCM;IAOI,6BAAA;E5EgjvCV;E4EvjvCM;IAOI,8BAAA;E5EmjvCV;E4E1jvCM;IAOI,wBAAA;E5EsjvCV;E4E7jvCM;IAOI,+BAAA;E5EyjvCV;E4EhkvCM;IAOI,wBAAA;E5E4jvCV;AACF;A8EtovCA;;eAAA;AAIA;EACE,kBAAA;EACA,gBAAA;A9EuovCF;;A8EpovCA;;EAEE,cpEkCS;EoEjCT,sCpEUsB;EoETtB,gBpEMqB;AViovCvB;;A8EpovCA;EACE,gCAAA;A9EuovCF;;A8EpovCA;EACE,gBAAA;A9EuovCF;;A8EpovCA;EACE;IACE,iBAAA;E9EuovCF;AACF;A+E3pvCI;EACI,sDAAA;A/E6pvCR;;A+E9pvCI;EACI,sDAAA;A/EiqvCR;;A+ElqvCI;EACI,oDAAA;A/EqqvCR;;A+EtqvCI;EACI,qDAAA;A/EyqvCR;;A+E1qvCI;EACI,sDAAA;A/E6qvCR;;A+E9qvCI;EACI,qDAAA;A/EirvCR;;A+ElrvCI;EACI,sDAAA;A/EqrvCR;;A+EtrvCI;EACI,mDAAA;A/EyrvCR;;AgFxqvCE;EAnBA,ctEiGa;EsEhGb,2CAAA;AhF+rvCF;AgF7rvCE;EACE,ctE6FW;EsE5FX,qBAAA;EACA,0CAAA;AhF+rvCJ;;AgFlrvCE;EAnBA,ctEiGa;EsEhGb,2CAAA;AhFysvCF;AgFvsvCE;EACE,ctE6FW;EsE5FX,qBAAA;EACA,0CAAA;AhFysvCJ;;AgF5rvCE;EAnBA,ctEiGa;EsEhGb,yCAAA;AhFmtvCF;AgFjtvCE;EACE,ctE6FW;EsE5FX,qBAAA;EACA,wCAAA;AhFmtvCJ;;AgFtsvCE;EAnBA,ctEiGa;EsEhGb,0CAAA;AhF6tvCF;AgF3tvCE;EACE,ctE6FW;EsE5FX,qBAAA;EACA,yCAAA;AhF6tvCJ;;AgFhtvCE;EAnBA,ctEiGa;EsEhGb,2CAAA;AhFuuvCF;AgFruvCE;EACE,ctE6FW;EsE5FX,qBAAA;EACA,0CAAA;AhFuuvCJ;;AgF1tvCE;EAnBA,ctEiGa;EsEhGb,0CAAA;AhFivvCF;AgF/uvCE;EACE,ctE6FW;EsE5FX,qBAAA;EACA,yCAAA;AhFivvCJ;;AgFpuvCE;EAnBA,ctEiGa;EsEhGb,2CAAA;AhF2vvCF;AgFzvvCE;EACE,ctE6FW;EsE5FX,qBAAA;EACA,0CAAA;AhF2vvCJ;;AgF9uvCE;EAnBA,ctEiGa;EsEhGb,wCAAA;AhFqwvCF;AgFnwvCE;EACE,ctE6FW;EsE5FX,qBAAA;EACA,uCAAA;AhFqwvCJ;;AgFjvvCA;EACE,ctESS;AV2uvCX;;AiFjxvCA;EACE,wBAAA;AjFoxvCF;;AiF/wvCA;EACE,mBAAA;EACA,mBAAA;AjFkxvCF;;AiF9wvCA;EACE,yBAAA;AjFixvCF;;AiF9wvCA;EACE,cvE0BS;AVuvvCX;;AiF9wvCA;EACE,SAAA;AjFixvCF;;AkFlyvCI;EACI,cxEoCG;AViwvCX;AkFlyvCQ;EACI,oCAAA;AlFoyvCZ;;AmF7yvCA;EACE,mBzE2VkB;AVq9uCpB;;AmF7yvCA;EACE,czEoCS;AV4wvCX;;AmF7yvCA;EACE,eAAA;EACA,iBAAA;EACA,gBzEIqB;AV4yvCvB;;AmF7yvCA;EACE,czEyBS;EyExBT,mBAAA;AnFgzvCF;;AoFh0vCA;EACE,4C1E2Xc;E0E1Xd,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;ApFm0vCF;AoFj0vCE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;ApFm0vCJ;AoFh0vCE;EACE,iCAAA;ApFk0vCJ;;AoF9zvCA;EACE;IACE,gBAAA;EpFi0vCF;EoF/zvCA;IACE,eAAA;EpFi0vCF;AACF;AoF9zvCA;EACE;IACE,gBAAA;EpFg0vCF;EoF9zvCA;IACE,kBAAA;EpFg0vCF;AACF;AoFzzvCA;EACE,mBAAA;EACA,qBAAA;ApF2zvCF;;AoFxzvCA;EACE;IACE,YAAA;EpF2zvCF;EoFxzvCA;IACE,YAAA;EpF0zvCF;AACF;AoFvzvCA;EACE,yB1EpBS;AV60vCX;;AqFh3vCM;EACI,c3EsCC;E2ErCD,gB3EUW;AVy2vCrB;;AqF72vCE;EACI,c3E8BK;E2E7BL,gB3EEe;AV82vCrB;;AqF32vCA;EACE,gCAAA;ArF82vCF;AqF52vCE;EACE,kBAAA;EACA,c3EoBO;AV01vCX;AqF72vCI;EACE,YAAA;ArF+2vCN;AqF72vCM;EACE,WAAA;EACA,mB3EgCD;E2E/BC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;ArF+2vCR;AqF52vCM;EACE,c3EqBD;AVy1vCP;AqF72vCQ;EACE,mBAAA;ArF+2vCV;;AqFl2vCM;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;ArFq2vCV;AqFp2vCU;EACI,eAAA;ArFs2vCd;;AsFh6vCE;EACI,gB5Eyaa;AV0/uCnB;;AsF75vCE;EACI,iCAAA;AtFg6vCN;;AsF35vCE;EACE,mBAAA;AtF85vCJ;;AuF36vCI;EACI,8BAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AvF86vCR;;AwFv7vCA;EACE,WAAA;AxF07vCF;;AwFr7vCA;EACE,WAAA;AxFw7vCF;;AwFn7vCA;EACE,YAAA;AxFs7vCF;;AwFl7vCA;EACE,YAAA;AxFq7vCF;;AyF58vCA;;;;;;;CAAA;ACCA;;;;;;uDAAA;AAOC;EACG,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,wCAAA;A1Fs9vCJ;;A0Fp9vCE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EAIA,qJAAA;EAIA,6BAAA;EAIA,uCAAA;EAKA,mCAAA;EACA,oBAAA;A1Fu9vCJ;;A0Fr9vCE;EACE,oCAAA;EAIA,6KAAA;A1Fw9vCJ;;A0Ft9vCE;EACE,8BAAA;A1Fy9vCJ;;A0Fv9vCE;EACE,oCAAA;A1F09vCJ;;A0Fx9vCE;EAIE,2BAAA;A1F29vCJ;;A0Fz9vCE;;EAME,wBAAA;EACA,2EAAA;A1F49vCJ;;A0F19vCE;;;;EAIE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;A1F69vCJ;;A0F39vCE;EACE,qBAAA;EACA,oBAAA;A1F89vCJ;;A0F59vCE;EACE,SAAA;EACA,qBAAA;A1F+9vCJ;;A0F79vCE;EACE,oBAAA;EACA,sBAAA;A1Fg+vCJ;;A0F99vCE;EACE,UAAA;A1Fi+vCJ;;A0F/9vCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;A1Fk+vCJ;;A0Fh+vCE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;A1Fm+vCJ;;A0Fj+vCE;EACE,wBAAA;EAEA,iDAAA;EAIA,qBAAA;A1Fo+vCJ;;A0Fl+vCE;EAEE,+CAAA;A1Fq+vCJ;;A0Fn+vCE;EACE,cAAA;A1Fs+vCJ;;A0Fl+vCI;EACI,0CAAA;A1Fq+vCR;;A0Fh+vCI;EACI,0CAAA;A1Fm+vCR;;A0F/9vCI;EACI,wCAAA;A1Fk+vCR;;A0F99vCI;EACI,yCAAA;A1Fi+vCR;;A0F79vCI;EACI,0CAAA;A1Fg+vCR;;A0F59vCI;EACI,yCAAA;A1F+9vCR;;A2FhowCA;EACE,cAAA;EACA,aAAA;A3FmowCF;;A2FhowCA;EACE,YAAA;EACA,WAAA;A3FmowCF;;A2FhowCA;EACE,cAAA;EACA,aAAA;A3FmowCF;;A2FhowCA;EACE,YAAA;EACA,WAAA;A3FmowCF;;A2FhowCA;EACE,cAAA;EACA,aAAA;A3FmowCF;;A2FhowCA;EACE,mBAAA;EACA,yBjFiCK;EiFhCL,WjFMM;EiFLN,aAAA;EACA,gBjFhBmB;EiFiBnB,YAAA;EACA,uBAAA;EACA,WAAA;A3FmowCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FpqwCA;EACE,0BAAA;A5FuqwCF;;A4FlqwCA;EACE,gBlFrCmB;AV0swCrB;;A4FlqwCA;EACE,gBlFxCqB;AV6swCvB;;A4FhqwCA;EACE,YAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,clF5BS;EkF6BT,kBAAA;EACA,oBAAA;A5FmqwCF;A4FlqwCE;EACE,clF/BO;EkFgCP,yBlFpCO;AVwswCX;;A4F/pwCA;EACE,eAAA;A5FkqwCF;;A4FhqwCA;EACE,eAAA;A5FmqwCF;;A4FjqwCA;EACE,gBAAA;A5FoqwCF;;A4FlqwCA;EACE,gBAAA;A5FqqwCF;;A4FlqwCA;EACE,gBAAA;A5FqqwCF;;A4FlqwCA;EACE,oBAAA;A5FqqwCF;;A6FjwwCQ;EACI,kBAAA;A7FowwCZ;A6F/vwCQ;EACI,eAAA;A7FiwwCZ;A6F7vwCgB;EACI,iBAAA;A7F+vwCpB;;A6FvvwCI;EACI,iBAAA;EACA,eAAA;A7F0vwCR;;A8F9wwCC;;;;EACE,gBAAA,EAAA,aAAA;A9FoxwCH;;A8FzwwCM;EACE,yBpFiFO;EoFhFP,qBpFgFO;AV4rwCf;;A8F9wwCM;EACE,yBpFiFO;EoFhFP,qBpFgFO;AViswCf;;A8FnxwCM;EACE,yBpFiFO;EoFhFP,qBpFgFO;AVsswCf;;A8FxxwCM;EACE,yBpFiFO;EoFhFP,qBpFgFO;AV2swCf;;A8F7xwCM;EACE,yBpFiFO;EoFhFP,qBpFgFO;AVgtwCf;;A8FlywCM;EACE,yBpFiFO;EoFhFP,qBpFgFO;AVqtwCf;;A8FvywCM;EACE,yBpFiFO;EoFhFP,qBpFgFO;AV0twCf;;A8F5ywCM;EACE,yBpFiFO;EoFhFP,qBpFgFO;AV+twCf;;A8FtywCI;EACE,cpFaK;AV4xwCX;;A8FnywCA;EACE,eAAA;A9FsywCF;;A8F9xwCA;EACE,kBAAA;A9FiywCF;A8FhywCE;EACE,iBAAA;A9FkywCJ;A8FjywCI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;A9FmywCN;A8FjywCI;EACE,WAAA;EACA,YAAA;EACA,uBAAA;A9FmywCN;A8FhywCE;EACE,8BAAA;A9FkywCJ;;A8F7xwCA;EACE,qBAAA;A9FgywCF;A8F/xwCE;EACE,iBAAA;A9FiywCJ;A8FhywCI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;A9FkywCN;A8FhywCI;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;A9FkywCN;A8F/xwCE;EACE,6BAAA;A9FiywCJ;;A8F5xwCA;EACE,sBpFxDM;AVu1wCR;;A+F73wCA;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;A/Fg4wCF;;A+F73wCA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;A/Fg4wCF;;A+F73wCA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;A/Fg4wCF;;A+F73wCA;EACE,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;A/Fg4wCF;;A+F73wCA;EACE,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mGAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,mFAAA;EACA,eAAA;EACA,kDAAA;EACA,gBAAA;EACA,0CAAA;EACA,qBAAA;EACA,uBAAA;A/Fg4wCF;;A+F73wCA;;EAEE,aAAA;A/Fg4wCF;;A+F73wCA;;EAEE,YAAA;EACA,cAAA;A/Fg4wCF;;A+F73wCA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;A/Fg4wCF;;A+F73wCA;EACE,8BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;A/Fg4wCF;;A+F73wCA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;A/Fg4wCF;;A+F73wCA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;A/Fg4wCF;;A+F73wCA;EACE,oBAAA;EACA,iBAAA;EACA,yBAAA;A/Fg4wCF;;A+F73wCA;EACE,mBAAA;A/Fg4wCF;;A+F73wCA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;A/Fg4wCF;;A+F73wCA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;A/Fg4wCF;;A+F73wCA;EACE,0DAAA;EACA,YAAA;EACA,6BAAA;A/Fg4wCF;;A+F73wCA;EACE,MAAA;EACA,WAAA;A/Fg4wCF;;A+F73wCA;EACE,QAAA;EACA,WAAA;A/Fg4wCF;;A+F73wCA;EACE,OAAA;EACA,YAAA;A/Fg4wCF;;A+F73wCA;EACE,YAAA;EACA,SAAA;EACA,UAAA;A/Fg4wCF;;A+F73wCA;EACE,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;A/Fg4wCF;;A+F73wCA,gBAAA;AACA;EACE,WAAA;EACA,OAAA;A/Fg4wCF;;A+F73wCA;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A/Fg4wCF;;A+F73wCA;EACE,eAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;A/Fg4wCF;;A+F73wCA;EACE,YAAA;A/Fg4wCF;;AgGrlxCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AhGwlxCF;AgGtlxCE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AhGwlxCJ;;AgGplxCA;EACE,WAAA;EAKA,yBAAA;EACA,aAAA;EACA,UAAA;AhGmlxCF;AgGhlxCE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AhGklxCJ;AgGhlxCI;EACE,eAAA;EACA,cAAA;AhGklxCN;AgG9kxCE;EAtBF;IAuBI,eAAA;IACA,SAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EhGilxCF;EgG/kxCE;IACE,cAAA;EhGilxCJ;EgG7kxCI;IACE,aAAA;EhG+kxCN;AACF;AgG3kxCE;EACE,kBAAA;AhG6kxCJ;AgG3kxCI;EAHF;IAII,aAAA;EhG8kxCJ;AACF;AgG5kxCI;EACE,iBAAA;AhG8kxCN;AgG3kxCI;EACE,ctF1DU;AVuoxChB;AgG1kxCI;EACE,atF/DS;AV2oxCf;AgGvkxCI;EACE,gBtFtDY;AV+nxClB;;AgGlkxCE;EACE,cAAA;AhGqkxCJ;AgGlkxCE;EACE,WAAA;EACA,QAAA;EACA,YAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AhGokxCJ;AgGlkxCI;EACE,sBAAA;AhGokxCN;AgGjkxCI;EACE,YAAA;EACA,oBAAA;EACA,eAAA;AhGmkxCN;;AiGlrxCA;EACE,sBAAA;EACA,aAAA;EACA,YAAA;EACA,+BAAA;AjGqrxCF;AiGnrxCE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,gCAAA;EACA,oBAAA;AjGqrxCJ;AiGnrxCI;EACE,kBAAA;EACA,cAAA;AjGqrxCN;AiGnrxCM;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AjGqrxCR;AiGlrxCM;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AjGorxCR;AiGlrxCQ;EACE,WAAA;EACA,YAAA;AjGorxCV;AiGjrxCQ;EACE,aAAA;AjGmrxCV;AiG/qxCM;EACE,cAAA;AjGirxCR;AiG7qxCI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AjG+qxCN;AiG5qxCI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AjG8qxCN;AiG1qxCE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;EACA,aAAA;EACA,YAAA;AjG4qxCJ;AiG1qxCI;;EAEE,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;AjG4qxCN;AiGzqxCI;EACE,mBAAA;AjG2qxCN;AiGxqxCI;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AjG0qxCN;AiGvqxCI;EACE,eAAA;EACA,mBAAA;AjGyqxCN;AiGlqxCE;EAvGF;IAwGI,WAAA;EjGqqxCF;AACF;AiGnqxCE;EACE,yBvFtEO;EuFuEP,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AjGqqxCJ;AiGnqxCI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AjGqqxCN;;AiG/pxCE;EACE,8BAAA;AjGkqxCJ;AiG/pxCE;EACE,SAAA;AjGiqxCJ;AiG9pxCE;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;AjGgqxCJ;;AiG5pxCA;EACE,2BAAA;AjG+pxCF;AiG7pxCE;EAHF;IAII,2BAAA;EjGgqxCF;AACF;;AiG7hxCA;EACE,SAAA;AjGgixCF;AiG5hxCM;EACE,yBvFrPG;AVmxxCX;AiG1hxCI;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,cvF3PK;EuF4PL,oBAAA;EACA,6BAAA;EACA,kBAAA;AjG4hxCN;AiG1hxCM;EACE,yBvFnQG;AV+xxCX;AiGxhxCI;EACE,eAAA;AjG0hxCN;AiGthxCM;EACE,cvFvPD;EuFwPC,gBvFtSa;AV8zxCrB;AiGthxCQ;EACE,yBvF3PH;AVmxxCP;AiGnhxCI;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AjGqhxCN;AiGnhxCM;EACE,iBAAA;EACA,gBvFtTe;EuFuTf,eAAA;AjGqhxCR;;AiG/gxCA;EACE,kBAAA;AjGkhxCF;AiGhhxCE;EACE,WAAA;EACA,YAAA;EACA,yBvF3SO;EuF4SP,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EAEA,SAAA;AjGihxCJ;AiG7gxCI;EACE,yBvF3RE;AV0yxCR;AiG1gxCI;EACE,yBvFlSG;AV8yxCT;;AiGpgxCE;EACE,eAAA;EACA,kBAAA;AjGugxCJ;;AiGjgxCA;EACE,kBAAA;EACA,qBAAA;AjGogxCF;AiGlgxCE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;AjGogxCJ;;AkGp3xCM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AlGu3xCR;AkG/1xCU;EACE,eAAA;EACA,mBAAA;AlGi2xCZ;AkG91xCU;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AlGg2xCZ;AkG11xCQ;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AlG41xCV;AkGt1xCM;EACE,kBAAA;AlGw1xCR;AkGt1xCQ;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;AlGw1xCV;AkGt1xCU;EACE,aAAA;AlGw1xCZ;AkGp1xCQ;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AlGs1xCV;AkGp1xCU;EACE,UAAA;EACA,sBAAA;EACA,cAAA;AlGs1xCZ;AkGl1xCQ;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AlGo1xCV;AkGh1xCM;EACE,YAAA;EACA,WAAA;EACA,oBAAA;AlGk1xCR;AkGh1xCQ;EACE,UAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AlGk1xCV;;AkG30xCA;EACE,cAAA;AlG80xCF;AkG50xCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AlG80xCJ;AkG50xCI;EACE,aAAA;AlG80xCN;AkG50xCM;EACE,yBAAA;AlG80xCR;AkGz0xCE;EACE,kBAAA;AlG20xCJ;AkGz0xCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AlG20xCN;AkGv0xCE;EACE,kBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AlGw0xCJ;AkGt0xCI;EAGE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AlGs0xCN;AkGtzxCI;EACE,eAAA;AlGwzxCN;AkGpzxCE;EAEE,aAAA;EAGA,UAAA;AlGmzxCJ;AkGjzxCI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AlGmzxCN;AkGjzxCM;EACE,WAAA;EACA,YAAA;EACA,cAAA;AlGmzxCR;AkG/yxCI;EACE,iBAAA;EACA,yBAAA;EACA,4BAAA;EACA,sBAAA;EACA,qBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AlGgzxCN;AkGlyxCI;EACE,gBxFpOe;EwFqOf,eAAA;AlGoyxCN;AkGhyxCM;EACE,eAAA;EACA,YAAA;EACA,cxFlNG;AVo/xCX;AkGhyxCQ;EALF;IAMI,aAAA;ElGmyxCR;AACF;AkG/xxCI;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AlGiyxCN;AkG9xxCI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AlGgyxCN;AkG7xxCI;EACE,qBAAA;EACA,kBAAA;AlG+xxCN;AkG7xxCM;EACE,kBAAA;AlG+xxCR;AkG5xxCM;EACE,gBAAA;AlG8xxCR;AkG3xxCM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;AlG6xxCR;AkG1xxCU;EACE,eAAA;EACA,WxFvQJ;EwFwQI,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AlG4xxCZ;AkGpxxCI;EACE,yBAAA;AlGsxxCN;AkGpxxCM;EACE,QAAA;EACA,yBAAA;EAGA,kBAAA;AlGoxxCR;AkGlxxCQ;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AlGoxxCV;AkGxwxCM;EACE,QAAA;AlG0wxCR;AkGtwxCI;EACE,yBxF3SK;AVmjyCX;;AkGlwxCE;EACE,SAAA;AlGqwxCJ;;AkGhwxCE;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBxFrUI;EwFsUJ,oCAAA;EACA,YAAA;AlGmwxCJ;AkGjwxCI;EACE,sBAAA;AlGmwxCN;AkGhwxCI;EACE,sBAAA;AlGkwxCN;;AkG7vxCA;EACE;IAGE,kBAAA;ElG8vxCF;EkG3vxCA;IACE,2BAAA;ElG6vxCF;AACF;AmGznyCA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AnG2nyCJ;AmGznyCI;EATJ;IAUQ,8BAAA;EnG4nyCN;AACF;AmG1nyCI;EAbJ;IAcQ,eAAA;IACA,QAAA;IACA,MAAA;IACA,WAAA;EnG6nyCN;AACF;AmG3nyCI;EApBJ;IAqBQ,eAAA;EnG8nyCN;AACF;AmG5nyCI;EACI,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AnG8nyCR;AmG5nyCQ;EACI,UAAA;EACA,kBAAA;EACA,QAAA;AnG8nyCZ;AmG3nyCQ;EACI,kBAAA;AnG6nyCZ;AmG3nyCY;EACI,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AnG6nyChB;AmGznyCQ;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AnG2nyCZ;AmGznyCY;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AnG2nyChB;AmGxnyCY;EACI,UAAA;EACA,kBAAA;EACA,QAAA;AnG0nyChB;AmGtnyCQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AnGwnyCZ;AmGrnyCQ;EACI,WAAA;EACA,mBAAA;AnGunyCZ;AmGrnyCY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AnGunyChB;AmGpnyCY;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AnGsnyChB;AmG9myCY;EACI,kBAAA;EACA,kBAAA;AnGgnyChB;AmG9myCgB;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AnGgnyCpB;AmG9myCoB;EACI,WAAA;EACA,YAAA;AnGgnyCxB;AmG7myCoB;EACI,aAAA;AnG+myCxB;AmG1myCY;EACI,WAAA;EACA,mBAAA;AnG4myChB;AmG1myCgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;AnG4myCpB;AmGzmyCgB;EACI,aAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AnG0myCpB;AmGxmyCoB;EACI,cAAA;AnG0myCxB;AmGvmyCoB;EACI,iBAAA;AnGymyCxB;AmGrmyCgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,8CAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AnGumyCpB;AmGpmyCgB;EACI,mBAAA;EACA,gBAAA;AnGsmyCpB;AmGnmyCgB;EACI,mBAAA;EACA,yBAAA;AnGqmyCpB;;AmG9lyCA;EACI,2BAAA;AnGimyCJ;AmG/lyCI;EAHJ;IAIQ,2BAAA;EnGkmyCN;AACF;;AAlxyCA;EACE,eAAA;AAqxyCF;;AAlxyCA;EACE,eAAA;AAqxyCF;;AAlxyCA;EACE,gBAAA;EACA,iBAAA;AAqxyCF;;AAlxyCA;EACE,aAAA;AAqxyCF;;AAlxyCA;EACE,uBAAA;AAqxyCF;;AAlxyCA;EACE,wBAAA;AAqxyCF;;AAlxyCA;EACE,uBAAA;AAqxyCF;;AAlxyCA;EACE,gBAAA;EACA,4BAAA;EACA,sBAAA;AAqxyCF;;AAjxyCE;EACE,gBAAA;AAoxyCJ;AAjxyCE;EACE,aAAA;AAmxyCJ;;AA/wyCA;EACE,iCAAA;AAkxyCF;;AA9wyCE;EACE,iCAAA;EACA,gCAAA;AAixyCJ;;AA5wyCE;EACE,iCAAA;EACA,cUtCO;AVqzyCX;;AAzwyCI;EACE,oCAAA;AA4wyCN;AAzwyCI;EACE,oCAAA;EACA,8BAAA;AA2wyCN;;AAtwyCA;EACE,qBAAA;AAywyCF;;AAtwyCA;EACE,iCAAA;AAywyCF;;AAtwyCA;EACE,WAAA;EACA,YAAA;AAywyCF;;AApwyCI;EACE,coGpHE;EpGqHF,qBAAA;EACA,yBUtDC;AV6zyCP;;AAjwyCE;;;EAGE,wBAAA;AAowyCJ;;AAhwyCA;EACE,uBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EAEA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAkwyCF;;AA/vyCA;EACE,WAAA;EACA,aAAA;AAkwyCF;;AA/vyCA;EACE,oBoGvJM;ApGy5yCR;;AA/vyCA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAkwyCF;AAhwyCE;EACE,cAAA;EACA,yBAAA;EACA,yBoG1KI;ApG46yCR;AAhwyCI;EACE,4DAAA;AAkwyCN;AA9vyCE;EACE,coGlLI;EpGmLJ,yBoG5KW;EpG6KX,yBAAA;AAgwyCJ;AA9vyCI;EACE,qDAAA;AAgwyCN","sourcesContent":["//Import Icon css\n@import './icons.scss';\n\n//light mode\n@import './bootstrap.scss';\n@import './app_.scss';\n\n// rtl mode\n\n// @import \"./custom/rtl/bootstrap-rtl\";\n// @import \"./custom/rtl/components-rtl\";\n// @import \"./custom/rtl/float-rtl\";\n// @import \"./custom/rtl/general-rtl.scss\";\n// @import \"./custom/rtl/pages-rtl\";\n// @import \"./custom/rtl/spacing-rtl\";\n// @import \"./custom/rtl/text-rtl\";\n\n// dark mode\n// @import \"./bootstrap-dark.scss\";\n// @import \"./app-dark.scss\";\n\n// my variables\n@import '../../variables.scss';\n\n.nav-item {\n  cursor: pointer;\n}\n\n.dropdown {\n  cursor: pointer;\n}\n\n.slick-slide {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n\n.slick-arrow {\n  display: none;\n}\n\n.emoji-mart {\n  border: none !important;\n}\n\n.emoji-mart-preview {\n  display: none !important;\n}\n\n.emoji-mart-bar {\n  border: none !important;\n}\n\n.alice-carousel__stage-item {\n  margin-left: 8px;\n  margin-right: 8px !important;\n  width: 71px !important;\n}\n\n.input-file {\n  label {\n    margin-bottom: 0;\n  }\n\n  input[type='file'] {\n    display: none;\n  }\n}\n\n.emoji-mart-light {\n  background-color: $card-bg !important;\n}\n\n.emoji-mart-search {\n  input {\n    background-color: $card-bg !important;\n    border-color: $card-border-color !important;\n  }\n}\n\n.emoji-mart-category-label {\n  span {\n    background-color: $card-bg !important;\n    color: $gray-700;\n  }\n}\n\n.emoji-mart-category {\n  .emoji-mart-emoji {\n    &:hover {\n      background-color: $gray-300 !important;\n    }\n\n    &::before {\n      background-color: $gray-300 !important;\n      border-radius: 100% !important;\n    }\n  }\n}\n\n.w-70 {\n  width: 73% !important;\n}\n\n.ctext-wrap-content {\n  animation: flyIn 0.6s ease-in-out;\n}\n\n.blank-div {\n  width: 36px;\n  height: 36px;\n}\n\n.profile-user-dropdown {\n  .dropdown-item {\n    &.active {\n      color: $white;\n      text-decoration: none;\n      background-color: $primary;\n    }\n  }\n}\n\n.dot_remove {\n  .alice-carousel__dots,\n  .alice-carousel__prev-btn,\n  .alice-carousel__next-btn {\n    display: none !important;\n  }\n}\n\n.close {\n  background: transparent;\n  border: 0;\n  font-size: 30px;\n  margin: 10px;\n  // background: transparent escape-svg($btn-close-bg-dark) center / $btn-close-width auto no-repeat;\n  position: absolute;\n  top: 0;\n  right: 0;\n  opacity: 0.5;\n  width: 1em;\n  height: 1em;\n  z-index: 2;\n}\n\n.main-page {\n  width: 100%;\n  display: flex;\n}\n\n.form-control {\n  caret-color: $black;\n}\n\n.button {\n  border-radius: 8px;\n  padding: 7px 23px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  box-shadow: 0px 3px 6px #28285a17;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  &.default {\n    color: #4a596a;\n    border: 1px solid #c4ccd6;\n    background-color: $white;\n\n    &:hover {\n      outline: 2px solid #28285a17 !important;\n    }\n  }\n\n  &.primary {\n    color: $white;\n    background-color: $active-color;\n    border: 1px solid $active-color;\n\n    &:hover {\n      outline: 2px solid rgba(95, 143, 223, 0.3) !important;\n    }\n  }\n}\n","/*\nTemplate Name: Chat Sms.by\nAuthor: Themesbrand\nVersion: 2.0.0\nWebsite: https://themesbrand.com/\nContact: themesbrand@gmail.com\nFile: Icons Css File\n*/\n\n// Plugins\n@import \"custom/plugins/icons\";","/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?v=5.0.45\");\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?#iefix&v=5.0.45\")\n      format(\"embedded-opentype\"),\n    url(\"../../../../fonts/materialdesignicons-webfont.woff2?v=5.0.45\")\n      format(\"woff2\"),\n    url(\"../../../../fonts/materialdesignicons-webfont.woff?v=5.0.45\")\n      format(\"woff\"),\n    url(\"../../../../fonts/materialdesignicons-webfont.ttf?v=5.0.45\")\n      format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-ab-testing::before {\n  content: \"\\F01C9\";\n}\n\n.mdi-abjad-arabic::before {\n  content: \"\\F1328\";\n}\n\n.mdi-abjad-hebrew::before {\n  content: \"\\F1329\";\n}\n\n.mdi-abugida-devanagari::before {\n  content: \"\\F132A\";\n}\n\n.mdi-abugida-thai::before {\n  content: \"\\F132B\";\n}\n\n.mdi-access-point::before {\n  content: \"\\F0003\";\n}\n\n.mdi-access-point-network::before {\n  content: \"\\F0002\";\n}\n\n.mdi-access-point-network-off::before {\n  content: \"\\F0BE1\";\n}\n\n.mdi-account::before {\n  content: \"\\F0004\";\n}\n\n.mdi-account-alert::before {\n  content: \"\\F0005\";\n}\n\n.mdi-account-alert-outline::before {\n  content: \"\\F0B50\";\n}\n\n.mdi-account-arrow-left::before {\n  content: \"\\F0B51\";\n}\n\n.mdi-account-arrow-left-outline::before {\n  content: \"\\F0B52\";\n}\n\n.mdi-account-arrow-right::before {\n  content: \"\\F0B53\";\n}\n\n.mdi-account-arrow-right-outline::before {\n  content: \"\\F0B54\";\n}\n\n.mdi-account-box::before {\n  content: \"\\F0006\";\n}\n\n.mdi-account-box-multiple::before {\n  content: \"\\F0934\";\n}\n\n.mdi-account-box-multiple-outline::before {\n  content: \"\\F100A\";\n}\n\n.mdi-account-box-outline::before {\n  content: \"\\F0007\";\n}\n\n.mdi-account-cancel::before {\n  content: \"\\F12DF\";\n}\n\n.mdi-account-cancel-outline::before {\n  content: \"\\F12E0\";\n}\n\n.mdi-account-cash::before {\n  content: \"\\F1097\";\n}\n\n.mdi-account-cash-outline::before {\n  content: \"\\F1098\";\n}\n\n.mdi-account-check::before {\n  content: \"\\F0008\";\n}\n\n.mdi-account-check-outline::before {\n  content: \"\\F0BE2\";\n}\n\n.mdi-account-child::before {\n  content: \"\\F0A89\";\n}\n\n.mdi-account-child-circle::before {\n  content: \"\\F0A8A\";\n}\n\n.mdi-account-child-outline::before {\n  content: \"\\F10C8\";\n}\n\n.mdi-account-circle::before {\n  content: \"\\F0009\";\n}\n\n.mdi-account-circle-outline::before {\n  content: \"\\F0B55\";\n}\n\n.mdi-account-clock::before {\n  content: \"\\F0B56\";\n}\n\n.mdi-account-clock-outline::before {\n  content: \"\\F0B57\";\n}\n\n.mdi-account-cog::before {\n  content: \"\\F1370\";\n}\n\n.mdi-account-cog-outline::before {\n  content: \"\\F1371\";\n}\n\n.mdi-account-convert::before {\n  content: \"\\F000A\";\n}\n\n.mdi-account-convert-outline::before {\n  content: \"\\F1301\";\n}\n\n.mdi-account-cowboy-hat::before {\n  content: \"\\F0E9B\";\n}\n\n.mdi-account-details::before {\n  content: \"\\F0631\";\n}\n\n.mdi-account-details-outline::before {\n  content: \"\\F1372\";\n}\n\n.mdi-account-edit::before {\n  content: \"\\F06BC\";\n}\n\n.mdi-account-edit-outline::before {\n  content: \"\\F0FFB\";\n}\n\n.mdi-account-group::before {\n  content: \"\\F0849\";\n}\n\n.mdi-account-group-outline::before {\n  content: \"\\F0B58\";\n}\n\n.mdi-account-hard-hat::before {\n  content: \"\\F05B5\";\n}\n\n.mdi-account-heart::before {\n  content: \"\\F0899\";\n}\n\n.mdi-account-heart-outline::before {\n  content: \"\\F0BE3\";\n}\n\n.mdi-account-key::before {\n  content: \"\\F000B\";\n}\n\n.mdi-account-key-outline::before {\n  content: \"\\F0BE4\";\n}\n\n.mdi-account-lock::before {\n  content: \"\\F115E\";\n}\n\n.mdi-account-lock-outline::before {\n  content: \"\\F115F\";\n}\n\n.mdi-account-minus::before {\n  content: \"\\F000D\";\n}\n\n.mdi-account-minus-outline::before {\n  content: \"\\F0AEC\";\n}\n\n.mdi-account-multiple::before {\n  content: \"\\F000E\";\n}\n\n.mdi-account-multiple-check::before {\n  content: \"\\F08C5\";\n}\n\n.mdi-account-multiple-check-outline::before {\n  content: \"\\F11FE\";\n}\n\n.mdi-account-multiple-minus::before {\n  content: \"\\F05D3\";\n}\n\n.mdi-account-multiple-minus-outline::before {\n  content: \"\\F0BE5\";\n}\n\n.mdi-account-multiple-outline::before {\n  content: \"\\F000F\";\n}\n\n.mdi-account-multiple-plus::before {\n  content: \"\\F0010\";\n}\n\n.mdi-account-multiple-plus-outline::before {\n  content: \"\\F0800\";\n}\n\n.mdi-account-multiple-remove::before {\n  content: \"\\F120A\";\n}\n\n.mdi-account-multiple-remove-outline::before {\n  content: \"\\F120B\";\n}\n\n.mdi-account-music::before {\n  content: \"\\F0803\";\n}\n\n.mdi-account-music-outline::before {\n  content: \"\\F0CE9\";\n}\n\n.mdi-account-network::before {\n  content: \"\\F0011\";\n}\n\n.mdi-account-network-outline::before {\n  content: \"\\F0BE6\";\n}\n\n.mdi-account-off::before {\n  content: \"\\F0012\";\n}\n\n.mdi-account-off-outline::before {\n  content: \"\\F0BE7\";\n}\n\n.mdi-account-outline::before {\n  content: \"\\F0013\";\n}\n\n.mdi-account-plus::before {\n  content: \"\\F0014\";\n}\n\n.mdi-account-plus-outline::before {\n  content: \"\\F0801\";\n}\n\n.mdi-account-question::before {\n  content: \"\\F0B59\";\n}\n\n.mdi-account-question-outline::before {\n  content: \"\\F0B5A\";\n}\n\n.mdi-account-remove::before {\n  content: \"\\F0015\";\n}\n\n.mdi-account-remove-outline::before {\n  content: \"\\F0AED\";\n}\n\n.mdi-account-search::before {\n  content: \"\\F0016\";\n}\n\n.mdi-account-search-outline::before {\n  content: \"\\F0935\";\n}\n\n.mdi-account-settings::before {\n  content: \"\\F0630\";\n}\n\n.mdi-account-settings-outline::before {\n  content: \"\\F10C9\";\n}\n\n.mdi-account-star::before {\n  content: \"\\F0017\";\n}\n\n.mdi-account-star-outline::before {\n  content: \"\\F0BE8\";\n}\n\n.mdi-account-supervisor::before {\n  content: \"\\F0A8B\";\n}\n\n.mdi-account-supervisor-circle::before {\n  content: \"\\F0A8C\";\n}\n\n.mdi-account-supervisor-outline::before {\n  content: \"\\F112D\";\n}\n\n.mdi-account-switch::before {\n  content: \"\\F0019\";\n}\n\n.mdi-account-switch-outline::before {\n  content: \"\\F04CB\";\n}\n\n.mdi-account-tie::before {\n  content: \"\\F0CE3\";\n}\n\n.mdi-account-tie-outline::before {\n  content: \"\\F10CA\";\n}\n\n.mdi-account-tie-voice::before {\n  content: \"\\F1308\";\n}\n\n.mdi-account-tie-voice-off::before {\n  content: \"\\F130A\";\n}\n\n.mdi-account-tie-voice-off-outline::before {\n  content: \"\\F130B\";\n}\n\n.mdi-account-tie-voice-outline::before {\n  content: \"\\F1309\";\n}\n\n.mdi-account-voice::before {\n  content: \"\\F05CB\";\n}\n\n.mdi-adjust::before {\n  content: \"\\F001A\";\n}\n\n.mdi-adobe::before {\n  content: \"\\F0936\";\n}\n\n.mdi-adobe-acrobat::before {\n  content: \"\\F0F9D\";\n}\n\n.mdi-air-conditioner::before {\n  content: \"\\F001B\";\n}\n\n.mdi-air-filter::before {\n  content: \"\\F0D43\";\n}\n\n.mdi-air-horn::before {\n  content: \"\\F0DAC\";\n}\n\n.mdi-air-humidifier::before {\n  content: \"\\F1099\";\n}\n\n.mdi-air-purifier::before {\n  content: \"\\F0D44\";\n}\n\n.mdi-airbag::before {\n  content: \"\\F0BE9\";\n}\n\n.mdi-airballoon::before {\n  content: \"\\F001C\";\n}\n\n.mdi-airballoon-outline::before {\n  content: \"\\F100B\";\n}\n\n.mdi-airplane::before {\n  content: \"\\F001D\";\n}\n\n.mdi-airplane-landing::before {\n  content: \"\\F05D4\";\n}\n\n.mdi-airplane-off::before {\n  content: \"\\F001E\";\n}\n\n.mdi-airplane-takeoff::before {\n  content: \"\\F05D5\";\n}\n\n.mdi-airport::before {\n  content: \"\\F084B\";\n}\n\n.mdi-alarm::before {\n  content: \"\\F0020\";\n}\n\n.mdi-alarm-bell::before {\n  content: \"\\F078E\";\n}\n\n.mdi-alarm-check::before {\n  content: \"\\F0021\";\n}\n\n.mdi-alarm-light::before {\n  content: \"\\F078F\";\n}\n\n.mdi-alarm-light-outline::before {\n  content: \"\\F0BEA\";\n}\n\n.mdi-alarm-multiple::before {\n  content: \"\\F0022\";\n}\n\n.mdi-alarm-note::before {\n  content: \"\\F0E71\";\n}\n\n.mdi-alarm-note-off::before {\n  content: \"\\F0E72\";\n}\n\n.mdi-alarm-off::before {\n  content: \"\\F0023\";\n}\n\n.mdi-alarm-plus::before {\n  content: \"\\F0024\";\n}\n\n.mdi-alarm-snooze::before {\n  content: \"\\F068E\";\n}\n\n.mdi-album::before {\n  content: \"\\F0025\";\n}\n\n.mdi-alert::before {\n  content: \"\\F0026\";\n}\n\n.mdi-alert-box::before {\n  content: \"\\F0027\";\n}\n\n.mdi-alert-box-outline::before {\n  content: \"\\F0CE4\";\n}\n\n.mdi-alert-circle::before {\n  content: \"\\F0028\";\n}\n\n.mdi-alert-circle-check::before {\n  content: \"\\F11ED\";\n}\n\n.mdi-alert-circle-check-outline::before {\n  content: \"\\F11EE\";\n}\n\n.mdi-alert-circle-outline::before {\n  content: \"\\F05D6\";\n}\n\n.mdi-alert-decagram::before {\n  content: \"\\F06BD\";\n}\n\n.mdi-alert-decagram-outline::before {\n  content: \"\\F0CE5\";\n}\n\n.mdi-alert-octagon::before {\n  content: \"\\F0029\";\n}\n\n.mdi-alert-octagon-outline::before {\n  content: \"\\F0CE6\";\n}\n\n.mdi-alert-octagram::before {\n  content: \"\\F0767\";\n}\n\n.mdi-alert-octagram-outline::before {\n  content: \"\\F0CE7\";\n}\n\n.mdi-alert-outline::before {\n  content: \"\\F002A\";\n}\n\n.mdi-alert-rhombus::before {\n  content: \"\\F11CE\";\n}\n\n.mdi-alert-rhombus-outline::before {\n  content: \"\\F11CF\";\n}\n\n.mdi-alien::before {\n  content: \"\\F089A\";\n}\n\n.mdi-alien-outline::before {\n  content: \"\\F10CB\";\n}\n\n.mdi-align-horizontal-center::before {\n  content: \"\\F11C3\";\n}\n\n.mdi-align-horizontal-left::before {\n  content: \"\\F11C2\";\n}\n\n.mdi-align-horizontal-right::before {\n  content: \"\\F11C4\";\n}\n\n.mdi-align-vertical-bottom::before {\n  content: \"\\F11C5\";\n}\n\n.mdi-align-vertical-center::before {\n  content: \"\\F11C6\";\n}\n\n.mdi-align-vertical-top::before {\n  content: \"\\F11C7\";\n}\n\n.mdi-all-inclusive::before {\n  content: \"\\F06BE\";\n}\n\n.mdi-allergy::before {\n  content: \"\\F1258\";\n}\n\n.mdi-alpha::before {\n  content: \"\\F002B\";\n}\n\n.mdi-alpha-a::before {\n  content: \"\\F0AEE\";\n}\n\n.mdi-alpha-a-box::before {\n  content: \"\\F0B08\";\n}\n\n.mdi-alpha-a-box-outline::before {\n  content: \"\\F0BEB\";\n}\n\n.mdi-alpha-a-circle::before {\n  content: \"\\F0BEC\";\n}\n\n.mdi-alpha-a-circle-outline::before {\n  content: \"\\F0BED\";\n}\n\n.mdi-alpha-b::before {\n  content: \"\\F0AEF\";\n}\n\n.mdi-alpha-b-box::before {\n  content: \"\\F0B09\";\n}\n\n.mdi-alpha-b-box-outline::before {\n  content: \"\\F0BEE\";\n}\n\n.mdi-alpha-b-circle::before {\n  content: \"\\F0BEF\";\n}\n\n.mdi-alpha-b-circle-outline::before {\n  content: \"\\F0BF0\";\n}\n\n.mdi-alpha-c::before {\n  content: \"\\F0AF0\";\n}\n\n.mdi-alpha-c-box::before {\n  content: \"\\F0B0A\";\n}\n\n.mdi-alpha-c-box-outline::before {\n  content: \"\\F0BF1\";\n}\n\n.mdi-alpha-c-circle::before {\n  content: \"\\F0BF2\";\n}\n\n.mdi-alpha-c-circle-outline::before {\n  content: \"\\F0BF3\";\n}\n\n.mdi-alpha-d::before {\n  content: \"\\F0AF1\";\n}\n\n.mdi-alpha-d-box::before {\n  content: \"\\F0B0B\";\n}\n\n.mdi-alpha-d-box-outline::before {\n  content: \"\\F0BF4\";\n}\n\n.mdi-alpha-d-circle::before {\n  content: \"\\F0BF5\";\n}\n\n.mdi-alpha-d-circle-outline::before {\n  content: \"\\F0BF6\";\n}\n\n.mdi-alpha-e::before {\n  content: \"\\F0AF2\";\n}\n\n.mdi-alpha-e-box::before {\n  content: \"\\F0B0C\";\n}\n\n.mdi-alpha-e-box-outline::before {\n  content: \"\\F0BF7\";\n}\n\n.mdi-alpha-e-circle::before {\n  content: \"\\F0BF8\";\n}\n\n.mdi-alpha-e-circle-outline::before {\n  content: \"\\F0BF9\";\n}\n\n.mdi-alpha-f::before {\n  content: \"\\F0AF3\";\n}\n\n.mdi-alpha-f-box::before {\n  content: \"\\F0B0D\";\n}\n\n.mdi-alpha-f-box-outline::before {\n  content: \"\\F0BFA\";\n}\n\n.mdi-alpha-f-circle::before {\n  content: \"\\F0BFB\";\n}\n\n.mdi-alpha-f-circle-outline::before {\n  content: \"\\F0BFC\";\n}\n\n.mdi-alpha-g::before {\n  content: \"\\F0AF4\";\n}\n\n.mdi-alpha-g-box::before {\n  content: \"\\F0B0E\";\n}\n\n.mdi-alpha-g-box-outline::before {\n  content: \"\\F0BFD\";\n}\n\n.mdi-alpha-g-circle::before {\n  content: \"\\F0BFE\";\n}\n\n.mdi-alpha-g-circle-outline::before {\n  content: \"\\F0BFF\";\n}\n\n.mdi-alpha-h::before {\n  content: \"\\F0AF5\";\n}\n\n.mdi-alpha-h-box::before {\n  content: \"\\F0B0F\";\n}\n\n.mdi-alpha-h-box-outline::before {\n  content: \"\\F0C00\";\n}\n\n.mdi-alpha-h-circle::before {\n  content: \"\\F0C01\";\n}\n\n.mdi-alpha-h-circle-outline::before {\n  content: \"\\F0C02\";\n}\n\n.mdi-alpha-i::before {\n  content: \"\\F0AF6\";\n}\n\n.mdi-alpha-i-box::before {\n  content: \"\\F0B10\";\n}\n\n.mdi-alpha-i-box-outline::before {\n  content: \"\\F0C03\";\n}\n\n.mdi-alpha-i-circle::before {\n  content: \"\\F0C04\";\n}\n\n.mdi-alpha-i-circle-outline::before {\n  content: \"\\F0C05\";\n}\n\n.mdi-alpha-j::before {\n  content: \"\\F0AF7\";\n}\n\n.mdi-alpha-j-box::before {\n  content: \"\\F0B11\";\n}\n\n.mdi-alpha-j-box-outline::before {\n  content: \"\\F0C06\";\n}\n\n.mdi-alpha-j-circle::before {\n  content: \"\\F0C07\";\n}\n\n.mdi-alpha-j-circle-outline::before {\n  content: \"\\F0C08\";\n}\n\n.mdi-alpha-k::before {\n  content: \"\\F0AF8\";\n}\n\n.mdi-alpha-k-box::before {\n  content: \"\\F0B12\";\n}\n\n.mdi-alpha-k-box-outline::before {\n  content: \"\\F0C09\";\n}\n\n.mdi-alpha-k-circle::before {\n  content: \"\\F0C0A\";\n}\n\n.mdi-alpha-k-circle-outline::before {\n  content: \"\\F0C0B\";\n}\n\n.mdi-alpha-l::before {\n  content: \"\\F0AF9\";\n}\n\n.mdi-alpha-l-box::before {\n  content: \"\\F0B13\";\n}\n\n.mdi-alpha-l-box-outline::before {\n  content: \"\\F0C0C\";\n}\n\n.mdi-alpha-l-circle::before {\n  content: \"\\F0C0D\";\n}\n\n.mdi-alpha-l-circle-outline::before {\n  content: \"\\F0C0E\";\n}\n\n.mdi-alpha-m::before {\n  content: \"\\F0AFA\";\n}\n\n.mdi-alpha-m-box::before {\n  content: \"\\F0B14\";\n}\n\n.mdi-alpha-m-box-outline::before {\n  content: \"\\F0C0F\";\n}\n\n.mdi-alpha-m-circle::before {\n  content: \"\\F0C10\";\n}\n\n.mdi-alpha-m-circle-outline::before {\n  content: \"\\F0C11\";\n}\n\n.mdi-alpha-n::before {\n  content: \"\\F0AFB\";\n}\n\n.mdi-alpha-n-box::before {\n  content: \"\\F0B15\";\n}\n\n.mdi-alpha-n-box-outline::before {\n  content: \"\\F0C12\";\n}\n\n.mdi-alpha-n-circle::before {\n  content: \"\\F0C13\";\n}\n\n.mdi-alpha-n-circle-outline::before {\n  content: \"\\F0C14\";\n}\n\n.mdi-alpha-o::before {\n  content: \"\\F0AFC\";\n}\n\n.mdi-alpha-o-box::before {\n  content: \"\\F0B16\";\n}\n\n.mdi-alpha-o-box-outline::before {\n  content: \"\\F0C15\";\n}\n\n.mdi-alpha-o-circle::before {\n  content: \"\\F0C16\";\n}\n\n.mdi-alpha-o-circle-outline::before {\n  content: \"\\F0C17\";\n}\n\n.mdi-alpha-p::before {\n  content: \"\\F0AFD\";\n}\n\n.mdi-alpha-p-box::before {\n  content: \"\\F0B17\";\n}\n\n.mdi-alpha-p-box-outline::before {\n  content: \"\\F0C18\";\n}\n\n.mdi-alpha-p-circle::before {\n  content: \"\\F0C19\";\n}\n\n.mdi-alpha-p-circle-outline::before {\n  content: \"\\F0C1A\";\n}\n\n.mdi-alpha-q::before {\n  content: \"\\F0AFE\";\n}\n\n.mdi-alpha-q-box::before {\n  content: \"\\F0B18\";\n}\n\n.mdi-alpha-q-box-outline::before {\n  content: \"\\F0C1B\";\n}\n\n.mdi-alpha-q-circle::before {\n  content: \"\\F0C1C\";\n}\n\n.mdi-alpha-q-circle-outline::before {\n  content: \"\\F0C1D\";\n}\n\n.mdi-alpha-r::before {\n  content: \"\\F0AFF\";\n}\n\n.mdi-alpha-r-box::before {\n  content: \"\\F0B19\";\n}\n\n.mdi-alpha-r-box-outline::before {\n  content: \"\\F0C1E\";\n}\n\n.mdi-alpha-r-circle::before {\n  content: \"\\F0C1F\";\n}\n\n.mdi-alpha-r-circle-outline::before {\n  content: \"\\F0C20\";\n}\n\n.mdi-alpha-s::before {\n  content: \"\\F0B00\";\n}\n\n.mdi-alpha-s-box::before {\n  content: \"\\F0B1A\";\n}\n\n.mdi-alpha-s-box-outline::before {\n  content: \"\\F0C21\";\n}\n\n.mdi-alpha-s-circle::before {\n  content: \"\\F0C22\";\n}\n\n.mdi-alpha-s-circle-outline::before {\n  content: \"\\F0C23\";\n}\n\n.mdi-alpha-t::before {\n  content: \"\\F0B01\";\n}\n\n.mdi-alpha-t-box::before {\n  content: \"\\F0B1B\";\n}\n\n.mdi-alpha-t-box-outline::before {\n  content: \"\\F0C24\";\n}\n\n.mdi-alpha-t-circle::before {\n  content: \"\\F0C25\";\n}\n\n.mdi-alpha-t-circle-outline::before {\n  content: \"\\F0C26\";\n}\n\n.mdi-alpha-u::before {\n  content: \"\\F0B02\";\n}\n\n.mdi-alpha-u-box::before {\n  content: \"\\F0B1C\";\n}\n\n.mdi-alpha-u-box-outline::before {\n  content: \"\\F0C27\";\n}\n\n.mdi-alpha-u-circle::before {\n  content: \"\\F0C28\";\n}\n\n.mdi-alpha-u-circle-outline::before {\n  content: \"\\F0C29\";\n}\n\n.mdi-alpha-v::before {\n  content: \"\\F0B03\";\n}\n\n.mdi-alpha-v-box::before {\n  content: \"\\F0B1D\";\n}\n\n.mdi-alpha-v-box-outline::before {\n  content: \"\\F0C2A\";\n}\n\n.mdi-alpha-v-circle::before {\n  content: \"\\F0C2B\";\n}\n\n.mdi-alpha-v-circle-outline::before {\n  content: \"\\F0C2C\";\n}\n\n.mdi-alpha-w::before {\n  content: \"\\F0B04\";\n}\n\n.mdi-alpha-w-box::before {\n  content: \"\\F0B1E\";\n}\n\n.mdi-alpha-w-box-outline::before {\n  content: \"\\F0C2D\";\n}\n\n.mdi-alpha-w-circle::before {\n  content: \"\\F0C2E\";\n}\n\n.mdi-alpha-w-circle-outline::before {\n  content: \"\\F0C2F\";\n}\n\n.mdi-alpha-x::before {\n  content: \"\\F0B05\";\n}\n\n.mdi-alpha-x-box::before {\n  content: \"\\F0B1F\";\n}\n\n.mdi-alpha-x-box-outline::before {\n  content: \"\\F0C30\";\n}\n\n.mdi-alpha-x-circle::before {\n  content: \"\\F0C31\";\n}\n\n.mdi-alpha-x-circle-outline::before {\n  content: \"\\F0C32\";\n}\n\n.mdi-alpha-y::before {\n  content: \"\\F0B06\";\n}\n\n.mdi-alpha-y-box::before {\n  content: \"\\F0B20\";\n}\n\n.mdi-alpha-y-box-outline::before {\n  content: \"\\F0C33\";\n}\n\n.mdi-alpha-y-circle::before {\n  content: \"\\F0C34\";\n}\n\n.mdi-alpha-y-circle-outline::before {\n  content: \"\\F0C35\";\n}\n\n.mdi-alpha-z::before {\n  content: \"\\F0B07\";\n}\n\n.mdi-alpha-z-box::before {\n  content: \"\\F0B21\";\n}\n\n.mdi-alpha-z-box-outline::before {\n  content: \"\\F0C36\";\n}\n\n.mdi-alpha-z-circle::before {\n  content: \"\\F0C37\";\n}\n\n.mdi-alpha-z-circle-outline::before {\n  content: \"\\F0C38\";\n}\n\n.mdi-alphabet-aurebesh::before {\n  content: \"\\F132C\";\n}\n\n.mdi-alphabet-cyrillic::before {\n  content: \"\\F132D\";\n}\n\n.mdi-alphabet-greek::before {\n  content: \"\\F132E\";\n}\n\n.mdi-alphabet-latin::before {\n  content: \"\\F132F\";\n}\n\n.mdi-alphabet-piqad::before {\n  content: \"\\F1330\";\n}\n\n.mdi-alphabet-tengwar::before {\n  content: \"\\F1337\";\n}\n\n.mdi-alphabetical::before {\n  content: \"\\F002C\";\n}\n\n.mdi-alphabetical-off::before {\n  content: \"\\F100C\";\n}\n\n.mdi-alphabetical-variant::before {\n  content: \"\\F100D\";\n}\n\n.mdi-alphabetical-variant-off::before {\n  content: \"\\F100E\";\n}\n\n.mdi-altimeter::before {\n  content: \"\\F05D7\";\n}\n\n.mdi-amazon::before {\n  content: \"\\F002D\";\n}\n\n.mdi-amazon-alexa::before {\n  content: \"\\F08C6\";\n}\n\n.mdi-ambulance::before {\n  content: \"\\F002F\";\n}\n\n.mdi-ammunition::before {\n  content: \"\\F0CE8\";\n}\n\n.mdi-ampersand::before {\n  content: \"\\F0A8D\";\n}\n\n.mdi-amplifier::before {\n  content: \"\\F0030\";\n}\n\n.mdi-amplifier-off::before {\n  content: \"\\F11B5\";\n}\n\n.mdi-anchor::before {\n  content: \"\\F0031\";\n}\n\n.mdi-android::before {\n  content: \"\\F0032\";\n}\n\n.mdi-android-auto::before {\n  content: \"\\F0A8E\";\n}\n\n.mdi-android-debug-bridge::before {\n  content: \"\\F0033\";\n}\n\n.mdi-android-messages::before {\n  content: \"\\F0D45\";\n}\n\n.mdi-android-studio::before {\n  content: \"\\F0034\";\n}\n\n.mdi-angle-acute::before {\n  content: \"\\F0937\";\n}\n\n.mdi-angle-obtuse::before {\n  content: \"\\F0938\";\n}\n\n.mdi-angle-right::before {\n  content: \"\\F0939\";\n}\n\n.mdi-angular::before {\n  content: \"\\F06B2\";\n}\n\n.mdi-angularjs::before {\n  content: \"\\F06BF\";\n}\n\n.mdi-animation::before {\n  content: \"\\F05D8\";\n}\n\n.mdi-animation-outline::before {\n  content: \"\\F0A8F\";\n}\n\n.mdi-animation-play::before {\n  content: \"\\F093A\";\n}\n\n.mdi-animation-play-outline::before {\n  content: \"\\F0A90\";\n}\n\n.mdi-ansible::before {\n  content: \"\\F109A\";\n}\n\n.mdi-antenna::before {\n  content: \"\\F1119\";\n}\n\n.mdi-anvil::before {\n  content: \"\\F089B\";\n}\n\n.mdi-apache-kafka::before {\n  content: \"\\F100F\";\n}\n\n.mdi-api::before {\n  content: \"\\F109B\";\n}\n\n.mdi-api-off::before {\n  content: \"\\F1257\";\n}\n\n.mdi-apple::before {\n  content: \"\\F0035\";\n}\n\n.mdi-apple-airplay::before {\n  content: \"\\F001F\";\n}\n\n.mdi-apple-finder::before {\n  content: \"\\F0036\";\n}\n\n.mdi-apple-icloud::before {\n  content: \"\\F0038\";\n}\n\n.mdi-apple-ios::before {\n  content: \"\\F0037\";\n}\n\n.mdi-apple-keyboard-caps::before {\n  content: \"\\F0632\";\n}\n\n.mdi-apple-keyboard-command::before {\n  content: \"\\F0633\";\n}\n\n.mdi-apple-keyboard-control::before {\n  content: \"\\F0634\";\n}\n\n.mdi-apple-keyboard-option::before {\n  content: \"\\F0635\";\n}\n\n.mdi-apple-keyboard-shift::before {\n  content: \"\\F0636\";\n}\n\n.mdi-apple-safari::before {\n  content: \"\\F0039\";\n}\n\n.mdi-application::before {\n  content: \"\\F0614\";\n}\n\n.mdi-application-export::before {\n  content: \"\\F0DAD\";\n}\n\n.mdi-application-import::before {\n  content: \"\\F0DAE\";\n}\n\n.mdi-approximately-equal::before {\n  content: \"\\F0F9E\";\n}\n\n.mdi-approximately-equal-box::before {\n  content: \"\\F0F9F\";\n}\n\n.mdi-apps::before {\n  content: \"\\F003B\";\n}\n\n.mdi-apps-box::before {\n  content: \"\\F0D46\";\n}\n\n.mdi-arch::before {\n  content: \"\\F08C7\";\n}\n\n.mdi-archive::before {\n  content: \"\\F003C\";\n}\n\n.mdi-archive-arrow-down::before {\n  content: \"\\F1259\";\n}\n\n.mdi-archive-arrow-down-outline::before {\n  content: \"\\F125A\";\n}\n\n.mdi-archive-arrow-up::before {\n  content: \"\\F125B\";\n}\n\n.mdi-archive-arrow-up-outline::before {\n  content: \"\\F125C\";\n}\n\n.mdi-archive-outline::before {\n  content: \"\\F120E\";\n}\n\n.mdi-arm-flex::before {\n  content: \"\\F0FD7\";\n}\n\n.mdi-arm-flex-outline::before {\n  content: \"\\F0FD6\";\n}\n\n.mdi-arrange-bring-forward::before {\n  content: \"\\F003D\";\n}\n\n.mdi-arrange-bring-to-front::before {\n  content: \"\\F003E\";\n}\n\n.mdi-arrange-send-backward::before {\n  content: \"\\F003F\";\n}\n\n.mdi-arrange-send-to-back::before {\n  content: \"\\F0040\";\n}\n\n.mdi-arrow-all::before {\n  content: \"\\F0041\";\n}\n\n.mdi-arrow-bottom-left::before {\n  content: \"\\F0042\";\n}\n\n.mdi-arrow-bottom-left-bold-outline::before {\n  content: \"\\F09B7\";\n}\n\n.mdi-arrow-bottom-left-thick::before {\n  content: \"\\F09B8\";\n}\n\n.mdi-arrow-bottom-right::before {\n  content: \"\\F0043\";\n}\n\n.mdi-arrow-bottom-right-bold-outline::before {\n  content: \"\\F09B9\";\n}\n\n.mdi-arrow-bottom-right-thick::before {\n  content: \"\\F09BA\";\n}\n\n.mdi-arrow-collapse::before {\n  content: \"\\F0615\";\n}\n\n.mdi-arrow-collapse-all::before {\n  content: \"\\F0044\";\n}\n\n.mdi-arrow-collapse-down::before {\n  content: \"\\F0792\";\n}\n\n.mdi-arrow-collapse-horizontal::before {\n  content: \"\\F084C\";\n}\n\n.mdi-arrow-collapse-left::before {\n  content: \"\\F0793\";\n}\n\n.mdi-arrow-collapse-right::before {\n  content: \"\\F0794\";\n}\n\n.mdi-arrow-collapse-up::before {\n  content: \"\\F0795\";\n}\n\n.mdi-arrow-collapse-vertical::before {\n  content: \"\\F084D\";\n}\n\n.mdi-arrow-decision::before {\n  content: \"\\F09BB\";\n}\n\n.mdi-arrow-decision-auto::before {\n  content: \"\\F09BC\";\n}\n\n.mdi-arrow-decision-auto-outline::before {\n  content: \"\\F09BD\";\n}\n\n.mdi-arrow-decision-outline::before {\n  content: \"\\F09BE\";\n}\n\n.mdi-arrow-down::before {\n  content: \"\\F0045\";\n}\n\n.mdi-arrow-down-bold::before {\n  content: \"\\F072E\";\n}\n\n.mdi-arrow-down-bold-box::before {\n  content: \"\\F072F\";\n}\n\n.mdi-arrow-down-bold-box-outline::before {\n  content: \"\\F0730\";\n}\n\n.mdi-arrow-down-bold-circle::before {\n  content: \"\\F0047\";\n}\n\n.mdi-arrow-down-bold-circle-outline::before {\n  content: \"\\F0048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline::before {\n  content: \"\\F0049\";\n}\n\n.mdi-arrow-down-bold-outline::before {\n  content: \"\\F09BF\";\n}\n\n.mdi-arrow-down-box::before {\n  content: \"\\F06C0\";\n}\n\n.mdi-arrow-down-circle::before {\n  content: \"\\F0CDB\";\n}\n\n.mdi-arrow-down-circle-outline::before {\n  content: \"\\F0CDC\";\n}\n\n.mdi-arrow-down-drop-circle::before {\n  content: \"\\F004A\";\n}\n\n.mdi-arrow-down-drop-circle-outline::before {\n  content: \"\\F004B\";\n}\n\n.mdi-arrow-down-thick::before {\n  content: \"\\F0046\";\n}\n\n.mdi-arrow-expand::before {\n  content: \"\\F0616\";\n}\n\n.mdi-arrow-expand-all::before {\n  content: \"\\F004C\";\n}\n\n.mdi-arrow-expand-down::before {\n  content: \"\\F0796\";\n}\n\n.mdi-arrow-expand-horizontal::before {\n  content: \"\\F084E\";\n}\n\n.mdi-arrow-expand-left::before {\n  content: \"\\F0797\";\n}\n\n.mdi-arrow-expand-right::before {\n  content: \"\\F0798\";\n}\n\n.mdi-arrow-expand-up::before {\n  content: \"\\F0799\";\n}\n\n.mdi-arrow-expand-vertical::before {\n  content: \"\\F084F\";\n}\n\n.mdi-arrow-horizontal-lock::before {\n  content: \"\\F115B\";\n}\n\n.mdi-arrow-left::before {\n  content: \"\\F004D\";\n}\n\n.mdi-arrow-left-bold::before {\n  content: \"\\F0731\";\n}\n\n.mdi-arrow-left-bold-box::before {\n  content: \"\\F0732\";\n}\n\n.mdi-arrow-left-bold-box-outline::before {\n  content: \"\\F0733\";\n}\n\n.mdi-arrow-left-bold-circle::before {\n  content: \"\\F004F\";\n}\n\n.mdi-arrow-left-bold-circle-outline::before {\n  content: \"\\F0050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline::before {\n  content: \"\\F0051\";\n}\n\n.mdi-arrow-left-bold-outline::before {\n  content: \"\\F09C0\";\n}\n\n.mdi-arrow-left-box::before {\n  content: \"\\F06C1\";\n}\n\n.mdi-arrow-left-circle::before {\n  content: \"\\F0CDD\";\n}\n\n.mdi-arrow-left-circle-outline::before {\n  content: \"\\F0CDE\";\n}\n\n.mdi-arrow-left-drop-circle::before {\n  content: \"\\F0052\";\n}\n\n.mdi-arrow-left-drop-circle-outline::before {\n  content: \"\\F0053\";\n}\n\n.mdi-arrow-left-right::before {\n  content: \"\\F0E73\";\n}\n\n.mdi-arrow-left-right-bold::before {\n  content: \"\\F0E74\";\n}\n\n.mdi-arrow-left-right-bold-outline::before {\n  content: \"\\F09C1\";\n}\n\n.mdi-arrow-left-thick::before {\n  content: \"\\F004E\";\n}\n\n.mdi-arrow-right::before {\n  content: \"\\F0054\";\n}\n\n.mdi-arrow-right-bold::before {\n  content: \"\\F0734\";\n}\n\n.mdi-arrow-right-bold-box::before {\n  content: \"\\F0735\";\n}\n\n.mdi-arrow-right-bold-box-outline::before {\n  content: \"\\F0736\";\n}\n\n.mdi-arrow-right-bold-circle::before {\n  content: \"\\F0056\";\n}\n\n.mdi-arrow-right-bold-circle-outline::before {\n  content: \"\\F0057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline::before {\n  content: \"\\F0058\";\n}\n\n.mdi-arrow-right-bold-outline::before {\n  content: \"\\F09C2\";\n}\n\n.mdi-arrow-right-box::before {\n  content: \"\\F06C2\";\n}\n\n.mdi-arrow-right-circle::before {\n  content: \"\\F0CDF\";\n}\n\n.mdi-arrow-right-circle-outline::before {\n  content: \"\\F0CE0\";\n}\n\n.mdi-arrow-right-drop-circle::before {\n  content: \"\\F0059\";\n}\n\n.mdi-arrow-right-drop-circle-outline::before {\n  content: \"\\F005A\";\n}\n\n.mdi-arrow-right-thick::before {\n  content: \"\\F0055\";\n}\n\n.mdi-arrow-split-horizontal::before {\n  content: \"\\F093B\";\n}\n\n.mdi-arrow-split-vertical::before {\n  content: \"\\F093C\";\n}\n\n.mdi-arrow-top-left::before {\n  content: \"\\F005B\";\n}\n\n.mdi-arrow-top-left-bold-outline::before {\n  content: \"\\F09C3\";\n}\n\n.mdi-arrow-top-left-bottom-right::before {\n  content: \"\\F0E75\";\n}\n\n.mdi-arrow-top-left-bottom-right-bold::before {\n  content: \"\\F0E76\";\n}\n\n.mdi-arrow-top-left-thick::before {\n  content: \"\\F09C4\";\n}\n\n.mdi-arrow-top-right::before {\n  content: \"\\F005C\";\n}\n\n.mdi-arrow-top-right-bold-outline::before {\n  content: \"\\F09C5\";\n}\n\n.mdi-arrow-top-right-bottom-left::before {\n  content: \"\\F0E77\";\n}\n\n.mdi-arrow-top-right-bottom-left-bold::before {\n  content: \"\\F0E78\";\n}\n\n.mdi-arrow-top-right-thick::before {\n  content: \"\\F09C6\";\n}\n\n.mdi-arrow-up::before {\n  content: \"\\F005D\";\n}\n\n.mdi-arrow-up-bold::before {\n  content: \"\\F0737\";\n}\n\n.mdi-arrow-up-bold-box::before {\n  content: \"\\F0738\";\n}\n\n.mdi-arrow-up-bold-box-outline::before {\n  content: \"\\F0739\";\n}\n\n.mdi-arrow-up-bold-circle::before {\n  content: \"\\F005F\";\n}\n\n.mdi-arrow-up-bold-circle-outline::before {\n  content: \"\\F0060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline::before {\n  content: \"\\F0061\";\n}\n\n.mdi-arrow-up-bold-outline::before {\n  content: \"\\F09C7\";\n}\n\n.mdi-arrow-up-box::before {\n  content: \"\\F06C3\";\n}\n\n.mdi-arrow-up-circle::before {\n  content: \"\\F0CE1\";\n}\n\n.mdi-arrow-up-circle-outline::before {\n  content: \"\\F0CE2\";\n}\n\n.mdi-arrow-up-down::before {\n  content: \"\\F0E79\";\n}\n\n.mdi-arrow-up-down-bold::before {\n  content: \"\\F0E7A\";\n}\n\n.mdi-arrow-up-down-bold-outline::before {\n  content: \"\\F09C8\";\n}\n\n.mdi-arrow-up-drop-circle::before {\n  content: \"\\F0062\";\n}\n\n.mdi-arrow-up-drop-circle-outline::before {\n  content: \"\\F0063\";\n}\n\n.mdi-arrow-up-thick::before {\n  content: \"\\F005E\";\n}\n\n.mdi-arrow-vertical-lock::before {\n  content: \"\\F115C\";\n}\n\n.mdi-artstation::before {\n  content: \"\\F0B5B\";\n}\n\n.mdi-aspect-ratio::before {\n  content: \"\\F0A24\";\n}\n\n.mdi-assistant::before {\n  content: \"\\F0064\";\n}\n\n.mdi-asterisk::before {\n  content: \"\\F06C4\";\n}\n\n.mdi-at::before {\n  content: \"\\F0065\";\n}\n\n.mdi-atlassian::before {\n  content: \"\\F0804\";\n}\n\n.mdi-atm::before {\n  content: \"\\F0D47\";\n}\n\n.mdi-atom::before {\n  content: \"\\F0768\";\n}\n\n.mdi-atom-variant::before {\n  content: \"\\F0E7B\";\n}\n\n.mdi-attachment::before {\n  content: \"\\F0066\";\n}\n\n.mdi-audio-video::before {\n  content: \"\\F093D\";\n}\n\n.mdi-audio-video-off::before {\n  content: \"\\F11B6\";\n}\n\n.mdi-augmented-reality::before {\n  content: \"\\F0850\";\n}\n\n.mdi-auto-download::before {\n  content: \"\\F137E\";\n}\n\n.mdi-auto-fix::before {\n  content: \"\\F0068\";\n}\n\n.mdi-auto-upload::before {\n  content: \"\\F0069\";\n}\n\n.mdi-autorenew::before {\n  content: \"\\F006A\";\n}\n\n.mdi-av-timer::before {\n  content: \"\\F006B\";\n}\n\n.mdi-aws::before {\n  content: \"\\F0E0F\";\n}\n\n.mdi-axe::before {\n  content: \"\\F08C8\";\n}\n\n.mdi-axis::before {\n  content: \"\\F0D48\";\n}\n\n.mdi-axis-arrow::before {\n  content: \"\\F0D49\";\n}\n\n.mdi-axis-arrow-lock::before {\n  content: \"\\F0D4A\";\n}\n\n.mdi-axis-lock::before {\n  content: \"\\F0D4B\";\n}\n\n.mdi-axis-x-arrow::before {\n  content: \"\\F0D4C\";\n}\n\n.mdi-axis-x-arrow-lock::before {\n  content: \"\\F0D4D\";\n}\n\n.mdi-axis-x-rotate-clockwise::before {\n  content: \"\\F0D4E\";\n}\n\n.mdi-axis-x-rotate-counterclockwise::before {\n  content: \"\\F0D4F\";\n}\n\n.mdi-axis-x-y-arrow-lock::before {\n  content: \"\\F0D50\";\n}\n\n.mdi-axis-y-arrow::before {\n  content: \"\\F0D51\";\n}\n\n.mdi-axis-y-arrow-lock::before {\n  content: \"\\F0D52\";\n}\n\n.mdi-axis-y-rotate-clockwise::before {\n  content: \"\\F0D53\";\n}\n\n.mdi-axis-y-rotate-counterclockwise::before {\n  content: \"\\F0D54\";\n}\n\n.mdi-axis-z-arrow::before {\n  content: \"\\F0D55\";\n}\n\n.mdi-axis-z-arrow-lock::before {\n  content: \"\\F0D56\";\n}\n\n.mdi-axis-z-rotate-clockwise::before {\n  content: \"\\F0D57\";\n}\n\n.mdi-axis-z-rotate-counterclockwise::before {\n  content: \"\\F0D58\";\n}\n\n.mdi-babel::before {\n  content: \"\\F0A25\";\n}\n\n.mdi-baby::before {\n  content: \"\\F006C\";\n}\n\n.mdi-baby-bottle::before {\n  content: \"\\F0F39\";\n}\n\n.mdi-baby-bottle-outline::before {\n  content: \"\\F0F3A\";\n}\n\n.mdi-baby-carriage::before {\n  content: \"\\F068F\";\n}\n\n.mdi-baby-carriage-off::before {\n  content: \"\\F0FA0\";\n}\n\n.mdi-baby-face::before {\n  content: \"\\F0E7C\";\n}\n\n.mdi-baby-face-outline::before {\n  content: \"\\F0E7D\";\n}\n\n.mdi-backburger::before {\n  content: \"\\F006D\";\n}\n\n.mdi-backspace::before {\n  content: \"\\F006E\";\n}\n\n.mdi-backspace-outline::before {\n  content: \"\\F0B5C\";\n}\n\n.mdi-backspace-reverse::before {\n  content: \"\\F0E7E\";\n}\n\n.mdi-backspace-reverse-outline::before {\n  content: \"\\F0E7F\";\n}\n\n.mdi-backup-restore::before {\n  content: \"\\F006F\";\n}\n\n.mdi-bacteria::before {\n  content: \"\\F0ED5\";\n}\n\n.mdi-bacteria-outline::before {\n  content: \"\\F0ED6\";\n}\n\n.mdi-badge-account::before {\n  content: \"\\F0DA7\";\n}\n\n.mdi-badge-account-alert::before {\n  content: \"\\F0DA8\";\n}\n\n.mdi-badge-account-alert-outline::before {\n  content: \"\\F0DA9\";\n}\n\n.mdi-badge-account-horizontal::before {\n  content: \"\\F0E0D\";\n}\n\n.mdi-badge-account-horizontal-outline::before {\n  content: \"\\F0E0E\";\n}\n\n.mdi-badge-account-outline::before {\n  content: \"\\F0DAA\";\n}\n\n.mdi-badminton::before {\n  content: \"\\F0851\";\n}\n\n.mdi-bag-carry-on::before {\n  content: \"\\F0F3B\";\n}\n\n.mdi-bag-carry-on-check::before {\n  content: \"\\F0D65\";\n}\n\n.mdi-bag-carry-on-off::before {\n  content: \"\\F0F3C\";\n}\n\n.mdi-bag-checked::before {\n  content: \"\\F0F3D\";\n}\n\n.mdi-bag-personal::before {\n  content: \"\\F0E10\";\n}\n\n.mdi-bag-personal-off::before {\n  content: \"\\F0E11\";\n}\n\n.mdi-bag-personal-off-outline::before {\n  content: \"\\F0E12\";\n}\n\n.mdi-bag-personal-outline::before {\n  content: \"\\F0E13\";\n}\n\n.mdi-baguette::before {\n  content: \"\\F0F3E\";\n}\n\n.mdi-balloon::before {\n  content: \"\\F0A26\";\n}\n\n.mdi-ballot::before {\n  content: \"\\F09C9\";\n}\n\n.mdi-ballot-outline::before {\n  content: \"\\F09CA\";\n}\n\n.mdi-ballot-recount::before {\n  content: \"\\F0C39\";\n}\n\n.mdi-ballot-recount-outline::before {\n  content: \"\\F0C3A\";\n}\n\n.mdi-bandage::before {\n  content: \"\\F0DAF\";\n}\n\n.mdi-bandcamp::before {\n  content: \"\\F0675\";\n}\n\n.mdi-bank::before {\n  content: \"\\F0070\";\n}\n\n.mdi-bank-minus::before {\n  content: \"\\F0DB0\";\n}\n\n.mdi-bank-outline::before {\n  content: \"\\F0E80\";\n}\n\n.mdi-bank-plus::before {\n  content: \"\\F0DB1\";\n}\n\n.mdi-bank-remove::before {\n  content: \"\\F0DB2\";\n}\n\n.mdi-bank-transfer::before {\n  content: \"\\F0A27\";\n}\n\n.mdi-bank-transfer-in::before {\n  content: \"\\F0A28\";\n}\n\n.mdi-bank-transfer-out::before {\n  content: \"\\F0A29\";\n}\n\n.mdi-barcode::before {\n  content: \"\\F0071\";\n}\n\n.mdi-barcode-off::before {\n  content: \"\\F1236\";\n}\n\n.mdi-barcode-scan::before {\n  content: \"\\F0072\";\n}\n\n.mdi-barley::before {\n  content: \"\\F0073\";\n}\n\n.mdi-barley-off::before {\n  content: \"\\F0B5D\";\n}\n\n.mdi-barn::before {\n  content: \"\\F0B5E\";\n}\n\n.mdi-barrel::before {\n  content: \"\\F0074\";\n}\n\n.mdi-baseball::before {\n  content: \"\\F0852\";\n}\n\n.mdi-baseball-bat::before {\n  content: \"\\F0853\";\n}\n\n.mdi-bash::before {\n  content: \"\\F1183\";\n}\n\n.mdi-basket::before {\n  content: \"\\F0076\";\n}\n\n.mdi-basket-fill::before {\n  content: \"\\F0077\";\n}\n\n.mdi-basket-outline::before {\n  content: \"\\F1181\";\n}\n\n.mdi-basket-unfill::before {\n  content: \"\\F0078\";\n}\n\n.mdi-basketball::before {\n  content: \"\\F0806\";\n}\n\n.mdi-basketball-hoop::before {\n  content: \"\\F0C3B\";\n}\n\n.mdi-basketball-hoop-outline::before {\n  content: \"\\F0C3C\";\n}\n\n.mdi-bat::before {\n  content: \"\\F0B5F\";\n}\n\n.mdi-battery::before {\n  content: \"\\F0079\";\n}\n\n.mdi-battery-10::before {\n  content: \"\\F007A\";\n}\n\n.mdi-battery-10-bluetooth::before {\n  content: \"\\F093E\";\n}\n\n.mdi-battery-20::before {\n  content: \"\\F007B\";\n}\n\n.mdi-battery-20-bluetooth::before {\n  content: \"\\F093F\";\n}\n\n.mdi-battery-30::before {\n  content: \"\\F007C\";\n}\n\n.mdi-battery-30-bluetooth::before {\n  content: \"\\F0940\";\n}\n\n.mdi-battery-40::before {\n  content: \"\\F007D\";\n}\n\n.mdi-battery-40-bluetooth::before {\n  content: \"\\F0941\";\n}\n\n.mdi-battery-50::before {\n  content: \"\\F007E\";\n}\n\n.mdi-battery-50-bluetooth::before {\n  content: \"\\F0942\";\n}\n\n.mdi-battery-60::before {\n  content: \"\\F007F\";\n}\n\n.mdi-battery-60-bluetooth::before {\n  content: \"\\F0943\";\n}\n\n.mdi-battery-70::before {\n  content: \"\\F0080\";\n}\n\n.mdi-battery-70-bluetooth::before {\n  content: \"\\F0944\";\n}\n\n.mdi-battery-80::before {\n  content: \"\\F0081\";\n}\n\n.mdi-battery-80-bluetooth::before {\n  content: \"\\F0945\";\n}\n\n.mdi-battery-90::before {\n  content: \"\\F0082\";\n}\n\n.mdi-battery-90-bluetooth::before {\n  content: \"\\F0946\";\n}\n\n.mdi-battery-alert::before {\n  content: \"\\F0083\";\n}\n\n.mdi-battery-alert-bluetooth::before {\n  content: \"\\F0947\";\n}\n\n.mdi-battery-alert-variant::before {\n  content: \"\\F10CC\";\n}\n\n.mdi-battery-alert-variant-outline::before {\n  content: \"\\F10CD\";\n}\n\n.mdi-battery-bluetooth::before {\n  content: \"\\F0948\";\n}\n\n.mdi-battery-bluetooth-variant::before {\n  content: \"\\F0949\";\n}\n\n.mdi-battery-charging::before {\n  content: \"\\F0084\";\n}\n\n.mdi-battery-charging-10::before {\n  content: \"\\F089C\";\n}\n\n.mdi-battery-charging-100::before {\n  content: \"\\F0085\";\n}\n\n.mdi-battery-charging-20::before {\n  content: \"\\F0086\";\n}\n\n.mdi-battery-charging-30::before {\n  content: \"\\F0087\";\n}\n\n.mdi-battery-charging-40::before {\n  content: \"\\F0088\";\n}\n\n.mdi-battery-charging-50::before {\n  content: \"\\F089D\";\n}\n\n.mdi-battery-charging-60::before {\n  content: \"\\F0089\";\n}\n\n.mdi-battery-charging-70::before {\n  content: \"\\F089E\";\n}\n\n.mdi-battery-charging-80::before {\n  content: \"\\F008A\";\n}\n\n.mdi-battery-charging-90::before {\n  content: \"\\F008B\";\n}\n\n.mdi-battery-charging-high::before {\n  content: \"\\F12A6\";\n}\n\n.mdi-battery-charging-low::before {\n  content: \"\\F12A4\";\n}\n\n.mdi-battery-charging-medium::before {\n  content: \"\\F12A5\";\n}\n\n.mdi-battery-charging-outline::before {\n  content: \"\\F089F\";\n}\n\n.mdi-battery-charging-wireless::before {\n  content: \"\\F0807\";\n}\n\n.mdi-battery-charging-wireless-10::before {\n  content: \"\\F0808\";\n}\n\n.mdi-battery-charging-wireless-20::before {\n  content: \"\\F0809\";\n}\n\n.mdi-battery-charging-wireless-30::before {\n  content: \"\\F080A\";\n}\n\n.mdi-battery-charging-wireless-40::before {\n  content: \"\\F080B\";\n}\n\n.mdi-battery-charging-wireless-50::before {\n  content: \"\\F080C\";\n}\n\n.mdi-battery-charging-wireless-60::before {\n  content: \"\\F080D\";\n}\n\n.mdi-battery-charging-wireless-70::before {\n  content: \"\\F080E\";\n}\n\n.mdi-battery-charging-wireless-80::before {\n  content: \"\\F080F\";\n}\n\n.mdi-battery-charging-wireless-90::before {\n  content: \"\\F0810\";\n}\n\n.mdi-battery-charging-wireless-alert::before {\n  content: \"\\F0811\";\n}\n\n.mdi-battery-charging-wireless-outline::before {\n  content: \"\\F0812\";\n}\n\n.mdi-battery-heart::before {\n  content: \"\\F120F\";\n}\n\n.mdi-battery-heart-outline::before {\n  content: \"\\F1210\";\n}\n\n.mdi-battery-heart-variant::before {\n  content: \"\\F1211\";\n}\n\n.mdi-battery-high::before {\n  content: \"\\F12A3\";\n}\n\n.mdi-battery-low::before {\n  content: \"\\F12A1\";\n}\n\n.mdi-battery-medium::before {\n  content: \"\\F12A2\";\n}\n\n.mdi-battery-minus::before {\n  content: \"\\F008C\";\n}\n\n.mdi-battery-negative::before {\n  content: \"\\F008D\";\n}\n\n.mdi-battery-off::before {\n  content: \"\\F125D\";\n}\n\n.mdi-battery-off-outline::before {\n  content: \"\\F125E\";\n}\n\n.mdi-battery-outline::before {\n  content: \"\\F008E\";\n}\n\n.mdi-battery-plus::before {\n  content: \"\\F008F\";\n}\n\n.mdi-battery-positive::before {\n  content: \"\\F0090\";\n}\n\n.mdi-battery-unknown::before {\n  content: \"\\F0091\";\n}\n\n.mdi-battery-unknown-bluetooth::before {\n  content: \"\\F094A\";\n}\n\n.mdi-battlenet::before {\n  content: \"\\F0B60\";\n}\n\n.mdi-beach::before {\n  content: \"\\F0092\";\n}\n\n.mdi-beaker::before {\n  content: \"\\F0CEA\";\n}\n\n.mdi-beaker-alert::before {\n  content: \"\\F1229\";\n}\n\n.mdi-beaker-alert-outline::before {\n  content: \"\\F122A\";\n}\n\n.mdi-beaker-check::before {\n  content: \"\\F122B\";\n}\n\n.mdi-beaker-check-outline::before {\n  content: \"\\F122C\";\n}\n\n.mdi-beaker-minus::before {\n  content: \"\\F122D\";\n}\n\n.mdi-beaker-minus-outline::before {\n  content: \"\\F122E\";\n}\n\n.mdi-beaker-outline::before {\n  content: \"\\F0690\";\n}\n\n.mdi-beaker-plus::before {\n  content: \"\\F122F\";\n}\n\n.mdi-beaker-plus-outline::before {\n  content: \"\\F1230\";\n}\n\n.mdi-beaker-question::before {\n  content: \"\\F1231\";\n}\n\n.mdi-beaker-question-outline::before {\n  content: \"\\F1232\";\n}\n\n.mdi-beaker-remove::before {\n  content: \"\\F1233\";\n}\n\n.mdi-beaker-remove-outline::before {\n  content: \"\\F1234\";\n}\n\n.mdi-bed::before {\n  content: \"\\F02E3\";\n}\n\n.mdi-bed-double::before {\n  content: \"\\F0FD4\";\n}\n\n.mdi-bed-double-outline::before {\n  content: \"\\F0FD3\";\n}\n\n.mdi-bed-empty::before {\n  content: \"\\F08A0\";\n}\n\n.mdi-bed-king::before {\n  content: \"\\F0FD2\";\n}\n\n.mdi-bed-king-outline::before {\n  content: \"\\F0FD1\";\n}\n\n.mdi-bed-outline::before {\n  content: \"\\F0099\";\n}\n\n.mdi-bed-queen::before {\n  content: \"\\F0FD0\";\n}\n\n.mdi-bed-queen-outline::before {\n  content: \"\\F0FDB\";\n}\n\n.mdi-bed-single::before {\n  content: \"\\F106D\";\n}\n\n.mdi-bed-single-outline::before {\n  content: \"\\F106E\";\n}\n\n.mdi-bee::before {\n  content: \"\\F0FA1\";\n}\n\n.mdi-bee-flower::before {\n  content: \"\\F0FA2\";\n}\n\n.mdi-beehive-outline::before {\n  content: \"\\F10CE\";\n}\n\n.mdi-beer::before {\n  content: \"\\F0098\";\n}\n\n.mdi-beer-outline::before {\n  content: \"\\F130C\";\n}\n\n.mdi-bell::before {\n  content: \"\\F009A\";\n}\n\n.mdi-bell-alert::before {\n  content: \"\\F0D59\";\n}\n\n.mdi-bell-alert-outline::before {\n  content: \"\\F0E81\";\n}\n\n.mdi-bell-check::before {\n  content: \"\\F11E5\";\n}\n\n.mdi-bell-check-outline::before {\n  content: \"\\F11E6\";\n}\n\n.mdi-bell-circle::before {\n  content: \"\\F0D5A\";\n}\n\n.mdi-bell-circle-outline::before {\n  content: \"\\F0D5B\";\n}\n\n.mdi-bell-off::before {\n  content: \"\\F009B\";\n}\n\n.mdi-bell-off-outline::before {\n  content: \"\\F0A91\";\n}\n\n.mdi-bell-outline::before {\n  content: \"\\F009C\";\n}\n\n.mdi-bell-plus::before {\n  content: \"\\F009D\";\n}\n\n.mdi-bell-plus-outline::before {\n  content: \"\\F0A92\";\n}\n\n.mdi-bell-ring::before {\n  content: \"\\F009E\";\n}\n\n.mdi-bell-ring-outline::before {\n  content: \"\\F009F\";\n}\n\n.mdi-bell-sleep::before {\n  content: \"\\F00A0\";\n}\n\n.mdi-bell-sleep-outline::before {\n  content: \"\\F0A93\";\n}\n\n.mdi-beta::before {\n  content: \"\\F00A1\";\n}\n\n.mdi-betamax::before {\n  content: \"\\F09CB\";\n}\n\n.mdi-biathlon::before {\n  content: \"\\F0E14\";\n}\n\n.mdi-bicycle::before {\n  content: \"\\F109C\";\n}\n\n.mdi-bicycle-basket::before {\n  content: \"\\F1235\";\n}\n\n.mdi-bike::before {\n  content: \"\\F00A3\";\n}\n\n.mdi-bike-fast::before {\n  content: \"\\F111F\";\n}\n\n.mdi-billboard::before {\n  content: \"\\F1010\";\n}\n\n.mdi-billiards::before {\n  content: \"\\F0B61\";\n}\n\n.mdi-billiards-rack::before {\n  content: \"\\F0B62\";\n}\n\n.mdi-binoculars::before {\n  content: \"\\F00A5\";\n}\n\n.mdi-bio::before {\n  content: \"\\F00A6\";\n}\n\n.mdi-biohazard::before {\n  content: \"\\F00A7\";\n}\n\n.mdi-bitbucket::before {\n  content: \"\\F00A8\";\n}\n\n.mdi-bitcoin::before {\n  content: \"\\F0813\";\n}\n\n.mdi-black-mesa::before {\n  content: \"\\F00A9\";\n}\n\n.mdi-blender::before {\n  content: \"\\F0CEB\";\n}\n\n.mdi-blender-software::before {\n  content: \"\\F00AB\";\n}\n\n.mdi-blinds::before {\n  content: \"\\F00AC\";\n}\n\n.mdi-blinds-open::before {\n  content: \"\\F1011\";\n}\n\n.mdi-block-helper::before {\n  content: \"\\F00AD\";\n}\n\n.mdi-blogger::before {\n  content: \"\\F00AE\";\n}\n\n.mdi-blood-bag::before {\n  content: \"\\F0CEC\";\n}\n\n.mdi-bluetooth::before {\n  content: \"\\F00AF\";\n}\n\n.mdi-bluetooth-audio::before {\n  content: \"\\F00B0\";\n}\n\n.mdi-bluetooth-connect::before {\n  content: \"\\F00B1\";\n}\n\n.mdi-bluetooth-off::before {\n  content: \"\\F00B2\";\n}\n\n.mdi-bluetooth-settings::before {\n  content: \"\\F00B3\";\n}\n\n.mdi-bluetooth-transfer::before {\n  content: \"\\F00B4\";\n}\n\n.mdi-blur::before {\n  content: \"\\F00B5\";\n}\n\n.mdi-blur-linear::before {\n  content: \"\\F00B6\";\n}\n\n.mdi-blur-off::before {\n  content: \"\\F00B7\";\n}\n\n.mdi-blur-radial::before {\n  content: \"\\F00B8\";\n}\n\n.mdi-bolnisi-cross::before {\n  content: \"\\F0CED\";\n}\n\n.mdi-bolt::before {\n  content: \"\\F0DB3\";\n}\n\n.mdi-bomb::before {\n  content: \"\\F0691\";\n}\n\n.mdi-bomb-off::before {\n  content: \"\\F06C5\";\n}\n\n.mdi-bone::before {\n  content: \"\\F00B9\";\n}\n\n.mdi-book::before {\n  content: \"\\F00BA\";\n}\n\n.mdi-book-account::before {\n  content: \"\\F13AD\";\n}\n\n.mdi-book-account-outline::before {\n  content: \"\\F13AE\";\n}\n\n.mdi-book-alphabet::before {\n  content: \"\\F061D\";\n}\n\n.mdi-book-cross::before {\n  content: \"\\F00A2\";\n}\n\n.mdi-book-information-variant::before {\n  content: \"\\F106F\";\n}\n\n.mdi-book-lock::before {\n  content: \"\\F079A\";\n}\n\n.mdi-book-lock-open::before {\n  content: \"\\F079B\";\n}\n\n.mdi-book-minus::before {\n  content: \"\\F05D9\";\n}\n\n.mdi-book-minus-multiple::before {\n  content: \"\\F0A94\";\n}\n\n.mdi-book-minus-multiple-outline::before {\n  content: \"\\F090B\";\n}\n\n.mdi-book-multiple::before {\n  content: \"\\F00BB\";\n}\n\n.mdi-book-multiple-outline::before {\n  content: \"\\F0436\";\n}\n\n.mdi-book-music::before {\n  content: \"\\F0067\";\n}\n\n.mdi-book-open::before {\n  content: \"\\F00BD\";\n}\n\n.mdi-book-open-outline::before {\n  content: \"\\F0B63\";\n}\n\n.mdi-book-open-page-variant::before {\n  content: \"\\F05DA\";\n}\n\n.mdi-book-open-variant::before {\n  content: \"\\F00BE\";\n}\n\n.mdi-book-outline::before {\n  content: \"\\F0B64\";\n}\n\n.mdi-book-play::before {\n  content: \"\\F0E82\";\n}\n\n.mdi-book-play-outline::before {\n  content: \"\\F0E83\";\n}\n\n.mdi-book-plus::before {\n  content: \"\\F05DB\";\n}\n\n.mdi-book-plus-multiple::before {\n  content: \"\\F0A95\";\n}\n\n.mdi-book-plus-multiple-outline::before {\n  content: \"\\F0ADE\";\n}\n\n.mdi-book-remove::before {\n  content: \"\\F0A97\";\n}\n\n.mdi-book-remove-multiple::before {\n  content: \"\\F0A96\";\n}\n\n.mdi-book-remove-multiple-outline::before {\n  content: \"\\F04CA\";\n}\n\n.mdi-book-search::before {\n  content: \"\\F0E84\";\n}\n\n.mdi-book-search-outline::before {\n  content: \"\\F0E85\";\n}\n\n.mdi-book-variant::before {\n  content: \"\\F00BF\";\n}\n\n.mdi-book-variant-multiple::before {\n  content: \"\\F00BC\";\n}\n\n.mdi-bookmark::before {\n  content: \"\\F00C0\";\n}\n\n.mdi-bookmark-check::before {\n  content: \"\\F00C1\";\n}\n\n.mdi-bookmark-check-outline::before {\n  content: \"\\F137B\";\n}\n\n.mdi-bookmark-minus::before {\n  content: \"\\F09CC\";\n}\n\n.mdi-bookmark-minus-outline::before {\n  content: \"\\F09CD\";\n}\n\n.mdi-bookmark-multiple::before {\n  content: \"\\F0E15\";\n}\n\n.mdi-bookmark-multiple-outline::before {\n  content: \"\\F0E16\";\n}\n\n.mdi-bookmark-music::before {\n  content: \"\\F00C2\";\n}\n\n.mdi-bookmark-music-outline::before {\n  content: \"\\F1379\";\n}\n\n.mdi-bookmark-off::before {\n  content: \"\\F09CE\";\n}\n\n.mdi-bookmark-off-outline::before {\n  content: \"\\F09CF\";\n}\n\n.mdi-bookmark-outline::before {\n  content: \"\\F00C3\";\n}\n\n.mdi-bookmark-plus::before {\n  content: \"\\F00C5\";\n}\n\n.mdi-bookmark-plus-outline::before {\n  content: \"\\F00C4\";\n}\n\n.mdi-bookmark-remove::before {\n  content: \"\\F00C6\";\n}\n\n.mdi-bookmark-remove-outline::before {\n  content: \"\\F137A\";\n}\n\n.mdi-bookshelf::before {\n  content: \"\\F125F\";\n}\n\n.mdi-boom-gate::before {\n  content: \"\\F0E86\";\n}\n\n.mdi-boom-gate-alert::before {\n  content: \"\\F0E87\";\n}\n\n.mdi-boom-gate-alert-outline::before {\n  content: \"\\F0E88\";\n}\n\n.mdi-boom-gate-down::before {\n  content: \"\\F0E89\";\n}\n\n.mdi-boom-gate-down-outline::before {\n  content: \"\\F0E8A\";\n}\n\n.mdi-boom-gate-outline::before {\n  content: \"\\F0E8B\";\n}\n\n.mdi-boom-gate-up::before {\n  content: \"\\F0E8C\";\n}\n\n.mdi-boom-gate-up-outline::before {\n  content: \"\\F0E8D\";\n}\n\n.mdi-boombox::before {\n  content: \"\\F05DC\";\n}\n\n.mdi-boomerang::before {\n  content: \"\\F10CF\";\n}\n\n.mdi-bootstrap::before {\n  content: \"\\F06C6\";\n}\n\n.mdi-border-all::before {\n  content: \"\\F00C7\";\n}\n\n.mdi-border-all-variant::before {\n  content: \"\\F08A1\";\n}\n\n.mdi-border-bottom::before {\n  content: \"\\F00C8\";\n}\n\n.mdi-border-bottom-variant::before {\n  content: \"\\F08A2\";\n}\n\n.mdi-border-color::before {\n  content: \"\\F00C9\";\n}\n\n.mdi-border-horizontal::before {\n  content: \"\\F00CA\";\n}\n\n.mdi-border-inside::before {\n  content: \"\\F00CB\";\n}\n\n.mdi-border-left::before {\n  content: \"\\F00CC\";\n}\n\n.mdi-border-left-variant::before {\n  content: \"\\F08A3\";\n}\n\n.mdi-border-none::before {\n  content: \"\\F00CD\";\n}\n\n.mdi-border-none-variant::before {\n  content: \"\\F08A4\";\n}\n\n.mdi-border-outside::before {\n  content: \"\\F00CE\";\n}\n\n.mdi-border-right::before {\n  content: \"\\F00CF\";\n}\n\n.mdi-border-right-variant::before {\n  content: \"\\F08A5\";\n}\n\n.mdi-border-style::before {\n  content: \"\\F00D0\";\n}\n\n.mdi-border-top::before {\n  content: \"\\F00D1\";\n}\n\n.mdi-border-top-variant::before {\n  content: \"\\F08A6\";\n}\n\n.mdi-border-vertical::before {\n  content: \"\\F00D2\";\n}\n\n.mdi-bottle-soda::before {\n  content: \"\\F1070\";\n}\n\n.mdi-bottle-soda-classic::before {\n  content: \"\\F1071\";\n}\n\n.mdi-bottle-soda-classic-outline::before {\n  content: \"\\F1363\";\n}\n\n.mdi-bottle-soda-outline::before {\n  content: \"\\F1072\";\n}\n\n.mdi-bottle-tonic::before {\n  content: \"\\F112E\";\n}\n\n.mdi-bottle-tonic-outline::before {\n  content: \"\\F112F\";\n}\n\n.mdi-bottle-tonic-plus::before {\n  content: \"\\F1130\";\n}\n\n.mdi-bottle-tonic-plus-outline::before {\n  content: \"\\F1131\";\n}\n\n.mdi-bottle-tonic-skull::before {\n  content: \"\\F1132\";\n}\n\n.mdi-bottle-tonic-skull-outline::before {\n  content: \"\\F1133\";\n}\n\n.mdi-bottle-wine::before {\n  content: \"\\F0854\";\n}\n\n.mdi-bottle-wine-outline::before {\n  content: \"\\F1310\";\n}\n\n.mdi-bow-tie::before {\n  content: \"\\F0678\";\n}\n\n.mdi-bowl::before {\n  content: \"\\F028E\";\n}\n\n.mdi-bowl-mix::before {\n  content: \"\\F0617\";\n}\n\n.mdi-bowl-mix-outline::before {\n  content: \"\\F02E4\";\n}\n\n.mdi-bowl-outline::before {\n  content: \"\\F02A9\";\n}\n\n.mdi-bowling::before {\n  content: \"\\F00D3\";\n}\n\n.mdi-box::before {\n  content: \"\\F00D4\";\n}\n\n.mdi-box-cutter::before {\n  content: \"\\F00D5\";\n}\n\n.mdi-box-cutter-off::before {\n  content: \"\\F0B4A\";\n}\n\n.mdi-box-shadow::before {\n  content: \"\\F0637\";\n}\n\n.mdi-boxing-glove::before {\n  content: \"\\F0B65\";\n}\n\n.mdi-braille::before {\n  content: \"\\F09D0\";\n}\n\n.mdi-brain::before {\n  content: \"\\F09D1\";\n}\n\n.mdi-bread-slice::before {\n  content: \"\\F0CEE\";\n}\n\n.mdi-bread-slice-outline::before {\n  content: \"\\F0CEF\";\n}\n\n.mdi-bridge::before {\n  content: \"\\F0618\";\n}\n\n.mdi-briefcase::before {\n  content: \"\\F00D6\";\n}\n\n.mdi-briefcase-account::before {\n  content: \"\\F0CF0\";\n}\n\n.mdi-briefcase-account-outline::before {\n  content: \"\\F0CF1\";\n}\n\n.mdi-briefcase-check::before {\n  content: \"\\F00D7\";\n}\n\n.mdi-briefcase-check-outline::before {\n  content: \"\\F131E\";\n}\n\n.mdi-briefcase-clock::before {\n  content: \"\\F10D0\";\n}\n\n.mdi-briefcase-clock-outline::before {\n  content: \"\\F10D1\";\n}\n\n.mdi-briefcase-download::before {\n  content: \"\\F00D8\";\n}\n\n.mdi-briefcase-download-outline::before {\n  content: \"\\F0C3D\";\n}\n\n.mdi-briefcase-edit::before {\n  content: \"\\F0A98\";\n}\n\n.mdi-briefcase-edit-outline::before {\n  content: \"\\F0C3E\";\n}\n\n.mdi-briefcase-minus::before {\n  content: \"\\F0A2A\";\n}\n\n.mdi-briefcase-minus-outline::before {\n  content: \"\\F0C3F\";\n}\n\n.mdi-briefcase-outline::before {\n  content: \"\\F0814\";\n}\n\n.mdi-briefcase-plus::before {\n  content: \"\\F0A2B\";\n}\n\n.mdi-briefcase-plus-outline::before {\n  content: \"\\F0C40\";\n}\n\n.mdi-briefcase-remove::before {\n  content: \"\\F0A2C\";\n}\n\n.mdi-briefcase-remove-outline::before {\n  content: \"\\F0C41\";\n}\n\n.mdi-briefcase-search::before {\n  content: \"\\F0A2D\";\n}\n\n.mdi-briefcase-search-outline::before {\n  content: \"\\F0C42\";\n}\n\n.mdi-briefcase-upload::before {\n  content: \"\\F00D9\";\n}\n\n.mdi-briefcase-upload-outline::before {\n  content: \"\\F0C43\";\n}\n\n.mdi-brightness-1::before {\n  content: \"\\F00DA\";\n}\n\n.mdi-brightness-2::before {\n  content: \"\\F00DB\";\n}\n\n.mdi-brightness-3::before {\n  content: \"\\F00DC\";\n}\n\n.mdi-brightness-4::before {\n  content: \"\\F00DD\";\n}\n\n.mdi-brightness-5::before {\n  content: \"\\F00DE\";\n}\n\n.mdi-brightness-6::before {\n  content: \"\\F00DF\";\n}\n\n.mdi-brightness-7::before {\n  content: \"\\F00E0\";\n}\n\n.mdi-brightness-auto::before {\n  content: \"\\F00E1\";\n}\n\n.mdi-brightness-percent::before {\n  content: \"\\F0CF2\";\n}\n\n.mdi-broom::before {\n  content: \"\\F00E2\";\n}\n\n.mdi-brush::before {\n  content: \"\\F00E3\";\n}\n\n.mdi-buddhism::before {\n  content: \"\\F094B\";\n}\n\n.mdi-buffer::before {\n  content: \"\\F0619\";\n}\n\n.mdi-buffet::before {\n  content: \"\\F0578\";\n}\n\n.mdi-bug::before {\n  content: \"\\F00E4\";\n}\n\n.mdi-bug-check::before {\n  content: \"\\F0A2E\";\n}\n\n.mdi-bug-check-outline::before {\n  content: \"\\F0A2F\";\n}\n\n.mdi-bug-outline::before {\n  content: \"\\F0A30\";\n}\n\n.mdi-bugle::before {\n  content: \"\\F0DB4\";\n}\n\n.mdi-bulldozer::before {\n  content: \"\\F0B22\";\n}\n\n.mdi-bullet::before {\n  content: \"\\F0CF3\";\n}\n\n.mdi-bulletin-board::before {\n  content: \"\\F00E5\";\n}\n\n.mdi-bullhorn::before {\n  content: \"\\F00E6\";\n}\n\n.mdi-bullhorn-outline::before {\n  content: \"\\F0B23\";\n}\n\n.mdi-bullseye::before {\n  content: \"\\F05DD\";\n}\n\n.mdi-bullseye-arrow::before {\n  content: \"\\F08C9\";\n}\n\n.mdi-bulma::before {\n  content: \"\\F12E7\";\n}\n\n.mdi-bunk-bed::before {\n  content: \"\\F1302\";\n}\n\n.mdi-bunk-bed-outline::before {\n  content: \"\\F0097\";\n}\n\n.mdi-bus::before {\n  content: \"\\F00E7\";\n}\n\n.mdi-bus-alert::before {\n  content: \"\\F0A99\";\n}\n\n.mdi-bus-articulated-end::before {\n  content: \"\\F079C\";\n}\n\n.mdi-bus-articulated-front::before {\n  content: \"\\F079D\";\n}\n\n.mdi-bus-clock::before {\n  content: \"\\F08CA\";\n}\n\n.mdi-bus-double-decker::before {\n  content: \"\\F079E\";\n}\n\n.mdi-bus-marker::before {\n  content: \"\\F1212\";\n}\n\n.mdi-bus-multiple::before {\n  content: \"\\F0F3F\";\n}\n\n.mdi-bus-school::before {\n  content: \"\\F079F\";\n}\n\n.mdi-bus-side::before {\n  content: \"\\F07A0\";\n}\n\n.mdi-bus-stop::before {\n  content: \"\\F1012\";\n}\n\n.mdi-bus-stop-covered::before {\n  content: \"\\F1013\";\n}\n\n.mdi-bus-stop-uncovered::before {\n  content: \"\\F1014\";\n}\n\n.mdi-cable-data::before {\n  content: \"\\F1394\";\n}\n\n.mdi-cached::before {\n  content: \"\\F00E8\";\n}\n\n.mdi-cactus::before {\n  content: \"\\F0DB5\";\n}\n\n.mdi-cake::before {\n  content: \"\\F00E9\";\n}\n\n.mdi-cake-layered::before {\n  content: \"\\F00EA\";\n}\n\n.mdi-cake-variant::before {\n  content: \"\\F00EB\";\n}\n\n.mdi-calculator::before {\n  content: \"\\F00EC\";\n}\n\n.mdi-calculator-variant::before {\n  content: \"\\F0A9A\";\n}\n\n.mdi-calendar::before {\n  content: \"\\F00ED\";\n}\n\n.mdi-calendar-account::before {\n  content: \"\\F0ED7\";\n}\n\n.mdi-calendar-account-outline::before {\n  content: \"\\F0ED8\";\n}\n\n.mdi-calendar-alert::before {\n  content: \"\\F0A31\";\n}\n\n.mdi-calendar-arrow-left::before {\n  content: \"\\F1134\";\n}\n\n.mdi-calendar-arrow-right::before {\n  content: \"\\F1135\";\n}\n\n.mdi-calendar-blank::before {\n  content: \"\\F00EE\";\n}\n\n.mdi-calendar-blank-multiple::before {\n  content: \"\\F1073\";\n}\n\n.mdi-calendar-blank-outline::before {\n  content: \"\\F0B66\";\n}\n\n.mdi-calendar-check::before {\n  content: \"\\F00EF\";\n}\n\n.mdi-calendar-check-outline::before {\n  content: \"\\F0C44\";\n}\n\n.mdi-calendar-clock::before {\n  content: \"\\F00F0\";\n}\n\n.mdi-calendar-edit::before {\n  content: \"\\F08A7\";\n}\n\n.mdi-calendar-export::before {\n  content: \"\\F0B24\";\n}\n\n.mdi-calendar-heart::before {\n  content: \"\\F09D2\";\n}\n\n.mdi-calendar-import::before {\n  content: \"\\F0B25\";\n}\n\n.mdi-calendar-minus::before {\n  content: \"\\F0D5C\";\n}\n\n.mdi-calendar-month::before {\n  content: \"\\F0E17\";\n}\n\n.mdi-calendar-month-outline::before {\n  content: \"\\F0E18\";\n}\n\n.mdi-calendar-multiple::before {\n  content: \"\\F00F1\";\n}\n\n.mdi-calendar-multiple-check::before {\n  content: \"\\F00F2\";\n}\n\n.mdi-calendar-multiselect::before {\n  content: \"\\F0A32\";\n}\n\n.mdi-calendar-outline::before {\n  content: \"\\F0B67\";\n}\n\n.mdi-calendar-plus::before {\n  content: \"\\F00F3\";\n}\n\n.mdi-calendar-question::before {\n  content: \"\\F0692\";\n}\n\n.mdi-calendar-range::before {\n  content: \"\\F0679\";\n}\n\n.mdi-calendar-range-outline::before {\n  content: \"\\F0B68\";\n}\n\n.mdi-calendar-refresh::before {\n  content: \"\\F01E1\";\n}\n\n.mdi-calendar-refresh-outline::before {\n  content: \"\\F0203\";\n}\n\n.mdi-calendar-remove::before {\n  content: \"\\F00F4\";\n}\n\n.mdi-calendar-remove-outline::before {\n  content: \"\\F0C45\";\n}\n\n.mdi-calendar-search::before {\n  content: \"\\F094C\";\n}\n\n.mdi-calendar-star::before {\n  content: \"\\F09D3\";\n}\n\n.mdi-calendar-sync::before {\n  content: \"\\F0E8E\";\n}\n\n.mdi-calendar-sync-outline::before {\n  content: \"\\F0E8F\";\n}\n\n.mdi-calendar-text::before {\n  content: \"\\F00F5\";\n}\n\n.mdi-calendar-text-outline::before {\n  content: \"\\F0C46\";\n}\n\n.mdi-calendar-today::before {\n  content: \"\\F00F6\";\n}\n\n.mdi-calendar-week::before {\n  content: \"\\F0A33\";\n}\n\n.mdi-calendar-week-begin::before {\n  content: \"\\F0A34\";\n}\n\n.mdi-calendar-weekend::before {\n  content: \"\\F0ED9\";\n}\n\n.mdi-calendar-weekend-outline::before {\n  content: \"\\F0EDA\";\n}\n\n.mdi-call-made::before {\n  content: \"\\F00F7\";\n}\n\n.mdi-call-merge::before {\n  content: \"\\F00F8\";\n}\n\n.mdi-call-missed::before {\n  content: \"\\F00F9\";\n}\n\n.mdi-call-received::before {\n  content: \"\\F00FA\";\n}\n\n.mdi-call-split::before {\n  content: \"\\F00FB\";\n}\n\n.mdi-camcorder::before {\n  content: \"\\F00FC\";\n}\n\n.mdi-camcorder-off::before {\n  content: \"\\F00FF\";\n}\n\n.mdi-camera::before {\n  content: \"\\F0100\";\n}\n\n.mdi-camera-account::before {\n  content: \"\\F08CB\";\n}\n\n.mdi-camera-burst::before {\n  content: \"\\F0693\";\n}\n\n.mdi-camera-control::before {\n  content: \"\\F0B69\";\n}\n\n.mdi-camera-enhance::before {\n  content: \"\\F0101\";\n}\n\n.mdi-camera-enhance-outline::before {\n  content: \"\\F0B6A\";\n}\n\n.mdi-camera-front::before {\n  content: \"\\F0102\";\n}\n\n.mdi-camera-front-variant::before {\n  content: \"\\F0103\";\n}\n\n.mdi-camera-gopro::before {\n  content: \"\\F07A1\";\n}\n\n.mdi-camera-image::before {\n  content: \"\\F08CC\";\n}\n\n.mdi-camera-iris::before {\n  content: \"\\F0104\";\n}\n\n.mdi-camera-metering-center::before {\n  content: \"\\F07A2\";\n}\n\n.mdi-camera-metering-matrix::before {\n  content: \"\\F07A3\";\n}\n\n.mdi-camera-metering-partial::before {\n  content: \"\\F07A4\";\n}\n\n.mdi-camera-metering-spot::before {\n  content: \"\\F07A5\";\n}\n\n.mdi-camera-off::before {\n  content: \"\\F05DF\";\n}\n\n.mdi-camera-outline::before {\n  content: \"\\F0D5D\";\n}\n\n.mdi-camera-party-mode::before {\n  content: \"\\F0105\";\n}\n\n.mdi-camera-plus::before {\n  content: \"\\F0EDB\";\n}\n\n.mdi-camera-plus-outline::before {\n  content: \"\\F0EDC\";\n}\n\n.mdi-camera-rear::before {\n  content: \"\\F0106\";\n}\n\n.mdi-camera-rear-variant::before {\n  content: \"\\F0107\";\n}\n\n.mdi-camera-retake::before {\n  content: \"\\F0E19\";\n}\n\n.mdi-camera-retake-outline::before {\n  content: \"\\F0E1A\";\n}\n\n.mdi-camera-switch::before {\n  content: \"\\F0108\";\n}\n\n.mdi-camera-switch-outline::before {\n  content: \"\\F084A\";\n}\n\n.mdi-camera-timer::before {\n  content: \"\\F0109\";\n}\n\n.mdi-camera-wireless::before {\n  content: \"\\F0DB6\";\n}\n\n.mdi-camera-wireless-outline::before {\n  content: \"\\F0DB7\";\n}\n\n.mdi-campfire::before {\n  content: \"\\F0EDD\";\n}\n\n.mdi-cancel::before {\n  content: \"\\F073A\";\n}\n\n.mdi-candle::before {\n  content: \"\\F05E2\";\n}\n\n.mdi-candycane::before {\n  content: \"\\F010A\";\n}\n\n.mdi-cannabis::before {\n  content: \"\\F07A6\";\n}\n\n.mdi-caps-lock::before {\n  content: \"\\F0A9B\";\n}\n\n.mdi-car::before {\n  content: \"\\F010B\";\n}\n\n.mdi-car-2-plus::before {\n  content: \"\\F1015\";\n}\n\n.mdi-car-3-plus::before {\n  content: \"\\F1016\";\n}\n\n.mdi-car-arrow-left::before {\n  content: \"\\F13B2\";\n}\n\n.mdi-car-arrow-right::before {\n  content: \"\\F13B3\";\n}\n\n.mdi-car-back::before {\n  content: \"\\F0E1B\";\n}\n\n.mdi-car-battery::before {\n  content: \"\\F010C\";\n}\n\n.mdi-car-brake-abs::before {\n  content: \"\\F0C47\";\n}\n\n.mdi-car-brake-alert::before {\n  content: \"\\F0C48\";\n}\n\n.mdi-car-brake-hold::before {\n  content: \"\\F0D5E\";\n}\n\n.mdi-car-brake-parking::before {\n  content: \"\\F0D5F\";\n}\n\n.mdi-car-brake-retarder::before {\n  content: \"\\F1017\";\n}\n\n.mdi-car-child-seat::before {\n  content: \"\\F0FA3\";\n}\n\n.mdi-car-clutch::before {\n  content: \"\\F1018\";\n}\n\n.mdi-car-connected::before {\n  content: \"\\F010D\";\n}\n\n.mdi-car-convertible::before {\n  content: \"\\F07A7\";\n}\n\n.mdi-car-coolant-level::before {\n  content: \"\\F1019\";\n}\n\n.mdi-car-cruise-control::before {\n  content: \"\\F0D60\";\n}\n\n.mdi-car-defrost-front::before {\n  content: \"\\F0D61\";\n}\n\n.mdi-car-defrost-rear::before {\n  content: \"\\F0D62\";\n}\n\n.mdi-car-door::before {\n  content: \"\\F0B6B\";\n}\n\n.mdi-car-door-lock::before {\n  content: \"\\F109D\";\n}\n\n.mdi-car-electric::before {\n  content: \"\\F0B6C\";\n}\n\n.mdi-car-esp::before {\n  content: \"\\F0C49\";\n}\n\n.mdi-car-estate::before {\n  content: \"\\F07A8\";\n}\n\n.mdi-car-hatchback::before {\n  content: \"\\F07A9\";\n}\n\n.mdi-car-info::before {\n  content: \"\\F11BE\";\n}\n\n.mdi-car-key::before {\n  content: \"\\F0B6D\";\n}\n\n.mdi-car-light-dimmed::before {\n  content: \"\\F0C4A\";\n}\n\n.mdi-car-light-fog::before {\n  content: \"\\F0C4B\";\n}\n\n.mdi-car-light-high::before {\n  content: \"\\F0C4C\";\n}\n\n.mdi-car-limousine::before {\n  content: \"\\F08CD\";\n}\n\n.mdi-car-multiple::before {\n  content: \"\\F0B6E\";\n}\n\n.mdi-car-off::before {\n  content: \"\\F0E1C\";\n}\n\n.mdi-car-parking-lights::before {\n  content: \"\\F0D63\";\n}\n\n.mdi-car-pickup::before {\n  content: \"\\F07AA\";\n}\n\n.mdi-car-seat::before {\n  content: \"\\F0FA4\";\n}\n\n.mdi-car-seat-cooler::before {\n  content: \"\\F0FA5\";\n}\n\n.mdi-car-seat-heater::before {\n  content: \"\\F0FA6\";\n}\n\n.mdi-car-shift-pattern::before {\n  content: \"\\F0F40\";\n}\n\n.mdi-car-side::before {\n  content: \"\\F07AB\";\n}\n\n.mdi-car-sports::before {\n  content: \"\\F07AC\";\n}\n\n.mdi-car-tire-alert::before {\n  content: \"\\F0C4D\";\n}\n\n.mdi-car-traction-control::before {\n  content: \"\\F0D64\";\n}\n\n.mdi-car-turbocharger::before {\n  content: \"\\F101A\";\n}\n\n.mdi-car-wash::before {\n  content: \"\\F010E\";\n}\n\n.mdi-car-windshield::before {\n  content: \"\\F101B\";\n}\n\n.mdi-car-windshield-outline::before {\n  content: \"\\F101C\";\n}\n\n.mdi-caravan::before {\n  content: \"\\F07AD\";\n}\n\n.mdi-card::before {\n  content: \"\\F0B6F\";\n}\n\n.mdi-card-account-details::before {\n  content: \"\\F05D2\";\n}\n\n.mdi-card-account-details-outline::before {\n  content: \"\\F0DAB\";\n}\n\n.mdi-card-account-details-star::before {\n  content: \"\\F02A3\";\n}\n\n.mdi-card-account-details-star-outline::before {\n  content: \"\\F06DB\";\n}\n\n.mdi-card-account-mail::before {\n  content: \"\\F018E\";\n}\n\n.mdi-card-account-mail-outline::before {\n  content: \"\\F0E98\";\n}\n\n.mdi-card-account-phone::before {\n  content: \"\\F0E99\";\n}\n\n.mdi-card-account-phone-outline::before {\n  content: \"\\F0E9A\";\n}\n\n.mdi-card-bulleted::before {\n  content: \"\\F0B70\";\n}\n\n.mdi-card-bulleted-off::before {\n  content: \"\\F0B71\";\n}\n\n.mdi-card-bulleted-off-outline::before {\n  content: \"\\F0B72\";\n}\n\n.mdi-card-bulleted-outline::before {\n  content: \"\\F0B73\";\n}\n\n.mdi-card-bulleted-settings::before {\n  content: \"\\F0B74\";\n}\n\n.mdi-card-bulleted-settings-outline::before {\n  content: \"\\F0B75\";\n}\n\n.mdi-card-outline::before {\n  content: \"\\F0B76\";\n}\n\n.mdi-card-plus::before {\n  content: \"\\F11FF\";\n}\n\n.mdi-card-plus-outline::before {\n  content: \"\\F1200\";\n}\n\n.mdi-card-search::before {\n  content: \"\\F1074\";\n}\n\n.mdi-card-search-outline::before {\n  content: \"\\F1075\";\n}\n\n.mdi-card-text::before {\n  content: \"\\F0B77\";\n}\n\n.mdi-card-text-outline::before {\n  content: \"\\F0B78\";\n}\n\n.mdi-cards::before {\n  content: \"\\F0638\";\n}\n\n.mdi-cards-club::before {\n  content: \"\\F08CE\";\n}\n\n.mdi-cards-diamond::before {\n  content: \"\\F08CF\";\n}\n\n.mdi-cards-diamond-outline::before {\n  content: \"\\F101D\";\n}\n\n.mdi-cards-heart::before {\n  content: \"\\F08D0\";\n}\n\n.mdi-cards-outline::before {\n  content: \"\\F0639\";\n}\n\n.mdi-cards-playing-outline::before {\n  content: \"\\F063A\";\n}\n\n.mdi-cards-spade::before {\n  content: \"\\F08D1\";\n}\n\n.mdi-cards-variant::before {\n  content: \"\\F06C7\";\n}\n\n.mdi-carrot::before {\n  content: \"\\F010F\";\n}\n\n.mdi-cart::before {\n  content: \"\\F0110\";\n}\n\n.mdi-cart-arrow-down::before {\n  content: \"\\F0D66\";\n}\n\n.mdi-cart-arrow-right::before {\n  content: \"\\F0C4E\";\n}\n\n.mdi-cart-arrow-up::before {\n  content: \"\\F0D67\";\n}\n\n.mdi-cart-minus::before {\n  content: \"\\F0D68\";\n}\n\n.mdi-cart-off::before {\n  content: \"\\F066B\";\n}\n\n.mdi-cart-outline::before {\n  content: \"\\F0111\";\n}\n\n.mdi-cart-plus::before {\n  content: \"\\F0112\";\n}\n\n.mdi-cart-remove::before {\n  content: \"\\F0D69\";\n}\n\n.mdi-case-sensitive-alt::before {\n  content: \"\\F0113\";\n}\n\n.mdi-cash::before {\n  content: \"\\F0114\";\n}\n\n.mdi-cash-100::before {\n  content: \"\\F0115\";\n}\n\n.mdi-cash-marker::before {\n  content: \"\\F0DB8\";\n}\n\n.mdi-cash-minus::before {\n  content: \"\\F1260\";\n}\n\n.mdi-cash-multiple::before {\n  content: \"\\F0116\";\n}\n\n.mdi-cash-plus::before {\n  content: \"\\F1261\";\n}\n\n.mdi-cash-refund::before {\n  content: \"\\F0A9C\";\n}\n\n.mdi-cash-register::before {\n  content: \"\\F0CF4\";\n}\n\n.mdi-cash-remove::before {\n  content: \"\\F1262\";\n}\n\n.mdi-cash-usd::before {\n  content: \"\\F1176\";\n}\n\n.mdi-cash-usd-outline::before {\n  content: \"\\F0117\";\n}\n\n.mdi-cassette::before {\n  content: \"\\F09D4\";\n}\n\n.mdi-cast::before {\n  content: \"\\F0118\";\n}\n\n.mdi-cast-audio::before {\n  content: \"\\F101E\";\n}\n\n.mdi-cast-connected::before {\n  content: \"\\F0119\";\n}\n\n.mdi-cast-education::before {\n  content: \"\\F0E1D\";\n}\n\n.mdi-cast-off::before {\n  content: \"\\F078A\";\n}\n\n.mdi-castle::before {\n  content: \"\\F011A\";\n}\n\n.mdi-cat::before {\n  content: \"\\F011B\";\n}\n\n.mdi-cctv::before {\n  content: \"\\F07AE\";\n}\n\n.mdi-ceiling-light::before {\n  content: \"\\F0769\";\n}\n\n.mdi-cellphone::before {\n  content: \"\\F011C\";\n}\n\n.mdi-cellphone-android::before {\n  content: \"\\F011D\";\n}\n\n.mdi-cellphone-arrow-down::before {\n  content: \"\\F09D5\";\n}\n\n.mdi-cellphone-basic::before {\n  content: \"\\F011E\";\n}\n\n.mdi-cellphone-charging::before {\n  content: \"\\F1397\";\n}\n\n.mdi-cellphone-cog::before {\n  content: \"\\F0951\";\n}\n\n.mdi-cellphone-dock::before {\n  content: \"\\F011F\";\n}\n\n.mdi-cellphone-erase::before {\n  content: \"\\F094D\";\n}\n\n.mdi-cellphone-information::before {\n  content: \"\\F0F41\";\n}\n\n.mdi-cellphone-iphone::before {\n  content: \"\\F0120\";\n}\n\n.mdi-cellphone-key::before {\n  content: \"\\F094E\";\n}\n\n.mdi-cellphone-link::before {\n  content: \"\\F0121\";\n}\n\n.mdi-cellphone-link-off::before {\n  content: \"\\F0122\";\n}\n\n.mdi-cellphone-lock::before {\n  content: \"\\F094F\";\n}\n\n.mdi-cellphone-message::before {\n  content: \"\\F08D3\";\n}\n\n.mdi-cellphone-message-off::before {\n  content: \"\\F10D2\";\n}\n\n.mdi-cellphone-nfc::before {\n  content: \"\\F0E90\";\n}\n\n.mdi-cellphone-nfc-off::before {\n  content: \"\\F12D8\";\n}\n\n.mdi-cellphone-off::before {\n  content: \"\\F0950\";\n}\n\n.mdi-cellphone-play::before {\n  content: \"\\F101F\";\n}\n\n.mdi-cellphone-screenshot::before {\n  content: \"\\F0A35\";\n}\n\n.mdi-cellphone-settings::before {\n  content: \"\\F0123\";\n}\n\n.mdi-cellphone-sound::before {\n  content: \"\\F0952\";\n}\n\n.mdi-cellphone-text::before {\n  content: \"\\F08D2\";\n}\n\n.mdi-cellphone-wireless::before {\n  content: \"\\F0815\";\n}\n\n.mdi-celtic-cross::before {\n  content: \"\\F0CF5\";\n}\n\n.mdi-centos::before {\n  content: \"\\F111A\";\n}\n\n.mdi-certificate::before {\n  content: \"\\F0124\";\n}\n\n.mdi-certificate-outline::before {\n  content: \"\\F1188\";\n}\n\n.mdi-chair-rolling::before {\n  content: \"\\F0F48\";\n}\n\n.mdi-chair-school::before {\n  content: \"\\F0125\";\n}\n\n.mdi-charity::before {\n  content: \"\\F0C4F\";\n}\n\n.mdi-chart-arc::before {\n  content: \"\\F0126\";\n}\n\n.mdi-chart-areaspline::before {\n  content: \"\\F0127\";\n}\n\n.mdi-chart-areaspline-variant::before {\n  content: \"\\F0E91\";\n}\n\n.mdi-chart-bar::before {\n  content: \"\\F0128\";\n}\n\n.mdi-chart-bar-stacked::before {\n  content: \"\\F076A\";\n}\n\n.mdi-chart-bell-curve::before {\n  content: \"\\F0C50\";\n}\n\n.mdi-chart-bell-curve-cumulative::before {\n  content: \"\\F0FA7\";\n}\n\n.mdi-chart-bubble::before {\n  content: \"\\F05E3\";\n}\n\n.mdi-chart-donut::before {\n  content: \"\\F07AF\";\n}\n\n.mdi-chart-donut-variant::before {\n  content: \"\\F07B0\";\n}\n\n.mdi-chart-gantt::before {\n  content: \"\\F066C\";\n}\n\n.mdi-chart-histogram::before {\n  content: \"\\F0129\";\n}\n\n.mdi-chart-line::before {\n  content: \"\\F012A\";\n}\n\n.mdi-chart-line-stacked::before {\n  content: \"\\F076B\";\n}\n\n.mdi-chart-line-variant::before {\n  content: \"\\F07B1\";\n}\n\n.mdi-chart-multiline::before {\n  content: \"\\F08D4\";\n}\n\n.mdi-chart-multiple::before {\n  content: \"\\F1213\";\n}\n\n.mdi-chart-pie::before {\n  content: \"\\F012B\";\n}\n\n.mdi-chart-ppf::before {\n  content: \"\\F1380\";\n}\n\n.mdi-chart-sankey::before {\n  content: \"\\F11DF\";\n}\n\n.mdi-chart-sankey-variant::before {\n  content: \"\\F11E0\";\n}\n\n.mdi-chart-scatter-plot::before {\n  content: \"\\F0E92\";\n}\n\n.mdi-chart-scatter-plot-hexbin::before {\n  content: \"\\F066D\";\n}\n\n.mdi-chart-timeline::before {\n  content: \"\\F066E\";\n}\n\n.mdi-chart-timeline-variant::before {\n  content: \"\\F0E93\";\n}\n\n.mdi-chart-tree::before {\n  content: \"\\F0E94\";\n}\n\n.mdi-chat::before {\n  content: \"\\F0B79\";\n}\n\n.mdi-chat-alert::before {\n  content: \"\\F0B7A\";\n}\n\n.mdi-chat-alert-outline::before {\n  content: \"\\F12C9\";\n}\n\n.mdi-chat-outline::before {\n  content: \"\\F0EDE\";\n}\n\n.mdi-chat-processing::before {\n  content: \"\\F0B7B\";\n}\n\n.mdi-chat-processing-outline::before {\n  content: \"\\F12CA\";\n}\n\n.mdi-chat-sleep::before {\n  content: \"\\F12D1\";\n}\n\n.mdi-chat-sleep-outline::before {\n  content: \"\\F12D2\";\n}\n\n.mdi-check::before {\n  content: \"\\F012C\";\n}\n\n.mdi-check-all::before {\n  content: \"\\F012D\";\n}\n\n.mdi-check-bold::before {\n  content: \"\\F0E1E\";\n}\n\n.mdi-check-box-multiple-outline::before {\n  content: \"\\F0C51\";\n}\n\n.mdi-check-box-outline::before {\n  content: \"\\F0C52\";\n}\n\n.mdi-check-circle::before {\n  content: \"\\F05E0\";\n}\n\n.mdi-check-circle-outline::before {\n  content: \"\\F05E1\";\n}\n\n.mdi-check-decagram::before {\n  content: \"\\F0791\";\n}\n\n.mdi-check-network::before {\n  content: \"\\F0C53\";\n}\n\n.mdi-check-network-outline::before {\n  content: \"\\F0C54\";\n}\n\n.mdi-check-outline::before {\n  content: \"\\F0855\";\n}\n\n.mdi-check-underline::before {\n  content: \"\\F0E1F\";\n}\n\n.mdi-check-underline-circle::before {\n  content: \"\\F0E20\";\n}\n\n.mdi-check-underline-circle-outline::before {\n  content: \"\\F0E21\";\n}\n\n.mdi-checkbook::before {\n  content: \"\\F0A9D\";\n}\n\n.mdi-checkbox-blank::before {\n  content: \"\\F012E\";\n}\n\n.mdi-checkbox-blank-circle::before {\n  content: \"\\F012F\";\n}\n\n.mdi-checkbox-blank-circle-outline::before {\n  content: \"\\F0130\";\n}\n\n.mdi-checkbox-blank-off::before {\n  content: \"\\F12EC\";\n}\n\n.mdi-checkbox-blank-off-outline::before {\n  content: \"\\F12ED\";\n}\n\n.mdi-checkbox-blank-outline::before {\n  content: \"\\F0131\";\n}\n\n.mdi-checkbox-intermediate::before {\n  content: \"\\F0856\";\n}\n\n.mdi-checkbox-marked::before {\n  content: \"\\F0132\";\n}\n\n.mdi-checkbox-marked-circle::before {\n  content: \"\\F0133\";\n}\n\n.mdi-checkbox-marked-circle-outline::before {\n  content: \"\\F0134\";\n}\n\n.mdi-checkbox-marked-outline::before {\n  content: \"\\F0135\";\n}\n\n.mdi-checkbox-multiple-blank::before {\n  content: \"\\F0136\";\n}\n\n.mdi-checkbox-multiple-blank-circle::before {\n  content: \"\\F063B\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline::before {\n  content: \"\\F063C\";\n}\n\n.mdi-checkbox-multiple-blank-outline::before {\n  content: \"\\F0137\";\n}\n\n.mdi-checkbox-multiple-marked::before {\n  content: \"\\F0138\";\n}\n\n.mdi-checkbox-multiple-marked-circle::before {\n  content: \"\\F063D\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline::before {\n  content: \"\\F063E\";\n}\n\n.mdi-checkbox-multiple-marked-outline::before {\n  content: \"\\F0139\";\n}\n\n.mdi-checkerboard::before {\n  content: \"\\F013A\";\n}\n\n.mdi-checkerboard-minus::before {\n  content: \"\\F1202\";\n}\n\n.mdi-checkerboard-plus::before {\n  content: \"\\F1201\";\n}\n\n.mdi-checkerboard-remove::before {\n  content: \"\\F1203\";\n}\n\n.mdi-cheese::before {\n  content: \"\\F12B9\";\n}\n\n.mdi-chef-hat::before {\n  content: \"\\F0B7C\";\n}\n\n.mdi-chemical-weapon::before {\n  content: \"\\F013B\";\n}\n\n.mdi-chess-bishop::before {\n  content: \"\\F085C\";\n}\n\n.mdi-chess-king::before {\n  content: \"\\F0857\";\n}\n\n.mdi-chess-knight::before {\n  content: \"\\F0858\";\n}\n\n.mdi-chess-pawn::before {\n  content: \"\\F0859\";\n}\n\n.mdi-chess-queen::before {\n  content: \"\\F085A\";\n}\n\n.mdi-chess-rook::before {\n  content: \"\\F085B\";\n}\n\n.mdi-chevron-double-down::before {\n  content: \"\\F013C\";\n}\n\n.mdi-chevron-double-left::before {\n  content: \"\\F013D\";\n}\n\n.mdi-chevron-double-right::before {\n  content: \"\\F013E\";\n}\n\n.mdi-chevron-double-up::before {\n  content: \"\\F013F\";\n}\n\n.mdi-chevron-down::before {\n  content: \"\\F0140\";\n}\n\n.mdi-chevron-down-box::before {\n  content: \"\\F09D6\";\n}\n\n.mdi-chevron-down-box-outline::before {\n  content: \"\\F09D7\";\n}\n\n.mdi-chevron-down-circle::before {\n  content: \"\\F0B26\";\n}\n\n.mdi-chevron-down-circle-outline::before {\n  content: \"\\F0B27\";\n}\n\n.mdi-chevron-left::before {\n  content: \"\\F0141\";\n}\n\n.mdi-chevron-left-box::before {\n  content: \"\\F09D8\";\n}\n\n.mdi-chevron-left-box-outline::before {\n  content: \"\\F09D9\";\n}\n\n.mdi-chevron-left-circle::before {\n  content: \"\\F0B28\";\n}\n\n.mdi-chevron-left-circle-outline::before {\n  content: \"\\F0B29\";\n}\n\n.mdi-chevron-right::before {\n  content: \"\\F0142\";\n}\n\n.mdi-chevron-right-box::before {\n  content: \"\\F09DA\";\n}\n\n.mdi-chevron-right-box-outline::before {\n  content: \"\\F09DB\";\n}\n\n.mdi-chevron-right-circle::before {\n  content: \"\\F0B2A\";\n}\n\n.mdi-chevron-right-circle-outline::before {\n  content: \"\\F0B2B\";\n}\n\n.mdi-chevron-triple-down::before {\n  content: \"\\F0DB9\";\n}\n\n.mdi-chevron-triple-left::before {\n  content: \"\\F0DBA\";\n}\n\n.mdi-chevron-triple-right::before {\n  content: \"\\F0DBB\";\n}\n\n.mdi-chevron-triple-up::before {\n  content: \"\\F0DBC\";\n}\n\n.mdi-chevron-up::before {\n  content: \"\\F0143\";\n}\n\n.mdi-chevron-up-box::before {\n  content: \"\\F09DC\";\n}\n\n.mdi-chevron-up-box-outline::before {\n  content: \"\\F09DD\";\n}\n\n.mdi-chevron-up-circle::before {\n  content: \"\\F0B2C\";\n}\n\n.mdi-chevron-up-circle-outline::before {\n  content: \"\\F0B2D\";\n}\n\n.mdi-chili-hot::before {\n  content: \"\\F07B2\";\n}\n\n.mdi-chili-medium::before {\n  content: \"\\F07B3\";\n}\n\n.mdi-chili-mild::before {\n  content: \"\\F07B4\";\n}\n\n.mdi-chip::before {\n  content: \"\\F061A\";\n}\n\n.mdi-christianity::before {\n  content: \"\\F0953\";\n}\n\n.mdi-christianity-outline::before {\n  content: \"\\F0CF6\";\n}\n\n.mdi-church::before {\n  content: \"\\F0144\";\n}\n\n.mdi-cigar::before {\n  content: \"\\F1189\";\n}\n\n.mdi-circle::before {\n  content: \"\\F0765\";\n}\n\n.mdi-circle-double::before {\n  content: \"\\F0E95\";\n}\n\n.mdi-circle-edit-outline::before {\n  content: \"\\F08D5\";\n}\n\n.mdi-circle-expand::before {\n  content: \"\\F0E96\";\n}\n\n.mdi-circle-half::before {\n  content: \"\\F1395\";\n}\n\n.mdi-circle-half-full::before {\n  content: \"\\F1396\";\n}\n\n.mdi-circle-medium::before {\n  content: \"\\F09DE\";\n}\n\n.mdi-circle-multiple::before {\n  content: \"\\F0B38\";\n}\n\n.mdi-circle-multiple-outline::before {\n  content: \"\\F0695\";\n}\n\n.mdi-circle-off-outline::before {\n  content: \"\\F10D3\";\n}\n\n.mdi-circle-outline::before {\n  content: \"\\F0766\";\n}\n\n.mdi-circle-slice-1::before {\n  content: \"\\F0A9E\";\n}\n\n.mdi-circle-slice-2::before {\n  content: \"\\F0A9F\";\n}\n\n.mdi-circle-slice-3::before {\n  content: \"\\F0AA0\";\n}\n\n.mdi-circle-slice-4::before {\n  content: \"\\F0AA1\";\n}\n\n.mdi-circle-slice-5::before {\n  content: \"\\F0AA2\";\n}\n\n.mdi-circle-slice-6::before {\n  content: \"\\F0AA3\";\n}\n\n.mdi-circle-slice-7::before {\n  content: \"\\F0AA4\";\n}\n\n.mdi-circle-slice-8::before {\n  content: \"\\F0AA5\";\n}\n\n.mdi-circle-small::before {\n  content: \"\\F09DF\";\n}\n\n.mdi-circular-saw::before {\n  content: \"\\F0E22\";\n}\n\n.mdi-city::before {\n  content: \"\\F0146\";\n}\n\n.mdi-city-variant::before {\n  content: \"\\F0A36\";\n}\n\n.mdi-city-variant-outline::before {\n  content: \"\\F0A37\";\n}\n\n.mdi-clipboard::before {\n  content: \"\\F0147\";\n}\n\n.mdi-clipboard-account::before {\n  content: \"\\F0148\";\n}\n\n.mdi-clipboard-account-outline::before {\n  content: \"\\F0C55\";\n}\n\n.mdi-clipboard-alert::before {\n  content: \"\\F0149\";\n}\n\n.mdi-clipboard-alert-outline::before {\n  content: \"\\F0CF7\";\n}\n\n.mdi-clipboard-arrow-down::before {\n  content: \"\\F014A\";\n}\n\n.mdi-clipboard-arrow-down-outline::before {\n  content: \"\\F0C56\";\n}\n\n.mdi-clipboard-arrow-left::before {\n  content: \"\\F014B\";\n}\n\n.mdi-clipboard-arrow-left-outline::before {\n  content: \"\\F0CF8\";\n}\n\n.mdi-clipboard-arrow-right::before {\n  content: \"\\F0CF9\";\n}\n\n.mdi-clipboard-arrow-right-outline::before {\n  content: \"\\F0CFA\";\n}\n\n.mdi-clipboard-arrow-up::before {\n  content: \"\\F0C57\";\n}\n\n.mdi-clipboard-arrow-up-outline::before {\n  content: \"\\F0C58\";\n}\n\n.mdi-clipboard-check::before {\n  content: \"\\F014E\";\n}\n\n.mdi-clipboard-check-multiple::before {\n  content: \"\\F1263\";\n}\n\n.mdi-clipboard-check-multiple-outline::before {\n  content: \"\\F1264\";\n}\n\n.mdi-clipboard-check-outline::before {\n  content: \"\\F08A8\";\n}\n\n.mdi-clipboard-file::before {\n  content: \"\\F1265\";\n}\n\n.mdi-clipboard-file-outline::before {\n  content: \"\\F1266\";\n}\n\n.mdi-clipboard-flow::before {\n  content: \"\\F06C8\";\n}\n\n.mdi-clipboard-flow-outline::before {\n  content: \"\\F1117\";\n}\n\n.mdi-clipboard-list::before {\n  content: \"\\F10D4\";\n}\n\n.mdi-clipboard-list-outline::before {\n  content: \"\\F10D5\";\n}\n\n.mdi-clipboard-multiple::before {\n  content: \"\\F1267\";\n}\n\n.mdi-clipboard-multiple-outline::before {\n  content: \"\\F1268\";\n}\n\n.mdi-clipboard-outline::before {\n  content: \"\\F014C\";\n}\n\n.mdi-clipboard-play::before {\n  content: \"\\F0C59\";\n}\n\n.mdi-clipboard-play-multiple::before {\n  content: \"\\F1269\";\n}\n\n.mdi-clipboard-play-multiple-outline::before {\n  content: \"\\F126A\";\n}\n\n.mdi-clipboard-play-outline::before {\n  content: \"\\F0C5A\";\n}\n\n.mdi-clipboard-plus::before {\n  content: \"\\F0751\";\n}\n\n.mdi-clipboard-plus-outline::before {\n  content: \"\\F131F\";\n}\n\n.mdi-clipboard-pulse::before {\n  content: \"\\F085D\";\n}\n\n.mdi-clipboard-pulse-outline::before {\n  content: \"\\F085E\";\n}\n\n.mdi-clipboard-text::before {\n  content: \"\\F014D\";\n}\n\n.mdi-clipboard-text-multiple::before {\n  content: \"\\F126B\";\n}\n\n.mdi-clipboard-text-multiple-outline::before {\n  content: \"\\F126C\";\n}\n\n.mdi-clipboard-text-outline::before {\n  content: \"\\F0A38\";\n}\n\n.mdi-clipboard-text-play::before {\n  content: \"\\F0C5B\";\n}\n\n.mdi-clipboard-text-play-outline::before {\n  content: \"\\F0C5C\";\n}\n\n.mdi-clippy::before {\n  content: \"\\F014F\";\n}\n\n.mdi-clock::before {\n  content: \"\\F0954\";\n}\n\n.mdi-clock-alert::before {\n  content: \"\\F0955\";\n}\n\n.mdi-clock-alert-outline::before {\n  content: \"\\F05CE\";\n}\n\n.mdi-clock-check::before {\n  content: \"\\F0FA8\";\n}\n\n.mdi-clock-check-outline::before {\n  content: \"\\F0FA9\";\n}\n\n.mdi-clock-digital::before {\n  content: \"\\F0E97\";\n}\n\n.mdi-clock-end::before {\n  content: \"\\F0151\";\n}\n\n.mdi-clock-fast::before {\n  content: \"\\F0152\";\n}\n\n.mdi-clock-in::before {\n  content: \"\\F0153\";\n}\n\n.mdi-clock-out::before {\n  content: \"\\F0154\";\n}\n\n.mdi-clock-outline::before {\n  content: \"\\F0150\";\n}\n\n.mdi-clock-start::before {\n  content: \"\\F0155\";\n}\n\n.mdi-close::before {\n  content: \"\\F0156\";\n}\n\n.mdi-close-box::before {\n  content: \"\\F0157\";\n}\n\n.mdi-close-box-multiple::before {\n  content: \"\\F0C5D\";\n}\n\n.mdi-close-box-multiple-outline::before {\n  content: \"\\F0C5E\";\n}\n\n.mdi-close-box-outline::before {\n  content: \"\\F0158\";\n}\n\n.mdi-close-circle::before {\n  content: \"\\F0159\";\n}\n\n.mdi-close-circle-multiple::before {\n  content: \"\\F062A\";\n}\n\n.mdi-close-circle-multiple-outline::before {\n  content: \"\\F0883\";\n}\n\n.mdi-close-circle-outline::before {\n  content: \"\\F015A\";\n}\n\n.mdi-close-network::before {\n  content: \"\\F015B\";\n}\n\n.mdi-close-network-outline::before {\n  content: \"\\F0C5F\";\n}\n\n.mdi-close-octagon::before {\n  content: \"\\F015C\";\n}\n\n.mdi-close-octagon-outline::before {\n  content: \"\\F015D\";\n}\n\n.mdi-close-outline::before {\n  content: \"\\F06C9\";\n}\n\n.mdi-close-thick::before {\n  content: \"\\F1398\";\n}\n\n.mdi-closed-caption::before {\n  content: \"\\F015E\";\n}\n\n.mdi-closed-caption-outline::before {\n  content: \"\\F0DBD\";\n}\n\n.mdi-cloud::before {\n  content: \"\\F015F\";\n}\n\n.mdi-cloud-alert::before {\n  content: \"\\F09E0\";\n}\n\n.mdi-cloud-braces::before {\n  content: \"\\F07B5\";\n}\n\n.mdi-cloud-check::before {\n  content: \"\\F0160\";\n}\n\n.mdi-cloud-check-outline::before {\n  content: \"\\F12CC\";\n}\n\n.mdi-cloud-circle::before {\n  content: \"\\F0161\";\n}\n\n.mdi-cloud-download::before {\n  content: \"\\F0162\";\n}\n\n.mdi-cloud-download-outline::before {\n  content: \"\\F0B7D\";\n}\n\n.mdi-cloud-lock::before {\n  content: \"\\F11F1\";\n}\n\n.mdi-cloud-lock-outline::before {\n  content: \"\\F11F2\";\n}\n\n.mdi-cloud-off-outline::before {\n  content: \"\\F0164\";\n}\n\n.mdi-cloud-outline::before {\n  content: \"\\F0163\";\n}\n\n.mdi-cloud-print::before {\n  content: \"\\F0165\";\n}\n\n.mdi-cloud-print-outline::before {\n  content: \"\\F0166\";\n}\n\n.mdi-cloud-question::before {\n  content: \"\\F0A39\";\n}\n\n.mdi-cloud-refresh::before {\n  content: \"\\F052A\";\n}\n\n.mdi-cloud-search::before {\n  content: \"\\F0956\";\n}\n\n.mdi-cloud-search-outline::before {\n  content: \"\\F0957\";\n}\n\n.mdi-cloud-sync::before {\n  content: \"\\F063F\";\n}\n\n.mdi-cloud-sync-outline::before {\n  content: \"\\F12D6\";\n}\n\n.mdi-cloud-tags::before {\n  content: \"\\F07B6\";\n}\n\n.mdi-cloud-upload::before {\n  content: \"\\F0167\";\n}\n\n.mdi-cloud-upload-outline::before {\n  content: \"\\F0B7E\";\n}\n\n.mdi-clover::before {\n  content: \"\\F0816\";\n}\n\n.mdi-coach-lamp::before {\n  content: \"\\F1020\";\n}\n\n.mdi-coat-rack::before {\n  content: \"\\F109E\";\n}\n\n.mdi-code-array::before {\n  content: \"\\F0168\";\n}\n\n.mdi-code-braces::before {\n  content: \"\\F0169\";\n}\n\n.mdi-code-braces-box::before {\n  content: \"\\F10D6\";\n}\n\n.mdi-code-brackets::before {\n  content: \"\\F016A\";\n}\n\n.mdi-code-equal::before {\n  content: \"\\F016B\";\n}\n\n.mdi-code-greater-than::before {\n  content: \"\\F016C\";\n}\n\n.mdi-code-greater-than-or-equal::before {\n  content: \"\\F016D\";\n}\n\n.mdi-code-json::before {\n  content: \"\\F0626\";\n}\n\n.mdi-code-less-than::before {\n  content: \"\\F016E\";\n}\n\n.mdi-code-less-than-or-equal::before {\n  content: \"\\F016F\";\n}\n\n.mdi-code-not-equal::before {\n  content: \"\\F0170\";\n}\n\n.mdi-code-not-equal-variant::before {\n  content: \"\\F0171\";\n}\n\n.mdi-code-parentheses::before {\n  content: \"\\F0172\";\n}\n\n.mdi-code-parentheses-box::before {\n  content: \"\\F10D7\";\n}\n\n.mdi-code-string::before {\n  content: \"\\F0173\";\n}\n\n.mdi-code-tags::before {\n  content: \"\\F0174\";\n}\n\n.mdi-code-tags-check::before {\n  content: \"\\F0694\";\n}\n\n.mdi-codepen::before {\n  content: \"\\F0175\";\n}\n\n.mdi-coffee::before {\n  content: \"\\F0176\";\n}\n\n.mdi-coffee-maker::before {\n  content: \"\\F109F\";\n}\n\n.mdi-coffee-off::before {\n  content: \"\\F0FAA\";\n}\n\n.mdi-coffee-off-outline::before {\n  content: \"\\F0FAB\";\n}\n\n.mdi-coffee-outline::before {\n  content: \"\\F06CA\";\n}\n\n.mdi-coffee-to-go::before {\n  content: \"\\F0177\";\n}\n\n.mdi-coffee-to-go-outline::before {\n  content: \"\\F130E\";\n}\n\n.mdi-coffin::before {\n  content: \"\\F0B7F\";\n}\n\n.mdi-cog::before {\n  content: \"\\F0493\";\n}\n\n.mdi-cog-box::before {\n  content: \"\\F0494\";\n}\n\n.mdi-cog-clockwise::before {\n  content: \"\\F11DD\";\n}\n\n.mdi-cog-counterclockwise::before {\n  content: \"\\F11DE\";\n}\n\n.mdi-cog-outline::before {\n  content: \"\\F08BB\";\n}\n\n.mdi-cog-transfer::before {\n  content: \"\\F105B\";\n}\n\n.mdi-cog-transfer-outline::before {\n  content: \"\\F105C\";\n}\n\n.mdi-cogs::before {\n  content: \"\\F08D6\";\n}\n\n.mdi-collage::before {\n  content: \"\\F0640\";\n}\n\n.mdi-collapse-all::before {\n  content: \"\\F0AA6\";\n}\n\n.mdi-collapse-all-outline::before {\n  content: \"\\F0AA7\";\n}\n\n.mdi-color-helper::before {\n  content: \"\\F0179\";\n}\n\n.mdi-comma::before {\n  content: \"\\F0E23\";\n}\n\n.mdi-comma-box::before {\n  content: \"\\F0E2B\";\n}\n\n.mdi-comma-box-outline::before {\n  content: \"\\F0E24\";\n}\n\n.mdi-comma-circle::before {\n  content: \"\\F0E25\";\n}\n\n.mdi-comma-circle-outline::before {\n  content: \"\\F0E26\";\n}\n\n.mdi-comment::before {\n  content: \"\\F017A\";\n}\n\n.mdi-comment-account::before {\n  content: \"\\F017B\";\n}\n\n.mdi-comment-account-outline::before {\n  content: \"\\F017C\";\n}\n\n.mdi-comment-alert::before {\n  content: \"\\F017D\";\n}\n\n.mdi-comment-alert-outline::before {\n  content: \"\\F017E\";\n}\n\n.mdi-comment-arrow-left::before {\n  content: \"\\F09E1\";\n}\n\n.mdi-comment-arrow-left-outline::before {\n  content: \"\\F09E2\";\n}\n\n.mdi-comment-arrow-right::before {\n  content: \"\\F09E3\";\n}\n\n.mdi-comment-arrow-right-outline::before {\n  content: \"\\F09E4\";\n}\n\n.mdi-comment-check::before {\n  content: \"\\F017F\";\n}\n\n.mdi-comment-check-outline::before {\n  content: \"\\F0180\";\n}\n\n.mdi-comment-edit::before {\n  content: \"\\F11BF\";\n}\n\n.mdi-comment-edit-outline::before {\n  content: \"\\F12C4\";\n}\n\n.mdi-comment-eye::before {\n  content: \"\\F0A3A\";\n}\n\n.mdi-comment-eye-outline::before {\n  content: \"\\F0A3B\";\n}\n\n.mdi-comment-multiple::before {\n  content: \"\\F085F\";\n}\n\n.mdi-comment-multiple-outline::before {\n  content: \"\\F0181\";\n}\n\n.mdi-comment-outline::before {\n  content: \"\\F0182\";\n}\n\n.mdi-comment-plus::before {\n  content: \"\\F09E5\";\n}\n\n.mdi-comment-plus-outline::before {\n  content: \"\\F0183\";\n}\n\n.mdi-comment-processing::before {\n  content: \"\\F0184\";\n}\n\n.mdi-comment-processing-outline::before {\n  content: \"\\F0185\";\n}\n\n.mdi-comment-question::before {\n  content: \"\\F0817\";\n}\n\n.mdi-comment-question-outline::before {\n  content: \"\\F0186\";\n}\n\n.mdi-comment-quote::before {\n  content: \"\\F1021\";\n}\n\n.mdi-comment-quote-outline::before {\n  content: \"\\F1022\";\n}\n\n.mdi-comment-remove::before {\n  content: \"\\F05DE\";\n}\n\n.mdi-comment-remove-outline::before {\n  content: \"\\F0187\";\n}\n\n.mdi-comment-search::before {\n  content: \"\\F0A3C\";\n}\n\n.mdi-comment-search-outline::before {\n  content: \"\\F0A3D\";\n}\n\n.mdi-comment-text::before {\n  content: \"\\F0188\";\n}\n\n.mdi-comment-text-multiple::before {\n  content: \"\\F0860\";\n}\n\n.mdi-comment-text-multiple-outline::before {\n  content: \"\\F0861\";\n}\n\n.mdi-comment-text-outline::before {\n  content: \"\\F0189\";\n}\n\n.mdi-compare::before {\n  content: \"\\F018A\";\n}\n\n.mdi-compass::before {\n  content: \"\\F018B\";\n}\n\n.mdi-compass-off::before {\n  content: \"\\F0B80\";\n}\n\n.mdi-compass-off-outline::before {\n  content: \"\\F0B81\";\n}\n\n.mdi-compass-outline::before {\n  content: \"\\F018C\";\n}\n\n.mdi-compass-rose::before {\n  content: \"\\F1382\";\n}\n\n.mdi-concourse-ci::before {\n  content: \"\\F10A0\";\n}\n\n.mdi-console::before {\n  content: \"\\F018D\";\n}\n\n.mdi-console-line::before {\n  content: \"\\F07B7\";\n}\n\n.mdi-console-network::before {\n  content: \"\\F08A9\";\n}\n\n.mdi-console-network-outline::before {\n  content: \"\\F0C60\";\n}\n\n.mdi-consolidate::before {\n  content: \"\\F10D8\";\n}\n\n.mdi-contactless-payment::before {\n  content: \"\\F0D6A\";\n}\n\n.mdi-contactless-payment-circle::before {\n  content: \"\\F0321\";\n}\n\n.mdi-contactless-payment-circle-outline::before {\n  content: \"\\F0408\";\n}\n\n.mdi-contacts::before {\n  content: \"\\F06CB\";\n}\n\n.mdi-contacts-outline::before {\n  content: \"\\F05B8\";\n}\n\n.mdi-contain::before {\n  content: \"\\F0A3E\";\n}\n\n.mdi-contain-end::before {\n  content: \"\\F0A3F\";\n}\n\n.mdi-contain-start::before {\n  content: \"\\F0A40\";\n}\n\n.mdi-content-copy::before {\n  content: \"\\F018F\";\n}\n\n.mdi-content-cut::before {\n  content: \"\\F0190\";\n}\n\n.mdi-content-duplicate::before {\n  content: \"\\F0191\";\n}\n\n.mdi-content-paste::before {\n  content: \"\\F0192\";\n}\n\n.mdi-content-save::before {\n  content: \"\\F0193\";\n}\n\n.mdi-content-save-alert::before {\n  content: \"\\F0F42\";\n}\n\n.mdi-content-save-alert-outline::before {\n  content: \"\\F0F43\";\n}\n\n.mdi-content-save-all::before {\n  content: \"\\F0194\";\n}\n\n.mdi-content-save-all-outline::before {\n  content: \"\\F0F44\";\n}\n\n.mdi-content-save-edit::before {\n  content: \"\\F0CFB\";\n}\n\n.mdi-content-save-edit-outline::before {\n  content: \"\\F0CFC\";\n}\n\n.mdi-content-save-move::before {\n  content: \"\\F0E27\";\n}\n\n.mdi-content-save-move-outline::before {\n  content: \"\\F0E28\";\n}\n\n.mdi-content-save-outline::before {\n  content: \"\\F0818\";\n}\n\n.mdi-content-save-settings::before {\n  content: \"\\F061B\";\n}\n\n.mdi-content-save-settings-outline::before {\n  content: \"\\F0B2E\";\n}\n\n.mdi-contrast::before {\n  content: \"\\F0195\";\n}\n\n.mdi-contrast-box::before {\n  content: \"\\F0196\";\n}\n\n.mdi-contrast-circle::before {\n  content: \"\\F0197\";\n}\n\n.mdi-controller-classic::before {\n  content: \"\\F0B82\";\n}\n\n.mdi-controller-classic-outline::before {\n  content: \"\\F0B83\";\n}\n\n.mdi-cookie::before {\n  content: \"\\F0198\";\n}\n\n.mdi-coolant-temperature::before {\n  content: \"\\F03C8\";\n}\n\n.mdi-copyright::before {\n  content: \"\\F05E6\";\n}\n\n.mdi-cordova::before {\n  content: \"\\F0958\";\n}\n\n.mdi-corn::before {\n  content: \"\\F07B8\";\n}\n\n.mdi-counter::before {\n  content: \"\\F0199\";\n}\n\n.mdi-cow::before {\n  content: \"\\F019A\";\n}\n\n.mdi-cpu-32-bit::before {\n  content: \"\\F0EDF\";\n}\n\n.mdi-cpu-64-bit::before {\n  content: \"\\F0EE0\";\n}\n\n.mdi-crane::before {\n  content: \"\\F0862\";\n}\n\n.mdi-creation::before {\n  content: \"\\F0674\";\n}\n\n.mdi-creative-commons::before {\n  content: \"\\F0D6B\";\n}\n\n.mdi-credit-card::before {\n  content: \"\\F0FEF\";\n}\n\n.mdi-credit-card-clock::before {\n  content: \"\\F0EE1\";\n}\n\n.mdi-credit-card-clock-outline::before {\n  content: \"\\F0EE2\";\n}\n\n.mdi-credit-card-marker::before {\n  content: \"\\F06A8\";\n}\n\n.mdi-credit-card-marker-outline::before {\n  content: \"\\F0DBE\";\n}\n\n.mdi-credit-card-minus::before {\n  content: \"\\F0FAC\";\n}\n\n.mdi-credit-card-minus-outline::before {\n  content: \"\\F0FAD\";\n}\n\n.mdi-credit-card-multiple::before {\n  content: \"\\F0FF0\";\n}\n\n.mdi-credit-card-multiple-outline::before {\n  content: \"\\F019C\";\n}\n\n.mdi-credit-card-off::before {\n  content: \"\\F0FF1\";\n}\n\n.mdi-credit-card-off-outline::before {\n  content: \"\\F05E4\";\n}\n\n.mdi-credit-card-outline::before {\n  content: \"\\F019B\";\n}\n\n.mdi-credit-card-plus::before {\n  content: \"\\F0FF2\";\n}\n\n.mdi-credit-card-plus-outline::before {\n  content: \"\\F0676\";\n}\n\n.mdi-credit-card-refund::before {\n  content: \"\\F0FF3\";\n}\n\n.mdi-credit-card-refund-outline::before {\n  content: \"\\F0AA8\";\n}\n\n.mdi-credit-card-remove::before {\n  content: \"\\F0FAE\";\n}\n\n.mdi-credit-card-remove-outline::before {\n  content: \"\\F0FAF\";\n}\n\n.mdi-credit-card-scan::before {\n  content: \"\\F0FF4\";\n}\n\n.mdi-credit-card-scan-outline::before {\n  content: \"\\F019D\";\n}\n\n.mdi-credit-card-settings::before {\n  content: \"\\F0FF5\";\n}\n\n.mdi-credit-card-settings-outline::before {\n  content: \"\\F08D7\";\n}\n\n.mdi-credit-card-wireless::before {\n  content: \"\\F0802\";\n}\n\n.mdi-credit-card-wireless-off::before {\n  content: \"\\F057A\";\n}\n\n.mdi-credit-card-wireless-off-outline::before {\n  content: \"\\F057B\";\n}\n\n.mdi-credit-card-wireless-outline::before {\n  content: \"\\F0D6C\";\n}\n\n.mdi-cricket::before {\n  content: \"\\F0D6D\";\n}\n\n.mdi-crop::before {\n  content: \"\\F019E\";\n}\n\n.mdi-crop-free::before {\n  content: \"\\F019F\";\n}\n\n.mdi-crop-landscape::before {\n  content: \"\\F01A0\";\n}\n\n.mdi-crop-portrait::before {\n  content: \"\\F01A1\";\n}\n\n.mdi-crop-rotate::before {\n  content: \"\\F0696\";\n}\n\n.mdi-crop-square::before {\n  content: \"\\F01A2\";\n}\n\n.mdi-crosshairs::before {\n  content: \"\\F01A3\";\n}\n\n.mdi-crosshairs-gps::before {\n  content: \"\\F01A4\";\n}\n\n.mdi-crosshairs-off::before {\n  content: \"\\F0F45\";\n}\n\n.mdi-crosshairs-question::before {\n  content: \"\\F1136\";\n}\n\n.mdi-crown::before {\n  content: \"\\F01A5\";\n}\n\n.mdi-crown-outline::before {\n  content: \"\\F11D0\";\n}\n\n.mdi-cryengine::before {\n  content: \"\\F0959\";\n}\n\n.mdi-crystal-ball::before {\n  content: \"\\F0B2F\";\n}\n\n.mdi-cube::before {\n  content: \"\\F01A6\";\n}\n\n.mdi-cube-outline::before {\n  content: \"\\F01A7\";\n}\n\n.mdi-cube-scan::before {\n  content: \"\\F0B84\";\n}\n\n.mdi-cube-send::before {\n  content: \"\\F01A8\";\n}\n\n.mdi-cube-unfolded::before {\n  content: \"\\F01A9\";\n}\n\n.mdi-cup::before {\n  content: \"\\F01AA\";\n}\n\n.mdi-cup-off::before {\n  content: \"\\F05E5\";\n}\n\n.mdi-cup-off-outline::before {\n  content: \"\\F137D\";\n}\n\n.mdi-cup-outline::before {\n  content: \"\\F130F\";\n}\n\n.mdi-cup-water::before {\n  content: \"\\F01AB\";\n}\n\n.mdi-cupboard::before {\n  content: \"\\F0F46\";\n}\n\n.mdi-cupboard-outline::before {\n  content: \"\\F0F47\";\n}\n\n.mdi-cupcake::before {\n  content: \"\\F095A\";\n}\n\n.mdi-curling::before {\n  content: \"\\F0863\";\n}\n\n.mdi-currency-bdt::before {\n  content: \"\\F0864\";\n}\n\n.mdi-currency-brl::before {\n  content: \"\\F0B85\";\n}\n\n.mdi-currency-btc::before {\n  content: \"\\F01AC\";\n}\n\n.mdi-currency-cny::before {\n  content: \"\\F07BA\";\n}\n\n.mdi-currency-eth::before {\n  content: \"\\F07BB\";\n}\n\n.mdi-currency-eur::before {\n  content: \"\\F01AD\";\n}\n\n.mdi-currency-eur-off::before {\n  content: \"\\F1315\";\n}\n\n.mdi-currency-gbp::before {\n  content: \"\\F01AE\";\n}\n\n.mdi-currency-ils::before {\n  content: \"\\F0C61\";\n}\n\n.mdi-currency-inr::before {\n  content: \"\\F01AF\";\n}\n\n.mdi-currency-jpy::before {\n  content: \"\\F07BC\";\n}\n\n.mdi-currency-krw::before {\n  content: \"\\F07BD\";\n}\n\n.mdi-currency-kzt::before {\n  content: \"\\F0865\";\n}\n\n.mdi-currency-ngn::before {\n  content: \"\\F01B0\";\n}\n\n.mdi-currency-php::before {\n  content: \"\\F09E6\";\n}\n\n.mdi-currency-rial::before {\n  content: \"\\F0E9C\";\n}\n\n.mdi-currency-rub::before {\n  content: \"\\F01B1\";\n}\n\n.mdi-currency-sign::before {\n  content: \"\\F07BE\";\n}\n\n.mdi-currency-try::before {\n  content: \"\\F01B2\";\n}\n\n.mdi-currency-twd::before {\n  content: \"\\F07BF\";\n}\n\n.mdi-currency-usd::before {\n  content: \"\\F01C1\";\n}\n\n.mdi-currency-usd-circle::before {\n  content: \"\\F116B\";\n}\n\n.mdi-currency-usd-circle-outline::before {\n  content: \"\\F0178\";\n}\n\n.mdi-currency-usd-off::before {\n  content: \"\\F067A\";\n}\n\n.mdi-current-ac::before {\n  content: \"\\F095B\";\n}\n\n.mdi-current-dc::before {\n  content: \"\\F095C\";\n}\n\n.mdi-cursor-default::before {\n  content: \"\\F01C0\";\n}\n\n.mdi-cursor-default-click::before {\n  content: \"\\F0CFD\";\n}\n\n.mdi-cursor-default-click-outline::before {\n  content: \"\\F0CFE\";\n}\n\n.mdi-cursor-default-gesture::before {\n  content: \"\\F1127\";\n}\n\n.mdi-cursor-default-gesture-outline::before {\n  content: \"\\F1128\";\n}\n\n.mdi-cursor-default-outline::before {\n  content: \"\\F01BF\";\n}\n\n.mdi-cursor-move::before {\n  content: \"\\F01BE\";\n}\n\n.mdi-cursor-pointer::before {\n  content: \"\\F01BD\";\n}\n\n.mdi-cursor-text::before {\n  content: \"\\F05E7\";\n}\n\n.mdi-database::before {\n  content: \"\\F01BC\";\n}\n\n.mdi-database-check::before {\n  content: \"\\F0AA9\";\n}\n\n.mdi-database-edit::before {\n  content: \"\\F0B86\";\n}\n\n.mdi-database-export::before {\n  content: \"\\F095E\";\n}\n\n.mdi-database-import::before {\n  content: \"\\F095D\";\n}\n\n.mdi-database-lock::before {\n  content: \"\\F0AAA\";\n}\n\n.mdi-database-marker::before {\n  content: \"\\F12F6\";\n}\n\n.mdi-database-minus::before {\n  content: \"\\F01BB\";\n}\n\n.mdi-database-plus::before {\n  content: \"\\F01BA\";\n}\n\n.mdi-database-refresh::before {\n  content: \"\\F05C2\";\n}\n\n.mdi-database-remove::before {\n  content: \"\\F0D00\";\n}\n\n.mdi-database-search::before {\n  content: \"\\F0866\";\n}\n\n.mdi-database-settings::before {\n  content: \"\\F0D01\";\n}\n\n.mdi-database-sync::before {\n  content: \"\\F0CFF\";\n}\n\n.mdi-death-star::before {\n  content: \"\\F08D8\";\n}\n\n.mdi-death-star-variant::before {\n  content: \"\\F08D9\";\n}\n\n.mdi-deathly-hallows::before {\n  content: \"\\F0B87\";\n}\n\n.mdi-debian::before {\n  content: \"\\F08DA\";\n}\n\n.mdi-debug-step-into::before {\n  content: \"\\F01B9\";\n}\n\n.mdi-debug-step-out::before {\n  content: \"\\F01B8\";\n}\n\n.mdi-debug-step-over::before {\n  content: \"\\F01B7\";\n}\n\n.mdi-decagram::before {\n  content: \"\\F076C\";\n}\n\n.mdi-decagram-outline::before {\n  content: \"\\F076D\";\n}\n\n.mdi-decimal::before {\n  content: \"\\F10A1\";\n}\n\n.mdi-decimal-comma::before {\n  content: \"\\F10A2\";\n}\n\n.mdi-decimal-comma-decrease::before {\n  content: \"\\F10A3\";\n}\n\n.mdi-decimal-comma-increase::before {\n  content: \"\\F10A4\";\n}\n\n.mdi-decimal-decrease::before {\n  content: \"\\F01B6\";\n}\n\n.mdi-decimal-increase::before {\n  content: \"\\F01B5\";\n}\n\n.mdi-delete::before {\n  content: \"\\F01B4\";\n}\n\n.mdi-delete-alert::before {\n  content: \"\\F10A5\";\n}\n\n.mdi-delete-alert-outline::before {\n  content: \"\\F10A6\";\n}\n\n.mdi-delete-circle::before {\n  content: \"\\F0683\";\n}\n\n.mdi-delete-circle-outline::before {\n  content: \"\\F0B88\";\n}\n\n.mdi-delete-empty::before {\n  content: \"\\F06CC\";\n}\n\n.mdi-delete-empty-outline::before {\n  content: \"\\F0E9D\";\n}\n\n.mdi-delete-forever::before {\n  content: \"\\F05E8\";\n}\n\n.mdi-delete-forever-outline::before {\n  content: \"\\F0B89\";\n}\n\n.mdi-delete-off::before {\n  content: \"\\F10A7\";\n}\n\n.mdi-delete-off-outline::before {\n  content: \"\\F10A8\";\n}\n\n.mdi-delete-outline::before {\n  content: \"\\F09E7\";\n}\n\n.mdi-delete-restore::before {\n  content: \"\\F0819\";\n}\n\n.mdi-delete-sweep::before {\n  content: \"\\F05E9\";\n}\n\n.mdi-delete-sweep-outline::before {\n  content: \"\\F0C62\";\n}\n\n.mdi-delete-variant::before {\n  content: \"\\F01B3\";\n}\n\n.mdi-delta::before {\n  content: \"\\F01C2\";\n}\n\n.mdi-desk::before {\n  content: \"\\F1239\";\n}\n\n.mdi-desk-lamp::before {\n  content: \"\\F095F\";\n}\n\n.mdi-deskphone::before {\n  content: \"\\F01C3\";\n}\n\n.mdi-desktop-classic::before {\n  content: \"\\F07C0\";\n}\n\n.mdi-desktop-mac::before {\n  content: \"\\F01C4\";\n}\n\n.mdi-desktop-mac-dashboard::before {\n  content: \"\\F09E8\";\n}\n\n.mdi-desktop-tower::before {\n  content: \"\\F01C5\";\n}\n\n.mdi-desktop-tower-monitor::before {\n  content: \"\\F0AAB\";\n}\n\n.mdi-details::before {\n  content: \"\\F01C6\";\n}\n\n.mdi-dev-to::before {\n  content: \"\\F0D6E\";\n}\n\n.mdi-developer-board::before {\n  content: \"\\F0697\";\n}\n\n.mdi-deviantart::before {\n  content: \"\\F01C7\";\n}\n\n.mdi-devices::before {\n  content: \"\\F0FB0\";\n}\n\n.mdi-diabetes::before {\n  content: \"\\F1126\";\n}\n\n.mdi-dialpad::before {\n  content: \"\\F061C\";\n}\n\n.mdi-diameter::before {\n  content: \"\\F0C63\";\n}\n\n.mdi-diameter-outline::before {\n  content: \"\\F0C64\";\n}\n\n.mdi-diameter-variant::before {\n  content: \"\\F0C65\";\n}\n\n.mdi-diamond::before {\n  content: \"\\F0B8A\";\n}\n\n.mdi-diamond-outline::before {\n  content: \"\\F0B8B\";\n}\n\n.mdi-diamond-stone::before {\n  content: \"\\F01C8\";\n}\n\n.mdi-dice-1::before {\n  content: \"\\F01CA\";\n}\n\n.mdi-dice-1-outline::before {\n  content: \"\\F114A\";\n}\n\n.mdi-dice-2::before {\n  content: \"\\F01CB\";\n}\n\n.mdi-dice-2-outline::before {\n  content: \"\\F114B\";\n}\n\n.mdi-dice-3::before {\n  content: \"\\F01CC\";\n}\n\n.mdi-dice-3-outline::before {\n  content: \"\\F114C\";\n}\n\n.mdi-dice-4::before {\n  content: \"\\F01CD\";\n}\n\n.mdi-dice-4-outline::before {\n  content: \"\\F114D\";\n}\n\n.mdi-dice-5::before {\n  content: \"\\F01CE\";\n}\n\n.mdi-dice-5-outline::before {\n  content: \"\\F114E\";\n}\n\n.mdi-dice-6::before {\n  content: \"\\F01CF\";\n}\n\n.mdi-dice-6-outline::before {\n  content: \"\\F114F\";\n}\n\n.mdi-dice-d10::before {\n  content: \"\\F1153\";\n}\n\n.mdi-dice-d10-outline::before {\n  content: \"\\F076F\";\n}\n\n.mdi-dice-d12::before {\n  content: \"\\F1154\";\n}\n\n.mdi-dice-d12-outline::before {\n  content: \"\\F0867\";\n}\n\n.mdi-dice-d20::before {\n  content: \"\\F1155\";\n}\n\n.mdi-dice-d20-outline::before {\n  content: \"\\F05EA\";\n}\n\n.mdi-dice-d4::before {\n  content: \"\\F1150\";\n}\n\n.mdi-dice-d4-outline::before {\n  content: \"\\F05EB\";\n}\n\n.mdi-dice-d6::before {\n  content: \"\\F1151\";\n}\n\n.mdi-dice-d6-outline::before {\n  content: \"\\F05ED\";\n}\n\n.mdi-dice-d8::before {\n  content: \"\\F1152\";\n}\n\n.mdi-dice-d8-outline::before {\n  content: \"\\F05EC\";\n}\n\n.mdi-dice-multiple::before {\n  content: \"\\F076E\";\n}\n\n.mdi-dice-multiple-outline::before {\n  content: \"\\F1156\";\n}\n\n.mdi-digital-ocean::before {\n  content: \"\\F1237\";\n}\n\n.mdi-dip-switch::before {\n  content: \"\\F07C1\";\n}\n\n.mdi-directions::before {\n  content: \"\\F01D0\";\n}\n\n.mdi-directions-fork::before {\n  content: \"\\F0641\";\n}\n\n.mdi-disc::before {\n  content: \"\\F05EE\";\n}\n\n.mdi-disc-alert::before {\n  content: \"\\F01D1\";\n}\n\n.mdi-disc-player::before {\n  content: \"\\F0960\";\n}\n\n.mdi-discord::before {\n  content: \"\\F066F\";\n}\n\n.mdi-dishwasher::before {\n  content: \"\\F0AAC\";\n}\n\n.mdi-dishwasher-alert::before {\n  content: \"\\F11B8\";\n}\n\n.mdi-dishwasher-off::before {\n  content: \"\\F11B9\";\n}\n\n.mdi-disqus::before {\n  content: \"\\F01D2\";\n}\n\n.mdi-distribute-horizontal-center::before {\n  content: \"\\F11C9\";\n}\n\n.mdi-distribute-horizontal-left::before {\n  content: \"\\F11C8\";\n}\n\n.mdi-distribute-horizontal-right::before {\n  content: \"\\F11CA\";\n}\n\n.mdi-distribute-vertical-bottom::before {\n  content: \"\\F11CB\";\n}\n\n.mdi-distribute-vertical-center::before {\n  content: \"\\F11CC\";\n}\n\n.mdi-distribute-vertical-top::before {\n  content: \"\\F11CD\";\n}\n\n.mdi-diving-flippers::before {\n  content: \"\\F0DBF\";\n}\n\n.mdi-diving-helmet::before {\n  content: \"\\F0DC0\";\n}\n\n.mdi-diving-scuba::before {\n  content: \"\\F0DC1\";\n}\n\n.mdi-diving-scuba-flag::before {\n  content: \"\\F0DC2\";\n}\n\n.mdi-diving-scuba-tank::before {\n  content: \"\\F0DC3\";\n}\n\n.mdi-diving-scuba-tank-multiple::before {\n  content: \"\\F0DC4\";\n}\n\n.mdi-diving-snorkel::before {\n  content: \"\\F0DC5\";\n}\n\n.mdi-division::before {\n  content: \"\\F01D4\";\n}\n\n.mdi-division-box::before {\n  content: \"\\F01D5\";\n}\n\n.mdi-dlna::before {\n  content: \"\\F0A41\";\n}\n\n.mdi-dna::before {\n  content: \"\\F0684\";\n}\n\n.mdi-dns::before {\n  content: \"\\F01D6\";\n}\n\n.mdi-dns-outline::before {\n  content: \"\\F0B8C\";\n}\n\n.mdi-do-not-disturb::before {\n  content: \"\\F0698\";\n}\n\n.mdi-do-not-disturb-off::before {\n  content: \"\\F0699\";\n}\n\n.mdi-dock-bottom::before {\n  content: \"\\F10A9\";\n}\n\n.mdi-dock-left::before {\n  content: \"\\F10AA\";\n}\n\n.mdi-dock-right::before {\n  content: \"\\F10AB\";\n}\n\n.mdi-dock-window::before {\n  content: \"\\F10AC\";\n}\n\n.mdi-docker::before {\n  content: \"\\F0868\";\n}\n\n.mdi-doctor::before {\n  content: \"\\F0A42\";\n}\n\n.mdi-dog::before {\n  content: \"\\F0A43\";\n}\n\n.mdi-dog-service::before {\n  content: \"\\F0AAD\";\n}\n\n.mdi-dog-side::before {\n  content: \"\\F0A44\";\n}\n\n.mdi-dolby::before {\n  content: \"\\F06B3\";\n}\n\n.mdi-dolly::before {\n  content: \"\\F0E9E\";\n}\n\n.mdi-domain::before {\n  content: \"\\F01D7\";\n}\n\n.mdi-domain-off::before {\n  content: \"\\F0D6F\";\n}\n\n.mdi-domain-plus::before {\n  content: \"\\F10AD\";\n}\n\n.mdi-domain-remove::before {\n  content: \"\\F10AE\";\n}\n\n.mdi-domino-mask::before {\n  content: \"\\F1023\";\n}\n\n.mdi-donkey::before {\n  content: \"\\F07C2\";\n}\n\n.mdi-door::before {\n  content: \"\\F081A\";\n}\n\n.mdi-door-closed::before {\n  content: \"\\F081B\";\n}\n\n.mdi-door-closed-lock::before {\n  content: \"\\F10AF\";\n}\n\n.mdi-door-open::before {\n  content: \"\\F081C\";\n}\n\n.mdi-doorbell::before {\n  content: \"\\F12E6\";\n}\n\n.mdi-doorbell-video::before {\n  content: \"\\F0869\";\n}\n\n.mdi-dot-net::before {\n  content: \"\\F0AAE\";\n}\n\n.mdi-dots-horizontal::before {\n  content: \"\\F01D8\";\n}\n\n.mdi-dots-horizontal-circle::before {\n  content: \"\\F07C3\";\n}\n\n.mdi-dots-horizontal-circle-outline::before {\n  content: \"\\F0B8D\";\n}\n\n.mdi-dots-vertical::before {\n  content: \"\\F01D9\";\n}\n\n.mdi-dots-vertical-circle::before {\n  content: \"\\F07C4\";\n}\n\n.mdi-dots-vertical-circle-outline::before {\n  content: \"\\F0B8E\";\n}\n\n.mdi-douban::before {\n  content: \"\\F069A\";\n}\n\n.mdi-download::before {\n  content: \"\\F01DA\";\n}\n\n.mdi-download-lock::before {\n  content: \"\\F1320\";\n}\n\n.mdi-download-lock-outline::before {\n  content: \"\\F1321\";\n}\n\n.mdi-download-multiple::before {\n  content: \"\\F09E9\";\n}\n\n.mdi-download-network::before {\n  content: \"\\F06F4\";\n}\n\n.mdi-download-network-outline::before {\n  content: \"\\F0C66\";\n}\n\n.mdi-download-off::before {\n  content: \"\\F10B0\";\n}\n\n.mdi-download-off-outline::before {\n  content: \"\\F10B1\";\n}\n\n.mdi-download-outline::before {\n  content: \"\\F0B8F\";\n}\n\n.mdi-drag::before {\n  content: \"\\F01DB\";\n}\n\n.mdi-drag-horizontal::before {\n  content: \"\\F01DC\";\n}\n\n.mdi-drag-horizontal-variant::before {\n  content: \"\\F12F0\";\n}\n\n.mdi-drag-variant::before {\n  content: \"\\F0B90\";\n}\n\n.mdi-drag-vertical::before {\n  content: \"\\F01DD\";\n}\n\n.mdi-drag-vertical-variant::before {\n  content: \"\\F12F1\";\n}\n\n.mdi-drama-masks::before {\n  content: \"\\F0D02\";\n}\n\n.mdi-draw::before {\n  content: \"\\F0F49\";\n}\n\n.mdi-drawing::before {\n  content: \"\\F01DE\";\n}\n\n.mdi-drawing-box::before {\n  content: \"\\F01DF\";\n}\n\n.mdi-dresser::before {\n  content: \"\\F0F4A\";\n}\n\n.mdi-dresser-outline::before {\n  content: \"\\F0F4B\";\n}\n\n.mdi-drone::before {\n  content: \"\\F01E2\";\n}\n\n.mdi-dropbox::before {\n  content: \"\\F01E3\";\n}\n\n.mdi-drupal::before {\n  content: \"\\F01E4\";\n}\n\n.mdi-duck::before {\n  content: \"\\F01E5\";\n}\n\n.mdi-dumbbell::before {\n  content: \"\\F01E6\";\n}\n\n.mdi-dump-truck::before {\n  content: \"\\F0C67\";\n}\n\n.mdi-ear-hearing::before {\n  content: \"\\F07C5\";\n}\n\n.mdi-ear-hearing-off::before {\n  content: \"\\F0A45\";\n}\n\n.mdi-earth::before {\n  content: \"\\F01E7\";\n}\n\n.mdi-earth-arrow-right::before {\n  content: \"\\F1311\";\n}\n\n.mdi-earth-box::before {\n  content: \"\\F06CD\";\n}\n\n.mdi-earth-box-off::before {\n  content: \"\\F06CE\";\n}\n\n.mdi-earth-off::before {\n  content: \"\\F01E8\";\n}\n\n.mdi-egg::before {\n  content: \"\\F0AAF\";\n}\n\n.mdi-egg-easter::before {\n  content: \"\\F0AB0\";\n}\n\n.mdi-eight-track::before {\n  content: \"\\F09EA\";\n}\n\n.mdi-eject::before {\n  content: \"\\F01EA\";\n}\n\n.mdi-eject-outline::before {\n  content: \"\\F0B91\";\n}\n\n.mdi-electric-switch::before {\n  content: \"\\F0E9F\";\n}\n\n.mdi-electric-switch-closed::before {\n  content: \"\\F10D9\";\n}\n\n.mdi-electron-framework::before {\n  content: \"\\F1024\";\n}\n\n.mdi-elephant::before {\n  content: \"\\F07C6\";\n}\n\n.mdi-elevation-decline::before {\n  content: \"\\F01EB\";\n}\n\n.mdi-elevation-rise::before {\n  content: \"\\F01EC\";\n}\n\n.mdi-elevator::before {\n  content: \"\\F01ED\";\n}\n\n.mdi-elevator-down::before {\n  content: \"\\F12C2\";\n}\n\n.mdi-elevator-passenger::before {\n  content: \"\\F1381\";\n}\n\n.mdi-elevator-up::before {\n  content: \"\\F12C1\";\n}\n\n.mdi-ellipse::before {\n  content: \"\\F0EA0\";\n}\n\n.mdi-ellipse-outline::before {\n  content: \"\\F0EA1\";\n}\n\n.mdi-email::before {\n  content: \"\\F01EE\";\n}\n\n.mdi-email-alert::before {\n  content: \"\\F06CF\";\n}\n\n.mdi-email-alert-outline::before {\n  content: \"\\F0D42\";\n}\n\n.mdi-email-box::before {\n  content: \"\\F0D03\";\n}\n\n.mdi-email-check::before {\n  content: \"\\F0AB1\";\n}\n\n.mdi-email-check-outline::before {\n  content: \"\\F0AB2\";\n}\n\n.mdi-email-edit::before {\n  content: \"\\F0EE3\";\n}\n\n.mdi-email-edit-outline::before {\n  content: \"\\F0EE4\";\n}\n\n.mdi-email-lock::before {\n  content: \"\\F01F1\";\n}\n\n.mdi-email-mark-as-unread::before {\n  content: \"\\F0B92\";\n}\n\n.mdi-email-minus::before {\n  content: \"\\F0EE5\";\n}\n\n.mdi-email-minus-outline::before {\n  content: \"\\F0EE6\";\n}\n\n.mdi-email-multiple::before {\n  content: \"\\F0EE7\";\n}\n\n.mdi-email-multiple-outline::before {\n  content: \"\\F0EE8\";\n}\n\n.mdi-email-newsletter::before {\n  content: \"\\F0FB1\";\n}\n\n.mdi-email-open::before {\n  content: \"\\F01EF\";\n}\n\n.mdi-email-open-multiple::before {\n  content: \"\\F0EE9\";\n}\n\n.mdi-email-open-multiple-outline::before {\n  content: \"\\F0EEA\";\n}\n\n.mdi-email-open-outline::before {\n  content: \"\\F05EF\";\n}\n\n.mdi-email-outline::before {\n  content: \"\\F01F0\";\n}\n\n.mdi-email-plus::before {\n  content: \"\\F09EB\";\n}\n\n.mdi-email-plus-outline::before {\n  content: \"\\F09EC\";\n}\n\n.mdi-email-receive::before {\n  content: \"\\F10DA\";\n}\n\n.mdi-email-receive-outline::before {\n  content: \"\\F10DB\";\n}\n\n.mdi-email-search::before {\n  content: \"\\F0961\";\n}\n\n.mdi-email-search-outline::before {\n  content: \"\\F0962\";\n}\n\n.mdi-email-send::before {\n  content: \"\\F10DC\";\n}\n\n.mdi-email-send-outline::before {\n  content: \"\\F10DD\";\n}\n\n.mdi-email-sync::before {\n  content: \"\\F12C7\";\n}\n\n.mdi-email-sync-outline::before {\n  content: \"\\F12C8\";\n}\n\n.mdi-email-variant::before {\n  content: \"\\F05F0\";\n}\n\n.mdi-ember::before {\n  content: \"\\F0B30\";\n}\n\n.mdi-emby::before {\n  content: \"\\F06B4\";\n}\n\n.mdi-emoticon::before {\n  content: \"\\F0C68\";\n}\n\n.mdi-emoticon-angry::before {\n  content: \"\\F0C69\";\n}\n\n.mdi-emoticon-angry-outline::before {\n  content: \"\\F0C6A\";\n}\n\n.mdi-emoticon-confused::before {\n  content: \"\\F10DE\";\n}\n\n.mdi-emoticon-confused-outline::before {\n  content: \"\\F10DF\";\n}\n\n.mdi-emoticon-cool::before {\n  content: \"\\F0C6B\";\n}\n\n.mdi-emoticon-cool-outline::before {\n  content: \"\\F01F3\";\n}\n\n.mdi-emoticon-cry::before {\n  content: \"\\F0C6C\";\n}\n\n.mdi-emoticon-cry-outline::before {\n  content: \"\\F0C6D\";\n}\n\n.mdi-emoticon-dead::before {\n  content: \"\\F0C6E\";\n}\n\n.mdi-emoticon-dead-outline::before {\n  content: \"\\F069B\";\n}\n\n.mdi-emoticon-devil::before {\n  content: \"\\F0C6F\";\n}\n\n.mdi-emoticon-devil-outline::before {\n  content: \"\\F01F4\";\n}\n\n.mdi-emoticon-excited::before {\n  content: \"\\F0C70\";\n}\n\n.mdi-emoticon-excited-outline::before {\n  content: \"\\F069C\";\n}\n\n.mdi-emoticon-frown::before {\n  content: \"\\F0F4C\";\n}\n\n.mdi-emoticon-frown-outline::before {\n  content: \"\\F0F4D\";\n}\n\n.mdi-emoticon-happy::before {\n  content: \"\\F0C71\";\n}\n\n.mdi-emoticon-happy-outline::before {\n  content: \"\\F01F5\";\n}\n\n.mdi-emoticon-kiss::before {\n  content: \"\\F0C72\";\n}\n\n.mdi-emoticon-kiss-outline::before {\n  content: \"\\F0C73\";\n}\n\n.mdi-emoticon-lol::before {\n  content: \"\\F1214\";\n}\n\n.mdi-emoticon-lol-outline::before {\n  content: \"\\F1215\";\n}\n\n.mdi-emoticon-neutral::before {\n  content: \"\\F0C74\";\n}\n\n.mdi-emoticon-neutral-outline::before {\n  content: \"\\F01F6\";\n}\n\n.mdi-emoticon-outline::before {\n  content: \"\\F01F2\";\n}\n\n.mdi-emoticon-poop::before {\n  content: \"\\F01F7\";\n}\n\n.mdi-emoticon-poop-outline::before {\n  content: \"\\F0C75\";\n}\n\n.mdi-emoticon-sad::before {\n  content: \"\\F0C76\";\n}\n\n.mdi-emoticon-sad-outline::before {\n  content: \"\\F01F8\";\n}\n\n.mdi-emoticon-tongue::before {\n  content: \"\\F01F9\";\n}\n\n.mdi-emoticon-tongue-outline::before {\n  content: \"\\F0C77\";\n}\n\n.mdi-emoticon-wink::before {\n  content: \"\\F0C78\";\n}\n\n.mdi-emoticon-wink-outline::before {\n  content: \"\\F0C79\";\n}\n\n.mdi-engine::before {\n  content: \"\\F01FA\";\n}\n\n.mdi-engine-off::before {\n  content: \"\\F0A46\";\n}\n\n.mdi-engine-off-outline::before {\n  content: \"\\F0A47\";\n}\n\n.mdi-engine-outline::before {\n  content: \"\\F01FB\";\n}\n\n.mdi-epsilon::before {\n  content: \"\\F10E0\";\n}\n\n.mdi-equal::before {\n  content: \"\\F01FC\";\n}\n\n.mdi-equal-box::before {\n  content: \"\\F01FD\";\n}\n\n.mdi-equalizer::before {\n  content: \"\\F0EA2\";\n}\n\n.mdi-equalizer-outline::before {\n  content: \"\\F0EA3\";\n}\n\n.mdi-eraser::before {\n  content: \"\\F01FE\";\n}\n\n.mdi-eraser-variant::before {\n  content: \"\\F0642\";\n}\n\n.mdi-escalator::before {\n  content: \"\\F01FF\";\n}\n\n.mdi-escalator-box::before {\n  content: \"\\F1399\";\n}\n\n.mdi-escalator-down::before {\n  content: \"\\F12C0\";\n}\n\n.mdi-escalator-up::before {\n  content: \"\\F12BF\";\n}\n\n.mdi-eslint::before {\n  content: \"\\F0C7A\";\n}\n\n.mdi-et::before {\n  content: \"\\F0AB3\";\n}\n\n.mdi-ethereum::before {\n  content: \"\\F086A\";\n}\n\n.mdi-ethernet::before {\n  content: \"\\F0200\";\n}\n\n.mdi-ethernet-cable::before {\n  content: \"\\F0201\";\n}\n\n.mdi-ethernet-cable-off::before {\n  content: \"\\F0202\";\n}\n\n.mdi-ev-station::before {\n  content: \"\\F05F1\";\n}\n\n.mdi-evernote::before {\n  content: \"\\F0204\";\n}\n\n.mdi-excavator::before {\n  content: \"\\F1025\";\n}\n\n.mdi-exclamation::before {\n  content: \"\\F0205\";\n}\n\n.mdi-exclamation-thick::before {\n  content: \"\\F1238\";\n}\n\n.mdi-exit-run::before {\n  content: \"\\F0A48\";\n}\n\n.mdi-exit-to-app::before {\n  content: \"\\F0206\";\n}\n\n.mdi-expand-all::before {\n  content: \"\\F0AB4\";\n}\n\n.mdi-expand-all-outline::before {\n  content: \"\\F0AB5\";\n}\n\n.mdi-expansion-card::before {\n  content: \"\\F08AE\";\n}\n\n.mdi-expansion-card-variant::before {\n  content: \"\\F0FB2\";\n}\n\n.mdi-exponent::before {\n  content: \"\\F0963\";\n}\n\n.mdi-exponent-box::before {\n  content: \"\\F0964\";\n}\n\n.mdi-export::before {\n  content: \"\\F0207\";\n}\n\n.mdi-export-variant::before {\n  content: \"\\F0B93\";\n}\n\n.mdi-eye::before {\n  content: \"\\F0208\";\n}\n\n.mdi-eye-check::before {\n  content: \"\\F0D04\";\n}\n\n.mdi-eye-check-outline::before {\n  content: \"\\F0D05\";\n}\n\n.mdi-eye-circle::before {\n  content: \"\\F0B94\";\n}\n\n.mdi-eye-circle-outline::before {\n  content: \"\\F0B95\";\n}\n\n.mdi-eye-minus::before {\n  content: \"\\F1026\";\n}\n\n.mdi-eye-minus-outline::before {\n  content: \"\\F1027\";\n}\n\n.mdi-eye-off::before {\n  content: \"\\F0209\";\n}\n\n.mdi-eye-off-outline::before {\n  content: \"\\F06D1\";\n}\n\n.mdi-eye-outline::before {\n  content: \"\\F06D0\";\n}\n\n.mdi-eye-plus::before {\n  content: \"\\F086B\";\n}\n\n.mdi-eye-plus-outline::before {\n  content: \"\\F086C\";\n}\n\n.mdi-eye-settings::before {\n  content: \"\\F086D\";\n}\n\n.mdi-eye-settings-outline::before {\n  content: \"\\F086E\";\n}\n\n.mdi-eyedropper::before {\n  content: \"\\F020A\";\n}\n\n.mdi-eyedropper-variant::before {\n  content: \"\\F020B\";\n}\n\n.mdi-face::before {\n  content: \"\\F0643\";\n}\n\n.mdi-face-agent::before {\n  content: \"\\F0D70\";\n}\n\n.mdi-face-outline::before {\n  content: \"\\F0B96\";\n}\n\n.mdi-face-profile::before {\n  content: \"\\F0644\";\n}\n\n.mdi-face-profile-woman::before {\n  content: \"\\F1076\";\n}\n\n.mdi-face-recognition::before {\n  content: \"\\F0C7B\";\n}\n\n.mdi-face-woman::before {\n  content: \"\\F1077\";\n}\n\n.mdi-face-woman-outline::before {\n  content: \"\\F1078\";\n}\n\n.mdi-facebook::before {\n  content: \"\\F020C\";\n}\n\n.mdi-facebook-messenger::before {\n  content: \"\\F020E\";\n}\n\n.mdi-facebook-workplace::before {\n  content: \"\\F0B31\";\n}\n\n.mdi-factory::before {\n  content: \"\\F020F\";\n}\n\n.mdi-fan::before {\n  content: \"\\F0210\";\n}\n\n.mdi-fan-off::before {\n  content: \"\\F081D\";\n}\n\n.mdi-fast-forward::before {\n  content: \"\\F0211\";\n}\n\n.mdi-fast-forward-10::before {\n  content: \"\\F0D71\";\n}\n\n.mdi-fast-forward-30::before {\n  content: \"\\F0D06\";\n}\n\n.mdi-fast-forward-5::before {\n  content: \"\\F11F8\";\n}\n\n.mdi-fast-forward-outline::before {\n  content: \"\\F06D2\";\n}\n\n.mdi-fax::before {\n  content: \"\\F0212\";\n}\n\n.mdi-feather::before {\n  content: \"\\F06D3\";\n}\n\n.mdi-feature-search::before {\n  content: \"\\F0A49\";\n}\n\n.mdi-feature-search-outline::before {\n  content: \"\\F0A4A\";\n}\n\n.mdi-fedora::before {\n  content: \"\\F08DB\";\n}\n\n.mdi-ferris-wheel::before {\n  content: \"\\F0EA4\";\n}\n\n.mdi-ferry::before {\n  content: \"\\F0213\";\n}\n\n.mdi-file::before {\n  content: \"\\F0214\";\n}\n\n.mdi-file-account::before {\n  content: \"\\F073B\";\n}\n\n.mdi-file-account-outline::before {\n  content: \"\\F1028\";\n}\n\n.mdi-file-alert::before {\n  content: \"\\F0A4B\";\n}\n\n.mdi-file-alert-outline::before {\n  content: \"\\F0A4C\";\n}\n\n.mdi-file-cabinet::before {\n  content: \"\\F0AB6\";\n}\n\n.mdi-file-cad::before {\n  content: \"\\F0EEB\";\n}\n\n.mdi-file-cad-box::before {\n  content: \"\\F0EEC\";\n}\n\n.mdi-file-cancel::before {\n  content: \"\\F0DC6\";\n}\n\n.mdi-file-cancel-outline::before {\n  content: \"\\F0DC7\";\n}\n\n.mdi-file-certificate::before {\n  content: \"\\F1186\";\n}\n\n.mdi-file-certificate-outline::before {\n  content: \"\\F1187\";\n}\n\n.mdi-file-chart::before {\n  content: \"\\F0215\";\n}\n\n.mdi-file-chart-outline::before {\n  content: \"\\F1029\";\n}\n\n.mdi-file-check::before {\n  content: \"\\F0216\";\n}\n\n.mdi-file-check-outline::before {\n  content: \"\\F0E29\";\n}\n\n.mdi-file-clock::before {\n  content: \"\\F12E1\";\n}\n\n.mdi-file-clock-outline::before {\n  content: \"\\F12E2\";\n}\n\n.mdi-file-cloud::before {\n  content: \"\\F0217\";\n}\n\n.mdi-file-cloud-outline::before {\n  content: \"\\F102A\";\n}\n\n.mdi-file-code::before {\n  content: \"\\F022E\";\n}\n\n.mdi-file-code-outline::before {\n  content: \"\\F102B\";\n}\n\n.mdi-file-cog::before {\n  content: \"\\F107B\";\n}\n\n.mdi-file-cog-outline::before {\n  content: \"\\F107C\";\n}\n\n.mdi-file-compare::before {\n  content: \"\\F08AA\";\n}\n\n.mdi-file-delimited::before {\n  content: \"\\F0218\";\n}\n\n.mdi-file-delimited-outline::before {\n  content: \"\\F0EA5\";\n}\n\n.mdi-file-document::before {\n  content: \"\\F0219\";\n}\n\n.mdi-file-document-edit::before {\n  content: \"\\F0DC8\";\n}\n\n.mdi-file-document-edit-outline::before {\n  content: \"\\F0DC9\";\n}\n\n.mdi-file-document-outline::before {\n  content: \"\\F09EE\";\n}\n\n.mdi-file-download::before {\n  content: \"\\F0965\";\n}\n\n.mdi-file-download-outline::before {\n  content: \"\\F0966\";\n}\n\n.mdi-file-edit::before {\n  content: \"\\F11E7\";\n}\n\n.mdi-file-edit-outline::before {\n  content: \"\\F11E8\";\n}\n\n.mdi-file-excel::before {\n  content: \"\\F021B\";\n}\n\n.mdi-file-excel-box::before {\n  content: \"\\F021C\";\n}\n\n.mdi-file-excel-box-outline::before {\n  content: \"\\F102C\";\n}\n\n.mdi-file-excel-outline::before {\n  content: \"\\F102D\";\n}\n\n.mdi-file-export::before {\n  content: \"\\F021D\";\n}\n\n.mdi-file-export-outline::before {\n  content: \"\\F102E\";\n}\n\n.mdi-file-eye::before {\n  content: \"\\F0DCA\";\n}\n\n.mdi-file-eye-outline::before {\n  content: \"\\F0DCB\";\n}\n\n.mdi-file-find::before {\n  content: \"\\F021E\";\n}\n\n.mdi-file-find-outline::before {\n  content: \"\\F0B97\";\n}\n\n.mdi-file-hidden::before {\n  content: \"\\F0613\";\n}\n\n.mdi-file-image::before {\n  content: \"\\F021F\";\n}\n\n.mdi-file-image-outline::before {\n  content: \"\\F0EB0\";\n}\n\n.mdi-file-import::before {\n  content: \"\\F0220\";\n}\n\n.mdi-file-import-outline::before {\n  content: \"\\F102F\";\n}\n\n.mdi-file-key::before {\n  content: \"\\F1184\";\n}\n\n.mdi-file-key-outline::before {\n  content: \"\\F1185\";\n}\n\n.mdi-file-link::before {\n  content: \"\\F1177\";\n}\n\n.mdi-file-link-outline::before {\n  content: \"\\F1178\";\n}\n\n.mdi-file-lock::before {\n  content: \"\\F0221\";\n}\n\n.mdi-file-lock-outline::before {\n  content: \"\\F1030\";\n}\n\n.mdi-file-move::before {\n  content: \"\\F0AB9\";\n}\n\n.mdi-file-move-outline::before {\n  content: \"\\F1031\";\n}\n\n.mdi-file-multiple::before {\n  content: \"\\F0222\";\n}\n\n.mdi-file-multiple-outline::before {\n  content: \"\\F1032\";\n}\n\n.mdi-file-music::before {\n  content: \"\\F0223\";\n}\n\n.mdi-file-music-outline::before {\n  content: \"\\F0E2A\";\n}\n\n.mdi-file-outline::before {\n  content: \"\\F0224\";\n}\n\n.mdi-file-pdf::before {\n  content: \"\\F0225\";\n}\n\n.mdi-file-pdf-box::before {\n  content: \"\\F0226\";\n}\n\n.mdi-file-pdf-box-outline::before {\n  content: \"\\F0FB3\";\n}\n\n.mdi-file-pdf-outline::before {\n  content: \"\\F0E2D\";\n}\n\n.mdi-file-percent::before {\n  content: \"\\F081E\";\n}\n\n.mdi-file-percent-outline::before {\n  content: \"\\F1033\";\n}\n\n.mdi-file-phone::before {\n  content: \"\\F1179\";\n}\n\n.mdi-file-phone-outline::before {\n  content: \"\\F117A\";\n}\n\n.mdi-file-plus::before {\n  content: \"\\F0752\";\n}\n\n.mdi-file-plus-outline::before {\n  content: \"\\F0EED\";\n}\n\n.mdi-file-powerpoint::before {\n  content: \"\\F0227\";\n}\n\n.mdi-file-powerpoint-box::before {\n  content: \"\\F0228\";\n}\n\n.mdi-file-powerpoint-box-outline::before {\n  content: \"\\F1034\";\n}\n\n.mdi-file-powerpoint-outline::before {\n  content: \"\\F1035\";\n}\n\n.mdi-file-presentation-box::before {\n  content: \"\\F0229\";\n}\n\n.mdi-file-question::before {\n  content: \"\\F086F\";\n}\n\n.mdi-file-question-outline::before {\n  content: \"\\F1036\";\n}\n\n.mdi-file-refresh::before {\n  content: \"\\F0918\";\n}\n\n.mdi-file-refresh-outline::before {\n  content: \"\\F0541\";\n}\n\n.mdi-file-remove::before {\n  content: \"\\F0B98\";\n}\n\n.mdi-file-remove-outline::before {\n  content: \"\\F1037\";\n}\n\n.mdi-file-replace::before {\n  content: \"\\F0B32\";\n}\n\n.mdi-file-replace-outline::before {\n  content: \"\\F0B33\";\n}\n\n.mdi-file-restore::before {\n  content: \"\\F0670\";\n}\n\n.mdi-file-restore-outline::before {\n  content: \"\\F1038\";\n}\n\n.mdi-file-search::before {\n  content: \"\\F0C7C\";\n}\n\n.mdi-file-search-outline::before {\n  content: \"\\F0C7D\";\n}\n\n.mdi-file-send::before {\n  content: \"\\F022A\";\n}\n\n.mdi-file-send-outline::before {\n  content: \"\\F1039\";\n}\n\n.mdi-file-settings::before {\n  content: \"\\F1079\";\n}\n\n.mdi-file-settings-outline::before {\n  content: \"\\F107A\";\n}\n\n.mdi-file-star::before {\n  content: \"\\F103A\";\n}\n\n.mdi-file-star-outline::before {\n  content: \"\\F103B\";\n}\n\n.mdi-file-swap::before {\n  content: \"\\F0FB4\";\n}\n\n.mdi-file-swap-outline::before {\n  content: \"\\F0FB5\";\n}\n\n.mdi-file-sync::before {\n  content: \"\\F1216\";\n}\n\n.mdi-file-sync-outline::before {\n  content: \"\\F1217\";\n}\n\n.mdi-file-table::before {\n  content: \"\\F0C7E\";\n}\n\n.mdi-file-table-box::before {\n  content: \"\\F10E1\";\n}\n\n.mdi-file-table-box-multiple::before {\n  content: \"\\F10E2\";\n}\n\n.mdi-file-table-box-multiple-outline::before {\n  content: \"\\F10E3\";\n}\n\n.mdi-file-table-box-outline::before {\n  content: \"\\F10E4\";\n}\n\n.mdi-file-table-outline::before {\n  content: \"\\F0C7F\";\n}\n\n.mdi-file-tree::before {\n  content: \"\\F0645\";\n}\n\n.mdi-file-undo::before {\n  content: \"\\F08DC\";\n}\n\n.mdi-file-undo-outline::before {\n  content: \"\\F103C\";\n}\n\n.mdi-file-upload::before {\n  content: \"\\F0A4D\";\n}\n\n.mdi-file-upload-outline::before {\n  content: \"\\F0A4E\";\n}\n\n.mdi-file-video::before {\n  content: \"\\F022B\";\n}\n\n.mdi-file-video-outline::before {\n  content: \"\\F0E2C\";\n}\n\n.mdi-file-word::before {\n  content: \"\\F022C\";\n}\n\n.mdi-file-word-box::before {\n  content: \"\\F022D\";\n}\n\n.mdi-file-word-box-outline::before {\n  content: \"\\F103D\";\n}\n\n.mdi-file-word-outline::before {\n  content: \"\\F103E\";\n}\n\n.mdi-film::before {\n  content: \"\\F022F\";\n}\n\n.mdi-filmstrip::before {\n  content: \"\\F0230\";\n}\n\n.mdi-filmstrip-box::before {\n  content: \"\\F0332\";\n}\n\n.mdi-filmstrip-box-multiple::before {\n  content: \"\\F0D18\";\n}\n\n.mdi-filmstrip-off::before {\n  content: \"\\F0231\";\n}\n\n.mdi-filter::before {\n  content: \"\\F0232\";\n}\n\n.mdi-filter-menu::before {\n  content: \"\\F10E5\";\n}\n\n.mdi-filter-menu-outline::before {\n  content: \"\\F10E6\";\n}\n\n.mdi-filter-minus::before {\n  content: \"\\F0EEE\";\n}\n\n.mdi-filter-minus-outline::before {\n  content: \"\\F0EEF\";\n}\n\n.mdi-filter-outline::before {\n  content: \"\\F0233\";\n}\n\n.mdi-filter-plus::before {\n  content: \"\\F0EF0\";\n}\n\n.mdi-filter-plus-outline::before {\n  content: \"\\F0EF1\";\n}\n\n.mdi-filter-remove::before {\n  content: \"\\F0234\";\n}\n\n.mdi-filter-remove-outline::before {\n  content: \"\\F0235\";\n}\n\n.mdi-filter-variant::before {\n  content: \"\\F0236\";\n}\n\n.mdi-filter-variant-minus::before {\n  content: \"\\F1112\";\n}\n\n.mdi-filter-variant-plus::before {\n  content: \"\\F1113\";\n}\n\n.mdi-filter-variant-remove::before {\n  content: \"\\F103F\";\n}\n\n.mdi-finance::before {\n  content: \"\\F081F\";\n}\n\n.mdi-find-replace::before {\n  content: \"\\F06D4\";\n}\n\n.mdi-fingerprint::before {\n  content: \"\\F0237\";\n}\n\n.mdi-fingerprint-off::before {\n  content: \"\\F0EB1\";\n}\n\n.mdi-fire::before {\n  content: \"\\F0238\";\n}\n\n.mdi-fire-extinguisher::before {\n  content: \"\\F0EF2\";\n}\n\n.mdi-fire-hydrant::before {\n  content: \"\\F1137\";\n}\n\n.mdi-fire-hydrant-alert::before {\n  content: \"\\F1138\";\n}\n\n.mdi-fire-hydrant-off::before {\n  content: \"\\F1139\";\n}\n\n.mdi-fire-truck::before {\n  content: \"\\F08AB\";\n}\n\n.mdi-firebase::before {\n  content: \"\\F0967\";\n}\n\n.mdi-firefox::before {\n  content: \"\\F0239\";\n}\n\n.mdi-fireplace::before {\n  content: \"\\F0E2E\";\n}\n\n.mdi-fireplace-off::before {\n  content: \"\\F0E2F\";\n}\n\n.mdi-firework::before {\n  content: \"\\F0E30\";\n}\n\n.mdi-fish::before {\n  content: \"\\F023A\";\n}\n\n.mdi-fishbowl::before {\n  content: \"\\F0EF3\";\n}\n\n.mdi-fishbowl-outline::before {\n  content: \"\\F0EF4\";\n}\n\n.mdi-fit-to-page::before {\n  content: \"\\F0EF5\";\n}\n\n.mdi-fit-to-page-outline::before {\n  content: \"\\F0EF6\";\n}\n\n.mdi-flag::before {\n  content: \"\\F023B\";\n}\n\n.mdi-flag-checkered::before {\n  content: \"\\F023C\";\n}\n\n.mdi-flag-minus::before {\n  content: \"\\F0B99\";\n}\n\n.mdi-flag-minus-outline::before {\n  content: \"\\F10B2\";\n}\n\n.mdi-flag-outline::before {\n  content: \"\\F023D\";\n}\n\n.mdi-flag-plus::before {\n  content: \"\\F0B9A\";\n}\n\n.mdi-flag-plus-outline::before {\n  content: \"\\F10B3\";\n}\n\n.mdi-flag-remove::before {\n  content: \"\\F0B9B\";\n}\n\n.mdi-flag-remove-outline::before {\n  content: \"\\F10B4\";\n}\n\n.mdi-flag-triangle::before {\n  content: \"\\F023F\";\n}\n\n.mdi-flag-variant::before {\n  content: \"\\F0240\";\n}\n\n.mdi-flag-variant-outline::before {\n  content: \"\\F023E\";\n}\n\n.mdi-flare::before {\n  content: \"\\F0D72\";\n}\n\n.mdi-flash::before {\n  content: \"\\F0241\";\n}\n\n.mdi-flash-alert::before {\n  content: \"\\F0EF7\";\n}\n\n.mdi-flash-alert-outline::before {\n  content: \"\\F0EF8\";\n}\n\n.mdi-flash-auto::before {\n  content: \"\\F0242\";\n}\n\n.mdi-flash-circle::before {\n  content: \"\\F0820\";\n}\n\n.mdi-flash-off::before {\n  content: \"\\F0243\";\n}\n\n.mdi-flash-outline::before {\n  content: \"\\F06D5\";\n}\n\n.mdi-flash-red-eye::before {\n  content: \"\\F067B\";\n}\n\n.mdi-flashlight::before {\n  content: \"\\F0244\";\n}\n\n.mdi-flashlight-off::before {\n  content: \"\\F0245\";\n}\n\n.mdi-flask::before {\n  content: \"\\F0093\";\n}\n\n.mdi-flask-empty::before {\n  content: \"\\F0094\";\n}\n\n.mdi-flask-empty-minus::before {\n  content: \"\\F123A\";\n}\n\n.mdi-flask-empty-minus-outline::before {\n  content: \"\\F123B\";\n}\n\n.mdi-flask-empty-outline::before {\n  content: \"\\F0095\";\n}\n\n.mdi-flask-empty-plus::before {\n  content: \"\\F123C\";\n}\n\n.mdi-flask-empty-plus-outline::before {\n  content: \"\\F123D\";\n}\n\n.mdi-flask-empty-remove::before {\n  content: \"\\F123E\";\n}\n\n.mdi-flask-empty-remove-outline::before {\n  content: \"\\F123F\";\n}\n\n.mdi-flask-minus::before {\n  content: \"\\F1240\";\n}\n\n.mdi-flask-minus-outline::before {\n  content: \"\\F1241\";\n}\n\n.mdi-flask-outline::before {\n  content: \"\\F0096\";\n}\n\n.mdi-flask-plus::before {\n  content: \"\\F1242\";\n}\n\n.mdi-flask-plus-outline::before {\n  content: \"\\F1243\";\n}\n\n.mdi-flask-remove::before {\n  content: \"\\F1244\";\n}\n\n.mdi-flask-remove-outline::before {\n  content: \"\\F1245\";\n}\n\n.mdi-flask-round-bottom::before {\n  content: \"\\F124B\";\n}\n\n.mdi-flask-round-bottom-empty::before {\n  content: \"\\F124C\";\n}\n\n.mdi-flask-round-bottom-empty-outline::before {\n  content: \"\\F124D\";\n}\n\n.mdi-flask-round-bottom-outline::before {\n  content: \"\\F124E\";\n}\n\n.mdi-fleur-de-lis::before {\n  content: \"\\F1303\";\n}\n\n.mdi-flip-horizontal::before {\n  content: \"\\F10E7\";\n}\n\n.mdi-flip-to-back::before {\n  content: \"\\F0247\";\n}\n\n.mdi-flip-to-front::before {\n  content: \"\\F0248\";\n}\n\n.mdi-flip-vertical::before {\n  content: \"\\F10E8\";\n}\n\n.mdi-floor-lamp::before {\n  content: \"\\F08DD\";\n}\n\n.mdi-floor-lamp-dual::before {\n  content: \"\\F1040\";\n}\n\n.mdi-floor-lamp-variant::before {\n  content: \"\\F1041\";\n}\n\n.mdi-floor-plan::before {\n  content: \"\\F0821\";\n}\n\n.mdi-floppy::before {\n  content: \"\\F0249\";\n}\n\n.mdi-floppy-variant::before {\n  content: \"\\F09EF\";\n}\n\n.mdi-flower::before {\n  content: \"\\F024A\";\n}\n\n.mdi-flower-outline::before {\n  content: \"\\F09F0\";\n}\n\n.mdi-flower-poppy::before {\n  content: \"\\F0D08\";\n}\n\n.mdi-flower-tulip::before {\n  content: \"\\F09F1\";\n}\n\n.mdi-flower-tulip-outline::before {\n  content: \"\\F09F2\";\n}\n\n.mdi-focus-auto::before {\n  content: \"\\F0F4E\";\n}\n\n.mdi-focus-field::before {\n  content: \"\\F0F4F\";\n}\n\n.mdi-focus-field-horizontal::before {\n  content: \"\\F0F50\";\n}\n\n.mdi-focus-field-vertical::before {\n  content: \"\\F0F51\";\n}\n\n.mdi-folder::before {\n  content: \"\\F024B\";\n}\n\n.mdi-folder-account::before {\n  content: \"\\F024C\";\n}\n\n.mdi-folder-account-outline::before {\n  content: \"\\F0B9C\";\n}\n\n.mdi-folder-alert::before {\n  content: \"\\F0DCC\";\n}\n\n.mdi-folder-alert-outline::before {\n  content: \"\\F0DCD\";\n}\n\n.mdi-folder-clock::before {\n  content: \"\\F0ABA\";\n}\n\n.mdi-folder-clock-outline::before {\n  content: \"\\F0ABB\";\n}\n\n.mdi-folder-cog::before {\n  content: \"\\F107F\";\n}\n\n.mdi-folder-cog-outline::before {\n  content: \"\\F1080\";\n}\n\n.mdi-folder-download::before {\n  content: \"\\F024D\";\n}\n\n.mdi-folder-download-outline::before {\n  content: \"\\F10E9\";\n}\n\n.mdi-folder-edit::before {\n  content: \"\\F08DE\";\n}\n\n.mdi-folder-edit-outline::before {\n  content: \"\\F0DCE\";\n}\n\n.mdi-folder-google-drive::before {\n  content: \"\\F024E\";\n}\n\n.mdi-folder-heart::before {\n  content: \"\\F10EA\";\n}\n\n.mdi-folder-heart-outline::before {\n  content: \"\\F10EB\";\n}\n\n.mdi-folder-home::before {\n  content: \"\\F10B5\";\n}\n\n.mdi-folder-home-outline::before {\n  content: \"\\F10B6\";\n}\n\n.mdi-folder-image::before {\n  content: \"\\F024F\";\n}\n\n.mdi-folder-information::before {\n  content: \"\\F10B7\";\n}\n\n.mdi-folder-information-outline::before {\n  content: \"\\F10B8\";\n}\n\n.mdi-folder-key::before {\n  content: \"\\F08AC\";\n}\n\n.mdi-folder-key-network::before {\n  content: \"\\F08AD\";\n}\n\n.mdi-folder-key-network-outline::before {\n  content: \"\\F0C80\";\n}\n\n.mdi-folder-key-outline::before {\n  content: \"\\F10EC\";\n}\n\n.mdi-folder-lock::before {\n  content: \"\\F0250\";\n}\n\n.mdi-folder-lock-open::before {\n  content: \"\\F0251\";\n}\n\n.mdi-folder-marker::before {\n  content: \"\\F126D\";\n}\n\n.mdi-folder-marker-outline::before {\n  content: \"\\F126E\";\n}\n\n.mdi-folder-move::before {\n  content: \"\\F0252\";\n}\n\n.mdi-folder-move-outline::before {\n  content: \"\\F1246\";\n}\n\n.mdi-folder-multiple::before {\n  content: \"\\F0253\";\n}\n\n.mdi-folder-multiple-image::before {\n  content: \"\\F0254\";\n}\n\n.mdi-folder-multiple-outline::before {\n  content: \"\\F0255\";\n}\n\n.mdi-folder-music::before {\n  content: \"\\F1359\";\n}\n\n.mdi-folder-music-outline::before {\n  content: \"\\F135A\";\n}\n\n.mdi-folder-network::before {\n  content: \"\\F0870\";\n}\n\n.mdi-folder-network-outline::before {\n  content: \"\\F0C81\";\n}\n\n.mdi-folder-open::before {\n  content: \"\\F0770\";\n}\n\n.mdi-folder-open-outline::before {\n  content: \"\\F0DCF\";\n}\n\n.mdi-folder-outline::before {\n  content: \"\\F0256\";\n}\n\n.mdi-folder-plus::before {\n  content: \"\\F0257\";\n}\n\n.mdi-folder-plus-outline::before {\n  content: \"\\F0B9D\";\n}\n\n.mdi-folder-pound::before {\n  content: \"\\F0D09\";\n}\n\n.mdi-folder-pound-outline::before {\n  content: \"\\F0D0A\";\n}\n\n.mdi-folder-refresh::before {\n  content: \"\\F0749\";\n}\n\n.mdi-folder-refresh-outline::before {\n  content: \"\\F0542\";\n}\n\n.mdi-folder-remove::before {\n  content: \"\\F0258\";\n}\n\n.mdi-folder-remove-outline::before {\n  content: \"\\F0B9E\";\n}\n\n.mdi-folder-search::before {\n  content: \"\\F0968\";\n}\n\n.mdi-folder-search-outline::before {\n  content: \"\\F0969\";\n}\n\n.mdi-folder-settings::before {\n  content: \"\\F107D\";\n}\n\n.mdi-folder-settings-outline::before {\n  content: \"\\F107E\";\n}\n\n.mdi-folder-star::before {\n  content: \"\\F069D\";\n}\n\n.mdi-folder-star-outline::before {\n  content: \"\\F0B9F\";\n}\n\n.mdi-folder-swap::before {\n  content: \"\\F0FB6\";\n}\n\n.mdi-folder-swap-outline::before {\n  content: \"\\F0FB7\";\n}\n\n.mdi-folder-sync::before {\n  content: \"\\F0D0B\";\n}\n\n.mdi-folder-sync-outline::before {\n  content: \"\\F0D0C\";\n}\n\n.mdi-folder-table::before {\n  content: \"\\F12E3\";\n}\n\n.mdi-folder-table-outline::before {\n  content: \"\\F12E4\";\n}\n\n.mdi-folder-text::before {\n  content: \"\\F0C82\";\n}\n\n.mdi-folder-text-outline::before {\n  content: \"\\F0C83\";\n}\n\n.mdi-folder-upload::before {\n  content: \"\\F0259\";\n}\n\n.mdi-folder-upload-outline::before {\n  content: \"\\F10ED\";\n}\n\n.mdi-folder-zip::before {\n  content: \"\\F06EB\";\n}\n\n.mdi-folder-zip-outline::before {\n  content: \"\\F07B9\";\n}\n\n.mdi-font-awesome::before {\n  content: \"\\F003A\";\n}\n\n.mdi-food::before {\n  content: \"\\F025A\";\n}\n\n.mdi-food-apple::before {\n  content: \"\\F025B\";\n}\n\n.mdi-food-apple-outline::before {\n  content: \"\\F0C84\";\n}\n\n.mdi-food-croissant::before {\n  content: \"\\F07C8\";\n}\n\n.mdi-food-fork-drink::before {\n  content: \"\\F05F2\";\n}\n\n.mdi-food-off::before {\n  content: \"\\F05F3\";\n}\n\n.mdi-food-variant::before {\n  content: \"\\F025C\";\n}\n\n.mdi-foot-print::before {\n  content: \"\\F0F52\";\n}\n\n.mdi-football::before {\n  content: \"\\F025D\";\n}\n\n.mdi-football-australian::before {\n  content: \"\\F025E\";\n}\n\n.mdi-football-helmet::before {\n  content: \"\\F025F\";\n}\n\n.mdi-forklift::before {\n  content: \"\\F07C9\";\n}\n\n.mdi-format-align-bottom::before {\n  content: \"\\F0753\";\n}\n\n.mdi-format-align-center::before {\n  content: \"\\F0260\";\n}\n\n.mdi-format-align-justify::before {\n  content: \"\\F0261\";\n}\n\n.mdi-format-align-left::before {\n  content: \"\\F0262\";\n}\n\n.mdi-format-align-middle::before {\n  content: \"\\F0754\";\n}\n\n.mdi-format-align-right::before {\n  content: \"\\F0263\";\n}\n\n.mdi-format-align-top::before {\n  content: \"\\F0755\";\n}\n\n.mdi-format-annotation-minus::before {\n  content: \"\\F0ABC\";\n}\n\n.mdi-format-annotation-plus::before {\n  content: \"\\F0646\";\n}\n\n.mdi-format-bold::before {\n  content: \"\\F0264\";\n}\n\n.mdi-format-clear::before {\n  content: \"\\F0265\";\n}\n\n.mdi-format-color-fill::before {\n  content: \"\\F0266\";\n}\n\n.mdi-format-color-highlight::before {\n  content: \"\\F0E31\";\n}\n\n.mdi-format-color-marker-cancel::before {\n  content: \"\\F1313\";\n}\n\n.mdi-format-color-text::before {\n  content: \"\\F069E\";\n}\n\n.mdi-format-columns::before {\n  content: \"\\F08DF\";\n}\n\n.mdi-format-float-center::before {\n  content: \"\\F0267\";\n}\n\n.mdi-format-float-left::before {\n  content: \"\\F0268\";\n}\n\n.mdi-format-float-none::before {\n  content: \"\\F0269\";\n}\n\n.mdi-format-float-right::before {\n  content: \"\\F026A\";\n}\n\n.mdi-format-font::before {\n  content: \"\\F06D6\";\n}\n\n.mdi-format-font-size-decrease::before {\n  content: \"\\F09F3\";\n}\n\n.mdi-format-font-size-increase::before {\n  content: \"\\F09F4\";\n}\n\n.mdi-format-header-1::before {\n  content: \"\\F026B\";\n}\n\n.mdi-format-header-2::before {\n  content: \"\\F026C\";\n}\n\n.mdi-format-header-3::before {\n  content: \"\\F026D\";\n}\n\n.mdi-format-header-4::before {\n  content: \"\\F026E\";\n}\n\n.mdi-format-header-5::before {\n  content: \"\\F026F\";\n}\n\n.mdi-format-header-6::before {\n  content: \"\\F0270\";\n}\n\n.mdi-format-header-decrease::before {\n  content: \"\\F0271\";\n}\n\n.mdi-format-header-equal::before {\n  content: \"\\F0272\";\n}\n\n.mdi-format-header-increase::before {\n  content: \"\\F0273\";\n}\n\n.mdi-format-header-pound::before {\n  content: \"\\F0274\";\n}\n\n.mdi-format-horizontal-align-center::before {\n  content: \"\\F061E\";\n}\n\n.mdi-format-horizontal-align-left::before {\n  content: \"\\F061F\";\n}\n\n.mdi-format-horizontal-align-right::before {\n  content: \"\\F0620\";\n}\n\n.mdi-format-indent-decrease::before {\n  content: \"\\F0275\";\n}\n\n.mdi-format-indent-increase::before {\n  content: \"\\F0276\";\n}\n\n.mdi-format-italic::before {\n  content: \"\\F0277\";\n}\n\n.mdi-format-letter-case::before {\n  content: \"\\F0B34\";\n}\n\n.mdi-format-letter-case-lower::before {\n  content: \"\\F0B35\";\n}\n\n.mdi-format-letter-case-upper::before {\n  content: \"\\F0B36\";\n}\n\n.mdi-format-letter-ends-with::before {\n  content: \"\\F0FB8\";\n}\n\n.mdi-format-letter-matches::before {\n  content: \"\\F0FB9\";\n}\n\n.mdi-format-letter-starts-with::before {\n  content: \"\\F0FBA\";\n}\n\n.mdi-format-line-spacing::before {\n  content: \"\\F0278\";\n}\n\n.mdi-format-line-style::before {\n  content: \"\\F05C8\";\n}\n\n.mdi-format-line-weight::before {\n  content: \"\\F05C9\";\n}\n\n.mdi-format-list-bulleted::before {\n  content: \"\\F0279\";\n}\n\n.mdi-format-list-bulleted-square::before {\n  content: \"\\F0DD0\";\n}\n\n.mdi-format-list-bulleted-triangle::before {\n  content: \"\\F0EB2\";\n}\n\n.mdi-format-list-bulleted-type::before {\n  content: \"\\F027A\";\n}\n\n.mdi-format-list-checkbox::before {\n  content: \"\\F096A\";\n}\n\n.mdi-format-list-checks::before {\n  content: \"\\F0756\";\n}\n\n.mdi-format-list-numbered::before {\n  content: \"\\F027B\";\n}\n\n.mdi-format-list-numbered-rtl::before {\n  content: \"\\F0D0D\";\n}\n\n.mdi-format-list-text::before {\n  content: \"\\F126F\";\n}\n\n.mdi-format-overline::before {\n  content: \"\\F0EB3\";\n}\n\n.mdi-format-page-break::before {\n  content: \"\\F06D7\";\n}\n\n.mdi-format-paint::before {\n  content: \"\\F027C\";\n}\n\n.mdi-format-paragraph::before {\n  content: \"\\F027D\";\n}\n\n.mdi-format-pilcrow::before {\n  content: \"\\F06D8\";\n}\n\n.mdi-format-quote-close::before {\n  content: \"\\F027E\";\n}\n\n.mdi-format-quote-close-outline::before {\n  content: \"\\F11A8\";\n}\n\n.mdi-format-quote-open::before {\n  content: \"\\F0757\";\n}\n\n.mdi-format-quote-open-outline::before {\n  content: \"\\F11A7\";\n}\n\n.mdi-format-rotate-90::before {\n  content: \"\\F06AA\";\n}\n\n.mdi-format-section::before {\n  content: \"\\F069F\";\n}\n\n.mdi-format-size::before {\n  content: \"\\F027F\";\n}\n\n.mdi-format-strikethrough::before {\n  content: \"\\F0280\";\n}\n\n.mdi-format-strikethrough-variant::before {\n  content: \"\\F0281\";\n}\n\n.mdi-format-subscript::before {\n  content: \"\\F0282\";\n}\n\n.mdi-format-superscript::before {\n  content: \"\\F0283\";\n}\n\n.mdi-format-text::before {\n  content: \"\\F0284\";\n}\n\n.mdi-format-text-rotation-angle-down::before {\n  content: \"\\F0FBB\";\n}\n\n.mdi-format-text-rotation-angle-up::before {\n  content: \"\\F0FBC\";\n}\n\n.mdi-format-text-rotation-down::before {\n  content: \"\\F0D73\";\n}\n\n.mdi-format-text-rotation-down-vertical::before {\n  content: \"\\F0FBD\";\n}\n\n.mdi-format-text-rotation-none::before {\n  content: \"\\F0D74\";\n}\n\n.mdi-format-text-rotation-up::before {\n  content: \"\\F0FBE\";\n}\n\n.mdi-format-text-rotation-vertical::before {\n  content: \"\\F0FBF\";\n}\n\n.mdi-format-text-variant::before {\n  content: \"\\F0E32\";\n}\n\n.mdi-format-text-wrapping-clip::before {\n  content: \"\\F0D0E\";\n}\n\n.mdi-format-text-wrapping-overflow::before {\n  content: \"\\F0D0F\";\n}\n\n.mdi-format-text-wrapping-wrap::before {\n  content: \"\\F0D10\";\n}\n\n.mdi-format-textbox::before {\n  content: \"\\F0D11\";\n}\n\n.mdi-format-textdirection-l-to-r::before {\n  content: \"\\F0285\";\n}\n\n.mdi-format-textdirection-r-to-l::before {\n  content: \"\\F0286\";\n}\n\n.mdi-format-title::before {\n  content: \"\\F05F4\";\n}\n\n.mdi-format-underline::before {\n  content: \"\\F0287\";\n}\n\n.mdi-format-vertical-align-bottom::before {\n  content: \"\\F0621\";\n}\n\n.mdi-format-vertical-align-center::before {\n  content: \"\\F0622\";\n}\n\n.mdi-format-vertical-align-top::before {\n  content: \"\\F0623\";\n}\n\n.mdi-format-wrap-inline::before {\n  content: \"\\F0288\";\n}\n\n.mdi-format-wrap-square::before {\n  content: \"\\F0289\";\n}\n\n.mdi-format-wrap-tight::before {\n  content: \"\\F028A\";\n}\n\n.mdi-format-wrap-top-bottom::before {\n  content: \"\\F028B\";\n}\n\n.mdi-forum::before {\n  content: \"\\F028C\";\n}\n\n.mdi-forum-outline::before {\n  content: \"\\F0822\";\n}\n\n.mdi-forward::before {\n  content: \"\\F028D\";\n}\n\n.mdi-forwardburger::before {\n  content: \"\\F0D75\";\n}\n\n.mdi-fountain::before {\n  content: \"\\F096B\";\n}\n\n.mdi-fountain-pen::before {\n  content: \"\\F0D12\";\n}\n\n.mdi-fountain-pen-tip::before {\n  content: \"\\F0D13\";\n}\n\n.mdi-freebsd::before {\n  content: \"\\F08E0\";\n}\n\n.mdi-frequently-asked-questions::before {\n  content: \"\\F0EB4\";\n}\n\n.mdi-fridge::before {\n  content: \"\\F0290\";\n}\n\n.mdi-fridge-alert::before {\n  content: \"\\F11B1\";\n}\n\n.mdi-fridge-alert-outline::before {\n  content: \"\\F11B2\";\n}\n\n.mdi-fridge-bottom::before {\n  content: \"\\F0292\";\n}\n\n.mdi-fridge-off::before {\n  content: \"\\F11AF\";\n}\n\n.mdi-fridge-off-outline::before {\n  content: \"\\F11B0\";\n}\n\n.mdi-fridge-outline::before {\n  content: \"\\F028F\";\n}\n\n.mdi-fridge-top::before {\n  content: \"\\F0291\";\n}\n\n.mdi-fruit-cherries::before {\n  content: \"\\F1042\";\n}\n\n.mdi-fruit-citrus::before {\n  content: \"\\F1043\";\n}\n\n.mdi-fruit-grapes::before {\n  content: \"\\F1044\";\n}\n\n.mdi-fruit-grapes-outline::before {\n  content: \"\\F1045\";\n}\n\n.mdi-fruit-pineapple::before {\n  content: \"\\F1046\";\n}\n\n.mdi-fruit-watermelon::before {\n  content: \"\\F1047\";\n}\n\n.mdi-fuel::before {\n  content: \"\\F07CA\";\n}\n\n.mdi-fullscreen::before {\n  content: \"\\F0293\";\n}\n\n.mdi-fullscreen-exit::before {\n  content: \"\\F0294\";\n}\n\n.mdi-function::before {\n  content: \"\\F0295\";\n}\n\n.mdi-function-variant::before {\n  content: \"\\F0871\";\n}\n\n.mdi-furigana-horizontal::before {\n  content: \"\\F1081\";\n}\n\n.mdi-furigana-vertical::before {\n  content: \"\\F1082\";\n}\n\n.mdi-fuse::before {\n  content: \"\\F0C85\";\n}\n\n.mdi-fuse-blade::before {\n  content: \"\\F0C86\";\n}\n\n.mdi-gamepad::before {\n  content: \"\\F0296\";\n}\n\n.mdi-gamepad-circle::before {\n  content: \"\\F0E33\";\n}\n\n.mdi-gamepad-circle-down::before {\n  content: \"\\F0E34\";\n}\n\n.mdi-gamepad-circle-left::before {\n  content: \"\\F0E35\";\n}\n\n.mdi-gamepad-circle-outline::before {\n  content: \"\\F0E36\";\n}\n\n.mdi-gamepad-circle-right::before {\n  content: \"\\F0E37\";\n}\n\n.mdi-gamepad-circle-up::before {\n  content: \"\\F0E38\";\n}\n\n.mdi-gamepad-down::before {\n  content: \"\\F0E39\";\n}\n\n.mdi-gamepad-left::before {\n  content: \"\\F0E3A\";\n}\n\n.mdi-gamepad-right::before {\n  content: \"\\F0E3B\";\n}\n\n.mdi-gamepad-round::before {\n  content: \"\\F0E3C\";\n}\n\n.mdi-gamepad-round-down::before {\n  content: \"\\F0E3D\";\n}\n\n.mdi-gamepad-round-left::before {\n  content: \"\\F0E3E\";\n}\n\n.mdi-gamepad-round-outline::before {\n  content: \"\\F0E3F\";\n}\n\n.mdi-gamepad-round-right::before {\n  content: \"\\F0E40\";\n}\n\n.mdi-gamepad-round-up::before {\n  content: \"\\F0E41\";\n}\n\n.mdi-gamepad-square::before {\n  content: \"\\F0EB5\";\n}\n\n.mdi-gamepad-square-outline::before {\n  content: \"\\F0EB6\";\n}\n\n.mdi-gamepad-up::before {\n  content: \"\\F0E42\";\n}\n\n.mdi-gamepad-variant::before {\n  content: \"\\F0297\";\n}\n\n.mdi-gamepad-variant-outline::before {\n  content: \"\\F0EB7\";\n}\n\n.mdi-gamma::before {\n  content: \"\\F10EE\";\n}\n\n.mdi-gantry-crane::before {\n  content: \"\\F0DD1\";\n}\n\n.mdi-garage::before {\n  content: \"\\F06D9\";\n}\n\n.mdi-garage-alert::before {\n  content: \"\\F0872\";\n}\n\n.mdi-garage-alert-variant::before {\n  content: \"\\F12D5\";\n}\n\n.mdi-garage-open::before {\n  content: \"\\F06DA\";\n}\n\n.mdi-garage-open-variant::before {\n  content: \"\\F12D4\";\n}\n\n.mdi-garage-variant::before {\n  content: \"\\F12D3\";\n}\n\n.mdi-gas-cylinder::before {\n  content: \"\\F0647\";\n}\n\n.mdi-gas-station::before {\n  content: \"\\F0298\";\n}\n\n.mdi-gas-station-outline::before {\n  content: \"\\F0EB8\";\n}\n\n.mdi-gate::before {\n  content: \"\\F0299\";\n}\n\n.mdi-gate-and::before {\n  content: \"\\F08E1\";\n}\n\n.mdi-gate-arrow-right::before {\n  content: \"\\F1169\";\n}\n\n.mdi-gate-nand::before {\n  content: \"\\F08E2\";\n}\n\n.mdi-gate-nor::before {\n  content: \"\\F08E3\";\n}\n\n.mdi-gate-not::before {\n  content: \"\\F08E4\";\n}\n\n.mdi-gate-open::before {\n  content: \"\\F116A\";\n}\n\n.mdi-gate-or::before {\n  content: \"\\F08E5\";\n}\n\n.mdi-gate-xnor::before {\n  content: \"\\F08E6\";\n}\n\n.mdi-gate-xor::before {\n  content: \"\\F08E7\";\n}\n\n.mdi-gatsby::before {\n  content: \"\\F0E43\";\n}\n\n.mdi-gauge::before {\n  content: \"\\F029A\";\n}\n\n.mdi-gauge-empty::before {\n  content: \"\\F0873\";\n}\n\n.mdi-gauge-full::before {\n  content: \"\\F0874\";\n}\n\n.mdi-gauge-low::before {\n  content: \"\\F0875\";\n}\n\n.mdi-gavel::before {\n  content: \"\\F029B\";\n}\n\n.mdi-gender-female::before {\n  content: \"\\F029C\";\n}\n\n.mdi-gender-male::before {\n  content: \"\\F029D\";\n}\n\n.mdi-gender-male-female::before {\n  content: \"\\F029E\";\n}\n\n.mdi-gender-male-female-variant::before {\n  content: \"\\F113F\";\n}\n\n.mdi-gender-non-binary::before {\n  content: \"\\F1140\";\n}\n\n.mdi-gender-transgender::before {\n  content: \"\\F029F\";\n}\n\n.mdi-gentoo::before {\n  content: \"\\F08E8\";\n}\n\n.mdi-gesture::before {\n  content: \"\\F07CB\";\n}\n\n.mdi-gesture-double-tap::before {\n  content: \"\\F073C\";\n}\n\n.mdi-gesture-pinch::before {\n  content: \"\\F0ABD\";\n}\n\n.mdi-gesture-spread::before {\n  content: \"\\F0ABE\";\n}\n\n.mdi-gesture-swipe::before {\n  content: \"\\F0D76\";\n}\n\n.mdi-gesture-swipe-down::before {\n  content: \"\\F073D\";\n}\n\n.mdi-gesture-swipe-horizontal::before {\n  content: \"\\F0ABF\";\n}\n\n.mdi-gesture-swipe-left::before {\n  content: \"\\F073E\";\n}\n\n.mdi-gesture-swipe-right::before {\n  content: \"\\F073F\";\n}\n\n.mdi-gesture-swipe-up::before {\n  content: \"\\F0740\";\n}\n\n.mdi-gesture-swipe-vertical::before {\n  content: \"\\F0AC0\";\n}\n\n.mdi-gesture-tap::before {\n  content: \"\\F0741\";\n}\n\n.mdi-gesture-tap-box::before {\n  content: \"\\F12A9\";\n}\n\n.mdi-gesture-tap-button::before {\n  content: \"\\F12A8\";\n}\n\n.mdi-gesture-tap-hold::before {\n  content: \"\\F0D77\";\n}\n\n.mdi-gesture-two-double-tap::before {\n  content: \"\\F0742\";\n}\n\n.mdi-gesture-two-tap::before {\n  content: \"\\F0743\";\n}\n\n.mdi-ghost::before {\n  content: \"\\F02A0\";\n}\n\n.mdi-ghost-off::before {\n  content: \"\\F09F5\";\n}\n\n.mdi-gif::before {\n  content: \"\\F0D78\";\n}\n\n.mdi-gift::before {\n  content: \"\\F0E44\";\n}\n\n.mdi-gift-outline::before {\n  content: \"\\F02A1\";\n}\n\n.mdi-git::before {\n  content: \"\\F02A2\";\n}\n\n.mdi-github::before {\n  content: \"\\F02A4\";\n}\n\n.mdi-gitlab::before {\n  content: \"\\F0BA0\";\n}\n\n.mdi-glass-cocktail::before {\n  content: \"\\F0356\";\n}\n\n.mdi-glass-flute::before {\n  content: \"\\F02A5\";\n}\n\n.mdi-glass-mug::before {\n  content: \"\\F02A6\";\n}\n\n.mdi-glass-mug-variant::before {\n  content: \"\\F1116\";\n}\n\n.mdi-glass-pint-outline::before {\n  content: \"\\F130D\";\n}\n\n.mdi-glass-stange::before {\n  content: \"\\F02A7\";\n}\n\n.mdi-glass-tulip::before {\n  content: \"\\F02A8\";\n}\n\n.mdi-glass-wine::before {\n  content: \"\\F0876\";\n}\n\n.mdi-glasses::before {\n  content: \"\\F02AA\";\n}\n\n.mdi-globe-light::before {\n  content: \"\\F12D7\";\n}\n\n.mdi-globe-model::before {\n  content: \"\\F08E9\";\n}\n\n.mdi-gmail::before {\n  content: \"\\F02AB\";\n}\n\n.mdi-gnome::before {\n  content: \"\\F02AC\";\n}\n\n.mdi-go-kart::before {\n  content: \"\\F0D79\";\n}\n\n.mdi-go-kart-track::before {\n  content: \"\\F0D7A\";\n}\n\n.mdi-gog::before {\n  content: \"\\F0BA1\";\n}\n\n.mdi-gold::before {\n  content: \"\\F124F\";\n}\n\n.mdi-golf::before {\n  content: \"\\F0823\";\n}\n\n.mdi-golf-cart::before {\n  content: \"\\F11A4\";\n}\n\n.mdi-golf-tee::before {\n  content: \"\\F1083\";\n}\n\n.mdi-gondola::before {\n  content: \"\\F0686\";\n}\n\n.mdi-goodreads::before {\n  content: \"\\F0D7B\";\n}\n\n.mdi-google::before {\n  content: \"\\F02AD\";\n}\n\n.mdi-google-ads::before {\n  content: \"\\F0C87\";\n}\n\n.mdi-google-analytics::before {\n  content: \"\\F07CC\";\n}\n\n.mdi-google-assistant::before {\n  content: \"\\F07CD\";\n}\n\n.mdi-google-cardboard::before {\n  content: \"\\F02AE\";\n}\n\n.mdi-google-chrome::before {\n  content: \"\\F02AF\";\n}\n\n.mdi-google-circles::before {\n  content: \"\\F02B0\";\n}\n\n.mdi-google-circles-communities::before {\n  content: \"\\F02B1\";\n}\n\n.mdi-google-circles-extended::before {\n  content: \"\\F02B2\";\n}\n\n.mdi-google-circles-group::before {\n  content: \"\\F02B3\";\n}\n\n.mdi-google-classroom::before {\n  content: \"\\F02C0\";\n}\n\n.mdi-google-cloud::before {\n  content: \"\\F11F6\";\n}\n\n.mdi-google-controller::before {\n  content: \"\\F02B4\";\n}\n\n.mdi-google-controller-off::before {\n  content: \"\\F02B5\";\n}\n\n.mdi-google-downasaur::before {\n  content: \"\\F1362\";\n}\n\n.mdi-google-drive::before {\n  content: \"\\F02B6\";\n}\n\n.mdi-google-earth::before {\n  content: \"\\F02B7\";\n}\n\n.mdi-google-fit::before {\n  content: \"\\F096C\";\n}\n\n.mdi-google-glass::before {\n  content: \"\\F02B8\";\n}\n\n.mdi-google-hangouts::before {\n  content: \"\\F02C9\";\n}\n\n.mdi-google-home::before {\n  content: \"\\F0824\";\n}\n\n.mdi-google-keep::before {\n  content: \"\\F06DC\";\n}\n\n.mdi-google-lens::before {\n  content: \"\\F09F6\";\n}\n\n.mdi-google-maps::before {\n  content: \"\\F05F5\";\n}\n\n.mdi-google-my-business::before {\n  content: \"\\F1048\";\n}\n\n.mdi-google-nearby::before {\n  content: \"\\F02B9\";\n}\n\n.mdi-google-photos::before {\n  content: \"\\F06DD\";\n}\n\n.mdi-google-play::before {\n  content: \"\\F02BC\";\n}\n\n.mdi-google-plus::before {\n  content: \"\\F02BD\";\n}\n\n.mdi-google-podcast::before {\n  content: \"\\F0EB9\";\n}\n\n.mdi-google-spreadsheet::before {\n  content: \"\\F09F7\";\n}\n\n.mdi-google-street-view::before {\n  content: \"\\F0C88\";\n}\n\n.mdi-google-translate::before {\n  content: \"\\F02BF\";\n}\n\n.mdi-gradient::before {\n  content: \"\\F06A0\";\n}\n\n.mdi-grain::before {\n  content: \"\\F0D7C\";\n}\n\n.mdi-graph::before {\n  content: \"\\F1049\";\n}\n\n.mdi-graph-outline::before {\n  content: \"\\F104A\";\n}\n\n.mdi-graphql::before {\n  content: \"\\F0877\";\n}\n\n.mdi-grave-stone::before {\n  content: \"\\F0BA2\";\n}\n\n.mdi-grease-pencil::before {\n  content: \"\\F0648\";\n}\n\n.mdi-greater-than::before {\n  content: \"\\F096D\";\n}\n\n.mdi-greater-than-or-equal::before {\n  content: \"\\F096E\";\n}\n\n.mdi-grid::before {\n  content: \"\\F02C1\";\n}\n\n.mdi-grid-large::before {\n  content: \"\\F0758\";\n}\n\n.mdi-grid-off::before {\n  content: \"\\F02C2\";\n}\n\n.mdi-grill::before {\n  content: \"\\F0E45\";\n}\n\n.mdi-grill-outline::before {\n  content: \"\\F118A\";\n}\n\n.mdi-group::before {\n  content: \"\\F02C3\";\n}\n\n.mdi-guitar-acoustic::before {\n  content: \"\\F0771\";\n}\n\n.mdi-guitar-electric::before {\n  content: \"\\F02C4\";\n}\n\n.mdi-guitar-pick::before {\n  content: \"\\F02C5\";\n}\n\n.mdi-guitar-pick-outline::before {\n  content: \"\\F02C6\";\n}\n\n.mdi-guy-fawkes-mask::before {\n  content: \"\\F0825\";\n}\n\n.mdi-hail::before {\n  content: \"\\F0AC1\";\n}\n\n.mdi-hair-dryer::before {\n  content: \"\\F10EF\";\n}\n\n.mdi-hair-dryer-outline::before {\n  content: \"\\F10F0\";\n}\n\n.mdi-halloween::before {\n  content: \"\\F0BA3\";\n}\n\n.mdi-hamburger::before {\n  content: \"\\F0685\";\n}\n\n.mdi-hammer::before {\n  content: \"\\F08EA\";\n}\n\n.mdi-hammer-screwdriver::before {\n  content: \"\\F1322\";\n}\n\n.mdi-hammer-wrench::before {\n  content: \"\\F1323\";\n}\n\n.mdi-hand::before {\n  content: \"\\F0A4F\";\n}\n\n.mdi-hand-heart::before {\n  content: \"\\F10F1\";\n}\n\n.mdi-hand-left::before {\n  content: \"\\F0E46\";\n}\n\n.mdi-hand-okay::before {\n  content: \"\\F0A50\";\n}\n\n.mdi-hand-peace::before {\n  content: \"\\F0A51\";\n}\n\n.mdi-hand-peace-variant::before {\n  content: \"\\F0A52\";\n}\n\n.mdi-hand-pointing-down::before {\n  content: \"\\F0A53\";\n}\n\n.mdi-hand-pointing-left::before {\n  content: \"\\F0A54\";\n}\n\n.mdi-hand-pointing-right::before {\n  content: \"\\F02C7\";\n}\n\n.mdi-hand-pointing-up::before {\n  content: \"\\F0A55\";\n}\n\n.mdi-hand-right::before {\n  content: \"\\F0E47\";\n}\n\n.mdi-hand-saw::before {\n  content: \"\\F0E48\";\n}\n\n.mdi-hand-water::before {\n  content: \"\\F139F\";\n}\n\n.mdi-handball::before {\n  content: \"\\F0F53\";\n}\n\n.mdi-handcuffs::before {\n  content: \"\\F113E\";\n}\n\n.mdi-handshake::before {\n  content: \"\\F1218\";\n}\n\n.mdi-hanger::before {\n  content: \"\\F02C8\";\n}\n\n.mdi-hard-hat::before {\n  content: \"\\F096F\";\n}\n\n.mdi-harddisk::before {\n  content: \"\\F02CA\";\n}\n\n.mdi-harddisk-plus::before {\n  content: \"\\F104B\";\n}\n\n.mdi-harddisk-remove::before {\n  content: \"\\F104C\";\n}\n\n.mdi-hat-fedora::before {\n  content: \"\\F0BA4\";\n}\n\n.mdi-hazard-lights::before {\n  content: \"\\F0C89\";\n}\n\n.mdi-hdr::before {\n  content: \"\\F0D7D\";\n}\n\n.mdi-hdr-off::before {\n  content: \"\\F0D7E\";\n}\n\n.mdi-head::before {\n  content: \"\\F135E\";\n}\n\n.mdi-head-alert::before {\n  content: \"\\F1338\";\n}\n\n.mdi-head-alert-outline::before {\n  content: \"\\F1339\";\n}\n\n.mdi-head-check::before {\n  content: \"\\F133A\";\n}\n\n.mdi-head-check-outline::before {\n  content: \"\\F133B\";\n}\n\n.mdi-head-cog::before {\n  content: \"\\F133C\";\n}\n\n.mdi-head-cog-outline::before {\n  content: \"\\F133D\";\n}\n\n.mdi-head-dots-horizontal::before {\n  content: \"\\F133E\";\n}\n\n.mdi-head-dots-horizontal-outline::before {\n  content: \"\\F133F\";\n}\n\n.mdi-head-flash::before {\n  content: \"\\F1340\";\n}\n\n.mdi-head-flash-outline::before {\n  content: \"\\F1341\";\n}\n\n.mdi-head-heart::before {\n  content: \"\\F1342\";\n}\n\n.mdi-head-heart-outline::before {\n  content: \"\\F1343\";\n}\n\n.mdi-head-lightbulb::before {\n  content: \"\\F1344\";\n}\n\n.mdi-head-lightbulb-outline::before {\n  content: \"\\F1345\";\n}\n\n.mdi-head-minus::before {\n  content: \"\\F1346\";\n}\n\n.mdi-head-minus-outline::before {\n  content: \"\\F1347\";\n}\n\n.mdi-head-outline::before {\n  content: \"\\F135F\";\n}\n\n.mdi-head-plus::before {\n  content: \"\\F1348\";\n}\n\n.mdi-head-plus-outline::before {\n  content: \"\\F1349\";\n}\n\n.mdi-head-question::before {\n  content: \"\\F134A\";\n}\n\n.mdi-head-question-outline::before {\n  content: \"\\F134B\";\n}\n\n.mdi-head-remove::before {\n  content: \"\\F134C\";\n}\n\n.mdi-head-remove-outline::before {\n  content: \"\\F134D\";\n}\n\n.mdi-head-snowflake::before {\n  content: \"\\F134E\";\n}\n\n.mdi-head-snowflake-outline::before {\n  content: \"\\F134F\";\n}\n\n.mdi-head-sync::before {\n  content: \"\\F1350\";\n}\n\n.mdi-head-sync-outline::before {\n  content: \"\\F1351\";\n}\n\n.mdi-headphones::before {\n  content: \"\\F02CB\";\n}\n\n.mdi-headphones-bluetooth::before {\n  content: \"\\F0970\";\n}\n\n.mdi-headphones-box::before {\n  content: \"\\F02CC\";\n}\n\n.mdi-headphones-off::before {\n  content: \"\\F07CE\";\n}\n\n.mdi-headphones-settings::before {\n  content: \"\\F02CD\";\n}\n\n.mdi-headset::before {\n  content: \"\\F02CE\";\n}\n\n.mdi-headset-dock::before {\n  content: \"\\F02CF\";\n}\n\n.mdi-headset-off::before {\n  content: \"\\F02D0\";\n}\n\n.mdi-heart::before {\n  content: \"\\F02D1\";\n}\n\n.mdi-heart-box::before {\n  content: \"\\F02D2\";\n}\n\n.mdi-heart-box-outline::before {\n  content: \"\\F02D3\";\n}\n\n.mdi-heart-broken::before {\n  content: \"\\F02D4\";\n}\n\n.mdi-heart-broken-outline::before {\n  content: \"\\F0D14\";\n}\n\n.mdi-heart-circle::before {\n  content: \"\\F0971\";\n}\n\n.mdi-heart-circle-outline::before {\n  content: \"\\F0972\";\n}\n\n.mdi-heart-flash::before {\n  content: \"\\F0EF9\";\n}\n\n.mdi-heart-half::before {\n  content: \"\\F06DF\";\n}\n\n.mdi-heart-half-full::before {\n  content: \"\\F06DE\";\n}\n\n.mdi-heart-half-outline::before {\n  content: \"\\F06E0\";\n}\n\n.mdi-heart-multiple::before {\n  content: \"\\F0A56\";\n}\n\n.mdi-heart-multiple-outline::before {\n  content: \"\\F0A57\";\n}\n\n.mdi-heart-off::before {\n  content: \"\\F0759\";\n}\n\n.mdi-heart-outline::before {\n  content: \"\\F02D5\";\n}\n\n.mdi-heart-pulse::before {\n  content: \"\\F05F6\";\n}\n\n.mdi-helicopter::before {\n  content: \"\\F0AC2\";\n}\n\n.mdi-help::before {\n  content: \"\\F02D6\";\n}\n\n.mdi-help-box::before {\n  content: \"\\F078B\";\n}\n\n.mdi-help-circle::before {\n  content: \"\\F02D7\";\n}\n\n.mdi-help-circle-outline::before {\n  content: \"\\F0625\";\n}\n\n.mdi-help-network::before {\n  content: \"\\F06F5\";\n}\n\n.mdi-help-network-outline::before {\n  content: \"\\F0C8A\";\n}\n\n.mdi-help-rhombus::before {\n  content: \"\\F0BA5\";\n}\n\n.mdi-help-rhombus-outline::before {\n  content: \"\\F0BA6\";\n}\n\n.mdi-hexadecimal::before {\n  content: \"\\F12A7\";\n}\n\n.mdi-hexagon::before {\n  content: \"\\F02D8\";\n}\n\n.mdi-hexagon-multiple::before {\n  content: \"\\F06E1\";\n}\n\n.mdi-hexagon-multiple-outline::before {\n  content: \"\\F10F2\";\n}\n\n.mdi-hexagon-outline::before {\n  content: \"\\F02D9\";\n}\n\n.mdi-hexagon-slice-1::before {\n  content: \"\\F0AC3\";\n}\n\n.mdi-hexagon-slice-2::before {\n  content: \"\\F0AC4\";\n}\n\n.mdi-hexagon-slice-3::before {\n  content: \"\\F0AC5\";\n}\n\n.mdi-hexagon-slice-4::before {\n  content: \"\\F0AC6\";\n}\n\n.mdi-hexagon-slice-5::before {\n  content: \"\\F0AC7\";\n}\n\n.mdi-hexagon-slice-6::before {\n  content: \"\\F0AC8\";\n}\n\n.mdi-hexagram::before {\n  content: \"\\F0AC9\";\n}\n\n.mdi-hexagram-outline::before {\n  content: \"\\F0ACA\";\n}\n\n.mdi-high-definition::before {\n  content: \"\\F07CF\";\n}\n\n.mdi-high-definition-box::before {\n  content: \"\\F0878\";\n}\n\n.mdi-highway::before {\n  content: \"\\F05F7\";\n}\n\n.mdi-hiking::before {\n  content: \"\\F0D7F\";\n}\n\n.mdi-hinduism::before {\n  content: \"\\F0973\";\n}\n\n.mdi-history::before {\n  content: \"\\F02DA\";\n}\n\n.mdi-hockey-puck::before {\n  content: \"\\F0879\";\n}\n\n.mdi-hockey-sticks::before {\n  content: \"\\F087A\";\n}\n\n.mdi-hololens::before {\n  content: \"\\F02DB\";\n}\n\n.mdi-home::before {\n  content: \"\\F02DC\";\n}\n\n.mdi-home-account::before {\n  content: \"\\F0826\";\n}\n\n.mdi-home-alert::before {\n  content: \"\\F087B\";\n}\n\n.mdi-home-analytics::before {\n  content: \"\\F0EBA\";\n}\n\n.mdi-home-assistant::before {\n  content: \"\\F07D0\";\n}\n\n.mdi-home-automation::before {\n  content: \"\\F07D1\";\n}\n\n.mdi-home-circle::before {\n  content: \"\\F07D2\";\n}\n\n.mdi-home-circle-outline::before {\n  content: \"\\F104D\";\n}\n\n.mdi-home-city::before {\n  content: \"\\F0D15\";\n}\n\n.mdi-home-city-outline::before {\n  content: \"\\F0D16\";\n}\n\n.mdi-home-currency-usd::before {\n  content: \"\\F08AF\";\n}\n\n.mdi-home-edit::before {\n  content: \"\\F1159\";\n}\n\n.mdi-home-edit-outline::before {\n  content: \"\\F115A\";\n}\n\n.mdi-home-export-outline::before {\n  content: \"\\F0F9B\";\n}\n\n.mdi-home-flood::before {\n  content: \"\\F0EFA\";\n}\n\n.mdi-home-floor-0::before {\n  content: \"\\F0DD2\";\n}\n\n.mdi-home-floor-1::before {\n  content: \"\\F0D80\";\n}\n\n.mdi-home-floor-2::before {\n  content: \"\\F0D81\";\n}\n\n.mdi-home-floor-3::before {\n  content: \"\\F0D82\";\n}\n\n.mdi-home-floor-a::before {\n  content: \"\\F0D83\";\n}\n\n.mdi-home-floor-b::before {\n  content: \"\\F0D84\";\n}\n\n.mdi-home-floor-g::before {\n  content: \"\\F0D85\";\n}\n\n.mdi-home-floor-l::before {\n  content: \"\\F0D86\";\n}\n\n.mdi-home-floor-negative-1::before {\n  content: \"\\F0DD3\";\n}\n\n.mdi-home-group::before {\n  content: \"\\F0DD4\";\n}\n\n.mdi-home-heart::before {\n  content: \"\\F0827\";\n}\n\n.mdi-home-import-outline::before {\n  content: \"\\F0F9C\";\n}\n\n.mdi-home-lightbulb::before {\n  content: \"\\F1251\";\n}\n\n.mdi-home-lightbulb-outline::before {\n  content: \"\\F1252\";\n}\n\n.mdi-home-lock::before {\n  content: \"\\F08EB\";\n}\n\n.mdi-home-lock-open::before {\n  content: \"\\F08EC\";\n}\n\n.mdi-home-map-marker::before {\n  content: \"\\F05F8\";\n}\n\n.mdi-home-minus::before {\n  content: \"\\F0974\";\n}\n\n.mdi-home-modern::before {\n  content: \"\\F02DD\";\n}\n\n.mdi-home-outline::before {\n  content: \"\\F06A1\";\n}\n\n.mdi-home-plus::before {\n  content: \"\\F0975\";\n}\n\n.mdi-home-remove::before {\n  content: \"\\F1247\";\n}\n\n.mdi-home-roof::before {\n  content: \"\\F112B\";\n}\n\n.mdi-home-search::before {\n  content: \"\\F13B0\";\n}\n\n.mdi-home-search-outline::before {\n  content: \"\\F13B1\";\n}\n\n.mdi-home-thermometer::before {\n  content: \"\\F0F54\";\n}\n\n.mdi-home-thermometer-outline::before {\n  content: \"\\F0F55\";\n}\n\n.mdi-home-variant::before {\n  content: \"\\F02DE\";\n}\n\n.mdi-home-variant-outline::before {\n  content: \"\\F0BA7\";\n}\n\n.mdi-hook::before {\n  content: \"\\F06E2\";\n}\n\n.mdi-hook-off::before {\n  content: \"\\F06E3\";\n}\n\n.mdi-hops::before {\n  content: \"\\F02DF\";\n}\n\n.mdi-horizontal-rotate-clockwise::before {\n  content: \"\\F10F3\";\n}\n\n.mdi-horizontal-rotate-counterclockwise::before {\n  content: \"\\F10F4\";\n}\n\n.mdi-horseshoe::before {\n  content: \"\\F0A58\";\n}\n\n.mdi-hospital::before {\n  content: \"\\F0FF6\";\n}\n\n.mdi-hospital-box::before {\n  content: \"\\F02E0\";\n}\n\n.mdi-hospital-box-outline::before {\n  content: \"\\F0FF7\";\n}\n\n.mdi-hospital-building::before {\n  content: \"\\F02E1\";\n}\n\n.mdi-hospital-marker::before {\n  content: \"\\F02E2\";\n}\n\n.mdi-hot-tub::before {\n  content: \"\\F0828\";\n}\n\n.mdi-hubspot::before {\n  content: \"\\F0D17\";\n}\n\n.mdi-hulu::before {\n  content: \"\\F0829\";\n}\n\n.mdi-human::before {\n  content: \"\\F02E6\";\n}\n\n.mdi-human-baby-changing-table::before {\n  content: \"\\F138B\";\n}\n\n.mdi-human-child::before {\n  content: \"\\F02E7\";\n}\n\n.mdi-human-female::before {\n  content: \"\\F0649\";\n}\n\n.mdi-human-female-boy::before {\n  content: \"\\F0A59\";\n}\n\n.mdi-human-female-female::before {\n  content: \"\\F0A5A\";\n}\n\n.mdi-human-female-girl::before {\n  content: \"\\F0A5B\";\n}\n\n.mdi-human-greeting::before {\n  content: \"\\F064A\";\n}\n\n.mdi-human-handsdown::before {\n  content: \"\\F064B\";\n}\n\n.mdi-human-handsup::before {\n  content: \"\\F064C\";\n}\n\n.mdi-human-male::before {\n  content: \"\\F064D\";\n}\n\n.mdi-human-male-boy::before {\n  content: \"\\F0A5C\";\n}\n\n.mdi-human-male-child::before {\n  content: \"\\F138C\";\n}\n\n.mdi-human-male-female::before {\n  content: \"\\F02E8\";\n}\n\n.mdi-human-male-girl::before {\n  content: \"\\F0A5D\";\n}\n\n.mdi-human-male-height::before {\n  content: \"\\F0EFB\";\n}\n\n.mdi-human-male-height-variant::before {\n  content: \"\\F0EFC\";\n}\n\n.mdi-human-male-male::before {\n  content: \"\\F0A5E\";\n}\n\n.mdi-human-pregnant::before {\n  content: \"\\F05CF\";\n}\n\n.mdi-human-wheelchair::before {\n  content: \"\\F138D\";\n}\n\n.mdi-humble-bundle::before {\n  content: \"\\F0744\";\n}\n\n.mdi-hvac::before {\n  content: \"\\F1352\";\n}\n\n.mdi-hydraulic-oil-level::before {\n  content: \"\\F1324\";\n}\n\n.mdi-hydraulic-oil-temperature::before {\n  content: \"\\F1325\";\n}\n\n.mdi-hydro-power::before {\n  content: \"\\F12E5\";\n}\n\n.mdi-ice-cream::before {\n  content: \"\\F082A\";\n}\n\n.mdi-ice-cream-off::before {\n  content: \"\\F0E52\";\n}\n\n.mdi-ice-pop::before {\n  content: \"\\F0EFD\";\n}\n\n.mdi-id-card::before {\n  content: \"\\F0FC0\";\n}\n\n.mdi-identifier::before {\n  content: \"\\F0EFE\";\n}\n\n.mdi-ideogram-cjk::before {\n  content: \"\\F1331\";\n}\n\n.mdi-ideogram-cjk-variant::before {\n  content: \"\\F1332\";\n}\n\n.mdi-iframe::before {\n  content: \"\\F0C8B\";\n}\n\n.mdi-iframe-array::before {\n  content: \"\\F10F5\";\n}\n\n.mdi-iframe-array-outline::before {\n  content: \"\\F10F6\";\n}\n\n.mdi-iframe-braces::before {\n  content: \"\\F10F7\";\n}\n\n.mdi-iframe-braces-outline::before {\n  content: \"\\F10F8\";\n}\n\n.mdi-iframe-outline::before {\n  content: \"\\F0C8C\";\n}\n\n.mdi-iframe-parentheses::before {\n  content: \"\\F10F9\";\n}\n\n.mdi-iframe-parentheses-outline::before {\n  content: \"\\F10FA\";\n}\n\n.mdi-iframe-variable::before {\n  content: \"\\F10FB\";\n}\n\n.mdi-iframe-variable-outline::before {\n  content: \"\\F10FC\";\n}\n\n.mdi-image::before {\n  content: \"\\F02E9\";\n}\n\n.mdi-image-album::before {\n  content: \"\\F02EA\";\n}\n\n.mdi-image-area::before {\n  content: \"\\F02EB\";\n}\n\n.mdi-image-area-close::before {\n  content: \"\\F02EC\";\n}\n\n.mdi-image-auto-adjust::before {\n  content: \"\\F0FC1\";\n}\n\n.mdi-image-broken::before {\n  content: \"\\F02ED\";\n}\n\n.mdi-image-broken-variant::before {\n  content: \"\\F02EE\";\n}\n\n.mdi-image-edit::before {\n  content: \"\\F11E3\";\n}\n\n.mdi-image-edit-outline::before {\n  content: \"\\F11E4\";\n}\n\n.mdi-image-filter-black-white::before {\n  content: \"\\F02F0\";\n}\n\n.mdi-image-filter-center-focus::before {\n  content: \"\\F02F1\";\n}\n\n.mdi-image-filter-center-focus-strong::before {\n  content: \"\\F0EFF\";\n}\n\n.mdi-image-filter-center-focus-strong-outline::before {\n  content: \"\\F0F00\";\n}\n\n.mdi-image-filter-center-focus-weak::before {\n  content: \"\\F02F2\";\n}\n\n.mdi-image-filter-drama::before {\n  content: \"\\F02F3\";\n}\n\n.mdi-image-filter-frames::before {\n  content: \"\\F02F4\";\n}\n\n.mdi-image-filter-hdr::before {\n  content: \"\\F02F5\";\n}\n\n.mdi-image-filter-none::before {\n  content: \"\\F02F6\";\n}\n\n.mdi-image-filter-tilt-shift::before {\n  content: \"\\F02F7\";\n}\n\n.mdi-image-filter-vintage::before {\n  content: \"\\F02F8\";\n}\n\n.mdi-image-frame::before {\n  content: \"\\F0E49\";\n}\n\n.mdi-image-move::before {\n  content: \"\\F09F8\";\n}\n\n.mdi-image-multiple::before {\n  content: \"\\F02F9\";\n}\n\n.mdi-image-multiple-outline::before {\n  content: \"\\F02EF\";\n}\n\n.mdi-image-off::before {\n  content: \"\\F082B\";\n}\n\n.mdi-image-off-outline::before {\n  content: \"\\F11D1\";\n}\n\n.mdi-image-outline::before {\n  content: \"\\F0976\";\n}\n\n.mdi-image-plus::before {\n  content: \"\\F087C\";\n}\n\n.mdi-image-search::before {\n  content: \"\\F0977\";\n}\n\n.mdi-image-search-outline::before {\n  content: \"\\F0978\";\n}\n\n.mdi-image-size-select-actual::before {\n  content: \"\\F0C8D\";\n}\n\n.mdi-image-size-select-large::before {\n  content: \"\\F0C8E\";\n}\n\n.mdi-image-size-select-small::before {\n  content: \"\\F0C8F\";\n}\n\n.mdi-import::before {\n  content: \"\\F02FA\";\n}\n\n.mdi-inbox::before {\n  content: \"\\F0687\";\n}\n\n.mdi-inbox-arrow-down::before {\n  content: \"\\F02FB\";\n}\n\n.mdi-inbox-arrow-down-outline::before {\n  content: \"\\F1270\";\n}\n\n.mdi-inbox-arrow-up::before {\n  content: \"\\F03D1\";\n}\n\n.mdi-inbox-arrow-up-outline::before {\n  content: \"\\F1271\";\n}\n\n.mdi-inbox-full::before {\n  content: \"\\F1272\";\n}\n\n.mdi-inbox-full-outline::before {\n  content: \"\\F1273\";\n}\n\n.mdi-inbox-multiple::before {\n  content: \"\\F08B0\";\n}\n\n.mdi-inbox-multiple-outline::before {\n  content: \"\\F0BA8\";\n}\n\n.mdi-inbox-outline::before {\n  content: \"\\F1274\";\n}\n\n.mdi-incognito::before {\n  content: \"\\F05F9\";\n}\n\n.mdi-incognito-off::before {\n  content: \"\\F0075\";\n}\n\n.mdi-infinity::before {\n  content: \"\\F06E4\";\n}\n\n.mdi-information::before {\n  content: \"\\F02FC\";\n}\n\n.mdi-information-outline::before {\n  content: \"\\F02FD\";\n}\n\n.mdi-information-variant::before {\n  content: \"\\F064E\";\n}\n\n.mdi-instagram::before {\n  content: \"\\F02FE\";\n}\n\n.mdi-instrument-triangle::before {\n  content: \"\\F104E\";\n}\n\n.mdi-invert-colors::before {\n  content: \"\\F0301\";\n}\n\n.mdi-invert-colors-off::before {\n  content: \"\\F0E4A\";\n}\n\n.mdi-iobroker::before {\n  content: \"\\F12E8\";\n}\n\n.mdi-ip::before {\n  content: \"\\F0A5F\";\n}\n\n.mdi-ip-network::before {\n  content: \"\\F0A60\";\n}\n\n.mdi-ip-network-outline::before {\n  content: \"\\F0C90\";\n}\n\n.mdi-ipod::before {\n  content: \"\\F0C91\";\n}\n\n.mdi-islam::before {\n  content: \"\\F0979\";\n}\n\n.mdi-island::before {\n  content: \"\\F104F\";\n}\n\n.mdi-iv-bag::before {\n  content: \"\\F10B9\";\n}\n\n.mdi-jabber::before {\n  content: \"\\F0DD5\";\n}\n\n.mdi-jeepney::before {\n  content: \"\\F0302\";\n}\n\n.mdi-jellyfish::before {\n  content: \"\\F0F01\";\n}\n\n.mdi-jellyfish-outline::before {\n  content: \"\\F0F02\";\n}\n\n.mdi-jira::before {\n  content: \"\\F0303\";\n}\n\n.mdi-jquery::before {\n  content: \"\\F087D\";\n}\n\n.mdi-jsfiddle::before {\n  content: \"\\F0304\";\n}\n\n.mdi-judaism::before {\n  content: \"\\F097A\";\n}\n\n.mdi-jump-rope::before {\n  content: \"\\F12FF\";\n}\n\n.mdi-kabaddi::before {\n  content: \"\\F0D87\";\n}\n\n.mdi-karate::before {\n  content: \"\\F082C\";\n}\n\n.mdi-keg::before {\n  content: \"\\F0305\";\n}\n\n.mdi-kettle::before {\n  content: \"\\F05FA\";\n}\n\n.mdi-kettle-alert::before {\n  content: \"\\F1317\";\n}\n\n.mdi-kettle-alert-outline::before {\n  content: \"\\F1318\";\n}\n\n.mdi-kettle-off::before {\n  content: \"\\F131B\";\n}\n\n.mdi-kettle-off-outline::before {\n  content: \"\\F131C\";\n}\n\n.mdi-kettle-outline::before {\n  content: \"\\F0F56\";\n}\n\n.mdi-kettle-steam::before {\n  content: \"\\F1319\";\n}\n\n.mdi-kettle-steam-outline::before {\n  content: \"\\F131A\";\n}\n\n.mdi-kettlebell::before {\n  content: \"\\F1300\";\n}\n\n.mdi-key::before {\n  content: \"\\F0306\";\n}\n\n.mdi-key-arrow-right::before {\n  content: \"\\F1312\";\n}\n\n.mdi-key-change::before {\n  content: \"\\F0307\";\n}\n\n.mdi-key-link::before {\n  content: \"\\F119F\";\n}\n\n.mdi-key-minus::before {\n  content: \"\\F0308\";\n}\n\n.mdi-key-outline::before {\n  content: \"\\F0DD6\";\n}\n\n.mdi-key-plus::before {\n  content: \"\\F0309\";\n}\n\n.mdi-key-remove::before {\n  content: \"\\F030A\";\n}\n\n.mdi-key-star::before {\n  content: \"\\F119E\";\n}\n\n.mdi-key-variant::before {\n  content: \"\\F030B\";\n}\n\n.mdi-key-wireless::before {\n  content: \"\\F0FC2\";\n}\n\n.mdi-keyboard::before {\n  content: \"\\F030C\";\n}\n\n.mdi-keyboard-backspace::before {\n  content: \"\\F030D\";\n}\n\n.mdi-keyboard-caps::before {\n  content: \"\\F030E\";\n}\n\n.mdi-keyboard-close::before {\n  content: \"\\F030F\";\n}\n\n.mdi-keyboard-esc::before {\n  content: \"\\F12B7\";\n}\n\n.mdi-keyboard-f1::before {\n  content: \"\\F12AB\";\n}\n\n.mdi-keyboard-f10::before {\n  content: \"\\F12B4\";\n}\n\n.mdi-keyboard-f11::before {\n  content: \"\\F12B5\";\n}\n\n.mdi-keyboard-f12::before {\n  content: \"\\F12B6\";\n}\n\n.mdi-keyboard-f2::before {\n  content: \"\\F12AC\";\n}\n\n.mdi-keyboard-f3::before {\n  content: \"\\F12AD\";\n}\n\n.mdi-keyboard-f4::before {\n  content: \"\\F12AE\";\n}\n\n.mdi-keyboard-f5::before {\n  content: \"\\F12AF\";\n}\n\n.mdi-keyboard-f6::before {\n  content: \"\\F12B0\";\n}\n\n.mdi-keyboard-f7::before {\n  content: \"\\F12B1\";\n}\n\n.mdi-keyboard-f8::before {\n  content: \"\\F12B2\";\n}\n\n.mdi-keyboard-f9::before {\n  content: \"\\F12B3\";\n}\n\n.mdi-keyboard-off::before {\n  content: \"\\F0310\";\n}\n\n.mdi-keyboard-off-outline::before {\n  content: \"\\F0E4B\";\n}\n\n.mdi-keyboard-outline::before {\n  content: \"\\F097B\";\n}\n\n.mdi-keyboard-return::before {\n  content: \"\\F0311\";\n}\n\n.mdi-keyboard-settings::before {\n  content: \"\\F09F9\";\n}\n\n.mdi-keyboard-settings-outline::before {\n  content: \"\\F09FA\";\n}\n\n.mdi-keyboard-space::before {\n  content: \"\\F1050\";\n}\n\n.mdi-keyboard-tab::before {\n  content: \"\\F0312\";\n}\n\n.mdi-keyboard-variant::before {\n  content: \"\\F0313\";\n}\n\n.mdi-khanda::before {\n  content: \"\\F10FD\";\n}\n\n.mdi-kickstarter::before {\n  content: \"\\F0745\";\n}\n\n.mdi-klingon::before {\n  content: \"\\F135B\";\n}\n\n.mdi-knife::before {\n  content: \"\\F09FB\";\n}\n\n.mdi-knife-military::before {\n  content: \"\\F09FC\";\n}\n\n.mdi-kodi::before {\n  content: \"\\F0314\";\n}\n\n.mdi-kubernetes::before {\n  content: \"\\F10FE\";\n}\n\n.mdi-label::before {\n  content: \"\\F0315\";\n}\n\n.mdi-label-multiple::before {\n  content: \"\\F1375\";\n}\n\n.mdi-label-multiple-outline::before {\n  content: \"\\F1376\";\n}\n\n.mdi-label-off::before {\n  content: \"\\F0ACB\";\n}\n\n.mdi-label-off-outline::before {\n  content: \"\\F0ACC\";\n}\n\n.mdi-label-outline::before {\n  content: \"\\F0316\";\n}\n\n.mdi-label-percent::before {\n  content: \"\\F12EA\";\n}\n\n.mdi-label-percent-outline::before {\n  content: \"\\F12EB\";\n}\n\n.mdi-label-variant::before {\n  content: \"\\F0ACD\";\n}\n\n.mdi-label-variant-outline::before {\n  content: \"\\F0ACE\";\n}\n\n.mdi-ladybug::before {\n  content: \"\\F082D\";\n}\n\n.mdi-lambda::before {\n  content: \"\\F0627\";\n}\n\n.mdi-lamp::before {\n  content: \"\\F06B5\";\n}\n\n.mdi-lan::before {\n  content: \"\\F0317\";\n}\n\n.mdi-lan-check::before {\n  content: \"\\F12AA\";\n}\n\n.mdi-lan-connect::before {\n  content: \"\\F0318\";\n}\n\n.mdi-lan-disconnect::before {\n  content: \"\\F0319\";\n}\n\n.mdi-lan-pending::before {\n  content: \"\\F031A\";\n}\n\n.mdi-language-c::before {\n  content: \"\\F0671\";\n}\n\n.mdi-language-cpp::before {\n  content: \"\\F0672\";\n}\n\n.mdi-language-csharp::before {\n  content: \"\\F031B\";\n}\n\n.mdi-language-css3::before {\n  content: \"\\F031C\";\n}\n\n.mdi-language-fortran::before {\n  content: \"\\F121A\";\n}\n\n.mdi-language-go::before {\n  content: \"\\F07D3\";\n}\n\n.mdi-language-haskell::before {\n  content: \"\\F0C92\";\n}\n\n.mdi-language-html5::before {\n  content: \"\\F031D\";\n}\n\n.mdi-language-java::before {\n  content: \"\\F0B37\";\n}\n\n.mdi-language-javascript::before {\n  content: \"\\F031E\";\n}\n\n.mdi-language-kotlin::before {\n  content: \"\\F1219\";\n}\n\n.mdi-language-lua::before {\n  content: \"\\F08B1\";\n}\n\n.mdi-language-markdown::before {\n  content: \"\\F0354\";\n}\n\n.mdi-language-markdown-outline::before {\n  content: \"\\F0F5B\";\n}\n\n.mdi-language-php::before {\n  content: \"\\F031F\";\n}\n\n.mdi-language-python::before {\n  content: \"\\F0320\";\n}\n\n.mdi-language-r::before {\n  content: \"\\F07D4\";\n}\n\n.mdi-language-ruby::before {\n  content: \"\\F0D2D\";\n}\n\n.mdi-language-ruby-on-rails::before {\n  content: \"\\F0ACF\";\n}\n\n.mdi-language-swift::before {\n  content: \"\\F06E5\";\n}\n\n.mdi-language-typescript::before {\n  content: \"\\F06E6\";\n}\n\n.mdi-language-xaml::before {\n  content: \"\\F0673\";\n}\n\n.mdi-laptop::before {\n  content: \"\\F0322\";\n}\n\n.mdi-laptop-chromebook::before {\n  content: \"\\F0323\";\n}\n\n.mdi-laptop-mac::before {\n  content: \"\\F0324\";\n}\n\n.mdi-laptop-off::before {\n  content: \"\\F06E7\";\n}\n\n.mdi-laptop-windows::before {\n  content: \"\\F0325\";\n}\n\n.mdi-laravel::before {\n  content: \"\\F0AD0\";\n}\n\n.mdi-lasso::before {\n  content: \"\\F0F03\";\n}\n\n.mdi-lastpass::before {\n  content: \"\\F0446\";\n}\n\n.mdi-latitude::before {\n  content: \"\\F0F57\";\n}\n\n.mdi-launch::before {\n  content: \"\\F0327\";\n}\n\n.mdi-lava-lamp::before {\n  content: \"\\F07D5\";\n}\n\n.mdi-layers::before {\n  content: \"\\F0328\";\n}\n\n.mdi-layers-minus::before {\n  content: \"\\F0E4C\";\n}\n\n.mdi-layers-off::before {\n  content: \"\\F0329\";\n}\n\n.mdi-layers-off-outline::before {\n  content: \"\\F09FD\";\n}\n\n.mdi-layers-outline::before {\n  content: \"\\F09FE\";\n}\n\n.mdi-layers-plus::before {\n  content: \"\\F0E4D\";\n}\n\n.mdi-layers-remove::before {\n  content: \"\\F0E4E\";\n}\n\n.mdi-layers-search::before {\n  content: \"\\F1206\";\n}\n\n.mdi-layers-search-outline::before {\n  content: \"\\F1207\";\n}\n\n.mdi-layers-triple::before {\n  content: \"\\F0F58\";\n}\n\n.mdi-layers-triple-outline::before {\n  content: \"\\F0F59\";\n}\n\n.mdi-lead-pencil::before {\n  content: \"\\F064F\";\n}\n\n.mdi-leaf::before {\n  content: \"\\F032A\";\n}\n\n.mdi-leaf-maple::before {\n  content: \"\\F0C93\";\n}\n\n.mdi-leaf-maple-off::before {\n  content: \"\\F12DA\";\n}\n\n.mdi-leaf-off::before {\n  content: \"\\F12D9\";\n}\n\n.mdi-leak::before {\n  content: \"\\F0DD7\";\n}\n\n.mdi-leak-off::before {\n  content: \"\\F0DD8\";\n}\n\n.mdi-led-off::before {\n  content: \"\\F032B\";\n}\n\n.mdi-led-on::before {\n  content: \"\\F032C\";\n}\n\n.mdi-led-outline::before {\n  content: \"\\F032D\";\n}\n\n.mdi-led-strip::before {\n  content: \"\\F07D6\";\n}\n\n.mdi-led-strip-variant::before {\n  content: \"\\F1051\";\n}\n\n.mdi-led-variant-off::before {\n  content: \"\\F032E\";\n}\n\n.mdi-led-variant-on::before {\n  content: \"\\F032F\";\n}\n\n.mdi-led-variant-outline::before {\n  content: \"\\F0330\";\n}\n\n.mdi-leek::before {\n  content: \"\\F117D\";\n}\n\n.mdi-less-than::before {\n  content: \"\\F097C\";\n}\n\n.mdi-less-than-or-equal::before {\n  content: \"\\F097D\";\n}\n\n.mdi-library::before {\n  content: \"\\F0331\";\n}\n\n.mdi-library-shelves::before {\n  content: \"\\F0BA9\";\n}\n\n.mdi-license::before {\n  content: \"\\F0FC3\";\n}\n\n.mdi-lifebuoy::before {\n  content: \"\\F087E\";\n}\n\n.mdi-light-switch::before {\n  content: \"\\F097E\";\n}\n\n.mdi-lightbulb::before {\n  content: \"\\F0335\";\n}\n\n.mdi-lightbulb-cfl::before {\n  content: \"\\F1208\";\n}\n\n.mdi-lightbulb-cfl-off::before {\n  content: \"\\F1209\";\n}\n\n.mdi-lightbulb-cfl-spiral::before {\n  content: \"\\F1275\";\n}\n\n.mdi-lightbulb-cfl-spiral-off::before {\n  content: \"\\F12C3\";\n}\n\n.mdi-lightbulb-group::before {\n  content: \"\\F1253\";\n}\n\n.mdi-lightbulb-group-off::before {\n  content: \"\\F12CD\";\n}\n\n.mdi-lightbulb-group-off-outline::before {\n  content: \"\\F12CE\";\n}\n\n.mdi-lightbulb-group-outline::before {\n  content: \"\\F1254\";\n}\n\n.mdi-lightbulb-multiple::before {\n  content: \"\\F1255\";\n}\n\n.mdi-lightbulb-multiple-off::before {\n  content: \"\\F12CF\";\n}\n\n.mdi-lightbulb-multiple-off-outline::before {\n  content: \"\\F12D0\";\n}\n\n.mdi-lightbulb-multiple-outline::before {\n  content: \"\\F1256\";\n}\n\n.mdi-lightbulb-off::before {\n  content: \"\\F0E4F\";\n}\n\n.mdi-lightbulb-off-outline::before {\n  content: \"\\F0E50\";\n}\n\n.mdi-lightbulb-on::before {\n  content: \"\\F06E8\";\n}\n\n.mdi-lightbulb-on-outline::before {\n  content: \"\\F06E9\";\n}\n\n.mdi-lightbulb-outline::before {\n  content: \"\\F0336\";\n}\n\n.mdi-lighthouse::before {\n  content: \"\\F09FF\";\n}\n\n.mdi-lighthouse-on::before {\n  content: \"\\F0A00\";\n}\n\n.mdi-link::before {\n  content: \"\\F0337\";\n}\n\n.mdi-link-box::before {\n  content: \"\\F0D1A\";\n}\n\n.mdi-link-box-outline::before {\n  content: \"\\F0D1B\";\n}\n\n.mdi-link-box-variant::before {\n  content: \"\\F0D1C\";\n}\n\n.mdi-link-box-variant-outline::before {\n  content: \"\\F0D1D\";\n}\n\n.mdi-link-lock::before {\n  content: \"\\F10BA\";\n}\n\n.mdi-link-off::before {\n  content: \"\\F0338\";\n}\n\n.mdi-link-plus::before {\n  content: \"\\F0C94\";\n}\n\n.mdi-link-variant::before {\n  content: \"\\F0339\";\n}\n\n.mdi-link-variant-minus::before {\n  content: \"\\F10FF\";\n}\n\n.mdi-link-variant-off::before {\n  content: \"\\F033A\";\n}\n\n.mdi-link-variant-plus::before {\n  content: \"\\F1100\";\n}\n\n.mdi-link-variant-remove::before {\n  content: \"\\F1101\";\n}\n\n.mdi-linkedin::before {\n  content: \"\\F033B\";\n}\n\n.mdi-linux::before {\n  content: \"\\F033D\";\n}\n\n.mdi-linux-mint::before {\n  content: \"\\F08ED\";\n}\n\n.mdi-lipstick::before {\n  content: \"\\F13B5\";\n}\n\n.mdi-litecoin::before {\n  content: \"\\F0A61\";\n}\n\n.mdi-loading::before {\n  content: \"\\F0772\";\n}\n\n.mdi-location-enter::before {\n  content: \"\\F0FC4\";\n}\n\n.mdi-location-exit::before {\n  content: \"\\F0FC5\";\n}\n\n.mdi-lock::before {\n  content: \"\\F033E\";\n}\n\n.mdi-lock-alert::before {\n  content: \"\\F08EE\";\n}\n\n.mdi-lock-check::before {\n  content: \"\\F139A\";\n}\n\n.mdi-lock-clock::before {\n  content: \"\\F097F\";\n}\n\n.mdi-lock-open::before {\n  content: \"\\F033F\";\n}\n\n.mdi-lock-open-alert::before {\n  content: \"\\F139B\";\n}\n\n.mdi-lock-open-check::before {\n  content: \"\\F139C\";\n}\n\n.mdi-lock-open-outline::before {\n  content: \"\\F0340\";\n}\n\n.mdi-lock-open-variant::before {\n  content: \"\\F0FC6\";\n}\n\n.mdi-lock-open-variant-outline::before {\n  content: \"\\F0FC7\";\n}\n\n.mdi-lock-outline::before {\n  content: \"\\F0341\";\n}\n\n.mdi-lock-pattern::before {\n  content: \"\\F06EA\";\n}\n\n.mdi-lock-plus::before {\n  content: \"\\F05FB\";\n}\n\n.mdi-lock-question::before {\n  content: \"\\F08EF\";\n}\n\n.mdi-lock-reset::before {\n  content: \"\\F0773\";\n}\n\n.mdi-lock-smart::before {\n  content: \"\\F08B2\";\n}\n\n.mdi-locker::before {\n  content: \"\\F07D7\";\n}\n\n.mdi-locker-multiple::before {\n  content: \"\\F07D8\";\n}\n\n.mdi-login::before {\n  content: \"\\F0342\";\n}\n\n.mdi-login-variant::before {\n  content: \"\\F05FC\";\n}\n\n.mdi-logout::before {\n  content: \"\\F0343\";\n}\n\n.mdi-logout-variant::before {\n  content: \"\\F05FD\";\n}\n\n.mdi-longitude::before {\n  content: \"\\F0F5A\";\n}\n\n.mdi-looks::before {\n  content: \"\\F0344\";\n}\n\n.mdi-loupe::before {\n  content: \"\\F0345\";\n}\n\n.mdi-lumx::before {\n  content: \"\\F0346\";\n}\n\n.mdi-lungs::before {\n  content: \"\\F1084\";\n}\n\n.mdi-magnet::before {\n  content: \"\\F0347\";\n}\n\n.mdi-magnet-on::before {\n  content: \"\\F0348\";\n}\n\n.mdi-magnify::before {\n  content: \"\\F0349\";\n}\n\n.mdi-magnify-close::before {\n  content: \"\\F0980\";\n}\n\n.mdi-magnify-minus::before {\n  content: \"\\F034A\";\n}\n\n.mdi-magnify-minus-cursor::before {\n  content: \"\\F0A62\";\n}\n\n.mdi-magnify-minus-outline::before {\n  content: \"\\F06EC\";\n}\n\n.mdi-magnify-plus::before {\n  content: \"\\F034B\";\n}\n\n.mdi-magnify-plus-cursor::before {\n  content: \"\\F0A63\";\n}\n\n.mdi-magnify-plus-outline::before {\n  content: \"\\F06ED\";\n}\n\n.mdi-magnify-remove-cursor::before {\n  content: \"\\F120C\";\n}\n\n.mdi-magnify-remove-outline::before {\n  content: \"\\F120D\";\n}\n\n.mdi-magnify-scan::before {\n  content: \"\\F1276\";\n}\n\n.mdi-mail::before {\n  content: \"\\F0EBB\";\n}\n\n.mdi-mailbox::before {\n  content: \"\\F06EE\";\n}\n\n.mdi-mailbox-open::before {\n  content: \"\\F0D88\";\n}\n\n.mdi-mailbox-open-outline::before {\n  content: \"\\F0D89\";\n}\n\n.mdi-mailbox-open-up::before {\n  content: \"\\F0D8A\";\n}\n\n.mdi-mailbox-open-up-outline::before {\n  content: \"\\F0D8B\";\n}\n\n.mdi-mailbox-outline::before {\n  content: \"\\F0D8C\";\n}\n\n.mdi-mailbox-up::before {\n  content: \"\\F0D8D\";\n}\n\n.mdi-mailbox-up-outline::before {\n  content: \"\\F0D8E\";\n}\n\n.mdi-map::before {\n  content: \"\\F034D\";\n}\n\n.mdi-map-check::before {\n  content: \"\\F0EBC\";\n}\n\n.mdi-map-check-outline::before {\n  content: \"\\F0EBD\";\n}\n\n.mdi-map-clock::before {\n  content: \"\\F0D1E\";\n}\n\n.mdi-map-clock-outline::before {\n  content: \"\\F0D1F\";\n}\n\n.mdi-map-legend::before {\n  content: \"\\F0A01\";\n}\n\n.mdi-map-marker::before {\n  content: \"\\F034E\";\n}\n\n.mdi-map-marker-alert::before {\n  content: \"\\F0F05\";\n}\n\n.mdi-map-marker-alert-outline::before {\n  content: \"\\F0F06\";\n}\n\n.mdi-map-marker-check::before {\n  content: \"\\F0C95\";\n}\n\n.mdi-map-marker-check-outline::before {\n  content: \"\\F12FB\";\n}\n\n.mdi-map-marker-circle::before {\n  content: \"\\F034F\";\n}\n\n.mdi-map-marker-distance::before {\n  content: \"\\F08F0\";\n}\n\n.mdi-map-marker-down::before {\n  content: \"\\F1102\";\n}\n\n.mdi-map-marker-left::before {\n  content: \"\\F12DB\";\n}\n\n.mdi-map-marker-left-outline::before {\n  content: \"\\F12DD\";\n}\n\n.mdi-map-marker-minus::before {\n  content: \"\\F0650\";\n}\n\n.mdi-map-marker-minus-outline::before {\n  content: \"\\F12F9\";\n}\n\n.mdi-map-marker-multiple::before {\n  content: \"\\F0350\";\n}\n\n.mdi-map-marker-multiple-outline::before {\n  content: \"\\F1277\";\n}\n\n.mdi-map-marker-off::before {\n  content: \"\\F0351\";\n}\n\n.mdi-map-marker-off-outline::before {\n  content: \"\\F12FD\";\n}\n\n.mdi-map-marker-outline::before {\n  content: \"\\F07D9\";\n}\n\n.mdi-map-marker-path::before {\n  content: \"\\F0D20\";\n}\n\n.mdi-map-marker-plus::before {\n  content: \"\\F0651\";\n}\n\n.mdi-map-marker-plus-outline::before {\n  content: \"\\F12F8\";\n}\n\n.mdi-map-marker-question::before {\n  content: \"\\F0F07\";\n}\n\n.mdi-map-marker-question-outline::before {\n  content: \"\\F0F08\";\n}\n\n.mdi-map-marker-radius::before {\n  content: \"\\F0352\";\n}\n\n.mdi-map-marker-radius-outline::before {\n  content: \"\\F12FC\";\n}\n\n.mdi-map-marker-remove::before {\n  content: \"\\F0F09\";\n}\n\n.mdi-map-marker-remove-outline::before {\n  content: \"\\F12FA\";\n}\n\n.mdi-map-marker-remove-variant::before {\n  content: \"\\F0F0A\";\n}\n\n.mdi-map-marker-right::before {\n  content: \"\\F12DC\";\n}\n\n.mdi-map-marker-right-outline::before {\n  content: \"\\F12DE\";\n}\n\n.mdi-map-marker-up::before {\n  content: \"\\F1103\";\n}\n\n.mdi-map-minus::before {\n  content: \"\\F0981\";\n}\n\n.mdi-map-outline::before {\n  content: \"\\F0982\";\n}\n\n.mdi-map-plus::before {\n  content: \"\\F0983\";\n}\n\n.mdi-map-search::before {\n  content: \"\\F0984\";\n}\n\n.mdi-map-search-outline::before {\n  content: \"\\F0985\";\n}\n\n.mdi-mapbox::before {\n  content: \"\\F0BAA\";\n}\n\n.mdi-margin::before {\n  content: \"\\F0353\";\n}\n\n.mdi-marker::before {\n  content: \"\\F0652\";\n}\n\n.mdi-marker-cancel::before {\n  content: \"\\F0DD9\";\n}\n\n.mdi-marker-check::before {\n  content: \"\\F0355\";\n}\n\n.mdi-mastodon::before {\n  content: \"\\F0AD1\";\n}\n\n.mdi-material-design::before {\n  content: \"\\F0986\";\n}\n\n.mdi-material-ui::before {\n  content: \"\\F0357\";\n}\n\n.mdi-math-compass::before {\n  content: \"\\F0358\";\n}\n\n.mdi-math-cos::before {\n  content: \"\\F0C96\";\n}\n\n.mdi-math-integral::before {\n  content: \"\\F0FC8\";\n}\n\n.mdi-math-integral-box::before {\n  content: \"\\F0FC9\";\n}\n\n.mdi-math-log::before {\n  content: \"\\F1085\";\n}\n\n.mdi-math-norm::before {\n  content: \"\\F0FCA\";\n}\n\n.mdi-math-norm-box::before {\n  content: \"\\F0FCB\";\n}\n\n.mdi-math-sin::before {\n  content: \"\\F0C97\";\n}\n\n.mdi-math-tan::before {\n  content: \"\\F0C98\";\n}\n\n.mdi-matrix::before {\n  content: \"\\F0628\";\n}\n\n.mdi-medal::before {\n  content: \"\\F0987\";\n}\n\n.mdi-medal-outline::before {\n  content: \"\\F1326\";\n}\n\n.mdi-medical-bag::before {\n  content: \"\\F06EF\";\n}\n\n.mdi-meditation::before {\n  content: \"\\F117B\";\n}\n\n.mdi-memory::before {\n  content: \"\\F035B\";\n}\n\n.mdi-menu::before {\n  content: \"\\F035C\";\n}\n\n.mdi-menu-down::before {\n  content: \"\\F035D\";\n}\n\n.mdi-menu-down-outline::before {\n  content: \"\\F06B6\";\n}\n\n.mdi-menu-left::before {\n  content: \"\\F035E\";\n}\n\n.mdi-menu-left-outline::before {\n  content: \"\\F0A02\";\n}\n\n.mdi-menu-open::before {\n  content: \"\\F0BAB\";\n}\n\n.mdi-menu-right::before {\n  content: \"\\F035F\";\n}\n\n.mdi-menu-right-outline::before {\n  content: \"\\F0A03\";\n}\n\n.mdi-menu-swap::before {\n  content: \"\\F0A64\";\n}\n\n.mdi-menu-swap-outline::before {\n  content: \"\\F0A65\";\n}\n\n.mdi-menu-up::before {\n  content: \"\\F0360\";\n}\n\n.mdi-menu-up-outline::before {\n  content: \"\\F06B7\";\n}\n\n.mdi-merge::before {\n  content: \"\\F0F5C\";\n}\n\n.mdi-message::before {\n  content: \"\\F0361\";\n}\n\n.mdi-message-alert::before {\n  content: \"\\F0362\";\n}\n\n.mdi-message-alert-outline::before {\n  content: \"\\F0A04\";\n}\n\n.mdi-message-arrow-left::before {\n  content: \"\\F12F2\";\n}\n\n.mdi-message-arrow-left-outline::before {\n  content: \"\\F12F3\";\n}\n\n.mdi-message-arrow-right::before {\n  content: \"\\F12F4\";\n}\n\n.mdi-message-arrow-right-outline::before {\n  content: \"\\F12F5\";\n}\n\n.mdi-message-bulleted::before {\n  content: \"\\F06A2\";\n}\n\n.mdi-message-bulleted-off::before {\n  content: \"\\F06A3\";\n}\n\n.mdi-message-cog::before {\n  content: \"\\F06F1\";\n}\n\n.mdi-message-cog-outline::before {\n  content: \"\\F1172\";\n}\n\n.mdi-message-draw::before {\n  content: \"\\F0363\";\n}\n\n.mdi-message-image::before {\n  content: \"\\F0364\";\n}\n\n.mdi-message-image-outline::before {\n  content: \"\\F116C\";\n}\n\n.mdi-message-lock::before {\n  content: \"\\F0FCC\";\n}\n\n.mdi-message-lock-outline::before {\n  content: \"\\F116D\";\n}\n\n.mdi-message-minus::before {\n  content: \"\\F116E\";\n}\n\n.mdi-message-minus-outline::before {\n  content: \"\\F116F\";\n}\n\n.mdi-message-outline::before {\n  content: \"\\F0365\";\n}\n\n.mdi-message-plus::before {\n  content: \"\\F0653\";\n}\n\n.mdi-message-plus-outline::before {\n  content: \"\\F10BB\";\n}\n\n.mdi-message-processing::before {\n  content: \"\\F0366\";\n}\n\n.mdi-message-processing-outline::before {\n  content: \"\\F1170\";\n}\n\n.mdi-message-reply::before {\n  content: \"\\F0367\";\n}\n\n.mdi-message-reply-text::before {\n  content: \"\\F0368\";\n}\n\n.mdi-message-settings::before {\n  content: \"\\F06F0\";\n}\n\n.mdi-message-settings-outline::before {\n  content: \"\\F1171\";\n}\n\n.mdi-message-text::before {\n  content: \"\\F0369\";\n}\n\n.mdi-message-text-clock::before {\n  content: \"\\F1173\";\n}\n\n.mdi-message-text-clock-outline::before {\n  content: \"\\F1174\";\n}\n\n.mdi-message-text-lock::before {\n  content: \"\\F0FCD\";\n}\n\n.mdi-message-text-lock-outline::before {\n  content: \"\\F1175\";\n}\n\n.mdi-message-text-outline::before {\n  content: \"\\F036A\";\n}\n\n.mdi-message-video::before {\n  content: \"\\F036B\";\n}\n\n.mdi-meteor::before {\n  content: \"\\F0629\";\n}\n\n.mdi-metronome::before {\n  content: \"\\F07DA\";\n}\n\n.mdi-metronome-tick::before {\n  content: \"\\F07DB\";\n}\n\n.mdi-micro-sd::before {\n  content: \"\\F07DC\";\n}\n\n.mdi-microphone::before {\n  content: \"\\F036C\";\n}\n\n.mdi-microphone-minus::before {\n  content: \"\\F08B3\";\n}\n\n.mdi-microphone-off::before {\n  content: \"\\F036D\";\n}\n\n.mdi-microphone-outline::before {\n  content: \"\\F036E\";\n}\n\n.mdi-microphone-plus::before {\n  content: \"\\F08B4\";\n}\n\n.mdi-microphone-settings::before {\n  content: \"\\F036F\";\n}\n\n.mdi-microphone-variant::before {\n  content: \"\\F0370\";\n}\n\n.mdi-microphone-variant-off::before {\n  content: \"\\F0371\";\n}\n\n.mdi-microscope::before {\n  content: \"\\F0654\";\n}\n\n.mdi-microsoft::before {\n  content: \"\\F0372\";\n}\n\n.mdi-microsoft-access::before {\n  content: \"\\F138E\";\n}\n\n.mdi-microsoft-azure::before {\n  content: \"\\F0805\";\n}\n\n.mdi-microsoft-azure-devops::before {\n  content: \"\\F0FD5\";\n}\n\n.mdi-microsoft-bing::before {\n  content: \"\\F00A4\";\n}\n\n.mdi-microsoft-dynamics-365::before {\n  content: \"\\F0988\";\n}\n\n.mdi-microsoft-edge::before {\n  content: \"\\F01E9\";\n}\n\n.mdi-microsoft-edge-legacy::before {\n  content: \"\\F1250\";\n}\n\n.mdi-microsoft-excel::before {\n  content: \"\\F138F\";\n}\n\n.mdi-microsoft-internet-explorer::before {\n  content: \"\\F0300\";\n}\n\n.mdi-microsoft-office::before {\n  content: \"\\F03C6\";\n}\n\n.mdi-microsoft-onedrive::before {\n  content: \"\\F03CA\";\n}\n\n.mdi-microsoft-onenote::before {\n  content: \"\\F0747\";\n}\n\n.mdi-microsoft-outlook::before {\n  content: \"\\F0D22\";\n}\n\n.mdi-microsoft-powerpoint::before {\n  content: \"\\F1390\";\n}\n\n.mdi-microsoft-sharepoint::before {\n  content: \"\\F1391\";\n}\n\n.mdi-microsoft-teams::before {\n  content: \"\\F02BB\";\n}\n\n.mdi-microsoft-visual-studio::before {\n  content: \"\\F0610\";\n}\n\n.mdi-microsoft-visual-studio-code::before {\n  content: \"\\F0A1E\";\n}\n\n.mdi-microsoft-windows::before {\n  content: \"\\F05B3\";\n}\n\n.mdi-microsoft-windows-classic::before {\n  content: \"\\F0A21\";\n}\n\n.mdi-microsoft-word::before {\n  content: \"\\F1392\";\n}\n\n.mdi-microsoft-xbox::before {\n  content: \"\\F05B9\";\n}\n\n.mdi-microsoft-xbox-controller::before {\n  content: \"\\F05BA\";\n}\n\n.mdi-microsoft-xbox-controller-battery-alert::before {\n  content: \"\\F074B\";\n}\n\n.mdi-microsoft-xbox-controller-battery-charging::before {\n  content: \"\\F0A22\";\n}\n\n.mdi-microsoft-xbox-controller-battery-empty::before {\n  content: \"\\F074C\";\n}\n\n.mdi-microsoft-xbox-controller-battery-full::before {\n  content: \"\\F074D\";\n}\n\n.mdi-microsoft-xbox-controller-battery-low::before {\n  content: \"\\F074E\";\n}\n\n.mdi-microsoft-xbox-controller-battery-medium::before {\n  content: \"\\F074F\";\n}\n\n.mdi-microsoft-xbox-controller-battery-unknown::before {\n  content: \"\\F0750\";\n}\n\n.mdi-microsoft-xbox-controller-menu::before {\n  content: \"\\F0E6F\";\n}\n\n.mdi-microsoft-xbox-controller-off::before {\n  content: \"\\F05BB\";\n}\n\n.mdi-microsoft-xbox-controller-view::before {\n  content: \"\\F0E70\";\n}\n\n.mdi-microsoft-yammer::before {\n  content: \"\\F0789\";\n}\n\n.mdi-microwave::before {\n  content: \"\\F0C99\";\n}\n\n.mdi-middleware::before {\n  content: \"\\F0F5D\";\n}\n\n.mdi-middleware-outline::before {\n  content: \"\\F0F5E\";\n}\n\n.mdi-midi::before {\n  content: \"\\F08F1\";\n}\n\n.mdi-midi-port::before {\n  content: \"\\F08F2\";\n}\n\n.mdi-mine::before {\n  content: \"\\F0DDA\";\n}\n\n.mdi-minecraft::before {\n  content: \"\\F0373\";\n}\n\n.mdi-mini-sd::before {\n  content: \"\\F0A05\";\n}\n\n.mdi-minidisc::before {\n  content: \"\\F0A06\";\n}\n\n.mdi-minus::before {\n  content: \"\\F0374\";\n}\n\n.mdi-minus-box::before {\n  content: \"\\F0375\";\n}\n\n.mdi-minus-box-multiple::before {\n  content: \"\\F1141\";\n}\n\n.mdi-minus-box-multiple-outline::before {\n  content: \"\\F1142\";\n}\n\n.mdi-minus-box-outline::before {\n  content: \"\\F06F2\";\n}\n\n.mdi-minus-circle::before {\n  content: \"\\F0376\";\n}\n\n.mdi-minus-circle-multiple::before {\n  content: \"\\F035A\";\n}\n\n.mdi-minus-circle-multiple-outline::before {\n  content: \"\\F0AD3\";\n}\n\n.mdi-minus-circle-outline::before {\n  content: \"\\F0377\";\n}\n\n.mdi-minus-network::before {\n  content: \"\\F0378\";\n}\n\n.mdi-minus-network-outline::before {\n  content: \"\\F0C9A\";\n}\n\n.mdi-mirror::before {\n  content: \"\\F11FD\";\n}\n\n.mdi-mixed-martial-arts::before {\n  content: \"\\F0D8F\";\n}\n\n.mdi-mixed-reality::before {\n  content: \"\\F087F\";\n}\n\n.mdi-mixer::before {\n  content: \"\\F07DD\";\n}\n\n.mdi-molecule::before {\n  content: \"\\F0BAC\";\n}\n\n.mdi-molecule-co::before {\n  content: \"\\F12FE\";\n}\n\n.mdi-molecule-co2::before {\n  content: \"\\F07E4\";\n}\n\n.mdi-monitor::before {\n  content: \"\\F0379\";\n}\n\n.mdi-monitor-cellphone::before {\n  content: \"\\F0989\";\n}\n\n.mdi-monitor-cellphone-star::before {\n  content: \"\\F098A\";\n}\n\n.mdi-monitor-clean::before {\n  content: \"\\F1104\";\n}\n\n.mdi-monitor-dashboard::before {\n  content: \"\\F0A07\";\n}\n\n.mdi-monitor-edit::before {\n  content: \"\\F12C6\";\n}\n\n.mdi-monitor-eye::before {\n  content: \"\\F13B4\";\n}\n\n.mdi-monitor-lock::before {\n  content: \"\\F0DDB\";\n}\n\n.mdi-monitor-multiple::before {\n  content: \"\\F037A\";\n}\n\n.mdi-monitor-off::before {\n  content: \"\\F0D90\";\n}\n\n.mdi-monitor-screenshot::before {\n  content: \"\\F0E51\";\n}\n\n.mdi-monitor-speaker::before {\n  content: \"\\F0F5F\";\n}\n\n.mdi-monitor-speaker-off::before {\n  content: \"\\F0F60\";\n}\n\n.mdi-monitor-star::before {\n  content: \"\\F0DDC\";\n}\n\n.mdi-moon-first-quarter::before {\n  content: \"\\F0F61\";\n}\n\n.mdi-moon-full::before {\n  content: \"\\F0F62\";\n}\n\n.mdi-moon-last-quarter::before {\n  content: \"\\F0F63\";\n}\n\n.mdi-moon-new::before {\n  content: \"\\F0F64\";\n}\n\n.mdi-moon-waning-crescent::before {\n  content: \"\\F0F65\";\n}\n\n.mdi-moon-waning-gibbous::before {\n  content: \"\\F0F66\";\n}\n\n.mdi-moon-waxing-crescent::before {\n  content: \"\\F0F67\";\n}\n\n.mdi-moon-waxing-gibbous::before {\n  content: \"\\F0F68\";\n}\n\n.mdi-moped::before {\n  content: \"\\F1086\";\n}\n\n.mdi-more::before {\n  content: \"\\F037B\";\n}\n\n.mdi-mother-heart::before {\n  content: \"\\F1314\";\n}\n\n.mdi-mother-nurse::before {\n  content: \"\\F0D21\";\n}\n\n.mdi-motion-sensor::before {\n  content: \"\\F0D91\";\n}\n\n.mdi-motorbike::before {\n  content: \"\\F037C\";\n}\n\n.mdi-mouse::before {\n  content: \"\\F037D\";\n}\n\n.mdi-mouse-bluetooth::before {\n  content: \"\\F098B\";\n}\n\n.mdi-mouse-off::before {\n  content: \"\\F037E\";\n}\n\n.mdi-mouse-variant::before {\n  content: \"\\F037F\";\n}\n\n.mdi-mouse-variant-off::before {\n  content: \"\\F0380\";\n}\n\n.mdi-move-resize::before {\n  content: \"\\F0655\";\n}\n\n.mdi-move-resize-variant::before {\n  content: \"\\F0656\";\n}\n\n.mdi-movie::before {\n  content: \"\\F0381\";\n}\n\n.mdi-movie-edit::before {\n  content: \"\\F1122\";\n}\n\n.mdi-movie-edit-outline::before {\n  content: \"\\F1123\";\n}\n\n.mdi-movie-filter::before {\n  content: \"\\F1124\";\n}\n\n.mdi-movie-filter-outline::before {\n  content: \"\\F1125\";\n}\n\n.mdi-movie-open::before {\n  content: \"\\F0FCE\";\n}\n\n.mdi-movie-open-outline::before {\n  content: \"\\F0FCF\";\n}\n\n.mdi-movie-outline::before {\n  content: \"\\F0DDD\";\n}\n\n.mdi-movie-roll::before {\n  content: \"\\F07DE\";\n}\n\n.mdi-movie-search::before {\n  content: \"\\F11D2\";\n}\n\n.mdi-movie-search-outline::before {\n  content: \"\\F11D3\";\n}\n\n.mdi-muffin::before {\n  content: \"\\F098C\";\n}\n\n.mdi-multiplication::before {\n  content: \"\\F0382\";\n}\n\n.mdi-multiplication-box::before {\n  content: \"\\F0383\";\n}\n\n.mdi-mushroom::before {\n  content: \"\\F07DF\";\n}\n\n.mdi-mushroom-outline::before {\n  content: \"\\F07E0\";\n}\n\n.mdi-music::before {\n  content: \"\\F075A\";\n}\n\n.mdi-music-accidental-double-flat::before {\n  content: \"\\F0F69\";\n}\n\n.mdi-music-accidental-double-sharp::before {\n  content: \"\\F0F6A\";\n}\n\n.mdi-music-accidental-flat::before {\n  content: \"\\F0F6B\";\n}\n\n.mdi-music-accidental-natural::before {\n  content: \"\\F0F6C\";\n}\n\n.mdi-music-accidental-sharp::before {\n  content: \"\\F0F6D\";\n}\n\n.mdi-music-box::before {\n  content: \"\\F0384\";\n}\n\n.mdi-music-box-multiple::before {\n  content: \"\\F0333\";\n}\n\n.mdi-music-box-multiple-outline::before {\n  content: \"\\F0F04\";\n}\n\n.mdi-music-box-outline::before {\n  content: \"\\F0385\";\n}\n\n.mdi-music-circle::before {\n  content: \"\\F0386\";\n}\n\n.mdi-music-circle-outline::before {\n  content: \"\\F0AD4\";\n}\n\n.mdi-music-clef-alto::before {\n  content: \"\\F0F6E\";\n}\n\n.mdi-music-clef-bass::before {\n  content: \"\\F0F6F\";\n}\n\n.mdi-music-clef-treble::before {\n  content: \"\\F0F70\";\n}\n\n.mdi-music-note::before {\n  content: \"\\F0387\";\n}\n\n.mdi-music-note-bluetooth::before {\n  content: \"\\F05FE\";\n}\n\n.mdi-music-note-bluetooth-off::before {\n  content: \"\\F05FF\";\n}\n\n.mdi-music-note-eighth::before {\n  content: \"\\F0388\";\n}\n\n.mdi-music-note-eighth-dotted::before {\n  content: \"\\F0F71\";\n}\n\n.mdi-music-note-half::before {\n  content: \"\\F0389\";\n}\n\n.mdi-music-note-half-dotted::before {\n  content: \"\\F0F72\";\n}\n\n.mdi-music-note-off::before {\n  content: \"\\F038A\";\n}\n\n.mdi-music-note-off-outline::before {\n  content: \"\\F0F73\";\n}\n\n.mdi-music-note-outline::before {\n  content: \"\\F0F74\";\n}\n\n.mdi-music-note-plus::before {\n  content: \"\\F0DDE\";\n}\n\n.mdi-music-note-quarter::before {\n  content: \"\\F038B\";\n}\n\n.mdi-music-note-quarter-dotted::before {\n  content: \"\\F0F75\";\n}\n\n.mdi-music-note-sixteenth::before {\n  content: \"\\F038C\";\n}\n\n.mdi-music-note-sixteenth-dotted::before {\n  content: \"\\F0F76\";\n}\n\n.mdi-music-note-whole::before {\n  content: \"\\F038D\";\n}\n\n.mdi-music-note-whole-dotted::before {\n  content: \"\\F0F77\";\n}\n\n.mdi-music-off::before {\n  content: \"\\F075B\";\n}\n\n.mdi-music-rest-eighth::before {\n  content: \"\\F0F78\";\n}\n\n.mdi-music-rest-half::before {\n  content: \"\\F0F79\";\n}\n\n.mdi-music-rest-quarter::before {\n  content: \"\\F0F7A\";\n}\n\n.mdi-music-rest-sixteenth::before {\n  content: \"\\F0F7B\";\n}\n\n.mdi-music-rest-whole::before {\n  content: \"\\F0F7C\";\n}\n\n.mdi-nail::before {\n  content: \"\\F0DDF\";\n}\n\n.mdi-nas::before {\n  content: \"\\F08F3\";\n}\n\n.mdi-nativescript::before {\n  content: \"\\F0880\";\n}\n\n.mdi-nature::before {\n  content: \"\\F038E\";\n}\n\n.mdi-nature-people::before {\n  content: \"\\F038F\";\n}\n\n.mdi-navigation::before {\n  content: \"\\F0390\";\n}\n\n.mdi-near-me::before {\n  content: \"\\F05CD\";\n}\n\n.mdi-necklace::before {\n  content: \"\\F0F0B\";\n}\n\n.mdi-needle::before {\n  content: \"\\F0391\";\n}\n\n.mdi-netflix::before {\n  content: \"\\F0746\";\n}\n\n.mdi-network::before {\n  content: \"\\F06F3\";\n}\n\n.mdi-network-off::before {\n  content: \"\\F0C9B\";\n}\n\n.mdi-network-off-outline::before {\n  content: \"\\F0C9C\";\n}\n\n.mdi-network-outline::before {\n  content: \"\\F0C9D\";\n}\n\n.mdi-network-strength-1::before {\n  content: \"\\F08F4\";\n}\n\n.mdi-network-strength-1-alert::before {\n  content: \"\\F08F5\";\n}\n\n.mdi-network-strength-2::before {\n  content: \"\\F08F6\";\n}\n\n.mdi-network-strength-2-alert::before {\n  content: \"\\F08F7\";\n}\n\n.mdi-network-strength-3::before {\n  content: \"\\F08F8\";\n}\n\n.mdi-network-strength-3-alert::before {\n  content: \"\\F08F9\";\n}\n\n.mdi-network-strength-4::before {\n  content: \"\\F08FA\";\n}\n\n.mdi-network-strength-4-alert::before {\n  content: \"\\F08FB\";\n}\n\n.mdi-network-strength-off::before {\n  content: \"\\F08FC\";\n}\n\n.mdi-network-strength-off-outline::before {\n  content: \"\\F08FD\";\n}\n\n.mdi-network-strength-outline::before {\n  content: \"\\F08FE\";\n}\n\n.mdi-new-box::before {\n  content: \"\\F0394\";\n}\n\n.mdi-newspaper::before {\n  content: \"\\F0395\";\n}\n\n.mdi-newspaper-minus::before {\n  content: \"\\F0F0C\";\n}\n\n.mdi-newspaper-plus::before {\n  content: \"\\F0F0D\";\n}\n\n.mdi-newspaper-variant::before {\n  content: \"\\F1001\";\n}\n\n.mdi-newspaper-variant-multiple::before {\n  content: \"\\F1002\";\n}\n\n.mdi-newspaper-variant-multiple-outline::before {\n  content: \"\\F1003\";\n}\n\n.mdi-newspaper-variant-outline::before {\n  content: \"\\F1004\";\n}\n\n.mdi-nfc::before {\n  content: \"\\F0396\";\n}\n\n.mdi-nfc-search-variant::before {\n  content: \"\\F0E53\";\n}\n\n.mdi-nfc-tap::before {\n  content: \"\\F0397\";\n}\n\n.mdi-nfc-variant::before {\n  content: \"\\F0398\";\n}\n\n.mdi-nfc-variant-off::before {\n  content: \"\\F0E54\";\n}\n\n.mdi-ninja::before {\n  content: \"\\F0774\";\n}\n\n.mdi-nintendo-game-boy::before {\n  content: \"\\F1393\";\n}\n\n.mdi-nintendo-switch::before {\n  content: \"\\F07E1\";\n}\n\n.mdi-nintendo-wii::before {\n  content: \"\\F05AB\";\n}\n\n.mdi-nintendo-wiiu::before {\n  content: \"\\F072D\";\n}\n\n.mdi-nix::before {\n  content: \"\\F1105\";\n}\n\n.mdi-nodejs::before {\n  content: \"\\F0399\";\n}\n\n.mdi-noodles::before {\n  content: \"\\F117E\";\n}\n\n.mdi-not-equal::before {\n  content: \"\\F098D\";\n}\n\n.mdi-not-equal-variant::before {\n  content: \"\\F098E\";\n}\n\n.mdi-note::before {\n  content: \"\\F039A\";\n}\n\n.mdi-note-multiple::before {\n  content: \"\\F06B8\";\n}\n\n.mdi-note-multiple-outline::before {\n  content: \"\\F06B9\";\n}\n\n.mdi-note-outline::before {\n  content: \"\\F039B\";\n}\n\n.mdi-note-plus::before {\n  content: \"\\F039C\";\n}\n\n.mdi-note-plus-outline::before {\n  content: \"\\F039D\";\n}\n\n.mdi-note-text::before {\n  content: \"\\F039E\";\n}\n\n.mdi-note-text-outline::before {\n  content: \"\\F11D7\";\n}\n\n.mdi-notebook::before {\n  content: \"\\F082E\";\n}\n\n.mdi-notebook-multiple::before {\n  content: \"\\F0E55\";\n}\n\n.mdi-notebook-outline::before {\n  content: \"\\F0EBF\";\n}\n\n.mdi-notification-clear-all::before {\n  content: \"\\F039F\";\n}\n\n.mdi-npm::before {\n  content: \"\\F06F7\";\n}\n\n.mdi-nuke::before {\n  content: \"\\F06A4\";\n}\n\n.mdi-null::before {\n  content: \"\\F07E2\";\n}\n\n.mdi-numeric::before {\n  content: \"\\F03A0\";\n}\n\n.mdi-numeric-0::before {\n  content: \"\\F0B39\";\n}\n\n.mdi-numeric-0-box::before {\n  content: \"\\F03A1\";\n}\n\n.mdi-numeric-0-box-multiple::before {\n  content: \"\\F0F0E\";\n}\n\n.mdi-numeric-0-box-multiple-outline::before {\n  content: \"\\F03A2\";\n}\n\n.mdi-numeric-0-box-outline::before {\n  content: \"\\F03A3\";\n}\n\n.mdi-numeric-0-circle::before {\n  content: \"\\F0C9E\";\n}\n\n.mdi-numeric-0-circle-outline::before {\n  content: \"\\F0C9F\";\n}\n\n.mdi-numeric-1::before {\n  content: \"\\F0B3A\";\n}\n\n.mdi-numeric-1-box::before {\n  content: \"\\F03A4\";\n}\n\n.mdi-numeric-1-box-multiple::before {\n  content: \"\\F0F0F\";\n}\n\n.mdi-numeric-1-box-multiple-outline::before {\n  content: \"\\F03A5\";\n}\n\n.mdi-numeric-1-box-outline::before {\n  content: \"\\F03A6\";\n}\n\n.mdi-numeric-1-circle::before {\n  content: \"\\F0CA0\";\n}\n\n.mdi-numeric-1-circle-outline::before {\n  content: \"\\F0CA1\";\n}\n\n.mdi-numeric-10::before {\n  content: \"\\F0FE9\";\n}\n\n.mdi-numeric-10-box::before {\n  content: \"\\F0F7D\";\n}\n\n.mdi-numeric-10-box-multiple::before {\n  content: \"\\F0FEA\";\n}\n\n.mdi-numeric-10-box-multiple-outline::before {\n  content: \"\\F0FEB\";\n}\n\n.mdi-numeric-10-box-outline::before {\n  content: \"\\F0F7E\";\n}\n\n.mdi-numeric-10-circle::before {\n  content: \"\\F0FEC\";\n}\n\n.mdi-numeric-10-circle-outline::before {\n  content: \"\\F0FED\";\n}\n\n.mdi-numeric-2::before {\n  content: \"\\F0B3B\";\n}\n\n.mdi-numeric-2-box::before {\n  content: \"\\F03A7\";\n}\n\n.mdi-numeric-2-box-multiple::before {\n  content: \"\\F0F10\";\n}\n\n.mdi-numeric-2-box-multiple-outline::before {\n  content: \"\\F03A8\";\n}\n\n.mdi-numeric-2-box-outline::before {\n  content: \"\\F03A9\";\n}\n\n.mdi-numeric-2-circle::before {\n  content: \"\\F0CA2\";\n}\n\n.mdi-numeric-2-circle-outline::before {\n  content: \"\\F0CA3\";\n}\n\n.mdi-numeric-3::before {\n  content: \"\\F0B3C\";\n}\n\n.mdi-numeric-3-box::before {\n  content: \"\\F03AA\";\n}\n\n.mdi-numeric-3-box-multiple::before {\n  content: \"\\F0F11\";\n}\n\n.mdi-numeric-3-box-multiple-outline::before {\n  content: \"\\F03AB\";\n}\n\n.mdi-numeric-3-box-outline::before {\n  content: \"\\F03AC\";\n}\n\n.mdi-numeric-3-circle::before {\n  content: \"\\F0CA4\";\n}\n\n.mdi-numeric-3-circle-outline::before {\n  content: \"\\F0CA5\";\n}\n\n.mdi-numeric-4::before {\n  content: \"\\F0B3D\";\n}\n\n.mdi-numeric-4-box::before {\n  content: \"\\F03AD\";\n}\n\n.mdi-numeric-4-box-multiple::before {\n  content: \"\\F0F12\";\n}\n\n.mdi-numeric-4-box-multiple-outline::before {\n  content: \"\\F03B2\";\n}\n\n.mdi-numeric-4-box-outline::before {\n  content: \"\\F03AE\";\n}\n\n.mdi-numeric-4-circle::before {\n  content: \"\\F0CA6\";\n}\n\n.mdi-numeric-4-circle-outline::before {\n  content: \"\\F0CA7\";\n}\n\n.mdi-numeric-5::before {\n  content: \"\\F0B3E\";\n}\n\n.mdi-numeric-5-box::before {\n  content: \"\\F03B1\";\n}\n\n.mdi-numeric-5-box-multiple::before {\n  content: \"\\F0F13\";\n}\n\n.mdi-numeric-5-box-multiple-outline::before {\n  content: \"\\F03AF\";\n}\n\n.mdi-numeric-5-box-outline::before {\n  content: \"\\F03B0\";\n}\n\n.mdi-numeric-5-circle::before {\n  content: \"\\F0CA8\";\n}\n\n.mdi-numeric-5-circle-outline::before {\n  content: \"\\F0CA9\";\n}\n\n.mdi-numeric-6::before {\n  content: \"\\F0B3F\";\n}\n\n.mdi-numeric-6-box::before {\n  content: \"\\F03B3\";\n}\n\n.mdi-numeric-6-box-multiple::before {\n  content: \"\\F0F14\";\n}\n\n.mdi-numeric-6-box-multiple-outline::before {\n  content: \"\\F03B4\";\n}\n\n.mdi-numeric-6-box-outline::before {\n  content: \"\\F03B5\";\n}\n\n.mdi-numeric-6-circle::before {\n  content: \"\\F0CAA\";\n}\n\n.mdi-numeric-6-circle-outline::before {\n  content: \"\\F0CAB\";\n}\n\n.mdi-numeric-7::before {\n  content: \"\\F0B40\";\n}\n\n.mdi-numeric-7-box::before {\n  content: \"\\F03B6\";\n}\n\n.mdi-numeric-7-box-multiple::before {\n  content: \"\\F0F15\";\n}\n\n.mdi-numeric-7-box-multiple-outline::before {\n  content: \"\\F03B7\";\n}\n\n.mdi-numeric-7-box-outline::before {\n  content: \"\\F03B8\";\n}\n\n.mdi-numeric-7-circle::before {\n  content: \"\\F0CAC\";\n}\n\n.mdi-numeric-7-circle-outline::before {\n  content: \"\\F0CAD\";\n}\n\n.mdi-numeric-8::before {\n  content: \"\\F0B41\";\n}\n\n.mdi-numeric-8-box::before {\n  content: \"\\F03B9\";\n}\n\n.mdi-numeric-8-box-multiple::before {\n  content: \"\\F0F16\";\n}\n\n.mdi-numeric-8-box-multiple-outline::before {\n  content: \"\\F03BA\";\n}\n\n.mdi-numeric-8-box-outline::before {\n  content: \"\\F03BB\";\n}\n\n.mdi-numeric-8-circle::before {\n  content: \"\\F0CAE\";\n}\n\n.mdi-numeric-8-circle-outline::before {\n  content: \"\\F0CAF\";\n}\n\n.mdi-numeric-9::before {\n  content: \"\\F0B42\";\n}\n\n.mdi-numeric-9-box::before {\n  content: \"\\F03BC\";\n}\n\n.mdi-numeric-9-box-multiple::before {\n  content: \"\\F0F17\";\n}\n\n.mdi-numeric-9-box-multiple-outline::before {\n  content: \"\\F03BD\";\n}\n\n.mdi-numeric-9-box-outline::before {\n  content: \"\\F03BE\";\n}\n\n.mdi-numeric-9-circle::before {\n  content: \"\\F0CB0\";\n}\n\n.mdi-numeric-9-circle-outline::before {\n  content: \"\\F0CB1\";\n}\n\n.mdi-numeric-9-plus::before {\n  content: \"\\F0FEE\";\n}\n\n.mdi-numeric-9-plus-box::before {\n  content: \"\\F03BF\";\n}\n\n.mdi-numeric-9-plus-box-multiple::before {\n  content: \"\\F0F18\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline::before {\n  content: \"\\F03C0\";\n}\n\n.mdi-numeric-9-plus-box-outline::before {\n  content: \"\\F03C1\";\n}\n\n.mdi-numeric-9-plus-circle::before {\n  content: \"\\F0CB2\";\n}\n\n.mdi-numeric-9-plus-circle-outline::before {\n  content: \"\\F0CB3\";\n}\n\n.mdi-numeric-negative-1::before {\n  content: \"\\F1052\";\n}\n\n.mdi-nut::before {\n  content: \"\\F06F8\";\n}\n\n.mdi-nutrition::before {\n  content: \"\\F03C2\";\n}\n\n.mdi-nuxt::before {\n  content: \"\\F1106\";\n}\n\n.mdi-oar::before {\n  content: \"\\F067C\";\n}\n\n.mdi-ocarina::before {\n  content: \"\\F0DE0\";\n}\n\n.mdi-oci::before {\n  content: \"\\F12E9\";\n}\n\n.mdi-ocr::before {\n  content: \"\\F113A\";\n}\n\n.mdi-octagon::before {\n  content: \"\\F03C3\";\n}\n\n.mdi-octagon-outline::before {\n  content: \"\\F03C4\";\n}\n\n.mdi-octagram::before {\n  content: \"\\F06F9\";\n}\n\n.mdi-octagram-outline::before {\n  content: \"\\F0775\";\n}\n\n.mdi-odnoklassniki::before {\n  content: \"\\F03C5\";\n}\n\n.mdi-offer::before {\n  content: \"\\F121B\";\n}\n\n.mdi-office-building::before {\n  content: \"\\F0991\";\n}\n\n.mdi-oil::before {\n  content: \"\\F03C7\";\n}\n\n.mdi-oil-lamp::before {\n  content: \"\\F0F19\";\n}\n\n.mdi-oil-level::before {\n  content: \"\\F1053\";\n}\n\n.mdi-oil-temperature::before {\n  content: \"\\F0FF8\";\n}\n\n.mdi-omega::before {\n  content: \"\\F03C9\";\n}\n\n.mdi-one-up::before {\n  content: \"\\F0BAD\";\n}\n\n.mdi-onepassword::before {\n  content: \"\\F0881\";\n}\n\n.mdi-opacity::before {\n  content: \"\\F05CC\";\n}\n\n.mdi-open-in-app::before {\n  content: \"\\F03CB\";\n}\n\n.mdi-open-in-new::before {\n  content: \"\\F03CC\";\n}\n\n.mdi-open-source-initiative::before {\n  content: \"\\F0BAE\";\n}\n\n.mdi-openid::before {\n  content: \"\\F03CD\";\n}\n\n.mdi-opera::before {\n  content: \"\\F03CE\";\n}\n\n.mdi-orbit::before {\n  content: \"\\F0018\";\n}\n\n.mdi-order-alphabetical-ascending::before {\n  content: \"\\F020D\";\n}\n\n.mdi-order-alphabetical-descending::before {\n  content: \"\\F0D07\";\n}\n\n.mdi-order-bool-ascending::before {\n  content: \"\\F02BE\";\n}\n\n.mdi-order-bool-ascending-variant::before {\n  content: \"\\F098F\";\n}\n\n.mdi-order-bool-descending::before {\n  content: \"\\F1384\";\n}\n\n.mdi-order-bool-descending-variant::before {\n  content: \"\\F0990\";\n}\n\n.mdi-order-numeric-ascending::before {\n  content: \"\\F0545\";\n}\n\n.mdi-order-numeric-descending::before {\n  content: \"\\F0546\";\n}\n\n.mdi-origin::before {\n  content: \"\\F0B43\";\n}\n\n.mdi-ornament::before {\n  content: \"\\F03CF\";\n}\n\n.mdi-ornament-variant::before {\n  content: \"\\F03D0\";\n}\n\n.mdi-outdoor-lamp::before {\n  content: \"\\F1054\";\n}\n\n.mdi-overscan::before {\n  content: \"\\F1005\";\n}\n\n.mdi-owl::before {\n  content: \"\\F03D2\";\n}\n\n.mdi-pac-man::before {\n  content: \"\\F0BAF\";\n}\n\n.mdi-package::before {\n  content: \"\\F03D3\";\n}\n\n.mdi-package-down::before {\n  content: \"\\F03D4\";\n}\n\n.mdi-package-up::before {\n  content: \"\\F03D5\";\n}\n\n.mdi-package-variant::before {\n  content: \"\\F03D6\";\n}\n\n.mdi-package-variant-closed::before {\n  content: \"\\F03D7\";\n}\n\n.mdi-page-first::before {\n  content: \"\\F0600\";\n}\n\n.mdi-page-last::before {\n  content: \"\\F0601\";\n}\n\n.mdi-page-layout-body::before {\n  content: \"\\F06FA\";\n}\n\n.mdi-page-layout-footer::before {\n  content: \"\\F06FB\";\n}\n\n.mdi-page-layout-header::before {\n  content: \"\\F06FC\";\n}\n\n.mdi-page-layout-header-footer::before {\n  content: \"\\F0F7F\";\n}\n\n.mdi-page-layout-sidebar-left::before {\n  content: \"\\F06FD\";\n}\n\n.mdi-page-layout-sidebar-right::before {\n  content: \"\\F06FE\";\n}\n\n.mdi-page-next::before {\n  content: \"\\F0BB0\";\n}\n\n.mdi-page-next-outline::before {\n  content: \"\\F0BB1\";\n}\n\n.mdi-page-previous::before {\n  content: \"\\F0BB2\";\n}\n\n.mdi-page-previous-outline::before {\n  content: \"\\F0BB3\";\n}\n\n.mdi-palette::before {\n  content: \"\\F03D8\";\n}\n\n.mdi-palette-advanced::before {\n  content: \"\\F03D9\";\n}\n\n.mdi-palette-outline::before {\n  content: \"\\F0E0C\";\n}\n\n.mdi-palette-swatch::before {\n  content: \"\\F08B5\";\n}\n\n.mdi-palette-swatch-outline::before {\n  content: \"\\F135C\";\n}\n\n.mdi-palm-tree::before {\n  content: \"\\F1055\";\n}\n\n.mdi-pan::before {\n  content: \"\\F0BB4\";\n}\n\n.mdi-pan-bottom-left::before {\n  content: \"\\F0BB5\";\n}\n\n.mdi-pan-bottom-right::before {\n  content: \"\\F0BB6\";\n}\n\n.mdi-pan-down::before {\n  content: \"\\F0BB7\";\n}\n\n.mdi-pan-horizontal::before {\n  content: \"\\F0BB8\";\n}\n\n.mdi-pan-left::before {\n  content: \"\\F0BB9\";\n}\n\n.mdi-pan-right::before {\n  content: \"\\F0BBA\";\n}\n\n.mdi-pan-top-left::before {\n  content: \"\\F0BBB\";\n}\n\n.mdi-pan-top-right::before {\n  content: \"\\F0BBC\";\n}\n\n.mdi-pan-up::before {\n  content: \"\\F0BBD\";\n}\n\n.mdi-pan-vertical::before {\n  content: \"\\F0BBE\";\n}\n\n.mdi-panda::before {\n  content: \"\\F03DA\";\n}\n\n.mdi-pandora::before {\n  content: \"\\F03DB\";\n}\n\n.mdi-panorama::before {\n  content: \"\\F03DC\";\n}\n\n.mdi-panorama-fisheye::before {\n  content: \"\\F03DD\";\n}\n\n.mdi-panorama-horizontal::before {\n  content: \"\\F03DE\";\n}\n\n.mdi-panorama-vertical::before {\n  content: \"\\F03DF\";\n}\n\n.mdi-panorama-wide-angle::before {\n  content: \"\\F03E0\";\n}\n\n.mdi-paper-cut-vertical::before {\n  content: \"\\F03E1\";\n}\n\n.mdi-paper-roll::before {\n  content: \"\\F1157\";\n}\n\n.mdi-paper-roll-outline::before {\n  content: \"\\F1158\";\n}\n\n.mdi-paperclip::before {\n  content: \"\\F03E2\";\n}\n\n.mdi-parachute::before {\n  content: \"\\F0CB4\";\n}\n\n.mdi-parachute-outline::before {\n  content: \"\\F0CB5\";\n}\n\n.mdi-parking::before {\n  content: \"\\F03E3\";\n}\n\n.mdi-party-popper::before {\n  content: \"\\F1056\";\n}\n\n.mdi-passport::before {\n  content: \"\\F07E3\";\n}\n\n.mdi-passport-biometric::before {\n  content: \"\\F0DE1\";\n}\n\n.mdi-pasta::before {\n  content: \"\\F1160\";\n}\n\n.mdi-patio-heater::before {\n  content: \"\\F0F80\";\n}\n\n.mdi-patreon::before {\n  content: \"\\F0882\";\n}\n\n.mdi-pause::before {\n  content: \"\\F03E4\";\n}\n\n.mdi-pause-circle::before {\n  content: \"\\F03E5\";\n}\n\n.mdi-pause-circle-outline::before {\n  content: \"\\F03E6\";\n}\n\n.mdi-pause-octagon::before {\n  content: \"\\F03E7\";\n}\n\n.mdi-pause-octagon-outline::before {\n  content: \"\\F03E8\";\n}\n\n.mdi-paw::before {\n  content: \"\\F03E9\";\n}\n\n.mdi-paw-off::before {\n  content: \"\\F0657\";\n}\n\n.mdi-pdf-box::before {\n  content: \"\\F0E56\";\n}\n\n.mdi-peace::before {\n  content: \"\\F0884\";\n}\n\n.mdi-peanut::before {\n  content: \"\\F0FFC\";\n}\n\n.mdi-peanut-off::before {\n  content: \"\\F0FFD\";\n}\n\n.mdi-peanut-off-outline::before {\n  content: \"\\F0FFF\";\n}\n\n.mdi-peanut-outline::before {\n  content: \"\\F0FFE\";\n}\n\n.mdi-pen::before {\n  content: \"\\F03EA\";\n}\n\n.mdi-pen-lock::before {\n  content: \"\\F0DE2\";\n}\n\n.mdi-pen-minus::before {\n  content: \"\\F0DE3\";\n}\n\n.mdi-pen-off::before {\n  content: \"\\F0DE4\";\n}\n\n.mdi-pen-plus::before {\n  content: \"\\F0DE5\";\n}\n\n.mdi-pen-remove::before {\n  content: \"\\F0DE6\";\n}\n\n.mdi-pencil::before {\n  content: \"\\F03EB\";\n}\n\n.mdi-pencil-box::before {\n  content: \"\\F03EC\";\n}\n\n.mdi-pencil-box-multiple::before {\n  content: \"\\F1144\";\n}\n\n.mdi-pencil-box-multiple-outline::before {\n  content: \"\\F1145\";\n}\n\n.mdi-pencil-box-outline::before {\n  content: \"\\F03ED\";\n}\n\n.mdi-pencil-circle::before {\n  content: \"\\F06FF\";\n}\n\n.mdi-pencil-circle-outline::before {\n  content: \"\\F0776\";\n}\n\n.mdi-pencil-lock::before {\n  content: \"\\F03EE\";\n}\n\n.mdi-pencil-lock-outline::before {\n  content: \"\\F0DE7\";\n}\n\n.mdi-pencil-minus::before {\n  content: \"\\F0DE8\";\n}\n\n.mdi-pencil-minus-outline::before {\n  content: \"\\F0DE9\";\n}\n\n.mdi-pencil-off::before {\n  content: \"\\F03EF\";\n}\n\n.mdi-pencil-off-outline::before {\n  content: \"\\F0DEA\";\n}\n\n.mdi-pencil-outline::before {\n  content: \"\\F0CB6\";\n}\n\n.mdi-pencil-plus::before {\n  content: \"\\F0DEB\";\n}\n\n.mdi-pencil-plus-outline::before {\n  content: \"\\F0DEC\";\n}\n\n.mdi-pencil-remove::before {\n  content: \"\\F0DED\";\n}\n\n.mdi-pencil-remove-outline::before {\n  content: \"\\F0DEE\";\n}\n\n.mdi-pencil-ruler::before {\n  content: \"\\F1353\";\n}\n\n.mdi-penguin::before {\n  content: \"\\F0EC0\";\n}\n\n.mdi-pentagon::before {\n  content: \"\\F0701\";\n}\n\n.mdi-pentagon-outline::before {\n  content: \"\\F0700\";\n}\n\n.mdi-percent::before {\n  content: \"\\F03F0\";\n}\n\n.mdi-percent-outline::before {\n  content: \"\\F1278\";\n}\n\n.mdi-periodic-table::before {\n  content: \"\\F08B6\";\n}\n\n.mdi-perspective-less::before {\n  content: \"\\F0D23\";\n}\n\n.mdi-perspective-more::before {\n  content: \"\\F0D24\";\n}\n\n.mdi-pharmacy::before {\n  content: \"\\F03F1\";\n}\n\n.mdi-phone::before {\n  content: \"\\F03F2\";\n}\n\n.mdi-phone-alert::before {\n  content: \"\\F0F1A\";\n}\n\n.mdi-phone-alert-outline::before {\n  content: \"\\F118E\";\n}\n\n.mdi-phone-bluetooth::before {\n  content: \"\\F03F3\";\n}\n\n.mdi-phone-bluetooth-outline::before {\n  content: \"\\F118F\";\n}\n\n.mdi-phone-cancel::before {\n  content: \"\\F10BC\";\n}\n\n.mdi-phone-cancel-outline::before {\n  content: \"\\F1190\";\n}\n\n.mdi-phone-check::before {\n  content: \"\\F11A9\";\n}\n\n.mdi-phone-check-outline::before {\n  content: \"\\F11AA\";\n}\n\n.mdi-phone-classic::before {\n  content: \"\\F0602\";\n}\n\n.mdi-phone-classic-off::before {\n  content: \"\\F1279\";\n}\n\n.mdi-phone-forward::before {\n  content: \"\\F03F4\";\n}\n\n.mdi-phone-forward-outline::before {\n  content: \"\\F1191\";\n}\n\n.mdi-phone-hangup::before {\n  content: \"\\F03F5\";\n}\n\n.mdi-phone-hangup-outline::before {\n  content: \"\\F1192\";\n}\n\n.mdi-phone-in-talk::before {\n  content: \"\\F03F6\";\n}\n\n.mdi-phone-in-talk-outline::before {\n  content: \"\\F1182\";\n}\n\n.mdi-phone-incoming::before {\n  content: \"\\F03F7\";\n}\n\n.mdi-phone-incoming-outline::before {\n  content: \"\\F1193\";\n}\n\n.mdi-phone-lock::before {\n  content: \"\\F03F8\";\n}\n\n.mdi-phone-lock-outline::before {\n  content: \"\\F1194\";\n}\n\n.mdi-phone-log::before {\n  content: \"\\F03F9\";\n}\n\n.mdi-phone-log-outline::before {\n  content: \"\\F1195\";\n}\n\n.mdi-phone-message::before {\n  content: \"\\F1196\";\n}\n\n.mdi-phone-message-outline::before {\n  content: \"\\F1197\";\n}\n\n.mdi-phone-minus::before {\n  content: \"\\F0658\";\n}\n\n.mdi-phone-minus-outline::before {\n  content: \"\\F1198\";\n}\n\n.mdi-phone-missed::before {\n  content: \"\\F03FA\";\n}\n\n.mdi-phone-missed-outline::before {\n  content: \"\\F11A5\";\n}\n\n.mdi-phone-off::before {\n  content: \"\\F0DEF\";\n}\n\n.mdi-phone-off-outline::before {\n  content: \"\\F11A6\";\n}\n\n.mdi-phone-outgoing::before {\n  content: \"\\F03FB\";\n}\n\n.mdi-phone-outgoing-outline::before {\n  content: \"\\F1199\";\n}\n\n.mdi-phone-outline::before {\n  content: \"\\F0DF0\";\n}\n\n.mdi-phone-paused::before {\n  content: \"\\F03FC\";\n}\n\n.mdi-phone-paused-outline::before {\n  content: \"\\F119A\";\n}\n\n.mdi-phone-plus::before {\n  content: \"\\F0659\";\n}\n\n.mdi-phone-plus-outline::before {\n  content: \"\\F119B\";\n}\n\n.mdi-phone-return::before {\n  content: \"\\F082F\";\n}\n\n.mdi-phone-return-outline::before {\n  content: \"\\F119C\";\n}\n\n.mdi-phone-ring::before {\n  content: \"\\F11AB\";\n}\n\n.mdi-phone-ring-outline::before {\n  content: \"\\F11AC\";\n}\n\n.mdi-phone-rotate-landscape::before {\n  content: \"\\F0885\";\n}\n\n.mdi-phone-rotate-portrait::before {\n  content: \"\\F0886\";\n}\n\n.mdi-phone-settings::before {\n  content: \"\\F03FD\";\n}\n\n.mdi-phone-settings-outline::before {\n  content: \"\\F119D\";\n}\n\n.mdi-phone-voip::before {\n  content: \"\\F03FE\";\n}\n\n.mdi-pi::before {\n  content: \"\\F03FF\";\n}\n\n.mdi-pi-box::before {\n  content: \"\\F0400\";\n}\n\n.mdi-pi-hole::before {\n  content: \"\\F0DF1\";\n}\n\n.mdi-piano::before {\n  content: \"\\F067D\";\n}\n\n.mdi-pickaxe::before {\n  content: \"\\F08B7\";\n}\n\n.mdi-picture-in-picture-bottom-right::before {\n  content: \"\\F0E57\";\n}\n\n.mdi-picture-in-picture-bottom-right-outline::before {\n  content: \"\\F0E58\";\n}\n\n.mdi-picture-in-picture-top-right::before {\n  content: \"\\F0E59\";\n}\n\n.mdi-picture-in-picture-top-right-outline::before {\n  content: \"\\F0E5A\";\n}\n\n.mdi-pier::before {\n  content: \"\\F0887\";\n}\n\n.mdi-pier-crane::before {\n  content: \"\\F0888\";\n}\n\n.mdi-pig::before {\n  content: \"\\F0401\";\n}\n\n.mdi-pig-variant::before {\n  content: \"\\F1006\";\n}\n\n.mdi-piggy-bank::before {\n  content: \"\\F1007\";\n}\n\n.mdi-pill::before {\n  content: \"\\F0402\";\n}\n\n.mdi-pillar::before {\n  content: \"\\F0702\";\n}\n\n.mdi-pin::before {\n  content: \"\\F0403\";\n}\n\n.mdi-pin-off::before {\n  content: \"\\F0404\";\n}\n\n.mdi-pin-off-outline::before {\n  content: \"\\F0930\";\n}\n\n.mdi-pin-outline::before {\n  content: \"\\F0931\";\n}\n\n.mdi-pine-tree::before {\n  content: \"\\F0405\";\n}\n\n.mdi-pine-tree-box::before {\n  content: \"\\F0406\";\n}\n\n.mdi-pinterest::before {\n  content: \"\\F0407\";\n}\n\n.mdi-pinwheel::before {\n  content: \"\\F0AD5\";\n}\n\n.mdi-pinwheel-outline::before {\n  content: \"\\F0AD6\";\n}\n\n.mdi-pipe::before {\n  content: \"\\F07E5\";\n}\n\n.mdi-pipe-disconnected::before {\n  content: \"\\F07E6\";\n}\n\n.mdi-pipe-leak::before {\n  content: \"\\F0889\";\n}\n\n.mdi-pipe-wrench::before {\n  content: \"\\F1354\";\n}\n\n.mdi-pirate::before {\n  content: \"\\F0A08\";\n}\n\n.mdi-pistol::before {\n  content: \"\\F0703\";\n}\n\n.mdi-piston::before {\n  content: \"\\F088A\";\n}\n\n.mdi-pizza::before {\n  content: \"\\F0409\";\n}\n\n.mdi-play::before {\n  content: \"\\F040A\";\n}\n\n.mdi-play-box::before {\n  content: \"\\F127A\";\n}\n\n.mdi-play-box-multiple::before {\n  content: \"\\F0D19\";\n}\n\n.mdi-play-box-outline::before {\n  content: \"\\F040B\";\n}\n\n.mdi-play-circle::before {\n  content: \"\\F040C\";\n}\n\n.mdi-play-circle-outline::before {\n  content: \"\\F040D\";\n}\n\n.mdi-play-network::before {\n  content: \"\\F088B\";\n}\n\n.mdi-play-network-outline::before {\n  content: \"\\F0CB7\";\n}\n\n.mdi-play-outline::before {\n  content: \"\\F0F1B\";\n}\n\n.mdi-play-pause::before {\n  content: \"\\F040E\";\n}\n\n.mdi-play-protected-content::before {\n  content: \"\\F040F\";\n}\n\n.mdi-play-speed::before {\n  content: \"\\F08FF\";\n}\n\n.mdi-playlist-check::before {\n  content: \"\\F05C7\";\n}\n\n.mdi-playlist-edit::before {\n  content: \"\\F0900\";\n}\n\n.mdi-playlist-minus::before {\n  content: \"\\F0410\";\n}\n\n.mdi-playlist-music::before {\n  content: \"\\F0CB8\";\n}\n\n.mdi-playlist-music-outline::before {\n  content: \"\\F0CB9\";\n}\n\n.mdi-playlist-play::before {\n  content: \"\\F0411\";\n}\n\n.mdi-playlist-plus::before {\n  content: \"\\F0412\";\n}\n\n.mdi-playlist-remove::before {\n  content: \"\\F0413\";\n}\n\n.mdi-playlist-star::before {\n  content: \"\\F0DF2\";\n}\n\n.mdi-plex::before {\n  content: \"\\F06BA\";\n}\n\n.mdi-plus::before {\n  content: \"\\F0415\";\n}\n\n.mdi-plus-box::before {\n  content: \"\\F0416\";\n}\n\n.mdi-plus-box-multiple::before {\n  content: \"\\F0334\";\n}\n\n.mdi-plus-box-multiple-outline::before {\n  content: \"\\F1143\";\n}\n\n.mdi-plus-box-outline::before {\n  content: \"\\F0704\";\n}\n\n.mdi-plus-circle::before {\n  content: \"\\F0417\";\n}\n\n.mdi-plus-circle-multiple::before {\n  content: \"\\F034C\";\n}\n\n.mdi-plus-circle-multiple-outline::before {\n  content: \"\\F0418\";\n}\n\n.mdi-plus-circle-outline::before {\n  content: \"\\F0419\";\n}\n\n.mdi-plus-minus::before {\n  content: \"\\F0992\";\n}\n\n.mdi-plus-minus-box::before {\n  content: \"\\F0993\";\n}\n\n.mdi-plus-network::before {\n  content: \"\\F041A\";\n}\n\n.mdi-plus-network-outline::before {\n  content: \"\\F0CBA\";\n}\n\n.mdi-plus-one::before {\n  content: \"\\F041B\";\n}\n\n.mdi-plus-outline::before {\n  content: \"\\F0705\";\n}\n\n.mdi-plus-thick::before {\n  content: \"\\F11EC\";\n}\n\n.mdi-podcast::before {\n  content: \"\\F0994\";\n}\n\n.mdi-podium::before {\n  content: \"\\F0D25\";\n}\n\n.mdi-podium-bronze::before {\n  content: \"\\F0D26\";\n}\n\n.mdi-podium-gold::before {\n  content: \"\\F0D27\";\n}\n\n.mdi-podium-silver::before {\n  content: \"\\F0D28\";\n}\n\n.mdi-point-of-sale::before {\n  content: \"\\F0D92\";\n}\n\n.mdi-pokeball::before {\n  content: \"\\F041D\";\n}\n\n.mdi-pokemon-go::before {\n  content: \"\\F0A09\";\n}\n\n.mdi-poker-chip::before {\n  content: \"\\F0830\";\n}\n\n.mdi-polaroid::before {\n  content: \"\\F041E\";\n}\n\n.mdi-police-badge::before {\n  content: \"\\F1167\";\n}\n\n.mdi-police-badge-outline::before {\n  content: \"\\F1168\";\n}\n\n.mdi-poll::before {\n  content: \"\\F041F\";\n}\n\n.mdi-poll-box::before {\n  content: \"\\F0420\";\n}\n\n.mdi-poll-box-outline::before {\n  content: \"\\F127B\";\n}\n\n.mdi-polymer::before {\n  content: \"\\F0421\";\n}\n\n.mdi-pool::before {\n  content: \"\\F0606\";\n}\n\n.mdi-popcorn::before {\n  content: \"\\F0422\";\n}\n\n.mdi-post::before {\n  content: \"\\F1008\";\n}\n\n.mdi-post-outline::before {\n  content: \"\\F1009\";\n}\n\n.mdi-postage-stamp::before {\n  content: \"\\F0CBB\";\n}\n\n.mdi-pot::before {\n  content: \"\\F02E5\";\n}\n\n.mdi-pot-mix::before {\n  content: \"\\F065B\";\n}\n\n.mdi-pot-mix-outline::before {\n  content: \"\\F0677\";\n}\n\n.mdi-pot-outline::before {\n  content: \"\\F02FF\";\n}\n\n.mdi-pot-steam::before {\n  content: \"\\F065A\";\n}\n\n.mdi-pot-steam-outline::before {\n  content: \"\\F0326\";\n}\n\n.mdi-pound::before {\n  content: \"\\F0423\";\n}\n\n.mdi-pound-box::before {\n  content: \"\\F0424\";\n}\n\n.mdi-pound-box-outline::before {\n  content: \"\\F117F\";\n}\n\n.mdi-power::before {\n  content: \"\\F0425\";\n}\n\n.mdi-power-cycle::before {\n  content: \"\\F0901\";\n}\n\n.mdi-power-off::before {\n  content: \"\\F0902\";\n}\n\n.mdi-power-on::before {\n  content: \"\\F0903\";\n}\n\n.mdi-power-plug::before {\n  content: \"\\F06A5\";\n}\n\n.mdi-power-plug-off::before {\n  content: \"\\F06A6\";\n}\n\n.mdi-power-settings::before {\n  content: \"\\F0426\";\n}\n\n.mdi-power-sleep::before {\n  content: \"\\F0904\";\n}\n\n.mdi-power-socket::before {\n  content: \"\\F0427\";\n}\n\n.mdi-power-socket-au::before {\n  content: \"\\F0905\";\n}\n\n.mdi-power-socket-de::before {\n  content: \"\\F1107\";\n}\n\n.mdi-power-socket-eu::before {\n  content: \"\\F07E7\";\n}\n\n.mdi-power-socket-fr::before {\n  content: \"\\F1108\";\n}\n\n.mdi-power-socket-jp::before {\n  content: \"\\F1109\";\n}\n\n.mdi-power-socket-uk::before {\n  content: \"\\F07E8\";\n}\n\n.mdi-power-socket-us::before {\n  content: \"\\F07E9\";\n}\n\n.mdi-power-standby::before {\n  content: \"\\F0906\";\n}\n\n.mdi-powershell::before {\n  content: \"\\F0A0A\";\n}\n\n.mdi-prescription::before {\n  content: \"\\F0706\";\n}\n\n.mdi-presentation::before {\n  content: \"\\F0428\";\n}\n\n.mdi-presentation-play::before {\n  content: \"\\F0429\";\n}\n\n.mdi-printer::before {\n  content: \"\\F042A\";\n}\n\n.mdi-printer-3d::before {\n  content: \"\\F042B\";\n}\n\n.mdi-printer-3d-nozzle::before {\n  content: \"\\F0E5B\";\n}\n\n.mdi-printer-3d-nozzle-alert::before {\n  content: \"\\F11C0\";\n}\n\n.mdi-printer-3d-nozzle-alert-outline::before {\n  content: \"\\F11C1\";\n}\n\n.mdi-printer-3d-nozzle-outline::before {\n  content: \"\\F0E5C\";\n}\n\n.mdi-printer-alert::before {\n  content: \"\\F042C\";\n}\n\n.mdi-printer-check::before {\n  content: \"\\F1146\";\n}\n\n.mdi-printer-off::before {\n  content: \"\\F0E5D\";\n}\n\n.mdi-printer-pos::before {\n  content: \"\\F1057\";\n}\n\n.mdi-printer-settings::before {\n  content: \"\\F0707\";\n}\n\n.mdi-printer-wireless::before {\n  content: \"\\F0A0B\";\n}\n\n.mdi-priority-high::before {\n  content: \"\\F0603\";\n}\n\n.mdi-priority-low::before {\n  content: \"\\F0604\";\n}\n\n.mdi-professional-hexagon::before {\n  content: \"\\F042D\";\n}\n\n.mdi-progress-alert::before {\n  content: \"\\F0CBC\";\n}\n\n.mdi-progress-check::before {\n  content: \"\\F0995\";\n}\n\n.mdi-progress-clock::before {\n  content: \"\\F0996\";\n}\n\n.mdi-progress-close::before {\n  content: \"\\F110A\";\n}\n\n.mdi-progress-download::before {\n  content: \"\\F0997\";\n}\n\n.mdi-progress-upload::before {\n  content: \"\\F0998\";\n}\n\n.mdi-progress-wrench::before {\n  content: \"\\F0CBD\";\n}\n\n.mdi-projector::before {\n  content: \"\\F042E\";\n}\n\n.mdi-projector-screen::before {\n  content: \"\\F042F\";\n}\n\n.mdi-propane-tank::before {\n  content: \"\\F1357\";\n}\n\n.mdi-propane-tank-outline::before {\n  content: \"\\F1358\";\n}\n\n.mdi-protocol::before {\n  content: \"\\F0FD8\";\n}\n\n.mdi-publish::before {\n  content: \"\\F06A7\";\n}\n\n.mdi-pulse::before {\n  content: \"\\F0430\";\n}\n\n.mdi-pumpkin::before {\n  content: \"\\F0BBF\";\n}\n\n.mdi-purse::before {\n  content: \"\\F0F1C\";\n}\n\n.mdi-purse-outline::before {\n  content: \"\\F0F1D\";\n}\n\n.mdi-puzzle::before {\n  content: \"\\F0431\";\n}\n\n.mdi-puzzle-outline::before {\n  content: \"\\F0A66\";\n}\n\n.mdi-qi::before {\n  content: \"\\F0999\";\n}\n\n.mdi-qqchat::before {\n  content: \"\\F0605\";\n}\n\n.mdi-qrcode::before {\n  content: \"\\F0432\";\n}\n\n.mdi-qrcode-edit::before {\n  content: \"\\F08B8\";\n}\n\n.mdi-qrcode-minus::before {\n  content: \"\\F118C\";\n}\n\n.mdi-qrcode-plus::before {\n  content: \"\\F118B\";\n}\n\n.mdi-qrcode-remove::before {\n  content: \"\\F118D\";\n}\n\n.mdi-qrcode-scan::before {\n  content: \"\\F0433\";\n}\n\n.mdi-quadcopter::before {\n  content: \"\\F0434\";\n}\n\n.mdi-quality-high::before {\n  content: \"\\F0435\";\n}\n\n.mdi-quality-low::before {\n  content: \"\\F0A0C\";\n}\n\n.mdi-quality-medium::before {\n  content: \"\\F0A0D\";\n}\n\n.mdi-quora::before {\n  content: \"\\F0D29\";\n}\n\n.mdi-rabbit::before {\n  content: \"\\F0907\";\n}\n\n.mdi-racing-helmet::before {\n  content: \"\\F0D93\";\n}\n\n.mdi-racquetball::before {\n  content: \"\\F0D94\";\n}\n\n.mdi-radar::before {\n  content: \"\\F0437\";\n}\n\n.mdi-radiator::before {\n  content: \"\\F0438\";\n}\n\n.mdi-radiator-disabled::before {\n  content: \"\\F0AD7\";\n}\n\n.mdi-radiator-off::before {\n  content: \"\\F0AD8\";\n}\n\n.mdi-radio::before {\n  content: \"\\F0439\";\n}\n\n.mdi-radio-am::before {\n  content: \"\\F0CBE\";\n}\n\n.mdi-radio-fm::before {\n  content: \"\\F0CBF\";\n}\n\n.mdi-radio-handheld::before {\n  content: \"\\F043A\";\n}\n\n.mdi-radio-off::before {\n  content: \"\\F121C\";\n}\n\n.mdi-radio-tower::before {\n  content: \"\\F043B\";\n}\n\n.mdi-radioactive::before {\n  content: \"\\F043C\";\n}\n\n.mdi-radioactive-off::before {\n  content: \"\\F0EC1\";\n}\n\n.mdi-radiobox-blank::before {\n  content: \"\\F043D\";\n}\n\n.mdi-radiobox-marked::before {\n  content: \"\\F043E\";\n}\n\n.mdi-radius::before {\n  content: \"\\F0CC0\";\n}\n\n.mdi-radius-outline::before {\n  content: \"\\F0CC1\";\n}\n\n.mdi-railroad-light::before {\n  content: \"\\F0F1E\";\n}\n\n.mdi-raspberry-pi::before {\n  content: \"\\F043F\";\n}\n\n.mdi-ray-end::before {\n  content: \"\\F0440\";\n}\n\n.mdi-ray-end-arrow::before {\n  content: \"\\F0441\";\n}\n\n.mdi-ray-start::before {\n  content: \"\\F0442\";\n}\n\n.mdi-ray-start-arrow::before {\n  content: \"\\F0443\";\n}\n\n.mdi-ray-start-end::before {\n  content: \"\\F0444\";\n}\n\n.mdi-ray-vertex::before {\n  content: \"\\F0445\";\n}\n\n.mdi-react::before {\n  content: \"\\F0708\";\n}\n\n.mdi-read::before {\n  content: \"\\F0447\";\n}\n\n.mdi-receipt::before {\n  content: \"\\F0449\";\n}\n\n.mdi-record::before {\n  content: \"\\F044A\";\n}\n\n.mdi-record-circle::before {\n  content: \"\\F0EC2\";\n}\n\n.mdi-record-circle-outline::before {\n  content: \"\\F0EC3\";\n}\n\n.mdi-record-player::before {\n  content: \"\\F099A\";\n}\n\n.mdi-record-rec::before {\n  content: \"\\F044B\";\n}\n\n.mdi-rectangle::before {\n  content: \"\\F0E5E\";\n}\n\n.mdi-rectangle-outline::before {\n  content: \"\\F0E5F\";\n}\n\n.mdi-recycle::before {\n  content: \"\\F044C\";\n}\n\n.mdi-recycle-variant::before {\n  content: \"\\F139D\";\n}\n\n.mdi-reddit::before {\n  content: \"\\F044D\";\n}\n\n.mdi-redhat::before {\n  content: \"\\F111B\";\n}\n\n.mdi-redo::before {\n  content: \"\\F044E\";\n}\n\n.mdi-redo-variant::before {\n  content: \"\\F044F\";\n}\n\n.mdi-reflect-horizontal::before {\n  content: \"\\F0A0E\";\n}\n\n.mdi-reflect-vertical::before {\n  content: \"\\F0A0F\";\n}\n\n.mdi-refresh::before {\n  content: \"\\F0450\";\n}\n\n.mdi-refresh-circle::before {\n  content: \"\\F1377\";\n}\n\n.mdi-regex::before {\n  content: \"\\F0451\";\n}\n\n.mdi-registered-trademark::before {\n  content: \"\\F0A67\";\n}\n\n.mdi-relative-scale::before {\n  content: \"\\F0452\";\n}\n\n.mdi-reload::before {\n  content: \"\\F0453\";\n}\n\n.mdi-reload-alert::before {\n  content: \"\\F110B\";\n}\n\n.mdi-reminder::before {\n  content: \"\\F088C\";\n}\n\n.mdi-remote::before {\n  content: \"\\F0454\";\n}\n\n.mdi-remote-desktop::before {\n  content: \"\\F08B9\";\n}\n\n.mdi-remote-off::before {\n  content: \"\\F0EC4\";\n}\n\n.mdi-remote-tv::before {\n  content: \"\\F0EC5\";\n}\n\n.mdi-remote-tv-off::before {\n  content: \"\\F0EC6\";\n}\n\n.mdi-rename-box::before {\n  content: \"\\F0455\";\n}\n\n.mdi-reorder-horizontal::before {\n  content: \"\\F0688\";\n}\n\n.mdi-reorder-vertical::before {\n  content: \"\\F0689\";\n}\n\n.mdi-repeat::before {\n  content: \"\\F0456\";\n}\n\n.mdi-repeat-off::before {\n  content: \"\\F0457\";\n}\n\n.mdi-repeat-once::before {\n  content: \"\\F0458\";\n}\n\n.mdi-replay::before {\n  content: \"\\F0459\";\n}\n\n.mdi-reply::before {\n  content: \"\\F045A\";\n}\n\n.mdi-reply-all::before {\n  content: \"\\F045B\";\n}\n\n.mdi-reply-all-outline::before {\n  content: \"\\F0F1F\";\n}\n\n.mdi-reply-circle::before {\n  content: \"\\F11AE\";\n}\n\n.mdi-reply-outline::before {\n  content: \"\\F0F20\";\n}\n\n.mdi-reproduction::before {\n  content: \"\\F045C\";\n}\n\n.mdi-resistor::before {\n  content: \"\\F0B44\";\n}\n\n.mdi-resistor-nodes::before {\n  content: \"\\F0B45\";\n}\n\n.mdi-resize::before {\n  content: \"\\F0A68\";\n}\n\n.mdi-resize-bottom-right::before {\n  content: \"\\F045D\";\n}\n\n.mdi-responsive::before {\n  content: \"\\F045E\";\n}\n\n.mdi-restart::before {\n  content: \"\\F0709\";\n}\n\n.mdi-restart-alert::before {\n  content: \"\\F110C\";\n}\n\n.mdi-restart-off::before {\n  content: \"\\F0D95\";\n}\n\n.mdi-restore::before {\n  content: \"\\F099B\";\n}\n\n.mdi-restore-alert::before {\n  content: \"\\F110D\";\n}\n\n.mdi-rewind::before {\n  content: \"\\F045F\";\n}\n\n.mdi-rewind-10::before {\n  content: \"\\F0D2A\";\n}\n\n.mdi-rewind-30::before {\n  content: \"\\F0D96\";\n}\n\n.mdi-rewind-5::before {\n  content: \"\\F11F9\";\n}\n\n.mdi-rewind-outline::before {\n  content: \"\\F070A\";\n}\n\n.mdi-rhombus::before {\n  content: \"\\F070B\";\n}\n\n.mdi-rhombus-medium::before {\n  content: \"\\F0A10\";\n}\n\n.mdi-rhombus-outline::before {\n  content: \"\\F070C\";\n}\n\n.mdi-rhombus-split::before {\n  content: \"\\F0A11\";\n}\n\n.mdi-ribbon::before {\n  content: \"\\F0460\";\n}\n\n.mdi-rice::before {\n  content: \"\\F07EA\";\n}\n\n.mdi-ring::before {\n  content: \"\\F07EB\";\n}\n\n.mdi-rivet::before {\n  content: \"\\F0E60\";\n}\n\n.mdi-road::before {\n  content: \"\\F0461\";\n}\n\n.mdi-road-variant::before {\n  content: \"\\F0462\";\n}\n\n.mdi-robber::before {\n  content: \"\\F1058\";\n}\n\n.mdi-robot::before {\n  content: \"\\F06A9\";\n}\n\n.mdi-robot-industrial::before {\n  content: \"\\F0B46\";\n}\n\n.mdi-robot-mower::before {\n  content: \"\\F11F7\";\n}\n\n.mdi-robot-mower-outline::before {\n  content: \"\\F11F3\";\n}\n\n.mdi-robot-vacuum::before {\n  content: \"\\F070D\";\n}\n\n.mdi-robot-vacuum-variant::before {\n  content: \"\\F0908\";\n}\n\n.mdi-rocket::before {\n  content: \"\\F0463\";\n}\n\n.mdi-rocket-outline::before {\n  content: \"\\F13AF\";\n}\n\n.mdi-rodent::before {\n  content: \"\\F1327\";\n}\n\n.mdi-roller-skate::before {\n  content: \"\\F0D2B\";\n}\n\n.mdi-roller-skate-off::before {\n  content: \"\\F0145\";\n}\n\n.mdi-rollerblade::before {\n  content: \"\\F0D2C\";\n}\n\n.mdi-rollerblade-off::before {\n  content: \"\\F002E\";\n}\n\n.mdi-rollupjs::before {\n  content: \"\\F0BC0\";\n}\n\n.mdi-roman-numeral-1::before {\n  content: \"\\F1088\";\n}\n\n.mdi-roman-numeral-10::before {\n  content: \"\\F1091\";\n}\n\n.mdi-roman-numeral-2::before {\n  content: \"\\F1089\";\n}\n\n.mdi-roman-numeral-3::before {\n  content: \"\\F108A\";\n}\n\n.mdi-roman-numeral-4::before {\n  content: \"\\F108B\";\n}\n\n.mdi-roman-numeral-5::before {\n  content: \"\\F108C\";\n}\n\n.mdi-roman-numeral-6::before {\n  content: \"\\F108D\";\n}\n\n.mdi-roman-numeral-7::before {\n  content: \"\\F108E\";\n}\n\n.mdi-roman-numeral-8::before {\n  content: \"\\F108F\";\n}\n\n.mdi-roman-numeral-9::before {\n  content: \"\\F1090\";\n}\n\n.mdi-room-service::before {\n  content: \"\\F088D\";\n}\n\n.mdi-room-service-outline::before {\n  content: \"\\F0D97\";\n}\n\n.mdi-rotate-3d::before {\n  content: \"\\F0EC7\";\n}\n\n.mdi-rotate-3d-variant::before {\n  content: \"\\F0464\";\n}\n\n.mdi-rotate-left::before {\n  content: \"\\F0465\";\n}\n\n.mdi-rotate-left-variant::before {\n  content: \"\\F0466\";\n}\n\n.mdi-rotate-orbit::before {\n  content: \"\\F0D98\";\n}\n\n.mdi-rotate-right::before {\n  content: \"\\F0467\";\n}\n\n.mdi-rotate-right-variant::before {\n  content: \"\\F0468\";\n}\n\n.mdi-rounded-corner::before {\n  content: \"\\F0607\";\n}\n\n.mdi-router::before {\n  content: \"\\F11E2\";\n}\n\n.mdi-router-network::before {\n  content: \"\\F1087\";\n}\n\n.mdi-router-wireless::before {\n  content: \"\\F0469\";\n}\n\n.mdi-router-wireless-settings::before {\n  content: \"\\F0A69\";\n}\n\n.mdi-routes::before {\n  content: \"\\F046A\";\n}\n\n.mdi-routes-clock::before {\n  content: \"\\F1059\";\n}\n\n.mdi-rowing::before {\n  content: \"\\F0608\";\n}\n\n.mdi-rss::before {\n  content: \"\\F046B\";\n}\n\n.mdi-rss-box::before {\n  content: \"\\F046C\";\n}\n\n.mdi-rss-off::before {\n  content: \"\\F0F21\";\n}\n\n.mdi-rugby::before {\n  content: \"\\F0D99\";\n}\n\n.mdi-ruler::before {\n  content: \"\\F046D\";\n}\n\n.mdi-ruler-square::before {\n  content: \"\\F0CC2\";\n}\n\n.mdi-ruler-square-compass::before {\n  content: \"\\F0EBE\";\n}\n\n.mdi-run::before {\n  content: \"\\F070E\";\n}\n\n.mdi-run-fast::before {\n  content: \"\\F046E\";\n}\n\n.mdi-rv-truck::before {\n  content: \"\\F11D4\";\n}\n\n.mdi-sack::before {\n  content: \"\\F0D2E\";\n}\n\n.mdi-sack-percent::before {\n  content: \"\\F0D2F\";\n}\n\n.mdi-safe::before {\n  content: \"\\F0A6A\";\n}\n\n.mdi-safe-square::before {\n  content: \"\\F127C\";\n}\n\n.mdi-safe-square-outline::before {\n  content: \"\\F127D\";\n}\n\n.mdi-safety-goggles::before {\n  content: \"\\F0D30\";\n}\n\n.mdi-sail-boat::before {\n  content: \"\\F0EC8\";\n}\n\n.mdi-sale::before {\n  content: \"\\F046F\";\n}\n\n.mdi-salesforce::before {\n  content: \"\\F088E\";\n}\n\n.mdi-sass::before {\n  content: \"\\F07EC\";\n}\n\n.mdi-satellite::before {\n  content: \"\\F0470\";\n}\n\n.mdi-satellite-uplink::before {\n  content: \"\\F0909\";\n}\n\n.mdi-satellite-variant::before {\n  content: \"\\F0471\";\n}\n\n.mdi-sausage::before {\n  content: \"\\F08BA\";\n}\n\n.mdi-saw-blade::before {\n  content: \"\\F0E61\";\n}\n\n.mdi-saxophone::before {\n  content: \"\\F0609\";\n}\n\n.mdi-scale::before {\n  content: \"\\F0472\";\n}\n\n.mdi-scale-balance::before {\n  content: \"\\F05D1\";\n}\n\n.mdi-scale-bathroom::before {\n  content: \"\\F0473\";\n}\n\n.mdi-scale-off::before {\n  content: \"\\F105A\";\n}\n\n.mdi-scanner::before {\n  content: \"\\F06AB\";\n}\n\n.mdi-scanner-off::before {\n  content: \"\\F090A\";\n}\n\n.mdi-scatter-plot::before {\n  content: \"\\F0EC9\";\n}\n\n.mdi-scatter-plot-outline::before {\n  content: \"\\F0ECA\";\n}\n\n.mdi-school::before {\n  content: \"\\F0474\";\n}\n\n.mdi-school-outline::before {\n  content: \"\\F1180\";\n}\n\n.mdi-scissors-cutting::before {\n  content: \"\\F0A6B\";\n}\n\n.mdi-scooter::before {\n  content: \"\\F11E9\";\n}\n\n.mdi-scoreboard::before {\n  content: \"\\F127E\";\n}\n\n.mdi-scoreboard-outline::before {\n  content: \"\\F127F\";\n}\n\n.mdi-screen-rotation::before {\n  content: \"\\F0475\";\n}\n\n.mdi-screen-rotation-lock::before {\n  content: \"\\F0478\";\n}\n\n.mdi-screw-flat-top::before {\n  content: \"\\F0DF3\";\n}\n\n.mdi-screw-lag::before {\n  content: \"\\F0DF4\";\n}\n\n.mdi-screw-machine-flat-top::before {\n  content: \"\\F0DF5\";\n}\n\n.mdi-screw-machine-round-top::before {\n  content: \"\\F0DF6\";\n}\n\n.mdi-screw-round-top::before {\n  content: \"\\F0DF7\";\n}\n\n.mdi-screwdriver::before {\n  content: \"\\F0476\";\n}\n\n.mdi-script::before {\n  content: \"\\F0BC1\";\n}\n\n.mdi-script-outline::before {\n  content: \"\\F0477\";\n}\n\n.mdi-script-text::before {\n  content: \"\\F0BC2\";\n}\n\n.mdi-script-text-outline::before {\n  content: \"\\F0BC3\";\n}\n\n.mdi-sd::before {\n  content: \"\\F0479\";\n}\n\n.mdi-seal::before {\n  content: \"\\F047A\";\n}\n\n.mdi-seal-variant::before {\n  content: \"\\F0FD9\";\n}\n\n.mdi-search-web::before {\n  content: \"\\F070F\";\n}\n\n.mdi-seat::before {\n  content: \"\\F0CC3\";\n}\n\n.mdi-seat-flat::before {\n  content: \"\\F047B\";\n}\n\n.mdi-seat-flat-angled::before {\n  content: \"\\F047C\";\n}\n\n.mdi-seat-individual-suite::before {\n  content: \"\\F047D\";\n}\n\n.mdi-seat-legroom-extra::before {\n  content: \"\\F047E\";\n}\n\n.mdi-seat-legroom-normal::before {\n  content: \"\\F047F\";\n}\n\n.mdi-seat-legroom-reduced::before {\n  content: \"\\F0480\";\n}\n\n.mdi-seat-outline::before {\n  content: \"\\F0CC4\";\n}\n\n.mdi-seat-passenger::before {\n  content: \"\\F1249\";\n}\n\n.mdi-seat-recline-extra::before {\n  content: \"\\F0481\";\n}\n\n.mdi-seat-recline-normal::before {\n  content: \"\\F0482\";\n}\n\n.mdi-seatbelt::before {\n  content: \"\\F0CC5\";\n}\n\n.mdi-security::before {\n  content: \"\\F0483\";\n}\n\n.mdi-security-network::before {\n  content: \"\\F0484\";\n}\n\n.mdi-seed::before {\n  content: \"\\F0E62\";\n}\n\n.mdi-seed-outline::before {\n  content: \"\\F0E63\";\n}\n\n.mdi-segment::before {\n  content: \"\\F0ECB\";\n}\n\n.mdi-select::before {\n  content: \"\\F0485\";\n}\n\n.mdi-select-all::before {\n  content: \"\\F0486\";\n}\n\n.mdi-select-color::before {\n  content: \"\\F0D31\";\n}\n\n.mdi-select-compare::before {\n  content: \"\\F0AD9\";\n}\n\n.mdi-select-drag::before {\n  content: \"\\F0A6C\";\n}\n\n.mdi-select-group::before {\n  content: \"\\F0F82\";\n}\n\n.mdi-select-inverse::before {\n  content: \"\\F0487\";\n}\n\n.mdi-select-marker::before {\n  content: \"\\F1280\";\n}\n\n.mdi-select-multiple::before {\n  content: \"\\F1281\";\n}\n\n.mdi-select-multiple-marker::before {\n  content: \"\\F1282\";\n}\n\n.mdi-select-off::before {\n  content: \"\\F0488\";\n}\n\n.mdi-select-place::before {\n  content: \"\\F0FDA\";\n}\n\n.mdi-select-search::before {\n  content: \"\\F1204\";\n}\n\n.mdi-selection::before {\n  content: \"\\F0489\";\n}\n\n.mdi-selection-drag::before {\n  content: \"\\F0A6D\";\n}\n\n.mdi-selection-ellipse::before {\n  content: \"\\F0D32\";\n}\n\n.mdi-selection-ellipse-arrow-inside::before {\n  content: \"\\F0F22\";\n}\n\n.mdi-selection-marker::before {\n  content: \"\\F1283\";\n}\n\n.mdi-selection-multiple-marker::before {\n  content: \"\\F1284\";\n}\n\n.mdi-selection-mutliple::before {\n  content: \"\\F1285\";\n}\n\n.mdi-selection-off::before {\n  content: \"\\F0777\";\n}\n\n.mdi-selection-search::before {\n  content: \"\\F1205\";\n}\n\n.mdi-semantic-web::before {\n  content: \"\\F1316\";\n}\n\n.mdi-send::before {\n  content: \"\\F048A\";\n}\n\n.mdi-send-check::before {\n  content: \"\\F1161\";\n}\n\n.mdi-send-check-outline::before {\n  content: \"\\F1162\";\n}\n\n.mdi-send-circle::before {\n  content: \"\\F0DF8\";\n}\n\n.mdi-send-circle-outline::before {\n  content: \"\\F0DF9\";\n}\n\n.mdi-send-clock::before {\n  content: \"\\F1163\";\n}\n\n.mdi-send-clock-outline::before {\n  content: \"\\F1164\";\n}\n\n.mdi-send-lock::before {\n  content: \"\\F07ED\";\n}\n\n.mdi-send-lock-outline::before {\n  content: \"\\F1166\";\n}\n\n.mdi-send-outline::before {\n  content: \"\\F1165\";\n}\n\n.mdi-serial-port::before {\n  content: \"\\F065C\";\n}\n\n.mdi-server::before {\n  content: \"\\F048B\";\n}\n\n.mdi-server-minus::before {\n  content: \"\\F048C\";\n}\n\n.mdi-server-network::before {\n  content: \"\\F048D\";\n}\n\n.mdi-server-network-off::before {\n  content: \"\\F048E\";\n}\n\n.mdi-server-off::before {\n  content: \"\\F048F\";\n}\n\n.mdi-server-plus::before {\n  content: \"\\F0490\";\n}\n\n.mdi-server-remove::before {\n  content: \"\\F0491\";\n}\n\n.mdi-server-security::before {\n  content: \"\\F0492\";\n}\n\n.mdi-set-all::before {\n  content: \"\\F0778\";\n}\n\n.mdi-set-center::before {\n  content: \"\\F0779\";\n}\n\n.mdi-set-center-right::before {\n  content: \"\\F077A\";\n}\n\n.mdi-set-left::before {\n  content: \"\\F077B\";\n}\n\n.mdi-set-left-center::before {\n  content: \"\\F077C\";\n}\n\n.mdi-set-left-right::before {\n  content: \"\\F077D\";\n}\n\n.mdi-set-none::before {\n  content: \"\\F077E\";\n}\n\n.mdi-set-right::before {\n  content: \"\\F077F\";\n}\n\n.mdi-set-top-box::before {\n  content: \"\\F099F\";\n}\n\n.mdi-settings-helper::before {\n  content: \"\\F0A6E\";\n}\n\n.mdi-shaker::before {\n  content: \"\\F110E\";\n}\n\n.mdi-shaker-outline::before {\n  content: \"\\F110F\";\n}\n\n.mdi-shape::before {\n  content: \"\\F0831\";\n}\n\n.mdi-shape-circle-plus::before {\n  content: \"\\F065D\";\n}\n\n.mdi-shape-outline::before {\n  content: \"\\F0832\";\n}\n\n.mdi-shape-oval-plus::before {\n  content: \"\\F11FA\";\n}\n\n.mdi-shape-plus::before {\n  content: \"\\F0495\";\n}\n\n.mdi-shape-polygon-plus::before {\n  content: \"\\F065E\";\n}\n\n.mdi-shape-rectangle-plus::before {\n  content: \"\\F065F\";\n}\n\n.mdi-shape-square-plus::before {\n  content: \"\\F0660\";\n}\n\n.mdi-share::before {\n  content: \"\\F0496\";\n}\n\n.mdi-share-all::before {\n  content: \"\\F11F4\";\n}\n\n.mdi-share-all-outline::before {\n  content: \"\\F11F5\";\n}\n\n.mdi-share-circle::before {\n  content: \"\\F11AD\";\n}\n\n.mdi-share-off::before {\n  content: \"\\F0F23\";\n}\n\n.mdi-share-off-outline::before {\n  content: \"\\F0F24\";\n}\n\n.mdi-share-outline::before {\n  content: \"\\F0932\";\n}\n\n.mdi-share-variant::before {\n  content: \"\\F0497\";\n}\n\n.mdi-sheep::before {\n  content: \"\\F0CC6\";\n}\n\n.mdi-shield::before {\n  content: \"\\F0498\";\n}\n\n.mdi-shield-account::before {\n  content: \"\\F088F\";\n}\n\n.mdi-shield-account-outline::before {\n  content: \"\\F0A12\";\n}\n\n.mdi-shield-airplane::before {\n  content: \"\\F06BB\";\n}\n\n.mdi-shield-airplane-outline::before {\n  content: \"\\F0CC7\";\n}\n\n.mdi-shield-alert::before {\n  content: \"\\F0ECC\";\n}\n\n.mdi-shield-alert-outline::before {\n  content: \"\\F0ECD\";\n}\n\n.mdi-shield-car::before {\n  content: \"\\F0F83\";\n}\n\n.mdi-shield-check::before {\n  content: \"\\F0565\";\n}\n\n.mdi-shield-check-outline::before {\n  content: \"\\F0CC8\";\n}\n\n.mdi-shield-cross::before {\n  content: \"\\F0CC9\";\n}\n\n.mdi-shield-cross-outline::before {\n  content: \"\\F0CCA\";\n}\n\n.mdi-shield-edit::before {\n  content: \"\\F11A0\";\n}\n\n.mdi-shield-edit-outline::before {\n  content: \"\\F11A1\";\n}\n\n.mdi-shield-half::before {\n  content: \"\\F1360\";\n}\n\n.mdi-shield-half-full::before {\n  content: \"\\F0780\";\n}\n\n.mdi-shield-home::before {\n  content: \"\\F068A\";\n}\n\n.mdi-shield-home-outline::before {\n  content: \"\\F0CCB\";\n}\n\n.mdi-shield-key::before {\n  content: \"\\F0BC4\";\n}\n\n.mdi-shield-key-outline::before {\n  content: \"\\F0BC5\";\n}\n\n.mdi-shield-link-variant::before {\n  content: \"\\F0D33\";\n}\n\n.mdi-shield-link-variant-outline::before {\n  content: \"\\F0D34\";\n}\n\n.mdi-shield-lock::before {\n  content: \"\\F099D\";\n}\n\n.mdi-shield-lock-outline::before {\n  content: \"\\F0CCC\";\n}\n\n.mdi-shield-off::before {\n  content: \"\\F099E\";\n}\n\n.mdi-shield-off-outline::before {\n  content: \"\\F099C\";\n}\n\n.mdi-shield-outline::before {\n  content: \"\\F0499\";\n}\n\n.mdi-shield-plus::before {\n  content: \"\\F0ADA\";\n}\n\n.mdi-shield-plus-outline::before {\n  content: \"\\F0ADB\";\n}\n\n.mdi-shield-refresh::before {\n  content: \"\\F00AA\";\n}\n\n.mdi-shield-refresh-outline::before {\n  content: \"\\F01E0\";\n}\n\n.mdi-shield-remove::before {\n  content: \"\\F0ADC\";\n}\n\n.mdi-shield-remove-outline::before {\n  content: \"\\F0ADD\";\n}\n\n.mdi-shield-search::before {\n  content: \"\\F0D9A\";\n}\n\n.mdi-shield-star::before {\n  content: \"\\F113B\";\n}\n\n.mdi-shield-star-outline::before {\n  content: \"\\F113C\";\n}\n\n.mdi-shield-sun::before {\n  content: \"\\F105D\";\n}\n\n.mdi-shield-sun-outline::before {\n  content: \"\\F105E\";\n}\n\n.mdi-shield-sync::before {\n  content: \"\\F11A2\";\n}\n\n.mdi-shield-sync-outline::before {\n  content: \"\\F11A3\";\n}\n\n.mdi-ship-wheel::before {\n  content: \"\\F0833\";\n}\n\n.mdi-shoe-formal::before {\n  content: \"\\F0B47\";\n}\n\n.mdi-shoe-heel::before {\n  content: \"\\F0B48\";\n}\n\n.mdi-shoe-print::before {\n  content: \"\\F0DFA\";\n}\n\n.mdi-shopping::before {\n  content: \"\\F049A\";\n}\n\n.mdi-shopping-music::before {\n  content: \"\\F049B\";\n}\n\n.mdi-shopping-outline::before {\n  content: \"\\F11D5\";\n}\n\n.mdi-shopping-search::before {\n  content: \"\\F0F84\";\n}\n\n.mdi-shovel::before {\n  content: \"\\F0710\";\n}\n\n.mdi-shovel-off::before {\n  content: \"\\F0711\";\n}\n\n.mdi-shower::before {\n  content: \"\\F09A0\";\n}\n\n.mdi-shower-head::before {\n  content: \"\\F09A1\";\n}\n\n.mdi-shredder::before {\n  content: \"\\F049C\";\n}\n\n.mdi-shuffle::before {\n  content: \"\\F049D\";\n}\n\n.mdi-shuffle-disabled::before {\n  content: \"\\F049E\";\n}\n\n.mdi-shuffle-variant::before {\n  content: \"\\F049F\";\n}\n\n.mdi-shuriken::before {\n  content: \"\\F137F\";\n}\n\n.mdi-sigma::before {\n  content: \"\\F04A0\";\n}\n\n.mdi-sigma-lower::before {\n  content: \"\\F062B\";\n}\n\n.mdi-sign-caution::before {\n  content: \"\\F04A1\";\n}\n\n.mdi-sign-direction::before {\n  content: \"\\F0781\";\n}\n\n.mdi-sign-direction-minus::before {\n  content: \"\\F1000\";\n}\n\n.mdi-sign-direction-plus::before {\n  content: \"\\F0FDC\";\n}\n\n.mdi-sign-direction-remove::before {\n  content: \"\\F0FDD\";\n}\n\n.mdi-sign-real-estate::before {\n  content: \"\\F1118\";\n}\n\n.mdi-sign-text::before {\n  content: \"\\F0782\";\n}\n\n.mdi-signal::before {\n  content: \"\\F04A2\";\n}\n\n.mdi-signal-2g::before {\n  content: \"\\F0712\";\n}\n\n.mdi-signal-3g::before {\n  content: \"\\F0713\";\n}\n\n.mdi-signal-4g::before {\n  content: \"\\F0714\";\n}\n\n.mdi-signal-5g::before {\n  content: \"\\F0A6F\";\n}\n\n.mdi-signal-cellular-1::before {\n  content: \"\\F08BC\";\n}\n\n.mdi-signal-cellular-2::before {\n  content: \"\\F08BD\";\n}\n\n.mdi-signal-cellular-3::before {\n  content: \"\\F08BE\";\n}\n\n.mdi-signal-cellular-outline::before {\n  content: \"\\F08BF\";\n}\n\n.mdi-signal-distance-variant::before {\n  content: \"\\F0E64\";\n}\n\n.mdi-signal-hspa::before {\n  content: \"\\F0715\";\n}\n\n.mdi-signal-hspa-plus::before {\n  content: \"\\F0716\";\n}\n\n.mdi-signal-off::before {\n  content: \"\\F0783\";\n}\n\n.mdi-signal-variant::before {\n  content: \"\\F060A\";\n}\n\n.mdi-signature::before {\n  content: \"\\F0DFB\";\n}\n\n.mdi-signature-freehand::before {\n  content: \"\\F0DFC\";\n}\n\n.mdi-signature-image::before {\n  content: \"\\F0DFD\";\n}\n\n.mdi-signature-text::before {\n  content: \"\\F0DFE\";\n}\n\n.mdi-silo::before {\n  content: \"\\F0B49\";\n}\n\n.mdi-silverware::before {\n  content: \"\\F04A3\";\n}\n\n.mdi-silverware-clean::before {\n  content: \"\\F0FDE\";\n}\n\n.mdi-silverware-fork::before {\n  content: \"\\F04A4\";\n}\n\n.mdi-silverware-fork-knife::before {\n  content: \"\\F0A70\";\n}\n\n.mdi-silverware-spoon::before {\n  content: \"\\F04A5\";\n}\n\n.mdi-silverware-variant::before {\n  content: \"\\F04A6\";\n}\n\n.mdi-sim::before {\n  content: \"\\F04A7\";\n}\n\n.mdi-sim-alert::before {\n  content: \"\\F04A8\";\n}\n\n.mdi-sim-off::before {\n  content: \"\\F04A9\";\n}\n\n.mdi-simple-icons::before {\n  content: \"\\F131D\";\n}\n\n.mdi-sina-weibo::before {\n  content: \"\\F0ADF\";\n}\n\n.mdi-sitemap::before {\n  content: \"\\F04AA\";\n}\n\n.mdi-size-l::before {\n  content: \"\\F13A6\";\n}\n\n.mdi-size-m::before {\n  content: \"\\F13A5\";\n}\n\n.mdi-size-s::before {\n  content: \"\\F13A4\";\n}\n\n.mdi-size-xl::before {\n  content: \"\\F13A7\";\n}\n\n.mdi-size-xs::before {\n  content: \"\\F13A3\";\n}\n\n.mdi-size-xxl::before {\n  content: \"\\F13A8\";\n}\n\n.mdi-size-xxs::before {\n  content: \"\\F13A2\";\n}\n\n.mdi-size-xxxl::before {\n  content: \"\\F13A9\";\n}\n\n.mdi-skate::before {\n  content: \"\\F0D35\";\n}\n\n.mdi-skew-less::before {\n  content: \"\\F0D36\";\n}\n\n.mdi-skew-more::before {\n  content: \"\\F0D37\";\n}\n\n.mdi-ski::before {\n  content: \"\\F1304\";\n}\n\n.mdi-ski-cross-country::before {\n  content: \"\\F1305\";\n}\n\n.mdi-ski-water::before {\n  content: \"\\F1306\";\n}\n\n.mdi-skip-backward::before {\n  content: \"\\F04AB\";\n}\n\n.mdi-skip-backward-outline::before {\n  content: \"\\F0F25\";\n}\n\n.mdi-skip-forward::before {\n  content: \"\\F04AC\";\n}\n\n.mdi-skip-forward-outline::before {\n  content: \"\\F0F26\";\n}\n\n.mdi-skip-next::before {\n  content: \"\\F04AD\";\n}\n\n.mdi-skip-next-circle::before {\n  content: \"\\F0661\";\n}\n\n.mdi-skip-next-circle-outline::before {\n  content: \"\\F0662\";\n}\n\n.mdi-skip-next-outline::before {\n  content: \"\\F0F27\";\n}\n\n.mdi-skip-previous::before {\n  content: \"\\F04AE\";\n}\n\n.mdi-skip-previous-circle::before {\n  content: \"\\F0663\";\n}\n\n.mdi-skip-previous-circle-outline::before {\n  content: \"\\F0664\";\n}\n\n.mdi-skip-previous-outline::before {\n  content: \"\\F0F28\";\n}\n\n.mdi-skull::before {\n  content: \"\\F068C\";\n}\n\n.mdi-skull-crossbones::before {\n  content: \"\\F0BC6\";\n}\n\n.mdi-skull-crossbones-outline::before {\n  content: \"\\F0BC7\";\n}\n\n.mdi-skull-outline::before {\n  content: \"\\F0BC8\";\n}\n\n.mdi-skype::before {\n  content: \"\\F04AF\";\n}\n\n.mdi-skype-business::before {\n  content: \"\\F04B0\";\n}\n\n.mdi-slack::before {\n  content: \"\\F04B1\";\n}\n\n.mdi-slash-forward::before {\n  content: \"\\F0FDF\";\n}\n\n.mdi-slash-forward-box::before {\n  content: \"\\F0FE0\";\n}\n\n.mdi-sleep::before {\n  content: \"\\F04B2\";\n}\n\n.mdi-sleep-off::before {\n  content: \"\\F04B3\";\n}\n\n.mdi-slope-downhill::before {\n  content: \"\\F0DFF\";\n}\n\n.mdi-slope-uphill::before {\n  content: \"\\F0E00\";\n}\n\n.mdi-slot-machine::before {\n  content: \"\\F1114\";\n}\n\n.mdi-slot-machine-outline::before {\n  content: \"\\F1115\";\n}\n\n.mdi-smart-card::before {\n  content: \"\\F10BD\";\n}\n\n.mdi-smart-card-outline::before {\n  content: \"\\F10BE\";\n}\n\n.mdi-smart-card-reader::before {\n  content: \"\\F10BF\";\n}\n\n.mdi-smart-card-reader-outline::before {\n  content: \"\\F10C0\";\n}\n\n.mdi-smog::before {\n  content: \"\\F0A71\";\n}\n\n.mdi-smoke-detector::before {\n  content: \"\\F0392\";\n}\n\n.mdi-smoking::before {\n  content: \"\\F04B4\";\n}\n\n.mdi-smoking-off::before {\n  content: \"\\F04B5\";\n}\n\n.mdi-snapchat::before {\n  content: \"\\F04B6\";\n}\n\n.mdi-snowboard::before {\n  content: \"\\F1307\";\n}\n\n.mdi-snowflake::before {\n  content: \"\\F0717\";\n}\n\n.mdi-snowflake-alert::before {\n  content: \"\\F0F29\";\n}\n\n.mdi-snowflake-melt::before {\n  content: \"\\F12CB\";\n}\n\n.mdi-snowflake-variant::before {\n  content: \"\\F0F2A\";\n}\n\n.mdi-snowman::before {\n  content: \"\\F04B7\";\n}\n\n.mdi-soccer::before {\n  content: \"\\F04B8\";\n}\n\n.mdi-soccer-field::before {\n  content: \"\\F0834\";\n}\n\n.mdi-sofa::before {\n  content: \"\\F04B9\";\n}\n\n.mdi-solar-panel::before {\n  content: \"\\F0D9B\";\n}\n\n.mdi-solar-panel-large::before {\n  content: \"\\F0D9C\";\n}\n\n.mdi-solar-power::before {\n  content: \"\\F0A72\";\n}\n\n.mdi-soldering-iron::before {\n  content: \"\\F1092\";\n}\n\n.mdi-solid::before {\n  content: \"\\F068D\";\n}\n\n.mdi-sony-playstation::before {\n  content: \"\\F0414\";\n}\n\n.mdi-sort::before {\n  content: \"\\F04BA\";\n}\n\n.mdi-sort-alphabetical-ascending::before {\n  content: \"\\F05BD\";\n}\n\n.mdi-sort-alphabetical-ascending-variant::before {\n  content: \"\\F1148\";\n}\n\n.mdi-sort-alphabetical-descending::before {\n  content: \"\\F05BF\";\n}\n\n.mdi-sort-alphabetical-descending-variant::before {\n  content: \"\\F1149\";\n}\n\n.mdi-sort-alphabetical-variant::before {\n  content: \"\\F04BB\";\n}\n\n.mdi-sort-ascending::before {\n  content: \"\\F04BC\";\n}\n\n.mdi-sort-bool-ascending::before {\n  content: \"\\F1385\";\n}\n\n.mdi-sort-bool-ascending-variant::before {\n  content: \"\\F1386\";\n}\n\n.mdi-sort-bool-descending::before {\n  content: \"\\F1387\";\n}\n\n.mdi-sort-bool-descending-variant::before {\n  content: \"\\F1388\";\n}\n\n.mdi-sort-descending::before {\n  content: \"\\F04BD\";\n}\n\n.mdi-sort-numeric-ascending::before {\n  content: \"\\F1389\";\n}\n\n.mdi-sort-numeric-ascending-variant::before {\n  content: \"\\F090D\";\n}\n\n.mdi-sort-numeric-descending::before {\n  content: \"\\F138A\";\n}\n\n.mdi-sort-numeric-descending-variant::before {\n  content: \"\\F0AD2\";\n}\n\n.mdi-sort-numeric-variant::before {\n  content: \"\\F04BE\";\n}\n\n.mdi-sort-reverse-variant::before {\n  content: \"\\F033C\";\n}\n\n.mdi-sort-variant::before {\n  content: \"\\F04BF\";\n}\n\n.mdi-sort-variant-lock::before {\n  content: \"\\F0CCD\";\n}\n\n.mdi-sort-variant-lock-open::before {\n  content: \"\\F0CCE\";\n}\n\n.mdi-sort-variant-remove::before {\n  content: \"\\F1147\";\n}\n\n.mdi-soundcloud::before {\n  content: \"\\F04C0\";\n}\n\n.mdi-source-branch::before {\n  content: \"\\F062C\";\n}\n\n.mdi-source-commit::before {\n  content: \"\\F0718\";\n}\n\n.mdi-source-commit-end::before {\n  content: \"\\F0719\";\n}\n\n.mdi-source-commit-end-local::before {\n  content: \"\\F071A\";\n}\n\n.mdi-source-commit-local::before {\n  content: \"\\F071B\";\n}\n\n.mdi-source-commit-next-local::before {\n  content: \"\\F071C\";\n}\n\n.mdi-source-commit-start::before {\n  content: \"\\F071D\";\n}\n\n.mdi-source-commit-start-next-local::before {\n  content: \"\\F071E\";\n}\n\n.mdi-source-fork::before {\n  content: \"\\F04C1\";\n}\n\n.mdi-source-merge::before {\n  content: \"\\F062D\";\n}\n\n.mdi-source-pull::before {\n  content: \"\\F04C2\";\n}\n\n.mdi-source-repository::before {\n  content: \"\\F0CCF\";\n}\n\n.mdi-source-repository-multiple::before {\n  content: \"\\F0CD0\";\n}\n\n.mdi-soy-sauce::before {\n  content: \"\\F07EE\";\n}\n\n.mdi-spa::before {\n  content: \"\\F0CD1\";\n}\n\n.mdi-spa-outline::before {\n  content: \"\\F0CD2\";\n}\n\n.mdi-space-invaders::before {\n  content: \"\\F0BC9\";\n}\n\n.mdi-space-station::before {\n  content: \"\\F1383\";\n}\n\n.mdi-spade::before {\n  content: \"\\F0E65\";\n}\n\n.mdi-speaker::before {\n  content: \"\\F04C3\";\n}\n\n.mdi-speaker-bluetooth::before {\n  content: \"\\F09A2\";\n}\n\n.mdi-speaker-multiple::before {\n  content: \"\\F0D38\";\n}\n\n.mdi-speaker-off::before {\n  content: \"\\F04C4\";\n}\n\n.mdi-speaker-wireless::before {\n  content: \"\\F071F\";\n}\n\n.mdi-speedometer::before {\n  content: \"\\F04C5\";\n}\n\n.mdi-speedometer-medium::before {\n  content: \"\\F0F85\";\n}\n\n.mdi-speedometer-slow::before {\n  content: \"\\F0F86\";\n}\n\n.mdi-spellcheck::before {\n  content: \"\\F04C6\";\n}\n\n.mdi-spider::before {\n  content: \"\\F11EA\";\n}\n\n.mdi-spider-thread::before {\n  content: \"\\F11EB\";\n}\n\n.mdi-spider-web::before {\n  content: \"\\F0BCA\";\n}\n\n.mdi-spotify::before {\n  content: \"\\F04C7\";\n}\n\n.mdi-spotlight::before {\n  content: \"\\F04C8\";\n}\n\n.mdi-spotlight-beam::before {\n  content: \"\\F04C9\";\n}\n\n.mdi-spray::before {\n  content: \"\\F0665\";\n}\n\n.mdi-spray-bottle::before {\n  content: \"\\F0AE0\";\n}\n\n.mdi-sprinkler::before {\n  content: \"\\F105F\";\n}\n\n.mdi-sprinkler-variant::before {\n  content: \"\\F1060\";\n}\n\n.mdi-sprout::before {\n  content: \"\\F0E66\";\n}\n\n.mdi-sprout-outline::before {\n  content: \"\\F0E67\";\n}\n\n.mdi-square::before {\n  content: \"\\F0764\";\n}\n\n.mdi-square-edit-outline::before {\n  content: \"\\F090C\";\n}\n\n.mdi-square-medium::before {\n  content: \"\\F0A13\";\n}\n\n.mdi-square-medium-outline::before {\n  content: \"\\F0A14\";\n}\n\n.mdi-square-off::before {\n  content: \"\\F12EE\";\n}\n\n.mdi-square-off-outline::before {\n  content: \"\\F12EF\";\n}\n\n.mdi-square-outline::before {\n  content: \"\\F0763\";\n}\n\n.mdi-square-root::before {\n  content: \"\\F0784\";\n}\n\n.mdi-square-root-box::before {\n  content: \"\\F09A3\";\n}\n\n.mdi-square-small::before {\n  content: \"\\F0A15\";\n}\n\n.mdi-squeegee::before {\n  content: \"\\F0AE1\";\n}\n\n.mdi-ssh::before {\n  content: \"\\F08C0\";\n}\n\n.mdi-stack-exchange::before {\n  content: \"\\F060B\";\n}\n\n.mdi-stack-overflow::before {\n  content: \"\\F04CC\";\n}\n\n.mdi-stackpath::before {\n  content: \"\\F0359\";\n}\n\n.mdi-stadium::before {\n  content: \"\\F0FF9\";\n}\n\n.mdi-stadium-variant::before {\n  content: \"\\F0720\";\n}\n\n.mdi-stairs::before {\n  content: \"\\F04CD\";\n}\n\n.mdi-stairs-box::before {\n  content: \"\\F139E\";\n}\n\n.mdi-stairs-down::before {\n  content: \"\\F12BE\";\n}\n\n.mdi-stairs-up::before {\n  content: \"\\F12BD\";\n}\n\n.mdi-stamper::before {\n  content: \"\\F0D39\";\n}\n\n.mdi-standard-definition::before {\n  content: \"\\F07EF\";\n}\n\n.mdi-star::before {\n  content: \"\\F04CE\";\n}\n\n.mdi-star-box::before {\n  content: \"\\F0A73\";\n}\n\n.mdi-star-box-multiple::before {\n  content: \"\\F1286\";\n}\n\n.mdi-star-box-multiple-outline::before {\n  content: \"\\F1287\";\n}\n\n.mdi-star-box-outline::before {\n  content: \"\\F0A74\";\n}\n\n.mdi-star-circle::before {\n  content: \"\\F04CF\";\n}\n\n.mdi-star-circle-outline::before {\n  content: \"\\F09A4\";\n}\n\n.mdi-star-face::before {\n  content: \"\\F09A5\";\n}\n\n.mdi-star-four-points::before {\n  content: \"\\F0AE2\";\n}\n\n.mdi-star-four-points-outline::before {\n  content: \"\\F0AE3\";\n}\n\n.mdi-star-half::before {\n  content: \"\\F0246\";\n}\n\n.mdi-star-half-full::before {\n  content: \"\\F04D0\";\n}\n\n.mdi-star-off::before {\n  content: \"\\F04D1\";\n}\n\n.mdi-star-outline::before {\n  content: \"\\F04D2\";\n}\n\n.mdi-star-three-points::before {\n  content: \"\\F0AE4\";\n}\n\n.mdi-star-three-points-outline::before {\n  content: \"\\F0AE5\";\n}\n\n.mdi-state-machine::before {\n  content: \"\\F11EF\";\n}\n\n.mdi-steam::before {\n  content: \"\\F04D3\";\n}\n\n.mdi-steering::before {\n  content: \"\\F04D4\";\n}\n\n.mdi-steering-off::before {\n  content: \"\\F090E\";\n}\n\n.mdi-step-backward::before {\n  content: \"\\F04D5\";\n}\n\n.mdi-step-backward-2::before {\n  content: \"\\F04D6\";\n}\n\n.mdi-step-forward::before {\n  content: \"\\F04D7\";\n}\n\n.mdi-step-forward-2::before {\n  content: \"\\F04D8\";\n}\n\n.mdi-stethoscope::before {\n  content: \"\\F04D9\";\n}\n\n.mdi-sticker::before {\n  content: \"\\F1364\";\n}\n\n.mdi-sticker-alert::before {\n  content: \"\\F1365\";\n}\n\n.mdi-sticker-alert-outline::before {\n  content: \"\\F1366\";\n}\n\n.mdi-sticker-check::before {\n  content: \"\\F1367\";\n}\n\n.mdi-sticker-check-outline::before {\n  content: \"\\F1368\";\n}\n\n.mdi-sticker-circle-outline::before {\n  content: \"\\F05D0\";\n}\n\n.mdi-sticker-emoji::before {\n  content: \"\\F0785\";\n}\n\n.mdi-sticker-minus::before {\n  content: \"\\F1369\";\n}\n\n.mdi-sticker-minus-outline::before {\n  content: \"\\F136A\";\n}\n\n.mdi-sticker-outline::before {\n  content: \"\\F136B\";\n}\n\n.mdi-sticker-plus::before {\n  content: \"\\F136C\";\n}\n\n.mdi-sticker-plus-outline::before {\n  content: \"\\F136D\";\n}\n\n.mdi-sticker-remove::before {\n  content: \"\\F136E\";\n}\n\n.mdi-sticker-remove-outline::before {\n  content: \"\\F136F\";\n}\n\n.mdi-stocking::before {\n  content: \"\\F04DA\";\n}\n\n.mdi-stomach::before {\n  content: \"\\F1093\";\n}\n\n.mdi-stop::before {\n  content: \"\\F04DB\";\n}\n\n.mdi-stop-circle::before {\n  content: \"\\F0666\";\n}\n\n.mdi-stop-circle-outline::before {\n  content: \"\\F0667\";\n}\n\n.mdi-store::before {\n  content: \"\\F04DC\";\n}\n\n.mdi-store-24-hour::before {\n  content: \"\\F04DD\";\n}\n\n.mdi-store-outline::before {\n  content: \"\\F1361\";\n}\n\n.mdi-storefront::before {\n  content: \"\\F07C7\";\n}\n\n.mdi-storefront-outline::before {\n  content: \"\\F10C1\";\n}\n\n.mdi-stove::before {\n  content: \"\\F04DE\";\n}\n\n.mdi-strategy::before {\n  content: \"\\F11D6\";\n}\n\n.mdi-stretch-to-page::before {\n  content: \"\\F0F2B\";\n}\n\n.mdi-stretch-to-page-outline::before {\n  content: \"\\F0F2C\";\n}\n\n.mdi-string-lights::before {\n  content: \"\\F12BA\";\n}\n\n.mdi-string-lights-off::before {\n  content: \"\\F12BB\";\n}\n\n.mdi-subdirectory-arrow-left::before {\n  content: \"\\F060C\";\n}\n\n.mdi-subdirectory-arrow-right::before {\n  content: \"\\F060D\";\n}\n\n.mdi-subtitles::before {\n  content: \"\\F0A16\";\n}\n\n.mdi-subtitles-outline::before {\n  content: \"\\F0A17\";\n}\n\n.mdi-subway::before {\n  content: \"\\F06AC\";\n}\n\n.mdi-subway-alert-variant::before {\n  content: \"\\F0D9D\";\n}\n\n.mdi-subway-variant::before {\n  content: \"\\F04DF\";\n}\n\n.mdi-summit::before {\n  content: \"\\F0786\";\n}\n\n.mdi-sunglasses::before {\n  content: \"\\F04E0\";\n}\n\n.mdi-surround-sound::before {\n  content: \"\\F05C5\";\n}\n\n.mdi-surround-sound-2-0::before {\n  content: \"\\F07F0\";\n}\n\n.mdi-surround-sound-3-1::before {\n  content: \"\\F07F1\";\n}\n\n.mdi-surround-sound-5-1::before {\n  content: \"\\F07F2\";\n}\n\n.mdi-surround-sound-7-1::before {\n  content: \"\\F07F3\";\n}\n\n.mdi-svg::before {\n  content: \"\\F0721\";\n}\n\n.mdi-swap-horizontal::before {\n  content: \"\\F04E1\";\n}\n\n.mdi-swap-horizontal-bold::before {\n  content: \"\\F0BCD\";\n}\n\n.mdi-swap-horizontal-circle::before {\n  content: \"\\F0FE1\";\n}\n\n.mdi-swap-horizontal-circle-outline::before {\n  content: \"\\F0FE2\";\n}\n\n.mdi-swap-horizontal-variant::before {\n  content: \"\\F08C1\";\n}\n\n.mdi-swap-vertical::before {\n  content: \"\\F04E2\";\n}\n\n.mdi-swap-vertical-bold::before {\n  content: \"\\F0BCE\";\n}\n\n.mdi-swap-vertical-circle::before {\n  content: \"\\F0FE3\";\n}\n\n.mdi-swap-vertical-circle-outline::before {\n  content: \"\\F0FE4\";\n}\n\n.mdi-swap-vertical-variant::before {\n  content: \"\\F08C2\";\n}\n\n.mdi-swim::before {\n  content: \"\\F04E3\";\n}\n\n.mdi-switch::before {\n  content: \"\\F04E4\";\n}\n\n.mdi-sword::before {\n  content: \"\\F04E5\";\n}\n\n.mdi-sword-cross::before {\n  content: \"\\F0787\";\n}\n\n.mdi-syllabary-hangul::before {\n  content: \"\\F1333\";\n}\n\n.mdi-syllabary-hiragana::before {\n  content: \"\\F1334\";\n}\n\n.mdi-syllabary-katakana::before {\n  content: \"\\F1335\";\n}\n\n.mdi-syllabary-katakana-half-width::before {\n  content: \"\\F1336\";\n}\n\n.mdi-symfony::before {\n  content: \"\\F0AE6\";\n}\n\n.mdi-sync::before {\n  content: \"\\F04E6\";\n}\n\n.mdi-sync-alert::before {\n  content: \"\\F04E7\";\n}\n\n.mdi-sync-circle::before {\n  content: \"\\F1378\";\n}\n\n.mdi-sync-off::before {\n  content: \"\\F04E8\";\n}\n\n.mdi-tab::before {\n  content: \"\\F04E9\";\n}\n\n.mdi-tab-minus::before {\n  content: \"\\F0B4B\";\n}\n\n.mdi-tab-plus::before {\n  content: \"\\F075C\";\n}\n\n.mdi-tab-remove::before {\n  content: \"\\F0B4C\";\n}\n\n.mdi-tab-unselected::before {\n  content: \"\\F04EA\";\n}\n\n.mdi-table::before {\n  content: \"\\F04EB\";\n}\n\n.mdi-table-border::before {\n  content: \"\\F0A18\";\n}\n\n.mdi-table-chair::before {\n  content: \"\\F1061\";\n}\n\n.mdi-table-column::before {\n  content: \"\\F0835\";\n}\n\n.mdi-table-column-plus-after::before {\n  content: \"\\F04EC\";\n}\n\n.mdi-table-column-plus-before::before {\n  content: \"\\F04ED\";\n}\n\n.mdi-table-column-remove::before {\n  content: \"\\F04EE\";\n}\n\n.mdi-table-column-width::before {\n  content: \"\\F04EF\";\n}\n\n.mdi-table-edit::before {\n  content: \"\\F04F0\";\n}\n\n.mdi-table-eye::before {\n  content: \"\\F1094\";\n}\n\n.mdi-table-furniture::before {\n  content: \"\\F05BC\";\n}\n\n.mdi-table-headers-eye::before {\n  content: \"\\F121D\";\n}\n\n.mdi-table-headers-eye-off::before {\n  content: \"\\F121E\";\n}\n\n.mdi-table-large::before {\n  content: \"\\F04F1\";\n}\n\n.mdi-table-large-plus::before {\n  content: \"\\F0F87\";\n}\n\n.mdi-table-large-remove::before {\n  content: \"\\F0F88\";\n}\n\n.mdi-table-merge-cells::before {\n  content: \"\\F09A6\";\n}\n\n.mdi-table-of-contents::before {\n  content: \"\\F0836\";\n}\n\n.mdi-table-plus::before {\n  content: \"\\F0A75\";\n}\n\n.mdi-table-refresh::before {\n  content: \"\\F13A0\";\n}\n\n.mdi-table-remove::before {\n  content: \"\\F0A76\";\n}\n\n.mdi-table-row::before {\n  content: \"\\F0837\";\n}\n\n.mdi-table-row-height::before {\n  content: \"\\F04F2\";\n}\n\n.mdi-table-row-plus-after::before {\n  content: \"\\F04F3\";\n}\n\n.mdi-table-row-plus-before::before {\n  content: \"\\F04F4\";\n}\n\n.mdi-table-row-remove::before {\n  content: \"\\F04F5\";\n}\n\n.mdi-table-search::before {\n  content: \"\\F090F\";\n}\n\n.mdi-table-settings::before {\n  content: \"\\F0838\";\n}\n\n.mdi-table-sync::before {\n  content: \"\\F13A1\";\n}\n\n.mdi-table-tennis::before {\n  content: \"\\F0E68\";\n}\n\n.mdi-tablet::before {\n  content: \"\\F04F6\";\n}\n\n.mdi-tablet-android::before {\n  content: \"\\F04F7\";\n}\n\n.mdi-tablet-cellphone::before {\n  content: \"\\F09A7\";\n}\n\n.mdi-tablet-dashboard::before {\n  content: \"\\F0ECE\";\n}\n\n.mdi-tablet-ipad::before {\n  content: \"\\F04F8\";\n}\n\n.mdi-taco::before {\n  content: \"\\F0762\";\n}\n\n.mdi-tag::before {\n  content: \"\\F04F9\";\n}\n\n.mdi-tag-faces::before {\n  content: \"\\F04FA\";\n}\n\n.mdi-tag-heart::before {\n  content: \"\\F068B\";\n}\n\n.mdi-tag-heart-outline::before {\n  content: \"\\F0BCF\";\n}\n\n.mdi-tag-minus::before {\n  content: \"\\F0910\";\n}\n\n.mdi-tag-minus-outline::before {\n  content: \"\\F121F\";\n}\n\n.mdi-tag-multiple::before {\n  content: \"\\F04FB\";\n}\n\n.mdi-tag-multiple-outline::before {\n  content: \"\\F12F7\";\n}\n\n.mdi-tag-off::before {\n  content: \"\\F1220\";\n}\n\n.mdi-tag-off-outline::before {\n  content: \"\\F1221\";\n}\n\n.mdi-tag-outline::before {\n  content: \"\\F04FC\";\n}\n\n.mdi-tag-plus::before {\n  content: \"\\F0722\";\n}\n\n.mdi-tag-plus-outline::before {\n  content: \"\\F1222\";\n}\n\n.mdi-tag-remove::before {\n  content: \"\\F0723\";\n}\n\n.mdi-tag-remove-outline::before {\n  content: \"\\F1223\";\n}\n\n.mdi-tag-text::before {\n  content: \"\\F1224\";\n}\n\n.mdi-tag-text-outline::before {\n  content: \"\\F04FD\";\n}\n\n.mdi-tank::before {\n  content: \"\\F0D3A\";\n}\n\n.mdi-tanker-truck::before {\n  content: \"\\F0FE5\";\n}\n\n.mdi-tape-measure::before {\n  content: \"\\F0B4D\";\n}\n\n.mdi-target::before {\n  content: \"\\F04FE\";\n}\n\n.mdi-target-account::before {\n  content: \"\\F0BD0\";\n}\n\n.mdi-target-variant::before {\n  content: \"\\F0A77\";\n}\n\n.mdi-taxi::before {\n  content: \"\\F04FF\";\n}\n\n.mdi-tea::before {\n  content: \"\\F0D9E\";\n}\n\n.mdi-tea-outline::before {\n  content: \"\\F0D9F\";\n}\n\n.mdi-teach::before {\n  content: \"\\F0890\";\n}\n\n.mdi-teamviewer::before {\n  content: \"\\F0500\";\n}\n\n.mdi-telegram::before {\n  content: \"\\F0501\";\n}\n\n.mdi-telescope::before {\n  content: \"\\F0B4E\";\n}\n\n.mdi-television::before {\n  content: \"\\F0502\";\n}\n\n.mdi-television-ambient-light::before {\n  content: \"\\F1356\";\n}\n\n.mdi-television-box::before {\n  content: \"\\F0839\";\n}\n\n.mdi-television-classic::before {\n  content: \"\\F07F4\";\n}\n\n.mdi-television-classic-off::before {\n  content: \"\\F083A\";\n}\n\n.mdi-television-clean::before {\n  content: \"\\F1110\";\n}\n\n.mdi-television-guide::before {\n  content: \"\\F0503\";\n}\n\n.mdi-television-off::before {\n  content: \"\\F083B\";\n}\n\n.mdi-television-pause::before {\n  content: \"\\F0F89\";\n}\n\n.mdi-television-play::before {\n  content: \"\\F0ECF\";\n}\n\n.mdi-television-stop::before {\n  content: \"\\F0F8A\";\n}\n\n.mdi-temperature-celsius::before {\n  content: \"\\F0504\";\n}\n\n.mdi-temperature-fahrenheit::before {\n  content: \"\\F0505\";\n}\n\n.mdi-temperature-kelvin::before {\n  content: \"\\F0506\";\n}\n\n.mdi-tennis::before {\n  content: \"\\F0DA0\";\n}\n\n.mdi-tennis-ball::before {\n  content: \"\\F0507\";\n}\n\n.mdi-tent::before {\n  content: \"\\F0508\";\n}\n\n.mdi-terraform::before {\n  content: \"\\F1062\";\n}\n\n.mdi-terrain::before {\n  content: \"\\F0509\";\n}\n\n.mdi-test-tube::before {\n  content: \"\\F0668\";\n}\n\n.mdi-test-tube-empty::before {\n  content: \"\\F0911\";\n}\n\n.mdi-test-tube-off::before {\n  content: \"\\F0912\";\n}\n\n.mdi-text::before {\n  content: \"\\F09A8\";\n}\n\n.mdi-text-box::before {\n  content: \"\\F021A\";\n}\n\n.mdi-text-box-check::before {\n  content: \"\\F0EA6\";\n}\n\n.mdi-text-box-check-outline::before {\n  content: \"\\F0EA7\";\n}\n\n.mdi-text-box-minus::before {\n  content: \"\\F0EA8\";\n}\n\n.mdi-text-box-minus-outline::before {\n  content: \"\\F0EA9\";\n}\n\n.mdi-text-box-multiple::before {\n  content: \"\\F0AB7\";\n}\n\n.mdi-text-box-multiple-outline::before {\n  content: \"\\F0AB8\";\n}\n\n.mdi-text-box-outline::before {\n  content: \"\\F09ED\";\n}\n\n.mdi-text-box-plus::before {\n  content: \"\\F0EAA\";\n}\n\n.mdi-text-box-plus-outline::before {\n  content: \"\\F0EAB\";\n}\n\n.mdi-text-box-remove::before {\n  content: \"\\F0EAC\";\n}\n\n.mdi-text-box-remove-outline::before {\n  content: \"\\F0EAD\";\n}\n\n.mdi-text-box-search::before {\n  content: \"\\F0EAE\";\n}\n\n.mdi-text-box-search-outline::before {\n  content: \"\\F0EAF\";\n}\n\n.mdi-text-recognition::before {\n  content: \"\\F113D\";\n}\n\n.mdi-text-shadow::before {\n  content: \"\\F0669\";\n}\n\n.mdi-text-short::before {\n  content: \"\\F09A9\";\n}\n\n.mdi-text-subject::before {\n  content: \"\\F09AA\";\n}\n\n.mdi-text-to-speech::before {\n  content: \"\\F050A\";\n}\n\n.mdi-text-to-speech-off::before {\n  content: \"\\F050B\";\n}\n\n.mdi-textarea::before {\n  content: \"\\F1095\";\n}\n\n.mdi-textbox::before {\n  content: \"\\F060E\";\n}\n\n.mdi-textbox-lock::before {\n  content: \"\\F135D\";\n}\n\n.mdi-textbox-password::before {\n  content: \"\\F07F5\";\n}\n\n.mdi-texture::before {\n  content: \"\\F050C\";\n}\n\n.mdi-texture-box::before {\n  content: \"\\F0FE6\";\n}\n\n.mdi-theater::before {\n  content: \"\\F050D\";\n}\n\n.mdi-theme-light-dark::before {\n  content: \"\\F050E\";\n}\n\n.mdi-thermometer::before {\n  content: \"\\F050F\";\n}\n\n.mdi-thermometer-alert::before {\n  content: \"\\F0E01\";\n}\n\n.mdi-thermometer-chevron-down::before {\n  content: \"\\F0E02\";\n}\n\n.mdi-thermometer-chevron-up::before {\n  content: \"\\F0E03\";\n}\n\n.mdi-thermometer-high::before {\n  content: \"\\F10C2\";\n}\n\n.mdi-thermometer-lines::before {\n  content: \"\\F0510\";\n}\n\n.mdi-thermometer-low::before {\n  content: \"\\F10C3\";\n}\n\n.mdi-thermometer-minus::before {\n  content: \"\\F0E04\";\n}\n\n.mdi-thermometer-plus::before {\n  content: \"\\F0E05\";\n}\n\n.mdi-thermostat::before {\n  content: \"\\F0393\";\n}\n\n.mdi-thermostat-box::before {\n  content: \"\\F0891\";\n}\n\n.mdi-thought-bubble::before {\n  content: \"\\F07F6\";\n}\n\n.mdi-thought-bubble-outline::before {\n  content: \"\\F07F7\";\n}\n\n.mdi-thumb-down::before {\n  content: \"\\F0511\";\n}\n\n.mdi-thumb-down-outline::before {\n  content: \"\\F0512\";\n}\n\n.mdi-thumb-up::before {\n  content: \"\\F0513\";\n}\n\n.mdi-thumb-up-outline::before {\n  content: \"\\F0514\";\n}\n\n.mdi-thumbs-up-down::before {\n  content: \"\\F0515\";\n}\n\n.mdi-ticket::before {\n  content: \"\\F0516\";\n}\n\n.mdi-ticket-account::before {\n  content: \"\\F0517\";\n}\n\n.mdi-ticket-confirmation::before {\n  content: \"\\F0518\";\n}\n\n.mdi-ticket-confirmation-outline::before {\n  content: \"\\F13AA\";\n}\n\n.mdi-ticket-outline::before {\n  content: \"\\F0913\";\n}\n\n.mdi-ticket-percent::before {\n  content: \"\\F0724\";\n}\n\n.mdi-tie::before {\n  content: \"\\F0519\";\n}\n\n.mdi-tilde::before {\n  content: \"\\F0725\";\n}\n\n.mdi-timelapse::before {\n  content: \"\\F051A\";\n}\n\n.mdi-timeline::before {\n  content: \"\\F0BD1\";\n}\n\n.mdi-timeline-alert::before {\n  content: \"\\F0F95\";\n}\n\n.mdi-timeline-alert-outline::before {\n  content: \"\\F0F98\";\n}\n\n.mdi-timeline-clock::before {\n  content: \"\\F11FB\";\n}\n\n.mdi-timeline-clock-outline::before {\n  content: \"\\F11FC\";\n}\n\n.mdi-timeline-help::before {\n  content: \"\\F0F99\";\n}\n\n.mdi-timeline-help-outline::before {\n  content: \"\\F0F9A\";\n}\n\n.mdi-timeline-outline::before {\n  content: \"\\F0BD2\";\n}\n\n.mdi-timeline-plus::before {\n  content: \"\\F0F96\";\n}\n\n.mdi-timeline-plus-outline::before {\n  content: \"\\F0F97\";\n}\n\n.mdi-timeline-text::before {\n  content: \"\\F0BD3\";\n}\n\n.mdi-timeline-text-outline::before {\n  content: \"\\F0BD4\";\n}\n\n.mdi-timer::before {\n  content: \"\\F13AB\";\n}\n\n.mdi-timer-10::before {\n  content: \"\\F051C\";\n}\n\n.mdi-timer-3::before {\n  content: \"\\F051D\";\n}\n\n.mdi-timer-off::before {\n  content: \"\\F13AC\";\n}\n\n.mdi-timer-off-outline::before {\n  content: \"\\F051E\";\n}\n\n.mdi-timer-outline::before {\n  content: \"\\F051B\";\n}\n\n.mdi-timer-sand::before {\n  content: \"\\F051F\";\n}\n\n.mdi-timer-sand-empty::before {\n  content: \"\\F06AD\";\n}\n\n.mdi-timer-sand-full::before {\n  content: \"\\F078C\";\n}\n\n.mdi-timetable::before {\n  content: \"\\F0520\";\n}\n\n.mdi-toaster::before {\n  content: \"\\F1063\";\n}\n\n.mdi-toaster-off::before {\n  content: \"\\F11B7\";\n}\n\n.mdi-toaster-oven::before {\n  content: \"\\F0CD3\";\n}\n\n.mdi-toggle-switch::before {\n  content: \"\\F0521\";\n}\n\n.mdi-toggle-switch-off::before {\n  content: \"\\F0522\";\n}\n\n.mdi-toggle-switch-off-outline::before {\n  content: \"\\F0A19\";\n}\n\n.mdi-toggle-switch-outline::before {\n  content: \"\\F0A1A\";\n}\n\n.mdi-toilet::before {\n  content: \"\\F09AB\";\n}\n\n.mdi-toolbox::before {\n  content: \"\\F09AC\";\n}\n\n.mdi-toolbox-outline::before {\n  content: \"\\F09AD\";\n}\n\n.mdi-tools::before {\n  content: \"\\F1064\";\n}\n\n.mdi-tooltip::before {\n  content: \"\\F0523\";\n}\n\n.mdi-tooltip-account::before {\n  content: \"\\F000C\";\n}\n\n.mdi-tooltip-edit::before {\n  content: \"\\F0524\";\n}\n\n.mdi-tooltip-edit-outline::before {\n  content: \"\\F12C5\";\n}\n\n.mdi-tooltip-image::before {\n  content: \"\\F0525\";\n}\n\n.mdi-tooltip-image-outline::before {\n  content: \"\\F0BD5\";\n}\n\n.mdi-tooltip-outline::before {\n  content: \"\\F0526\";\n}\n\n.mdi-tooltip-plus::before {\n  content: \"\\F0BD6\";\n}\n\n.mdi-tooltip-plus-outline::before {\n  content: \"\\F0527\";\n}\n\n.mdi-tooltip-text::before {\n  content: \"\\F0528\";\n}\n\n.mdi-tooltip-text-outline::before {\n  content: \"\\F0BD7\";\n}\n\n.mdi-tooth::before {\n  content: \"\\F08C3\";\n}\n\n.mdi-tooth-outline::before {\n  content: \"\\F0529\";\n}\n\n.mdi-toothbrush::before {\n  content: \"\\F1129\";\n}\n\n.mdi-toothbrush-electric::before {\n  content: \"\\F112C\";\n}\n\n.mdi-toothbrush-paste::before {\n  content: \"\\F112A\";\n}\n\n.mdi-tortoise::before {\n  content: \"\\F0D3B\";\n}\n\n.mdi-toslink::before {\n  content: \"\\F12B8\";\n}\n\n.mdi-tournament::before {\n  content: \"\\F09AE\";\n}\n\n.mdi-tow-truck::before {\n  content: \"\\F083C\";\n}\n\n.mdi-tower-beach::before {\n  content: \"\\F0681\";\n}\n\n.mdi-tower-fire::before {\n  content: \"\\F0682\";\n}\n\n.mdi-toy-brick::before {\n  content: \"\\F1288\";\n}\n\n.mdi-toy-brick-marker::before {\n  content: \"\\F1289\";\n}\n\n.mdi-toy-brick-marker-outline::before {\n  content: \"\\F128A\";\n}\n\n.mdi-toy-brick-minus::before {\n  content: \"\\F128B\";\n}\n\n.mdi-toy-brick-minus-outline::before {\n  content: \"\\F128C\";\n}\n\n.mdi-toy-brick-outline::before {\n  content: \"\\F128D\";\n}\n\n.mdi-toy-brick-plus::before {\n  content: \"\\F128E\";\n}\n\n.mdi-toy-brick-plus-outline::before {\n  content: \"\\F128F\";\n}\n\n.mdi-toy-brick-remove::before {\n  content: \"\\F1290\";\n}\n\n.mdi-toy-brick-remove-outline::before {\n  content: \"\\F1291\";\n}\n\n.mdi-toy-brick-search::before {\n  content: \"\\F1292\";\n}\n\n.mdi-toy-brick-search-outline::before {\n  content: \"\\F1293\";\n}\n\n.mdi-track-light::before {\n  content: \"\\F0914\";\n}\n\n.mdi-trackpad::before {\n  content: \"\\F07F8\";\n}\n\n.mdi-trackpad-lock::before {\n  content: \"\\F0933\";\n}\n\n.mdi-tractor::before {\n  content: \"\\F0892\";\n}\n\n.mdi-trademark::before {\n  content: \"\\F0A78\";\n}\n\n.mdi-traffic-cone::before {\n  content: \"\\F137C\";\n}\n\n.mdi-traffic-light::before {\n  content: \"\\F052B\";\n}\n\n.mdi-train::before {\n  content: \"\\F052C\";\n}\n\n.mdi-train-car::before {\n  content: \"\\F0BD8\";\n}\n\n.mdi-train-variant::before {\n  content: \"\\F08C4\";\n}\n\n.mdi-tram::before {\n  content: \"\\F052D\";\n}\n\n.mdi-tram-side::before {\n  content: \"\\F0FE7\";\n}\n\n.mdi-transcribe::before {\n  content: \"\\F052E\";\n}\n\n.mdi-transcribe-close::before {\n  content: \"\\F052F\";\n}\n\n.mdi-transfer::before {\n  content: \"\\F1065\";\n}\n\n.mdi-transfer-down::before {\n  content: \"\\F0DA1\";\n}\n\n.mdi-transfer-left::before {\n  content: \"\\F0DA2\";\n}\n\n.mdi-transfer-right::before {\n  content: \"\\F0530\";\n}\n\n.mdi-transfer-up::before {\n  content: \"\\F0DA3\";\n}\n\n.mdi-transit-connection::before {\n  content: \"\\F0D3C\";\n}\n\n.mdi-transit-connection-variant::before {\n  content: \"\\F0D3D\";\n}\n\n.mdi-transit-detour::before {\n  content: \"\\F0F8B\";\n}\n\n.mdi-transit-transfer::before {\n  content: \"\\F06AE\";\n}\n\n.mdi-transition::before {\n  content: \"\\F0915\";\n}\n\n.mdi-transition-masked::before {\n  content: \"\\F0916\";\n}\n\n.mdi-translate::before {\n  content: \"\\F05CA\";\n}\n\n.mdi-translate-off::before {\n  content: \"\\F0E06\";\n}\n\n.mdi-transmission-tower::before {\n  content: \"\\F0D3E\";\n}\n\n.mdi-trash-can::before {\n  content: \"\\F0A79\";\n}\n\n.mdi-trash-can-outline::before {\n  content: \"\\F0A7A\";\n}\n\n.mdi-tray::before {\n  content: \"\\F1294\";\n}\n\n.mdi-tray-alert::before {\n  content: \"\\F1295\";\n}\n\n.mdi-tray-full::before {\n  content: \"\\F1296\";\n}\n\n.mdi-tray-minus::before {\n  content: \"\\F1297\";\n}\n\n.mdi-tray-plus::before {\n  content: \"\\F1298\";\n}\n\n.mdi-tray-remove::before {\n  content: \"\\F1299\";\n}\n\n.mdi-treasure-chest::before {\n  content: \"\\F0726\";\n}\n\n.mdi-tree::before {\n  content: \"\\F0531\";\n}\n\n.mdi-tree-outline::before {\n  content: \"\\F0E69\";\n}\n\n.mdi-trello::before {\n  content: \"\\F0532\";\n}\n\n.mdi-trending-down::before {\n  content: \"\\F0533\";\n}\n\n.mdi-trending-neutral::before {\n  content: \"\\F0534\";\n}\n\n.mdi-trending-up::before {\n  content: \"\\F0535\";\n}\n\n.mdi-triangle::before {\n  content: \"\\F0536\";\n}\n\n.mdi-triangle-outline::before {\n  content: \"\\F0537\";\n}\n\n.mdi-triforce::before {\n  content: \"\\F0BD9\";\n}\n\n.mdi-trophy::before {\n  content: \"\\F0538\";\n}\n\n.mdi-trophy-award::before {\n  content: \"\\F0539\";\n}\n\n.mdi-trophy-broken::before {\n  content: \"\\F0DA4\";\n}\n\n.mdi-trophy-outline::before {\n  content: \"\\F053A\";\n}\n\n.mdi-trophy-variant::before {\n  content: \"\\F053B\";\n}\n\n.mdi-trophy-variant-outline::before {\n  content: \"\\F053C\";\n}\n\n.mdi-truck::before {\n  content: \"\\F053D\";\n}\n\n.mdi-truck-check::before {\n  content: \"\\F0CD4\";\n}\n\n.mdi-truck-check-outline::before {\n  content: \"\\F129A\";\n}\n\n.mdi-truck-delivery::before {\n  content: \"\\F053E\";\n}\n\n.mdi-truck-delivery-outline::before {\n  content: \"\\F129B\";\n}\n\n.mdi-truck-fast::before {\n  content: \"\\F0788\";\n}\n\n.mdi-truck-fast-outline::before {\n  content: \"\\F129C\";\n}\n\n.mdi-truck-outline::before {\n  content: \"\\F129D\";\n}\n\n.mdi-truck-trailer::before {\n  content: \"\\F0727\";\n}\n\n.mdi-trumpet::before {\n  content: \"\\F1096\";\n}\n\n.mdi-tshirt-crew::before {\n  content: \"\\F0A7B\";\n}\n\n.mdi-tshirt-crew-outline::before {\n  content: \"\\F053F\";\n}\n\n.mdi-tshirt-v::before {\n  content: \"\\F0A7C\";\n}\n\n.mdi-tshirt-v-outline::before {\n  content: \"\\F0540\";\n}\n\n.mdi-tumble-dryer::before {\n  content: \"\\F0917\";\n}\n\n.mdi-tumble-dryer-alert::before {\n  content: \"\\F11BA\";\n}\n\n.mdi-tumble-dryer-off::before {\n  content: \"\\F11BB\";\n}\n\n.mdi-tune::before {\n  content: \"\\F062E\";\n}\n\n.mdi-tune-vertical::before {\n  content: \"\\F066A\";\n}\n\n.mdi-turnstile::before {\n  content: \"\\F0CD5\";\n}\n\n.mdi-turnstile-outline::before {\n  content: \"\\F0CD6\";\n}\n\n.mdi-turtle::before {\n  content: \"\\F0CD7\";\n}\n\n.mdi-twitch::before {\n  content: \"\\F0543\";\n}\n\n.mdi-twitter::before {\n  content: \"\\F0544\";\n}\n\n.mdi-twitter-retweet::before {\n  content: \"\\F0547\";\n}\n\n.mdi-two-factor-authentication::before {\n  content: \"\\F09AF\";\n}\n\n.mdi-typewriter::before {\n  content: \"\\F0F2D\";\n}\n\n.mdi-ubisoft::before {\n  content: \"\\F0BDA\";\n}\n\n.mdi-ubuntu::before {\n  content: \"\\F0548\";\n}\n\n.mdi-ufo::before {\n  content: \"\\F10C4\";\n}\n\n.mdi-ufo-outline::before {\n  content: \"\\F10C5\";\n}\n\n.mdi-ultra-high-definition::before {\n  content: \"\\F07F9\";\n}\n\n.mdi-umbraco::before {\n  content: \"\\F0549\";\n}\n\n.mdi-umbrella::before {\n  content: \"\\F054A\";\n}\n\n.mdi-umbrella-closed::before {\n  content: \"\\F09B0\";\n}\n\n.mdi-umbrella-outline::before {\n  content: \"\\F054B\";\n}\n\n.mdi-undo::before {\n  content: \"\\F054C\";\n}\n\n.mdi-undo-variant::before {\n  content: \"\\F054D\";\n}\n\n.mdi-unfold-less-horizontal::before {\n  content: \"\\F054E\";\n}\n\n.mdi-unfold-less-vertical::before {\n  content: \"\\F0760\";\n}\n\n.mdi-unfold-more-horizontal::before {\n  content: \"\\F054F\";\n}\n\n.mdi-unfold-more-vertical::before {\n  content: \"\\F0761\";\n}\n\n.mdi-ungroup::before {\n  content: \"\\F0550\";\n}\n\n.mdi-unicode::before {\n  content: \"\\F0ED0\";\n}\n\n.mdi-unity::before {\n  content: \"\\F06AF\";\n}\n\n.mdi-unreal::before {\n  content: \"\\F09B1\";\n}\n\n.mdi-untappd::before {\n  content: \"\\F0551\";\n}\n\n.mdi-update::before {\n  content: \"\\F06B0\";\n}\n\n.mdi-upload::before {\n  content: \"\\F0552\";\n}\n\n.mdi-upload-lock::before {\n  content: \"\\F1373\";\n}\n\n.mdi-upload-lock-outline::before {\n  content: \"\\F1374\";\n}\n\n.mdi-upload-multiple::before {\n  content: \"\\F083D\";\n}\n\n.mdi-upload-network::before {\n  content: \"\\F06F6\";\n}\n\n.mdi-upload-network-outline::before {\n  content: \"\\F0CD8\";\n}\n\n.mdi-upload-off::before {\n  content: \"\\F10C6\";\n}\n\n.mdi-upload-off-outline::before {\n  content: \"\\F10C7\";\n}\n\n.mdi-upload-outline::before {\n  content: \"\\F0E07\";\n}\n\n.mdi-usb::before {\n  content: \"\\F0553\";\n}\n\n.mdi-usb-flash-drive::before {\n  content: \"\\F129E\";\n}\n\n.mdi-usb-flash-drive-outline::before {\n  content: \"\\F129F\";\n}\n\n.mdi-usb-port::before {\n  content: \"\\F11F0\";\n}\n\n.mdi-valve::before {\n  content: \"\\F1066\";\n}\n\n.mdi-valve-closed::before {\n  content: \"\\F1067\";\n}\n\n.mdi-valve-open::before {\n  content: \"\\F1068\";\n}\n\n.mdi-van-passenger::before {\n  content: \"\\F07FA\";\n}\n\n.mdi-van-utility::before {\n  content: \"\\F07FB\";\n}\n\n.mdi-vanish::before {\n  content: \"\\F07FC\";\n}\n\n.mdi-vanity-light::before {\n  content: \"\\F11E1\";\n}\n\n.mdi-variable::before {\n  content: \"\\F0AE7\";\n}\n\n.mdi-variable-box::before {\n  content: \"\\F1111\";\n}\n\n.mdi-vector-arrange-above::before {\n  content: \"\\F0554\";\n}\n\n.mdi-vector-arrange-below::before {\n  content: \"\\F0555\";\n}\n\n.mdi-vector-bezier::before {\n  content: \"\\F0AE8\";\n}\n\n.mdi-vector-circle::before {\n  content: \"\\F0556\";\n}\n\n.mdi-vector-circle-variant::before {\n  content: \"\\F0557\";\n}\n\n.mdi-vector-combine::before {\n  content: \"\\F0558\";\n}\n\n.mdi-vector-curve::before {\n  content: \"\\F0559\";\n}\n\n.mdi-vector-difference::before {\n  content: \"\\F055A\";\n}\n\n.mdi-vector-difference-ab::before {\n  content: \"\\F055B\";\n}\n\n.mdi-vector-difference-ba::before {\n  content: \"\\F055C\";\n}\n\n.mdi-vector-ellipse::before {\n  content: \"\\F0893\";\n}\n\n.mdi-vector-intersection::before {\n  content: \"\\F055D\";\n}\n\n.mdi-vector-line::before {\n  content: \"\\F055E\";\n}\n\n.mdi-vector-link::before {\n  content: \"\\F0FE8\";\n}\n\n.mdi-vector-point::before {\n  content: \"\\F055F\";\n}\n\n.mdi-vector-polygon::before {\n  content: \"\\F0560\";\n}\n\n.mdi-vector-polyline::before {\n  content: \"\\F0561\";\n}\n\n.mdi-vector-polyline-edit::before {\n  content: \"\\F1225\";\n}\n\n.mdi-vector-polyline-minus::before {\n  content: \"\\F1226\";\n}\n\n.mdi-vector-polyline-plus::before {\n  content: \"\\F1227\";\n}\n\n.mdi-vector-polyline-remove::before {\n  content: \"\\F1228\";\n}\n\n.mdi-vector-radius::before {\n  content: \"\\F074A\";\n}\n\n.mdi-vector-rectangle::before {\n  content: \"\\F05C6\";\n}\n\n.mdi-vector-selection::before {\n  content: \"\\F0562\";\n}\n\n.mdi-vector-square::before {\n  content: \"\\F0001\";\n}\n\n.mdi-vector-triangle::before {\n  content: \"\\F0563\";\n}\n\n.mdi-vector-union::before {\n  content: \"\\F0564\";\n}\n\n.mdi-vhs::before {\n  content: \"\\F0A1B\";\n}\n\n.mdi-vibrate::before {\n  content: \"\\F0566\";\n}\n\n.mdi-vibrate-off::before {\n  content: \"\\F0CD9\";\n}\n\n.mdi-video::before {\n  content: \"\\F0567\";\n}\n\n.mdi-video-3d::before {\n  content: \"\\F07FD\";\n}\n\n.mdi-video-3d-variant::before {\n  content: \"\\F0ED1\";\n}\n\n.mdi-video-4k-box::before {\n  content: \"\\F083E\";\n}\n\n.mdi-video-account::before {\n  content: \"\\F0919\";\n}\n\n.mdi-video-box::before {\n  content: \"\\F00FD\";\n}\n\n.mdi-video-box-off::before {\n  content: \"\\F00FE\";\n}\n\n.mdi-video-check::before {\n  content: \"\\F1069\";\n}\n\n.mdi-video-check-outline::before {\n  content: \"\\F106A\";\n}\n\n.mdi-video-image::before {\n  content: \"\\F091A\";\n}\n\n.mdi-video-input-antenna::before {\n  content: \"\\F083F\";\n}\n\n.mdi-video-input-component::before {\n  content: \"\\F0840\";\n}\n\n.mdi-video-input-hdmi::before {\n  content: \"\\F0841\";\n}\n\n.mdi-video-input-scart::before {\n  content: \"\\F0F8C\";\n}\n\n.mdi-video-input-svideo::before {\n  content: \"\\F0842\";\n}\n\n.mdi-video-minus::before {\n  content: \"\\F09B2\";\n}\n\n.mdi-video-minus-outline::before {\n  content: \"\\F02BA\";\n}\n\n.mdi-video-off::before {\n  content: \"\\F0568\";\n}\n\n.mdi-video-off-outline::before {\n  content: \"\\F0BDB\";\n}\n\n.mdi-video-outline::before {\n  content: \"\\F0BDC\";\n}\n\n.mdi-video-plus::before {\n  content: \"\\F09B3\";\n}\n\n.mdi-video-plus-outline::before {\n  content: \"\\F01D3\";\n}\n\n.mdi-video-stabilization::before {\n  content: \"\\F091B\";\n}\n\n.mdi-video-switch::before {\n  content: \"\\F0569\";\n}\n\n.mdi-video-switch-outline::before {\n  content: \"\\F0790\";\n}\n\n.mdi-video-vintage::before {\n  content: \"\\F0A1C\";\n}\n\n.mdi-video-wireless::before {\n  content: \"\\F0ED2\";\n}\n\n.mdi-video-wireless-outline::before {\n  content: \"\\F0ED3\";\n}\n\n.mdi-view-agenda::before {\n  content: \"\\F056A\";\n}\n\n.mdi-view-agenda-outline::before {\n  content: \"\\F11D8\";\n}\n\n.mdi-view-array::before {\n  content: \"\\F056B\";\n}\n\n.mdi-view-carousel::before {\n  content: \"\\F056C\";\n}\n\n.mdi-view-column::before {\n  content: \"\\F056D\";\n}\n\n.mdi-view-comfy::before {\n  content: \"\\F0E6A\";\n}\n\n.mdi-view-compact::before {\n  content: \"\\F0E6B\";\n}\n\n.mdi-view-compact-outline::before {\n  content: \"\\F0E6C\";\n}\n\n.mdi-view-dashboard::before {\n  content: \"\\F056E\";\n}\n\n.mdi-view-dashboard-outline::before {\n  content: \"\\F0A1D\";\n}\n\n.mdi-view-dashboard-variant::before {\n  content: \"\\F0843\";\n}\n\n.mdi-view-day::before {\n  content: \"\\F056F\";\n}\n\n.mdi-view-grid::before {\n  content: \"\\F0570\";\n}\n\n.mdi-view-grid-outline::before {\n  content: \"\\F11D9\";\n}\n\n.mdi-view-grid-plus::before {\n  content: \"\\F0F8D\";\n}\n\n.mdi-view-grid-plus-outline::before {\n  content: \"\\F11DA\";\n}\n\n.mdi-view-headline::before {\n  content: \"\\F0571\";\n}\n\n.mdi-view-list::before {\n  content: \"\\F0572\";\n}\n\n.mdi-view-module::before {\n  content: \"\\F0573\";\n}\n\n.mdi-view-parallel::before {\n  content: \"\\F0728\";\n}\n\n.mdi-view-quilt::before {\n  content: \"\\F0574\";\n}\n\n.mdi-view-sequential::before {\n  content: \"\\F0729\";\n}\n\n.mdi-view-split-horizontal::before {\n  content: \"\\F0BCB\";\n}\n\n.mdi-view-split-vertical::before {\n  content: \"\\F0BCC\";\n}\n\n.mdi-view-stream::before {\n  content: \"\\F0575\";\n}\n\n.mdi-view-week::before {\n  content: \"\\F0576\";\n}\n\n.mdi-vimeo::before {\n  content: \"\\F0577\";\n}\n\n.mdi-violin::before {\n  content: \"\\F060F\";\n}\n\n.mdi-virtual-reality::before {\n  content: \"\\F0894\";\n}\n\n.mdi-vk::before {\n  content: \"\\F0579\";\n}\n\n.mdi-vlc::before {\n  content: \"\\F057C\";\n}\n\n.mdi-voice-off::before {\n  content: \"\\F0ED4\";\n}\n\n.mdi-voicemail::before {\n  content: \"\\F057D\";\n}\n\n.mdi-volleyball::before {\n  content: \"\\F09B4\";\n}\n\n.mdi-volume-high::before {\n  content: \"\\F057E\";\n}\n\n.mdi-volume-low::before {\n  content: \"\\F057F\";\n}\n\n.mdi-volume-medium::before {\n  content: \"\\F0580\";\n}\n\n.mdi-volume-minus::before {\n  content: \"\\F075E\";\n}\n\n.mdi-volume-mute::before {\n  content: \"\\F075F\";\n}\n\n.mdi-volume-off::before {\n  content: \"\\F0581\";\n}\n\n.mdi-volume-plus::before {\n  content: \"\\F075D\";\n}\n\n.mdi-volume-source::before {\n  content: \"\\F1120\";\n}\n\n.mdi-volume-variant-off::before {\n  content: \"\\F0E08\";\n}\n\n.mdi-volume-vibrate::before {\n  content: \"\\F1121\";\n}\n\n.mdi-vote::before {\n  content: \"\\F0A1F\";\n}\n\n.mdi-vote-outline::before {\n  content: \"\\F0A20\";\n}\n\n.mdi-vpn::before {\n  content: \"\\F0582\";\n}\n\n.mdi-vuejs::before {\n  content: \"\\F0844\";\n}\n\n.mdi-vuetify::before {\n  content: \"\\F0E6D\";\n}\n\n.mdi-walk::before {\n  content: \"\\F0583\";\n}\n\n.mdi-wall::before {\n  content: \"\\F07FE\";\n}\n\n.mdi-wall-sconce::before {\n  content: \"\\F091C\";\n}\n\n.mdi-wall-sconce-flat::before {\n  content: \"\\F091D\";\n}\n\n.mdi-wall-sconce-flat-variant::before {\n  content: \"\\F041C\";\n}\n\n.mdi-wall-sconce-round::before {\n  content: \"\\F0748\";\n}\n\n.mdi-wall-sconce-round-variant::before {\n  content: \"\\F091E\";\n}\n\n.mdi-wallet::before {\n  content: \"\\F0584\";\n}\n\n.mdi-wallet-giftcard::before {\n  content: \"\\F0585\";\n}\n\n.mdi-wallet-membership::before {\n  content: \"\\F0586\";\n}\n\n.mdi-wallet-outline::before {\n  content: \"\\F0BDD\";\n}\n\n.mdi-wallet-plus::before {\n  content: \"\\F0F8E\";\n}\n\n.mdi-wallet-plus-outline::before {\n  content: \"\\F0F8F\";\n}\n\n.mdi-wallet-travel::before {\n  content: \"\\F0587\";\n}\n\n.mdi-wallpaper::before {\n  content: \"\\F0E09\";\n}\n\n.mdi-wan::before {\n  content: \"\\F0588\";\n}\n\n.mdi-wardrobe::before {\n  content: \"\\F0F90\";\n}\n\n.mdi-wardrobe-outline::before {\n  content: \"\\F0F91\";\n}\n\n.mdi-warehouse::before {\n  content: \"\\F0F81\";\n}\n\n.mdi-washing-machine::before {\n  content: \"\\F072A\";\n}\n\n.mdi-washing-machine-alert::before {\n  content: \"\\F11BC\";\n}\n\n.mdi-washing-machine-off::before {\n  content: \"\\F11BD\";\n}\n\n.mdi-watch::before {\n  content: \"\\F0589\";\n}\n\n.mdi-watch-export::before {\n  content: \"\\F058A\";\n}\n\n.mdi-watch-export-variant::before {\n  content: \"\\F0895\";\n}\n\n.mdi-watch-import::before {\n  content: \"\\F058B\";\n}\n\n.mdi-watch-import-variant::before {\n  content: \"\\F0896\";\n}\n\n.mdi-watch-variant::before {\n  content: \"\\F0897\";\n}\n\n.mdi-watch-vibrate::before {\n  content: \"\\F06B1\";\n}\n\n.mdi-watch-vibrate-off::before {\n  content: \"\\F0CDA\";\n}\n\n.mdi-water::before {\n  content: \"\\F058C\";\n}\n\n.mdi-water-boiler::before {\n  content: \"\\F0F92\";\n}\n\n.mdi-water-boiler-alert::before {\n  content: \"\\F11B3\";\n}\n\n.mdi-water-boiler-off::before {\n  content: \"\\F11B4\";\n}\n\n.mdi-water-off::before {\n  content: \"\\F058D\";\n}\n\n.mdi-water-outline::before {\n  content: \"\\F0E0A\";\n}\n\n.mdi-water-percent::before {\n  content: \"\\F058E\";\n}\n\n.mdi-water-polo::before {\n  content: \"\\F12A0\";\n}\n\n.mdi-water-pump::before {\n  content: \"\\F058F\";\n}\n\n.mdi-water-pump-off::before {\n  content: \"\\F0F93\";\n}\n\n.mdi-water-well::before {\n  content: \"\\F106B\";\n}\n\n.mdi-water-well-outline::before {\n  content: \"\\F106C\";\n}\n\n.mdi-watermark::before {\n  content: \"\\F0612\";\n}\n\n.mdi-wave::before {\n  content: \"\\F0F2E\";\n}\n\n.mdi-waves::before {\n  content: \"\\F078D\";\n}\n\n.mdi-waze::before {\n  content: \"\\F0BDE\";\n}\n\n.mdi-weather-cloudy::before {\n  content: \"\\F0590\";\n}\n\n.mdi-weather-cloudy-alert::before {\n  content: \"\\F0F2F\";\n}\n\n.mdi-weather-cloudy-arrow-right::before {\n  content: \"\\F0E6E\";\n}\n\n.mdi-weather-fog::before {\n  content: \"\\F0591\";\n}\n\n.mdi-weather-hail::before {\n  content: \"\\F0592\";\n}\n\n.mdi-weather-hazy::before {\n  content: \"\\F0F30\";\n}\n\n.mdi-weather-hurricane::before {\n  content: \"\\F0898\";\n}\n\n.mdi-weather-lightning::before {\n  content: \"\\F0593\";\n}\n\n.mdi-weather-lightning-rainy::before {\n  content: \"\\F067E\";\n}\n\n.mdi-weather-night::before {\n  content: \"\\F0594\";\n}\n\n.mdi-weather-night-partly-cloudy::before {\n  content: \"\\F0F31\";\n}\n\n.mdi-weather-partly-cloudy::before {\n  content: \"\\F0595\";\n}\n\n.mdi-weather-partly-lightning::before {\n  content: \"\\F0F32\";\n}\n\n.mdi-weather-partly-rainy::before {\n  content: \"\\F0F33\";\n}\n\n.mdi-weather-partly-snowy::before {\n  content: \"\\F0F34\";\n}\n\n.mdi-weather-partly-snowy-rainy::before {\n  content: \"\\F0F35\";\n}\n\n.mdi-weather-pouring::before {\n  content: \"\\F0596\";\n}\n\n.mdi-weather-rainy::before {\n  content: \"\\F0597\";\n}\n\n.mdi-weather-snowy::before {\n  content: \"\\F0598\";\n}\n\n.mdi-weather-snowy-heavy::before {\n  content: \"\\F0F36\";\n}\n\n.mdi-weather-snowy-rainy::before {\n  content: \"\\F067F\";\n}\n\n.mdi-weather-sunny::before {\n  content: \"\\F0599\";\n}\n\n.mdi-weather-sunny-alert::before {\n  content: \"\\F0F37\";\n}\n\n.mdi-weather-sunset::before {\n  content: \"\\F059A\";\n}\n\n.mdi-weather-sunset-down::before {\n  content: \"\\F059B\";\n}\n\n.mdi-weather-sunset-up::before {\n  content: \"\\F059C\";\n}\n\n.mdi-weather-tornado::before {\n  content: \"\\F0F38\";\n}\n\n.mdi-weather-windy::before {\n  content: \"\\F059D\";\n}\n\n.mdi-weather-windy-variant::before {\n  content: \"\\F059E\";\n}\n\n.mdi-web::before {\n  content: \"\\F059F\";\n}\n\n.mdi-web-box::before {\n  content: \"\\F0F94\";\n}\n\n.mdi-web-clock::before {\n  content: \"\\F124A\";\n}\n\n.mdi-webcam::before {\n  content: \"\\F05A0\";\n}\n\n.mdi-webhook::before {\n  content: \"\\F062F\";\n}\n\n.mdi-webpack::before {\n  content: \"\\F072B\";\n}\n\n.mdi-webrtc::before {\n  content: \"\\F1248\";\n}\n\n.mdi-wechat::before {\n  content: \"\\F0611\";\n}\n\n.mdi-weight::before {\n  content: \"\\F05A1\";\n}\n\n.mdi-weight-gram::before {\n  content: \"\\F0D3F\";\n}\n\n.mdi-weight-kilogram::before {\n  content: \"\\F05A2\";\n}\n\n.mdi-weight-lifter::before {\n  content: \"\\F115D\";\n}\n\n.mdi-weight-pound::before {\n  content: \"\\F09B5\";\n}\n\n.mdi-whatsapp::before {\n  content: \"\\F05A3\";\n}\n\n.mdi-wheelchair-accessibility::before {\n  content: \"\\F05A4\";\n}\n\n.mdi-whistle::before {\n  content: \"\\F09B6\";\n}\n\n.mdi-whistle-outline::before {\n  content: \"\\F12BC\";\n}\n\n.mdi-white-balance-auto::before {\n  content: \"\\F05A5\";\n}\n\n.mdi-white-balance-incandescent::before {\n  content: \"\\F05A6\";\n}\n\n.mdi-white-balance-iridescent::before {\n  content: \"\\F05A7\";\n}\n\n.mdi-white-balance-sunny::before {\n  content: \"\\F05A8\";\n}\n\n.mdi-widgets::before {\n  content: \"\\F072C\";\n}\n\n.mdi-widgets-outline::before {\n  content: \"\\F1355\";\n}\n\n.mdi-wifi::before {\n  content: \"\\F05A9\";\n}\n\n.mdi-wifi-off::before {\n  content: \"\\F05AA\";\n}\n\n.mdi-wifi-star::before {\n  content: \"\\F0E0B\";\n}\n\n.mdi-wifi-strength-1::before {\n  content: \"\\F091F\";\n}\n\n.mdi-wifi-strength-1-alert::before {\n  content: \"\\F0920\";\n}\n\n.mdi-wifi-strength-1-lock::before {\n  content: \"\\F0921\";\n}\n\n.mdi-wifi-strength-2::before {\n  content: \"\\F0922\";\n}\n\n.mdi-wifi-strength-2-alert::before {\n  content: \"\\F0923\";\n}\n\n.mdi-wifi-strength-2-lock::before {\n  content: \"\\F0924\";\n}\n\n.mdi-wifi-strength-3::before {\n  content: \"\\F0925\";\n}\n\n.mdi-wifi-strength-3-alert::before {\n  content: \"\\F0926\";\n}\n\n.mdi-wifi-strength-3-lock::before {\n  content: \"\\F0927\";\n}\n\n.mdi-wifi-strength-4::before {\n  content: \"\\F0928\";\n}\n\n.mdi-wifi-strength-4-alert::before {\n  content: \"\\F0929\";\n}\n\n.mdi-wifi-strength-4-lock::before {\n  content: \"\\F092A\";\n}\n\n.mdi-wifi-strength-alert-outline::before {\n  content: \"\\F092B\";\n}\n\n.mdi-wifi-strength-lock-outline::before {\n  content: \"\\F092C\";\n}\n\n.mdi-wifi-strength-off::before {\n  content: \"\\F092D\";\n}\n\n.mdi-wifi-strength-off-outline::before {\n  content: \"\\F092E\";\n}\n\n.mdi-wifi-strength-outline::before {\n  content: \"\\F092F\";\n}\n\n.mdi-wikipedia::before {\n  content: \"\\F05AC\";\n}\n\n.mdi-wind-turbine::before {\n  content: \"\\F0DA5\";\n}\n\n.mdi-window-close::before {\n  content: \"\\F05AD\";\n}\n\n.mdi-window-closed::before {\n  content: \"\\F05AE\";\n}\n\n.mdi-window-closed-variant::before {\n  content: \"\\F11DB\";\n}\n\n.mdi-window-maximize::before {\n  content: \"\\F05AF\";\n}\n\n.mdi-window-minimize::before {\n  content: \"\\F05B0\";\n}\n\n.mdi-window-open::before {\n  content: \"\\F05B1\";\n}\n\n.mdi-window-open-variant::before {\n  content: \"\\F11DC\";\n}\n\n.mdi-window-restore::before {\n  content: \"\\F05B2\";\n}\n\n.mdi-window-shutter::before {\n  content: \"\\F111C\";\n}\n\n.mdi-window-shutter-alert::before {\n  content: \"\\F111D\";\n}\n\n.mdi-window-shutter-open::before {\n  content: \"\\F111E\";\n}\n\n.mdi-wiper::before {\n  content: \"\\F0AE9\";\n}\n\n.mdi-wiper-wash::before {\n  content: \"\\F0DA6\";\n}\n\n.mdi-wordpress::before {\n  content: \"\\F05B4\";\n}\n\n.mdi-wrap::before {\n  content: \"\\F05B6\";\n}\n\n.mdi-wrap-disabled::before {\n  content: \"\\F0BDF\";\n}\n\n.mdi-wrench::before {\n  content: \"\\F05B7\";\n}\n\n.mdi-wrench-outline::before {\n  content: \"\\F0BE0\";\n}\n\n.mdi-xamarin::before {\n  content: \"\\F0845\";\n}\n\n.mdi-xamarin-outline::before {\n  content: \"\\F0846\";\n}\n\n.mdi-xing::before {\n  content: \"\\F05BE\";\n}\n\n.mdi-xml::before {\n  content: \"\\F05C0\";\n}\n\n.mdi-xmpp::before {\n  content: \"\\F07FF\";\n}\n\n.mdi-y-combinator::before {\n  content: \"\\F0624\";\n}\n\n.mdi-yahoo::before {\n  content: \"\\F0B4F\";\n}\n\n.mdi-yeast::before {\n  content: \"\\F05C1\";\n}\n\n.mdi-yin-yang::before {\n  content: \"\\F0680\";\n}\n\n.mdi-yoga::before {\n  content: \"\\F117C\";\n}\n\n.mdi-youtube::before {\n  content: \"\\F05C3\";\n}\n\n.mdi-youtube-gaming::before {\n  content: \"\\F0848\";\n}\n\n.mdi-youtube-studio::before {\n  content: \"\\F0847\";\n}\n\n.mdi-youtube-subscription::before {\n  content: \"\\F0D40\";\n}\n\n.mdi-youtube-tv::before {\n  content: \"\\F0448\";\n}\n\n.mdi-z-wave::before {\n  content: \"\\F0AEA\";\n}\n\n.mdi-zend::before {\n  content: \"\\F0AEB\";\n}\n\n.mdi-zigbee::before {\n  content: \"\\F0D41\";\n}\n\n.mdi-zip-box::before {\n  content: \"\\F05C4\";\n}\n\n.mdi-zip-box-outline::before {\n  content: \"\\F0FFA\";\n}\n\n.mdi-zip-disk::before {\n  content: \"\\F0A23\";\n}\n\n.mdi-zodiac-aquarius::before {\n  content: \"\\F0A7D\";\n}\n\n.mdi-zodiac-aries::before {\n  content: \"\\F0A7E\";\n}\n\n.mdi-zodiac-cancer::before {\n  content: \"\\F0A7F\";\n}\n\n.mdi-zodiac-capricorn::before {\n  content: \"\\F0A80\";\n}\n\n.mdi-zodiac-gemini::before {\n  content: \"\\F0A81\";\n}\n\n.mdi-zodiac-leo::before {\n  content: \"\\F0A82\";\n}\n\n.mdi-zodiac-libra::before {\n  content: \"\\F0A83\";\n}\n\n.mdi-zodiac-pisces::before {\n  content: \"\\F0A84\";\n}\n\n.mdi-zodiac-sagittarius::before {\n  content: \"\\F0A85\";\n}\n\n.mdi-zodiac-scorpio::before {\n  content: \"\\F0A86\";\n}\n\n.mdi-zodiac-taurus::before {\n  content: \"\\F0A87\";\n}\n\n.mdi-zodiac-virgo::before {\n  content: \"\\F0A88\";\n}\n\n.mdi-blank::before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set,\n.mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set,\n.mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set,\n.mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set,\n.mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(45deg);\n            transform: scaleX(-1) rotate(45deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: scaleY(-1) rotate(45deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(90deg);\n            transform: scaleX(-1) rotate(90deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(90deg);\n            -ms-transform: rotate(90deg);\n            transform: scaleY(-1) rotate(90deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(135deg);\n            -ms-transform: rotate(135deg);\n            transform: scaleY(-1) rotate(135deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(180deg);\n            transform: scaleX(-1) rotate(180deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(180deg);\n            -ms-transform: rotate(180deg);\n            transform: scaleY(-1) rotate(180deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(225deg);\n            transform: scaleX(-1) rotate(225deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(225deg);\n            -ms-transform: rotate(225deg);\n            transform: scaleY(-1) rotate(225deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(270deg);\n            transform: scaleX(-1) rotate(270deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(270deg);\n            -ms-transform: rotate(270deg);\n            transform: scaleY(-1) rotate(270deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(315deg);\n            transform: scaleX(-1) rotate(315deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(315deg);\n            -ms-transform: rotate(315deg);\n            transform: scaleY(-1) rotate(315deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n/*# sourceMappingURL=materialdesignicons.css.map */\n","/*\n* Remix Icon v2.3.0\n* https://remixicon.com\n* https://github.com/Remix-Design/RemixIcon\n*\n* Copyright RemixIcon.com\n* Released under the Apache License Version 2.0\n*\n* Date: 2020-02-04\n*/\n@font-face {\n  font-family: \"remixicon\";\n  src: url(\"../../../../fonts/remixicon.eot?t=1580819880586\"); /* IE9*/\n  src: url(\"../../../../fonts/remixicon.eot?t=1580819880586#iefix\")\n      format(\"embedded-opentype\"),\n    /* IE6-IE8 */ url(\"../../../../fonts/remixicon.woff2?t=1580819880586\")\n      format(\"woff2\"),\n    url(\"../../../../fonts/remixicon.woff?t=1580819880586\") format(\"woff\"),\n    url(\"../../../../fonts/remixicon.ttf?t=1580819880586\") format(\"truetype\"),\n    /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/\n      url(\"../../../../fonts/remixicon.svg?t=1580819880586#remixicon\")\n      format(\"svg\"); /* iOS 4.1- */\n  font-display: swap;\n}\n\n[class^=\"ri-\"],\n[class*=\" ri-\"] {\n  font-family: \"remixicon\" !important;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ri-lg {\n  font-size: 1.3333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n.ri-xl {\n  font-size: 1.5em;\n  line-height: 0.6666em;\n  vertical-align: -0.075em;\n}\n.ri-xxs {\n  font-size: 0.5em;\n}\n.ri-xs {\n  font-size: 0.75em;\n}\n.ri-sm {\n  font-size: 0.875em;\n}\n.ri-1x {\n  font-size: 1em;\n}\n.ri-2x {\n  font-size: 2em;\n}\n.ri-3x {\n  font-size: 3em;\n}\n.ri-4x {\n  font-size: 4em;\n}\n.ri-5x {\n  font-size: 5em;\n}\n.ri-6x {\n  font-size: 6em;\n}\n.ri-7x {\n  font-size: 7em;\n}\n.ri-8x {\n  font-size: 8em;\n}\n.ri-9x {\n  font-size: 9em;\n}\n.ri-10x {\n  font-size: 10em;\n}\n.ri-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.ri-4k-fill:before {\n  content: \"\\ea01\";\n}\n.ri-4k-line:before {\n  content: \"\\ea02\";\n}\n.ri-a-b:before {\n  content: \"\\ea03\";\n}\n.ri-account-box-fill:before {\n  content: \"\\ea04\";\n}\n.ri-account-box-line:before {\n  content: \"\\ea05\";\n}\n.ri-account-circle-fill:before {\n  content: \"\\ea06\";\n}\n.ri-account-circle-line:before {\n  content: \"\\ea07\";\n}\n.ri-account-pin-box-fill:before {\n  content: \"\\ea08\";\n}\n.ri-account-pin-box-line:before {\n  content: \"\\ea09\";\n}\n.ri-account-pin-circle-fill:before {\n  content: \"\\ea0a\";\n}\n.ri-account-pin-circle-line:before {\n  content: \"\\ea0b\";\n}\n.ri-add-box-fill:before {\n  content: \"\\ea0c\";\n}\n.ri-add-box-line:before {\n  content: \"\\ea0d\";\n}\n.ri-add-circle-fill:before {\n  content: \"\\ea0e\";\n}\n.ri-add-circle-line:before {\n  content: \"\\ea0f\";\n}\n.ri-add-fill:before {\n  content: \"\\ea10\";\n}\n.ri-add-line:before {\n  content: \"\\ea11\";\n}\n.ri-admin-fill:before {\n  content: \"\\ea12\";\n}\n.ri-admin-line:before {\n  content: \"\\ea13\";\n}\n.ri-advertisement-fill:before {\n  content: \"\\ea14\";\n}\n.ri-advertisement-line:before {\n  content: \"\\ea15\";\n}\n.ri-airplay-fill:before {\n  content: \"\\ea16\";\n}\n.ri-airplay-line:before {\n  content: \"\\ea17\";\n}\n.ri-alarm-fill:before {\n  content: \"\\ea18\";\n}\n.ri-alarm-line:before {\n  content: \"\\ea19\";\n}\n.ri-alarm-warning-fill:before {\n  content: \"\\ea1a\";\n}\n.ri-alarm-warning-line:before {\n  content: \"\\ea1b\";\n}\n.ri-album-fill:before {\n  content: \"\\ea1c\";\n}\n.ri-album-line:before {\n  content: \"\\ea1d\";\n}\n.ri-alert-fill:before {\n  content: \"\\ea1e\";\n}\n.ri-alert-line:before {\n  content: \"\\ea1f\";\n}\n.ri-aliens-fill:before {\n  content: \"\\ea20\";\n}\n.ri-aliens-line:before {\n  content: \"\\ea21\";\n}\n.ri-align-bottom:before {\n  content: \"\\ea22\";\n}\n.ri-align-center:before {\n  content: \"\\ea23\";\n}\n.ri-align-justify:before {\n  content: \"\\ea24\";\n}\n.ri-align-left:before {\n  content: \"\\ea25\";\n}\n.ri-align-right:before {\n  content: \"\\ea26\";\n}\n.ri-align-top:before {\n  content: \"\\ea27\";\n}\n.ri-align-vertically:before {\n  content: \"\\ea28\";\n}\n.ri-alipay-fill:before {\n  content: \"\\ea29\";\n}\n.ri-alipay-line:before {\n  content: \"\\ea2a\";\n}\n.ri-amazon-fill:before {\n  content: \"\\ea2b\";\n}\n.ri-amazon-line:before {\n  content: \"\\ea2c\";\n}\n.ri-anchor-fill:before {\n  content: \"\\ea2d\";\n}\n.ri-anchor-line:before {\n  content: \"\\ea2e\";\n}\n.ri-ancient-gate-fill:before {\n  content: \"\\ea2f\";\n}\n.ri-ancient-gate-line:before {\n  content: \"\\ea30\";\n}\n.ri-ancient-pavilion-fill:before {\n  content: \"\\ea31\";\n}\n.ri-ancient-pavilion-line:before {\n  content: \"\\ea32\";\n}\n.ri-android-fill:before {\n  content: \"\\ea33\";\n}\n.ri-android-line:before {\n  content: \"\\ea34\";\n}\n.ri-angularjs-fill:before {\n  content: \"\\ea35\";\n}\n.ri-angularjs-line:before {\n  content: \"\\ea36\";\n}\n.ri-anticlockwise-2-fill:before {\n  content: \"\\ea37\";\n}\n.ri-anticlockwise-2-line:before {\n  content: \"\\ea38\";\n}\n.ri-anticlockwise-fill:before {\n  content: \"\\ea39\";\n}\n.ri-anticlockwise-line:before {\n  content: \"\\ea3a\";\n}\n.ri-app-store-fill:before {\n  content: \"\\ea3b\";\n}\n.ri-app-store-line:before {\n  content: \"\\ea3c\";\n}\n.ri-apple-fill:before {\n  content: \"\\ea3d\";\n}\n.ri-apple-line:before {\n  content: \"\\ea3e\";\n}\n.ri-apps-2-fill:before {\n  content: \"\\ea3f\";\n}\n.ri-apps-2-line:before {\n  content: \"\\ea40\";\n}\n.ri-apps-fill:before {\n  content: \"\\ea41\";\n}\n.ri-apps-line:before {\n  content: \"\\ea42\";\n}\n.ri-archive-drawer-fill:before {\n  content: \"\\ea43\";\n}\n.ri-archive-drawer-line:before {\n  content: \"\\ea44\";\n}\n.ri-archive-fill:before {\n  content: \"\\ea45\";\n}\n.ri-archive-line:before {\n  content: \"\\ea46\";\n}\n.ri-arrow-down-circle-fill:before {\n  content: \"\\ea47\";\n}\n.ri-arrow-down-circle-line:before {\n  content: \"\\ea48\";\n}\n.ri-arrow-down-fill:before {\n  content: \"\\ea49\";\n}\n.ri-arrow-down-line:before {\n  content: \"\\ea4a\";\n}\n.ri-arrow-down-s-fill:before {\n  content: \"\\ea4b\";\n}\n.ri-arrow-down-s-line:before {\n  content: \"\\ea4c\";\n}\n.ri-arrow-drop-down-fill:before {\n  content: \"\\ea4d\";\n}\n.ri-arrow-drop-down-line:before {\n  content: \"\\ea4e\";\n}\n.ri-arrow-drop-left-fill:before {\n  content: \"\\ea4f\";\n}\n.ri-arrow-drop-left-line:before {\n  content: \"\\ea50\";\n}\n.ri-arrow-drop-right-fill:before {\n  content: \"\\ea51\";\n}\n.ri-arrow-drop-right-line:before {\n  content: \"\\ea52\";\n}\n.ri-arrow-drop-up-fill:before {\n  content: \"\\ea53\";\n}\n.ri-arrow-drop-up-line:before {\n  content: \"\\ea54\";\n}\n.ri-arrow-go-back-fill:before {\n  content: \"\\ea55\";\n}\n.ri-arrow-go-back-line:before {\n  content: \"\\ea56\";\n}\n.ri-arrow-go-forward-fill:before {\n  content: \"\\ea57\";\n}\n.ri-arrow-go-forward-line:before {\n  content: \"\\ea58\";\n}\n.ri-arrow-left-circle-fill:before {\n  content: \"\\ea59\";\n}\n.ri-arrow-left-circle-line:before {\n  content: \"\\ea5a\";\n}\n.ri-arrow-left-down-fill:before {\n  content: \"\\ea5b\";\n}\n.ri-arrow-left-down-line:before {\n  content: \"\\ea5c\";\n}\n.ri-arrow-left-fill:before {\n  content: \"\\ea5d\";\n}\n.ri-arrow-left-line:before {\n  content: \"\\ea5e\";\n}\n.ri-arrow-left-right-fill:before {\n  content: \"\\ea5f\";\n}\n.ri-arrow-left-right-line:before {\n  content: \"\\ea60\";\n}\n.ri-arrow-left-s-fill:before {\n  content: \"\\ea61\";\n}\n.ri-arrow-left-s-line:before {\n  content: \"\\ea62\";\n}\n.ri-arrow-left-up-fill:before {\n  content: \"\\ea63\";\n}\n.ri-arrow-left-up-line:before {\n  content: \"\\ea64\";\n}\n.ri-arrow-right-circle-fill:before {\n  content: \"\\ea65\";\n}\n.ri-arrow-right-circle-line:before {\n  content: \"\\ea66\";\n}\n.ri-arrow-right-down-fill:before {\n  content: \"\\ea67\";\n}\n.ri-arrow-right-down-line:before {\n  content: \"\\ea68\";\n}\n.ri-arrow-right-fill:before {\n  content: \"\\ea69\";\n}\n.ri-arrow-right-line:before {\n  content: \"\\ea6a\";\n}\n.ri-arrow-right-s-fill:before {\n  content: \"\\ea6b\";\n}\n.ri-arrow-right-s-line:before {\n  content: \"\\ea6c\";\n}\n.ri-arrow-right-up-fill:before {\n  content: \"\\ea6d\";\n}\n.ri-arrow-right-up-line:before {\n  content: \"\\ea6e\";\n}\n.ri-arrow-up-circle-fill:before {\n  content: \"\\ea6f\";\n}\n.ri-arrow-up-circle-line:before {\n  content: \"\\ea70\";\n}\n.ri-arrow-up-down-fill:before {\n  content: \"\\ea71\";\n}\n.ri-arrow-up-down-line:before {\n  content: \"\\ea72\";\n}\n.ri-arrow-up-fill:before {\n  content: \"\\ea73\";\n}\n.ri-arrow-up-line:before {\n  content: \"\\ea74\";\n}\n.ri-arrow-up-s-fill:before {\n  content: \"\\ea75\";\n}\n.ri-arrow-up-s-line:before {\n  content: \"\\ea76\";\n}\n.ri-artboard-2-fill:before {\n  content: \"\\ea77\";\n}\n.ri-artboard-2-line:before {\n  content: \"\\ea78\";\n}\n.ri-artboard-fill:before {\n  content: \"\\ea79\";\n}\n.ri-artboard-line:before {\n  content: \"\\ea7a\";\n}\n.ri-article-fill:before {\n  content: \"\\ea7b\";\n}\n.ri-article-line:before {\n  content: \"\\ea7c\";\n}\n.ri-aspect-ratio-fill:before {\n  content: \"\\ea7d\";\n}\n.ri-aspect-ratio-line:before {\n  content: \"\\ea7e\";\n}\n.ri-asterisk:before {\n  content: \"\\ea7f\";\n}\n.ri-at-fill:before {\n  content: \"\\ea80\";\n}\n.ri-at-line:before {\n  content: \"\\ea81\";\n}\n.ri-attachment-2:before {\n  content: \"\\ea82\";\n}\n.ri-attachment-fill:before {\n  content: \"\\ea83\";\n}\n.ri-attachment-line:before {\n  content: \"\\ea84\";\n}\n.ri-auction-fill:before {\n  content: \"\\ea85\";\n}\n.ri-auction-line:before {\n  content: \"\\ea86\";\n}\n.ri-award-fill:before {\n  content: \"\\ea87\";\n}\n.ri-award-line:before {\n  content: \"\\ea88\";\n}\n.ri-baidu-fill:before {\n  content: \"\\ea89\";\n}\n.ri-baidu-line:before {\n  content: \"\\ea8a\";\n}\n.ri-ball-pen-fill:before {\n  content: \"\\ea8b\";\n}\n.ri-ball-pen-line:before {\n  content: \"\\ea8c\";\n}\n.ri-bank-card-2-fill:before {\n  content: \"\\ea8d\";\n}\n.ri-bank-card-2-line:before {\n  content: \"\\ea8e\";\n}\n.ri-bank-card-fill:before {\n  content: \"\\ea8f\";\n}\n.ri-bank-card-line:before {\n  content: \"\\ea90\";\n}\n.ri-bank-fill:before {\n  content: \"\\ea91\";\n}\n.ri-bank-line:before {\n  content: \"\\ea92\";\n}\n.ri-bar-chart-2-fill:before {\n  content: \"\\ea93\";\n}\n.ri-bar-chart-2-line:before {\n  content: \"\\ea94\";\n}\n.ri-bar-chart-box-fill:before {\n  content: \"\\ea95\";\n}\n.ri-bar-chart-box-line:before {\n  content: \"\\ea96\";\n}\n.ri-bar-chart-fill:before {\n  content: \"\\ea97\";\n}\n.ri-bar-chart-grouped-fill:before {\n  content: \"\\ea98\";\n}\n.ri-bar-chart-grouped-line:before {\n  content: \"\\ea99\";\n}\n.ri-bar-chart-horizontal-fill:before {\n  content: \"\\ea9a\";\n}\n.ri-bar-chart-horizontal-line:before {\n  content: \"\\ea9b\";\n}\n.ri-bar-chart-line:before {\n  content: \"\\ea9c\";\n}\n.ri-barcode-box-fill:before {\n  content: \"\\ea9d\";\n}\n.ri-barcode-box-line:before {\n  content: \"\\ea9e\";\n}\n.ri-barcode-fill:before {\n  content: \"\\ea9f\";\n}\n.ri-barcode-line:before {\n  content: \"\\eaa0\";\n}\n.ri-barricade-fill:before {\n  content: \"\\eaa1\";\n}\n.ri-barricade-line:before {\n  content: \"\\eaa2\";\n}\n.ri-base-station-fill:before {\n  content: \"\\eaa3\";\n}\n.ri-base-station-line:before {\n  content: \"\\eaa4\";\n}\n.ri-basketball-fill:before {\n  content: \"\\eaa5\";\n}\n.ri-basketball-line:before {\n  content: \"\\eaa6\";\n}\n.ri-battery-2-charge-fill:before {\n  content: \"\\eaa7\";\n}\n.ri-battery-2-charge-line:before {\n  content: \"\\eaa8\";\n}\n.ri-battery-2-fill:before {\n  content: \"\\eaa9\";\n}\n.ri-battery-2-line:before {\n  content: \"\\eaaa\";\n}\n.ri-battery-charge-fill:before {\n  content: \"\\eaab\";\n}\n.ri-battery-charge-line:before {\n  content: \"\\eaac\";\n}\n.ri-battery-fill:before {\n  content: \"\\eaad\";\n}\n.ri-battery-line:before {\n  content: \"\\eaae\";\n}\n.ri-battery-low-fill:before {\n  content: \"\\eaaf\";\n}\n.ri-battery-low-line:before {\n  content: \"\\eab0\";\n}\n.ri-battery-saver-fill:before {\n  content: \"\\eab1\";\n}\n.ri-battery-saver-line:before {\n  content: \"\\eab2\";\n}\n.ri-battery-share-fill:before {\n  content: \"\\eab3\";\n}\n.ri-battery-share-line:before {\n  content: \"\\eab4\";\n}\n.ri-bear-smile-fill:before {\n  content: \"\\eab5\";\n}\n.ri-bear-smile-line:before {\n  content: \"\\eab6\";\n}\n.ri-behance-fill:before {\n  content: \"\\eab7\";\n}\n.ri-behance-line:before {\n  content: \"\\eab8\";\n}\n.ri-bell-fill:before {\n  content: \"\\eab9\";\n}\n.ri-bell-line:before {\n  content: \"\\eaba\";\n}\n.ri-bike-fill:before {\n  content: \"\\eabb\";\n}\n.ri-bike-line:before {\n  content: \"\\eabc\";\n}\n.ri-bilibili-fill:before {\n  content: \"\\eabd\";\n}\n.ri-bilibili-line:before {\n  content: \"\\eabe\";\n}\n.ri-bill-fill:before {\n  content: \"\\eabf\";\n}\n.ri-bill-line:before {\n  content: \"\\eac0\";\n}\n.ri-billiards-fill:before {\n  content: \"\\eac1\";\n}\n.ri-billiards-line:before {\n  content: \"\\eac2\";\n}\n.ri-bit-coin-fill:before {\n  content: \"\\eac3\";\n}\n.ri-bit-coin-line:before {\n  content: \"\\eac4\";\n}\n.ri-blaze-fill:before {\n  content: \"\\eac5\";\n}\n.ri-blaze-line:before {\n  content: \"\\eac6\";\n}\n.ri-bluetooth-connect-fill:before {\n  content: \"\\eac7\";\n}\n.ri-bluetooth-connect-line:before {\n  content: \"\\eac8\";\n}\n.ri-bluetooth-fill:before {\n  content: \"\\eac9\";\n}\n.ri-bluetooth-line:before {\n  content: \"\\eaca\";\n}\n.ri-blur-off-fill:before {\n  content: \"\\eacb\";\n}\n.ri-blur-off-line:before {\n  content: \"\\eacc\";\n}\n.ri-body-scan-fill:before {\n  content: \"\\eacd\";\n}\n.ri-body-scan-line:before {\n  content: \"\\eace\";\n}\n.ri-bold:before {\n  content: \"\\eacf\";\n}\n.ri-book-2-fill:before {\n  content: \"\\ead0\";\n}\n.ri-book-2-line:before {\n  content: \"\\ead1\";\n}\n.ri-book-3-fill:before {\n  content: \"\\ead2\";\n}\n.ri-book-3-line:before {\n  content: \"\\ead3\";\n}\n.ri-book-fill:before {\n  content: \"\\ead4\";\n}\n.ri-book-line:before {\n  content: \"\\ead5\";\n}\n.ri-book-mark-fill:before {\n  content: \"\\ead6\";\n}\n.ri-book-mark-line:before {\n  content: \"\\ead7\";\n}\n.ri-book-open-fill:before {\n  content: \"\\ead8\";\n}\n.ri-book-open-line:before {\n  content: \"\\ead9\";\n}\n.ri-book-read-fill:before {\n  content: \"\\eada\";\n}\n.ri-book-read-line:before {\n  content: \"\\eadb\";\n}\n.ri-booklet-fill:before {\n  content: \"\\eadc\";\n}\n.ri-booklet-line:before {\n  content: \"\\eadd\";\n}\n.ri-bookmark-2-fill:before {\n  content: \"\\eade\";\n}\n.ri-bookmark-2-line:before {\n  content: \"\\eadf\";\n}\n.ri-bookmark-3-fill:before {\n  content: \"\\eae0\";\n}\n.ri-bookmark-3-line:before {\n  content: \"\\eae1\";\n}\n.ri-bookmark-fill:before {\n  content: \"\\eae2\";\n}\n.ri-bookmark-line:before {\n  content: \"\\eae3\";\n}\n.ri-boxing-fill:before {\n  content: \"\\eae4\";\n}\n.ri-boxing-line:before {\n  content: \"\\eae5\";\n}\n.ri-braces-fill:before {\n  content: \"\\eae6\";\n}\n.ri-braces-line:before {\n  content: \"\\eae7\";\n}\n.ri-brackets-fill:before {\n  content: \"\\eae8\";\n}\n.ri-brackets-line:before {\n  content: \"\\eae9\";\n}\n.ri-briefcase-2-fill:before {\n  content: \"\\eaea\";\n}\n.ri-briefcase-2-line:before {\n  content: \"\\eaeb\";\n}\n.ri-briefcase-3-fill:before {\n  content: \"\\eaec\";\n}\n.ri-briefcase-3-line:before {\n  content: \"\\eaed\";\n}\n.ri-briefcase-4-fill:before {\n  content: \"\\eaee\";\n}\n.ri-briefcase-4-line:before {\n  content: \"\\eaef\";\n}\n.ri-briefcase-5-fill:before {\n  content: \"\\eaf0\";\n}\n.ri-briefcase-5-line:before {\n  content: \"\\eaf1\";\n}\n.ri-briefcase-fill:before {\n  content: \"\\eaf2\";\n}\n.ri-briefcase-line:before {\n  content: \"\\eaf3\";\n}\n.ri-broadcast-fill:before {\n  content: \"\\eaf4\";\n}\n.ri-broadcast-line:before {\n  content: \"\\eaf5\";\n}\n.ri-brush-2-fill:before {\n  content: \"\\eaf6\";\n}\n.ri-brush-2-line:before {\n  content: \"\\eaf7\";\n}\n.ri-brush-3-fill:before {\n  content: \"\\eaf8\";\n}\n.ri-brush-3-line:before {\n  content: \"\\eaf9\";\n}\n.ri-brush-4-fill:before {\n  content: \"\\eafa\";\n}\n.ri-brush-4-line:before {\n  content: \"\\eafb\";\n}\n.ri-brush-fill:before {\n  content: \"\\eafc\";\n}\n.ri-brush-line:before {\n  content: \"\\eafd\";\n}\n.ri-bug-2-fill:before {\n  content: \"\\eafe\";\n}\n.ri-bug-2-line:before {\n  content: \"\\eaff\";\n}\n.ri-bug-fill:before {\n  content: \"\\eb00\";\n}\n.ri-bug-line:before {\n  content: \"\\eb01\";\n}\n.ri-building-2-fill:before {\n  content: \"\\eb02\";\n}\n.ri-building-2-line:before {\n  content: \"\\eb03\";\n}\n.ri-building-3-fill:before {\n  content: \"\\eb04\";\n}\n.ri-building-3-line:before {\n  content: \"\\eb05\";\n}\n.ri-building-4-fill:before {\n  content: \"\\eb06\";\n}\n.ri-building-4-line:before {\n  content: \"\\eb07\";\n}\n.ri-building-fill:before {\n  content: \"\\eb08\";\n}\n.ri-building-line:before {\n  content: \"\\eb09\";\n}\n.ri-bus-2-fill:before {\n  content: \"\\eb0a\";\n}\n.ri-bus-2-line:before {\n  content: \"\\eb0b\";\n}\n.ri-bus-fill:before {\n  content: \"\\eb0c\";\n}\n.ri-bus-line:before {\n  content: \"\\eb0d\";\n}\n.ri-bus-wifi-fill:before {\n  content: \"\\eb0e\";\n}\n.ri-bus-wifi-line:before {\n  content: \"\\eb0f\";\n}\n.ri-cake-2-fill:before {\n  content: \"\\eb10\";\n}\n.ri-cake-2-line:before {\n  content: \"\\eb11\";\n}\n.ri-cake-3-fill:before {\n  content: \"\\eb12\";\n}\n.ri-cake-3-line:before {\n  content: \"\\eb13\";\n}\n.ri-cake-fill:before {\n  content: \"\\eb14\";\n}\n.ri-cake-line:before {\n  content: \"\\eb15\";\n}\n.ri-calculator-fill:before {\n  content: \"\\eb16\";\n}\n.ri-calculator-line:before {\n  content: \"\\eb17\";\n}\n.ri-calendar-2-fill:before {\n  content: \"\\eb18\";\n}\n.ri-calendar-2-line:before {\n  content: \"\\eb19\";\n}\n.ri-calendar-check-fill:before {\n  content: \"\\eb1a\";\n}\n.ri-calendar-check-line:before {\n  content: \"\\eb1b\";\n}\n.ri-calendar-event-fill:before {\n  content: \"\\eb1c\";\n}\n.ri-calendar-event-line:before {\n  content: \"\\eb1d\";\n}\n.ri-calendar-fill:before {\n  content: \"\\eb1e\";\n}\n.ri-calendar-line:before {\n  content: \"\\eb1f\";\n}\n.ri-calendar-todo-fill:before {\n  content: \"\\eb20\";\n}\n.ri-calendar-todo-line:before {\n  content: \"\\eb21\";\n}\n.ri-camera-2-fill:before {\n  content: \"\\eb22\";\n}\n.ri-camera-2-line:before {\n  content: \"\\eb23\";\n}\n.ri-camera-3-fill:before {\n  content: \"\\eb24\";\n}\n.ri-camera-3-line:before {\n  content: \"\\eb25\";\n}\n.ri-camera-fill:before {\n  content: \"\\eb26\";\n}\n.ri-camera-lens-fill:before {\n  content: \"\\eb27\";\n}\n.ri-camera-lens-line:before {\n  content: \"\\eb28\";\n}\n.ri-camera-line:before {\n  content: \"\\eb29\";\n}\n.ri-camera-off-fill:before {\n  content: \"\\eb2a\";\n}\n.ri-camera-off-line:before {\n  content: \"\\eb2b\";\n}\n.ri-camera-switch-fill:before {\n  content: \"\\eb2c\";\n}\n.ri-camera-switch-line:before {\n  content: \"\\eb2d\";\n}\n.ri-car-fill:before {\n  content: \"\\eb2e\";\n}\n.ri-car-line:before {\n  content: \"\\eb2f\";\n}\n.ri-car-washing-fill:before {\n  content: \"\\eb30\";\n}\n.ri-car-washing-line:before {\n  content: \"\\eb31\";\n}\n.ri-cast-fill:before {\n  content: \"\\eb32\";\n}\n.ri-cast-line:before {\n  content: \"\\eb33\";\n}\n.ri-cellphone-fill:before {\n  content: \"\\eb34\";\n}\n.ri-cellphone-line:before {\n  content: \"\\eb35\";\n}\n.ri-celsius-fill:before {\n  content: \"\\eb36\";\n}\n.ri-celsius-line:before {\n  content: \"\\eb37\";\n}\n.ri-character-recognition-fill:before {\n  content: \"\\eb38\";\n}\n.ri-character-recognition-line:before {\n  content: \"\\eb39\";\n}\n.ri-charging-pile-2-fill:before {\n  content: \"\\eb3a\";\n}\n.ri-charging-pile-2-line:before {\n  content: \"\\eb3b\";\n}\n.ri-charging-pile-fill:before {\n  content: \"\\eb3c\";\n}\n.ri-charging-pile-line:before {\n  content: \"\\eb3d\";\n}\n.ri-chat-1-fill:before {\n  content: \"\\eb3e\";\n}\n.ri-chat-1-line:before {\n  content: \"\\eb3f\";\n}\n.ri-chat-2-fill:before {\n  content: \"\\eb40\";\n}\n.ri-chat-2-line:before {\n  content: \"\\eb41\";\n}\n.ri-chat-3-fill:before {\n  content: \"\\eb42\";\n}\n.ri-chat-3-line:before {\n  content: \"\\eb43\";\n}\n.ri-chat-4-fill:before {\n  content: \"\\eb44\";\n}\n.ri-chat-4-line:before {\n  content: \"\\eb45\";\n}\n.ri-chat-check-fill:before {\n  content: \"\\eb46\";\n}\n.ri-chat-check-line:before {\n  content: \"\\eb47\";\n}\n.ri-chat-delete-fill:before {\n  content: \"\\eb48\";\n}\n.ri-chat-delete-line:before {\n  content: \"\\eb49\";\n}\n.ri-chat-download-fill:before {\n  content: \"\\eb4a\";\n}\n.ri-chat-download-line:before {\n  content: \"\\eb4b\";\n}\n.ri-chat-forward-fill:before {\n  content: \"\\eb4c\";\n}\n.ri-chat-forward-line:before {\n  content: \"\\eb4d\";\n}\n.ri-chat-heart-fill:before {\n  content: \"\\eb4e\";\n}\n.ri-chat-heart-line:before {\n  content: \"\\eb4f\";\n}\n.ri-chat-new-fill:before {\n  content: \"\\eb50\";\n}\n.ri-chat-new-line:before {\n  content: \"\\eb51\";\n}\n.ri-chat-off-fill:before {\n  content: \"\\eb52\";\n}\n.ri-chat-off-line:before {\n  content: \"\\eb53\";\n}\n.ri-chat-settings-fill:before {\n  content: \"\\eb54\";\n}\n.ri-chat-settings-line:before {\n  content: \"\\eb55\";\n}\n.ri-chat-smile-2-fill:before {\n  content: \"\\eb56\";\n}\n.ri-chat-smile-2-line:before {\n  content: \"\\eb57\";\n}\n.ri-chat-smile-3-fill:before {\n  content: \"\\eb58\";\n}\n.ri-chat-smile-3-line:before {\n  content: \"\\eb59\";\n}\n.ri-chat-smile-fill:before {\n  content: \"\\eb5a\";\n}\n.ri-chat-smile-line:before {\n  content: \"\\eb5b\";\n}\n.ri-chat-upload-fill:before {\n  content: \"\\eb5c\";\n}\n.ri-chat-upload-line:before {\n  content: \"\\eb5d\";\n}\n.ri-chat-voice-fill:before {\n  content: \"\\eb5e\";\n}\n.ri-chat-voice-line:before {\n  content: \"\\eb5f\";\n}\n.ri-check-double-fill:before {\n  content: \"\\eb60\";\n}\n.ri-check-double-line:before {\n  content: \"\\eb61\";\n}\n.ri-check-fill:before {\n  content: \"\\eb62\";\n}\n.ri-check-line:before {\n  content: \"\\eb63\";\n}\n.ri-checkbox-blank-circle-fill:before {\n  content: \"\\eb64\";\n}\n.ri-checkbox-blank-circle-line:before {\n  content: \"\\eb65\";\n}\n.ri-checkbox-blank-fill:before {\n  content: \"\\eb66\";\n}\n.ri-checkbox-blank-line:before {\n  content: \"\\eb67\";\n}\n.ri-checkbox-circle-fill:before {\n  content: \"\\eb68\";\n}\n.ri-checkbox-circle-line:before {\n  content: \"\\eb69\";\n}\n.ri-checkbox-fill:before {\n  content: \"\\eb6a\";\n}\n.ri-checkbox-indeterminate-fill:before {\n  content: \"\\eb6b\";\n}\n.ri-checkbox-indeterminate-line:before {\n  content: \"\\eb6c\";\n}\n.ri-checkbox-line:before {\n  content: \"\\eb6d\";\n}\n.ri-checkbox-multiple-blank-fill:before {\n  content: \"\\eb6e\";\n}\n.ri-checkbox-multiple-blank-line:before {\n  content: \"\\eb6f\";\n}\n.ri-checkbox-multiple-fill:before {\n  content: \"\\eb70\";\n}\n.ri-checkbox-multiple-line:before {\n  content: \"\\eb71\";\n}\n.ri-china-railway-fill:before {\n  content: \"\\eb72\";\n}\n.ri-china-railway-line:before {\n  content: \"\\eb73\";\n}\n.ri-chrome-fill:before {\n  content: \"\\eb74\";\n}\n.ri-chrome-line:before {\n  content: \"\\eb75\";\n}\n.ri-clapperboard-fill:before {\n  content: \"\\eb76\";\n}\n.ri-clapperboard-line:before {\n  content: \"\\eb77\";\n}\n.ri-clipboard-fill:before {\n  content: \"\\eb78\";\n}\n.ri-clipboard-line:before {\n  content: \"\\eb79\";\n}\n.ri-clockwise-2-fill:before {\n  content: \"\\eb7a\";\n}\n.ri-clockwise-2-line:before {\n  content: \"\\eb7b\";\n}\n.ri-clockwise-fill:before {\n  content: \"\\eb7c\";\n}\n.ri-clockwise-line:before {\n  content: \"\\eb7d\";\n}\n.ri-close-circle-fill:before {\n  content: \"\\eb7e\";\n}\n.ri-close-circle-line:before {\n  content: \"\\eb7f\";\n}\n.ri-close-fill:before {\n  content: \"\\eb80\";\n}\n.ri-close-line:before {\n  content: \"\\eb81\";\n}\n.ri-cloud-fill:before {\n  content: \"\\eb82\";\n}\n.ri-cloud-line:before {\n  content: \"\\eb83\";\n}\n.ri-cloud-off-fill:before {\n  content: \"\\eb84\";\n}\n.ri-cloud-off-line:before {\n  content: \"\\eb85\";\n}\n.ri-cloud-windy-fill:before {\n  content: \"\\eb86\";\n}\n.ri-cloud-windy-line:before {\n  content: \"\\eb87\";\n}\n.ri-cloudy-2-fill:before {\n  content: \"\\eb88\";\n}\n.ri-cloudy-2-line:before {\n  content: \"\\eb89\";\n}\n.ri-cloudy-fill:before {\n  content: \"\\eb8a\";\n}\n.ri-cloudy-line:before {\n  content: \"\\eb8b\";\n}\n.ri-code-box-fill:before {\n  content: \"\\eb8c\";\n}\n.ri-code-box-line:before {\n  content: \"\\eb8d\";\n}\n.ri-code-fill:before {\n  content: \"\\eb8e\";\n}\n.ri-code-line:before {\n  content: \"\\eb8f\";\n}\n.ri-code-s-fill:before {\n  content: \"\\eb90\";\n}\n.ri-code-s-line:before {\n  content: \"\\eb91\";\n}\n.ri-code-s-slash-fill:before {\n  content: \"\\eb92\";\n}\n.ri-code-s-slash-line:before {\n  content: \"\\eb93\";\n}\n.ri-code-view:before {\n  content: \"\\eb94\";\n}\n.ri-codepen-fill:before {\n  content: \"\\eb95\";\n}\n.ri-codepen-line:before {\n  content: \"\\eb96\";\n}\n.ri-coin-fill:before {\n  content: \"\\eb97\";\n}\n.ri-coin-line:before {\n  content: \"\\eb98\";\n}\n.ri-coins-fill:before {\n  content: \"\\eb99\";\n}\n.ri-coins-line:before {\n  content: \"\\eb9a\";\n}\n.ri-command-fill:before {\n  content: \"\\eb9b\";\n}\n.ri-command-line:before {\n  content: \"\\eb9c\";\n}\n.ri-community-fill:before {\n  content: \"\\eb9d\";\n}\n.ri-community-line:before {\n  content: \"\\eb9e\";\n}\n.ri-compass-2-fill:before {\n  content: \"\\eb9f\";\n}\n.ri-compass-2-line:before {\n  content: \"\\eba0\";\n}\n.ri-compass-3-fill:before {\n  content: \"\\eba1\";\n}\n.ri-compass-3-line:before {\n  content: \"\\eba2\";\n}\n.ri-compass-4-fill:before {\n  content: \"\\eba3\";\n}\n.ri-compass-4-line:before {\n  content: \"\\eba4\";\n}\n.ri-compass-discover-fill:before {\n  content: \"\\eba5\";\n}\n.ri-compass-discover-line:before {\n  content: \"\\eba6\";\n}\n.ri-compass-fill:before {\n  content: \"\\eba7\";\n}\n.ri-compass-line:before {\n  content: \"\\eba8\";\n}\n.ri-compasses-2-fill:before {\n  content: \"\\eba9\";\n}\n.ri-compasses-2-line:before {\n  content: \"\\ebaa\";\n}\n.ri-compasses-fill:before {\n  content: \"\\ebab\";\n}\n.ri-compasses-line:before {\n  content: \"\\ebac\";\n}\n.ri-computer-fill:before {\n  content: \"\\ebad\";\n}\n.ri-computer-line:before {\n  content: \"\\ebae\";\n}\n.ri-contacts-book-2-fill:before {\n  content: \"\\ebaf\";\n}\n.ri-contacts-book-2-line:before {\n  content: \"\\ebb0\";\n}\n.ri-contacts-book-fill:before {\n  content: \"\\ebb1\";\n}\n.ri-contacts-book-line:before {\n  content: \"\\ebb2\";\n}\n.ri-contacts-book-upload-fill:before {\n  content: \"\\ebb3\";\n}\n.ri-contacts-book-upload-line:before {\n  content: \"\\ebb4\";\n}\n.ri-contacts-fill:before {\n  content: \"\\ebb5\";\n}\n.ri-contacts-line:before {\n  content: \"\\ebb6\";\n}\n.ri-contrast-2-fill:before {\n  content: \"\\ebb7\";\n}\n.ri-contrast-2-line:before {\n  content: \"\\ebb8\";\n}\n.ri-contrast-drop-2-fill:before {\n  content: \"\\ebb9\";\n}\n.ri-contrast-drop-2-line:before {\n  content: \"\\ebba\";\n}\n.ri-contrast-drop-fill:before {\n  content: \"\\ebbb\";\n}\n.ri-contrast-drop-line:before {\n  content: \"\\ebbc\";\n}\n.ri-contrast-fill:before {\n  content: \"\\ebbd\";\n}\n.ri-contrast-line:before {\n  content: \"\\ebbe\";\n}\n.ri-copper-coin-fill:before {\n  content: \"\\ebbf\";\n}\n.ri-copper-coin-line:before {\n  content: \"\\ebc0\";\n}\n.ri-copper-diamond-fill:before {\n  content: \"\\ebc1\";\n}\n.ri-copper-diamond-line:before {\n  content: \"\\ebc2\";\n}\n.ri-copyright-fill:before {\n  content: \"\\ebc3\";\n}\n.ri-copyright-line:before {\n  content: \"\\ebc4\";\n}\n.ri-coreos-fill:before {\n  content: \"\\ebc5\";\n}\n.ri-coreos-line:before {\n  content: \"\\ebc6\";\n}\n.ri-coupon-2-fill:before {\n  content: \"\\ebc7\";\n}\n.ri-coupon-2-line:before {\n  content: \"\\ebc8\";\n}\n.ri-coupon-3-fill:before {\n  content: \"\\ebc9\";\n}\n.ri-coupon-3-line:before {\n  content: \"\\ebca\";\n}\n.ri-coupon-4-fill:before {\n  content: \"\\ebcb\";\n}\n.ri-coupon-4-line:before {\n  content: \"\\ebcc\";\n}\n.ri-coupon-5-fill:before {\n  content: \"\\ebcd\";\n}\n.ri-coupon-5-line:before {\n  content: \"\\ebce\";\n}\n.ri-coupon-fill:before {\n  content: \"\\ebcf\";\n}\n.ri-coupon-line:before {\n  content: \"\\ebd0\";\n}\n.ri-cpu-fill:before {\n  content: \"\\ebd1\";\n}\n.ri-cpu-line:before {\n  content: \"\\ebd2\";\n}\n.ri-creative-commons-by-fill:before {\n  content: \"\\ebd3\";\n}\n.ri-creative-commons-by-line:before {\n  content: \"\\ebd4\";\n}\n.ri-creative-commons-fill:before {\n  content: \"\\ebd5\";\n}\n.ri-creative-commons-line:before {\n  content: \"\\ebd6\";\n}\n.ri-creative-commons-nc-fill:before {\n  content: \"\\ebd7\";\n}\n.ri-creative-commons-nc-line:before {\n  content: \"\\ebd8\";\n}\n.ri-creative-commons-nd-fill:before {\n  content: \"\\ebd9\";\n}\n.ri-creative-commons-nd-line:before {\n  content: \"\\ebda\";\n}\n.ri-creative-commons-sa-fill:before {\n  content: \"\\ebdb\";\n}\n.ri-creative-commons-sa-line:before {\n  content: \"\\ebdc\";\n}\n.ri-creative-commons-zero-fill:before {\n  content: \"\\ebdd\";\n}\n.ri-creative-commons-zero-line:before {\n  content: \"\\ebde\";\n}\n.ri-criminal-fill:before {\n  content: \"\\ebdf\";\n}\n.ri-criminal-line:before {\n  content: \"\\ebe0\";\n}\n.ri-crop-2-fill:before {\n  content: \"\\ebe1\";\n}\n.ri-crop-2-line:before {\n  content: \"\\ebe2\";\n}\n.ri-crop-fill:before {\n  content: \"\\ebe3\";\n}\n.ri-crop-line:before {\n  content: \"\\ebe4\";\n}\n.ri-css3-fill:before {\n  content: \"\\ebe5\";\n}\n.ri-css3-line:before {\n  content: \"\\ebe6\";\n}\n.ri-cup-fill:before {\n  content: \"\\ebe7\";\n}\n.ri-cup-line:before {\n  content: \"\\ebe8\";\n}\n.ri-currency-fill:before {\n  content: \"\\ebe9\";\n}\n.ri-currency-line:before {\n  content: \"\\ebea\";\n}\n.ri-cursor-fill:before {\n  content: \"\\ebeb\";\n}\n.ri-cursor-line:before {\n  content: \"\\ebec\";\n}\n.ri-customer-service-2-fill:before {\n  content: \"\\ebed\";\n}\n.ri-customer-service-2-line:before {\n  content: \"\\ebee\";\n}\n.ri-customer-service-fill:before {\n  content: \"\\ebef\";\n}\n.ri-customer-service-line:before {\n  content: \"\\ebf0\";\n}\n.ri-dashboard-fill:before {\n  content: \"\\ebf1\";\n}\n.ri-dashboard-line:before {\n  content: \"\\ebf2\";\n}\n.ri-database-2-fill:before {\n  content: \"\\ebf3\";\n}\n.ri-database-2-line:before {\n  content: \"\\ebf4\";\n}\n.ri-database-fill:before {\n  content: \"\\ebf5\";\n}\n.ri-database-line:before {\n  content: \"\\ebf6\";\n}\n.ri-delete-back-2-fill:before {\n  content: \"\\ebf7\";\n}\n.ri-delete-back-2-line:before {\n  content: \"\\ebf8\";\n}\n.ri-delete-back-fill:before {\n  content: \"\\ebf9\";\n}\n.ri-delete-back-line:before {\n  content: \"\\ebfa\";\n}\n.ri-delete-bin-2-fill:before {\n  content: \"\\ebfb\";\n}\n.ri-delete-bin-2-line:before {\n  content: \"\\ebfc\";\n}\n.ri-delete-bin-3-fill:before {\n  content: \"\\ebfd\";\n}\n.ri-delete-bin-3-line:before {\n  content: \"\\ebfe\";\n}\n.ri-delete-bin-4-fill:before {\n  content: \"\\ebff\";\n}\n.ri-delete-bin-4-line:before {\n  content: \"\\ec00\";\n}\n.ri-delete-bin-5-fill:before {\n  content: \"\\ec01\";\n}\n.ri-delete-bin-5-line:before {\n  content: \"\\ec02\";\n}\n.ri-delete-bin-6-fill:before {\n  content: \"\\ec03\";\n}\n.ri-delete-bin-6-line:before {\n  content: \"\\ec04\";\n}\n.ri-delete-bin-7-fill:before {\n  content: \"\\ec05\";\n}\n.ri-delete-bin-7-line:before {\n  content: \"\\ec06\";\n}\n.ri-delete-bin-fill:before {\n  content: \"\\ec07\";\n}\n.ri-delete-bin-line:before {\n  content: \"\\ec08\";\n}\n.ri-device-fill:before {\n  content: \"\\ec09\";\n}\n.ri-device-line:before {\n  content: \"\\ec0a\";\n}\n.ri-device-recover-fill:before {\n  content: \"\\ec0b\";\n}\n.ri-device-recover-line:before {\n  content: \"\\ec0c\";\n}\n.ri-dingding-fill:before {\n  content: \"\\ec0d\";\n}\n.ri-dingding-line:before {\n  content: \"\\ec0e\";\n}\n.ri-direction-fill:before {\n  content: \"\\ec0f\";\n}\n.ri-direction-line:before {\n  content: \"\\ec10\";\n}\n.ri-disc-fill:before {\n  content: \"\\ec11\";\n}\n.ri-disc-line:before {\n  content: \"\\ec12\";\n}\n.ri-discord-fill:before {\n  content: \"\\ec13\";\n}\n.ri-discord-line:before {\n  content: \"\\ec14\";\n}\n.ri-discuss-fill:before {\n  content: \"\\ec15\";\n}\n.ri-discuss-line:before {\n  content: \"\\ec16\";\n}\n.ri-divide-fill:before {\n  content: \"\\ec17\";\n}\n.ri-divide-line:before {\n  content: \"\\ec18\";\n}\n.ri-door-lock-box-fill:before {\n  content: \"\\ec19\";\n}\n.ri-door-lock-box-line:before {\n  content: \"\\ec1a\";\n}\n.ri-door-lock-fill:before {\n  content: \"\\ec1b\";\n}\n.ri-door-lock-line:before {\n  content: \"\\ec1c\";\n}\n.ri-douban-fill:before {\n  content: \"\\ec1d\";\n}\n.ri-douban-line:before {\n  content: \"\\ec1e\";\n}\n.ri-double-quotes-l:before {\n  content: \"\\ec1f\";\n}\n.ri-double-quotes-r:before {\n  content: \"\\ec20\";\n}\n.ri-download-2-fill:before {\n  content: \"\\ec21\";\n}\n.ri-download-2-line:before {\n  content: \"\\ec22\";\n}\n.ri-download-cloud-2-fill:before {\n  content: \"\\ec23\";\n}\n.ri-download-cloud-2-line:before {\n  content: \"\\ec24\";\n}\n.ri-download-cloud-fill:before {\n  content: \"\\ec25\";\n}\n.ri-download-cloud-line:before {\n  content: \"\\ec26\";\n}\n.ri-download-fill:before {\n  content: \"\\ec27\";\n}\n.ri-download-line:before {\n  content: \"\\ec28\";\n}\n.ri-drag-drop-fill:before {\n  content: \"\\ec29\";\n}\n.ri-drag-drop-line:before {\n  content: \"\\ec2a\";\n}\n.ri-drag-move-2-fill:before {\n  content: \"\\ec2b\";\n}\n.ri-drag-move-2-line:before {\n  content: \"\\ec2c\";\n}\n.ri-drag-move-fill:before {\n  content: \"\\ec2d\";\n}\n.ri-drag-move-line:before {\n  content: \"\\ec2e\";\n}\n.ri-dribbble-fill:before {\n  content: \"\\ec2f\";\n}\n.ri-dribbble-line:before {\n  content: \"\\ec30\";\n}\n.ri-drive-fill:before {\n  content: \"\\ec31\";\n}\n.ri-drive-line:before {\n  content: \"\\ec32\";\n}\n.ri-drizzle-fill:before {\n  content: \"\\ec33\";\n}\n.ri-drizzle-line:before {\n  content: \"\\ec34\";\n}\n.ri-drop-fill:before {\n  content: \"\\ec35\";\n}\n.ri-drop-line:before {\n  content: \"\\ec36\";\n}\n.ri-dropbox-fill:before {\n  content: \"\\ec37\";\n}\n.ri-dropbox-line:before {\n  content: \"\\ec38\";\n}\n.ri-dual-sim-1-fill:before {\n  content: \"\\ec39\";\n}\n.ri-dual-sim-1-line:before {\n  content: \"\\ec3a\";\n}\n.ri-dual-sim-2-fill:before {\n  content: \"\\ec3b\";\n}\n.ri-dual-sim-2-line:before {\n  content: \"\\ec3c\";\n}\n.ri-dv-fill:before {\n  content: \"\\ec3d\";\n}\n.ri-dv-line:before {\n  content: \"\\ec3e\";\n}\n.ri-dvd-fill:before {\n  content: \"\\ec3f\";\n}\n.ri-dvd-line:before {\n  content: \"\\ec40\";\n}\n.ri-e-bike-2-fill:before {\n  content: \"\\ec41\";\n}\n.ri-e-bike-2-line:before {\n  content: \"\\ec42\";\n}\n.ri-e-bike-fill:before {\n  content: \"\\ec43\";\n}\n.ri-e-bike-line:before {\n  content: \"\\ec44\";\n}\n.ri-earth-fill:before {\n  content: \"\\ec45\";\n}\n.ri-earth-line:before {\n  content: \"\\ec46\";\n}\n.ri-earthquake-fill:before {\n  content: \"\\ec47\";\n}\n.ri-earthquake-line:before {\n  content: \"\\ec48\";\n}\n.ri-edge-fill:before {\n  content: \"\\ec49\";\n}\n.ri-edge-line:before {\n  content: \"\\ec4a\";\n}\n.ri-edit-2-fill:before {\n  content: \"\\ec4b\";\n}\n.ri-edit-2-line:before {\n  content: \"\\ec4c\";\n}\n.ri-edit-box-fill:before {\n  content: \"\\ec4d\";\n}\n.ri-edit-box-line:before {\n  content: \"\\ec4e\";\n}\n.ri-edit-circle-fill:before {\n  content: \"\\ec4f\";\n}\n.ri-edit-circle-line:before {\n  content: \"\\ec50\";\n}\n.ri-edit-fill:before {\n  content: \"\\ec51\";\n}\n.ri-edit-line:before {\n  content: \"\\ec52\";\n}\n.ri-eject-fill:before {\n  content: \"\\ec53\";\n}\n.ri-eject-line:before {\n  content: \"\\ec54\";\n}\n.ri-emotion-2-fill:before {\n  content: \"\\ec55\";\n}\n.ri-emotion-2-line:before {\n  content: \"\\ec56\";\n}\n.ri-emotion-fill:before {\n  content: \"\\ec57\";\n}\n.ri-emotion-happy-fill:before {\n  content: \"\\ec58\";\n}\n.ri-emotion-happy-line:before {\n  content: \"\\ec59\";\n}\n.ri-emotion-laugh-fill:before {\n  content: \"\\ec5a\";\n}\n.ri-emotion-laugh-line:before {\n  content: \"\\ec5b\";\n}\n.ri-emotion-line:before {\n  content: \"\\ec5c\";\n}\n.ri-emotion-normal-fill:before {\n  content: \"\\ec5d\";\n}\n.ri-emotion-normal-line:before {\n  content: \"\\ec5e\";\n}\n.ri-emotion-sad-fill:before {\n  content: \"\\ec5f\";\n}\n.ri-emotion-sad-line:before {\n  content: \"\\ec60\";\n}\n.ri-emotion-unhappy-fill:before {\n  content: \"\\ec61\";\n}\n.ri-emotion-unhappy-line:before {\n  content: \"\\ec62\";\n}\n.ri-emphasis-cn:before {\n  content: \"\\ec63\";\n}\n.ri-emphasis:before {\n  content: \"\\ec64\";\n}\n.ri-english-input:before {\n  content: \"\\ec65\";\n}\n.ri-equalizer-fill:before {\n  content: \"\\ec66\";\n}\n.ri-equalizer-line:before {\n  content: \"\\ec67\";\n}\n.ri-eraser-fill:before {\n  content: \"\\ec68\";\n}\n.ri-eraser-line:before {\n  content: \"\\ec69\";\n}\n.ri-error-warning-fill:before {\n  content: \"\\ec6a\";\n}\n.ri-error-warning-line:before {\n  content: \"\\ec6b\";\n}\n.ri-evernote-fill:before {\n  content: \"\\ec6c\";\n}\n.ri-evernote-line:before {\n  content: \"\\ec6d\";\n}\n.ri-exchange-box-fill:before {\n  content: \"\\ec6e\";\n}\n.ri-exchange-box-line:before {\n  content: \"\\ec6f\";\n}\n.ri-exchange-cny-fill:before {\n  content: \"\\ec70\";\n}\n.ri-exchange-cny-line:before {\n  content: \"\\ec71\";\n}\n.ri-exchange-dollar-fill:before {\n  content: \"\\ec72\";\n}\n.ri-exchange-dollar-line:before {\n  content: \"\\ec73\";\n}\n.ri-exchange-fill:before {\n  content: \"\\ec74\";\n}\n.ri-exchange-funds-fill:before {\n  content: \"\\ec75\";\n}\n.ri-exchange-funds-line:before {\n  content: \"\\ec76\";\n}\n.ri-exchange-line:before {\n  content: \"\\ec77\";\n}\n.ri-external-link-fill:before {\n  content: \"\\ec78\";\n}\n.ri-external-link-line:before {\n  content: \"\\ec79\";\n}\n.ri-eye-2-fill:before {\n  content: \"\\ec7a\";\n}\n.ri-eye-2-line:before {\n  content: \"\\ec7b\";\n}\n.ri-eye-close-fill:before {\n  content: \"\\ec7c\";\n}\n.ri-eye-close-line:before {\n  content: \"\\ec7d\";\n}\n.ri-eye-fill:before {\n  content: \"\\ec7e\";\n}\n.ri-eye-line:before {\n  content: \"\\ec7f\";\n}\n.ri-eye-off-fill:before {\n  content: \"\\ec80\";\n}\n.ri-eye-off-line:before {\n  content: \"\\ec81\";\n}\n.ri-facebook-box-fill:before {\n  content: \"\\ec82\";\n}\n.ri-facebook-box-line:before {\n  content: \"\\ec83\";\n}\n.ri-facebook-circle-fill:before {\n  content: \"\\ec84\";\n}\n.ri-facebook-circle-line:before {\n  content: \"\\ec85\";\n}\n.ri-facebook-fill:before {\n  content: \"\\ec86\";\n}\n.ri-facebook-line:before {\n  content: \"\\ec87\";\n}\n.ri-fahrenheit-fill:before {\n  content: \"\\ec88\";\n}\n.ri-fahrenheit-line:before {\n  content: \"\\ec89\";\n}\n.ri-feedback-fill:before {\n  content: \"\\ec8a\";\n}\n.ri-feedback-line:before {\n  content: \"\\ec8b\";\n}\n.ri-file-2-fill:before {\n  content: \"\\ec8c\";\n}\n.ri-file-2-line:before {\n  content: \"\\ec8d\";\n}\n.ri-file-3-fill:before {\n  content: \"\\ec8e\";\n}\n.ri-file-3-line:before {\n  content: \"\\ec8f\";\n}\n.ri-file-4-fill:before {\n  content: \"\\ec90\";\n}\n.ri-file-4-line:before {\n  content: \"\\ec91\";\n}\n.ri-file-add-fill:before {\n  content: \"\\ec92\";\n}\n.ri-file-add-line:before {\n  content: \"\\ec93\";\n}\n.ri-file-chart-2-fill:before {\n  content: \"\\ec94\";\n}\n.ri-file-chart-2-line:before {\n  content: \"\\ec95\";\n}\n.ri-file-chart-fill:before {\n  content: \"\\ec96\";\n}\n.ri-file-chart-line:before {\n  content: \"\\ec97\";\n}\n.ri-file-cloud-fill:before {\n  content: \"\\ec98\";\n}\n.ri-file-cloud-line:before {\n  content: \"\\ec99\";\n}\n.ri-file-code-fill:before {\n  content: \"\\ec9a\";\n}\n.ri-file-code-line:before {\n  content: \"\\ec9b\";\n}\n.ri-file-copy-2-fill:before {\n  content: \"\\ec9c\";\n}\n.ri-file-copy-2-line:before {\n  content: \"\\ec9d\";\n}\n.ri-file-copy-fill:before {\n  content: \"\\ec9e\";\n}\n.ri-file-copy-line:before {\n  content: \"\\ec9f\";\n}\n.ri-file-damage-fill:before {\n  content: \"\\eca0\";\n}\n.ri-file-damage-line:before {\n  content: \"\\eca1\";\n}\n.ri-file-download-fill:before {\n  content: \"\\eca2\";\n}\n.ri-file-download-line:before {\n  content: \"\\eca3\";\n}\n.ri-file-edit-fill:before {\n  content: \"\\eca4\";\n}\n.ri-file-edit-line:before {\n  content: \"\\eca5\";\n}\n.ri-file-excel-2-fill:before {\n  content: \"\\eca6\";\n}\n.ri-file-excel-2-line:before {\n  content: \"\\eca7\";\n}\n.ri-file-excel-fill:before {\n  content: \"\\eca8\";\n}\n.ri-file-excel-line:before {\n  content: \"\\eca9\";\n}\n.ri-file-fill:before {\n  content: \"\\ecaa\";\n}\n.ri-file-forbid-fill:before {\n  content: \"\\ecab\";\n}\n.ri-file-forbid-line:before {\n  content: \"\\ecac\";\n}\n.ri-file-hwp-fill:before {\n  content: \"\\ecad\";\n}\n.ri-file-hwp-line:before {\n  content: \"\\ecae\";\n}\n.ri-file-info-fill:before {\n  content: \"\\ecaf\";\n}\n.ri-file-info-line:before {\n  content: \"\\ecb0\";\n}\n.ri-file-line:before {\n  content: \"\\ecb1\";\n}\n.ri-file-list-2-fill:before {\n  content: \"\\ecb2\";\n}\n.ri-file-list-2-line:before {\n  content: \"\\ecb3\";\n}\n.ri-file-list-3-fill:before {\n  content: \"\\ecb4\";\n}\n.ri-file-list-3-line:before {\n  content: \"\\ecb5\";\n}\n.ri-file-list-fill:before {\n  content: \"\\ecb6\";\n}\n.ri-file-list-line:before {\n  content: \"\\ecb7\";\n}\n.ri-file-lock-fill:before {\n  content: \"\\ecb8\";\n}\n.ri-file-lock-line:before {\n  content: \"\\ecb9\";\n}\n.ri-file-mark-fill:before {\n  content: \"\\ecba\";\n}\n.ri-file-mark-line:before {\n  content: \"\\ecbb\";\n}\n.ri-file-music-fill:before {\n  content: \"\\ecbc\";\n}\n.ri-file-music-line:before {\n  content: \"\\ecbd\";\n}\n.ri-file-paper-2-fill:before {\n  content: \"\\ecbe\";\n}\n.ri-file-paper-2-line:before {\n  content: \"\\ecbf\";\n}\n.ri-file-paper-fill:before {\n  content: \"\\ecc0\";\n}\n.ri-file-paper-line:before {\n  content: \"\\ecc1\";\n}\n.ri-file-pdf-fill:before {\n  content: \"\\ecc2\";\n}\n.ri-file-pdf-line:before {\n  content: \"\\ecc3\";\n}\n.ri-file-ppt-2-fill:before {\n  content: \"\\ecc4\";\n}\n.ri-file-ppt-2-line:before {\n  content: \"\\ecc5\";\n}\n.ri-file-ppt-fill:before {\n  content: \"\\ecc6\";\n}\n.ri-file-ppt-line:before {\n  content: \"\\ecc7\";\n}\n.ri-file-reduce-fill:before {\n  content: \"\\ecc8\";\n}\n.ri-file-reduce-line:before {\n  content: \"\\ecc9\";\n}\n.ri-file-search-fill:before {\n  content: \"\\ecca\";\n}\n.ri-file-search-line:before {\n  content: \"\\eccb\";\n}\n.ri-file-settings-fill:before {\n  content: \"\\eccc\";\n}\n.ri-file-settings-line:before {\n  content: \"\\eccd\";\n}\n.ri-file-shield-2-fill:before {\n  content: \"\\ecce\";\n}\n.ri-file-shield-2-line:before {\n  content: \"\\eccf\";\n}\n.ri-file-shield-fill:before {\n  content: \"\\ecd0\";\n}\n.ri-file-shield-line:before {\n  content: \"\\ecd1\";\n}\n.ri-file-shred-fill:before {\n  content: \"\\ecd2\";\n}\n.ri-file-shred-line:before {\n  content: \"\\ecd3\";\n}\n.ri-file-text-fill:before {\n  content: \"\\ecd4\";\n}\n.ri-file-text-line:before {\n  content: \"\\ecd5\";\n}\n.ri-file-transfer-fill:before {\n  content: \"\\ecd6\";\n}\n.ri-file-transfer-line:before {\n  content: \"\\ecd7\";\n}\n.ri-file-unknow-fill:before {\n  content: \"\\ecd8\";\n}\n.ri-file-unknow-line:before {\n  content: \"\\ecd9\";\n}\n.ri-file-upload-fill:before {\n  content: \"\\ecda\";\n}\n.ri-file-upload-line:before {\n  content: \"\\ecdb\";\n}\n.ri-file-user-fill:before {\n  content: \"\\ecdc\";\n}\n.ri-file-user-line:before {\n  content: \"\\ecdd\";\n}\n.ri-file-warning-fill:before {\n  content: \"\\ecde\";\n}\n.ri-file-warning-line:before {\n  content: \"\\ecdf\";\n}\n.ri-file-word-2-fill:before {\n  content: \"\\ece0\";\n}\n.ri-file-word-2-line:before {\n  content: \"\\ece1\";\n}\n.ri-file-word-fill:before {\n  content: \"\\ece2\";\n}\n.ri-file-word-line:before {\n  content: \"\\ece3\";\n}\n.ri-file-zip-fill:before {\n  content: \"\\ece4\";\n}\n.ri-file-zip-line:before {\n  content: \"\\ece5\";\n}\n.ri-film-fill:before {\n  content: \"\\ece6\";\n}\n.ri-film-line:before {\n  content: \"\\ece7\";\n}\n.ri-filter-2-fill:before {\n  content: \"\\ece8\";\n}\n.ri-filter-2-line:before {\n  content: \"\\ece9\";\n}\n.ri-filter-3-fill:before {\n  content: \"\\ecea\";\n}\n.ri-filter-3-line:before {\n  content: \"\\eceb\";\n}\n.ri-filter-fill:before {\n  content: \"\\ecec\";\n}\n.ri-filter-line:before {\n  content: \"\\eced\";\n}\n.ri-find-replace-fill:before {\n  content: \"\\ecee\";\n}\n.ri-find-replace-line:before {\n  content: \"\\ecef\";\n}\n.ri-fingerprint-2-fill:before {\n  content: \"\\ecf0\";\n}\n.ri-fingerprint-2-line:before {\n  content: \"\\ecf1\";\n}\n.ri-fingerprint-fill:before {\n  content: \"\\ecf2\";\n}\n.ri-fingerprint-line:before {\n  content: \"\\ecf3\";\n}\n.ri-fire-fill:before {\n  content: \"\\ecf4\";\n}\n.ri-fire-line:before {\n  content: \"\\ecf5\";\n}\n.ri-firefox-fill:before {\n  content: \"\\ecf6\";\n}\n.ri-firefox-line:before {\n  content: \"\\ecf7\";\n}\n.ri-flag-2-fill:before {\n  content: \"\\ecf8\";\n}\n.ri-flag-2-line:before {\n  content: \"\\ecf9\";\n}\n.ri-flag-fill:before {\n  content: \"\\ecfa\";\n}\n.ri-flag-line:before {\n  content: \"\\ecfb\";\n}\n.ri-flashlight-fill:before {\n  content: \"\\ecfc\";\n}\n.ri-flashlight-line:before {\n  content: \"\\ecfd\";\n}\n.ri-flask-fill:before {\n  content: \"\\ecfe\";\n}\n.ri-flask-line:before {\n  content: \"\\ecff\";\n}\n.ri-flight-land-fill:before {\n  content: \"\\ed00\";\n}\n.ri-flight-land-line:before {\n  content: \"\\ed01\";\n}\n.ri-flight-takeoff-fill:before {\n  content: \"\\ed02\";\n}\n.ri-flight-takeoff-line:before {\n  content: \"\\ed03\";\n}\n.ri-flood-fill:before {\n  content: \"\\ed04\";\n}\n.ri-flood-line:before {\n  content: \"\\ed05\";\n}\n.ri-flutter-fill:before {\n  content: \"\\ed06\";\n}\n.ri-flutter-line:before {\n  content: \"\\ed07\";\n}\n.ri-focus-2-fill:before {\n  content: \"\\ed08\";\n}\n.ri-focus-2-line:before {\n  content: \"\\ed09\";\n}\n.ri-focus-3-fill:before {\n  content: \"\\ed0a\";\n}\n.ri-focus-3-line:before {\n  content: \"\\ed0b\";\n}\n.ri-focus-fill:before {\n  content: \"\\ed0c\";\n}\n.ri-focus-line:before {\n  content: \"\\ed0d\";\n}\n.ri-foggy-fill:before {\n  content: \"\\ed0e\";\n}\n.ri-foggy-line:before {\n  content: \"\\ed0f\";\n}\n.ri-folder-2-fill:before {\n  content: \"\\ed10\";\n}\n.ri-folder-2-line:before {\n  content: \"\\ed11\";\n}\n.ri-folder-3-fill:before {\n  content: \"\\ed12\";\n}\n.ri-folder-3-line:before {\n  content: \"\\ed13\";\n}\n.ri-folder-4-fill:before {\n  content: \"\\ed14\";\n}\n.ri-folder-4-line:before {\n  content: \"\\ed15\";\n}\n.ri-folder-5-fill:before {\n  content: \"\\ed16\";\n}\n.ri-folder-5-line:before {\n  content: \"\\ed17\";\n}\n.ri-folder-add-fill:before {\n  content: \"\\ed18\";\n}\n.ri-folder-add-line:before {\n  content: \"\\ed19\";\n}\n.ri-folder-chart-2-fill:before {\n  content: \"\\ed1a\";\n}\n.ri-folder-chart-2-line:before {\n  content: \"\\ed1b\";\n}\n.ri-folder-chart-fill:before {\n  content: \"\\ed1c\";\n}\n.ri-folder-chart-line:before {\n  content: \"\\ed1d\";\n}\n.ri-folder-download-fill:before {\n  content: \"\\ed1e\";\n}\n.ri-folder-download-line:before {\n  content: \"\\ed1f\";\n}\n.ri-folder-fill:before {\n  content: \"\\ed20\";\n}\n.ri-folder-forbid-fill:before {\n  content: \"\\ed21\";\n}\n.ri-folder-forbid-line:before {\n  content: \"\\ed22\";\n}\n.ri-folder-info-fill:before {\n  content: \"\\ed23\";\n}\n.ri-folder-info-line:before {\n  content: \"\\ed24\";\n}\n.ri-folder-keyhole-fill:before {\n  content: \"\\ed25\";\n}\n.ri-folder-keyhole-line:before {\n  content: \"\\ed26\";\n}\n.ri-folder-line:before {\n  content: \"\\ed27\";\n}\n.ri-folder-lock-fill:before {\n  content: \"\\ed28\";\n}\n.ri-folder-lock-line:before {\n  content: \"\\ed29\";\n}\n.ri-folder-music-fill:before {\n  content: \"\\ed2a\";\n}\n.ri-folder-music-line:before {\n  content: \"\\ed2b\";\n}\n.ri-folder-open-fill:before {\n  content: \"\\ed2c\";\n}\n.ri-folder-open-line:before {\n  content: \"\\ed2d\";\n}\n.ri-folder-received-fill:before {\n  content: \"\\ed2e\";\n}\n.ri-folder-received-line:before {\n  content: \"\\ed2f\";\n}\n.ri-folder-reduce-fill:before {\n  content: \"\\ed30\";\n}\n.ri-folder-reduce-line:before {\n  content: \"\\ed31\";\n}\n.ri-folder-settings-fill:before {\n  content: \"\\ed32\";\n}\n.ri-folder-settings-line:before {\n  content: \"\\ed33\";\n}\n.ri-folder-shared-fill:before {\n  content: \"\\ed34\";\n}\n.ri-folder-shared-line:before {\n  content: \"\\ed35\";\n}\n.ri-folder-shield-2-fill:before {\n  content: \"\\ed36\";\n}\n.ri-folder-shield-2-line:before {\n  content: \"\\ed37\";\n}\n.ri-folder-shield-fill:before {\n  content: \"\\ed38\";\n}\n.ri-folder-shield-line:before {\n  content: \"\\ed39\";\n}\n.ri-folder-transfer-fill:before {\n  content: \"\\ed3a\";\n}\n.ri-folder-transfer-line:before {\n  content: \"\\ed3b\";\n}\n.ri-folder-unknow-fill:before {\n  content: \"\\ed3c\";\n}\n.ri-folder-unknow-line:before {\n  content: \"\\ed3d\";\n}\n.ri-folder-upload-fill:before {\n  content: \"\\ed3e\";\n}\n.ri-folder-upload-line:before {\n  content: \"\\ed3f\";\n}\n.ri-folder-user-fill:before {\n  content: \"\\ed40\";\n}\n.ri-folder-user-line:before {\n  content: \"\\ed41\";\n}\n.ri-folder-warning-fill:before {\n  content: \"\\ed42\";\n}\n.ri-folder-warning-line:before {\n  content: \"\\ed43\";\n}\n.ri-folder-zip-fill:before {\n  content: \"\\ed44\";\n}\n.ri-folder-zip-line:before {\n  content: \"\\ed45\";\n}\n.ri-folders-fill:before {\n  content: \"\\ed46\";\n}\n.ri-folders-line:before {\n  content: \"\\ed47\";\n}\n.ri-font-color:before {\n  content: \"\\ed48\";\n}\n.ri-font-size-2:before {\n  content: \"\\ed49\";\n}\n.ri-font-size:before {\n  content: \"\\ed4a\";\n}\n.ri-football-fill:before {\n  content: \"\\ed4b\";\n}\n.ri-football-line:before {\n  content: \"\\ed4c\";\n}\n.ri-footprint-fill:before {\n  content: \"\\ed4d\";\n}\n.ri-footprint-line:before {\n  content: \"\\ed4e\";\n}\n.ri-forbid-2-fill:before {\n  content: \"\\ed4f\";\n}\n.ri-forbid-2-line:before {\n  content: \"\\ed50\";\n}\n.ri-forbid-fill:before {\n  content: \"\\ed51\";\n}\n.ri-forbid-line:before {\n  content: \"\\ed52\";\n}\n.ri-format-clear:before {\n  content: \"\\ed53\";\n}\n.ri-fullscreen-exit-fill:before {\n  content: \"\\ed54\";\n}\n.ri-fullscreen-exit-line:before {\n  content: \"\\ed55\";\n}\n.ri-fullscreen-fill:before {\n  content: \"\\ed56\";\n}\n.ri-fullscreen-line:before {\n  content: \"\\ed57\";\n}\n.ri-function-fill:before {\n  content: \"\\ed58\";\n}\n.ri-function-line:before {\n  content: \"\\ed59\";\n}\n.ri-functions:before {\n  content: \"\\ed5a\";\n}\n.ri-funds-box-fill:before {\n  content: \"\\ed5b\";\n}\n.ri-funds-box-line:before {\n  content: \"\\ed5c\";\n}\n.ri-funds-fill:before {\n  content: \"\\ed5d\";\n}\n.ri-funds-line:before {\n  content: \"\\ed5e\";\n}\n.ri-gallery-fill:before {\n  content: \"\\ed5f\";\n}\n.ri-gallery-line:before {\n  content: \"\\ed60\";\n}\n.ri-gallery-upload-fill:before {\n  content: \"\\ed61\";\n}\n.ri-gallery-upload-line:before {\n  content: \"\\ed62\";\n}\n.ri-game-fill:before {\n  content: \"\\ed63\";\n}\n.ri-game-line:before {\n  content: \"\\ed64\";\n}\n.ri-gamepad-fill:before {\n  content: \"\\ed65\";\n}\n.ri-gamepad-line:before {\n  content: \"\\ed66\";\n}\n.ri-gas-station-fill:before {\n  content: \"\\ed67\";\n}\n.ri-gas-station-line:before {\n  content: \"\\ed68\";\n}\n.ri-gatsby-fill:before {\n  content: \"\\ed69\";\n}\n.ri-gatsby-line:before {\n  content: \"\\ed6a\";\n}\n.ri-genderless-fill:before {\n  content: \"\\ed6b\";\n}\n.ri-genderless-line:before {\n  content: \"\\ed6c\";\n}\n.ri-ghost-2-fill:before {\n  content: \"\\ed6d\";\n}\n.ri-ghost-2-line:before {\n  content: \"\\ed6e\";\n}\n.ri-ghost-fill:before {\n  content: \"\\ed6f\";\n}\n.ri-ghost-line:before {\n  content: \"\\ed70\";\n}\n.ri-ghost-smile-fill:before {\n  content: \"\\ed71\";\n}\n.ri-ghost-smile-line:before {\n  content: \"\\ed72\";\n}\n.ri-gift-2-fill:before {\n  content: \"\\ed73\";\n}\n.ri-gift-2-line:before {\n  content: \"\\ed74\";\n}\n.ri-gift-fill:before {\n  content: \"\\ed75\";\n}\n.ri-gift-line:before {\n  content: \"\\ed76\";\n}\n.ri-git-branch-fill:before {\n  content: \"\\ed77\";\n}\n.ri-git-branch-line:before {\n  content: \"\\ed78\";\n}\n.ri-git-commit-fill:before {\n  content: \"\\ed79\";\n}\n.ri-git-commit-line:before {\n  content: \"\\ed7a\";\n}\n.ri-git-merge-fill:before {\n  content: \"\\ed7b\";\n}\n.ri-git-merge-line:before {\n  content: \"\\ed7c\";\n}\n.ri-git-pull-request-fill:before {\n  content: \"\\ed7d\";\n}\n.ri-git-pull-request-line:before {\n  content: \"\\ed7e\";\n}\n.ri-git-repository-commits-fill:before {\n  content: \"\\ed7f\";\n}\n.ri-git-repository-commits-line:before {\n  content: \"\\ed80\";\n}\n.ri-git-repository-fill:before {\n  content: \"\\ed81\";\n}\n.ri-git-repository-line:before {\n  content: \"\\ed82\";\n}\n.ri-git-repository-private-fill:before {\n  content: \"\\ed83\";\n}\n.ri-git-repository-private-line:before {\n  content: \"\\ed84\";\n}\n.ri-github-fill:before {\n  content: \"\\ed85\";\n}\n.ri-github-line:before {\n  content: \"\\ed86\";\n}\n.ri-gitlab-fill:before {\n  content: \"\\ed87\";\n}\n.ri-gitlab-line:before {\n  content: \"\\ed88\";\n}\n.ri-global-fill:before {\n  content: \"\\ed89\";\n}\n.ri-global-line:before {\n  content: \"\\ed8a\";\n}\n.ri-globe-fill:before {\n  content: \"\\ed8b\";\n}\n.ri-globe-line:before {\n  content: \"\\ed8c\";\n}\n.ri-goblet-fill:before {\n  content: \"\\ed8d\";\n}\n.ri-goblet-line:before {\n  content: \"\\ed8e\";\n}\n.ri-google-fill:before {\n  content: \"\\ed8f\";\n}\n.ri-google-line:before {\n  content: \"\\ed90\";\n}\n.ri-google-play-fill:before {\n  content: \"\\ed91\";\n}\n.ri-google-play-line:before {\n  content: \"\\ed92\";\n}\n.ri-government-fill:before {\n  content: \"\\ed93\";\n}\n.ri-government-line:before {\n  content: \"\\ed94\";\n}\n.ri-gps-fill:before {\n  content: \"\\ed95\";\n}\n.ri-gps-line:before {\n  content: \"\\ed96\";\n}\n.ri-gradienter-fill:before {\n  content: \"\\ed97\";\n}\n.ri-gradienter-line:before {\n  content: \"\\ed98\";\n}\n.ri-grid-fill:before {\n  content: \"\\ed99\";\n}\n.ri-grid-line:before {\n  content: \"\\ed9a\";\n}\n.ri-group-2-fill:before {\n  content: \"\\ed9b\";\n}\n.ri-group-2-line:before {\n  content: \"\\ed9c\";\n}\n.ri-group-fill:before {\n  content: \"\\ed9d\";\n}\n.ri-group-line:before {\n  content: \"\\ed9e\";\n}\n.ri-guide-fill:before {\n  content: \"\\ed9f\";\n}\n.ri-guide-line:before {\n  content: \"\\eda0\";\n}\n.ri-hail-fill:before {\n  content: \"\\eda1\";\n}\n.ri-hail-line:before {\n  content: \"\\eda2\";\n}\n.ri-hammer-fill:before {\n  content: \"\\eda3\";\n}\n.ri-hammer-line:before {\n  content: \"\\eda4\";\n}\n.ri-hand-coin-fill:before {\n  content: \"\\eda5\";\n}\n.ri-hand-coin-line:before {\n  content: \"\\eda6\";\n}\n.ri-hand-heart-fill:before {\n  content: \"\\eda7\";\n}\n.ri-hand-heart-line:before {\n  content: \"\\eda8\";\n}\n.ri-handbag-fill:before {\n  content: \"\\eda9\";\n}\n.ri-handbag-line:before {\n  content: \"\\edaa\";\n}\n.ri-hard-drive-2-fill:before {\n  content: \"\\edab\";\n}\n.ri-hard-drive-2-line:before {\n  content: \"\\edac\";\n}\n.ri-hard-drive-fill:before {\n  content: \"\\edad\";\n}\n.ri-hard-drive-line:before {\n  content: \"\\edae\";\n}\n.ri-hashtag:before {\n  content: \"\\edaf\";\n}\n.ri-haze-2-fill:before {\n  content: \"\\edb0\";\n}\n.ri-haze-2-line:before {\n  content: \"\\edb1\";\n}\n.ri-haze-fill:before {\n  content: \"\\edb2\";\n}\n.ri-haze-line:before {\n  content: \"\\edb3\";\n}\n.ri-hd-fill:before {\n  content: \"\\edb4\";\n}\n.ri-hd-line:before {\n  content: \"\\edb5\";\n}\n.ri-heading:before {\n  content: \"\\edb6\";\n}\n.ri-headphone-fill:before {\n  content: \"\\edb7\";\n}\n.ri-headphone-line:before {\n  content: \"\\edb8\";\n}\n.ri-heart-2-fill:before {\n  content: \"\\edb9\";\n}\n.ri-heart-2-line:before {\n  content: \"\\edba\";\n}\n.ri-heart-add-fill:before {\n  content: \"\\edbb\";\n}\n.ri-heart-add-line:before {\n  content: \"\\edbc\";\n}\n.ri-heart-fill:before {\n  content: \"\\edbd\";\n}\n.ri-heart-line:before {\n  content: \"\\edbe\";\n}\n.ri-hearts-fill:before {\n  content: \"\\edbf\";\n}\n.ri-hearts-line:before {\n  content: \"\\edc0\";\n}\n.ri-heavy-showers-fill:before {\n  content: \"\\edc1\";\n}\n.ri-heavy-showers-line:before {\n  content: \"\\edc2\";\n}\n.ri-home-2-fill:before {\n  content: \"\\edc3\";\n}\n.ri-home-2-line:before {\n  content: \"\\edc4\";\n}\n.ri-home-3-fill:before {\n  content: \"\\edc5\";\n}\n.ri-home-3-line:before {\n  content: \"\\edc6\";\n}\n.ri-home-4-fill:before {\n  content: \"\\edc7\";\n}\n.ri-home-4-line:before {\n  content: \"\\edc8\";\n}\n.ri-home-5-fill:before {\n  content: \"\\edc9\";\n}\n.ri-home-5-line:before {\n  content: \"\\edca\";\n}\n.ri-home-6-fill:before {\n  content: \"\\edcb\";\n}\n.ri-home-6-line:before {\n  content: \"\\edcc\";\n}\n.ri-home-7-fill:before {\n  content: \"\\edcd\";\n}\n.ri-home-7-line:before {\n  content: \"\\edce\";\n}\n.ri-home-8-fill:before {\n  content: \"\\edcf\";\n}\n.ri-home-8-line:before {\n  content: \"\\edd0\";\n}\n.ri-home-fill:before {\n  content: \"\\edd1\";\n}\n.ri-home-gear-fill:before {\n  content: \"\\edd2\";\n}\n.ri-home-gear-line:before {\n  content: \"\\edd3\";\n}\n.ri-home-heart-fill:before {\n  content: \"\\edd4\";\n}\n.ri-home-heart-line:before {\n  content: \"\\edd5\";\n}\n.ri-home-line:before {\n  content: \"\\edd6\";\n}\n.ri-home-smile-2-fill:before {\n  content: \"\\edd7\";\n}\n.ri-home-smile-2-line:before {\n  content: \"\\edd8\";\n}\n.ri-home-smile-fill:before {\n  content: \"\\edd9\";\n}\n.ri-home-smile-line:before {\n  content: \"\\edda\";\n}\n.ri-home-wifi-fill:before {\n  content: \"\\eddb\";\n}\n.ri-home-wifi-line:before {\n  content: \"\\eddc\";\n}\n.ri-honour-fill:before {\n  content: \"\\eddd\";\n}\n.ri-honour-line:before {\n  content: \"\\edde\";\n}\n.ri-hospital-fill:before {\n  content: \"\\eddf\";\n}\n.ri-hospital-line:before {\n  content: \"\\ede0\";\n}\n.ri-hotel-bed-fill:before {\n  content: \"\\ede1\";\n}\n.ri-hotel-bed-line:before {\n  content: \"\\ede2\";\n}\n.ri-hotel-fill:before {\n  content: \"\\ede3\";\n}\n.ri-hotel-line:before {\n  content: \"\\ede4\";\n}\n.ri-hotspot-fill:before {\n  content: \"\\ede5\";\n}\n.ri-hotspot-line:before {\n  content: \"\\ede6\";\n}\n.ri-hq-fill:before {\n  content: \"\\ede7\";\n}\n.ri-hq-line:before {\n  content: \"\\ede8\";\n}\n.ri-html5-fill:before {\n  content: \"\\ede9\";\n}\n.ri-html5-line:before {\n  content: \"\\edea\";\n}\n.ri-ie-fill:before {\n  content: \"\\edeb\";\n}\n.ri-ie-line:before {\n  content: \"\\edec\";\n}\n.ri-image-2-fill:before {\n  content: \"\\eded\";\n}\n.ri-image-2-line:before {\n  content: \"\\edee\";\n}\n.ri-image-add-fill:before {\n  content: \"\\edef\";\n}\n.ri-image-add-line:before {\n  content: \"\\edf0\";\n}\n.ri-image-fill:before {\n  content: \"\\edf1\";\n}\n.ri-image-line:before {\n  content: \"\\edf2\";\n}\n.ri-inbox-archive-fill:before {\n  content: \"\\edf3\";\n}\n.ri-inbox-archive-line:before {\n  content: \"\\edf4\";\n}\n.ri-inbox-fill:before {\n  content: \"\\edf5\";\n}\n.ri-inbox-line:before {\n  content: \"\\edf6\";\n}\n.ri-inbox-unarchive-fill:before {\n  content: \"\\edf7\";\n}\n.ri-inbox-unarchive-line:before {\n  content: \"\\edf8\";\n}\n.ri-increase-decrease-fill:before {\n  content: \"\\edf9\";\n}\n.ri-increase-decrease-line:before {\n  content: \"\\edfa\";\n}\n.ri-indent-decrease:before {\n  content: \"\\edfb\";\n}\n.ri-indent-increase:before {\n  content: \"\\edfc\";\n}\n.ri-indeterminate-circle-fill:before {\n  content: \"\\edfd\";\n}\n.ri-indeterminate-circle-line:before {\n  content: \"\\edfe\";\n}\n.ri-information-fill:before {\n  content: \"\\edff\";\n}\n.ri-information-line:before {\n  content: \"\\ee00\";\n}\n.ri-input-cursor-move:before {\n  content: \"\\ee01\";\n}\n.ri-input-method-fill:before {\n  content: \"\\ee02\";\n}\n.ri-input-method-line:before {\n  content: \"\\ee03\";\n}\n.ri-instagram-fill:before {\n  content: \"\\ee04\";\n}\n.ri-instagram-line:before {\n  content: \"\\ee05\";\n}\n.ri-install-fill:before {\n  content: \"\\ee06\";\n}\n.ri-install-line:before {\n  content: \"\\ee07\";\n}\n.ri-invision-fill:before {\n  content: \"\\ee08\";\n}\n.ri-invision-line:before {\n  content: \"\\ee09\";\n}\n.ri-italic:before {\n  content: \"\\ee0a\";\n}\n.ri-kakao-talk-fill:before {\n  content: \"\\ee0b\";\n}\n.ri-kakao-talk-line:before {\n  content: \"\\ee0c\";\n}\n.ri-key-2-fill:before {\n  content: \"\\ee0d\";\n}\n.ri-key-2-line:before {\n  content: \"\\ee0e\";\n}\n.ri-key-fill:before {\n  content: \"\\ee0f\";\n}\n.ri-key-line:before {\n  content: \"\\ee10\";\n}\n.ri-keyboard-box-fill:before {\n  content: \"\\ee11\";\n}\n.ri-keyboard-box-line:before {\n  content: \"\\ee12\";\n}\n.ri-keyboard-fill:before {\n  content: \"\\ee13\";\n}\n.ri-keyboard-line:before {\n  content: \"\\ee14\";\n}\n.ri-keynote-fill:before {\n  content: \"\\ee15\";\n}\n.ri-keynote-line:before {\n  content: \"\\ee16\";\n}\n.ri-knife-blood-fill:before {\n  content: \"\\ee17\";\n}\n.ri-knife-blood-line:before {\n  content: \"\\ee18\";\n}\n.ri-knife-fill:before {\n  content: \"\\ee19\";\n}\n.ri-knife-line:before {\n  content: \"\\ee1a\";\n}\n.ri-landscape-fill:before {\n  content: \"\\ee1b\";\n}\n.ri-landscape-line:before {\n  content: \"\\ee1c\";\n}\n.ri-layout-2-fill:before {\n  content: \"\\ee1d\";\n}\n.ri-layout-2-line:before {\n  content: \"\\ee1e\";\n}\n.ri-layout-3-fill:before {\n  content: \"\\ee1f\";\n}\n.ri-layout-3-line:before {\n  content: \"\\ee20\";\n}\n.ri-layout-4-fill:before {\n  content: \"\\ee21\";\n}\n.ri-layout-4-line:before {\n  content: \"\\ee22\";\n}\n.ri-layout-5-fill:before {\n  content: \"\\ee23\";\n}\n.ri-layout-5-line:before {\n  content: \"\\ee24\";\n}\n.ri-layout-6-fill:before {\n  content: \"\\ee25\";\n}\n.ri-layout-6-line:before {\n  content: \"\\ee26\";\n}\n.ri-layout-bottom-2-fill:before {\n  content: \"\\ee27\";\n}\n.ri-layout-bottom-2-line:before {\n  content: \"\\ee28\";\n}\n.ri-layout-bottom-fill:before {\n  content: \"\\ee29\";\n}\n.ri-layout-bottom-line:before {\n  content: \"\\ee2a\";\n}\n.ri-layout-column-fill:before {\n  content: \"\\ee2b\";\n}\n.ri-layout-column-line:before {\n  content: \"\\ee2c\";\n}\n.ri-layout-fill:before {\n  content: \"\\ee2d\";\n}\n.ri-layout-grid-fill:before {\n  content: \"\\ee2e\";\n}\n.ri-layout-grid-line:before {\n  content: \"\\ee2f\";\n}\n.ri-layout-left-2-fill:before {\n  content: \"\\ee30\";\n}\n.ri-layout-left-2-line:before {\n  content: \"\\ee31\";\n}\n.ri-layout-left-fill:before {\n  content: \"\\ee32\";\n}\n.ri-layout-left-line:before {\n  content: \"\\ee33\";\n}\n.ri-layout-line:before {\n  content: \"\\ee34\";\n}\n.ri-layout-masonry-fill:before {\n  content: \"\\ee35\";\n}\n.ri-layout-masonry-line:before {\n  content: \"\\ee36\";\n}\n.ri-layout-right-2-fill:before {\n  content: \"\\ee37\";\n}\n.ri-layout-right-2-line:before {\n  content: \"\\ee38\";\n}\n.ri-layout-right-fill:before {\n  content: \"\\ee39\";\n}\n.ri-layout-right-line:before {\n  content: \"\\ee3a\";\n}\n.ri-layout-row-fill:before {\n  content: \"\\ee3b\";\n}\n.ri-layout-row-line:before {\n  content: \"\\ee3c\";\n}\n.ri-layout-top-2-fill:before {\n  content: \"\\ee3d\";\n}\n.ri-layout-top-2-line:before {\n  content: \"\\ee3e\";\n}\n.ri-layout-top-fill:before {\n  content: \"\\ee3f\";\n}\n.ri-layout-top-line:before {\n  content: \"\\ee40\";\n}\n.ri-lifebuoy-fill:before {\n  content: \"\\ee41\";\n}\n.ri-lifebuoy-line:before {\n  content: \"\\ee42\";\n}\n.ri-lightbulb-fill:before {\n  content: \"\\ee43\";\n}\n.ri-lightbulb-flash-fill:before {\n  content: \"\\ee44\";\n}\n.ri-lightbulb-flash-line:before {\n  content: \"\\ee45\";\n}\n.ri-lightbulb-line:before {\n  content: \"\\ee46\";\n}\n.ri-line-fill:before {\n  content: \"\\ee47\";\n}\n.ri-line-height:before {\n  content: \"\\ee48\";\n}\n.ri-line-line:before {\n  content: \"\\ee49\";\n}\n.ri-link-m:before {\n  content: \"\\ee4a\";\n}\n.ri-link-unlink-m:before {\n  content: \"\\ee4b\";\n}\n.ri-link-unlink:before {\n  content: \"\\ee4c\";\n}\n.ri-link:before {\n  content: \"\\ee4d\";\n}\n.ri-linkedin-box-fill:before {\n  content: \"\\ee4e\";\n}\n.ri-linkedin-box-line:before {\n  content: \"\\ee4f\";\n}\n.ri-linkedin-fill:before {\n  content: \"\\ee50\";\n}\n.ri-linkedin-line:before {\n  content: \"\\ee51\";\n}\n.ri-links-fill:before {\n  content: \"\\ee52\";\n}\n.ri-links-line:before {\n  content: \"\\ee53\";\n}\n.ri-list-check-2:before {\n  content: \"\\ee54\";\n}\n.ri-list-check:before {\n  content: \"\\ee55\";\n}\n.ri-list-ordered:before {\n  content: \"\\ee56\";\n}\n.ri-list-settings-fill:before {\n  content: \"\\ee57\";\n}\n.ri-list-settings-line:before {\n  content: \"\\ee58\";\n}\n.ri-list-unordered:before {\n  content: \"\\ee59\";\n}\n.ri-live-fill:before {\n  content: \"\\ee5a\";\n}\n.ri-live-line:before {\n  content: \"\\ee5b\";\n}\n.ri-loader-2-fill:before {\n  content: \"\\ee5c\";\n}\n.ri-loader-2-line:before {\n  content: \"\\ee5d\";\n}\n.ri-loader-3-fill:before {\n  content: \"\\ee5e\";\n}\n.ri-loader-3-line:before {\n  content: \"\\ee5f\";\n}\n.ri-loader-4-fill:before {\n  content: \"\\ee60\";\n}\n.ri-loader-4-line:before {\n  content: \"\\ee61\";\n}\n.ri-loader-5-fill:before {\n  content: \"\\ee62\";\n}\n.ri-loader-5-line:before {\n  content: \"\\ee63\";\n}\n.ri-loader-fill:before {\n  content: \"\\ee64\";\n}\n.ri-loader-line:before {\n  content: \"\\ee65\";\n}\n.ri-lock-2-fill:before {\n  content: \"\\ee66\";\n}\n.ri-lock-2-line:before {\n  content: \"\\ee67\";\n}\n.ri-lock-fill:before {\n  content: \"\\ee68\";\n}\n.ri-lock-line:before {\n  content: \"\\ee69\";\n}\n.ri-lock-password-fill:before {\n  content: \"\\ee6a\";\n}\n.ri-lock-password-line:before {\n  content: \"\\ee6b\";\n}\n.ri-lock-unlock-fill:before {\n  content: \"\\ee6c\";\n}\n.ri-lock-unlock-line:before {\n  content: \"\\ee6d\";\n}\n.ri-login-box-fill:before {\n  content: \"\\ee6e\";\n}\n.ri-login-box-line:before {\n  content: \"\\ee6f\";\n}\n.ri-login-circle-fill:before {\n  content: \"\\ee70\";\n}\n.ri-login-circle-line:before {\n  content: \"\\ee71\";\n}\n.ri-logout-box-fill:before {\n  content: \"\\ee72\";\n}\n.ri-logout-box-line:before {\n  content: \"\\ee73\";\n}\n.ri-logout-box-r-fill:before {\n  content: \"\\ee74\";\n}\n.ri-logout-box-r-line:before {\n  content: \"\\ee75\";\n}\n.ri-logout-circle-fill:before {\n  content: \"\\ee76\";\n}\n.ri-logout-circle-line:before {\n  content: \"\\ee77\";\n}\n.ri-logout-circle-r-fill:before {\n  content: \"\\ee78\";\n}\n.ri-logout-circle-r-line:before {\n  content: \"\\ee79\";\n}\n.ri-mac-fill:before {\n  content: \"\\ee7a\";\n}\n.ri-mac-line:before {\n  content: \"\\ee7b\";\n}\n.ri-macbook-fill:before {\n  content: \"\\ee7c\";\n}\n.ri-macbook-line:before {\n  content: \"\\ee7d\";\n}\n.ri-magic-fill:before {\n  content: \"\\ee7e\";\n}\n.ri-magic-line:before {\n  content: \"\\ee7f\";\n}\n.ri-mail-add-fill:before {\n  content: \"\\ee80\";\n}\n.ri-mail-add-line:before {\n  content: \"\\ee81\";\n}\n.ri-mail-check-fill:before {\n  content: \"\\ee82\";\n}\n.ri-mail-check-line:before {\n  content: \"\\ee83\";\n}\n.ri-mail-close-fill:before {\n  content: \"\\ee84\";\n}\n.ri-mail-close-line:before {\n  content: \"\\ee85\";\n}\n.ri-mail-download-fill:before {\n  content: \"\\ee86\";\n}\n.ri-mail-download-line:before {\n  content: \"\\ee87\";\n}\n.ri-mail-fill:before {\n  content: \"\\ee88\";\n}\n.ri-mail-forbid-fill:before {\n  content: \"\\ee89\";\n}\n.ri-mail-forbid-line:before {\n  content: \"\\ee8a\";\n}\n.ri-mail-line:before {\n  content: \"\\ee8b\";\n}\n.ri-mail-lock-fill:before {\n  content: \"\\ee8c\";\n}\n.ri-mail-lock-line:before {\n  content: \"\\ee8d\";\n}\n.ri-mail-open-fill:before {\n  content: \"\\ee8e\";\n}\n.ri-mail-open-line:before {\n  content: \"\\ee8f\";\n}\n.ri-mail-send-fill:before {\n  content: \"\\ee90\";\n}\n.ri-mail-send-line:before {\n  content: \"\\ee91\";\n}\n.ri-mail-settings-fill:before {\n  content: \"\\ee92\";\n}\n.ri-mail-settings-line:before {\n  content: \"\\ee93\";\n}\n.ri-mail-star-fill:before {\n  content: \"\\ee94\";\n}\n.ri-mail-star-line:before {\n  content: \"\\ee95\";\n}\n.ri-mail-unread-fill:before {\n  content: \"\\ee96\";\n}\n.ri-mail-unread-line:before {\n  content: \"\\ee97\";\n}\n.ri-mail-volume-fill:before {\n  content: \"\\ee98\";\n}\n.ri-mail-volume-line:before {\n  content: \"\\ee99\";\n}\n.ri-map-2-fill:before {\n  content: \"\\ee9a\";\n}\n.ri-map-2-line:before {\n  content: \"\\ee9b\";\n}\n.ri-map-fill:before {\n  content: \"\\ee9c\";\n}\n.ri-map-line:before {\n  content: \"\\ee9d\";\n}\n.ri-map-pin-2-fill:before {\n  content: \"\\ee9e\";\n}\n.ri-map-pin-2-line:before {\n  content: \"\\ee9f\";\n}\n.ri-map-pin-3-fill:before {\n  content: \"\\eea0\";\n}\n.ri-map-pin-3-line:before {\n  content: \"\\eea1\";\n}\n.ri-map-pin-4-fill:before {\n  content: \"\\eea2\";\n}\n.ri-map-pin-4-line:before {\n  content: \"\\eea3\";\n}\n.ri-map-pin-5-fill:before {\n  content: \"\\eea4\";\n}\n.ri-map-pin-5-line:before {\n  content: \"\\eea5\";\n}\n.ri-map-pin-add-fill:before {\n  content: \"\\eea6\";\n}\n.ri-map-pin-add-line:before {\n  content: \"\\eea7\";\n}\n.ri-map-pin-fill:before {\n  content: \"\\eea8\";\n}\n.ri-map-pin-line:before {\n  content: \"\\eea9\";\n}\n.ri-map-pin-range-fill:before {\n  content: \"\\eeaa\";\n}\n.ri-map-pin-range-line:before {\n  content: \"\\eeab\";\n}\n.ri-map-pin-time-fill:before {\n  content: \"\\eeac\";\n}\n.ri-map-pin-time-line:before {\n  content: \"\\eead\";\n}\n.ri-map-pin-user-fill:before {\n  content: \"\\eeae\";\n}\n.ri-map-pin-user-line:before {\n  content: \"\\eeaf\";\n}\n.ri-mark-pen-fill:before {\n  content: \"\\eeb0\";\n}\n.ri-mark-pen-line:before {\n  content: \"\\eeb1\";\n}\n.ri-markdown-fill:before {\n  content: \"\\eeb2\";\n}\n.ri-markdown-line:before {\n  content: \"\\eeb3\";\n}\n.ri-markup-fill:before {\n  content: \"\\eeb4\";\n}\n.ri-markup-line:before {\n  content: \"\\eeb5\";\n}\n.ri-mastercard-fill:before {\n  content: \"\\eeb6\";\n}\n.ri-mastercard-line:before {\n  content: \"\\eeb7\";\n}\n.ri-mastodon-fill:before {\n  content: \"\\eeb8\";\n}\n.ri-mastodon-line:before {\n  content: \"\\eeb9\";\n}\n.ri-medal-2-fill:before {\n  content: \"\\eeba\";\n}\n.ri-medal-2-line:before {\n  content: \"\\eebb\";\n}\n.ri-medal-fill:before {\n  content: \"\\eebc\";\n}\n.ri-medal-line:before {\n  content: \"\\eebd\";\n}\n.ri-medium-fill:before {\n  content: \"\\eebe\";\n}\n.ri-medium-line:before {\n  content: \"\\eebf\";\n}\n.ri-men-fill:before {\n  content: \"\\eec0\";\n}\n.ri-men-line:before {\n  content: \"\\eec1\";\n}\n.ri-menu-2-fill:before {\n  content: \"\\eec2\";\n}\n.ri-menu-2-line:before {\n  content: \"\\eec3\";\n}\n.ri-menu-3-fill:before {\n  content: \"\\eec4\";\n}\n.ri-menu-3-line:before {\n  content: \"\\eec5\";\n}\n.ri-menu-4-fill:before {\n  content: \"\\eec6\";\n}\n.ri-menu-4-line:before {\n  content: \"\\eec7\";\n}\n.ri-menu-5-fill:before {\n  content: \"\\eec8\";\n}\n.ri-menu-5-line:before {\n  content: \"\\eec9\";\n}\n.ri-menu-add-fill:before {\n  content: \"\\eeca\";\n}\n.ri-menu-add-line:before {\n  content: \"\\eecb\";\n}\n.ri-menu-fill:before {\n  content: \"\\eecc\";\n}\n.ri-menu-line:before {\n  content: \"\\eecd\";\n}\n.ri-message-2-fill:before {\n  content: \"\\eece\";\n}\n.ri-message-2-line:before {\n  content: \"\\eecf\";\n}\n.ri-message-3-fill:before {\n  content: \"\\eed0\";\n}\n.ri-message-3-line:before {\n  content: \"\\eed1\";\n}\n.ri-message-fill:before {\n  content: \"\\eed2\";\n}\n.ri-message-line:before {\n  content: \"\\eed3\";\n}\n.ri-messenger-fill:before {\n  content: \"\\eed4\";\n}\n.ri-messenger-line:before {\n  content: \"\\eed5\";\n}\n.ri-meteor-fill:before {\n  content: \"\\eed6\";\n}\n.ri-meteor-line:before {\n  content: \"\\eed7\";\n}\n.ri-mic-2-fill:before {\n  content: \"\\eed8\";\n}\n.ri-mic-2-line:before {\n  content: \"\\eed9\";\n}\n.ri-mic-fill:before {\n  content: \"\\eeda\";\n}\n.ri-mic-line:before {\n  content: \"\\eedb\";\n}\n.ri-mic-off-fill:before {\n  content: \"\\eedc\";\n}\n.ri-mic-off-line:before {\n  content: \"\\eedd\";\n}\n.ri-mickey-fill:before {\n  content: \"\\eede\";\n}\n.ri-mickey-line:before {\n  content: \"\\eedf\";\n}\n.ri-mini-program-fill:before {\n  content: \"\\eee0\";\n}\n.ri-mini-program-line:before {\n  content: \"\\eee1\";\n}\n.ri-mist-fill:before {\n  content: \"\\eee2\";\n}\n.ri-mist-line:before {\n  content: \"\\eee3\";\n}\n.ri-money-cny-box-fill:before {\n  content: \"\\eee4\";\n}\n.ri-money-cny-box-line:before {\n  content: \"\\eee5\";\n}\n.ri-money-cny-circle-fill:before {\n  content: \"\\eee6\";\n}\n.ri-money-cny-circle-line:before {\n  content: \"\\eee7\";\n}\n.ri-money-dollar-box-fill:before {\n  content: \"\\eee8\";\n}\n.ri-money-dollar-box-line:before {\n  content: \"\\eee9\";\n}\n.ri-money-dollar-circle-fill:before {\n  content: \"\\eeea\";\n}\n.ri-money-dollar-circle-line:before {\n  content: \"\\eeeb\";\n}\n.ri-money-euro-box-fill:before {\n  content: \"\\eeec\";\n}\n.ri-money-euro-box-line:before {\n  content: \"\\eeed\";\n}\n.ri-money-euro-circle-fill:before {\n  content: \"\\eeee\";\n}\n.ri-money-euro-circle-line:before {\n  content: \"\\eeef\";\n}\n.ri-money-pound-box-fill:before {\n  content: \"\\eef0\";\n}\n.ri-money-pound-box-line:before {\n  content: \"\\eef1\";\n}\n.ri-money-pound-circle-fill:before {\n  content: \"\\eef2\";\n}\n.ri-money-pound-circle-line:before {\n  content: \"\\eef3\";\n}\n.ri-moon-clear-fill:before {\n  content: \"\\eef4\";\n}\n.ri-moon-clear-line:before {\n  content: \"\\eef5\";\n}\n.ri-moon-cloudy-fill:before {\n  content: \"\\eef6\";\n}\n.ri-moon-cloudy-line:before {\n  content: \"\\eef7\";\n}\n.ri-moon-fill:before {\n  content: \"\\eef8\";\n}\n.ri-moon-foggy-fill:before {\n  content: \"\\eef9\";\n}\n.ri-moon-foggy-line:before {\n  content: \"\\eefa\";\n}\n.ri-moon-line:before {\n  content: \"\\eefb\";\n}\n.ri-more-2-fill:before {\n  content: \"\\eefc\";\n}\n.ri-more-2-line:before {\n  content: \"\\eefd\";\n}\n.ri-more-fill:before {\n  content: \"\\eefe\";\n}\n.ri-more-line:before {\n  content: \"\\eeff\";\n}\n.ri-motorbike-fill:before {\n  content: \"\\ef00\";\n}\n.ri-motorbike-line:before {\n  content: \"\\ef01\";\n}\n.ri-mouse-fill:before {\n  content: \"\\ef02\";\n}\n.ri-mouse-line:before {\n  content: \"\\ef03\";\n}\n.ri-movie-2-fill:before {\n  content: \"\\ef04\";\n}\n.ri-movie-2-line:before {\n  content: \"\\ef05\";\n}\n.ri-movie-fill:before {\n  content: \"\\ef06\";\n}\n.ri-movie-line:before {\n  content: \"\\ef07\";\n}\n.ri-music-2-fill:before {\n  content: \"\\ef08\";\n}\n.ri-music-2-line:before {\n  content: \"\\ef09\";\n}\n.ri-music-fill:before {\n  content: \"\\ef0a\";\n}\n.ri-music-line:before {\n  content: \"\\ef0b\";\n}\n.ri-mv-fill:before {\n  content: \"\\ef0c\";\n}\n.ri-mv-line:before {\n  content: \"\\ef0d\";\n}\n.ri-navigation-fill:before {\n  content: \"\\ef0e\";\n}\n.ri-navigation-line:before {\n  content: \"\\ef0f\";\n}\n.ri-netease-cloud-music-fill:before {\n  content: \"\\ef10\";\n}\n.ri-netease-cloud-music-line:before {\n  content: \"\\ef11\";\n}\n.ri-netflix-fill:before {\n  content: \"\\ef12\";\n}\n.ri-netflix-line:before {\n  content: \"\\ef13\";\n}\n.ri-newspaper-fill:before {\n  content: \"\\ef14\";\n}\n.ri-newspaper-line:before {\n  content: \"\\ef15\";\n}\n.ri-notification-2-fill:before {\n  content: \"\\ef16\";\n}\n.ri-notification-2-line:before {\n  content: \"\\ef17\";\n}\n.ri-notification-3-fill:before {\n  content: \"\\ef18\";\n}\n.ri-notification-3-line:before {\n  content: \"\\ef19\";\n}\n.ri-notification-4-fill:before {\n  content: \"\\ef1a\";\n}\n.ri-notification-4-line:before {\n  content: \"\\ef1b\";\n}\n.ri-notification-badge-fill:before {\n  content: \"\\ef1c\";\n}\n.ri-notification-badge-line:before {\n  content: \"\\ef1d\";\n}\n.ri-notification-fill:before {\n  content: \"\\ef1e\";\n}\n.ri-notification-line:before {\n  content: \"\\ef1f\";\n}\n.ri-notification-off-fill:before {\n  content: \"\\ef20\";\n}\n.ri-notification-off-line:before {\n  content: \"\\ef21\";\n}\n.ri-number-0:before {\n  content: \"\\ef22\";\n}\n.ri-number-1:before {\n  content: \"\\ef23\";\n}\n.ri-number-2:before {\n  content: \"\\ef24\";\n}\n.ri-number-3:before {\n  content: \"\\ef25\";\n}\n.ri-number-4:before {\n  content: \"\\ef26\";\n}\n.ri-number-5:before {\n  content: \"\\ef27\";\n}\n.ri-number-6:before {\n  content: \"\\ef28\";\n}\n.ri-number-7:before {\n  content: \"\\ef29\";\n}\n.ri-number-8:before {\n  content: \"\\ef2a\";\n}\n.ri-number-9:before {\n  content: \"\\ef2b\";\n}\n.ri-numbers-fill:before {\n  content: \"\\ef2c\";\n}\n.ri-numbers-line:before {\n  content: \"\\ef2d\";\n}\n.ri-oil-fill:before {\n  content: \"\\ef2e\";\n}\n.ri-oil-line:before {\n  content: \"\\ef2f\";\n}\n.ri-omega:before {\n  content: \"\\ef30\";\n}\n.ri-open-arm-fill:before {\n  content: \"\\ef31\";\n}\n.ri-open-arm-line:before {\n  content: \"\\ef32\";\n}\n.ri-opera-fill:before {\n  content: \"\\ef33\";\n}\n.ri-opera-line:before {\n  content: \"\\ef34\";\n}\n.ri-order-play-fill:before {\n  content: \"\\ef35\";\n}\n.ri-order-play-line:before {\n  content: \"\\ef36\";\n}\n.ri-outlet-2-fill:before {\n  content: \"\\ef37\";\n}\n.ri-outlet-2-line:before {\n  content: \"\\ef38\";\n}\n.ri-outlet-fill:before {\n  content: \"\\ef39\";\n}\n.ri-outlet-line:before {\n  content: \"\\ef3a\";\n}\n.ri-page-separator:before {\n  content: \"\\ef3b\";\n}\n.ri-pages-fill:before {\n  content: \"\\ef3c\";\n}\n.ri-pages-line:before {\n  content: \"\\ef3d\";\n}\n.ri-paint-brush-fill:before {\n  content: \"\\ef3e\";\n}\n.ri-paint-brush-line:before {\n  content: \"\\ef3f\";\n}\n.ri-paint-fill:before {\n  content: \"\\ef40\";\n}\n.ri-paint-line:before {\n  content: \"\\ef41\";\n}\n.ri-palette-fill:before {\n  content: \"\\ef42\";\n}\n.ri-palette-line:before {\n  content: \"\\ef43\";\n}\n.ri-pantone-fill:before {\n  content: \"\\ef44\";\n}\n.ri-pantone-line:before {\n  content: \"\\ef45\";\n}\n.ri-paragraph:before {\n  content: \"\\ef46\";\n}\n.ri-parent-fill:before {\n  content: \"\\ef47\";\n}\n.ri-parent-line:before {\n  content: \"\\ef48\";\n}\n.ri-parentheses-fill:before {\n  content: \"\\ef49\";\n}\n.ri-parentheses-line:before {\n  content: \"\\ef4a\";\n}\n.ri-parking-box-fill:before {\n  content: \"\\ef4b\";\n}\n.ri-parking-box-line:before {\n  content: \"\\ef4c\";\n}\n.ri-parking-fill:before {\n  content: \"\\ef4d\";\n}\n.ri-parking-line:before {\n  content: \"\\ef4e\";\n}\n.ri-passport-fill:before {\n  content: \"\\ef4f\";\n}\n.ri-passport-line:before {\n  content: \"\\ef50\";\n}\n.ri-patreon-fill:before {\n  content: \"\\ef51\";\n}\n.ri-patreon-line:before {\n  content: \"\\ef52\";\n}\n.ri-pause-circle-fill:before {\n  content: \"\\ef53\";\n}\n.ri-pause-circle-line:before {\n  content: \"\\ef54\";\n}\n.ri-pause-fill:before {\n  content: \"\\ef55\";\n}\n.ri-pause-line:before {\n  content: \"\\ef56\";\n}\n.ri-pause-mini-fill:before {\n  content: \"\\ef57\";\n}\n.ri-pause-mini-line:before {\n  content: \"\\ef58\";\n}\n.ri-paypal-fill:before {\n  content: \"\\ef59\";\n}\n.ri-paypal-line:before {\n  content: \"\\ef5a\";\n}\n.ri-pen-nib-fill:before {\n  content: \"\\ef5b\";\n}\n.ri-pen-nib-line:before {\n  content: \"\\ef5c\";\n}\n.ri-pencil-fill:before {\n  content: \"\\ef5d\";\n}\n.ri-pencil-line:before {\n  content: \"\\ef5e\";\n}\n.ri-pencil-ruler-2-fill:before {\n  content: \"\\ef5f\";\n}\n.ri-pencil-ruler-2-line:before {\n  content: \"\\ef60\";\n}\n.ri-pencil-ruler-fill:before {\n  content: \"\\ef61\";\n}\n.ri-pencil-ruler-line:before {\n  content: \"\\ef62\";\n}\n.ri-percent-fill:before {\n  content: \"\\ef63\";\n}\n.ri-percent-line:before {\n  content: \"\\ef64\";\n}\n.ri-phone-camera-fill:before {\n  content: \"\\ef65\";\n}\n.ri-phone-camera-line:before {\n  content: \"\\ef66\";\n}\n.ri-phone-fill:before {\n  content: \"\\ef67\";\n}\n.ri-phone-find-fill:before {\n  content: \"\\ef68\";\n}\n.ri-phone-find-line:before {\n  content: \"\\ef69\";\n}\n.ri-phone-line:before {\n  content: \"\\ef6a\";\n}\n.ri-phone-lock-fill:before {\n  content: \"\\ef6b\";\n}\n.ri-phone-lock-line:before {\n  content: \"\\ef6c\";\n}\n.ri-picture-in-picture-2-fill:before {\n  content: \"\\ef6d\";\n}\n.ri-picture-in-picture-2-line:before {\n  content: \"\\ef6e\";\n}\n.ri-picture-in-picture-exit-fill:before {\n  content: \"\\ef6f\";\n}\n.ri-picture-in-picture-exit-line:before {\n  content: \"\\ef70\";\n}\n.ri-picture-in-picture-fill:before {\n  content: \"\\ef71\";\n}\n.ri-picture-in-picture-line:before {\n  content: \"\\ef72\";\n}\n.ri-pie-chart-2-fill:before {\n  content: \"\\ef73\";\n}\n.ri-pie-chart-2-line:before {\n  content: \"\\ef74\";\n}\n.ri-pie-chart-box-fill:before {\n  content: \"\\ef75\";\n}\n.ri-pie-chart-box-line:before {\n  content: \"\\ef76\";\n}\n.ri-pie-chart-fill:before {\n  content: \"\\ef77\";\n}\n.ri-pie-chart-line:before {\n  content: \"\\ef78\";\n}\n.ri-pin-distance-fill:before {\n  content: \"\\ef79\";\n}\n.ri-pin-distance-line:before {\n  content: \"\\ef7a\";\n}\n.ri-ping-pong-fill:before {\n  content: \"\\ef7b\";\n}\n.ri-ping-pong-line:before {\n  content: \"\\ef7c\";\n}\n.ri-pinterest-fill:before {\n  content: \"\\ef7d\";\n}\n.ri-pinterest-line:before {\n  content: \"\\ef7e\";\n}\n.ri-pinyin-input:before {\n  content: \"\\ef7f\";\n}\n.ri-plane-fill:before {\n  content: \"\\ef80\";\n}\n.ri-plane-line:before {\n  content: \"\\ef81\";\n}\n.ri-play-circle-fill:before {\n  content: \"\\ef82\";\n}\n.ri-play-circle-line:before {\n  content: \"\\ef83\";\n}\n.ri-play-fill:before {\n  content: \"\\ef84\";\n}\n.ri-play-line:before {\n  content: \"\\ef85\";\n}\n.ri-play-list-add-fill:before {\n  content: \"\\ef86\";\n}\n.ri-play-list-add-line:before {\n  content: \"\\ef87\";\n}\n.ri-play-list-fill:before {\n  content: \"\\ef88\";\n}\n.ri-play-list-line:before {\n  content: \"\\ef89\";\n}\n.ri-play-mini-fill:before {\n  content: \"\\ef8a\";\n}\n.ri-play-mini-line:before {\n  content: \"\\ef8b\";\n}\n.ri-playstation-fill:before {\n  content: \"\\ef8c\";\n}\n.ri-playstation-line:before {\n  content: \"\\ef8d\";\n}\n.ri-plug-2-fill:before {\n  content: \"\\ef8e\";\n}\n.ri-plug-2-line:before {\n  content: \"\\ef8f\";\n}\n.ri-plug-fill:before {\n  content: \"\\ef90\";\n}\n.ri-plug-line:before {\n  content: \"\\ef91\";\n}\n.ri-polaroid-2-fill:before {\n  content: \"\\ef92\";\n}\n.ri-polaroid-2-line:before {\n  content: \"\\ef93\";\n}\n.ri-polaroid-fill:before {\n  content: \"\\ef94\";\n}\n.ri-polaroid-line:before {\n  content: \"\\ef95\";\n}\n.ri-police-car-fill:before {\n  content: \"\\ef96\";\n}\n.ri-police-car-line:before {\n  content: \"\\ef97\";\n}\n.ri-price-tag-2-fill:before {\n  content: \"\\ef98\";\n}\n.ri-price-tag-2-line:before {\n  content: \"\\ef99\";\n}\n.ri-price-tag-3-fill:before {\n  content: \"\\ef9a\";\n}\n.ri-price-tag-3-line:before {\n  content: \"\\ef9b\";\n}\n.ri-price-tag-fill:before {\n  content: \"\\ef9c\";\n}\n.ri-price-tag-line:before {\n  content: \"\\ef9d\";\n}\n.ri-printer-cloud-fill:before {\n  content: \"\\ef9e\";\n}\n.ri-printer-cloud-line:before {\n  content: \"\\ef9f\";\n}\n.ri-printer-fill:before {\n  content: \"\\efa0\";\n}\n.ri-printer-line:before {\n  content: \"\\efa1\";\n}\n.ri-product-hunt-fill:before {\n  content: \"\\efa2\";\n}\n.ri-product-hunt-line:before {\n  content: \"\\efa3\";\n}\n.ri-profile-fill:before {\n  content: \"\\efa4\";\n}\n.ri-profile-line:before {\n  content: \"\\efa5\";\n}\n.ri-projector-2-fill:before {\n  content: \"\\efa6\";\n}\n.ri-projector-2-line:before {\n  content: \"\\efa7\";\n}\n.ri-projector-fill:before {\n  content: \"\\efa8\";\n}\n.ri-projector-line:before {\n  content: \"\\efa9\";\n}\n.ri-pushpin-2-fill:before {\n  content: \"\\efaa\";\n}\n.ri-pushpin-2-line:before {\n  content: \"\\efab\";\n}\n.ri-pushpin-fill:before {\n  content: \"\\efac\";\n}\n.ri-pushpin-line:before {\n  content: \"\\efad\";\n}\n.ri-qq-fill:before {\n  content: \"\\efae\";\n}\n.ri-qq-line:before {\n  content: \"\\efaf\";\n}\n.ri-qr-code-fill:before {\n  content: \"\\efb0\";\n}\n.ri-qr-code-line:before {\n  content: \"\\efb1\";\n}\n.ri-qr-scan-2-fill:before {\n  content: \"\\efb2\";\n}\n.ri-qr-scan-2-line:before {\n  content: \"\\efb3\";\n}\n.ri-qr-scan-fill:before {\n  content: \"\\efb4\";\n}\n.ri-qr-scan-line:before {\n  content: \"\\efb5\";\n}\n.ri-question-answer-fill:before {\n  content: \"\\efb6\";\n}\n.ri-question-answer-line:before {\n  content: \"\\efb7\";\n}\n.ri-question-fill:before {\n  content: \"\\efb8\";\n}\n.ri-question-line:before {\n  content: \"\\efb9\";\n}\n.ri-questionnaire-fill:before {\n  content: \"\\efba\";\n}\n.ri-questionnaire-line:before {\n  content: \"\\efbb\";\n}\n.ri-quill-pen-fill:before {\n  content: \"\\efbc\";\n}\n.ri-quill-pen-line:before {\n  content: \"\\efbd\";\n}\n.ri-radar-fill:before {\n  content: \"\\efbe\";\n}\n.ri-radar-line:before {\n  content: \"\\efbf\";\n}\n.ri-radio-2-fill:before {\n  content: \"\\efc0\";\n}\n.ri-radio-2-line:before {\n  content: \"\\efc1\";\n}\n.ri-radio-button-fill:before {\n  content: \"\\efc2\";\n}\n.ri-radio-button-line:before {\n  content: \"\\efc3\";\n}\n.ri-radio-fill:before {\n  content: \"\\efc4\";\n}\n.ri-radio-line:before {\n  content: \"\\efc5\";\n}\n.ri-rainbow-fill:before {\n  content: \"\\efc6\";\n}\n.ri-rainbow-line:before {\n  content: \"\\efc7\";\n}\n.ri-rainy-fill:before {\n  content: \"\\efc8\";\n}\n.ri-rainy-line:before {\n  content: \"\\efc9\";\n}\n.ri-reactjs-fill:before {\n  content: \"\\efca\";\n}\n.ri-reactjs-line:before {\n  content: \"\\efcb\";\n}\n.ri-record-circle-fill:before {\n  content: \"\\efcc\";\n}\n.ri-record-circle-line:before {\n  content: \"\\efcd\";\n}\n.ri-record-mail-fill:before {\n  content: \"\\efce\";\n}\n.ri-record-mail-line:before {\n  content: \"\\efcf\";\n}\n.ri-red-packet-fill:before {\n  content: \"\\efd0\";\n}\n.ri-red-packet-line:before {\n  content: \"\\efd1\";\n}\n.ri-reddit-fill:before {\n  content: \"\\efd2\";\n}\n.ri-reddit-line:before {\n  content: \"\\efd3\";\n}\n.ri-refresh-fill:before {\n  content: \"\\efd4\";\n}\n.ri-refresh-line:before {\n  content: \"\\efd5\";\n}\n.ri-refund-2-fill:before {\n  content: \"\\efd6\";\n}\n.ri-refund-2-line:before {\n  content: \"\\efd7\";\n}\n.ri-refund-fill:before {\n  content: \"\\efd8\";\n}\n.ri-refund-line:before {\n  content: \"\\efd9\";\n}\n.ri-registered-fill:before {\n  content: \"\\efda\";\n}\n.ri-registered-line:before {\n  content: \"\\efdb\";\n}\n.ri-remixicon-fill:before {\n  content: \"\\efdc\";\n}\n.ri-remixicon-line:before {\n  content: \"\\efdd\";\n}\n.ri-remote-control-2-fill:before {\n  content: \"\\efde\";\n}\n.ri-remote-control-2-line:before {\n  content: \"\\efdf\";\n}\n.ri-remote-control-fill:before {\n  content: \"\\efe0\";\n}\n.ri-remote-control-line:before {\n  content: \"\\efe1\";\n}\n.ri-repeat-2-fill:before {\n  content: \"\\efe2\";\n}\n.ri-repeat-2-line:before {\n  content: \"\\efe3\";\n}\n.ri-repeat-fill:before {\n  content: \"\\efe4\";\n}\n.ri-repeat-line:before {\n  content: \"\\efe5\";\n}\n.ri-repeat-one-fill:before {\n  content: \"\\efe6\";\n}\n.ri-repeat-one-line:before {\n  content: \"\\efe7\";\n}\n.ri-reply-fill:before {\n  content: \"\\efe8\";\n}\n.ri-reply-line:before {\n  content: \"\\efe9\";\n}\n.ri-reserved-fill:before {\n  content: \"\\efea\";\n}\n.ri-reserved-line:before {\n  content: \"\\efeb\";\n}\n.ri-restart-fill:before {\n  content: \"\\efec\";\n}\n.ri-restart-line:before {\n  content: \"\\efed\";\n}\n.ri-restaurant-2-fill:before {\n  content: \"\\efee\";\n}\n.ri-restaurant-2-line:before {\n  content: \"\\efef\";\n}\n.ri-restaurant-fill:before {\n  content: \"\\eff0\";\n}\n.ri-restaurant-line:before {\n  content: \"\\eff1\";\n}\n.ri-rewind-fill:before {\n  content: \"\\eff2\";\n}\n.ri-rewind-line:before {\n  content: \"\\eff3\";\n}\n.ri-rewind-mini-fill:before {\n  content: \"\\eff4\";\n}\n.ri-rewind-mini-line:before {\n  content: \"\\eff5\";\n}\n.ri-rhythm-fill:before {\n  content: \"\\eff6\";\n}\n.ri-rhythm-line:before {\n  content: \"\\eff7\";\n}\n.ri-riding-fill:before {\n  content: \"\\eff8\";\n}\n.ri-riding-line:before {\n  content: \"\\eff9\";\n}\n.ri-road-map-fill:before {\n  content: \"\\effa\";\n}\n.ri-road-map-line:before {\n  content: \"\\effb\";\n}\n.ri-roadster-fill:before {\n  content: \"\\effc\";\n}\n.ri-roadster-line:before {\n  content: \"\\effd\";\n}\n.ri-robot-fill:before {\n  content: \"\\effe\";\n}\n.ri-robot-line:before {\n  content: \"\\efff\";\n}\n.ri-rocket-2-fill:before {\n  content: \"\\f000\";\n}\n.ri-rocket-2-line:before {\n  content: \"\\f001\";\n}\n.ri-rocket-fill:before {\n  content: \"\\f002\";\n}\n.ri-rocket-line:before {\n  content: \"\\f003\";\n}\n.ri-rotate-lock-fill:before {\n  content: \"\\f004\";\n}\n.ri-rotate-lock-line:before {\n  content: \"\\f005\";\n}\n.ri-route-fill:before {\n  content: \"\\f006\";\n}\n.ri-route-line:before {\n  content: \"\\f007\";\n}\n.ri-router-fill:before {\n  content: \"\\f008\";\n}\n.ri-router-line:before {\n  content: \"\\f009\";\n}\n.ri-rss-fill:before {\n  content: \"\\f00a\";\n}\n.ri-rss-line:before {\n  content: \"\\f00b\";\n}\n.ri-ruler-2-fill:before {\n  content: \"\\f00c\";\n}\n.ri-ruler-2-line:before {\n  content: \"\\f00d\";\n}\n.ri-ruler-fill:before {\n  content: \"\\f00e\";\n}\n.ri-ruler-line:before {\n  content: \"\\f00f\";\n}\n.ri-run-fill:before {\n  content: \"\\f010\";\n}\n.ri-run-line:before {\n  content: \"\\f011\";\n}\n.ri-safari-fill:before {\n  content: \"\\f012\";\n}\n.ri-safari-line:before {\n  content: \"\\f013\";\n}\n.ri-safe-2-fill:before {\n  content: \"\\f014\";\n}\n.ri-safe-2-line:before {\n  content: \"\\f015\";\n}\n.ri-safe-fill:before {\n  content: \"\\f016\";\n}\n.ri-safe-line:before {\n  content: \"\\f017\";\n}\n.ri-sailboat-fill:before {\n  content: \"\\f018\";\n}\n.ri-sailboat-line:before {\n  content: \"\\f019\";\n}\n.ri-save-2-fill:before {\n  content: \"\\f01a\";\n}\n.ri-save-2-line:before {\n  content: \"\\f01b\";\n}\n.ri-save-3-fill:before {\n  content: \"\\f01c\";\n}\n.ri-save-3-line:before {\n  content: \"\\f01d\";\n}\n.ri-save-fill:before {\n  content: \"\\f01e\";\n}\n.ri-save-line:before {\n  content: \"\\f01f\";\n}\n.ri-scan-2-fill:before {\n  content: \"\\f020\";\n}\n.ri-scan-2-line:before {\n  content: \"\\f021\";\n}\n.ri-scan-fill:before {\n  content: \"\\f022\";\n}\n.ri-scan-line:before {\n  content: \"\\f023\";\n}\n.ri-scissors-2-fill:before {\n  content: \"\\f024\";\n}\n.ri-scissors-2-line:before {\n  content: \"\\f025\";\n}\n.ri-scissors-cut-fill:before {\n  content: \"\\f026\";\n}\n.ri-scissors-cut-line:before {\n  content: \"\\f027\";\n}\n.ri-scissors-fill:before {\n  content: \"\\f028\";\n}\n.ri-scissors-line:before {\n  content: \"\\f029\";\n}\n.ri-screenshot-2-fill:before {\n  content: \"\\f02a\";\n}\n.ri-screenshot-2-line:before {\n  content: \"\\f02b\";\n}\n.ri-screenshot-fill:before {\n  content: \"\\f02c\";\n}\n.ri-screenshot-line:before {\n  content: \"\\f02d\";\n}\n.ri-sd-card-fill:before {\n  content: \"\\f02e\";\n}\n.ri-sd-card-line:before {\n  content: \"\\f02f\";\n}\n.ri-sd-card-mini-fill:before {\n  content: \"\\f030\";\n}\n.ri-sd-card-mini-line:before {\n  content: \"\\f031\";\n}\n.ri-search-2-fill:before {\n  content: \"\\f032\";\n}\n.ri-search-2-line:before {\n  content: \"\\f033\";\n}\n.ri-search-eye-fill:before {\n  content: \"\\f034\";\n}\n.ri-search-eye-line:before {\n  content: \"\\f035\";\n}\n.ri-search-fill:before {\n  content: \"\\f036\";\n}\n.ri-search-line:before {\n  content: \"\\f037\";\n}\n.ri-secure-payment-fill:before {\n  content: \"\\f038\";\n}\n.ri-secure-payment-line:before {\n  content: \"\\f039\";\n}\n.ri-send-plane-2-fill:before {\n  content: \"\\f03a\";\n}\n.ri-send-plane-2-line:before {\n  content: \"\\f03b\";\n}\n.ri-send-plane-fill:before {\n  content: \"\\f03c\";\n}\n.ri-send-plane-line:before {\n  content: \"\\f03d\";\n}\n.ri-sensor-fill:before {\n  content: \"\\f03e\";\n}\n.ri-sensor-line:before {\n  content: \"\\f03f\";\n}\n.ri-separator:before {\n  content: \"\\f040\";\n}\n.ri-server-fill:before {\n  content: \"\\f041\";\n}\n.ri-server-line:before {\n  content: \"\\f042\";\n}\n.ri-service-fill:before {\n  content: \"\\f043\";\n}\n.ri-service-line:before {\n  content: \"\\f044\";\n}\n.ri-settings-2-fill:before {\n  content: \"\\f045\";\n}\n.ri-settings-2-line:before {\n  content: \"\\f046\";\n}\n.ri-settings-3-fill:before {\n  content: \"\\f047\";\n}\n.ri-settings-3-line:before {\n  content: \"\\f048\";\n}\n.ri-settings-4-fill:before {\n  content: \"\\f049\";\n}\n.ri-settings-4-line:before {\n  content: \"\\f04a\";\n}\n.ri-settings-5-fill:before {\n  content: \"\\f04b\";\n}\n.ri-settings-5-line:before {\n  content: \"\\f04c\";\n}\n.ri-settings-6-fill:before {\n  content: \"\\f04d\";\n}\n.ri-settings-6-line:before {\n  content: \"\\f04e\";\n}\n.ri-settings-fill:before {\n  content: \"\\f04f\";\n}\n.ri-settings-line:before {\n  content: \"\\f050\";\n}\n.ri-shape-2-fill:before {\n  content: \"\\f051\";\n}\n.ri-shape-2-line:before {\n  content: \"\\f052\";\n}\n.ri-shape-fill:before {\n  content: \"\\f053\";\n}\n.ri-shape-line:before {\n  content: \"\\f054\";\n}\n.ri-share-box-fill:before {\n  content: \"\\f055\";\n}\n.ri-share-box-line:before {\n  content: \"\\f056\";\n}\n.ri-share-circle-fill:before {\n  content: \"\\f057\";\n}\n.ri-share-circle-line:before {\n  content: \"\\f058\";\n}\n.ri-share-fill:before {\n  content: \"\\f059\";\n}\n.ri-share-forward-2-fill:before {\n  content: \"\\f05a\";\n}\n.ri-share-forward-2-line:before {\n  content: \"\\f05b\";\n}\n.ri-share-forward-box-fill:before {\n  content: \"\\f05c\";\n}\n.ri-share-forward-box-line:before {\n  content: \"\\f05d\";\n}\n.ri-share-forward-fill:before {\n  content: \"\\f05e\";\n}\n.ri-share-forward-line:before {\n  content: \"\\f05f\";\n}\n.ri-share-line:before {\n  content: \"\\f060\";\n}\n.ri-shield-cross-fill:before {\n  content: \"\\f061\";\n}\n.ri-shield-cross-line:before {\n  content: \"\\f062\";\n}\n.ri-shield-fill:before {\n  content: \"\\f063\";\n}\n.ri-shield-flash-fill:before {\n  content: \"\\f064\";\n}\n.ri-shield-flash-line:before {\n  content: \"\\f065\";\n}\n.ri-shield-keyhole-fill:before {\n  content: \"\\f066\";\n}\n.ri-shield-keyhole-line:before {\n  content: \"\\f067\";\n}\n.ri-shield-line:before {\n  content: \"\\f068\";\n}\n.ri-shield-star-fill:before {\n  content: \"\\f069\";\n}\n.ri-shield-star-line:before {\n  content: \"\\f06a\";\n}\n.ri-shield-user-fill:before {\n  content: \"\\f06b\";\n}\n.ri-shield-user-line:before {\n  content: \"\\f06c\";\n}\n.ri-ship-2-fill:before {\n  content: \"\\f06d\";\n}\n.ri-ship-2-line:before {\n  content: \"\\f06e\";\n}\n.ri-ship-fill:before {\n  content: \"\\f06f\";\n}\n.ri-ship-line:before {\n  content: \"\\f070\";\n}\n.ri-shirt-fill:before {\n  content: \"\\f071\";\n}\n.ri-shirt-line:before {\n  content: \"\\f072\";\n}\n.ri-shopping-bag-2-fill:before {\n  content: \"\\f073\";\n}\n.ri-shopping-bag-2-line:before {\n  content: \"\\f074\";\n}\n.ri-shopping-bag-3-fill:before {\n  content: \"\\f075\";\n}\n.ri-shopping-bag-3-line:before {\n  content: \"\\f076\";\n}\n.ri-shopping-bag-fill:before {\n  content: \"\\f077\";\n}\n.ri-shopping-bag-line:before {\n  content: \"\\f078\";\n}\n.ri-shopping-basket-2-fill:before {\n  content: \"\\f079\";\n}\n.ri-shopping-basket-2-line:before {\n  content: \"\\f07a\";\n}\n.ri-shopping-basket-fill:before {\n  content: \"\\f07b\";\n}\n.ri-shopping-basket-line:before {\n  content: \"\\f07c\";\n}\n.ri-shopping-cart-2-fill:before {\n  content: \"\\f07d\";\n}\n.ri-shopping-cart-2-line:before {\n  content: \"\\f07e\";\n}\n.ri-shopping-cart-fill:before {\n  content: \"\\f07f\";\n}\n.ri-shopping-cart-line:before {\n  content: \"\\f080\";\n}\n.ri-showers-fill:before {\n  content: \"\\f081\";\n}\n.ri-showers-line:before {\n  content: \"\\f082\";\n}\n.ri-shuffle-fill:before {\n  content: \"\\f083\";\n}\n.ri-shuffle-line:before {\n  content: \"\\f084\";\n}\n.ri-shut-down-fill:before {\n  content: \"\\f085\";\n}\n.ri-shut-down-line:before {\n  content: \"\\f086\";\n}\n.ri-side-bar-fill:before {\n  content: \"\\f087\";\n}\n.ri-side-bar-line:before {\n  content: \"\\f088\";\n}\n.ri-signal-tower-fill:before {\n  content: \"\\f089\";\n}\n.ri-signal-tower-line:before {\n  content: \"\\f08a\";\n}\n.ri-sim-card-2-fill:before {\n  content: \"\\f08b\";\n}\n.ri-sim-card-2-line:before {\n  content: \"\\f08c\";\n}\n.ri-sim-card-fill:before {\n  content: \"\\f08d\";\n}\n.ri-sim-card-line:before {\n  content: \"\\f08e\";\n}\n.ri-single-quotes-l:before {\n  content: \"\\f08f\";\n}\n.ri-single-quotes-r:before {\n  content: \"\\f090\";\n}\n.ri-sip-fill:before {\n  content: \"\\f091\";\n}\n.ri-sip-line:before {\n  content: \"\\f092\";\n}\n.ri-skip-back-fill:before {\n  content: \"\\f093\";\n}\n.ri-skip-back-line:before {\n  content: \"\\f094\";\n}\n.ri-skip-back-mini-fill:before {\n  content: \"\\f095\";\n}\n.ri-skip-back-mini-line:before {\n  content: \"\\f096\";\n}\n.ri-skip-forward-fill:before {\n  content: \"\\f097\";\n}\n.ri-skip-forward-line:before {\n  content: \"\\f098\";\n}\n.ri-skip-forward-mini-fill:before {\n  content: \"\\f099\";\n}\n.ri-skip-forward-mini-line:before {\n  content: \"\\f09a\";\n}\n.ri-skull-2-fill:before {\n  content: \"\\f09b\";\n}\n.ri-skull-2-line:before {\n  content: \"\\f09c\";\n}\n.ri-skull-fill:before {\n  content: \"\\f09d\";\n}\n.ri-skull-line:before {\n  content: \"\\f09e\";\n}\n.ri-skype-fill:before {\n  content: \"\\f09f\";\n}\n.ri-skype-line:before {\n  content: \"\\f0a0\";\n}\n.ri-slack-fill:before {\n  content: \"\\f0a1\";\n}\n.ri-slack-line:before {\n  content: \"\\f0a2\";\n}\n.ri-slice-fill:before {\n  content: \"\\f0a3\";\n}\n.ri-slice-line:before {\n  content: \"\\f0a4\";\n}\n.ri-slideshow-2-fill:before {\n  content: \"\\f0a5\";\n}\n.ri-slideshow-2-line:before {\n  content: \"\\f0a6\";\n}\n.ri-slideshow-3-fill:before {\n  content: \"\\f0a7\";\n}\n.ri-slideshow-3-line:before {\n  content: \"\\f0a8\";\n}\n.ri-slideshow-4-fill:before {\n  content: \"\\f0a9\";\n}\n.ri-slideshow-4-line:before {\n  content: \"\\f0aa\";\n}\n.ri-slideshow-fill:before {\n  content: \"\\f0ab\";\n}\n.ri-slideshow-line:before {\n  content: \"\\f0ac\";\n}\n.ri-smartphone-fill:before {\n  content: \"\\f0ad\";\n}\n.ri-smartphone-line:before {\n  content: \"\\f0ae\";\n}\n.ri-snapchat-fill:before {\n  content: \"\\f0af\";\n}\n.ri-snapchat-line:before {\n  content: \"\\f0b0\";\n}\n.ri-snowy-fill:before {\n  content: \"\\f0b1\";\n}\n.ri-snowy-line:before {\n  content: \"\\f0b2\";\n}\n.ri-sound-module-fill:before {\n  content: \"\\f0b3\";\n}\n.ri-sound-module-line:before {\n  content: \"\\f0b4\";\n}\n.ri-soundcloud-fill:before {\n  content: \"\\f0b5\";\n}\n.ri-soundcloud-line:before {\n  content: \"\\f0b6\";\n}\n.ri-space-ship-fill:before {\n  content: \"\\f0b7\";\n}\n.ri-space-ship-line:before {\n  content: \"\\f0b8\";\n}\n.ri-space:before {\n  content: \"\\f0b9\";\n}\n.ri-spam-2-fill:before {\n  content: \"\\f0ba\";\n}\n.ri-spam-2-line:before {\n  content: \"\\f0bb\";\n}\n.ri-spam-3-fill:before {\n  content: \"\\f0bc\";\n}\n.ri-spam-3-line:before {\n  content: \"\\f0bd\";\n}\n.ri-spam-fill:before {\n  content: \"\\f0be\";\n}\n.ri-spam-line:before {\n  content: \"\\f0bf\";\n}\n.ri-speaker-2-fill:before {\n  content: \"\\f0c0\";\n}\n.ri-speaker-2-line:before {\n  content: \"\\f0c1\";\n}\n.ri-speaker-3-fill:before {\n  content: \"\\f0c2\";\n}\n.ri-speaker-3-line:before {\n  content: \"\\f0c3\";\n}\n.ri-speaker-fill:before {\n  content: \"\\f0c4\";\n}\n.ri-speaker-line:before {\n  content: \"\\f0c5\";\n}\n.ri-spectrum-fill:before {\n  content: \"\\f0c6\";\n}\n.ri-spectrum-line:before {\n  content: \"\\f0c7\";\n}\n.ri-speed-fill:before {\n  content: \"\\f0c8\";\n}\n.ri-speed-line:before {\n  content: \"\\f0c9\";\n}\n.ri-speed-mini-fill:before {\n  content: \"\\f0ca\";\n}\n.ri-speed-mini-line:before {\n  content: \"\\f0cb\";\n}\n.ri-spotify-fill:before {\n  content: \"\\f0cc\";\n}\n.ri-spotify-line:before {\n  content: \"\\f0cd\";\n}\n.ri-spy-fill:before {\n  content: \"\\f0ce\";\n}\n.ri-spy-line:before {\n  content: \"\\f0cf\";\n}\n.ri-stack-fill:before {\n  content: \"\\f0d0\";\n}\n.ri-stack-line:before {\n  content: \"\\f0d1\";\n}\n.ri-stack-overflow-fill:before {\n  content: \"\\f0d2\";\n}\n.ri-stack-overflow-line:before {\n  content: \"\\f0d3\";\n}\n.ri-stackshare-fill:before {\n  content: \"\\f0d4\";\n}\n.ri-stackshare-line:before {\n  content: \"\\f0d5\";\n}\n.ri-star-fill:before {\n  content: \"\\f0d6\";\n}\n.ri-star-half-fill:before {\n  content: \"\\f0d7\";\n}\n.ri-star-half-line:before {\n  content: \"\\f0d8\";\n}\n.ri-star-half-s-fill:before {\n  content: \"\\f0d9\";\n}\n.ri-star-half-s-line:before {\n  content: \"\\f0da\";\n}\n.ri-star-line:before {\n  content: \"\\f0db\";\n}\n.ri-star-s-fill:before {\n  content: \"\\f0dc\";\n}\n.ri-star-s-line:before {\n  content: \"\\f0dd\";\n}\n.ri-star-smile-fill:before {\n  content: \"\\f0de\";\n}\n.ri-star-smile-line:before {\n  content: \"\\f0df\";\n}\n.ri-steering-2-fill:before {\n  content: \"\\f0e0\";\n}\n.ri-steering-2-line:before {\n  content: \"\\f0e1\";\n}\n.ri-steering-fill:before {\n  content: \"\\f0e2\";\n}\n.ri-steering-line:before {\n  content: \"\\f0e3\";\n}\n.ri-sticky-note-2-fill:before {\n  content: \"\\f0e4\";\n}\n.ri-sticky-note-2-line:before {\n  content: \"\\f0e5\";\n}\n.ri-sticky-note-fill:before {\n  content: \"\\f0e6\";\n}\n.ri-sticky-note-line:before {\n  content: \"\\f0e7\";\n}\n.ri-stock-fill:before {\n  content: \"\\f0e8\";\n}\n.ri-stock-line:before {\n  content: \"\\f0e9\";\n}\n.ri-stop-circle-fill:before {\n  content: \"\\f0ea\";\n}\n.ri-stop-circle-line:before {\n  content: \"\\f0eb\";\n}\n.ri-stop-fill:before {\n  content: \"\\f0ec\";\n}\n.ri-stop-line:before {\n  content: \"\\f0ed\";\n}\n.ri-stop-mini-fill:before {\n  content: \"\\f0ee\";\n}\n.ri-stop-mini-line:before {\n  content: \"\\f0ef\";\n}\n.ri-store-2-fill:before {\n  content: \"\\f0f0\";\n}\n.ri-store-2-line:before {\n  content: \"\\f0f1\";\n}\n.ri-store-3-fill:before {\n  content: \"\\f0f2\";\n}\n.ri-store-3-line:before {\n  content: \"\\f0f3\";\n}\n.ri-store-fill:before {\n  content: \"\\f0f4\";\n}\n.ri-store-line:before {\n  content: \"\\f0f5\";\n}\n.ri-strikethrough-2:before {\n  content: \"\\f0f6\";\n}\n.ri-strikethrough:before {\n  content: \"\\f0f7\";\n}\n.ri-subscript-2:before {\n  content: \"\\f0f8\";\n}\n.ri-subscript:before {\n  content: \"\\f0f9\";\n}\n.ri-subtract-fill:before {\n  content: \"\\f0fa\";\n}\n.ri-subtract-line:before {\n  content: \"\\f0fb\";\n}\n.ri-subway-fill:before {\n  content: \"\\f0fc\";\n}\n.ri-subway-line:before {\n  content: \"\\f0fd\";\n}\n.ri-subway-wifi-fill:before {\n  content: \"\\f0fe\";\n}\n.ri-subway-wifi-line:before {\n  content: \"\\f0ff\";\n}\n.ri-sun-cloudy-fill:before {\n  content: \"\\f100\";\n}\n.ri-sun-cloudy-line:before {\n  content: \"\\f101\";\n}\n.ri-sun-fill:before {\n  content: \"\\f102\";\n}\n.ri-sun-foggy-fill:before {\n  content: \"\\f103\";\n}\n.ri-sun-foggy-line:before {\n  content: \"\\f104\";\n}\n.ri-sun-line:before {\n  content: \"\\f105\";\n}\n.ri-superscript-2:before {\n  content: \"\\f106\";\n}\n.ri-superscript:before {\n  content: \"\\f107\";\n}\n.ri-surround-sound-fill:before {\n  content: \"\\f108\";\n}\n.ri-surround-sound-line:before {\n  content: \"\\f109\";\n}\n.ri-swap-box-fill:before {\n  content: \"\\f10a\";\n}\n.ri-swap-box-line:before {\n  content: \"\\f10b\";\n}\n.ri-swap-fill:before {\n  content: \"\\f10c\";\n}\n.ri-swap-line:before {\n  content: \"\\f10d\";\n}\n.ri-switch-fill:before {\n  content: \"\\f10e\";\n}\n.ri-switch-line:before {\n  content: \"\\f10f\";\n}\n.ri-sword-fill:before {\n  content: \"\\f110\";\n}\n.ri-sword-line:before {\n  content: \"\\f111\";\n}\n.ri-t-box-fill:before {\n  content: \"\\f112\";\n}\n.ri-t-box-line:before {\n  content: \"\\f113\";\n}\n.ri-t-shirt-2-fill:before {\n  content: \"\\f114\";\n}\n.ri-t-shirt-2-line:before {\n  content: \"\\f115\";\n}\n.ri-t-shirt-air-fill:before {\n  content: \"\\f116\";\n}\n.ri-t-shirt-air-line:before {\n  content: \"\\f117\";\n}\n.ri-t-shirt-fill:before {\n  content: \"\\f118\";\n}\n.ri-t-shirt-line:before {\n  content: \"\\f119\";\n}\n.ri-table-2:before {\n  content: \"\\f11a\";\n}\n.ri-table-alt-fill:before {\n  content: \"\\f11b\";\n}\n.ri-table-alt-line:before {\n  content: \"\\f11c\";\n}\n.ri-table-fill:before {\n  content: \"\\f11d\";\n}\n.ri-table-line:before {\n  content: \"\\f11e\";\n}\n.ri-tablet-fill:before {\n  content: \"\\f11f\";\n}\n.ri-tablet-line:before {\n  content: \"\\f120\";\n}\n.ri-takeaway-fill:before {\n  content: \"\\f121\";\n}\n.ri-takeaway-line:before {\n  content: \"\\f122\";\n}\n.ri-taobao-fill:before {\n  content: \"\\f123\";\n}\n.ri-taobao-line:before {\n  content: \"\\f124\";\n}\n.ri-tape-fill:before {\n  content: \"\\f125\";\n}\n.ri-tape-line:before {\n  content: \"\\f126\";\n}\n.ri-task-fill:before {\n  content: \"\\f127\";\n}\n.ri-task-line:before {\n  content: \"\\f128\";\n}\n.ri-taxi-fill:before {\n  content: \"\\f129\";\n}\n.ri-taxi-line:before {\n  content: \"\\f12a\";\n}\n.ri-taxi-wifi-fill:before {\n  content: \"\\f12b\";\n}\n.ri-taxi-wifi-line:before {\n  content: \"\\f12c\";\n}\n.ri-team-fill:before {\n  content: \"\\f12d\";\n}\n.ri-team-line:before {\n  content: \"\\f12e\";\n}\n.ri-telegram-fill:before {\n  content: \"\\f12f\";\n}\n.ri-telegram-line:before {\n  content: \"\\f130\";\n}\n.ri-temp-cold-fill:before {\n  content: \"\\f131\";\n}\n.ri-temp-cold-line:before {\n  content: \"\\f132\";\n}\n.ri-temp-hot-fill:before {\n  content: \"\\f133\";\n}\n.ri-temp-hot-line:before {\n  content: \"\\f134\";\n}\n.ri-terminal-box-fill:before {\n  content: \"\\f135\";\n}\n.ri-terminal-box-line:before {\n  content: \"\\f136\";\n}\n.ri-terminal-fill:before {\n  content: \"\\f137\";\n}\n.ri-terminal-line:before {\n  content: \"\\f138\";\n}\n.ri-terminal-window-fill:before {\n  content: \"\\f139\";\n}\n.ri-terminal-window-line:before {\n  content: \"\\f13a\";\n}\n.ri-text-direction-l:before {\n  content: \"\\f13b\";\n}\n.ri-text-direction-r:before {\n  content: \"\\f13c\";\n}\n.ri-text-spacing:before {\n  content: \"\\f13d\";\n}\n.ri-text-wrap:before {\n  content: \"\\f13e\";\n}\n.ri-text:before {\n  content: \"\\f13f\";\n}\n.ri-thumb-down-fill:before {\n  content: \"\\f140\";\n}\n.ri-thumb-down-line:before {\n  content: \"\\f141\";\n}\n.ri-thumb-up-fill:before {\n  content: \"\\f142\";\n}\n.ri-thumb-up-line:before {\n  content: \"\\f143\";\n}\n.ri-thunderstorms-fill:before {\n  content: \"\\f144\";\n}\n.ri-thunderstorms-line:before {\n  content: \"\\f145\";\n}\n.ri-ticket-2-fill:before {\n  content: \"\\f146\";\n}\n.ri-ticket-2-line:before {\n  content: \"\\f147\";\n}\n.ri-ticket-fill:before {\n  content: \"\\f148\";\n}\n.ri-ticket-line:before {\n  content: \"\\f149\";\n}\n.ri-time-fill:before {\n  content: \"\\f14a\";\n}\n.ri-time-line:before {\n  content: \"\\f14b\";\n}\n.ri-timer-2-fill:before {\n  content: \"\\f14c\";\n}\n.ri-timer-2-line:before {\n  content: \"\\f14d\";\n}\n.ri-timer-fill:before {\n  content: \"\\f14e\";\n}\n.ri-timer-flash-fill:before {\n  content: \"\\f14f\";\n}\n.ri-timer-flash-line:before {\n  content: \"\\f150\";\n}\n.ri-timer-line:before {\n  content: \"\\f151\";\n}\n.ri-todo-fill:before {\n  content: \"\\f152\";\n}\n.ri-todo-line:before {\n  content: \"\\f153\";\n}\n.ri-toggle-fill:before {\n  content: \"\\f154\";\n}\n.ri-toggle-line:before {\n  content: \"\\f155\";\n}\n.ri-tools-fill:before {\n  content: \"\\f156\";\n}\n.ri-tools-line:before {\n  content: \"\\f157\";\n}\n.ri-tornado-fill:before {\n  content: \"\\f158\";\n}\n.ri-tornado-line:before {\n  content: \"\\f159\";\n}\n.ri-trademark-fill:before {\n  content: \"\\f15a\";\n}\n.ri-trademark-line:before {\n  content: \"\\f15b\";\n}\n.ri-traffic-light-fill:before {\n  content: \"\\f15c\";\n}\n.ri-traffic-light-line:before {\n  content: \"\\f15d\";\n}\n.ri-train-fill:before {\n  content: \"\\f15e\";\n}\n.ri-train-line:before {\n  content: \"\\f15f\";\n}\n.ri-train-wifi-fill:before {\n  content: \"\\f160\";\n}\n.ri-train-wifi-line:before {\n  content: \"\\f161\";\n}\n.ri-translate-2:before {\n  content: \"\\f162\";\n}\n.ri-translate:before {\n  content: \"\\f163\";\n}\n.ri-travesti-fill:before {\n  content: \"\\f164\";\n}\n.ri-travesti-line:before {\n  content: \"\\f165\";\n}\n.ri-treasure-map-fill:before {\n  content: \"\\f166\";\n}\n.ri-treasure-map-line:before {\n  content: \"\\f167\";\n}\n.ri-trello-fill:before {\n  content: \"\\f168\";\n}\n.ri-trello-line:before {\n  content: \"\\f169\";\n}\n.ri-trophy-fill:before {\n  content: \"\\f16a\";\n}\n.ri-trophy-line:before {\n  content: \"\\f16b\";\n}\n.ri-truck-fill:before {\n  content: \"\\f16c\";\n}\n.ri-truck-line:before {\n  content: \"\\f16d\";\n}\n.ri-tumblr-fill:before {\n  content: \"\\f16e\";\n}\n.ri-tumblr-line:before {\n  content: \"\\f16f\";\n}\n.ri-tv-2-fill:before {\n  content: \"\\f170\";\n}\n.ri-tv-2-line:before {\n  content: \"\\f171\";\n}\n.ri-tv-fill:before {\n  content: \"\\f172\";\n}\n.ri-tv-line:before {\n  content: \"\\f173\";\n}\n.ri-twitch-fill:before {\n  content: \"\\f174\";\n}\n.ri-twitch-line:before {\n  content: \"\\f175\";\n}\n.ri-twitter-fill:before {\n  content: \"\\f176\";\n}\n.ri-twitter-line:before {\n  content: \"\\f177\";\n}\n.ri-typhoon-fill:before {\n  content: \"\\f178\";\n}\n.ri-typhoon-line:before {\n  content: \"\\f179\";\n}\n.ri-u-disk-fill:before {\n  content: \"\\f17a\";\n}\n.ri-u-disk-line:before {\n  content: \"\\f17b\";\n}\n.ri-ubuntu-fill:before {\n  content: \"\\f17c\";\n}\n.ri-ubuntu-line:before {\n  content: \"\\f17d\";\n}\n.ri-umbrella-fill:before {\n  content: \"\\f17e\";\n}\n.ri-umbrella-line:before {\n  content: \"\\f17f\";\n}\n.ri-underline:before {\n  content: \"\\f180\";\n}\n.ri-uninstall-fill:before {\n  content: \"\\f181\";\n}\n.ri-uninstall-line:before {\n  content: \"\\f182\";\n}\n.ri-upload-2-fill:before {\n  content: \"\\f183\";\n}\n.ri-upload-2-line:before {\n  content: \"\\f184\";\n}\n.ri-upload-cloud-2-fill:before {\n  content: \"\\f185\";\n}\n.ri-upload-cloud-2-line:before {\n  content: \"\\f186\";\n}\n.ri-upload-cloud-fill:before {\n  content: \"\\f187\";\n}\n.ri-upload-cloud-line:before {\n  content: \"\\f188\";\n}\n.ri-upload-fill:before {\n  content: \"\\f189\";\n}\n.ri-upload-line:before {\n  content: \"\\f18a\";\n}\n.ri-user-2-fill:before {\n  content: \"\\f18b\";\n}\n.ri-user-2-line:before {\n  content: \"\\f18c\";\n}\n.ri-user-3-fill:before {\n  content: \"\\f18d\";\n}\n.ri-user-3-line:before {\n  content: \"\\f18e\";\n}\n.ri-user-4-fill:before {\n  content: \"\\f18f\";\n}\n.ri-user-4-line:before {\n  content: \"\\f190\";\n}\n.ri-user-5-fill:before {\n  content: \"\\f191\";\n}\n.ri-user-5-line:before {\n  content: \"\\f192\";\n}\n.ri-user-6-fill:before {\n  content: \"\\f193\";\n}\n.ri-user-6-line:before {\n  content: \"\\f194\";\n}\n.ri-user-add-fill:before {\n  content: \"\\f195\";\n}\n.ri-user-add-line:before {\n  content: \"\\f196\";\n}\n.ri-user-fill:before {\n  content: \"\\f197\";\n}\n.ri-user-follow-fill:before {\n  content: \"\\f198\";\n}\n.ri-user-follow-line:before {\n  content: \"\\f199\";\n}\n.ri-user-heart-fill:before {\n  content: \"\\f19a\";\n}\n.ri-user-heart-line:before {\n  content: \"\\f19b\";\n}\n.ri-user-line:before {\n  content: \"\\f19c\";\n}\n.ri-user-location-fill:before {\n  content: \"\\f19d\";\n}\n.ri-user-location-line:before {\n  content: \"\\f19e\";\n}\n.ri-user-received-2-fill:before {\n  content: \"\\f19f\";\n}\n.ri-user-received-2-line:before {\n  content: \"\\f1a0\";\n}\n.ri-user-received-fill:before {\n  content: \"\\f1a1\";\n}\n.ri-user-received-line:before {\n  content: \"\\f1a2\";\n}\n.ri-user-search-fill:before {\n  content: \"\\f1a3\";\n}\n.ri-user-search-line:before {\n  content: \"\\f1a4\";\n}\n.ri-user-settings-fill:before {\n  content: \"\\f1a5\";\n}\n.ri-user-settings-line:before {\n  content: \"\\f1a6\";\n}\n.ri-user-shared-2-fill:before {\n  content: \"\\f1a7\";\n}\n.ri-user-shared-2-line:before {\n  content: \"\\f1a8\";\n}\n.ri-user-shared-fill:before {\n  content: \"\\f1a9\";\n}\n.ri-user-shared-line:before {\n  content: \"\\f1aa\";\n}\n.ri-user-smile-fill:before {\n  content: \"\\f1ab\";\n}\n.ri-user-smile-line:before {\n  content: \"\\f1ac\";\n}\n.ri-user-star-fill:before {\n  content: \"\\f1ad\";\n}\n.ri-user-star-line:before {\n  content: \"\\f1ae\";\n}\n.ri-user-unfollow-fill:before {\n  content: \"\\f1af\";\n}\n.ri-user-unfollow-line:before {\n  content: \"\\f1b0\";\n}\n.ri-user-voice-fill:before {\n  content: \"\\f1b1\";\n}\n.ri-user-voice-line:before {\n  content: \"\\f1b2\";\n}\n.ri-video-chat-fill:before {\n  content: \"\\f1b3\";\n}\n.ri-video-chat-line:before {\n  content: \"\\f1b4\";\n}\n.ri-video-fill:before {\n  content: \"\\f1b5\";\n}\n.ri-video-line:before {\n  content: \"\\f1b6\";\n}\n.ri-vidicon-2-fill:before {\n  content: \"\\f1b7\";\n}\n.ri-vidicon-2-line:before {\n  content: \"\\f1b8\";\n}\n.ri-vidicon-fill:before {\n  content: \"\\f1b9\";\n}\n.ri-vidicon-line:before {\n  content: \"\\f1ba\";\n}\n.ri-vip-crown-2-fill:before {\n  content: \"\\f1bb\";\n}\n.ri-vip-crown-2-line:before {\n  content: \"\\f1bc\";\n}\n.ri-vip-crown-fill:before {\n  content: \"\\f1bd\";\n}\n.ri-vip-crown-line:before {\n  content: \"\\f1be\";\n}\n.ri-vip-diamond-fill:before {\n  content: \"\\f1bf\";\n}\n.ri-vip-diamond-line:before {\n  content: \"\\f1c0\";\n}\n.ri-vip-fill:before {\n  content: \"\\f1c1\";\n}\n.ri-vip-line:before {\n  content: \"\\f1c2\";\n}\n.ri-visa-fill:before {\n  content: \"\\f1c3\";\n}\n.ri-visa-line:before {\n  content: \"\\f1c4\";\n}\n.ri-voice-recognition-fill:before {\n  content: \"\\f1c5\";\n}\n.ri-voice-recognition-line:before {\n  content: \"\\f1c6\";\n}\n.ri-voiceprint-fill:before {\n  content: \"\\f1c7\";\n}\n.ri-voiceprint-line:before {\n  content: \"\\f1c8\";\n}\n.ri-volume-down-fill:before {\n  content: \"\\f1c9\";\n}\n.ri-volume-down-line:before {\n  content: \"\\f1ca\";\n}\n.ri-volume-mute-fill:before {\n  content: \"\\f1cb\";\n}\n.ri-volume-mute-line:before {\n  content: \"\\f1cc\";\n}\n.ri-volume-off-vibrate-fill:before {\n  content: \"\\f1cd\";\n}\n.ri-volume-off-vibrate-line:before {\n  content: \"\\f1ce\";\n}\n.ri-volume-up-fill:before {\n  content: \"\\f1cf\";\n}\n.ri-volume-up-line:before {\n  content: \"\\f1d0\";\n}\n.ri-volume-vibrate-fill:before {\n  content: \"\\f1d1\";\n}\n.ri-volume-vibrate-line:before {\n  content: \"\\f1d2\";\n}\n.ri-vuejs-fill:before {\n  content: \"\\f1d3\";\n}\n.ri-vuejs-line:before {\n  content: \"\\f1d4\";\n}\n.ri-walk-fill:before {\n  content: \"\\f1d5\";\n}\n.ri-walk-line:before {\n  content: \"\\f1d6\";\n}\n.ri-wallet-2-fill:before {\n  content: \"\\f1d7\";\n}\n.ri-wallet-2-line:before {\n  content: \"\\f1d8\";\n}\n.ri-wallet-3-fill:before {\n  content: \"\\f1d9\";\n}\n.ri-wallet-3-line:before {\n  content: \"\\f1da\";\n}\n.ri-wallet-fill:before {\n  content: \"\\f1db\";\n}\n.ri-wallet-line:before {\n  content: \"\\f1dc\";\n}\n.ri-water-flash-fill:before {\n  content: \"\\f1dd\";\n}\n.ri-water-flash-line:before {\n  content: \"\\f1de\";\n}\n.ri-webcam-fill:before {\n  content: \"\\f1df\";\n}\n.ri-webcam-line:before {\n  content: \"\\f1e0\";\n}\n.ri-wechat-2-fill:before {\n  content: \"\\f1e1\";\n}\n.ri-wechat-2-line:before {\n  content: \"\\f1e2\";\n}\n.ri-wechat-fill:before {\n  content: \"\\f1e3\";\n}\n.ri-wechat-line:before {\n  content: \"\\f1e4\";\n}\n.ri-wechat-pay-fill:before {\n  content: \"\\f1e5\";\n}\n.ri-wechat-pay-line:before {\n  content: \"\\f1e6\";\n}\n.ri-weibo-fill:before {\n  content: \"\\f1e7\";\n}\n.ri-weibo-line:before {\n  content: \"\\f1e8\";\n}\n.ri-whatsapp-fill:before {\n  content: \"\\f1e9\";\n}\n.ri-whatsapp-line:before {\n  content: \"\\f1ea\";\n}\n.ri-wifi-fill:before {\n  content: \"\\f1eb\";\n}\n.ri-wifi-line:before {\n  content: \"\\f1ec\";\n}\n.ri-wifi-off-fill:before {\n  content: \"\\f1ed\";\n}\n.ri-wifi-off-line:before {\n  content: \"\\f1ee\";\n}\n.ri-window-2-fill:before {\n  content: \"\\f1ef\";\n}\n.ri-window-2-line:before {\n  content: \"\\f1f0\";\n}\n.ri-window-fill:before {\n  content: \"\\f1f1\";\n}\n.ri-window-line:before {\n  content: \"\\f1f2\";\n}\n.ri-windows-fill:before {\n  content: \"\\f1f3\";\n}\n.ri-windows-line:before {\n  content: \"\\f1f4\";\n}\n.ri-windy-fill:before {\n  content: \"\\f1f5\";\n}\n.ri-windy-line:before {\n  content: \"\\f1f6\";\n}\n.ri-women-fill:before {\n  content: \"\\f1f7\";\n}\n.ri-women-line:before {\n  content: \"\\f1f8\";\n}\n.ri-wubi-input:before {\n  content: \"\\f1f9\";\n}\n.ri-xbox-fill:before {\n  content: \"\\f1fa\";\n}\n.ri-xbox-line:before {\n  content: \"\\f1fb\";\n}\n.ri-xing-fill:before {\n  content: \"\\f1fc\";\n}\n.ri-xing-line:before {\n  content: \"\\f1fd\";\n}\n.ri-youtube-fill:before {\n  content: \"\\f1fe\";\n}\n.ri-youtube-line:before {\n  content: \"\\f1ff\";\n}\n.ri-zcool-fill:before {\n  content: \"\\f200\";\n}\n.ri-zcool-line:before {\n  content: \"\\f201\";\n}\n.ri-zhihu-fill:before {\n  content: \"\\f202\";\n}\n.ri-zhihu-line:before {\n  content: \"\\f203\";\n}\n.ri-zoom-in-fill:before {\n  content: \"\\f204\";\n}\n.ri-zoom-in-line:before {\n  content: \"\\f205\";\n}\n.ri-zoom-out-fill:before {\n  content: \"\\f206\";\n}\n.ri-zoom-out-line:before {\n  content: \"\\f207\";\n}\n","/*\nTemplate Name: Chat Sms.by\nAuthor: Themesbrand\nVersion: 2.0.0\nWebsite: https://themesbrand.com/\nContact: themesbrand@gmail.com\nFile: Custom Bootstrap Css File\n*/\n\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"./node_modules/bootstrap/scss/bootstrap\";\n\n@import \"custom/components/reboot\";\n@import \"custom/components/backgrounds\";\n@import \"custom/components/badge\";\n@import \"custom/components/buttons\";\n@import \"custom/components/breadcrumb\";\n@import \"custom/components/card\";\n@import \"custom/components/dropdown\";\n@import \"custom/components/nav\";\n@import \"custom/components/table\";\n@import \"custom/components/pagination\";\n@import \"custom/components/progress\";","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n\n//\n// custom-variables\n//\n\n// Vertical Sidebar - Default Light\n$sidebar-bg: #ffffff;\n$sidebar-menu-item-color: #878a92;\n$sidebar-menu-item-active-color: #7269ef;\n$sidebar-menu-item-active-bg: #f7f7ff;\n$sidebar-sub-bg: #f5f7fb;\n\n// Display\n$display-none: none;\n$display-block: block;\n\n// Font Weight\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n\n// Font Family\n$font-family-secondary: 'Public Sans', sans-serif;\n\n// Chat\n$chat-primary-bg: #7269ef;\n$chat-secondary-bg: #f5f7fb;\n\n// Theme mode icon\n$theme-mode-icon: '\\eefb';\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white: #fff;\n$gray-100: #f8f9fa;\n$gray-200: #f5f7fb;\n$gray-300: #f0eff5;\n$gray-400: #e6ebf5;\n$gray-500: #adb5bd;\n$gray-600: #7a7f9a;\n$gray-700: #495057;\n$gray-800: #343a40;\n$gray-900: #212529;\n$black: #000;\n\n// fusv-disable\n$grays: (\n  '100': $gray-100,\n  '200': $gray-200,\n  '300': $gray-300,\n  '400': $gray-400,\n  '500': $gray-500,\n  '600': $gray-600,\n  '700': $gray-700,\n  '800': $gray-800,\n  '900': $gray-900,\n);\n// fusv-enable\n\n$blue: #7269ef;\n$indigo: #564ab1;\n$purple: #8e4aec;\n$pink: #e83e8c;\n$red: #ef476f;\n$orange: #fc814a;\n$yellow: #ffd166;\n$green: #06d6a0;\n$teal: #050505;\n$cyan: #50a5f1;\n\n// scss-docs-start colors-map\n$colors: (\n  'blue': $blue,\n  'indigo': $indigo,\n  'purple': $purple,\n  'pink': $pink,\n  'red': $red,\n  'orange': $orange,\n  'yellow': $yellow,\n  'green': $green,\n  'teal': $teal,\n  'cyan': $cyan,\n  'white': $white,\n  'gray': $gray-600,\n  'gray-dark': $gray-800,\n);\n// scss-docs-end colors-map\n\n$primary: $blue;\n$secondary: $gray-600;\n$success: $green;\n$info: $cyan;\n$warning: $yellow;\n$danger: $red;\n$light: $gray-400;\n$dark: $gray-800;\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  'primary': $primary,\n  'secondary': $secondary,\n  'success': $success,\n  'info': $info,\n  'warning': $warning,\n  'danger': $danger,\n  'light': $light,\n  'dark': $dark,\n);\n// scss-docs-end theme-colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio: 1.8;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark: $gray-900;\n$color-contrast-light: $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (('<', '%3c'), ('>', '%3e'), ('#', '%23'), ('(', '%28'), (')', '%29'));\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret: false;\n$enable-rounded: true;\n$enable-shadows: false;\n$enable-gradients: false;\n$enable-transitions: true;\n$enable-reduced-motion: true;\n$enable-smooth-scroll: true;\n$enable-grid-classes: true;\n$enable-button-pointers: true;\n$enable-rfs: true;\n$enable-validation-icons: true;\n$enable-negative-margins: false;\n$enable-deprecation-messages: true;\n$enable-important-utilities: true;\n\n// Prefix for :root CSS variables\n\n$variable-prefix: bs-;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n$gradient: linear-gradient(180deg, rgba($white, 0.15), rgba($white, 0));\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem;\n$spacers: (\n  0: 0,\n  1: $spacer / 4,\n  2: $spacer / 2,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n);\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%,\n);\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg: #ffffff;\n$body-color: $gray-700;\n$body-text-align: null;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color: $primary;\n$link-decoration: none;\n$link-shade-percentage: 15%;\n$link-hover-color: shade-color($link-color, 15%);\n$link-hover-decoration: underline;\n\n$stretched-link-pseudo-element: after;\n$stretched-link-z-index: 1;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom: 1rem;\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px,\n);\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, '$grid-breakpoints');\n@include _assert-starts-at-zero($grid-breakpoints, '$grid-breakpoints');\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px,\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, '$container-max-widths');\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns: 12;\n$grid-gutter-width: 24px;\n$grid-row-columns: 6;\n\n$gutters: $spacers;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width / 2;\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$border-width: 1px;\n$border-widths: (\n  0: 0,\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px,\n);\n\n$border-color: $gray-300;\n\n$border-radius: 0.25rem;\n$border-radius-sm: 0.2rem;\n$border-radius-lg: 0.4rem;\n$border-radius-pill: 50rem;\n\n$box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n$box-shadow-sm: 0 0.125rem 0.25rem rgba($black, 0.075);\n$box-shadow-lg: 0 1rem 3rem rgba($black, 0.175);\n$box-shadow-inset: inset 0 1px 2px rgba($black, 0.075);\n\n$component-active-color: $white;\n$component-active-bg: $primary;\n\n$caret-width: 0.3em;\n$caret-vertical-align: $caret-width * 0.85;\n$caret-spacing: $caret-width * 0.85;\n\n$transition-base: all 0.2s ease-in-out;\n$transition-fade: opacity 0.15s linear;\n$transition-collapse: height 0.35s ease;\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  '1x1': 100%,\n  '4x3': calc(3 / 4 * 100%),\n  '16x9': calc(9 / 16 * 100%),\n  '21x9': calc(9 / 21 * 100%),\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif: 'Public Sans', sans-serif;\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',\n  monospace;\n// stylelint-enable value-keyword-case\n$font-family-base: $font-family-sans-serif;\n$font-family-code: var(--#{$variable-prefix}font-monospace);\n\n// $font-size-root effects the value of `rem`, which is used for as well font sizes, paddings and margins\n// $font-size-base effects the font size of the body text\n$font-size-root: null;\n$font-size-base: 0.9375rem; // Assumes the browser default, typically `16px`\n$font-size-sm: $font-size-base * 0.875;\n$font-size-lg: $font-size-base * 1.25;\n\n$font-weight-lighter: lighter;\n$font-weight-light: 300;\n$font-weight-normal: 400;\n$font-weight-bold: 700;\n$font-weight-bolder: bolder;\n\n$font-weight-base: $font-weight-normal;\n\n$line-height-base: 1.5;\n$line-height-sm: 1.25;\n$line-height-lg: 2;\n\n$h1-font-size: $font-size-base * 2.5;\n$h2-font-size: $font-size-base * 2;\n$h3-font-size: $font-size-base * 1.75;\n$h4-font-size: $font-size-base * 1.4;\n$h5-font-size: $font-size-base * 1.25;\n$h6-font-size: $font-size-base;\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size,\n);\n// scss-docs-end font-sizes\n\n$headings-margin-bottom: $spacer / 2;\n$headings-font-family: null;\n$headings-font-style: null;\n$headings-font-weight: 500;\n$headings-line-height: 1.2;\n$headings-color: null;\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem,\n);\n\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n$lead-font-size: $font-size-base * 1.25;\n$lead-font-weight: 300;\n\n$small-font-size: 0.875em;\n\n$sub-sup-font-size: 0.75em;\n\n$text-muted: $gray-600;\n\n$initialism-font-size: $small-font-size;\n\n$blockquote-margin-y: $spacer;\n$blockquote-font-size: $font-size-base * 1.25;\n$blockquote-footer-color: $gray-600;\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y: $spacer;\n$hr-color: inherit;\n$hr-height: $border-width;\n$hr-opacity: 0.25;\n\n$legend-margin-bottom: 0.5rem;\n$legend-font-size: 1.5rem;\n$legend-font-weight: null;\n\n$mark-padding: 0.2em;\n\n$dt-font-weight: $font-weight-bold;\n\n$nested-kbd-font-weight: $font-weight-bold;\n\n$list-inline-padding: 0.5rem;\n\n$mark-bg: #fcf8e3;\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y: 0.5rem;\n$table-cell-padding-x: 0.5rem;\n$table-cell-padding-y-sm: 0.25rem;\n$table-cell-padding-x-sm: 0.25rem;\n\n$table-cell-vertical-align: top;\n\n$table-color: $body-color;\n$table-bg: null;\n\n$table-th-font-weight: null;\n\n$table-striped-color: $table-color;\n$table-striped-bg-factor: 0.05;\n$table-striped-bg: rgba($black, $table-striped-bg-factor);\n\n$table-active-color: $table-color;\n$table-active-bg-factor: 0.1;\n$table-active-bg: $table-hover-bg;\n\n$table-hover-color: $table-color;\n$table-hover-bg-factor: 0.075;\n$table-hover-bg: $gray-100;\n\n$table-border-factor: 0.1;\n$table-border-width: $border-width;\n$table-border-color: $border-color;\n\n$table-striped-order: odd;\n\n$table-group-separator-color: currentColor;\n\n$table-caption-color: $text-muted;\n\n$table-bg-scale: -80%;\n\n$table-variants: (\n  'primary': shift-color($primary, $table-bg-scale),\n  'secondary': shift-color($secondary, $table-bg-scale),\n  'success': shift-color($success, $table-bg-scale),\n  'info': shift-color($info, $table-bg-scale),\n  'warning': shift-color($warning, $table-bg-scale),\n  'danger': shift-color($danger, $table-bg-scale),\n  'light': $light,\n  'dark': $dark,\n);\n// scss-docs-end table-variables\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y: 0.5rem;\n$input-btn-padding-x: 1rem;\n$input-btn-font-family: null;\n$input-btn-font-size: $font-size-base;\n$input-btn-line-height: $line-height-base;\n\n$input-btn-focus-width: 0.15rem;\n$input-btn-focus-color-opacity: 0.25;\n$input-btn-focus-color: rgba($component-active-bg, 0.25);\n$input-btn-focus-box-shadow: 0 0 0 $input-btn-focus-width $input-btn-focus-color;\n\n$input-btn-padding-y-sm: 0.25rem;\n$input-btn-padding-x-sm: 0.5rem;\n$input-btn-font-size-sm: $font-size-sm;\n\n$input-btn-padding-y-lg: 0.5rem;\n$input-btn-padding-x-lg: 1rem;\n$input-btn-font-size-lg: $font-size-lg;\n\n$input-btn-border-width: $border-width;\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y: 0.47rem;\n$btn-padding-x: 0.75rem;\n$btn-font-family: $input-btn-font-family;\n$btn-font-size: $input-btn-font-size;\n$btn-line-height: $input-btn-line-height;\n$btn-white-space: null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm: $input-btn-padding-y-sm;\n$btn-padding-x-sm: $input-btn-padding-x-sm;\n$btn-font-size-sm: $input-btn-font-size-sm;\n\n$btn-padding-y-lg: $input-btn-padding-y-lg;\n$btn-padding-x-lg: $input-btn-padding-x-lg;\n$btn-font-size-lg: $input-btn-font-size-lg;\n\n$btn-border-width: $input-btn-border-width;\n\n$btn-font-weight: $font-weight-normal;\n$btn-box-shadow:\n  inset 0 1px 0 rgba($white, 0.15),\n  0 1px 1px rgba($black, 0.075);\n$btn-focus-width: $input-btn-focus-width;\n$btn-focus-box-shadow: $input-btn-focus-box-shadow;\n$btn-disabled-opacity: 0.65;\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, 0.125);\n\n$btn-link-color: $link-color;\n$btn-link-hover-color: $link-hover-color;\n$btn-link-disabled-color: $gray-600;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius: $border-radius;\n$btn-border-radius-sm: $border-radius-sm;\n$btn-border-radius-lg: $border-radius-lg;\n\n$btn-transition:\n  color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n// Forms\n\n$form-text-margin-top: 0.25rem;\n$form-text-font-size: $small-font-size;\n$form-text-font-style: null;\n$form-text-font-weight: null;\n$form-text-color: $text-muted;\n\n$form-label-margin-bottom: 0.5rem;\n$form-label-font-size: null;\n$form-label-font-style: null;\n$form-label-font-weight: null;\n$form-label-color: null;\n\n$input-padding-y: $input-btn-padding-y;\n$input-padding-x: $input-btn-padding-x;\n$input-font-family: $input-btn-font-family;\n$input-font-size: 0.875rem;\n$input-font-weight: $font-weight-base;\n$input-line-height: $input-btn-line-height;\n\n$input-padding-y-sm: $input-btn-padding-y-sm;\n$input-padding-x-sm: $input-btn-padding-x-sm;\n$input-font-size-sm: $input-btn-font-size-sm;\n\n$input-padding-y-lg: $input-btn-padding-y-lg;\n$input-padding-x-lg: $input-btn-padding-x-lg;\n$input-font-size-lg: 14px;\n\n$input-bg: $white;\n$input-disabled-bg: $white;\n$input-disabled-border-color: null;\n\n$input-color: $gray-700;\n$input-border-color: $gray-400;\n$input-border-width: $input-btn-border-width;\n$input-box-shadow: inset 0 1px 1px rgba($black, 0.075);\n\n$input-border-radius: $border-radius;\n$input-border-radius-sm: $border-radius-sm;\n$input-border-radius-lg: $border-radius-lg;\n\n$input-focus-bg: $input-bg;\n$input-focus-border-color: shade-color($input-border-color, 10%);\n$input-focus-color: $input-color;\n$input-focus-width: $input-btn-focus-width;\n$input-focus-box-shadow: none;\n\n$input-placeholder-color: $gray-600;\n$input-plaintext-color: $body-color;\n\n$input-height-border: $input-border-width * 2;\n\n$input-height-inner: add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half: add($input-line-height * 0.5em, $input-padding-y);\n$input-height-inner-quarter: add($input-line-height * 0.25em, $input-padding-y / 2);\n\n$input-height: add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border));\n$input-height-sm: add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border));\n$input-height-lg: add(\n  $input-line-height * 1em,\n  add($input-padding-y-lg * 2, $input-height-border * 3)\n);\n\n$input-transition:\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n$form-check-input-width: 1em;\n$form-check-min-height: $font-size-base * $line-height-base;\n$form-check-padding-start: $form-check-input-width + 0.5em;\n$form-check-margin-bottom: 0.125rem;\n$form-check-label-color: null;\n$form-check-label-cursor: null;\n$form-check-transition:\n  background-color 0.15s ease-in-out,\n  background-position 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n$form-check-input-active-filter: brightness(90%);\n\n$form-check-input-bg: $body-bg;\n$form-check-input-border: 1px solid rgba(0, 0, 0, 0.25);\n$form-check-input-border-radius: 0.25em;\n$form-check-radio-border-radius: 50%;\n$form-check-input-focus-border: $input-focus-border-color;\n$form-check-input-focus-box-shadow: $input-btn-focus-box-shadow;\n\n$form-check-input-checked-color: $component-active-color;\n$form-check-input-checked-bg-color: $component-active-bg;\n$form-check-input-checked-border-color: $form-check-input-checked-bg-color;\n$form-check-input-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\n$form-check-radio-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\n\n$form-check-input-indeterminate-color: $component-active-color;\n$form-check-input-indeterminate-bg-color: $component-active-bg;\n$form-check-input-indeterminate-border-color: $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity: 0.5;\n$form-check-label-disabled-opacity: $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity: $btn-disabled-opacity;\n\n$form-switch-color: rgba(0, 0, 0, 0.25);\n$form-switch-width: 2em;\n$form-switch-padding-start: $form-switch-width + 0.5em;\n$form-switch-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\n$form-switch-border-radius: $form-switch-width;\n\n$form-switch-focus-color: $input-focus-border-color;\n$form-switch-focus-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\n\n$form-switch-checked-color: $component-active-color;\n$form-switch-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\n$form-switch-checked-bg-position: right center;\n\n$form-check-inline-margin-end: 1rem;\n\n$input-group-addon-padding-y: $input-padding-y;\n$input-group-addon-padding-x: $input-padding-x;\n$input-group-addon-font-weight: $input-font-weight;\n$input-group-addon-color: $input-color;\n$input-group-addon-bg: $gray-200;\n$input-group-addon-border-color: $input-border-color;\n\n$form-select-padding-y: $input-padding-y;\n$form-select-padding-x: $input-padding-x;\n$form-select-font-family: $input-font-family;\n$form-select-font-size: $input-font-size;\n$form-select-indicator-padding: 1rem; // Extra padding to account for the presence of the background-image based indicator\n$form-select-font-weight: $input-font-weight;\n$form-select-line-height: $input-line-height;\n$form-select-color: $input-color;\n$form-select-disabled-color: $gray-600;\n$form-select-bg: $input-bg;\n$form-select-disabled-bg: $gray-200;\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position: right $form-select-padding-x center;\n$form-select-bg-size: 8px 10px; // In pixels because image dimensions\n$form-select-indicator-color: $gray-800;\n$form-select-indicator: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\n\n$form-select-feedback-icon-padding-end: add(\n  1em * 0.75,\n  (2 * $form-select-padding-y * 0.75) + $form-select-padding-x + $form-select-indicator-padding\n);\n$form-select-feedback-icon-position: center right\n  ($form-select-padding-x + $form-select-indicator-padding);\n$form-select-feedback-icon-size: $input-height-inner-half $input-height-inner-half;\n\n$form-select-border-width: $input-border-width;\n$form-select-border-color: $input-border-color;\n$form-select-border-radius: $border-radius;\n$form-select-box-shadow: inset 0 1px 2px rgba($black, 0.075);\n\n$form-select-focus-border-color: $input-focus-border-color;\n$form-select-focus-width: $input-focus-width;\n$form-select-focus-box-shadow: 0 0 0 $form-select-focus-width $input-btn-focus-color;\n\n$form-select-padding-y-sm: $input-padding-y-sm;\n$form-select-padding-x-sm: $input-padding-x-sm;\n$form-select-font-size-sm: $input-font-size-sm;\n\n$form-select-padding-y-lg: $input-padding-y-lg;\n$form-select-padding-x-lg: $input-padding-x-lg;\n$form-select-font-size-lg: $input-font-size-lg;\n\n$form-range-track-width: 100%;\n$form-range-track-height: 0.5rem;\n$form-range-track-cursor: pointer;\n$form-range-track-bg: $gray-300;\n$form-range-track-border-radius: 1rem;\n$form-range-track-box-shadow: inset 0 0.25rem 0.25rem rgba($black, 0.1);\n\n$form-range-thumb-width: 1rem;\n$form-range-thumb-height: $form-range-thumb-width;\n$form-range-thumb-bg: $component-active-bg;\n$form-range-thumb-border: 0;\n$form-range-thumb-border-radius: 1rem;\n$form-range-thumb-box-shadow: 0 0.1rem 0.25rem rgba($black, 0.1);\n$form-range-thumb-focus-box-shadow:\n  0 0 0 1px $body-bg,\n  $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width: $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg: tint-color($component-active-bg, 70%);\n$form-range-thumb-disabled-bg: $gray-500;\n$form-range-thumb-transition:\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n$form-file-button-color: $input-color;\n$form-file-button-bg: $input-group-addon-bg;\n$form-file-button-hover-bg: shade-color($form-file-button-bg, 5%);\n\n$form-floating-height: add(3.5rem, $input-height-border);\n$form-floating-padding-x: $input-padding-x;\n$form-floating-padding-y: 1rem;\n$form-floating-input-padding-t: 1.625rem;\n$form-floating-input-padding-b: 0.625rem;\n$form-floating-label-opacity: 0.65;\n$form-floating-label-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n$form-floating-transition:\n  opacity 0.1s ease-in-out,\n  transform 0.1s ease-in-out;\n\n// Form validation\n\n$form-feedback-margin-top: $form-text-margin-top;\n$form-feedback-font-size: $form-text-font-size;\n$form-feedback-font-style: $form-text-font-style;\n$form-feedback-valid-color: $success;\n$form-feedback-invalid-color: $danger;\n\n$form-feedback-icon-valid-color: $form-feedback-valid-color;\n$form-feedback-icon-valid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color: $form-feedback-invalid-color;\n$form-feedback-icon-invalid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  'valid': (\n    'color': $form-feedback-valid-color,\n    'icon': $form-feedback-icon-valid,\n  ),\n  'invalid': (\n    'color': $form-feedback-invalid-color,\n    'icon': $form-feedback-icon-invalid,\n  ),\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown: 1000;\n$zindex-sticky: 1020;\n$zindex-fixed: 1030;\n$zindex-modal-backdrop: 1040;\n$zindex-modal: 1050;\n$zindex-popover: 1060;\n$zindex-tooltip: 1070;\n// scss-docs-end zindex-stack\n\n// Navs\n\n$nav-link-padding-y: 0.5rem;\n$nav-link-padding-x: 1rem;\n$nav-link-font-size: null;\n$nav-link-font-weight: null;\n$nav-link-color: null;\n$nav-link-hover-color: null;\n$nav-link-transition:\n  color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out;\n$nav-link-disabled-color: $gray-600;\n\n$nav-tabs-border-color: $gray-400;\n$nav-tabs-border-width: $border-width;\n$nav-tabs-border-radius: $border-radius;\n$nav-tabs-link-hover-border-color: $gray-200 $gray-200 $nav-tabs-border-color;\n$nav-tabs-link-active-color: $gray-700;\n$nav-tabs-link-active-bg: $body-bg;\n$nav-tabs-link-active-border-color: $gray-400 $gray-400 $nav-tabs-link-active-bg;\n\n$nav-pills-border-radius: $border-radius;\n$nav-pills-link-active-color: $component-active-color;\n$nav-pills-link-active-bg: $component-active-bg;\n\n// Navbar\n\n$navbar-padding-y: $spacer / 2;\n$navbar-padding-x: $spacer;\n\n$navbar-nav-link-padding-x: 0.5rem;\n\n$navbar-brand-font-size: $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height: $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) / 2;\n$navbar-brand-margin-end: 1rem;\n\n$navbar-toggler-padding-y: 0.25rem;\n$navbar-toggler-padding-x: 0.75rem;\n$navbar-toggler-font-size: $font-size-lg;\n$navbar-toggler-border-radius: $btn-border-radius;\n$navbar-toggler-focus-width: $btn-focus-width;\n$navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n\n$navbar-dark-color: rgba($white, 0.55);\n$navbar-dark-hover-color: rgba($white, 0.75);\n$navbar-dark-active-color: $white;\n$navbar-dark-disabled-color: rgba($white, 0.25);\n$navbar-dark-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color: rgba($white, 0.1);\n\n$navbar-light-color: rgba($black, 0.55);\n$navbar-light-hover-color: rgba($black, 0.7);\n$navbar-light-active-color: rgba($black, 0.9);\n$navbar-light-disabled-color: rgba($black, 0.3);\n$navbar-light-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba($black, 0.1);\n\n$navbar-light-brand-color: $navbar-light-active-color;\n$navbar-light-brand-hover-color: $navbar-light-active-color;\n$navbar-dark-brand-color: $navbar-dark-active-color;\n$navbar-dark-brand-hover-color: $navbar-dark-active-color;\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width: 10rem;\n$dropdown-padding-x: 0;\n$dropdown-padding-y: 0.5rem;\n$dropdown-spacer: 0.125rem;\n$dropdown-font-size: $font-size-base;\n$dropdown-color: $body-color;\n$dropdown-bg: $white;\n$dropdown-border-color: $border-color;\n$dropdown-border-radius: $border-radius;\n$dropdown-border-width: $border-width;\n$dropdown-inner-border-radius: subtract($dropdown-border-radius, $dropdown-border-width);\n$dropdown-divider-bg: $dropdown-border-color;\n$dropdown-divider-margin-y: $spacer / 2;\n$dropdown-box-shadow: 0 0.5rem 1rem rgba($black, 0.175);\n\n$dropdown-link-color: $gray-900;\n$dropdown-link-hover-color: shade-color($gray-900, 5%);\n$dropdown-link-hover-bg: $gray-100;\n\n$dropdown-link-active-color: darken($gray-900, 5%);\n$dropdown-link-active-bg: $gray-100;\n\n$dropdown-link-disabled-color: $gray-600;\n\n$dropdown-item-padding-y: 0.35rem;\n$dropdown-item-padding-x: 1.5rem;\n\n$dropdown-header-color: $gray-600;\n$dropdown-header-padding: $dropdown-padding-y $dropdown-item-padding-x;\n\n$dropdown-dark-color: $gray-300;\n$dropdown-dark-bg: $gray-800;\n$dropdown-dark-border-color: $dropdown-border-color;\n$dropdown-dark-divider-bg: $dropdown-divider-bg;\n$dropdown-dark-box-shadow: null;\n$dropdown-dark-link-color: $dropdown-dark-color;\n$dropdown-dark-link-hover-color: $white;\n$dropdown-dark-link-hover-bg: rgba($white, 0.15);\n$dropdown-dark-link-active-color: $dropdown-link-active-color;\n$dropdown-dark-link-active-bg: $dropdown-link-active-bg;\n$dropdown-dark-link-disabled-color: $gray-500;\n$dropdown-dark-header-color: $gray-500;\n\n// Pagination\n\n$pagination-padding-y: 0.375rem;\n$pagination-padding-x: 0.75rem;\n$pagination-padding-y-sm: 0.25rem;\n$pagination-padding-x-sm: 0.5rem;\n$pagination-padding-y-lg: 0.75rem;\n$pagination-padding-x-lg: 1.5rem;\n\n$pagination-color: $link-color;\n$pagination-bg: $white;\n$pagination-border-width: $border-width;\n$pagination-border-radius: $border-radius;\n$pagination-margin-start: -$pagination-border-width;\n$pagination-border-color: $gray-300;\n\n$pagination-focus-color: $link-hover-color;\n$pagination-focus-bg: $gray-200;\n$pagination-focus-box-shadow: $input-btn-focus-box-shadow;\n$pagination-focus-outline: 0;\n\n$pagination-hover-color: $link-hover-color;\n$pagination-hover-bg: $gray-200;\n$pagination-hover-border-color: $gray-300;\n\n$pagination-active-color: $component-active-color;\n$pagination-active-bg: $component-active-bg;\n$pagination-active-border-color: $pagination-active-bg;\n\n$pagination-disabled-color: $gray-600;\n$pagination-disabled-bg: $white;\n$pagination-disabled-border-color: $gray-300;\n\n$pagination-transition:\n  color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n// Cards\n\n$card-spacer-y: 1.25rem;\n$card-spacer-x: 1.25rem;\n$card-title-spacer-y: $spacer / 2;\n$card-border-width: 0;\n$card-border-radius: $border-radius;\n$card-border-color: $gray-200;\n$card-inner-border-radius: subtract($card-border-radius, $card-border-width);\n$card-cap-padding-y: 0.75rem;\n$card-cap-padding-x: 1.25rem;\n$card-cap-bg: $gray-200;\n$card-cap-color: null;\n$card-height: null;\n$card-color: null;\n$card-bg: $white;\n\n$card-img-overlay-padding: $spacer;\n\n$card-group-margin: $grid-gutter-width / 2;\n\n// Accordion\n$accordion-padding-y: 1.25rem;\n$accordion-padding-x: 1.25rem;\n$accordion-color: $gray-700;\n$accordion-bg: $white;\n$accordion-border-width: 0;\n$accordion-border-color: $gray-300;\n$accordion-border-radius: $border-radius;\n\n$accordion-body-padding-y: $accordion-padding-y;\n$accordion-body-padding-x: $accordion-padding-x;\n\n$accordion-button-padding-y: 0.75rem;\n$accordion-button-padding-x: $accordion-padding-x;\n$accordion-button-color: $accordion-color;\n$accordion-button-bg: $gray-200;\n$accordion-transition:\n  $btn-transition,\n  border-radius 0.15s ease;\n$accordion-button-active-bg: $accordion-button-bg;\n$accordion-button-active-color: $accordion-color;\n\n$accordion-button-focus-border-color: $accordion-border-color;\n$accordion-button-focus-box-shadow: none;\n\n$accordion-icon-width: 0.75rem;\n$accordion-icon-color: $accordion-color;\n$accordion-icon-active-color: $accordion-button-active-color;\n$accordion-icon-transition: transform 0.2s ease-in-out;\n$accordion-icon-transform: rotate(180deg);\n\n$accordion-button-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n\n// Tooltips\n\n$tooltip-font-size: $font-size-sm;\n$tooltip-max-width: 200px;\n$tooltip-color: $white;\n$tooltip-bg: $black;\n$tooltip-border-radius: $border-radius;\n$tooltip-opacity: 0.9;\n$tooltip-padding-y: $spacer / 4;\n$tooltip-padding-x: $spacer / 2;\n$tooltip-margin: 0;\n\n$tooltip-arrow-width: 0.8rem;\n$tooltip-arrow-height: 0.4rem;\n$tooltip-arrow-color: $tooltip-bg;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y: $tooltip-padding-y;\n$form-feedback-tooltip-padding-x: $tooltip-padding-x;\n$form-feedback-tooltip-font-size: $tooltip-font-size;\n$form-feedback-tooltip-line-height: null;\n$form-feedback-tooltip-opacity: $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n\n// Popovers\n\n$popover-font-size: $font-size-sm;\n$popover-bg: $white;\n$popover-max-width: 276px;\n$popover-border-width: $border-width;\n$popover-border-color: rgba($black, 0.2);\n$popover-border-radius: $border-radius-lg;\n$popover-inner-border-radius: subtract($popover-border-radius, $popover-border-width);\n$popover-box-shadow: $box-shadow;\n\n$popover-header-bg: shade-color($popover-bg, 6%);\n$popover-header-color: $headings-color;\n$popover-header-padding-y: 0.5rem;\n$popover-header-padding-x: $spacer;\n\n$popover-body-color: $body-color;\n$popover-body-padding-y: $spacer;\n$popover-body-padding-x: $spacer;\n\n$popover-arrow-width: 1rem;\n$popover-arrow-height: 0.5rem;\n$popover-arrow-color: $popover-bg;\n\n$popover-arrow-outer-color: fade-in($popover-border-color, 0.05);\n\n// Toasts\n\n$toast-max-width: 350px;\n$toast-padding-x: 0.75rem;\n$toast-padding-y: 0.5rem;\n$toast-font-size: 0.875rem;\n$toast-color: null;\n$toast-background-color: rgba($white, 0.85);\n$toast-border-width: 1px;\n$toast-border-color: rgba(0, 0, 0, 0.1);\n$toast-border-radius: $border-radius;\n$toast-box-shadow: $box-shadow;\n$toast-spacing: $container-padding-x;\n\n$toast-header-color: $gray-600;\n$toast-header-background-color: rgba($white, 0.85);\n$toast-header-border-color: rgba(0, 0, 0, 0.05);\n\n// Badges\n\n$badge-font-size: 0.75em;\n$badge-font-weight: $font-weight-medium;\n$badge-color: $white;\n$badge-padding-y: 0.25em;\n$badge-padding-x: 0.6em;\n$badge-border-radius: $border-radius;\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding: $spacer;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between: 0.5rem;\n\n$modal-dialog-margin: 0.5rem;\n$modal-dialog-margin-y-sm-up: 1.75rem;\n\n$modal-title-line-height: $line-height-base;\n\n$modal-content-color: null;\n$modal-content-bg: $white;\n$modal-content-border-color: $gray-300;\n$modal-content-border-width: $border-width;\n$modal-content-border-radius: $border-radius-lg;\n$modal-content-inner-border-radius: subtract(\n  $modal-content-border-radius,\n  $modal-content-border-width\n);\n$modal-content-box-shadow-xs: $box-shadow-sm;\n$modal-content-box-shadow-sm-up: $box-shadow;\n\n$modal-backdrop-bg: $black;\n$modal-backdrop-opacity: 0.5;\n$modal-header-border-color: $border-color;\n$modal-footer-border-color: $modal-header-border-color;\n$modal-header-border-width: $modal-content-border-width;\n$modal-footer-border-width: $modal-header-border-width;\n$modal-header-padding-y: $modal-inner-padding;\n$modal-header-padding-x: $modal-inner-padding;\n$modal-header-padding: $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-sm: 300px;\n$modal-md: 500px;\n$modal-lg: 800px;\n$modal-xl: 1140px;\n\n$modal-fade-transform: translate(0, -50px);\n$modal-show-transform: none;\n$modal-transition: transform 0.3s ease-out;\n$modal-scale-transform: scale(1.02);\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y: 0.75rem;\n$alert-padding-x: 1.25rem;\n$alert-margin-bottom: 1rem;\n$alert-border-radius: $border-radius;\n$alert-link-font-weight: $font-weight-bold;\n$alert-border-width: $border-width;\n\n$alert-bg-scale: -80%;\n$alert-border-scale: -70%;\n$alert-color-scale: 40%;\n\n$alert-dismissible-padding-r: $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\n\n// Progress bars\n\n$progress-height: 1rem;\n$progress-font-size: $font-size-base * 0.75;\n$progress-bg: $gray-200;\n$progress-border-radius: $border-radius;\n$progress-box-shadow: $box-shadow-inset;\n$progress-bar-color: $white;\n$progress-bar-bg: $primary;\n$progress-bar-animation-timing: 1s linear infinite;\n$progress-bar-transition: width 0.6s ease;\n\n// List group\n\n$list-group-color: null;\n$list-group-bg: $white;\n$list-group-border-color: rgba($black, 0.125);\n$list-group-border-width: $border-width;\n$list-group-border-radius: $border-radius;\n\n$list-group-item-padding-y: $spacer / 2;\n$list-group-item-padding-x: $spacer;\n$list-group-item-bg-scale: -80%;\n$list-group-item-color-scale: 40%;\n\n$list-group-hover-bg: $gray-100;\n$list-group-active-color: $component-active-color;\n$list-group-active-bg: $component-active-bg;\n$list-group-active-border-color: $list-group-active-bg;\n\n$list-group-disabled-color: $gray-600;\n$list-group-disabled-bg: $list-group-bg;\n\n$list-group-action-color: $gray-700;\n$list-group-action-hover-color: $list-group-action-color;\n\n$list-group-action-active-color: $body-color;\n$list-group-action-active-bg: $gray-200;\n\n// Image thumbnails\n\n$thumbnail-padding: 0.25rem;\n$thumbnail-bg: $body-bg;\n$thumbnail-border-width: $border-width;\n$thumbnail-border-color: $gray-300;\n$thumbnail-border-radius: $border-radius;\n$thumbnail-box-shadow: $box-shadow-sm;\n\n// Figures\n\n$figure-caption-font-size: $small-font-size;\n$figure-caption-color: $gray-600;\n\n// Breadcrumbs\n\n$breadcrumb-font-size: null;\n$breadcrumb-padding-y: 0;\n$breadcrumb-padding-x: 0;\n$breadcrumb-item-padding-x: 0.5rem;\n$breadcrumb-margin-bottom: 1rem;\n$breadcrumb-bg: null;\n$breadcrumb-divider-color: $gray-600;\n$breadcrumb-active-color: $gray-600;\n$breadcrumb-divider: quote('/');\n$breadcrumb-divider-flipped: $breadcrumb-divider;\n$breadcrumb-border-radius: null;\n\n// Carousel\n\n$carousel-control-color: $white;\n$carousel-control-width: 15%;\n$carousel-control-opacity: 0.5;\n$carousel-control-hover-opacity: 0.9;\n$carousel-control-transition: opacity 0.15s ease;\n\n$carousel-indicator-width: 30px;\n$carousel-indicator-height: 3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer: 3px;\n$carousel-indicator-opacity: 0.5;\n$carousel-indicator-active-bg: $white;\n$carousel-indicator-active-opacity: 1;\n$carousel-indicator-transition: opacity 0.6s ease;\n\n$carousel-caption-width: 70%;\n$carousel-caption-color: $white;\n$carousel-caption-padding-y: 1.25rem;\n$carousel-caption-spacer: 1.25rem;\n\n$carousel-control-icon-width: 2rem;\n\n$carousel-control-prev-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration: 0.6s;\n$carousel-transition: transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg: $black;\n$carousel-dark-caption-color: $black;\n$carousel-dark-control-icon-filter: invert(1) grayscale(100);\n\n// Spinners\n\n$spinner-width: 2rem;\n$spinner-height: $spinner-width;\n$spinner-border-width: 0.25em;\n$spinner-animation-speed: 0.75s;\n\n$spinner-width-sm: 1rem;\n$spinner-height-sm: $spinner-width-sm;\n$spinner-border-width-sm: 0.2em;\n\n// Close\n\n$btn-close-width: 0.6em;\n$btn-close-height: $btn-close-width;\n$btn-close-padding-x: 0.25em;\n$btn-close-padding-y: $btn-close-padding-x;\n$btn-close-color: $black;\n$btn-close-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-focus-shadow: none;\n$btn-close-opacity: 0.5;\n$btn-close-hover-opacity: 0.75;\n$btn-close-focus-opacity: 1;\n$btn-close-disabled-opacity: 0.25;\n$btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n\n// Code\n\n$code-font-size: $small-font-size;\n$code-color: $pink;\n\n$kbd-padding-y: 0.2rem;\n$kbd-padding-x: 0.4rem;\n$kbd-font-size: $code-font-size;\n$kbd-color: $white;\n$kbd-bg: $gray-900;\n\n$pre-color: null;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/* =============\n   General\n============= */\n\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\n.h1,.h2,.h3,.h4,.h5,.h6,\nh1,h2,h3,h4,h5,h6 {\n  color: $gray-700;\n  font-family: $font-family-secondary;\n  font-weight: $font-weight-semibold;\n}\n\na {\n  text-decoration: none !important;\n}\n\nlabel {\n  font-weight: 500;\n}\n\n@media (min-width:1400px) {\n  .container {\n    max-width: 1140px;\n  }\n}\n\n","// \n// backgrounds.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .bg-soft-#{$color} {\n        background-color: rgba(($value), 0.25) !important;\n    }\n}\n","// \n// _badge.scss\n// \n\n// Soft badge\n@mixin badge-variant-soft($bg) {\n  color: $bg;\n  background-color: rgba($bg, 0.18);\n\n  &[href] {\n    color: $bg;\n    text-decoration: none;\n    background-color: rgba($bg, 0.4);\n  }\n\n  // &[href] {\n  //   @include hover-focus {\n  //     color: $bg;\n  //     text-decoration: none;\n  //     background-color: rgba($bg, 0.4);\n  //   }\n  // }\n}\n\n@each $color, $value in $theme-colors {\n  .badge-soft-#{$color} {\n      @include badge-variant-soft($value);\n  }\n}\n\n// Dark badge\n\n.badge-dark{\n  color: $light;\n}","// \n// _buttons.scss\n// \n\nbutton,a {\n  outline: none !important;\n}\n\n\n// Rounded Buttons\n.btn-rounded {\n  border-radius: 30px;\n  border-radius: 30px;\n\n}\n\n.btn-dark, .btn-secondary{\n  color: $gray-200 !important;\n}\n\n.btn-outline-light{\n  color: $gray-900;\n}\n\n.user-profile-show.disabled {\n  border: 0;\n}\n","\n// \n// breadcrumb.scss\n//\n\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    > a {\n        color: $gray-700;\n    }\n    +.breadcrumb-item {\n        &::before {\n            font-family: \"Material Design Icons\";\n        }\n    }\n}\n  ","// \n// _card.scss\n// \n\n.card {\n  margin-bottom: $grid-gutter-width;\n}\n\n.card-drop {\n  color: $body-color;\n}\n\n.card-title {\n  font-size: 15px;\n  margin: 0 0 7px 0;\n  font-weight: $font-weight-semibold;\n}\n\n.card-title-desc {\n  color: $gray-600;\n  margin-bottom: 24px;  \n}\n\n","//\n// _dropdown.scss\n//\n\n.dropdown-menu {\n  box-shadow: $box-shadow-lg;\n  animation-name: DropDownSlide;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  position: absolute;\n  z-index: 1000;\n\n  &.dropdown-megamenu {\n    padding: 20px;\n    left: 0 !important;\n    right: 0 !important;\n  }\n\n  &[data-popper-placement=\"top-start\"] {\n    animation-name: DropDownSlideDown;\n  }\n}\n\n@keyframes DropDownSlide {\n  100% {\n    margin-top: -1px;\n  }\n  0% {\n    margin-top: 8px;\n  }\n}\n\n@keyframes DropDownSlideDown {\n  100% {\n    margin-bottom: 0;\n  }\n  0% {\n    margin-bottom: 8px;\n  }\n}\n\n.dropdown-toggle {\n  @include caret(up);\n}\n\n.dropdown-menu-end[style] {\n  right: 0 !important;\n  left: auto !important;\n}\n\n@media (min-width: 600px) {\n  .dropdown-menu-lg {\n    width: 320px;\n  }\n\n  .dropdown-menu-md {\n    width: 240px;\n  }\n}\n\n.dropdown-divider {\n  border-top-color: $border-color;\n}\n","// \n// _nav.scss\n// \n\n.nav-tabs,.nav-pills {\n  > li {\n      > a {\n          color: $gray-700;\n          font-weight: $font-weight-medium;\n      }\n  }\n}\n\n.nav-pills {\n  > a {\n      color: $gray-700;  \n      font-weight: $font-weight-medium;\n  }\n}\n\n\n.nav-tabs-custom {\n  border-bottom: 2px solid $gray-300;\n\n  .nav-item {\n    position: relative;\n    color: $dark;\n    .nav-link {\n      border: none;\n\n      &::after {\n        content: \"\";\n        background: $primary;\n        height: 2px;\n        position: absolute;\n        width: 100%;\n        left: 0;\n        bottom: -1px;\n        transition: all 250ms ease 0s;\n        transform: scale(0);\n      }\n\n      &.active{\n        color: $primary;\n        &:after{\n          transform: scale(1);\n        }\n      }\n\n    }\n  }\n}\n\n\n// vertical nav\n\n.vertical-nav{\n  .nav{\n      .nav-link{\n          padding: 24px 16px;\n          text-align: center;\n          margin-bottom: 8px;\n          .nav-icon{\n              font-size: 24px;\n          }\n      }\n  }\n}","// \n// _table.scss\n// \n\n.table {\n  th {\n      font-weight: $font-weight-bold;\n  }\n}\n\n//Table centered\n.table-centered {\n  td,th {\n      vertical-align: middle !important;\n  }\n}\n\n.table-nowrap {\n  th, td {\n    white-space: nowrap;\n  }\n}","// \n// _pagination.scss\n// \n\n// Pagination rounded (Custom)\n.pagination-rounded {\n    .page-link {\n        border-radius: 30px !important;\n        margin: 0 3px;\n        border: none;\n        width: 32px;\n        height: 32px;\n        padding: 0;\n        text-align: center;\n        line-height: 32px;\n    }\n  }","// \n// _progress.scss\n// \n\n// Progress height small\n.progress-sm {\n  height: 5px;\n}\n\n\n// Progress height medium\n.progress-md {\n  height: 8px;\n}\n\n\n// Progress height large\n.progress-lg {\n  height: 12px;\n}\n\n// Progress height Extra large\n.progress-xl {\n  height: 16px;\n}\n","/*\nTemplate Name: Chat Sms.by\nAuthor: Themesbrand\nVersion: 2.0.0\nWebsite: https://themesbrand.com/\nContact: themesbrand@gmail.com\nFile: Main Css File\n*/\n\n//Fonts\n@import \"custom/fonts/fonts\";\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"./node_modules/bootstrap/scss/mixins.scss\";\n\n// Components\n@import \"custom/components/waves\";\n@import \"custom/components/avatar\";\n@import \"custom/components/helper\";\n@import \"custom/components/accordion\";\n@import \"custom/components/forms\";\n\n\n// Plugins\n@import \"custom/plugins/custom-scrollbar\";\n\n// structure\n@import \"custom/structure/sidemenu_\";\n\n// Pages\n@import \"custom/pages/chat-leftsidebar_\";\n@import \"custom/pages/user-chat_\";\n@import \"custom/pages/user-profile-details_\";","\n/*!\n * Waves v0.7.6\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE */\n .waves-effect {\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n  }\n  .waves-effect .waves-ripple {\n    position: absolute;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n    margin-left: -50px;\n    opacity: 0;\n    background: rgba(0, 0, 0, 0.2);\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    -webkit-transition: all 0.5s ease-out;\n    -moz-transition: all 0.5s ease-out;\n    -o-transition: all 0.5s ease-out;\n    transition: all 0.5s ease-out;\n    -webkit-transition-property: -webkit-transform, opacity;\n    -moz-transition-property: -moz-transform, opacity;\n    -o-transition-property: -o-transform, opacity;\n    transition-property: transform, opacity;\n    -webkit-transform: scale(0) translate(0, 0);\n    -moz-transform: scale(0) translate(0, 0);\n    -ms-transform: scale(0) translate(0, 0);\n    -o-transform: scale(0) translate(0, 0);\n    transform: scale(0) translate(0, 0);\n    pointer-events: none;\n  }\n  .waves-effect.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n  }\n  .waves-effect.waves-classic .waves-ripple {\n    background: rgba(0, 0, 0, 0.2);\n  }\n  .waves-effect.waves-classic.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n  }\n  .waves-notransition {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n  }\n  .waves-button,\n  .waves-circle {\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\n  }\n  .waves-button,\n  .waves-button:hover,\n  .waves-button:visited,\n  .waves-button-input {\n    white-space: nowrap;\n    vertical-align: middle;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    color: inherit;\n    background-color: rgba(0, 0, 0, 0);\n    font-size: 1em;\n    line-height: 1em;\n    text-align: center;\n    text-decoration: none;\n    z-index: 1;\n  }\n  .waves-button {\n    padding: 0.85em 1.1em;\n    border-radius: 0.2em;\n  }\n  .waves-button-input {\n    margin: 0;\n    padding: 0.85em 1.1em;\n  }\n  .waves-input-wrapper {\n    border-radius: 0.2em;\n    vertical-align: bottom;\n  }\n  .waves-input-wrapper.waves-button {\n    padding: 0;\n  }\n  .waves-input-wrapper .waves-button-input {\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n  .waves-circle {\n    text-align: center;\n    width: 2.5em;\n    height: 2.5em;\n    line-height: 2.5em;\n    border-radius: 50%;\n  }\n  .waves-float {\n    -webkit-mask-image: none;\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -o-transition: all 300ms;\n    transition: all 300ms;\n  }\n  .waves-float:active {\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n  }\n  .waves-block {\n    display: block;\n  }\n\n.waves-effect.waves-light {\n    .waves-ripple {\n        background-color: rgba($white, 0.4);\n    }\n}\n\n.waves-effect.waves-primary {\n    .waves-ripple {\n        background-color: rgba($primary, 0.4);\n    }\n}\n.waves-effect.waves-success {\n    .waves-ripple {\n        background-color: rgba($success, 0.4);\n    }\n}\n.waves-effect.waves-info {\n    .waves-ripple {\n        background-color: rgba($info, 0.4);\n    }\n}\n.waves-effect.waves-warning {\n    .waves-ripple {\n        background-color: rgba($warning, 0.4);\n    }\n}\n.waves-effect.waves-danger {\n    .waves-ripple {\n        background-color: rgba($danger, 0.4);\n    }\n}","//\n// avatar.scss\n//\n\n.avatar-xs {\n  height: 2.2rem;\n  width: 2.2rem;\n}\n\n.avatar-sm {\n  height: 3rem;\n  width: 3rem;\n}\n\n.avatar-md {\n  height: 4.5rem;\n  width: 4.5rem;\n}\n\n.avatar-lg {\n  height: 6rem;\n  width: 6rem;\n}\n\n.avatar-xl {\n  height: 7.5rem;\n  width: 7.5rem;\n}\n\n.avatar-title {\n  align-items: center;\n  background-color: $primary;\n  color: $white;\n  display: flex;\n  font-weight: $font-weight-medium;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}","//\n// _helper.scss\n//\n\n.font-size-10 {\n  font-size: 10px !important;\n}\n\n.font-size-11 {\n  font-size: 11px !important;\n}\n\n.font-size-12 {\n  font-size: 12px !important;\n}\n\n.font-size-13 {\n  font-size: 13px !important;\n}\n\n.font-size-14 {\n  font-size: 14px !important;\n}\n\n.font-size-15 {\n  font-size: 15px !important;\n}\n\n.font-size-16 {\n  font-size: 16px !important;\n}\n\n.font-size-17 {\n  font-size: 17px !important;\n}\n\n.font-size-18 {\n  font-size: 18px !important;\n}\n\n.font-size-20 {\n  font-size: 20px !important;\n}\n\n.font-size-22 {\n  font-size: 22px !important;\n}\n\n.font-size-24 {\n  font-size: 24px !important;\n}\n\n// Font weight help class\n\n.fw-medium {\n  font-weight: $font-weight-medium;\n}\n\n.fw-semibold {\n  font-weight: $font-weight-semibold;\n}\n\n// Social\n\n.social-list-item {\n  height: 2rem;\n  width: 2rem;\n  line-height: calc(2rem - 4px);\n  display: block;\n  border: 2px solid $gray-500;\n  border-radius: 50%;\n  color: $gray-500;\n  text-align: center;\n  transition: all 0.4s;\n  &:hover{\n    color: $gray-600;\n    background-color: $gray-200;\n  }\n}\n\n\n.w-xs {\n  min-width: 80px;\n}\n.w-sm {\n  min-width: 95px;\n}\n.w-md {\n  min-width: 110px;\n}\n.w-lg {\n  min-width: 140px;\n}\n\n.w-xl {\n  min-width: 160px;\n}\n\n.flex-1 {\n  flex: 1 !important;\n}","\n//\n// accordion.scss\n//\n\n.custom-accordion {\n    .card {\n        + .card {\n            margin-top: 0.5rem;\n        }\n    }\n\n    a {\n        i.accor-plus-icon {\n            font-size: 16px;\n        }\n        &.collapsed {\n            i.accor-plus-icon {\n                &:before {\n                    content: \"\\F0142\";\n                }\n            }\n        }\n    }\n}\n\n.accordion-button {\n    &:after {\n        margin-left: auto/*rtl:0*/;\n        margin-right:0/*rtl:auto*/;\n    }\n}","//\n// Forms.scss\n//\n\n\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n &::placeholder{\n   text-align: left; /*rtl: right*/\n }\n}\n\n\n// checkbox color\n\n@each $color,\n$value in $theme-colors {\n  .custom-checkbox-#{$color}, .custom-radio-#{$color}{\n    .custom-control-input{\n      &:checked~.custom-control-label:before{\n        background-color: $value;\n        border-color: $value;\n      }\n    }\n  }\n\n}\n\n.custom-checkbox-dark, .custom-radio-dark{\n  .custom-control-input{\n    &:checked~.custom-control-label:before{\n      color: $dark;\n    }\n  }\n}\n\n\n.custom-control-label{\n  cursor: pointer;\n}\n\n\n\n\n// Switch sizes\n\n.custom-switch-md{\n  padding-left: 3rem;\n  .custom-control-label{\n    line-height: 20px;\n    &:before{\n      width: 40px;\n      height: 20px;\n      border-radius: 30px;\n      left: -3rem;\n    }\n    &:after{\n      width: calc(20px - 4px);\n      height: calc(20px - 4px);\n      left: calc(-3rem + 2px);\n    }\n  }\n  .custom-control-input:checked~.custom-control-label::after{\n    transform: translateX(1.25rem);\n  }\n}\n\n\n.custom-switch-lg{\n  padding-left: 3.75rem;\n  .custom-control-label{\n    line-height: 24px;\n    &:before{\n      width: 48px;\n      height: 24px;\n      border-radius: 30px;\n      left: -3.75rem;\n    }\n    &:after{\n      width: calc(24px - 4px);\n      height: calc(24px - 4px);\n      left: calc(-3.75rem + 2px);\n      border-radius: 50%;\n    }\n  }\n  .custom-control-input:checked~.custom-control-label::after{\n    transform: translateX(1.5rem);\n  }\n}\n\n\n.custom-control-label::before{\n  background-color: $input-bg;\n}\n","[data-simplebar] {\n  position: relative;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0 !important;\n  bottom: 0;\n  right: 0 !important;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%;\n  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  visibility: visible;\n  overflow: auto;\n  /* Scroll on this element otherwise element can't have a padding applied properly */\n  max-width: 100%;\n  /* Not required for horizontal scroll to trigger */\n  max-height: 100%;\n  /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n  padding: 0px !important;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: ' ';\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  flex-grow: inherit;\n  flex-shrink: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  right: 2px;\n  width: 7px;\n  min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: '';\n  background: #a2adb7;\n  border-radius: 7px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\n.custom-scroll {\n  height: 100%;\n}","//\n// Sidemenu\n//\n\n.main-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  .title {\n    width: 50%;\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 36px;\n  }\n}\n\n.side-menu {\n  width: 100%;\n  // min-width: 104px;\n  // max-width: 104px;\n  // height: 100vh;\n  //min-height: 570px;\n  background-color: #edeef0;\n  display: flex;\n  z-index: 9;\n  //box-shadow: 0 2px 4px rgba(15,34,58,.12);\n\n  .go-back {\n    display: none;\n    position: absolute;\n    left: 10px;\n\n    a {\n      font-size: 20px;\n      color: #7a7f9a;\n    }\n  }\n\n  @media (max-width: 991.98px) {\n    position: fixed;\n    bottom: 0;\n    height: 80px;\n    min-width: 100%;\n    min-height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .go-back {\n      display: block;\n    }\n\n    .side-menu-nav {\n      .logo {\n        display: none;\n      }\n    }\n  }\n\n  .navbar-brand-box {\n    text-align: center;\n\n    @media (max-width: 991.98px) {\n      display: none;\n    }\n\n    .logo {\n      line-height: 70px;\n    }\n\n    .logo-dark {\n      display: $display-block;\n    }\n\n    .logo-light {\n      display: $display-none;\n    }\n  }\n\n  .theme-mode-icon {\n    &:before {\n      content: $theme-mode-icon;\n    }\n  }\n}\n\n.side-menu-nav {\n\n  .logo {\n    margin: 30px 0;\n  }\n\n  .nav-item {\n    width: 24px;\n    /*64px;*/\n    height: 24px;\n    /*64px;*/\n    border: 0 none;\n    border-radius: 32px;\n    background-color: inherit;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 8px 0;\n    padding: 27px;\n\n    &.active {\n      background-color: #fff;\n    }\n\n    .disabled {\n      opacity: 0.7;\n      pointer-events: none;\n      cursor: default;\n    }\n\n    //margin: 7px 0;\n    //@media (max-width: 991.98px) {\n    //    flex-basis: 0;\n    //    flex-grow: 1;\n    //    margin: 5px 0;\n    //}\n    //.nav-link{\n    //    text-align: center;\n    //    font-size: 24px;\n    //    color: $sidebar-menu-item-color;\n    //    width: 56px;\n    //    height: 56px;\n    //    line-height: 56px;\n    //    margin: 0px auto;\n    //    border-radius: 8px;\n    //    padding: 0;\n    //\n    //\n    //    @media (max-width: 991.98px) {\n    //        font-size: 20px;\n    //        width: 48px;\n    //        height: 48px;\n    //        line-height: 48px;\n    //    }\n    //\n    //    &.active{\n    //        background-color: $sidebar-menu-item-active-bg;\n    //        color: $primary;\n    //    }\n    //}\n    //\n    //&.show>.nav-link{\n    //    background-color: $sidebar-menu-item-active-bg;\n    //    color: $primary;\n    //}\n  }\n\n  //.profile-user {\n  //    height: 36px;\n  //    width: 36px;\n  //    background-color: $gray-300;\n  //    padding: 3px;\n  //}\n}\n","//\n// chat-leftsidebar.scss\n//\n\n.chat-leftsidebar {\n  background-color: #fff;\n  height: 100vh;\n  width: 380px;\n  border-right: 1px solid #f2f2f2;\n\n  .title-block {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    color: #4a4a4a;\n    border-bottom: 1px solid #f2f2f2;\n    padding-bottom: 35px;\n\n    .avatar-wrapper {\n      position: relative;\n      margin: 16px 0;\n\n      .avatar {\n        height: 80px;\n        width: 80px;\n        border: 0 none;\n        border-radius: 32px;\n      }\n\n      label {\n        display: none;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        cursor: pointer;\n        width: 32px;\n        height: 32px;\n\n        img {\n          width: 32px;\n          height: 32px;\n        }\n\n        input {\n          display: none;\n        }\n      }\n\n      &:hover label {\n        display: block;\n      }\n    }\n\n    .title {\n      font-size: 18px;\n      line-height: 18px;\n      font-weight: 500;\n      max-width: 250px;\n    }\n\n    .subtitle {\n      font-size: 12px;\n      line-height: 15px;\n      font-weight: 400;\n      margin-top: 4px;\n    }\n  }\n\n  .search-block {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #4a4a4a;\n    border-bottom: 1px solid #f2f2f2;\n    padding: 16px;\n    height: 69px;\n\n    .input-group-text,\n    .form-control {\n      border: 1px solid #e2e2e2;\n      border-right: 0;\n      border-radius: 18px;\n      background-color: #f4f5f5;\n      height: 36px;\n      color: #818c99;\n    }\n\n    .input-group-text {\n      padding: 0 0 0 11px;\n    }\n\n    .form-control {\n      border-left: 0 none;\n      font-size: 13px;\n      line-height: 15px;\n      padding-left: 9px;\n    }\n\n    .clear-search-input.input-group-text {\n      cursor: pointer;\n      padding-right: 12px;\n    }\n  }\n\n  //height: 100vh;\n  //background-color: $sidebar-sub-bg;\n  //\n  @media (max-width: 991.98px) {\n    width: auto;\n  }\n\n  .user-status-box {\n    background-color: $light;\n    padding: 8px;\n    border-radius: 8px;\n    text-align: center;\n    margin-top: 16px;\n    display: block;\n\n    .chat-user-img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n    }\n  }\n}\n\n.chat-search-box {\n  .search-color {\n    background: #e6ebf5 !important;\n  }\n\n  .form-control {\n    border: 0;\n  }\n\n  .search-icon-btn {\n    font-size: 16px;\n    position: absolute;\n    right: 13px;\n    top: 0;\n  }\n}\n\n.chat-group-list {\n  height: calc(100vh - 160px);\n\n  @media (max-width: 991.98px) {\n    height: calc(100vh - 194px);\n  }\n}\n\n// .chat-list_ {\n//   // padding: 0 8px;\n//   // color: #4a4a4a;\n\n//   li {\n//     transition: all 0.4s;\n\n//     color: #4a4a4a;\n//     height: 66px;\n//     display: flex;\n//     align-items: center;\n//     justify-content: space-between;\n\n//     // &:hover {\n//     //   background-color: #EFF4F5;\n//     // }\n\n//     // &.active {\n//     //   background-color: #EFF4F5;\n//     // }\n\n//     .user-left-block {\n//       width: 100%;\n//       display: flex;\n//       flex-direction: row;\n//       align-items: left;\n\n//       .user-avatar {\n//         width: 42px;\n//         height: 42px;\n//         border-radius: 16px;\n//         margin: 10px;\n//       }\n\n//       .user-message-time {\n//         margin-top: 7px;\n//       }\n\n//       .user-message {\n//         width: 100%;\n//         padding: 8px 10px;\n//         display: flex;\n//         flex-direction: column;\n//         align-items: left;\n//         text-align: left;\n\n//         .user-name {\n//           font-size: 13px;\n//           line-height: 15px;\n//           font-weight: 700;\n//           max-width: 175px;\n//         }\n\n//         .user-text {\n//           font-size: 12px;\n//           line-height: 15px;\n//           font-weight: 400;\n//           margin-top: 4px;\n//           overflow: hidden;\n//           max-width: 175px;\n//           max-height: 30px;\n//           white-space: nowrap;\n//           text-overflow: ellipsis;\n//         }\n//       }\n//     }\n\n//     .user-right-block {\n//       display: flex;\n//       flex-direction: column;\n//       align-items: flex-end;\n//       height: 100%;\n//       padding: 8px 16px 8px 0;\n\n//       .user-time {\n//         font-weight: 400;\n//         font-size: 9px;\n//         line-height: 15px;\n//       }\n\n//       .user-unread {\n//         .badge {\n//           margin-top: 4px;\n//           color: #fff;\n//           background-color: #7360f2;\n//           height: 18px;\n//           font-size: 12px;\n//         }\n//       }\n//     }\n\n//     &.typing {\n//       .chat-user-message {\n//         color: $primary;\n//         font-weight: $font-weight-medium;\n\n//         .dot {\n//           background-color: $primary;\n//         }\n//       }\n//     }\n\n//     .unread-message {\n//       position: absolute;\n//       display: inline-block;\n//       right: 24px /*rtl:auto*/;\n//       left: auto /*rtl:0*/;\n//       top: 33px;\n\n//       .badge {\n//         line-height: 16px;\n//         font-weight: $font-weight-semibold;\n//         font-size: 10px;\n//       }\n//     }\n//   }\n\n//   li:not(.active) {\n//     .user-text {\n//       color: #b0b0b0;\n//     }\n\n//     .user-time {\n//       color: #a8a8a8;\n//     }\n//   }\n// }\n\n.chat-list {\n  margin: 0;\n\n  li {\n    &.active {\n      a {\n        background-color: $light;\n      }\n    }\n\n    a {\n      position: relative;\n      display: block;\n      padding: 15px 20px;\n      color: $gray-600;\n      transition: all 0.4s;\n      border-top: 1px solid $sidebar-sub-bg;\n      border-radius: 4px;\n\n      &:hover {\n        background-color: $light;\n      }\n    }\n\n    .chat-user-message {\n      font-size: 14px;\n    }\n\n    &.typing {\n      .chat-user-message {\n        color: $primary;\n        font-weight: $font-weight-medium;\n\n        .dot {\n          background-color: $primary;\n        }\n      }\n    }\n\n    .unread-message {\n      position: absolute;\n      display: inline-block;\n      right: 24px /*rtl:auto*/;\n      left: auto /*rtl:0*/;\n      top: 33px;\n\n      .badge {\n        line-height: 16px;\n        font-weight: $font-weight-semibold;\n        font-size: 10px;\n      }\n    }\n  }\n}\n\n.chat-user-img {\n  position: relative;\n\n  .user-status {\n    width: 10px;\n    height: 10px;\n    background-color: $gray-500;\n    border-radius: 50%;\n    border: 2px solid $card-bg;\n    position: absolute;\n    right: 0 /*rtl:auto*/;\n    left: auto /*rtl:0*/;\n\n    bottom: 0;\n  }\n\n  &.online {\n    .user-status {\n      background-color: $success;\n    }\n  }\n\n  &.away {\n    .user-status {\n      background-color: $warning;\n    }\n  }\n}\n\n// contact list\n\n.contact-list {\n  li {\n    cursor: pointer;\n    padding: 10px 20px;\n  }\n}\n\n// setting\n\n.profile-user {\n  position: relative;\n  display: inline-block;\n\n  .profile-photo-edit {\n    position: absolute;\n    right: 0 /*rtl:auto*/;\n    left: auto /*rtl:0*/;\n    bottom: 0;\n  }\n}\n","//\n// user chat.scss\n//\n\n// user chat\n\n.user-chat {\n  .main-content {\n    .user-block {\n      //   color: #4a4a4a;\n      //   height: 66px;\n      //   border-bottom: none;\n      //   display: flex;\n      //   align-items: left;\n      //   justify-content: space-between;\n\n      .user-left-block {\n        display: flex;\n        flex-direction: row;\n        align-items: left;\n        width: auto;\n        cursor: pointer;\n        text-align: left;\n\n        // .user-avatar {\n        //   width: 42px;\n        //   height: 42px;\n        //   border: 0 none;\n        //   border-radius: 16px;\n        //   margin-left: 16px;\n        // }\n\n        .user-message {\n          // width: 100%;\n          // padding: 8px 10px;\n          // display: flex;\n          // flex-direction: column;\n          // text-align: left;\n          // align-items: left;\n\n          // .user-name {\n          //     font-size: 13px;\n          //     line-height: 15px;\n          //     font-weight: 700;\n          // }\n\n          .msg-user-name {\n            font-size: 11px;\n            font-weight: bolder;\n          }\n\n          .secondary-id {\n            padding-left: 7px;\n            font-weight: 400;\n            font-size: 11px;\n          }\n        }\n      }\n\n      .user-left-block {\n        .user-profile-show {\n          height: 24px;\n          width: 24px;\n          box-shadow: none;\n          padding: 0;\n          margin-right: 16px;\n        }\n      }\n    }\n\n    .send-message-block {\n      .send-message-wrapper {\n        position: relative;\n\n        .add-file {\n          position: absolute;\n          left: 14px;\n          bottom: 14px;\n          width: 24px;\n          height: 24px;\n          display: inline-flex;\n          align-items: center;\n\n          input {\n            display: none;\n          }\n        }\n\n        .add-emoji {\n          position: absolute;\n          left: 40px;\n          top: 0;\n          width: 24px;\n          height: 100%;\n          display: flex;\n          align-items: center;\n\n          button {\n            padding: 0;\n            background-color: #fff;\n            border: 0 none;\n          }\n        }\n\n        .send-message-error {\n          position: absolute;\n          width: 20%;\n          min-width: 120px;\n          text-align: center;\n          top: -50px;\n          left: 30%;\n          padding: 5px;\n          border-radius: 10px;\n          background-color: red;\n          color: #fff;\n        }\n      }\n\n      .send-button {\n        height: 40px;\n        width: 40px;\n        margin-bottom: 5.5px;\n\n        button {\n          padding: 0;\n          background-color: transparent;\n          border: 0 none;\n          box-shadow: none;\n          outline: none;\n        }\n      }\n    }\n  }\n}\n\n.chat-conversation {\n  color: #4a4a4a;\n\n  ul {\n    margin: 0 20px;\n    padding-left: 0;\n    list-style: none;\n\n    li {\n      display: flex;\n\n      &.right {\n        justify-content: flex-end;\n      }\n    }\n  }\n\n  .chat-avatar {\n    margin: 0 16px 0 0 /*rtl:0 0 0 16px*/;\n\n    img {\n      width: 36px;\n      height: 36px;\n      border-radius: 50%;\n    }\n  }\n\n  .chat-day-title {\n    position: relative;\n    //text-align: center;\n    margin-bottom: 32px;\n    margin-top: 32px;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n\n    .title {\n      //background-color: $border-color;\n      //position: relative;\n      font-size: 12px;\n      line-height: 12px;\n      color: #a8a8a8;\n      z-index: 1;\n      //padding: 6px 12px;\n      //border-radius: 5px;\n    }\n\n    //&:before {\n    //    content: \"\";\n    //    position: absolute;\n    //    width: 100%;\n    //    height: 1px;\n    //    left: 0;\n    //    right: 0;\n    //    background-color: $border-color;\n    //    top: 10px;\n    //}\n\n    .badge {\n      font-size: 12px;\n    }\n  }\n\n  .conversation-list {\n    //margin-bottom: 24px;\n    display: flex;\n    //position: relative;\n    //align-items: flex-end;\n    width: 70%;\n\n    .user-avatar {\n      width: 32px;\n      height: 32px;\n      border: 0 none;\n      border-radius: 12px;\n      margin-right: 8px;\n\n      img {\n        width: 32px;\n        height: auto;\n        display: block;\n      }\n    }\n\n    .ctext-wrap-content {\n      padding: 6px 12px;\n      background-color: #efefef;\n      border-radius: 8px 8px 8px 0;\n      word-break: break-word;\n      white-space: pre-wrap;\n      //color: $white;\n      position: relative;\n      border-radius: 8px;\n      font-weight: 400;\n      font-size: 15px;\n      line-height: 22px;\n      margin-bottom: 8px;\n\n      //&:before {\n      //    content: \"\";\n      //    position: absolute;\n      //    border: 5px solid transparent;\n      //    border-left-color: $chat-primary-bg;\n      //    border-top-color: $chat-primary-bg;\n      //    left: 0/*rtl:auto*/;\n      //    right: auto/*rtl:0*/;\n      //    bottom: -10px;\n      //}\n    }\n\n    .conversation-name {\n      font-weight: $font-weight-medium;\n      font-size: 14px;\n    }\n\n    .dropdown {\n      .dropdown-toggle {\n        font-size: 18px;\n        padding: 4px;\n        color: $gray-600;\n\n        @media (max-width: 575.98px) {\n          display: none;\n        }\n      }\n    }\n\n    .chat-time {\n      font-size: 12px;\n      line-height: 12px;\n      font-width: 500;\n      margin-top: 4px;\n      text-align: right;\n      color: #a8a8a8;\n      margin-bottom: 0;\n    }\n\n    .chat-party {\n      text-align: left;\n      font-size: 14px;\n      font-weight: bold;\n      line-height: 12px;\n      margin-bottom: 0;\n    }\n\n    .message-img {\n      border-radius: 0.2rem;\n      position: relative;\n\n      .message-img-list {\n        position: relative;\n      }\n\n      img {\n        max-width: 150px;\n      }\n\n      .message-img-link {\n        position: absolute;\n        right: 10px /*rtl:auto*/;\n        left: auto /*rtl:0*/;\n        bottom: 10px;\n\n        li {\n          > a {\n            font-size: 18px;\n            color: $white;\n            display: inline-block;\n            line-height: 30px;\n            width: 30px;\n            height: 30px;\n            text-align: center;\n          }\n        }\n      }\n    }\n  }\n\n  .right {\n    .conversation-list {\n      justify-content: flex-end;\n\n      .ctext-wrap-content {\n        order: 2;\n        background-color: #d8ebff;\n        //color: $dark;\n        //text-align: right;\n        border-radius: 8px;\n\n        .chat-time img {\n          margin-left: 5px;\n          width: 16px;\n          height: 16px;\n        }\n\n        //&:before {\n        //    border: 5px solid transparent;\n        //    border-top-color: $chat-secondary-bg;\n        //    border-right-color: $chat-secondary-bg;\n        //    left: auto;\n        //    right: 0px;\n        //}\n      }\n\n      .dropdown {\n        order: 1;\n      }\n    }\n\n    .dot {\n      background-color: $dark;\n    }\n  }\n}\n\n.chat-input-links {\n  .list-inline-item:not(:last-child) {\n    margin: 0;\n  }\n}\n\n.animate-typing {\n  .dot {\n    display: inline-block;\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    margin-right: -1px;\n    background: $white;\n    animation: wave 1.3s linear infinite;\n    opacity: 0.6;\n\n    &:nth-child(2) {\n      animation-delay: -1.1s;\n    }\n\n    &:nth-child(3) {\n      animation-delay: -0.9s;\n    }\n  }\n}\n\n@keyframes wave {\n  0%,\n  60%,\n  100% {\n    transform: initial;\n  }\n\n  30% {\n    transform: translateY(-5px);\n  }\n}\n","// \n//  User profile details.scss\n//\n\n// User profile details\n\n.user-profile-sidebar {\n    height: 100vh;\n    background-color: #fff;\n    display: none;\n    min-width: 380px;\n    max-width: 380px;\n    height: 100vh;\n    overflow-y: auto;\n\n    @media (min-width: 992px) {\n        border-left: 1px solid #F2F2F2;\n    }\n\n    @media (max-width: 1199.98px) {\n        position: fixed;\n        right: 0;\n        top: 0;\n        z-index: 99;\n    }\n\n    @media (max-width: 575.98px) {\n        min-width: 100%;\n    }\n\n    .profile-block {\n        margin: 16px;\n        position: relative;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n\n        .close-button {\n            padding: 0;\n            position: absolute;\n            right: 0;\n        }\n\n        .avatar-wrapper {\n            margin: 0 0 12px 0;\n\n            .avatar {\n                height: 80px;\n                width: 80px;\n                border: 0 none;\n                border-radius: 40px;\n            }\n        }\n\n        .title-wrapper {\n            position: relative;\n            width: 100%;\n            display: flex;\n            justify-content: center;\n\n            .title {\n                font-size: 24px;\n                line-height: 36px;\n                font-weight: 600;\n                max-width: 250px;\n                color: #515361;\n            }\n\n            .user-profile-edit {\n                padding: 0;\n                position: absolute;\n                right: 0;\n            }\n        }\n\n        .phone {\n            font-size: 16px;\n            line-height: 28px;\n            font-weight: 500;\n            color: #71737E;\n            margin-bottom: 24px;\n        }\n\n        .form-group {\n            width: 100%;\n            margin-bottom: 24px;\n\n            label {\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 24px;\n                color: #515361;\n                margin: 0;\n            }\n\n            .description {\n                font-size: 16px;\n                line-height: 28px;\n                font-weight: 500;\n                color: #515361;\n            }\n        }\n\n\n\n\n        &.profile-block-editing {\n            .avatar-wrapper {\n                position: relative;\n                margin: 0 0 24px 0;\n\n                label {\n                    position: absolute;\n                    bottom: 0;\n                    right: 0px;\n                    cursor: pointer;\n                    width: 32px;\n                    height: 32px;\n\n                    img {\n                        width: 32px;\n                        height: 32px;\n                    }\n\n                    input {\n                        display: none;\n                    }\n                }\n            }\n\n            .form-group {\n                width: 100%;\n                margin-bottom: 24px;\n\n                label {\n                    font-weight: 500;\n                    font-size: 12px;\n                    line-height: 24px;\n                    color: #515361;\n                    margin: 0 16px 12px 16px;\n                }\n\n                input {\n                    display: flex;\n                    padding: 4px 16px;\n                    width: 100%;\n                    height: 36px;\n                    border: 1px solid #DEDFE1;\n                    border-radius: 4px;\n\n                    font-weight: 500;\n                    font-size: 16px;\n                    line-height: 28px;\n                    color: #515361;\n\n                    &:disabled {\n                        color: #818C99;\n                    }\n\n                    &:invalid {\n                        border-color: red;\n                    }\n                }\n\n                button {\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    padding: 4px 24px;\n                    width: 100%;\n                    height: 36px;\n                    box-shadow: 2px 4px 4px rgba(37, 40, 57, 0.15);\n                    border-radius: 24px;\n                    border: 0 none;\n                    font-weight: 500;\n                    font-size: 16px;\n                    line-height: 28px;\n                    color: #252839 !important;\n                    margin-bottom: 20px;\n                }\n\n                .save-button {\n                    background: #FFB300;\n                    margin-top: 24px;\n                }\n\n                .cancel-button {\n                    background: #FFFFFF;\n                    border: 1px solid #FFB300;\n                }\n            }\n        }\n    }\n}\n\n.user-profile-desc {\n    height: calc(100vh - 300px);\n\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 324px);\n    }\n}","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
